/* tslint:disable */
/* eslint-disable */
/**
 * LeafLink API
 * This reference specification outlines all the available HTTP operations of the LeafLink API.  See the [LeafLink Developer Hub](/api) for guides, how-to, and general information of the API. 
 *
 * The version of the OpenAPI document: 2022-10-31
 * Contact: support@leaflink.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * Serializer for ll.ads.data_models.AdPlacement
 * @export
 * @interface AdPlacement
 */
export interface AdPlacement {
    /**
     * 
     * @type {string}
     * @memberof AdPlacement
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof AdPlacement
     */
    'style': string;
    /**
     * 
     * @type {string}
     * @memberof AdPlacement
     */
    'provider': string;
}
/**
 * Serializer for Address models via the internal API. This includes but is not limited to delivery and corporate addresses for Companies.
 * @export
 * @interface Address
 */
export interface Address {
    /**
     * Address
     * @type {string}
     * @memberof Address
     */
    'address': string;
    /**
     * Unit #
     * @type {string}
     * @memberof Address
     */
    'unit_number'?: string;
    /**
     * City
     * @type {string}
     * @memberof Address
     */
    'city': string;
    /**
     * County
     * @type {string}
     * @memberof Address
     */
    'county'?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'state'?: string;
    /**
     * Zipcode
     * @type {string}
     * @memberof Address
     */
    'zipcode': string;
}
/**
 * Serializer for Address models via the internal API. This includes but is not limited to delivery and corporate addresses for Companies.
 * @export
 * @interface AddressRequest
 */
export interface AddressRequest {
    /**
     * Address
     * @type {string}
     * @memberof AddressRequest
     */
    'address': string;
    /**
     * Unit #
     * @type {string}
     * @memberof AddressRequest
     */
    'unit_number'?: string;
    /**
     * City
     * @type {string}
     * @memberof AddressRequest
     */
    'city': string;
    /**
     * County
     * @type {string}
     * @memberof AddressRequest
     */
    'county'?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressRequest
     */
    'state'?: string;
    /**
     * Zipcode
     * @type {string}
     * @memberof AddressRequest
     */
    'zipcode': string;
}
/**
 * Author serializer
 * @export
 * @interface Author
 */
export interface Author {
    /**
     * 
     * @type {number}
     * @memberof Author
     */
    'id': number;
    /**
     * 
     * @type {CompanyUnifiedUpstreamMarketplace}
     * @memberof Author
     */
    'company': CompanyUnifiedUpstreamMarketplace;
    /**
     * 
     * @type {number}
     * @memberof Author
     */
    'user': number;
    /**
     * 
     * @type {string}
     * @memberof Author
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof Author
     */
    'email': string;
}
/**
 * Author serializer
 * @export
 * @interface AuthorRequest
 */
export interface AuthorRequest {
    /**
     * 
     * @type {number}
     * @memberof AuthorRequest
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof AuthorRequest
     */
    'user': number;
}
/**
 * Serializer for Badges.
 * @export
 * @interface Badge
 */
export interface Badge {
    /**
     * 
     * @type {number}
     * @memberof Badge
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof Badge
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof Badge
     */
    'code': string;
    /**
     * This badge can be added or removed by an external user.
     * @type {boolean}
     * @memberof Badge
     */
    'self_identify'?: boolean;
}
/**
 * BioTrack-specific DeliveryPackage fields serializer.
 * @export
 * @interface BiotrackDeliveryPackage
 */
export interface BiotrackDeliveryPackage {
    /**
     * 
     * @type {string}
     * @memberof BiotrackDeliveryPackage
     */
    'resource_type': string;
    /**
     * 
     * @type {number}
     * @memberof BiotrackDeliveryPackage
     */
    'common_delivery_package_id': number;
    /**
     * 
     * @type {string}
     * @memberof BiotrackDeliveryPackage
     */
    'description': string | null;
    /**
     * 
     * @type {number}
     * @memberof BiotrackDeliveryPackage
     */
    'session_time': number;
    /**
     * 
     * @type {number}
     * @memberof BiotrackDeliveryPackage
     */
    'stop_number': number;
    /**
     * 
     * @type {number}
     * @memberof BiotrackDeliveryPackage
     */
    'transaction_id': number;
}
/**
 * 
 * @export
 * @interface BiotrackDriver
 */
export interface BiotrackDriver {
    /**
     * 
     * @type {string}
     * @memberof BiotrackDriver
     */
    'resource_type': string;
    /**
     * 
     * @type {string}
     * @memberof BiotrackDriver
     */
    'birth_date': string;
    /**
     * 
     * @type {string}
     * @memberof BiotrackDriver
     */
    'hire_date': string;
    /**
     * 
     * @type {string}
     * @memberof BiotrackDriver
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof BiotrackDriver
     */
    'state_issued': string | null;
    /**
     * 
     * @type {number}
     * @memberof BiotrackDriver
     */
    'transaction_id': number;
}
/**
 * 
 * @export
 * @interface BiotrackTransfer
 */
export interface BiotrackTransfer {
    /**
     * 
     * @type {string}
     * @memberof BiotrackTransfer
     */
    'resource_type': string;
}
/**
 * 
 * @export
 * @interface BiotrackVehicle
 */
export interface BiotrackVehicle {
    /**
     * 
     * @type {string}
     * @memberof BiotrackVehicle
     */
    'resource_type': string;
    /**
     * 
     * @type {string}
     * @memberof BiotrackVehicle
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof BiotrackVehicle
     */
    'color': string;
    /**
     * 
     * @type {string}
     * @memberof BiotrackVehicle
     */
    'vin': string;
    /**
     * 
     * @type {string}
     * @memberof BiotrackVehicle
     */
    'year': string;
    /**
     * 
     * @type {number}
     * @memberof BiotrackVehicle
     */
    'transaction_id': number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const BlankEnum = {
    Empty: ''
} as const;

export type BlankEnum = typeof BlankEnum[keyof typeof BlankEnum];


/**
 * 
 * @export
 * @enum {string}
 */

export const BlankEnumUnifiedUpstreamMarketplace = {
    Empty: ''
} as const;

export type BlankEnumUnifiedUpstreamMarketplace = typeof BlankEnumUnifiedUpstreamMarketplace[keyof typeof BlankEnumUnifiedUpstreamMarketplace];


/**
 * 
 * @export
 * @interface BrandListingContent
 */
export interface BrandListingContent {
    /**
     * 
     * @type {SponsorshipPayload}
     * @memberof BrandListingContent
     */
    'sponsorships': SponsorshipPayload;
    /**
     * 
     * @type {Array<BrandResource>}
     * @memberof BrandListingContent
     */
    'collection': Array<BrandResource>;
}
/**
 * Serializer for Brand resource.
 * @export
 * @interface BrandResource
 */
export interface BrandResource {
    /**
     * 
     * @type {number}
     * @memberof BrandResource
     */
    'resource_id': number;
    /**
     * 
     * @type {string}
     * @memberof BrandResource
     */
    'resource_name': string;
    /**
     * Name of the Brand
     * @type {string}
     * @memberof BrandResource
     */
    'name': string;
    /**
     * An overview of the brand
     * @type {string}
     * @memberof BrandResource
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BrandResource
     */
    'image': string;
    /**
     * 
     * @type {CompanyResource}
     * @memberof BrandResource
     */
    'owner': CompanyResource;
    /**
     * 
     * @type {Array<string>}
     * @memberof BrandResource
     */
    'product_categories': Array<string>;
    /**
     * 
     * @type {Array<Badge>}
     * @memberof BrandResource
     */
    'badges': Array<Badge>;
    /**
     * 
     * @type {Array<string>}
     * @memberof BrandResource
     */
    'social_equity_programs': Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof BrandResource
     */
    'sponsored': boolean;
    /**
     * 
     * @type {string}
     * @memberof BrandResource
     */
    'tagline': string | null;
    /**
     * 
     * @type {string}
     * @memberof BrandResource
     */
    'company_s2s_integration_type': string;
}
/**
 * Used to serialize buyer data (a buyer is a company where `type` = `buyer`)
 * @export
 * @interface Buyer
 */
export interface Buyer {
    /**
     * 
     * @type {string}
     * @memberof Buyer
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof Buyer
     */
    'dba': string;
    /**
     * 
     * @type {string}
     * @memberof Buyer
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Buyer
     */
    'street_address'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Buyer
     */
    'unit_number'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Buyer
     */
    'city'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Buyer
     */
    'state'?: string | null;
    /**
     * 
     * @type {Array<License>}
     * @memberof Buyer
     */
    'licenses'?: Array<License>;
    /**
     * 
     * @type {string}
     * @memberof Buyer
     */
    'zipcode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Buyer
     */
    'country'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Buyer
     */
    'phone'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Buyer
     */
    'marketplace_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof Buyer
     */
    'marketplace_slug'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Buyer
     */
    'marketplace_dashboard_url': string;
    /**
     * 
     * @type {string}
     * @memberof Buyer
     */
    'has_signed_terms_and_conditions': string;
    /**
     * 
     * @type {string}
     * @memberof Buyer
     */
    'in_direct_enabled_state': string;
    /**
     * 
     * @type {Type7a8Enum}
     * @memberof Buyer
     */
    'type': Type7a8Enum | null;
    /**
     * 
     * @type {string}
     * @memberof Buyer
     */
    'url'?: string | null;
    /**
     * 
     * @type {LegalEntity}
     * @memberof Buyer
     */
    'legal_entity'?: LegalEntity;
    /**
     * 
     * @type {StatusEnum}
     * @memberof Buyer
     */
    'status'?: StatusEnum;
    /**
     * 
     * @type {boolean}
     * @memberof Buyer
     */
    'b2b_enabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Buyer
     */
    'flexible_enabled'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Buyer
     */
    'image'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Buyer
     */
    'timezone'?: string;
    /**
     * 
     * @type {string}
     * @memberof Buyer
     */
    'created_on': string;
    /**
     * 
     * @type {string}
     * @memberof Buyer
     */
    'modified': string;
    /**
     * 
     * @type {boolean}
     * @memberof Buyer
     */
    'excluded_from_automated_payments'?: boolean;
    /**
     * 
     * @type {PreferredPaymentProgramEnum}
     * @memberof Buyer
     */
    'preferred_payment_program'?: PreferredPaymentProgramEnum | null;
    /**
     * 
     * @type {DefaultFlexiblePaymentStrategyEnum}
     * @memberof Buyer
     */
    'default_flexible_payment_strategy'?: DefaultFlexiblePaymentStrategyEnum | null;
    /**
     * 
     * @type {string}
     * @memberof Buyer
     */
    'default_flexible_payment_term': string;
    /**
     * 
     * @type {string}
     * @memberof Buyer
     */
    'available_terms': string;
    /**
     * 
     * @type {boolean}
     * @memberof Buyer
     */
    'exempted_from_term_validation'?: boolean;
    /**
     * 
     * @type {BuyerCollectionDayPreference}
     * @memberof Buyer
     */
    'collection_day_preference'?: BuyerCollectionDayPreference | null;
    /**
     * 
     * @type {boolean}
     * @memberof Buyer
     */
    'excluded_from_funding_on_t'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Buyer
     */
    'cashback_rewards_enabled'?: boolean;
}


/**
 * @type BuyerCollectionDayPreference
 * @export
 */
export type BuyerCollectionDayPreference = BlankEnum | CollectionDayPreferenceEnum;

/**
 * Buyer Notification Setting Serializer for managing email notifications.
 * @export
 * @interface BuyerNotificationSetting
 */
export interface BuyerNotificationSetting {
    /**
     * 
     * @type {BuyerNotificationSettingEvent}
     * @memberof BuyerNotificationSetting
     */
    'order_accepted'?: BuyerNotificationSettingEvent | null;
    /**
     * 
     * @type {BuyerNotificationSettingEvent}
     * @memberof BuyerNotificationSetting
     */
    'order_rejected'?: BuyerNotificationSettingEvent | null;
    /**
     * 
     * @type {BuyerNotificationSettingEvent}
     * @memberof BuyerNotificationSetting
     */
    'order_fulfilled'?: BuyerNotificationSettingEvent | null;
    /**
     * 
     * @type {BuyerNotificationSettingEvent}
     * @memberof BuyerNotificationSetting
     */
    'order_shipped'?: BuyerNotificationSettingEvent | null;
    /**
     * 
     * @type {BuyerNotificationSettingEvent}
     * @memberof BuyerNotificationSetting
     */
    'order_complete'?: BuyerNotificationSettingEvent | null;
    /**
     * 
     * @type {BuyerNotificationSettingEvent}
     * @memberof BuyerNotificationSetting
     */
    'order_detail_changed'?: BuyerNotificationSettingEvent | null;
    /**
     * 
     * @type {BuyerNotificationSettingEvent}
     * @memberof BuyerNotificationSetting
     */
    'flower_available'?: BuyerNotificationSettingEvent | null;
}
/**
 * 
 * @export
 * @interface BuyerNotificationSettingEvent
 */
export interface BuyerNotificationSettingEvent {
    /**
     * 
     * @type {Array<User>}
     * @memberof BuyerNotificationSettingEvent
     */
    'users'?: Array<User> | null;
}
/**
 * 
 * @export
 * @interface BuyerNotificationSettingEventRequest
 */
export interface BuyerNotificationSettingEventRequest {
    /**
     * 
     * @type {Array<UserRequest>}
     * @memberof BuyerNotificationSettingEventRequest
     */
    'users'?: Array<UserRequest> | null;
}
/**
 * Buyer Notification Setting Serializer for managing email notifications.
 * @export
 * @interface BuyerNotificationSettingRequest
 */
export interface BuyerNotificationSettingRequest {
    /**
     * 
     * @type {BuyerNotificationSettingEventRequest}
     * @memberof BuyerNotificationSettingRequest
     */
    'order_accepted'?: BuyerNotificationSettingEventRequest | null;
    /**
     * 
     * @type {BuyerNotificationSettingEventRequest}
     * @memberof BuyerNotificationSettingRequest
     */
    'order_rejected'?: BuyerNotificationSettingEventRequest | null;
    /**
     * 
     * @type {BuyerNotificationSettingEventRequest}
     * @memberof BuyerNotificationSettingRequest
     */
    'order_fulfilled'?: BuyerNotificationSettingEventRequest | null;
    /**
     * 
     * @type {BuyerNotificationSettingEventRequest}
     * @memberof BuyerNotificationSettingRequest
     */
    'order_shipped'?: BuyerNotificationSettingEventRequest | null;
    /**
     * 
     * @type {BuyerNotificationSettingEventRequest}
     * @memberof BuyerNotificationSettingRequest
     */
    'order_complete'?: BuyerNotificationSettingEventRequest | null;
    /**
     * 
     * @type {BuyerNotificationSettingEventRequest}
     * @memberof BuyerNotificationSettingRequest
     */
    'order_detail_changed'?: BuyerNotificationSettingEventRequest | null;
    /**
     * 
     * @type {BuyerNotificationSettingEventRequest}
     * @memberof BuyerNotificationSettingRequest
     */
    'flower_available'?: BuyerNotificationSettingEventRequest | null;
}
/**
 * Order serializer (buyer side).
 * @export
 * @interface BuyerOrder
 */
export interface BuyerOrder {
    /**
     * <uuid> Order number generated by LeafLink
     * @type {string}
     * @memberof BuyerOrder
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof BuyerOrder
     */
    'short_id': string;
    /**
     * Order status
     * @type {BuyerOrderStatusEnum}
     * @memberof BuyerOrder
     */
    'status': BuyerOrderStatusEnum;
    /**
     * Classification of the license-type associated to the order
     * @type {string}
     * @memberof BuyerOrder
     */
    'type': string;
    /**
     * 
     * @type {NestedCompany}
     * @memberof BuyerOrder
     */
    'buyer': NestedCompany;
    /**
     * 
     * @type {NestedOrderSeller}
     * @memberof BuyerOrder
     */
    'seller': NestedOrderSeller;
    /**
     * 
     * @type {string}
     * @memberof BuyerOrder
     */
    'source': string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof BuyerOrder
     */
    'created_by': { [key: string]: any; };
    /**
     * 
     * @type {string}
     * @memberof BuyerOrder
     */
    'created_on': string;
    /**
     * Date and time that the order was last modified
     * @type {string}
     * @memberof BuyerOrder
     */
    'last_edited_on': string;
    /**
     * 
     * @type {string}
     * @memberof BuyerOrder
     */
    'currency': string;
    /**
     * 
     * @type {Array<NestedOrderedProduct>}
     * @memberof BuyerOrder
     */
    'line_items': Array<NestedOrderedProduct>;
    /**
     * 
     * @type {string}
     * @memberof BuyerOrder
     */
    'subtotal': string;
    /**
     * 
     * @type {string}
     * @memberof BuyerOrder
     */
    'shipping_charge': string;
    /**
     * 
     * @type {string}
     * @memberof BuyerOrder
     */
    'discount': string;
    /**
     * Tax amount applied to the order
     * @type {string}
     * @memberof BuyerOrder
     */
    'tax': string;
    /**
     * The total amount of the order
     * @type {string}
     * @memberof BuyerOrder
     */
    'total': string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof BuyerOrder
     */
    'payable_to': { [key: string]: any; };
    /**
     * 
     * @type {string}
     * @memberof BuyerOrder
     */
    'payment_term': string;
    /**
     * Date that the Payment is due
     * @type {string}
     * @memberof BuyerOrder
     */
    'payment_due_date'?: string | null;
    /**
     * Date the Order is shipped
     * @type {string}
     * @memberof BuyerOrder
     */
    'ship_date'?: string | null;
    /**
     * Shipping details for an Order
     * @type {string}
     * @memberof BuyerOrder
     */
    'shipping_details'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof BuyerOrder
     */
    'is_delivered': boolean;
    /**
     * 
     * @type {string}
     * @memberof BuyerOrder
     */
    'delivered_date'?: string | null;
    /**
     * Additional notes for an Order
     * @type {string}
     * @memberof BuyerOrder
     */
    'notes'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof BuyerOrder
     */
    'sales_reps': Array<string>;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof BuyerOrder
     */
    'delivery_address': { [key: string]: any; };
}


/**
 * 
 * @export
 * @enum {string}
 */

export const BuyerOrderStatusEnum = {
    Submitted: 'submitted',
    Accepted: 'accepted',
    Fulfilled: 'fulfilled',
    Shipped: 'shipped',
    Delivered: 'delivered',
    Rejected: 'rejected',
    Cancelled: 'cancelled',
    Backorder: 'backorder',
    Complete: 'complete',
    Combined: 'combined',
    Draft: 'draft'
} as const;

export type BuyerOrderStatusEnum = typeof BuyerOrderStatusEnum[keyof typeof BuyerOrderStatusEnum];


/**
 * Used to serialize buyer data (a buyer is a company where `type` = `buyer`)
 * @export
 * @interface BuyerRequest
 */
export interface BuyerRequest {
    /**
     * 
     * @type {string}
     * @memberof BuyerRequest
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof BuyerRequest
     */
    'dba': string;
    /**
     * 
     * @type {string}
     * @memberof BuyerRequest
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BuyerRequest
     */
    'street_address'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BuyerRequest
     */
    'unit_number'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BuyerRequest
     */
    'city'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BuyerRequest
     */
    'state'?: string | null;
    /**
     * 
     * @type {Array<LicenseRequest>}
     * @memberof BuyerRequest
     */
    'licenses'?: Array<LicenseRequest>;
    /**
     * 
     * @type {string}
     * @memberof BuyerRequest
     */
    'zipcode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BuyerRequest
     */
    'country'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BuyerRequest
     */
    'phone'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof BuyerRequest
     */
    'marketplace_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof BuyerRequest
     */
    'marketplace_slug'?: string | null;
    /**
     * 
     * @type {Type7a8Enum}
     * @memberof BuyerRequest
     */
    'type': Type7a8Enum | null;
    /**
     * 
     * @type {string}
     * @memberof BuyerRequest
     */
    'url'?: string | null;
    /**
     * 
     * @type {LegalEntityRequest}
     * @memberof BuyerRequest
     */
    'legal_entity'?: LegalEntityRequest;
    /**
     * 
     * @type {string}
     * @memberof BuyerRequest
     */
    'legal_entity_id'?: string;
    /**
     * 
     * @type {StatusEnum}
     * @memberof BuyerRequest
     */
    'status'?: StatusEnum;
    /**
     * 
     * @type {boolean}
     * @memberof BuyerRequest
     */
    'b2b_enabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BuyerRequest
     */
    'flexible_enabled'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof BuyerRequest
     */
    'image'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BuyerRequest
     */
    'timezone'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof BuyerRequest
     */
    'excluded_from_automated_payments'?: boolean;
    /**
     * 
     * @type {PreferredPaymentProgramEnum}
     * @memberof BuyerRequest
     */
    'preferred_payment_program'?: PreferredPaymentProgramEnum | null;
    /**
     * 
     * @type {DefaultFlexiblePaymentStrategyEnum}
     * @memberof BuyerRequest
     */
    'default_flexible_payment_strategy'?: DefaultFlexiblePaymentStrategyEnum | null;
    /**
     * 
     * @type {boolean}
     * @memberof BuyerRequest
     */
    'exempted_from_term_validation'?: boolean;
    /**
     * 
     * @type {BuyerCollectionDayPreference}
     * @memberof BuyerRequest
     */
    'collection_day_preference'?: BuyerCollectionDayPreference | null;
    /**
     * 
     * @type {boolean}
     * @memberof BuyerRequest
     */
    'excluded_from_funding_on_t'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BuyerRequest
     */
    'cashback_rewards_enabled'?: boolean;
}


/**
 * Unified Strain Classification serializer.
 * @export
 * @interface Choice
 */
export interface Choice {
    /**
     * 
     * @type {string}
     * @memberof Choice
     */
    'value': string;
    /**
     * 
     * @type {string}
     * @memberof Choice
     */
    'display_value': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const CollectionDayPreferenceEnum = {
    Monday: 'monday',
    Tuesday: 'tuesday',
    Wednesday: 'wednesday',
    Thursday: 'thursday',
    Friday: 'friday'
} as const;

export type CollectionDayPreferenceEnum = typeof CollectionDayPreferenceEnum[keyof typeof CollectionDayPreferenceEnum];


/**
 * Used to validate the company creation request.
 * @export
 * @interface Company
 */
export interface Company {
    /**
     * 
     * @type {string}
     * @memberof Company
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof Company
     */
    'dba': string;
    /**
     * 
     * @type {LegalEntity}
     * @memberof Company
     */
    'legal_entity'?: LegalEntity;
    /**
     * 
     * @type {boolean}
     * @memberof Company
     */
    'has_linked_bank_account': boolean;
}
/**
 * 
 * @export
 * @interface CompanyApiKeyRequest
 */
export interface CompanyApiKeyRequest {
    /**
     * 
     * @type {string}
     * @memberof CompanyApiKeyRequest
     */
    'api_key': string;
    /**
     * 
     * @type {Array<number>}
     * @memberof CompanyApiKeyRequest
     */
    'license_ids': Array<number>;
}
/**
 * Serializer for CompanyStats focusing on cashback-related statistics.
 * @export
 * @interface CompanyCashbackStats
 */
export interface CompanyCashbackStats {
    /**
     * 
     * @type {number}
     * @memberof CompanyCashbackStats
     */
    'buyer_cashback_invoice_count'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CompanyCashbackStats
     */
    'buyer_cashback_potential_earnings'?: number | null;
}
/**
 * 
 * @export
 * @interface CompanyCreateRequest
 */
export interface CompanyCreateRequest {
    /**
     * 
     * @type {boolean}
     * @memberof CompanyCreateRequest
     */
    'enable_seed_to_sale': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CompanyCreateRequest
     */
    'enable_transfer_manifest': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CompanyCreateRequest
     */
    'enable_sales_data': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CompanyCreateRequest
     */
    'enable_hide_attached_packages': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CompanyCreateRequest
     */
    'enable_license_verification'?: boolean | null;
    /**
     * 
     * @type {Array<CompanyApiKeyRequest>}
     * @memberof CompanyCreateRequest
     */
    'api_configs': Array<CompanyApiKeyRequest>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CompanyCreateRequest
     */
    'included_locations'?: Array<string>;
    /**
     * 
     * @type {Array<number>}
     * @memberof CompanyCreateRequest
     */
    'included_location_ids'?: Array<number>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CompanyCreateRequest
     */
    'excluded_lab_test_states': Array<string>;
}
/**
 * Unified serializer for License models.
 * @export
 * @interface CompanyLicense
 */
export interface CompanyLicense {
    /**
     * id for license
     * @type {number}
     * @memberof CompanyLicense
     */
    'id': number;
    /**
     * License Number
     * @type {string}
     * @memberof CompanyLicense
     */
    'number': string;
    /**
     * 
     * @type {CompanyLicenseType}
     * @memberof CompanyLicense
     */
    'type': CompanyLicenseType;
    /**
     * Display type
     * @type {string}
     * @memberof CompanyLicense
     */
    'display_type': string;
    /**
     * Classification
     * @type {string}
     * @memberof CompanyLicense
     */
    'classification': string;
}
/**
 * Unified serializer for LicenseType models.
 * @export
 * @interface CompanyLicenseType
 */
export interface CompanyLicenseType {
    /**
     * 
     * @type {number}
     * @memberof CompanyLicenseType
     */
    'id': number;
    /**
     * License Type
     * @type {string}
     * @memberof CompanyLicenseType
     */
    'type': string;
    /**
     * Type for display in the Leaflink frontend
     * @type {string}
     * @memberof CompanyLicenseType
     */
    'display_type': string;
    /**
     * License Classification Type
     * @type {string}
     * @memberof CompanyLicenseType
     */
    'classification': string;
    /**
     * 
     * @type {number}
     * @memberof CompanyLicenseType
     */
    'state': number | null;
    /**
     * EIN is required to register under this license type.
     * @type {boolean}
     * @memberof CompanyLicenseType
     */
    'require_ein'?: boolean;
    /**
     * This license type can sell medical line items.
     * @type {boolean}
     * @memberof CompanyLicenseType
     */
    'has_medical_line_items'?: boolean;
    /**
     * This license type is available for current registrations.
     * @type {boolean}
     * @memberof CompanyLicenseType
     */
    'active_for_registration'?: boolean;
    /**
     * Description or Notes
     * @type {string}
     * @memberof CompanyLicenseType
     */
    'description'?: string | null;
    /**
     * pre-2018 CA license.
     * @type {boolean}
     * @memberof CompanyLicenseType
     */
    'pre_2018_CA'?: boolean;
    /**
     * post-2018 CA license.
     * @type {boolean}
     * @memberof CompanyLicenseType
     */
    'post_2018_CA'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CompanyLicenseType
     */
    'created_on': string;
    /**
     * 
     * @type {string}
     * @memberof CompanyLicenseType
     */
    'modified': string;
    /**
     * 
     * @type {string}
     * @memberof CompanyLicenseType
     */
    'state_abbr': string;
}
/**
 * Company serializer
 * @export
 * @interface CompanyRequest
 */
export interface CompanyRequest {
    /**
     * 
     * @type {number}
     * @memberof CompanyRequest
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof CompanyRequest
     */
    'name'?: string | null;
}
/**
 * Serializer for Company resource.
 * @export
 * @interface CompanyResource
 */
export interface CompanyResource {
    /**
     * 
     * @type {number}
     * @memberof CompanyResource
     */
    'resource_id': number;
    /**
     * 
     * @type {string}
     * @memberof CompanyResource
     */
    'resource_name': string;
    /**
     * Name of Company (Note this is not the same as Brand)
     * @type {string}
     * @memberof CompanyResource
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CompanyResource
     */
    'slug'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CompanyResource
     */
    'enable_vendor_menu': boolean;
}
/**
 * Seriazlier for Company Transport Partner Model.
 * @export
 * @interface CompanyTransportPartner
 */
export interface CompanyTransportPartner {
    /**
     * 
     * @type {number}
     * @memberof CompanyTransportPartner
     */
    'id': number;
    /**
     * 
     * @type {CompanyUnifiedUpstreamMarketplace}
     * @memberof CompanyTransportPartner
     */
    'company': CompanyUnifiedUpstreamMarketplace;
    /**
     * 
     * @type {TransportCompany}
     * @memberof CompanyTransportPartner
     */
    'transport_company': TransportCompany;
}
/**
 * Seriazlier for Company Transport Partner Model.
 * @export
 * @interface CompanyTransportPartnerRequest
 */
export interface CompanyTransportPartnerRequest {
    /**
     * 
     * @type {number}
     * @memberof CompanyTransportPartnerRequest
     */
    'transport_company_id': number;
    /**
     * 
     * @type {number}
     * @memberof CompanyTransportPartnerRequest
     */
    'company_id'?: number;
}
/**
 * Company serializer
 * @export
 * @interface CompanyUnifiedUpstreamMarketplace
 */
export interface CompanyUnifiedUpstreamMarketplace {
    /**
     * 
     * @type {number}
     * @memberof CompanyUnifiedUpstreamMarketplace
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof CompanyUnifiedUpstreamMarketplace
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyUnifiedUpstreamMarketplace
     */
    'image_url': string | null;
}
/**
 * 
 * @export
 * @interface CompanyWriteSuccessResponse
 */
export interface CompanyWriteSuccessResponse {
    /**
     * 
     * @type {number}
     * @memberof CompanyWriteSuccessResponse
     */
    'company_id': number;
}
/**
 * Serializer for License models via the v2 API
 * @export
 * @interface ComplianceLicense
 */
export interface ComplianceLicense {
    /**
     * id for license
     * @type {number}
     * @memberof ComplianceLicense
     */
    'id': number;
    /**
     * License Number
     * @type {string}
     * @memberof ComplianceLicense
     */
    'number': string;
    /**
     * Type
     * @type {string}
     * @memberof ComplianceLicense
     */
    'type': string;
    /**
     * Display type
     * @type {string}
     * @memberof ComplianceLicense
     */
    'display_type': string;
    /**
     * Classification
     * @type {string}
     * @memberof ComplianceLicense
     */
    'classification': string;
}
/**
 * Serializer for License models via the v2 API
 * @export
 * @interface ComplianceLicenseRequest
 */
export interface ComplianceLicenseRequest {
    /**
     * License Number
     * @type {string}
     * @memberof ComplianceLicenseRequest
     */
    'number': string;
}
/**
 * Serializer for Contract
 * @export
 * @interface Contract
 */
export interface Contract {
    /**
     * 
     * @type {string}
     * @memberof Contract
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof Contract
     */
    'docusign_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Contract
     */
    'status'?: string;
    /**
     * 
     * @type {Buyer}
     * @memberof Contract
     */
    'buyer': Buyer;
    /**
     * 
     * @type {Seller}
     * @memberof Contract
     */
    'seller': Seller;
    /**
     * 
     * @type {ContractStats}
     * @memberof Contract
     */
    'contract_stats': ContractStats;
    /**
     * 
     * @type {string}
     * @memberof Contract
     */
    'created_on': string;
    /**
     * 
     * @type {string}
     * @memberof Contract
     */
    'modified': string;
    /**
     * 
     * @type {DefaultPaymentProgramEnum}
     * @memberof Contract
     */
    'default_payment_program'?: DefaultPaymentProgramEnum;
    /**
     * 
     * @type {DefaultFlexiblePaymentStrategyEnum}
     * @memberof Contract
     */
    'default_flexible_payment_strategy'?: DefaultFlexiblePaymentStrategyEnum;
    /**
     * 
     * @type {string}
     * @memberof Contract
     */
    'custom_direct_payment_term_type'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Contract
     */
    'custom_reverse_factor_auto_assignment'?: boolean | null;
}


/**
 * Serializer for Contract
 * @export
 * @interface ContractRequest
 */
export interface ContractRequest {
    /**
     * 
     * @type {string}
     * @memberof ContractRequest
     */
    'docusign_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContractRequest
     */
    'status'?: string;
    /**
     * 
     * @type {string}
     * @memberof ContractRequest
     */
    'buyer_id': string;
    /**
     * 
     * @type {string}
     * @memberof ContractRequest
     */
    'seller_id': string;
    /**
     * 
     * @type {DefaultPaymentProgramEnum}
     * @memberof ContractRequest
     */
    'default_payment_program'?: DefaultPaymentProgramEnum;
    /**
     * 
     * @type {DefaultFlexiblePaymentStrategyEnum}
     * @memberof ContractRequest
     */
    'default_flexible_payment_strategy'?: DefaultFlexiblePaymentStrategyEnum;
    /**
     * 
     * @type {string}
     * @memberof ContractRequest
     */
    'custom_direct_payment_term_type'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ContractRequest
     */
    'custom_reverse_factor_auto_assignment'?: boolean | null;
}


/**
 * Serializer for CompanyStats
 * @export
 * @interface ContractStats
 */
export interface ContractStats {
    /**
     * 
     * @type {string}
     * @memberof ContractStats
     */
    'first_completed_invoice_date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContractStats
     */
    'most_recent_eligible_invoice_date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContractStats
     */
    'most_recent_assigned_invoice_date'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ContractStats
     */
    'eligible_invoice_count'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ContractStats
     */
    'eligible_invoice_total'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ContractStats
     */
    'funded_invoice_total'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ContractStats
     */
    'funded_invoice_count'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ContractStats
     */
    'funded_invoice_percentage'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ContractStats
     */
    'invoice_count'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ContractStats
     */
    'invoice_total'?: number | null;
}
/**
 * Serializer for CompanyStats
 * @export
 * @interface ContractStatsRequest
 */
export interface ContractStatsRequest {
    /**
     * 
     * @type {string}
     * @memberof ContractStatsRequest
     */
    'first_completed_invoice_date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContractStatsRequest
     */
    'most_recent_eligible_invoice_date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContractStatsRequest
     */
    'most_recent_assigned_invoice_date'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ContractStatsRequest
     */
    'eligible_invoice_count'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ContractStatsRequest
     */
    'eligible_invoice_total'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ContractStatsRequest
     */
    'funded_invoice_total'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ContractStatsRequest
     */
    'funded_invoice_count'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ContractStatsRequest
     */
    'funded_invoice_percentage'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ContractStatsRequest
     */
    'invoice_count'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ContractStatsRequest
     */
    'invoice_total'?: number | null;
}
/**
 * Serializer for Country models via the internal API  Note:     The code -> iso_code is alias is intentional
 * @export
 * @interface Country
 */
export interface Country {
    /**
     * 
     * @type {number}
     * @memberof Country
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof Country
     */
    'abbr': string;
    /**
     * 
     * @type {string}
     * @memberof Country
     */
    'iso_code': string;
    /**
     * 
     * @type {string}
     * @memberof Country
     */
    'name': string;
}
/**
 * Serializer for Country models via the internal API  Note:     The code -> iso_code is alias is intentional
 * @export
 * @interface CountryRequest
 */
export interface CountryRequest {
    /**
     * 
     * @type {string}
     * @memberof CountryRequest
     */
    'abbr': string;
    /**
     * 
     * @type {string}
     * @memberof CountryRequest
     */
    'iso_code': string;
    /**
     * 
     * @type {string}
     * @memberof CountryRequest
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface CreateInputRequest
 */
export interface CreateInputRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateInputRequest
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof CreateInputRequest
     */
    'tax_type': number;
    /**
     * 
     * @type {string}
     * @memberof CreateInputRequest
     */
    'tax_rate': string;
    /**
     * 
     * @type {number}
     * @memberof CreateInputRequest
     */
    'unit_type': number;
    /**
     * 
     * @type {Array<number>}
     * @memberof CreateInputRequest
     */
    'product_category_ids': Array<number>;
}
/**
 * 
 * @export
 * @interface CreateUpdateSuccessResponse
 */
export interface CreateUpdateSuccessResponse {
    /**
     * 
     * @type {number}
     * @memberof CreateUpdateSuccessResponse
     */
    'id': number;
}
/**
 * External serializer class for Customers payment options.
 * @export
 * @interface CustomerPaymentOptionSerializerV2
 */
export interface CustomerPaymentOptionSerializerV2 {
    /**
     * 
     * @type {number}
     * @memberof CustomerPaymentOptionSerializerV2
     */
    'id'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CustomerPaymentOptionSerializerV2
     */
    'is_default'?: boolean;
    /**
     * 
     * @type {ShortPaymentMethod}
     * @memberof CustomerPaymentOptionSerializerV2
     */
    'payment_method'?: ShortPaymentMethod;
    /**
     * 
     * @type {PaymentProgramEnum}
     * @memberof CustomerPaymentOptionSerializerV2
     */
    'payment_program'?: PaymentProgramEnum | null;
    /**
     * 
     * @type {PaymentStrategyEnum}
     * @memberof CustomerPaymentOptionSerializerV2
     */
    'payment_strategy'?: PaymentStrategyEnum | null;
    /**
     * 
     * @type {ShortPaymentTerm}
     * @memberof CustomerPaymentOptionSerializerV2
     */
    'payment_term'?: ShortPaymentTerm;
}


/**
 * External serializer class for Customers payment options.
 * @export
 * @interface CustomerPaymentOptionSerializerV2Request
 */
export interface CustomerPaymentOptionSerializerV2Request {
    /**
     * 
     * @type {number}
     * @memberof CustomerPaymentOptionSerializerV2Request
     */
    'id'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CustomerPaymentOptionSerializerV2Request
     */
    'is_default'?: boolean;
    /**
     * 
     * @type {ShortPaymentMethodRequest}
     * @memberof CustomerPaymentOptionSerializerV2Request
     */
    'payment_method'?: ShortPaymentMethodRequest;
    /**
     * 
     * @type {number}
     * @memberof CustomerPaymentOptionSerializerV2Request
     */
    'payment_method_id': number;
    /**
     * 
     * @type {PaymentProgramEnum}
     * @memberof CustomerPaymentOptionSerializerV2Request
     */
    'payment_program'?: PaymentProgramEnum | null;
    /**
     * 
     * @type {PaymentStrategyEnum}
     * @memberof CustomerPaymentOptionSerializerV2Request
     */
    'payment_strategy'?: PaymentStrategyEnum | null;
    /**
     * 
     * @type {ShortPaymentTermRequest}
     * @memberof CustomerPaymentOptionSerializerV2Request
     */
    'payment_term'?: ShortPaymentTermRequest;
    /**
     * 
     * @type {number}
     * @memberof CustomerPaymentOptionSerializerV2Request
     */
    'payment_term_id': number;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const DefaultFlexiblePaymentStrategyEnum = {
    Factored: 'factored',
    ReverseFactored: 'reverse_factored'
} as const;

export type DefaultFlexiblePaymentStrategyEnum = typeof DefaultFlexiblePaymentStrategyEnum[keyof typeof DefaultFlexiblePaymentStrategyEnum];


/**
 * 
 * @export
 * @enum {string}
 */

export const DefaultPaymentProgramEnum = {
    DoNotProcess: 'do_not_process',
    Flexible: 'flexible',
    Direct: 'direct',
    Factoring: 'factoring',
    B2b: 'b2b'
} as const;

export type DefaultPaymentProgramEnum = typeof DefaultPaymentProgramEnum[keyof typeof DefaultPaymentProgramEnum];


/**
 * Delivery object from the Traceability.Delivery table.
 * @export
 * @interface Delivery
 */
export interface Delivery {
    /**
     * 
     * @type {string}
     * @memberof Delivery
     */
    'company_id': string;
    /**
     * 
     * @type {string}
     * @memberof Delivery
     */
    'license_number': string;
    /**
     * 
     * @type {number}
     * @memberof Delivery
     */
    'delivery_package_count': number;
    /**
     * 
     * @type {string}
     * @memberof Delivery
     */
    'recipient_facility_license_number': string | null;
    /**
     * 
     * @type {number}
     * @memberof Delivery
     */
    'delivery_received_package_count': number;
    /**
     * 
     * @type {string}
     * @memberof Delivery
     */
    'received_datetime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Delivery
     */
    'estimated_departure_date_time'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Delivery
     */
    'estimated_arrival_time'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Delivery
     */
    'recipient_facility_name': string | null;
    /**
     * 
     * @type {string}
     * @memberof Delivery
     */
    'shipment_type_name': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof Delivery
     */
    'rejected_packages_returned': boolean | null;
    /**
     * 
     * @type {string}
     * @memberof Delivery
     */
    'gross_weight': string | null;
    /**
     * 
     * @type {string}
     * @memberof Delivery
     */
    'gross_weight_unit_of_weight_name': string | null;
    /**
     * 
     * @type {number}
     * @memberof Delivery
     */
    'metrc_id': number;
    /**
     * 
     * @type {number}
     * @memberof Delivery
     */
    'transfer_metrc_id': number;
    /**
     * 
     * @type {string}
     * @memberof Delivery
     */
    'actual_departure_date_time'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Delivery
     */
    'actual_arrival_time'?: string | null;
}
/**
 * Serializer for traceability delivery packages.
 * @export
 * @interface DeliveryPackage
 */
export interface DeliveryPackage {
    /**
     * 
     * @type {number}
     * @memberof DeliveryPackage
     */
    'id'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DeliveryPackage
     */
    'company_id': string;
    /**
     * 
     * @type {string}
     * @memberof DeliveryPackage
     */
    'license_number': string;
    /**
     * 
     * @type {string}
     * @memberof DeliveryPackage
     */
    'package_label': string;
    /**
     * 
     * @type {string}
     * @memberof DeliveryPackage
     */
    'shipment_package_state': string | null;
    /**
     * 
     * @type {string}
     * @memberof DeliveryPackage
     */
    'shipped_quantity': string | null;
    /**
     * 
     * @type {string}
     * @memberof DeliveryPackage
     */
    'received_quantity': string | null;
    /**
     * 
     * @type {string}
     * @memberof DeliveryPackage
     */
    'resource_type': string;
    /**
     * 
     * @type {number}
     * @memberof DeliveryPackage
     */
    'item_metrc_id': number;
    /**
     * 
     * @type {string}
     * @memberof DeliveryPackage
     */
    'product_category_name': string | null;
    /**
     * 
     * @type {string}
     * @memberof DeliveryPackage
     */
    'item_name': string | null;
    /**
     * 
     * @type {number}
     * @memberof DeliveryPackage
     */
    'item_unit_volume': number | null;
    /**
     * 
     * @type {string}
     * @memberof DeliveryPackage
     */
    'item_unit_volume_unit_of_measure_name': string | null;
    /**
     * 
     * @type {string}
     * @memberof DeliveryPackage
     */
    'item_unit_weight': string | null;
    /**
     * 
     * @type {string}
     * @memberof DeliveryPackage
     */
    'item_unit_weight_unit_of_measure_name': string | null;
    /**
     * 
     * @type {string}
     * @memberof DeliveryPackage
     */
    'item_serving_size': string | null;
    /**
     * 
     * @type {string}
     * @memberof DeliveryPackage
     */
    'item_unit_quantity': string | null;
    /**
     * 
     * @type {string}
     * @memberof DeliveryPackage
     */
    'item_unit_quantity_unit_of_measure_name': string | null;
    /**
     * 
     * @type {string}
     * @memberof DeliveryPackage
     */
    'source_package_label': string;
    /**
     * 
     * @type {string}
     * @memberof DeliveryPackage
     */
    'product_name': string | null;
    /**
     * 
     * @type {number}
     * @memberof DeliveryPackage
     */
    'production_batch_number': number | null;
    /**
     * 
     * @type {string}
     * @memberof DeliveryPackage
     */
    'shipped_unit_of_measure_name': string | null;
    /**
     * 
     * @type {string}
     * @memberof DeliveryPackage
     */
    'gross_unit_of_weight_name': string | null;
    /**
     * 
     * @type {string}
     * @memberof DeliveryPackage
     */
    'received_unit_of_measure_name': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DeliveryPackage
     */
    'is_wholesale': boolean | null;
    /**
     * 
     * @type {string}
     * @memberof DeliveryPackage
     */
    'shipper_wholesale_price': string | null;
    /**
     * 
     * @type {string}
     * @memberof DeliveryPackage
     */
    'receiver_wholesale_price': string | null;
    /**
     * 
     * @type {number}
     * @memberof DeliveryPackage
     */
    'package_metrc_id': number;
    /**
     * 
     * @type {number}
     * @memberof DeliveryPackage
     */
    'delivery_metrc_id': number;
}
/**
 * serializer for Driver Model.
 * @export
 * @interface Driver
 */
export interface Driver {
    /**
     * 
     * @type {number}
     * @memberof Driver
     */
    'id': number;
    /**
     * First Name
     * @type {string}
     * @memberof Driver
     */
    'first_name': string;
    /**
     * Last Name of Driver
     * @type {string}
     * @memberof Driver
     */
    'last_name': string;
    /**
     * METRC Employee ID for Driver
     * @type {string}
     * @memberof Driver
     */
    'metrc_employee_id': string;
    /**
     * License Number of Driver
     * @type {string}
     * @memberof Driver
     */
    'license_number': string;
    /**
     * Phone Number of Driver
     * @type {string}
     * @memberof Driver
     */
    'phone': string;
    /**
     * Is an active driver?
     * @type {boolean}
     * @memberof Driver
     */
    'is_active'?: boolean;
    /**
     * Transport company driver is associated to.
     * @type {number}
     * @memberof Driver
     */
    'transport_company_id': number;
}
/**
 * serializer for Driver Model.
 * @export
 * @interface DriverRequest
 */
export interface DriverRequest {
    /**
     * First Name
     * @type {string}
     * @memberof DriverRequest
     */
    'first_name': string;
    /**
     * Last Name of Driver
     * @type {string}
     * @memberof DriverRequest
     */
    'last_name': string;
    /**
     * METRC Employee ID for Driver
     * @type {string}
     * @memberof DriverRequest
     */
    'metrc_employee_id': string;
    /**
     * License Number of Driver
     * @type {string}
     * @memberof DriverRequest
     */
    'license_number': string;
    /**
     * Phone Number of Driver
     * @type {string}
     * @memberof DriverRequest
     */
    'phone': string;
    /**
     * Is an active driver?
     * @type {boolean}
     * @memberof DriverRequest
     */
    'is_active'?: boolean;
}
/**
 * 
 * @export
 * @interface ErrorSource
 */
export interface ErrorSource {
    /**
     * 
     * @type {string}
     * @memberof ErrorSource
     */
    'pointer'?: string;
    /**
     * 
     * @type {string}
     * @memberof ErrorSource
     */
    'parameter'?: string;
}
/**
 * Serializer for Product Spotlight brands
 * @export
 * @interface FeaturedBrand
 */
export interface FeaturedBrand {
    /**
     * 
     * @type {number}
     * @memberof FeaturedBrand
     */
    'id': number;
    /**
     * Name of the Brand
     * @type {string}
     * @memberof FeaturedBrand
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof FeaturedBrand
     */
    'image': string;
}
/**
 * Serializer for Product Spotlight featured products
 * @export
 * @interface FeaturedProduct
 */
export interface FeaturedProduct {
    /**
     * 
     * @type {number}
     * @memberof FeaturedProduct
     */
    'id': number;
    /**
     * Product Name
     * @type {string}
     * @memberof FeaturedProduct
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof FeaturedProduct
     */
    'company_id': string;
    /**
     * 
     * @type {string}
     * @memberof FeaturedProduct
     */
    'company_name': string;
    /**
     * 
     * @type {boolean}
     * @memberof FeaturedProduct
     */
    'enable_vendor_menu': boolean;
    /**
     * 
     * @type {string}
     * @memberof FeaturedProduct
     */
    'slug': string;
    /**
     * 
     * @type {string}
     * @memberof FeaturedProduct
     */
    'image': string;
    /**
     * This product is featured for it\'s brand.
     * @type {boolean}
     * @memberof FeaturedProduct
     */
    'featured'?: boolean;
    /**
     * 
     * @type {Array<SpotlightBadgesEnum>}
     * @memberof FeaturedProduct
     */
    'spotlight_badges': Array<SpotlightBadgesEnum>;
    /**
     * 
     * @type {string}
     * @memberof FeaturedProduct
     */
    'display_price': string;
    /**
     * 
     * @type {string}
     * @memberof FeaturedProduct
     */
    'display_unit_price': string;
    /**
     * 
     * @type {string}
     * @memberof FeaturedProduct
     */
    'unit_price': string;
    /**
     * 
     * @type {string}
     * @memberof FeaturedProduct
     */
    'base_unit_price': string;
    /**
     * 
     * @type {number}
     * @memberof FeaturedProduct
     */
    'sale_or_deal_price': number;
    /**
     * 
     * @type {FeaturedProductDiscountPercent}
     * @memberof FeaturedProduct
     */
    'discount_percent': FeaturedProductDiscountPercent;
    /**
     * Minimum Units per Order
     * @type {string}
     * @memberof FeaturedProduct
     */
    'minimum_order'?: string;
    /**
     * 
     * @type {FeaturedBrand}
     * @memberof FeaturedProduct
     */
    'brand': FeaturedBrand;
    /**
     * 
     * @type {Sponsorship}
     * @memberof FeaturedProduct
     */
    'sponsorship': Sponsorship;
}
/**
 * @type FeaturedProductDiscountPercent
 * @export
 */
export type FeaturedProductDiscountPercent = number;

/**
 * 
 * @export
 * @enum {string}
 */

export const FieldEnum = {
    SalePrice: 'sale_price',
    WholesalePrice: 'wholesale_price',
    RetailPrice: 'retail_price'
} as const;

export type FieldEnum = typeof FieldEnum[keyof typeof FieldEnum];


/**
 * 
 * @export
 * @enum {string}
 */

export const GrowTypeEnum = {
    Greenhouse: 'greenhouse',
    Indoor: 'indoor',
    LightDeprivation: 'light-deprivation',
    Sun: 'sun'
} as const;

export type GrowTypeEnum = typeof GrowTypeEnum[keyof typeof GrowTypeEnum];


/**
 * 
 * @export
 * @interface IncludedLocation
 */
export interface IncludedLocation {
    /**
     * 
     * @type {number}
     * @memberof IncludedLocation
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof IncludedLocation
     */
    'external_id': string;
    /**
     * 
     * @type {string}
     * @memberof IncludedLocation
     */
    'license_number': string;
    /**
     * 
     * @type {string}
     * @memberof IncludedLocation
     */
    'name': string;
}
/**
 * Internal serializer for traceability API config.
 * @export
 * @interface InternalCompanyAPIConfig
 */
export interface InternalCompanyAPIConfig {
    /**
     * 
     * @type {number}
     * @memberof InternalCompanyAPIConfig
     */
    'integration_id': number;
    /**
     * 
     * @type {string}
     * @memberof InternalCompanyAPIConfig
     */
    'api_key': string;
    /**
     * 
     * @type {string}
     * @memberof InternalCompanyAPIConfig
     */
    'username': string;
    /**
     * 
     * @type {string}
     * @memberof InternalCompanyAPIConfig
     */
    'ubi': string;
    /**
     * 
     * @type {Array<InternalCompanyLicense>}
     * @memberof InternalCompanyAPIConfig
     */
    'licenses': Array<InternalCompanyLicense>;
    /**
     * 
     * @type {IncludedLocation}
     * @memberof InternalCompanyAPIConfig
     */
    'included_locations': IncludedLocation;
}
/**
 * Serializer for the Company License model.
 * @export
 * @interface InternalCompanyLicense
 */
export interface InternalCompanyLicense {
    /**
     * 
     * @type {number}
     * @memberof InternalCompanyLicense
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof InternalCompanyLicense
     */
    'company_license_id': number;
    /**
     * 
     * @type {string}
     * @memberof InternalCompanyLicense
     */
    'number': string;
    /**
     * 
     * @type {LicenseTypeResponse}
     * @memberof InternalCompanyLicense
     */
    'type': LicenseTypeResponse;
    /**
     * 
     * @type {string}
     * @memberof InternalCompanyLicense
     */
    'issue_date': string;
    /**
     * 
     * @type {string}
     * @memberof InternalCompanyLicense
     */
    'expiration_date': string;
    /**
     * Decides whether retailers are allowed to see this license
     * @type {boolean}
     * @memberof InternalCompanyLicense
     */
    'public'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof InternalCompanyLicense
     */
    'archived'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof InternalCompanyLicense
     */
    'document': string;
}
/**
 * Internal serializer for Driver Model.
 * @export
 * @interface InternalDriver
 */
export interface InternalDriver {
    /**
     * 
     * @type {number}
     * @memberof InternalDriver
     */
    'id': number;
    /**
     * First Name
     * @type {string}
     * @memberof InternalDriver
     */
    'first_name': string;
    /**
     * Last Name of Driver
     * @type {string}
     * @memberof InternalDriver
     */
    'last_name': string;
    /**
     * METRC Employee ID for Driver
     * @type {string}
     * @memberof InternalDriver
     */
    'metrc_employee_id': string;
    /**
     * License Number of Driver
     * @type {string}
     * @memberof InternalDriver
     */
    'license_number': string;
    /**
     * Phone Number of Driver
     * @type {string}
     * @memberof InternalDriver
     */
    'phone': string;
    /**
     * Is an active driver?
     * @type {boolean}
     * @memberof InternalDriver
     */
    'is_active'?: boolean;
    /**
     * 
     * @type {InternalTransportCompany}
     * @memberof InternalDriver
     */
    'transport_company': InternalTransportCompany;
}
/**
 * Internal serializer for Driver Model.
 * @export
 * @interface InternalDriverRequest
 */
export interface InternalDriverRequest {
    /**
     * First Name
     * @type {string}
     * @memberof InternalDriverRequest
     */
    'first_name': string;
    /**
     * Last Name of Driver
     * @type {string}
     * @memberof InternalDriverRequest
     */
    'last_name': string;
    /**
     * METRC Employee ID for Driver
     * @type {string}
     * @memberof InternalDriverRequest
     */
    'metrc_employee_id': string;
    /**
     * License Number of Driver
     * @type {string}
     * @memberof InternalDriverRequest
     */
    'license_number': string;
    /**
     * Phone Number of Driver
     * @type {string}
     * @memberof InternalDriverRequest
     */
    'phone': string;
    /**
     * Is an active driver?
     * @type {boolean}
     * @memberof InternalDriverRequest
     */
    'is_active'?: boolean;
}
/**
 * Internal serializer for the Company model to be used by L3 endpoints.
 * @export
 * @interface InternalLogisticsCompany
 */
export interface InternalLogisticsCompany {
    /**
     * 
     * @type {number}
     * @memberof InternalLogisticsCompany
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof InternalLogisticsCompany
     */
    'display_name': string;
    /**
     * 
     * @type {Array<ComplianceLicense>}
     * @memberof InternalLogisticsCompany
     */
    'licenses': Array<ComplianceLicense>;
    /**
     * 
     * @type {Address}
     * @memberof InternalLogisticsCompany
     */
    'delivery_address': Address;
    /**
     * 
     * @type {Address}
     * @memberof InternalLogisticsCompany
     */
    'corporate_address': Address;
}
/**
 * Internal serializer for the Company model to be used by L3 endpoints.
 * @export
 * @interface InternalLogisticsCompanyRequest
 */
export interface InternalLogisticsCompanyRequest {
    /**
     * 
     * @type {string}
     * @memberof InternalLogisticsCompanyRequest
     */
    'display_name': string;
}
/**
 * Internal serializer for TransportCompany Model.
 * @export
 * @interface InternalTransportCompany
 */
export interface InternalTransportCompany {
    /**
     * 
     * @type {number}
     * @memberof InternalTransportCompany
     */
    'id': number;
    /**
     * Name
     * @type {string}
     * @memberof InternalTransportCompany
     */
    'name'?: string | null;
    /**
     * Medical License Number of Transport Company
     * @type {string}
     * @memberof InternalTransportCompany
     */
    'medical_license_number'?: string | null;
    /**
     * Adult-Use License Number of Transport Company
     * @type {string}
     * @memberof InternalTransportCompany
     */
    'adult_use_license_number'?: string | null;
}
/**
 * Internal serializer for TransportCompany Model.
 * @export
 * @interface InternalTransportCompanyRequest
 */
export interface InternalTransportCompanyRequest {
    /**
     * Name
     * @type {string}
     * @memberof InternalTransportCompanyRequest
     */
    'name'?: string | null;
    /**
     * Medical License Number of Transport Company
     * @type {string}
     * @memberof InternalTransportCompanyRequest
     */
    'medical_license_number'?: string | null;
    /**
     * Adult-Use License Number of Transport Company
     * @type {string}
     * @memberof InternalTransportCompanyRequest
     */
    'adult_use_license_number'?: string | null;
}
/**
 * Internal serializer for Vehicle Model.
 * @export
 * @interface InternalVehicle
 */
export interface InternalVehicle {
    /**
     * 
     * @type {number}
     * @memberof InternalVehicle
     */
    'id': number;
    /**
     * Vehicle Make
     * @type {string}
     * @memberof InternalVehicle
     */
    'make'?: string | null;
    /**
     * Vehicle Model Year
     * @type {number}
     * @memberof InternalVehicle
     */
    'model_year'?: number | null;
    /**
     * Vehicle Model Name
     * @type {string}
     * @memberof InternalVehicle
     */
    'model_name'?: string | null;
    /**
     * License Number of Vehicle
     * @type {string}
     * @memberof InternalVehicle
     */
    'license_number'?: string | null;
    /**
     * Vehicle Capacity
     * @type {number}
     * @memberof InternalVehicle
     */
    'capacity'?: number | null;
    /**
     * Vehicle Has Air Conditioner
     * @type {boolean}
     * @memberof InternalVehicle
     */
    'has_air_conditioner'?: boolean;
}
/**
 * Internal serializer for Vehicle Model.
 * @export
 * @interface InternalVehicleRequest
 */
export interface InternalVehicleRequest {
    /**
     * Vehicle Make
     * @type {string}
     * @memberof InternalVehicleRequest
     */
    'make'?: string | null;
    /**
     * Vehicle Model Year
     * @type {number}
     * @memberof InternalVehicleRequest
     */
    'model_year'?: number | null;
    /**
     * Vehicle Model Name
     * @type {string}
     * @memberof InternalVehicleRequest
     */
    'model_name'?: string | null;
    /**
     * License Number of Vehicle
     * @type {string}
     * @memberof InternalVehicleRequest
     */
    'license_number'?: string | null;
    /**
     * Vehicle Capacity
     * @type {number}
     * @memberof InternalVehicleRequest
     */
    'capacity'?: number | null;
    /**
     * Vehicle Has Air Conditioner
     * @type {boolean}
     * @memberof InternalVehicleRequest
     */
    'has_air_conditioner'?: boolean;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const InventoryManagementEnum = {
    Inherited: 'inherited',
    Managed: 'managed',
    Unlimited: 'unlimited'
} as const;

export type InventoryManagementEnum = typeof InventoryManagementEnum[keyof typeof InventoryManagementEnum];


/**
 * Serializer for LegalEntity
 * @export
 * @interface LegalEntity
 */
export interface LegalEntity {
    /**
     * 
     * @type {string}
     * @memberof LegalEntity
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof LegalEntity
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof LegalEntity
     */
    'street_address'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LegalEntity
     */
    'city'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LegalEntity
     */
    'zipcode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LegalEntity
     */
    'unit_number'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LegalEntity
     */
    'state'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LegalEntity
     */
    'country'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LegalEntity
     */
    'lexis_nexis_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LegalEntity
     */
    'rep_first_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LegalEntity
     */
    'rep_last_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LegalEntity
     */
    'rep_title'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LegalEntity
     */
    'phone'?: string | null;
}
/**
 * Serializer for LegalEntity
 * @export
 * @interface LegalEntityRequest
 */
export interface LegalEntityRequest {
    /**
     * 
     * @type {string}
     * @memberof LegalEntityRequest
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof LegalEntityRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof LegalEntityRequest
     */
    'street_address'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LegalEntityRequest
     */
    'city'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LegalEntityRequest
     */
    'zipcode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LegalEntityRequest
     */
    'unit_number'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LegalEntityRequest
     */
    'state'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LegalEntityRequest
     */
    'country'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LegalEntityRequest
     */
    'lexis_nexis_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LegalEntityRequest
     */
    'rep_first_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LegalEntityRequest
     */
    'rep_last_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LegalEntityRequest
     */
    'rep_title'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LegalEntityRequest
     */
    'phone'?: string | null;
}
/**
 * Licenses Serializer
 * @export
 * @interface License
 */
export interface License {
    /**
     * 
     * @type {string}
     * @memberof License
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof License
     */
    'number': string;
    /**
     * 
     * @type {State}
     * @memberof License
     */
    'state': State;
    /**
     * Date the license was verified by Leaflink. Not the date the license was verified by Cannabiz API.
     * @type {string}
     * @memberof License
     */
    'verification_date'?: string | null;
    /**
     * 
     * @type {VerificationStatusEnum}
     * @memberof License
     */
    'verification_status'?: VerificationStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof License
     */
    'issued_date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof License
     */
    'expiration_date'?: string | null;
    /**
     * 
     * @type {LicenseType}
     * @memberof License
     */
    'type'?: LicenseType | null;
}


/**
 * 
 * @export
 * @interface LicenseApiKeyRequest
 */
export interface LicenseApiKeyRequest {
    /**
     * 
     * @type {string}
     * @memberof LicenseApiKeyRequest
     */
    'api_key': string;
}
/**
 * 
 * @export
 * @interface LicenseCreateUpdateRequest
 */
export interface LicenseCreateUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof LicenseCreateUpdateRequest
     */
    'number': string;
    /**
     * 
     * @type {string}
     * @memberof LicenseCreateUpdateRequest
     */
    'start_date': string | null;
    /**
     * 
     * @type {string}
     * @memberof LicenseCreateUpdateRequest
     */
    'end_date': string;
    /**
     * 
     * @type {number}
     * @memberof LicenseCreateUpdateRequest
     */
    'type_id': number;
}
/**
 * Serializer for License
 * @export
 * @interface LicenseRequest
 */
export interface LicenseRequest {
    /**
     * 
     * @type {string}
     * @memberof LicenseRequest
     */
    'id'?: string;
    /**
     * 
     * @type {LicenseType}
     * @memberof LicenseRequest
     */
    'type'?: LicenseType | null;
    /**
     * 
     * @type {string}
     * @memberof LicenseRequest
     */
    'number': string;
    /**
     * 
     * @type {string}
     * @memberof LicenseRequest
     */
    'state'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof LicenseRequest
     */
    'is_buyer_license'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof LicenseRequest
     */
    'is_seller_license'?: boolean | null;
}
/**
 * @type LicenseType
 * @export
 */
export type LicenseType = BlankEnum | LicenseTypeEnum;

/**
 * 
 * @export
 * @enum {string}
 */

export const LicenseTypeEnum = {
    Medical: 'medical',
    Combined: 'combined',
    Ancillary2: 'ancillary_2',
    Ancillary: 'ancillary',
    AdultUse: 'adult_use',
    Cannabis: 'cannabis',
    MedicalTransporter: 'medical_transporter',
    AncillaryLogisitics: 'ancillary_logisitics'
} as const;

export type LicenseTypeEnum = typeof LicenseTypeEnum[keyof typeof LicenseTypeEnum];


/**
 * Serializer for LicenseType models via the internal API
 * @export
 * @interface LicenseTypeResponse
 */
export interface LicenseTypeResponse {
    /**
     * This license type is available for current registrations.
     * @type {boolean}
     * @memberof LicenseTypeResponse
     */
    'active_for_registration'?: boolean;
    /**
     * License Classification Type
     * @type {string}
     * @memberof LicenseTypeResponse
     */
    'classification': string;
    /**
     * 
     * @type {string}
     * @memberof LicenseTypeResponse
     */
    'created_on': string;
    /**
     * Description or Notes
     * @type {string}
     * @memberof LicenseTypeResponse
     */
    'description'?: string | null;
    /**
     * Type for display in the Leaflink frontend
     * @type {string}
     * @memberof LicenseTypeResponse
     */
    'display_type': string;
    /**
     * This license type can sell medical line items.
     * @type {boolean}
     * @memberof LicenseTypeResponse
     */
    'has_medical_line_items'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof LicenseTypeResponse
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof LicenseTypeResponse
     */
    'modified': string;
    /**
     * post-2018 CA license.
     * @type {boolean}
     * @memberof LicenseTypeResponse
     */
    'post_2018_CA'?: boolean;
    /**
     * pre-2018 CA license.
     * @type {boolean}
     * @memberof LicenseTypeResponse
     */
    'pre_2018_CA'?: boolean;
    /**
     * EIN is required to register under this license type.
     * @type {boolean}
     * @memberof LicenseTypeResponse
     */
    'require_ein'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof LicenseTypeResponse
     */
    'state_id': number | null;
    /**
     * License Type
     * @type {string}
     * @memberof LicenseTypeResponse
     */
    'type': string;
}
/**
 * Serializer for returning a list of created or updated license IDs.
 * @export
 * @interface LicensesCreateUpdateResponse
 */
export interface LicensesCreateUpdateResponse {
    /**
     * 
     * @type {Array<number>}
     * @memberof LicensesCreateUpdateResponse
     */
    'license_ids': Array<number>;
}
/**
 * Company serializer contains only basic fields.
 * @export
 * @interface LightCompany
 */
export interface LightCompany {
    /**
     * 
     * @type {number}
     * @memberof LightCompany
     */
    'id': number;
    /**
     * Name of Company (Note this is not the same as Brand)
     * @type {string}
     * @memberof LightCompany
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof LightCompany
     */
    'slug'?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ListingStateEnum = {
    Available: 'Available',
    Archived: 'Archived',
    Sample: 'Sample',
    Backorder: 'Backorder',
    Internal: 'Internal',
    Unavailable: 'Unavailable'
} as const;

export type ListingStateEnum = typeof ListingStateEnum[keyof typeof ListingStateEnum];


/**
 * Discussion Message serializer
 * @export
 * @interface Message
 */
export interface Message {
    /**
     * 
     * @type {number}
     * @memberof Message
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof Message
     */
    'message': string;
    /**
     * 
     * @type {string}
     * @memberof Message
     */
    'created_on': string;
    /**
     * 
     * @type {string}
     * @memberof Message
     */
    'read_by_sender': string;
    /**
     * 
     * @type {string}
     * @memberof Message
     */
    'read_by_recipient': string;
    /**
     * 
     * @type {Author}
     * @memberof Message
     */
    'author': Author;
}
/**
 * Discussion Message serializer
 * @export
 * @interface MessageRequest
 */
export interface MessageRequest {
    /**
     * 
     * @type {string}
     * @memberof MessageRequest
     */
    'message': string;
}
/**
 * Metrc-specific transfer fields serializer.
 * @export
 * @interface MetrcDelivery
 */
export interface MetrcDelivery {
    /**
     * 
     * @type {number}
     * @memberof MetrcDelivery
     */
    'delivery_received_package_count': number;
    /**
     * 
     * @type {string}
     * @memberof MetrcDelivery
     */
    'received_datetime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MetrcDelivery
     */
    'estimated_departure_date_time'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MetrcDelivery
     */
    'estimated_arrival_time'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MetrcDelivery
     */
    'recipient_facility_name': string | null;
    /**
     * 
     * @type {string}
     * @memberof MetrcDelivery
     */
    'shipment_type_name': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof MetrcDelivery
     */
    'rejected_packages_returned': boolean | null;
    /**
     * 
     * @type {string}
     * @memberof MetrcDelivery
     */
    'gross_weight': string | null;
    /**
     * 
     * @type {string}
     * @memberof MetrcDelivery
     */
    'gross_weight_unit_of_weight_name': string | null;
}
/**
 * Metrc-specific DeliveryPackage fields serializer.
 * @export
 * @interface MetrcDeliveryPackage
 */
export interface MetrcDeliveryPackage {
    /**
     * 
     * @type {string}
     * @memberof MetrcDeliveryPackage
     */
    'resource_type': string;
    /**
     * 
     * @type {number}
     * @memberof MetrcDeliveryPackage
     */
    'item_metrc_id': number;
    /**
     * 
     * @type {string}
     * @memberof MetrcDeliveryPackage
     */
    'product_category_name': string | null;
    /**
     * 
     * @type {string}
     * @memberof MetrcDeliveryPackage
     */
    'item_name': string | null;
    /**
     * 
     * @type {number}
     * @memberof MetrcDeliveryPackage
     */
    'item_unit_volume': number | null;
    /**
     * 
     * @type {string}
     * @memberof MetrcDeliveryPackage
     */
    'item_unit_volume_unit_of_measure_name': string | null;
    /**
     * 
     * @type {string}
     * @memberof MetrcDeliveryPackage
     */
    'item_unit_weight': string | null;
    /**
     * 
     * @type {string}
     * @memberof MetrcDeliveryPackage
     */
    'item_unit_weight_unit_of_measure_name': string | null;
    /**
     * 
     * @type {string}
     * @memberof MetrcDeliveryPackage
     */
    'item_serving_size': string | null;
    /**
     * 
     * @type {string}
     * @memberof MetrcDeliveryPackage
     */
    'item_unit_quantity': string | null;
    /**
     * 
     * @type {string}
     * @memberof MetrcDeliveryPackage
     */
    'item_unit_quantity_unit_of_measure_name': string | null;
    /**
     * 
     * @type {string}
     * @memberof MetrcDeliveryPackage
     */
    'source_package_label': string;
    /**
     * 
     * @type {string}
     * @memberof MetrcDeliveryPackage
     */
    'product_name': string | null;
    /**
     * 
     * @type {number}
     * @memberof MetrcDeliveryPackage
     */
    'production_batch_number': number | null;
    /**
     * 
     * @type {string}
     * @memberof MetrcDeliveryPackage
     */
    'shipped_unit_of_measure_name': string | null;
    /**
     * 
     * @type {string}
     * @memberof MetrcDeliveryPackage
     */
    'gross_unit_of_weight_name': string | null;
    /**
     * 
     * @type {string}
     * @memberof MetrcDeliveryPackage
     */
    'received_unit_of_measure_name': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof MetrcDeliveryPackage
     */
    'is_wholesale': boolean | null;
    /**
     * 
     * @type {string}
     * @memberof MetrcDeliveryPackage
     */
    'shipper_wholesale_price': string | null;
    /**
     * 
     * @type {string}
     * @memberof MetrcDeliveryPackage
     */
    'receiver_wholesale_price': string | null;
}
/**
 * 
 * @export
 * @interface MetrcDriver
 */
export interface MetrcDriver {
    /**
     * 
     * @type {string}
     * @memberof MetrcDriver
     */
    'resource_type': string;
    /**
     * 
     * @type {number}
     * @memberof MetrcDriver
     */
    'common_driver_id': number;
    /**
     * 
     * @type {string}
     * @memberof MetrcDriver
     */
    'drivers_license_number': string;
    /**
     * 
     * @type {string}
     * @memberof MetrcDriver
     */
    'employee_id': string;
}
/**
 * Metrc specific location fields from the Traceability.metrc_location table.
 * @export
 * @interface MetrcLocation
 */
export interface MetrcLocation {
    /**
     * ID of the common_location in the Traceability Service
     * @type {number}
     * @memberof MetrcLocation
     */
    'common_location_id': number;
    /**
     * 
     * @type {number}
     * @memberof MetrcLocation
     */
    'metrc_type_id': number;
    /**
     * 
     * @type {string}
     * @memberof MetrcLocation
     */
    'type_name': string;
    /**
     * 
     * @type {boolean}
     * @memberof MetrcLocation
     */
    'for_harvests'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MetrcLocation
     */
    'for_packages'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MetrcLocation
     */
    'for_plant_batches'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MetrcLocation
     */
    'for_plants'?: boolean;
}
/**
 * Metrc package fields from the Traceability.metrc_package table.
 * @export
 * @interface MetrcPackage
 */
export interface MetrcPackage {
    /**
     * 
     * @type {number}
     * @memberof MetrcPackage
     */
    'common_package_id': number;
    /**
     * 
     * @type {string}
     * @memberof MetrcPackage
     */
    'external_last_modified_at': string;
    /**
     * 
     * @type {number}
     * @memberof MetrcPackage
     */
    'item_id': number;
    /**
     * 
     * @type {TraceabilityItem}
     * @memberof MetrcPackage
     */
    'item': TraceabilityItem;
    /**
     * 
     * @type {boolean}
     * @memberof MetrcPackage
     */
    'has_lab_test_document': boolean;
    /**
     * 
     * @type {string}
     * @memberof MetrcPackage
     */
    'item_from_facility_license_number': string;
    /**
     * 
     * @type {string}
     * @memberof MetrcPackage
     */
    'item_from_facility_name': string;
    /**
     * 
     * @type {string}
     * @memberof MetrcPackage
     */
    'note': string;
    /**
     * 
     * @type {string}
     * @memberof MetrcPackage
     */
    'packaged_date': string;
    /**
     * 
     * @type {string}
     * @memberof MetrcPackage
     */
    'production_batch_number': string | null;
    /**
     * 
     * @type {string}
     * @memberof MetrcPackage
     */
    'received_date_time': string | null;
    /**
     * 
     * @type {string}
     * @memberof MetrcPackage
     */
    'received_from_facility_license_number': string | null;
    /**
     * 
     * @type {string}
     * @memberof MetrcPackage
     */
    'received_from_facility_name': string | null;
    /**
     * 
     * @type {string}
     * @memberof MetrcPackage
     */
    'received_from_manifest_number': string | null;
    /**
     * 
     * @type {string}
     * @memberof MetrcPackage
     */
    'result_cbc': string;
    /**
     * 
     * @type {string}
     * @memberof MetrcPackage
     */
    'result_cbg': string;
    /**
     * 
     * @type {string}
     * @memberof MetrcPackage
     */
    'result_cbga': string;
    /**
     * 
     * @type {string}
     * @memberof MetrcPackage
     */
    'result_cbn': string;
    /**
     * 
     * @type {string}
     * @memberof MetrcPackage
     */
    'result_delta10': string;
    /**
     * 
     * @type {string}
     * @memberof MetrcPackage
     */
    'result_delta8': string;
    /**
     * 
     * @type {string}
     * @memberof MetrcPackage
     */
    'result_thcv': string;
    /**
     * 
     * @type {string}
     * @memberof MetrcPackage
     */
    'result_thcva': string;
    /**
     * 
     * @type {string}
     * @memberof MetrcPackage
     */
    'result_total_thc': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof MetrcPackage
     */
    'source_package_labels': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof MetrcPackage
     */
    'source_production_batch_numbers': string | null;
    /**
     * 
     * @type {string}
     * @memberof MetrcPackage
     */
    'type': string | null;
    /**
     * 
     * @type {string}
     * @memberof MetrcPackage
     */
    'unit_of_measure': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof MetrcPackage
     */
    'use_item_level_lab_result'?: boolean;
}
/**
 * Metrc-specific transfer fields serializer.
 * @export
 * @interface MetrcTransfer
 */
export interface MetrcTransfer {
    /**
     * 
     * @type {string}
     * @memberof MetrcTransfer
     */
    'resource_type': string;
    /**
     * 
     * @type {number}
     * @memberof MetrcTransfer
     */
    'metrc_delivery_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof MetrcTransfer
     */
    'recipient_facility_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MetrcTransfer
     */
    'shipment_type_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MetrcTransfer
     */
    'shipment_license_type'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MetrcTransfer
     */
    'shipment_transaction_type'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MetrcTransfer
     */
    'received_datetime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MetrcTransfer
     */
    'estimated_departure_datetime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MetrcTransfer
     */
    'estimated_arrival_datetime'?: string | null;
}
/**
 * 
 * @export
 * @interface MetrcVehicle
 */
export interface MetrcVehicle {
    /**
     * 
     * @type {string}
     * @memberof MetrcVehicle
     */
    'resource_type': string;
}
/**
 * 
 * @export
 * @interface ModelError
 */
export interface ModelError {
    /**
     * 
     * @type {string}
     * @memberof ModelError
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ModelError
     */
    'status': string;
    /**
     * 
     * @type {string}
     * @memberof ModelError
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof ModelError
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof ModelError
     */
    'detail'?: string;
    /**
     * 
     * @type {ErrorSource}
     * @memberof ModelError
     */
    'source'?: ErrorSource;
    /**
     * 
     * @type {any}
     * @memberof ModelError
     */
    'meta'?: any;
}
/**
 * 
 * @export
 * @interface MultipleErrors
 */
export interface MultipleErrors {
    /**
     * 
     * @type {Array<Error>}
     * @memberof MultipleErrors
     */
    'errors': Array<Error>;
}
/**
 * Company serializer to use as a nested value.
 * @export
 * @interface NestedCompany
 */
export interface NestedCompany {
    /**
     * 
     * @type {number}
     * @memberof NestedCompany
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof NestedCompany
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof NestedCompany
     */
    'address': string;
    /**
     * 
     * @type {string}
     * @memberof NestedCompany
     */
    'unit_number': string;
    /**
     * 
     * @type {string}
     * @memberof NestedCompany
     */
    'city': string;
    /**
     * 
     * @type {string}
     * @memberof NestedCompany
     */
    'state': string;
    /**
     * 
     * @type {string}
     * @memberof NestedCompany
     */
    'zip': string;
    /**
     * Phone Number of Company
     * @type {string}
     * @memberof NestedCompany
     */
    'phone'?: string | null;
    /**
     * 
     * @type {Array<NestedLicense>}
     * @memberof NestedCompany
     */
    'licenses': Array<NestedLicense>;
    /**
     * 
     * @type {string}
     * @memberof NestedCompany
     */
    'slug'?: string;
}
/**
 * License serializer to use as a nested value.
 * @export
 * @interface NestedLicense
 */
export interface NestedLicense {
    /**
     * 
     * @type {number}
     * @memberof NestedLicense
     */
    'id': number;
    /**
     * License Number
     * @type {string}
     * @memberof NestedLicense
     */
    'number': string;
    /**
     * 
     * @type {string}
     * @memberof NestedLicense
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof NestedLicense
     */
    'classification': string;
}
/**
 * Serializer for seller info on a buyer order.
 * @export
 * @interface NestedOrderSeller
 */
export interface NestedOrderSeller {
    /**
     * 
     * @type {number}
     * @memberof NestedOrderSeller
     */
    'id': number;
    /**
     * Name of Company (Note this is not the same as Brand)
     * @type {string}
     * @memberof NestedOrderSeller
     */
    'name': string;
    /**
     * This seller company has enabled the vendor menu for their company
     * @type {boolean}
     * @memberof NestedOrderSeller
     */
    'enable_seller_menu'?: boolean;
    /**
     * 
     * @type {Array<NestedLicense>}
     * @memberof NestedOrderSeller
     */
    'licenses': Array<NestedLicense>;
}
/**
 * Ordered Product serializer to use as a nested value.
 * @export
 * @interface NestedOrderedProduct
 */
export interface NestedOrderedProduct {
    /**
     * 
     * @type {NestedProduct}
     * @memberof NestedOrderedProduct
     */
    'product': NestedProduct;
    /**
     * 
     * @type {number}
     * @memberof NestedOrderedProduct
     */
    'quantity': number;
    /**
     * 
     * @type {string}
     * @memberof NestedOrderedProduct
     */
    'sold_by': string;
    /**
     * 
     * @type {number}
     * @memberof NestedOrderedProduct
     */
    'price': number;
    /**
     * 
     * @type {string}
     * @memberof NestedOrderedProduct
     */
    'total': string;
    /**
     * Information about discounts that were applied to this product.
     * @type {{ [key: string]: any; }}
     * @memberof NestedOrderedProduct
     */
    'discount_info'?: { [key: string]: any; } | null;
}
/**
 * Product serializer to use as a nested value.
 * @export
 * @interface NestedProduct
 */
export interface NestedProduct {
    /**
     * 
     * @type {number}
     * @memberof NestedProduct
     */
    'id': number;
    /**
     * Stock Keeping Unit. A unique identifier for a Product, alternative to id.
     * @type {string}
     * @memberof NestedProduct
     */
    'sku'?: string | null;
    /**
     * Product Name
     * @type {string}
     * @memberof NestedProduct
     */
    'name': string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof NestedProduct
     */
    'brand': { [key: string]: any; };
    /**
     * 
     * @type {string}
     * @memberof NestedProduct
     */
    'unit_of_measure'?: string;
    /**
     * 
     * @type {string}
     * @memberof NestedProduct
     */
    'unit_denomination'?: string;
    /**
     * 
     * @type {string}
     * @memberof NestedProduct
     */
    'base_unit_of_measure': string | null;
    /**
     * 
     * @type {number}
     * @memberof NestedProduct
     */
    'base_units_per_unit': number | null;
    /**
     * 
     * @type {boolean}
     * @memberof NestedProduct
     */
    'sold_in_multiples': boolean;
    /**
     * 
     * @type {number}
     * @memberof NestedProduct
     */
    'units_per_case': number | null;
    /**
     * 
     * @type {ProductCategory}
     * @memberof NestedProduct
     */
    'category': ProductCategory;
    /**
     * 
     * @type {ProductSubCategory}
     * @memberof NestedProduct
     */
    'sub_category': ProductSubCategory;
    /**
     * 
     * @type {boolean}
     * @memberof NestedProduct
     */
    'is_ancillary': boolean;
}
/**
 * Schema for notification preferences payload.
 * @export
 * @interface NotificationPreferences
 */
export interface NotificationPreferences {
    /**
     * 
     * @type {string}
     * @memberof NotificationPreferences
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof NotificationPreferences
     */
    'display_description': string;
    /**
     * 
     * @type {Array<NotificationTopic>}
     * @memberof NotificationPreferences
     */
    'items': Array<NotificationTopic>;
}
/**
 * 
 * @export
 * @interface NotificationPreferencesPayloadSchema
 */
export interface NotificationPreferencesPayloadSchema {
    /**
     * 
     * @type {string}
     * @memberof NotificationPreferencesPayloadSchema
     */
    'topic': string;
    /**
     * 
     * @type {string}
     * @memberof NotificationPreferencesPayloadSchema
     */
    'medium': string;
    /**
     * 
     * @type {boolean}
     * @memberof NotificationPreferencesPayloadSchema
     */
    'enabled_timestamp': boolean;
}
/**
 * 
 * @export
 * @interface NotificationPreferencesUnifiedUpstreamNotificationService
 */
export interface NotificationPreferencesUnifiedUpstreamNotificationService {
    /**
     * 
     * @type {string}
     * @memberof NotificationPreferencesUnifiedUpstreamNotificationService
     */
    'topic': string;
    /**
     * 
     * @type {string}
     * @memberof NotificationPreferencesUnifiedUpstreamNotificationService
     */
    'medium': string;
    /**
     * 
     * @type {string}
     * @memberof NotificationPreferencesUnifiedUpstreamNotificationService
     */
    'enabled_timestamp': string | null;
}
/**
 * Serializer for NotificationTopic model.
 * @export
 * @interface NotificationTopic
 */
export interface NotificationTopic {
    /**
     * 
     * @type {string}
     * @memberof NotificationTopic
     */
    'name': string;
    /**
     * 
     * @type {boolean}
     * @memberof NotificationTopic
     */
    'default_value': boolean;
    /**
     * 
     * @type {string}
     * @memberof NotificationTopic
     */
    'description': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof NotificationTopic
     */
    'available_medium': Array<string>;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const NullEnum = {
} as const;

export type NullEnum = typeof NullEnum[keyof typeof NullEnum];


/**
 * 
 * @export
 * @enum {string}
 */

export const NullEnumUnifiedUpstreamMarketplace = {
} as const;

export type NullEnumUnifiedUpstreamMarketplace = typeof NullEnumUnifiedUpstreamMarketplace[keyof typeof NullEnumUnifiedUpstreamMarketplace];


/**
 * 
 * @export
 * @interface PaginatedBrandListingContentList
 */
export interface PaginatedBrandListingContentList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedBrandListingContentList
     */
    'count'?: number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedBrandListingContentList
     */
    'next'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedBrandListingContentList
     */
    'previous'?: string | null;
    /**
     * 
     * @type {BrandListingContent}
     * @memberof PaginatedBrandListingContentList
     */
    'content'?: BrandListingContent;
}
/**
 * 
 * @export
 * @interface PaginatedBuyerNotificationSettingList
 */
export interface PaginatedBuyerNotificationSettingList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedBuyerNotificationSettingList
     */
    'count': number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedBuyerNotificationSettingList
     */
    'next'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedBuyerNotificationSettingList
     */
    'previous'?: string | null;
    /**
     * 
     * @type {Array<BuyerNotificationSetting>}
     * @memberof PaginatedBuyerNotificationSettingList
     */
    'results': Array<BuyerNotificationSetting>;
}
/**
 * 
 * @export
 * @interface PaginatedCompanyLicenseList
 */
export interface PaginatedCompanyLicenseList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedCompanyLicenseList
     */
    'count': number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedCompanyLicenseList
     */
    'next'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedCompanyLicenseList
     */
    'previous'?: string | null;
    /**
     * 
     * @type {Array<CompanyLicense>}
     * @memberof PaginatedCompanyLicenseList
     */
    'results': Array<CompanyLicense>;
}
/**
 * 
 * @export
 * @interface PaginatedCompanyList
 */
export interface PaginatedCompanyList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedCompanyList
     */
    'count': number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedCompanyList
     */
    'next'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedCompanyList
     */
    'previous'?: string | null;
    /**
     * 
     * @type {Array<Company>}
     * @memberof PaginatedCompanyList
     */
    'results': Array<Company>;
}
/**
 * 
 * @export
 * @interface PaginatedCompanyTransportPartnerList
 */
export interface PaginatedCompanyTransportPartnerList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedCompanyTransportPartnerList
     */
    'count': number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedCompanyTransportPartnerList
     */
    'next'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedCompanyTransportPartnerList
     */
    'previous'?: string | null;
    /**
     * 
     * @type {Array<CompanyTransportPartner>}
     * @memberof PaginatedCompanyTransportPartnerList
     */
    'results': Array<CompanyTransportPartner>;
}
/**
 * 
 * @export
 * @interface PaginatedContractList
 */
export interface PaginatedContractList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedContractList
     */
    'count': number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedContractList
     */
    'next'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedContractList
     */
    'previous'?: string | null;
    /**
     * 
     * @type {Array<Contract>}
     * @memberof PaginatedContractList
     */
    'results': Array<Contract>;
}
/**
 * 
 * @export
 * @interface PaginatedFeaturedProductList
 */
export interface PaginatedFeaturedProductList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedFeaturedProductList
     */
    'count': number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedFeaturedProductList
     */
    'next'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedFeaturedProductList
     */
    'previous'?: string | null;
    /**
     * 
     * @type {Array<FeaturedProduct>}
     * @memberof PaginatedFeaturedProductList
     */
    'results': Array<FeaturedProduct>;
}
/**
 * 
 * @export
 * @interface PaginatedInternalDriverList
 */
export interface PaginatedInternalDriverList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedInternalDriverList
     */
    'count': number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedInternalDriverList
     */
    'next'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedInternalDriverList
     */
    'previous'?: string | null;
    /**
     * 
     * @type {Array<InternalDriver>}
     * @memberof PaginatedInternalDriverList
     */
    'results': Array<InternalDriver>;
}
/**
 * 
 * @export
 * @interface PaginatedLicenseList
 */
export interface PaginatedLicenseList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedLicenseList
     */
    'count': number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedLicenseList
     */
    'next'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedLicenseList
     */
    'previous'?: string | null;
    /**
     * 
     * @type {Array<License>}
     * @memberof PaginatedLicenseList
     */
    'results': Array<License>;
}
/**
 * 
 * @export
 * @interface PaginatedLicenseTypeResponseList
 */
export interface PaginatedLicenseTypeResponseList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedLicenseTypeResponseList
     */
    'count': number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedLicenseTypeResponseList
     */
    'next'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedLicenseTypeResponseList
     */
    'previous'?: string | null;
    /**
     * 
     * @type {Array<LicenseTypeResponse>}
     * @memberof PaginatedLicenseTypeResponseList
     */
    'results': Array<LicenseTypeResponse>;
}
/**
 * 
 * @export
 * @interface PaginatedMessageList
 */
export interface PaginatedMessageList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedMessageList
     */
    'count'?: number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedMessageList
     */
    'next'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedMessageList
     */
    'previous'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof PaginatedMessageList
     */
    'current_page'?: number;
    /**
     * 
     * @type {Array<Message>}
     * @memberof PaginatedMessageList
     */
    'results'?: Array<Message>;
}
/**
 * 
 * @export
 * @interface PaginatedNotificationPreferencesList
 */
export interface PaginatedNotificationPreferencesList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedNotificationPreferencesList
     */
    'count': number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedNotificationPreferencesList
     */
    'next'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedNotificationPreferencesList
     */
    'previous'?: string | null;
    /**
     * 
     * @type {Array<NotificationPreferences>}
     * @memberof PaginatedNotificationPreferencesList
     */
    'results': Array<NotificationPreferences>;
}
/**
 * 
 * @export
 * @interface PaginatedPolymorphicTransferList
 */
export interface PaginatedPolymorphicTransferList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedPolymorphicTransferList
     */
    'count': number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedPolymorphicTransferList
     */
    'next'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedPolymorphicTransferList
     */
    'previous'?: string | null;
    /**
     * 
     * @type {Array<PolymorphicTransfer>}
     * @memberof PaginatedPolymorphicTransferList
     */
    'results': Array<PolymorphicTransfer>;
}
/**
 * 
 * @export
 * @interface PaginatedProductCategoryList
 */
export interface PaginatedProductCategoryList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedProductCategoryList
     */
    'count': number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedProductCategoryList
     */
    'next'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedProductCategoryList
     */
    'previous'?: string | null;
    /**
     * 
     * @type {Array<ProductCategory>}
     * @memberof PaginatedProductCategoryList
     */
    'results': Array<ProductCategory>;
}
/**
 * 
 * @export
 * @interface PaginatedProductPromotionList
 */
export interface PaginatedProductPromotionList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedProductPromotionList
     */
    'count': number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedProductPromotionList
     */
    'next'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedProductPromotionList
     */
    'previous'?: string | null;
    /**
     * 
     * @type {Array<ProductPromotion>}
     * @memberof PaginatedProductPromotionList
     */
    'results': Array<ProductPromotion>;
}
/**
 * 
 * @export
 * @interface PaginatedRecommendedProductList
 */
export interface PaginatedRecommendedProductList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedRecommendedProductList
     */
    'count': number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedRecommendedProductList
     */
    'next'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedRecommendedProductList
     */
    'previous'?: string | null;
    /**
     * 
     * @type {Array<RecommendedProduct>}
     * @memberof PaginatedRecommendedProductList
     */
    'results': Array<RecommendedProduct>;
}
/**
 * 
 * @export
 * @interface PaginatedStateList
 */
export interface PaginatedStateList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedStateList
     */
    'count': number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedStateList
     */
    'next'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedStateList
     */
    'previous'?: string | null;
    /**
     * 
     * @type {Array<StateUnifiedUpstreamMarketplace>}
     * @memberof PaginatedStateList
     */
    'results': Array<StateUnifiedUpstreamMarketplace>;
}
/**
 * 
 * @export
 * @interface PaginatedTraceabilityDriverList
 */
export interface PaginatedTraceabilityDriverList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedTraceabilityDriverList
     */
    'count': number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedTraceabilityDriverList
     */
    'next'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedTraceabilityDriverList
     */
    'previous'?: string | null;
    /**
     * 
     * @type {Array<TraceabilityDriver>}
     * @memberof PaginatedTraceabilityDriverList
     */
    'results': Array<TraceabilityDriver>;
}
/**
 * 
 * @export
 * @interface PaginatedTraceabilityItemList
 */
export interface PaginatedTraceabilityItemList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedTraceabilityItemList
     */
    'count': number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedTraceabilityItemList
     */
    'next'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedTraceabilityItemList
     */
    'previous'?: string | null;
    /**
     * 
     * @type {Array<TraceabilityItem>}
     * @memberof PaginatedTraceabilityItemList
     */
    'results': Array<TraceabilityItem>;
}
/**
 * 
 * @export
 * @interface PaginatedTraceabilityPackageList
 */
export interface PaginatedTraceabilityPackageList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedTraceabilityPackageList
     */
    'count': number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedTraceabilityPackageList
     */
    'next'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedTraceabilityPackageList
     */
    'previous'?: string | null;
    /**
     * 
     * @type {Array<TraceabilityPackage>}
     * @memberof PaginatedTraceabilityPackageList
     */
    'results': Array<TraceabilityPackage>;
}
/**
 * 
 * @export
 * @interface PaginatedTraceabilityRefreshRequestList
 */
export interface PaginatedTraceabilityRefreshRequestList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedTraceabilityRefreshRequestList
     */
    'count': number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedTraceabilityRefreshRequestList
     */
    'next'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedTraceabilityRefreshRequestList
     */
    'previous'?: string | null;
    /**
     * 
     * @type {Array<TraceabilityRefreshRequest>}
     * @memberof PaginatedTraceabilityRefreshRequestList
     */
    'results': Array<TraceabilityRefreshRequest>;
}
/**
 * 
 * @export
 * @interface PaginatedTraceabilityTemplateList
 */
export interface PaginatedTraceabilityTemplateList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedTraceabilityTemplateList
     */
    'count': number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedTraceabilityTemplateList
     */
    'next'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedTraceabilityTemplateList
     */
    'previous'?: string | null;
    /**
     * 
     * @type {Array<TraceabilityTemplate>}
     * @memberof PaginatedTraceabilityTemplateList
     */
    'results': Array<TraceabilityTemplate>;
}
/**
 * 
 * @export
 * @interface PaginatedTraceabilityVehicleList
 */
export interface PaginatedTraceabilityVehicleList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedTraceabilityVehicleList
     */
    'count': number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedTraceabilityVehicleList
     */
    'next'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedTraceabilityVehicleList
     */
    'previous'?: string | null;
    /**
     * 
     * @type {Array<TraceabilityVehicle>}
     * @memberof PaginatedTraceabilityVehicleList
     */
    'results': Array<TraceabilityVehicle>;
}
/**
 * 
 * @export
 * @interface PaginatedTransferCompanyList
 */
export interface PaginatedTransferCompanyList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedTransferCompanyList
     */
    'count': number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedTransferCompanyList
     */
    'next'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedTransferCompanyList
     */
    'previous'?: string | null;
    /**
     * 
     * @type {Array<TransferCompany>}
     * @memberof PaginatedTransferCompanyList
     */
    'results': Array<TransferCompany>;
}
/**
 * 
 * @export
 * @interface PaginatedTransportCompanyList
 */
export interface PaginatedTransportCompanyList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedTransportCompanyList
     */
    'count': number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedTransportCompanyList
     */
    'next'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedTransportCompanyList
     */
    'previous'?: string | null;
    /**
     * 
     * @type {Array<TransportCompany>}
     * @memberof PaginatedTransportCompanyList
     */
    'results': Array<TransportCompany>;
}
/**
 * 
 * @export
 * @interface PaginatedUnifiedBuyerProductImageList
 */
export interface PaginatedUnifiedBuyerProductImageList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedUnifiedBuyerProductImageList
     */
    'count': number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedUnifiedBuyerProductImageList
     */
    'next'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedUnifiedBuyerProductImageList
     */
    'previous'?: string | null;
    /**
     * 
     * @type {Array<UnifiedBuyerProductImage>}
     * @memberof PaginatedUnifiedBuyerProductImageList
     */
    'results': Array<UnifiedBuyerProductImage>;
}
/**
 * 
 * @export
 * @interface PaginatedUnifiedChatsList
 */
export interface PaginatedUnifiedChatsList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedUnifiedChatsList
     */
    'count'?: number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedUnifiedChatsList
     */
    'next'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedUnifiedChatsList
     */
    'previous'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof PaginatedUnifiedChatsList
     */
    'current_page'?: number;
    /**
     * 
     * @type {Array<UnifiedChats>}
     * @memberof PaginatedUnifiedChatsList
     */
    'results'?: Array<UnifiedChats>;
}
/**
 * 
 * @export
 * @interface PaginatedUnifiedL3OrderList
 */
export interface PaginatedUnifiedL3OrderList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedUnifiedL3OrderList
     */
    'count': number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedUnifiedL3OrderList
     */
    'next'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedUnifiedL3OrderList
     */
    'previous'?: string | null;
    /**
     * 
     * @type {Array<UnifiedL3Order>}
     * @memberof PaginatedUnifiedL3OrderList
     */
    'results': Array<UnifiedL3Order>;
}
/**
 * 
 * @export
 * @interface PaginatedUnifiedMessagingFindSellerList
 */
export interface PaginatedUnifiedMessagingFindSellerList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedUnifiedMessagingFindSellerList
     */
    'count': number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedUnifiedMessagingFindSellerList
     */
    'next'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedUnifiedMessagingFindSellerList
     */
    'previous'?: string | null;
    /**
     * 
     * @type {Array<UnifiedMessagingFindSeller>}
     * @memberof PaginatedUnifiedMessagingFindSellerList
     */
    'results': Array<UnifiedMessagingFindSeller>;
}
/**
 * 
 * @export
 * @interface PaginatedUnifiedOrderAsSalesInvoiceList
 */
export interface PaginatedUnifiedOrderAsSalesInvoiceList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedUnifiedOrderAsSalesInvoiceList
     */
    'count': number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedUnifiedOrderAsSalesInvoiceList
     */
    'next'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedUnifiedOrderAsSalesInvoiceList
     */
    'previous'?: string | null;
    /**
     * 
     * @type {Array<UnifiedOrderAsSalesInvoice>}
     * @memberof PaginatedUnifiedOrderAsSalesInvoiceList
     */
    'results': Array<UnifiedOrderAsSalesInvoice>;
}
/**
 * 
 * @export
 * @interface PaginatedUnifiedOrderPaymentList
 */
export interface PaginatedUnifiedOrderPaymentList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedUnifiedOrderPaymentList
     */
    'count': number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedUnifiedOrderPaymentList
     */
    'next'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedUnifiedOrderPaymentList
     */
    'previous'?: string | null;
    /**
     * 
     * @type {Array<UnifiedOrderPayment>}
     * @memberof PaginatedUnifiedOrderPaymentList
     */
    'results': Array<UnifiedOrderPayment>;
}
/**
 * 
 * @export
 * @interface PaginatedUnifiedProductDosageUnitList
 */
export interface PaginatedUnifiedProductDosageUnitList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedUnifiedProductDosageUnitList
     */
    'count': number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedUnifiedProductDosageUnitList
     */
    'next'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedUnifiedProductDosageUnitList
     */
    'previous'?: string | null;
    /**
     * 
     * @type {Array<UnifiedProductDosageUnit>}
     * @memberof PaginatedUnifiedProductDosageUnitList
     */
    'results': Array<UnifiedProductDosageUnit>;
}
/**
 * 
 * @export
 * @interface PaginatedUnifiedProductImageList
 */
export interface PaginatedUnifiedProductImageList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedUnifiedProductImageList
     */
    'count': number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedUnifiedProductImageList
     */
    'next'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedUnifiedProductImageList
     */
    'previous'?: string | null;
    /**
     * 
     * @type {Array<UnifiedProductImage>}
     * @memberof PaginatedUnifiedProductImageList
     */
    'results': Array<UnifiedProductImage>;
}
/**
 * 
 * @export
 * @interface PaginatedUnifiedProductLineList
 */
export interface PaginatedUnifiedProductLineList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedUnifiedProductLineList
     */
    'count': number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedUnifiedProductLineList
     */
    'next'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedUnifiedProductLineList
     */
    'previous'?: string | null;
    /**
     * 
     * @type {Array<UnifiedProductLine>}
     * @memberof PaginatedUnifiedProductLineList
     */
    'results': Array<UnifiedProductLine>;
}
/**
 * 
 * @export
 * @interface PaginatedUnifiedProductMVPList
 */
export interface PaginatedUnifiedProductMVPList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedUnifiedProductMVPList
     */
    'count': number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedUnifiedProductMVPList
     */
    'next'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedUnifiedProductMVPList
     */
    'previous'?: string | null;
    /**
     * 
     * @type {Array<UnifiedProductMVP>}
     * @memberof PaginatedUnifiedProductMVPList
     */
    'results': Array<UnifiedProductMVP>;
}
/**
 * 
 * @export
 * @interface PaginatedUnifiedProductSpecificationList
 */
export interface PaginatedUnifiedProductSpecificationList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedUnifiedProductSpecificationList
     */
    'count': number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedUnifiedProductSpecificationList
     */
    'next'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedUnifiedProductSpecificationList
     */
    'previous'?: string | null;
    /**
     * 
     * @type {Array<UnifiedProductSpecification>}
     * @memberof PaginatedUnifiedProductSpecificationList
     */
    'results': Array<UnifiedProductSpecification>;
}
/**
 * 
 * @export
 * @interface PaginatedUnifiedProductSubCategoryList
 */
export interface PaginatedUnifiedProductSubCategoryList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedUnifiedProductSubCategoryList
     */
    'count': number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedUnifiedProductSubCategoryList
     */
    'next'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedUnifiedProductSubCategoryList
     */
    'previous'?: string | null;
    /**
     * 
     * @type {Array<UnifiedProductSubCategory>}
     * @memberof PaginatedUnifiedProductSubCategoryList
     */
    'results': Array<UnifiedProductSubCategory>;
}
/**
 * 
 * @export
 * @interface PaginatedUnifiedProductTemplateList
 */
export interface PaginatedUnifiedProductTemplateList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedUnifiedProductTemplateList
     */
    'count': number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedUnifiedProductTemplateList
     */
    'next'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedUnifiedProductTemplateList
     */
    'previous'?: string | null;
    /**
     * 
     * @type {Array<UnifiedProductTemplate>}
     * @memberof PaginatedUnifiedProductTemplateList
     */
    'results': Array<UnifiedProductTemplate>;
}
/**
 * 
 * @export
 * @interface PaginatedUnifiedRecommendedBrandList
 */
export interface PaginatedUnifiedRecommendedBrandList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedUnifiedRecommendedBrandList
     */
    'count': number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedUnifiedRecommendedBrandList
     */
    'next'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedUnifiedRecommendedBrandList
     */
    'previous'?: string | null;
    /**
     * 
     * @type {Array<UnifiedRecommendedBrand>}
     * @memberof PaginatedUnifiedRecommendedBrandList
     */
    'results': Array<UnifiedRecommendedBrand>;
}
/**
 * 
 * @export
 * @interface PaginatedUnifiedRecommendedCompanyList
 */
export interface PaginatedUnifiedRecommendedCompanyList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedUnifiedRecommendedCompanyList
     */
    'count': number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedUnifiedRecommendedCompanyList
     */
    'next'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedUnifiedRecommendedCompanyList
     */
    'previous'?: string | null;
    /**
     * 
     * @type {Array<UnifiedRecommendedCompany>}
     * @memberof PaginatedUnifiedRecommendedCompanyList
     */
    'results': Array<UnifiedRecommendedCompany>;
}
/**
 * 
 * @export
 * @interface PaginatedUnifiedStrainList
 */
export interface PaginatedUnifiedStrainList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedUnifiedStrainList
     */
    'count': number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedUnifiedStrainList
     */
    'next'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedUnifiedStrainList
     */
    'previous'?: string | null;
    /**
     * 
     * @type {Array<UnifiedStrain>}
     * @memberof PaginatedUnifiedStrainList
     */
    'results': Array<UnifiedStrain>;
}
/**
 * 
 * @export
 * @interface PaginatedUnifiedTaxScheduleList
 */
export interface PaginatedUnifiedTaxScheduleList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedUnifiedTaxScheduleList
     */
    'count': number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedUnifiedTaxScheduleList
     */
    'next'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedUnifiedTaxScheduleList
     */
    'previous'?: string | null;
    /**
     * 
     * @type {Array<UnifiedTaxSchedule>}
     * @memberof PaginatedUnifiedTaxScheduleList
     */
    'results': Array<UnifiedTaxSchedule>;
}
/**
 * 
 * @export
 * @interface PaginatedUnifiedTraceabilityCompanyCustomerList
 */
export interface PaginatedUnifiedTraceabilityCompanyCustomerList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedUnifiedTraceabilityCompanyCustomerList
     */
    'count': number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedUnifiedTraceabilityCompanyCustomerList
     */
    'next'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedUnifiedTraceabilityCompanyCustomerList
     */
    'previous'?: string | null;
    /**
     * 
     * @type {Array<UnifiedTraceabilityCompanyCustomer>}
     * @memberof PaginatedUnifiedTraceabilityCompanyCustomerList
     */
    'results': Array<UnifiedTraceabilityCompanyCustomer>;
}
/**
 * 
 * @export
 * @interface PaginatedUnifiedTraceabilityPackageOrdersList
 */
export interface PaginatedUnifiedTraceabilityPackageOrdersList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedUnifiedTraceabilityPackageOrdersList
     */
    'count': number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedUnifiedTraceabilityPackageOrdersList
     */
    'next'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedUnifiedTraceabilityPackageOrdersList
     */
    'previous'?: string | null;
    /**
     * 
     * @type {Array<UnifiedTraceabilityPackageOrders>}
     * @memberof PaginatedUnifiedTraceabilityPackageOrdersList
     */
    'results': Array<UnifiedTraceabilityPackageOrders>;
}
/**
 * 
 * @export
 * @interface PaginatedUnifiedUnitDenominationList
 */
export interface PaginatedUnifiedUnitDenominationList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedUnifiedUnitDenominationList
     */
    'count': number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedUnifiedUnitDenominationList
     */
    'next'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedUnifiedUnitDenominationList
     */
    'previous'?: string | null;
    /**
     * 
     * @type {Array<UnifiedUnitDenomination>}
     * @memberof PaginatedUnifiedUnitDenominationList
     */
    'results': Array<UnifiedUnitDenomination>;
}
/**
 * 
 * @export
 * @interface PaginatedUnifiedUnitOfMeasureList
 */
export interface PaginatedUnifiedUnitOfMeasureList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedUnifiedUnitOfMeasureList
     */
    'count': number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedUnifiedUnitOfMeasureList
     */
    'next'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedUnifiedUnitOfMeasureList
     */
    'previous'?: string | null;
    /**
     * 
     * @type {Array<UnifiedUnitOfMeasure>}
     * @memberof PaginatedUnifiedUnitOfMeasureList
     */
    'results': Array<UnifiedUnitOfMeasure>;
}
/**
 * 
 * @export
 * @interface PaginatedVehicleList
 */
export interface PaginatedVehicleList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedVehicleList
     */
    'count': number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedVehicleList
     */
    'next'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedVehicleList
     */
    'previous'?: string | null;
    /**
     * 
     * @type {Array<Vehicle>}
     * @memberof PaginatedVehicleList
     */
    'results': Array<Vehicle>;
}
/**
 * Chat status serializer
 * @export
 * @interface PatchedBulkChatUpdateRequest
 */
export interface PatchedBulkChatUpdateRequest {
    /**
     * 
     * @type {StatusBcfEnum}
     * @memberof PatchedBulkChatUpdateRequest
     */
    'status'?: StatusBcfEnum;
    /**
     * 
     * @type {Array<number>}
     * @memberof PatchedBulkChatUpdateRequest
     */
    'chats'?: Array<number>;
}


/**
 * Seriazlier for Company Transport Partner Model.
 * @export
 * @interface PatchedCompanyTransportPartnerRequest
 */
export interface PatchedCompanyTransportPartnerRequest {
    /**
     * 
     * @type {number}
     * @memberof PatchedCompanyTransportPartnerRequest
     */
    'transport_company_id'?: number;
    /**
     * 
     * @type {number}
     * @memberof PatchedCompanyTransportPartnerRequest
     */
    'company_id'?: number;
}
/**
 * 
 * @export
 * @interface PatchedCompanyUpdateRequest
 */
export interface PatchedCompanyUpdateRequest {
    /**
     * 
     * @type {boolean}
     * @memberof PatchedCompanyUpdateRequest
     */
    'enable_seed_to_sale'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PatchedCompanyUpdateRequest
     */
    'enable_transfer_manifest'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PatchedCompanyUpdateRequest
     */
    'enable_sales_data'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PatchedCompanyUpdateRequest
     */
    'enable_hide_attached_packages'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PatchedCompanyUpdateRequest
     */
    'enable_license_verification'?: boolean | null;
    /**
     * 
     * @type {Array<CompanyApiKeyRequest>}
     * @memberof PatchedCompanyUpdateRequest
     */
    'api_configs'?: Array<CompanyApiKeyRequest>;
    /**
     * 
     * @type {Array<string>}
     * @memberof PatchedCompanyUpdateRequest
     */
    'included_locations'?: Array<string>;
    /**
     * 
     * @type {Array<number>}
     * @memberof PatchedCompanyUpdateRequest
     */
    'included_location_ids'?: Array<number>;
    /**
     * 
     * @type {Array<string>}
     * @memberof PatchedCompanyUpdateRequest
     */
    'excluded_lab_test_states'?: Array<string>;
}
/**
 * Serializer for Contract
 * @export
 * @interface PatchedContractRequest
 */
export interface PatchedContractRequest {
    /**
     * 
     * @type {string}
     * @memberof PatchedContractRequest
     */
    'docusign_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PatchedContractRequest
     */
    'status'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedContractRequest
     */
    'buyer_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedContractRequest
     */
    'seller_id'?: string;
    /**
     * 
     * @type {DefaultPaymentProgramEnum}
     * @memberof PatchedContractRequest
     */
    'default_payment_program'?: DefaultPaymentProgramEnum;
    /**
     * 
     * @type {DefaultFlexiblePaymentStrategyEnum}
     * @memberof PatchedContractRequest
     */
    'default_flexible_payment_strategy'?: DefaultFlexiblePaymentStrategyEnum;
    /**
     * 
     * @type {string}
     * @memberof PatchedContractRequest
     */
    'custom_direct_payment_term_type'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PatchedContractRequest
     */
    'custom_reverse_factor_auto_assignment'?: boolean | null;
}


/**
 * Internal serializer for Driver Model.
 * @export
 * @interface PatchedInternalDriverRequest
 */
export interface PatchedInternalDriverRequest {
    /**
     * First Name
     * @type {string}
     * @memberof PatchedInternalDriverRequest
     */
    'first_name'?: string;
    /**
     * Last Name of Driver
     * @type {string}
     * @memberof PatchedInternalDriverRequest
     */
    'last_name'?: string;
    /**
     * METRC Employee ID for Driver
     * @type {string}
     * @memberof PatchedInternalDriverRequest
     */
    'metrc_employee_id'?: string;
    /**
     * License Number of Driver
     * @type {string}
     * @memberof PatchedInternalDriverRequest
     */
    'license_number'?: string;
    /**
     * Phone Number of Driver
     * @type {string}
     * @memberof PatchedInternalDriverRequest
     */
    'phone'?: string;
    /**
     * Is an active driver?
     * @type {boolean}
     * @memberof PatchedInternalDriverRequest
     */
    'is_active'?: boolean;
}
/**
 * Discussion Message read serializer
 * @export
 * @interface PatchedMessageReadRequest
 */
export interface PatchedMessageReadRequest {
    /**
     * 
     * @type {boolean}
     * @memberof PatchedMessageReadRequest
     */
    'read_by_sender_company'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PatchedMessageReadRequest
     */
    'read_by_recipient_company'?: boolean;
}
/**
 * 
 * @export
 * @interface PatchedProductPromotionRequest
 */
export interface PatchedProductPromotionRequest {
    /**
     * 
     * @type {string}
     * @memberof PatchedProductPromotionRequest
     */
    'moloco_id'?: string;
    /**
     * 
     * @type {ProductPromotionStatusEnum}
     * @memberof PatchedProductPromotionRequest
     */
    'status'?: ProductPromotionStatusEnum;
    /**
     * 
     * @type {PeriodEnum}
     * @memberof PatchedProductPromotionRequest
     */
    'period'?: PeriodEnum;
    /**
     * 
     * @type {string}
     * @memberof PatchedProductPromotionRequest
     */
    'start_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedProductPromotionRequest
     */
    'end_date'?: string | null;
    /**
     * 
     * @type {PatchedProductPromotionRequestMaxCpc}
     * @memberof PatchedProductPromotionRequest
     */
    'max_cpc'?: PatchedProductPromotionRequestMaxCpc;
    /**
     * 
     * @type {PatchedProductPromotionRequestMaxCpc}
     * @memberof PatchedProductPromotionRequest
     */
    'max_budget'?: PatchedProductPromotionRequestMaxCpc;
    /**
     * 
     * @type {PatchedProductPromotionRequestMaxCpc}
     * @memberof PatchedProductPromotionRequest
     */
    'budget_per_period'?: PatchedProductPromotionRequestMaxCpc;
    /**
     * 
     * @type {string}
     * @memberof PatchedProductPromotionRequest
     */
    'approver_email'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof PatchedProductPromotionRequest
     */
    'brand_id'?: number;
    /**
     * 
     * @type {number}
     * @memberof PatchedProductPromotionRequest
     */
    'company_id'?: number;
    /**
     * 
     * @type {number}
     * @memberof PatchedProductPromotionRequest
     */
    'billing_company_id'?: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof PatchedProductPromotionRequest
     */
    'products'?: Array<number>;
}


/**
 * 
 * @export
 * @interface PatchedProductPromotionRequestMaxCpc
 */
export interface PatchedProductPromotionRequestMaxCpc {
    /**
     * 
     * @type {number}
     * @memberof PatchedProductPromotionRequestMaxCpc
     */
    'amount'?: number;
    /**
     * 
     * @type {string}
     * @memberof PatchedProductPromotionRequestMaxCpc
     */
    'currency'?: string;
}
/**
 * 
 * @export
 * @interface PatchedTemplateUpdateRequest
 */
export interface PatchedTemplateUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof PatchedTemplateUpdateRequest
     */
    'estimated_departure_datetime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PatchedTemplateUpdateRequest
     */
    'estimated_arrival_datetime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PatchedTemplateUpdateRequest
     */
    'shipment_type_name'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof PatchedTemplateUpdateRequest
     */
    'll_order_id'?: number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof PatchedTemplateUpdateRequest
     */
    'package_labels'?: Array<string> | null;
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof PatchedTemplateUpdateRequest
     */
    'packages'?: { [key: string]: Array<string>; } | null;
    /**
     * 
     * @type {number}
     * @memberof PatchedTemplateUpdateRequest
     */
    'driver_id'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PatchedTemplateUpdateRequest
     */
    'vehicle_id'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof PatchedTemplateUpdateRequest
     */
    'turn_by_turn_directions'?: string | null;
}
/**
 * 
 * @export
 * @interface PatchedTraceabilityDriverCreateUpdateInputRequest
 */
export interface PatchedTraceabilityDriverCreateUpdateInputRequest {
    /**
     * 
     * @type {string}
     * @memberof PatchedTraceabilityDriverCreateUpdateInputRequest
     */
    'drivers_license_number'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PatchedTraceabilityDriverCreateUpdateInputRequest
     */
    'birth_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedTraceabilityDriverCreateUpdateInputRequest
     */
    'hire_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedTraceabilityDriverCreateUpdateInputRequest
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedTraceabilityDriverCreateUpdateInputRequest
     */
    'state_issued'?: string | null;
}
/**
 * 
 * @export
 * @interface PatchedTraceabilityRefreshProductsPackagesRequest
 */
export interface PatchedTraceabilityRefreshProductsPackagesRequest {
    /**
     * 
     * @type {Array<number>}
     * @memberof PatchedTraceabilityRefreshProductsPackagesRequest
     */
    'product_ids'?: Array<number>;
}
/**
 * 
 * @export
 * @interface PatchedTraceabilityVehicleCreateUpdateInputRequest
 */
export interface PatchedTraceabilityVehicleCreateUpdateInputRequest {
    /**
     * 
     * @type {string}
     * @memberof PatchedTraceabilityVehicleCreateUpdateInputRequest
     */
    'license_plate_number'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedTraceabilityVehicleCreateUpdateInputRequest
     */
    'make'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedTraceabilityVehicleCreateUpdateInputRequest
     */
    'model'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedTraceabilityVehicleCreateUpdateInputRequest
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedTraceabilityVehicleCreateUpdateInputRequest
     */
    'color'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedTraceabilityVehicleCreateUpdateInputRequest
     */
    'vin'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedTraceabilityVehicleCreateUpdateInputRequest
     */
    'year'?: string;
}
/**
 * Inherits AddressSerializer but sets the FK relation on the resource Model
 * @export
 * @interface PatchedUnifiedAddressRequest
 */
export interface PatchedUnifiedAddressRequest {
    /**
     * Address
     * @type {string}
     * @memberof PatchedUnifiedAddressRequest
     */
    'address'?: string;
    /**
     * Unit #
     * @type {string}
     * @memberof PatchedUnifiedAddressRequest
     */
    'unit_number'?: string;
    /**
     * City
     * @type {string}
     * @memberof PatchedUnifiedAddressRequest
     */
    'city'?: string;
    /**
     * County
     * @type {string}
     * @memberof PatchedUnifiedAddressRequest
     */
    'county'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedUnifiedAddressRequest
     */
    'state'?: string;
    /**
     * Zipcode
     * @type {string}
     * @memberof PatchedUnifiedAddressRequest
     */
    'zipcode'?: string;
}
/**
 * Unified Chats serializer
 * @export
 * @interface PatchedUnifiedChatsRequest
 */
export interface PatchedUnifiedChatsRequest {
    /**
     * 
     * @type {string}
     * @memberof PatchedUnifiedChatsRequest
     */
    'topic'?: string;
    /**
     * 
     * @type {CompanyRequest}
     * @memberof PatchedUnifiedChatsRequest
     */
    'sender_company'?: CompanyRequest;
    /**
     * 
     * @type {CompanyRequest}
     * @memberof PatchedUnifiedChatsRequest
     */
    'recipient_company'?: CompanyRequest;
    /**
     * Discussion Creator
     * @type {number}
     * @memberof PatchedUnifiedChatsRequest
     */
    'creator'?: number | null;
    /**
     * 
     * @type {MessageRequest}
     * @memberof PatchedUnifiedChatsRequest
     */
    'first_message'?: MessageRequest;
}
/**
 * Unified serializer for the CompanyCustomerStatus model.
 * @export
 * @interface PatchedUnifiedCompanyCustomerStatusRequest
 */
export interface PatchedUnifiedCompanyCustomerStatusRequest {
    /**
     * Customer Status State
     * @type {string}
     * @memberof PatchedUnifiedCompanyCustomerStatusRequest
     */
    'state'?: string;
    /**
     * Sort order, lower is first.
     * @type {number}
     * @memberof PatchedUnifiedCompanyCustomerStatusRequest
     */
    'order'?: number;
    /**
     * Description of status
     * @type {string}
     * @memberof PatchedUnifiedCompanyCustomerStatusRequest
     */
    'description'?: string | null;
    /**
     * The Company that created the custom status.
     * @type {number}
     * @memberof PatchedUnifiedCompanyCustomerStatusRequest
     */
    'owner'?: number | null;
    /**
     * Is this a stock LeafLink status?
     * @type {boolean}
     * @memberof PatchedUnifiedCompanyCustomerStatusRequest
     */
    'is_stock'?: boolean;
    /**
     * Hex color for customer status
     * @type {string}
     * @memberof PatchedUnifiedCompanyCustomerStatusRequest
     */
    'hex_color'?: string | null;
}
/**
 * Unified Contact serializer
 * @export
 * @interface PatchedUnifiedContactRequest
 */
export interface PatchedUnifiedContactRequest {
    /**
     * 
     * @type {number}
     * @memberof PatchedUnifiedContactRequest
     */
    'owner'?: number;
    /**
     * 
     * @type {string}
     * @memberof PatchedUnifiedContactRequest
     */
    'first_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedUnifiedContactRequest
     */
    'last_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedUnifiedContactRequest
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PatchedUnifiedContactRequest
     */
    'secondary_email'?: string | null;
    /**
     * Position or role at company
     * @type {string}
     * @memberof PatchedUnifiedContactRequest
     */
    'role'?: string | null;
    /**
     * An overview of the contact
     * @type {string}
     * @memberof PatchedUnifiedContactRequest
     */
    'description'?: string | null;
    /**
     * Phone Number of Brand
     * @type {string}
     * @memberof PatchedUnifiedContactRequest
     */
    'phone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PatchedUnifiedContactRequest
     */
    'phone_extension'?: string | null;
    /**
     * Secondary Phone Number of Brand
     * @type {string}
     * @memberof PatchedUnifiedContactRequest
     */
    'secondary_phone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PatchedUnifiedContactRequest
     */
    'secondary_phone_extension'?: string | null;
    /**
     * Is this Contact marked as deleted?
     * @type {boolean}
     * @memberof PatchedUnifiedContactRequest
     */
    'delete'?: boolean;
}
/**
 * UnifiedCustomerSerializer inherits existing v2 CompanyCustomerSerializer for validations
 * @export
 * @interface PatchedUnifiedCustomerRequest
 */
export interface PatchedUnifiedCustomerRequest {
    /**
     * 
     * @type {Array<number>}
     * @memberof PatchedUnifiedCustomerRequest
     */
    'managers'?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof PatchedUnifiedCustomerRequest
     */
    'phone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PatchedUnifiedCustomerRequest
     */
    'phone_extension'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PatchedUnifiedCustomerRequest
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PatchedUnifiedCustomerRequest
     */
    'website'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PatchedUnifiedCustomerRequest
     */
    'next_contact_date'?: string | null;
    /**
     * 
     * @type {TierEnum}
     * @memberof PatchedUnifiedCustomerRequest
     */
    'tier'?: TierEnum | null;
    /**
     * 
     * @type {string}
     * @memberof PatchedUnifiedCustomerRequest
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedUnifiedCustomerRequest
     */
    'license_number'?: string;
    /**
     * Old License Number (stored after a transfer)
     * @type {string}
     * @memberof PatchedUnifiedCustomerRequest
     */
    'old_license_number'?: string | null;
    /**
     * License inactive or transferred for this customer
     * @type {boolean}
     * @memberof PatchedUnifiedCustomerRequest
     */
    'is_license_inactive'?: boolean;
    /**
     * Company identifier distinct from license numbers
     * @type {string}
     * @memberof PatchedUnifiedCustomerRequest
     */
    'business_identifier'?: string | null;
    /**
     * (Driving) Directions to the Customer location for deliveries
     * @type {string}
     * @memberof PatchedUnifiedCustomerRequest
     */
    'directions'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PatchedUnifiedCustomerRequest
     */
    'delivery_preferences'?: string | null;
    /**
     * Additional Shipping Charge
     * @type {string}
     * @memberof PatchedUnifiedCustomerRequest
     */
    'shipping_charge'?: string | null;
    /**
     * Known Brand name of Company or Parent Company
     * @type {string}
     * @memberof PatchedUnifiedCustomerRequest
     */
    'brand'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PatchedUnifiedCustomerRequest
     */
    'business_license_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PatchedUnifiedCustomerRequest
     */
    'description'?: string | null;
    /**
     * Other information on customer
     * @type {string}
     * @memberof PatchedUnifiedCustomerRequest
     */
    'notes'?: string | null;
    /**
     * Is the customer a relevent part of your CRM
     * @type {boolean}
     * @memberof PatchedUnifiedCustomerRequest
     */
    'is_archived'?: boolean;
    /**
     * Is this account delinquent on billing
     * @type {boolean}
     * @memberof PatchedUnifiedCustomerRequest
     */
    'is_delinquent'?: boolean;
    /**
     * Discount percent for orders of company customer
     * @type {string}
     * @memberof PatchedUnifiedCustomerRequest
     */
    'discount_percent'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedUnifiedCustomerRequest
     */
    'external_ids'?: string;
    /**
     * Owner ID for customer
     * @type {number}
     * @memberof PatchedUnifiedCustomerRequest
     */
    'owner_id'?: number;
    /**
     * Partner ID for customer
     * @type {number}
     * @memberof PatchedUnifiedCustomerRequest
     */
    'partner_id'?: number;
    /**
     * Price schedule ID for the customer
     * @type {number}
     * @memberof PatchedUnifiedCustomerRequest
     */
    'price_schedule_id'?: number;
    /**
     * Service zone ID for the customer
     * @type {number}
     * @memberof PatchedUnifiedCustomerRequest
     */
    'service_zone_id'?: number;
    /**
     * Status ID for the customer
     * @type {number}
     * @memberof PatchedUnifiedCustomerRequest
     */
    'status_id'?: number;
}


/**
 * 
 * @export
 * @interface PatchedUnifiedExpressProductMenuRequest
 */
export interface PatchedUnifiedExpressProductMenuRequest {
    /**
     * 
     * @type {number}
     * @memberof PatchedUnifiedExpressProductMenuRequest
     */
    'brand'?: number;
    /**
     * 
     * @type {number}
     * @memberof PatchedUnifiedExpressProductMenuRequest
     */
    'price_schedule'?: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof PatchedUnifiedExpressProductMenuRequest
     */
    'products'?: Array<number>;
}
/**
 * Base Unified ProductLine serializer.
 * @export
 * @interface PatchedUnifiedProductLineRequest
 */
export interface PatchedUnifiedProductLineRequest {
    /**
     * Name of Product Line
     * @type {string}
     * @memberof PatchedUnifiedProductLineRequest
     */
    'name'?: string;
    /**
     * Brand ID for the product line
     * @type {number}
     * @memberof PatchedUnifiedProductLineRequest
     */
    'brand_id'?: number;
    /**
     * The position of ordering
     * @type {number}
     * @memberof PatchedUnifiedProductLineRequest
     */
    'menu_position'?: number | null;
}
/**
 * Unified Product serializer.
 * @export
 * @interface PatchedUnifiedProductMVPRequest
 */
export interface PatchedUnifiedProductMVPRequest {
    /**
     * Stock Keeping Unit. A unique identifier for a Product, alternative to id.
     * @type {string}
     * @memberof PatchedUnifiedProductMVPRequest
     */
    'sku'?: string | null;
    /**
     * Company who is selling the Product
     * @type {number}
     * @memberof PatchedUnifiedProductMVPRequest
     */
    'seller_id'?: number;
    /**
     * Brand ID for the product
     * @type {number}
     * @memberof PatchedUnifiedProductMVPRequest
     */
    'brand_id'?: number;
    /**
     * Product Line ID of product
     * @type {number}
     * @memberof PatchedUnifiedProductMVPRequest
     */
    'product_line_id'?: number;
    /**
     * Product Name
     * @type {string}
     * @memberof PatchedUnifiedProductMVPRequest
     */
    'name'?: string;
    /**
     * License ID for the product
     * @type {number}
     * @memberof PatchedUnifiedProductMVPRequest
     */
    'license_id'?: number | null;
    /**
     * Product category ID for the product
     * @type {number}
     * @memberof PatchedUnifiedProductMVPRequest
     */
    'category_id'?: number;
    /**
     * Product sub-category ID for the product
     * @type {number}
     * @memberof PatchedUnifiedProductMVPRequest
     */
    'sub_category_id'?: number;
    /**
     * Base unit of measure ID for this product
     * @type {number}
     * @memberof PatchedUnifiedProductMVPRequest
     */
    'unit_of_measure_id'?: number;
    /**
     * The ID of amount of individual products in one sale unit
     * @type {number}
     * @memberof PatchedUnifiedProductMVPRequest
     */
    'unit_denomination_id'?: number;
    /**
     * Product listing state. Values available at the /listing-states/ endpoint.
     * @type {ListingStateEnum}
     * @memberof PatchedUnifiedProductMVPRequest
     */
    'listing_state'?: ListingStateEnum;
    /**
     * Brand Description
     * @type {string}
     * @memberof PatchedUnifiedProductMVPRequest
     */
    'description'?: string;
    /**
     * 
     * @type {PatchedUnifiedProductMVPRequestWholesalePrice}
     * @memberof PatchedUnifiedProductMVPRequest
     */
    'wholesale_price'?: PatchedUnifiedProductMVPRequestWholesalePrice;
    /**
     * 
     * @type {PatchedUnifiedProductMVPRequestRetailPrice}
     * @memberof PatchedUnifiedProductMVPRequest
     */
    'retail_price'?: PatchedUnifiedProductMVPRequestRetailPrice;
    /**
     * The cannabis strains associated with this product
     * @type {Array<number>}
     * @memberof PatchedUnifiedProductMVPRequest
     */
    'strains'?: Array<number>;
    /**
     * 
     * @type {PatchedUnifiedProductMVPRequestStrainClassification}
     * @memberof PatchedUnifiedProductMVPRequest
     */
    'strain_classification'?: PatchedUnifiedProductMVPRequestStrainClassification;
    /**
     * Is this a medical line item?
     * @type {boolean}
     * @memberof PatchedUnifiedProductMVPRequest
     */
    'is_medical_line_item'?: boolean;
    /**
     * 
     * @type {PatchedUnifiedProductMVPRequestGrowType}
     * @memberof PatchedUnifiedProductMVPRequest
     */
    'grow_type'?: PatchedUnifiedProductMVPRequestGrowType;
    /**
     * Number of base units in one unit of this product
     * @type {string}
     * @memberof PatchedUnifiedProductMVPRequest
     */
    'base_units_per_unit'?: string | null;
    /**
     * Threshold configuration for inventory alerts
     * @type {ThresholdRequest}
     * @memberof PatchedUnifiedProductMVPRequest
     */
    'threshold'?: ThresholdRequest | null;
    /**
     * 
     * @type {Array<UnifiedProductSpecificationItemRequest>}
     * @memberof PatchedUnifiedProductMVPRequest
     */
    'product_specification_items'?: Array<UnifiedProductSpecificationItemRequest>;
}


/**
 * @type PatchedUnifiedProductMVPRequestGrowType
 * The type of grow operation for the flower product
 * @export
 */
export type PatchedUnifiedProductMVPRequestGrowType = BlankEnumUnifiedUpstreamMarketplace | GrowTypeEnum;

/**
 * Retail price displayed in the LeafLink marketplace
 * @export
 * @interface PatchedUnifiedProductMVPRequestRetailPrice
 */
export interface PatchedUnifiedProductMVPRequestRetailPrice {
    /**
     * 
     * @type {number}
     * @memberof PatchedUnifiedProductMVPRequestRetailPrice
     */
    'amount'?: number;
    /**
     * 
     * @type {string}
     * @memberof PatchedUnifiedProductMVPRequestRetailPrice
     */
    'currency'?: string;
}
/**
 * @type PatchedUnifiedProductMVPRequestStrainClassification
 * @export
 */
export type PatchedUnifiedProductMVPRequestStrainClassification = BlankEnumUnifiedUpstreamMarketplace | StrainClassificationEnum;

/**
 * Wholesale price displayed in the LeafLink marketplace
 * @export
 * @interface PatchedUnifiedProductMVPRequestWholesalePrice
 */
export interface PatchedUnifiedProductMVPRequestWholesalePrice {
    /**
     * 
     * @type {number}
     * @memberof PatchedUnifiedProductMVPRequestWholesalePrice
     */
    'amount'?: number;
    /**
     * 
     * @type {string}
     * @memberof PatchedUnifiedProductMVPRequestWholesalePrice
     */
    'currency'?: string;
}
/**
 * Unified Product serializer.
 * @export
 * @interface PatchedUnifiedProductRequest
 */
export interface PatchedUnifiedProductRequest {
    /**
     * Product name
     * @type {string}
     * @memberof PatchedUnifiedProductRequest
     */
    'name'?: string;
    /**
     * Product details
     * @type {string}
     * @memberof PatchedUnifiedProductRequest
     */
    'description'?: string;
    /**
     * Product category ID for the product
     * @type {number}
     * @memberof PatchedUnifiedProductRequest
     */
    'category_id'?: number;
    /**
     * Product listing state. Values available at the /listing-states/ endpoint.
     * @type {ListingStateEnum}
     * @memberof PatchedUnifiedProductRequest
     */
    'listing_state'?: ListingStateEnum;
    /**
     * 
     * @type {PatchedUnifiedProductMVPRequestWholesalePrice}
     * @memberof PatchedUnifiedProductRequest
     */
    'wholesale_price'?: PatchedUnifiedProductMVPRequestWholesalePrice;
    /**
     * How many individual units are sold when compared to the assigned unit of measure
     * @type {number}
     * @memberof PatchedUnifiedProductRequest
     */
    'unit_multiplier'?: number;
    /**
     * The amount of individual products in one sale unit
     * @type {string}
     * @memberof PatchedUnifiedProductRequest
     */
    'unit_denomination'?: string;
    /**
     * Stock keeping unit for the product
     * @type {string}
     * @memberof PatchedUnifiedProductRequest
     */
    'sku'?: string | null;
    /**
     * Brand ID for the product
     * @type {number}
     * @memberof PatchedUnifiedProductRequest
     */
    'brand_id'?: number;
    /**
     * ID of the Company that manufactured the product
     * @type {number}
     * @memberof PatchedUnifiedProductRequest
     */
    'manufacturer_id'?: number;
    /**
     * Company who is selling the Product
     * @type {number}
     * @memberof PatchedUnifiedProductRequest
     */
    'seller_id'?: number;
    /**
     * Base unit of measure for this product
     * @type {string}
     * @memberof PatchedUnifiedProductRequest
     */
    'unit_of_measure'?: string;
}


/**
 * Base serializer class to rename created_on and modified fields to follow new naming standard of created_date and modified_date
 * @export
 * @interface PatchedUnifiedProductTemplateRequest
 */
export interface PatchedUnifiedProductTemplateRequest {
    /**
     * Template Name
     * @type {string}
     * @memberof PatchedUnifiedProductTemplateRequest
     */
    'template_name'?: string;
    /**
     * 
     * @type {PatchedUnifiedProductTemplateRequestListingState}
     * @memberof PatchedUnifiedProductTemplateRequest
     */
    'listing_state'?: PatchedUnifiedProductTemplateRequestListingState | null;
    /**
     * 
     * @type {ProductInventoryManagement}
     * @memberof PatchedUnifiedProductTemplateRequest
     */
    'inventory_management'?: ProductInventoryManagement;
    /**
     * Unit of measure
     * @type {number}
     * @memberof PatchedUnifiedProductTemplateRequest
     */
    'unit_of_measure'?: number | null;
    /**
     * Unit of measure that buyers see
     * @type {number}
     * @memberof PatchedUnifiedProductTemplateRequest
     */
    'sell_in_unit_of_measure'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof PatchedUnifiedProductTemplateRequest
     */
    'sell_in_multiples'?: boolean;
    /**
     * How many individual units are sold when checking out by Unit of Measure
     * @type {number}
     * @memberof PatchedUnifiedProductTemplateRequest
     */
    'unit_multiplier'?: number | null;
    /**
     * The denomination of unit for the Product.
     * @type {number}
     * @memberof PatchedUnifiedProductTemplateRequest
     */
    'unit_denomination'?: number | null;
    /**
     * Number of base units in one unit of this product template
     * @type {string}
     * @memberof PatchedUnifiedProductTemplateRequest
     */
    'base_units_per_unit'?: string | null;
    /**
     * Manufacturer\'s Suggested Retail Price (MSRP)
     * @type {string}
     * @memberof PatchedUnifiedProductTemplateRequest
     */
    'retail_price'?: string | null;
    /**
     * Max Wholesale Price
     * @type {string}
     * @memberof PatchedUnifiedProductTemplateRequest
     */
    'wholesale_price'?: string | null;
    /**
     * Sale Price
     * @type {string}
     * @memberof PatchedUnifiedProductTemplateRequest
     */
    'sale_price'?: string | null;
    /**
     * Minimum Units per Order
     * @type {string}
     * @memberof PatchedUnifiedProductTemplateRequest
     */
    'minimum_order'?: string | null;
    /**
     * Maximum Units per Order
     * @type {string}
     * @memberof PatchedUnifiedProductTemplateRequest
     */
    'maximum_order'?: string | null;
    /**
     * Brand Description
     * @type {string}
     * @memberof PatchedUnifiedProductTemplateRequest
     */
    'description'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof PatchedUnifiedProductTemplateRequest
     */
    'category'?: number | null;
    /**
     * The sub-category of the Product (e.g. Bulk Flower, Live Resin, etc)
     * @type {number}
     * @memberof PatchedUnifiedProductTemplateRequest
     */
    'sub_category'?: number | null;
    /**
     * Company who is selling the Product
     * @type {number}
     * @memberof PatchedUnifiedProductTemplateRequest
     */
    'seller'?: number;
    /**
     * Brand of product
     * @type {number}
     * @memberof PatchedUnifiedProductTemplateRequest
     */
    'brand'?: number | null;
    /**
     * Product Line of product
     * @type {number}
     * @memberof PatchedUnifiedProductTemplateRequest
     */
    'product_line'?: number | null;
    /**
     * 
     * @type {PatchedUnifiedProductTemplateRequestStrainClassification}
     * @memberof PatchedUnifiedProductTemplateRequest
     */
    'strain_classification'?: PatchedUnifiedProductTemplateRequestStrainClassification | null;
    /**
     * 
     * @type {number}
     * @memberof PatchedUnifiedProductTemplateRequest
     */
    'license'?: number | null;
    /**
     * Show Product Quantity
     * @type {boolean}
     * @memberof PatchedUnifiedProductTemplateRequest
     */
    'SHOW_QUANTITY'?: boolean | null;
    /**
     * This product is available for samples
     * @type {boolean}
     * @memberof PatchedUnifiedProductTemplateRequest
     */
    'AVAILABLE_FOR_SAMPLES'?: boolean | null;
    /**
     * When Product inventory reaches below this value, take various actions
     * @type {number}
     * @memberof PatchedUnifiedProductTemplateRequest
     */
    'threshold_value'?: number | null;
    /**
     * Action to take when Product inventory reaches below a specified value
     * @type {ThresholdActionEnum}
     * @memberof PatchedUnifiedProductTemplateRequest
     */
    'threshold_action'?: ThresholdActionEnum;
    /**
     * Is this a medical line item?
     * @type {boolean}
     * @memberof PatchedUnifiedProductTemplateRequest
     */
    'is_medical_line_item'?: boolean;
    /**
     * This product quantity can contain decimal places
     * @type {boolean}
     * @memberof PatchedUnifiedProductTemplateRequest
     */
    'allow_fractional_quantities'?: boolean | null;
}


/**
 * @type PatchedUnifiedProductTemplateRequestListingState
 * @export
 */
export type PatchedUnifiedProductTemplateRequestListingState = BlankEnumUnifiedUpstreamMarketplace | ListingStateEnum;

/**
 * @type PatchedUnifiedProductTemplateRequestStrainClassification
 * @export
 */
export type PatchedUnifiedProductTemplateRequestStrainClassification = BlankEnumUnifiedUpstreamMarketplace | StrainClassificationEnum;

/**
 * 
 * @export
 * @interface PatchedUpdateInputRequest
 */
export interface PatchedUpdateInputRequest {
    /**
     * 
     * @type {string}
     * @memberof PatchedUpdateInputRequest
     */
    'name'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof PatchedUpdateInputRequest
     */
    'tax_type'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof PatchedUpdateInputRequest
     */
    'tax_rate'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof PatchedUpdateInputRequest
     */
    'unit_type'?: number | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof PatchedUpdateInputRequest
     */
    'product_category_ids'?: Array<number> | null;
}
/**
 * Internal serializer for Vehicle Model.
 * @export
 * @interface PatchedVehicleRequest
 */
export interface PatchedVehicleRequest {
    /**
     * Vehicle Make
     * @type {string}
     * @memberof PatchedVehicleRequest
     */
    'make'?: string | null;
    /**
     * Vehicle Model Year
     * @type {number}
     * @memberof PatchedVehicleRequest
     */
    'model_year'?: number | null;
    /**
     * Vehicle Model Name
     * @type {string}
     * @memberof PatchedVehicleRequest
     */
    'model_name'?: string | null;
    /**
     * License Number of Vehicle
     * @type {string}
     * @memberof PatchedVehicleRequest
     */
    'license_number'?: string | null;
    /**
     * Vehicle Capacity
     * @type {number}
     * @memberof PatchedVehicleRequest
     */
    'capacity'?: number | null;
    /**
     * Vehicle Has Air Conditioner
     * @type {boolean}
     * @memberof PatchedVehicleRequest
     */
    'has_air_conditioner'?: boolean;
}
/**
 * Serialize payment method.
 * @export
 * @interface PaymentMethod
 */
export interface PaymentMethod {
    /**
     * 
     * @type {number}
     * @memberof PaymentMethod
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof PaymentMethod
     */
    'created_on': string;
    /**
     * 
     * @type {string}
     * @memberof PaymentMethod
     */
    'modified': string;
    /**
     * Name of the Payment Method
     * @type {string}
     * @memberof PaymentMethod
     */
    'method': string;
    /**
     * Description of the Payment Method
     * @type {string}
     * @memberof PaymentMethod
     */
    'description': string;
}
/**
 * Serialize payment method.
 * @export
 * @interface PaymentMethodRequest
 */
export interface PaymentMethodRequest {
    /**
     * Name of the Payment Method
     * @type {string}
     * @memberof PaymentMethodRequest
     */
    'method': string;
    /**
     * Description of the Payment Method
     * @type {string}
     * @memberof PaymentMethodRequest
     */
    'description': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const PaymentProgramEnum = {
    Direct: 'direct',
    Flexible: 'flexible'
} as const;

export type PaymentProgramEnum = typeof PaymentProgramEnum[keyof typeof PaymentProgramEnum];


/**
 * 
 * @export
 * @enum {string}
 */

export const PaymentStrategyEnum = {
    Direct: 'direct',
    Factored: 'factored',
    ReverseFactored: 'reverse_factored'
} as const;

export type PaymentStrategyEnum = typeof PaymentStrategyEnum[keyof typeof PaymentStrategyEnum];


/**
 * Serialize payment term.
 * @export
 * @interface PaymentTerm
 */
export interface PaymentTerm {
    /**
     * 
     * @type {number}
     * @memberof PaymentTerm
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof PaymentTerm
     */
    'created_on': string;
    /**
     * 
     * @type {string}
     * @memberof PaymentTerm
     */
    'modified': string;
    /**
     * Name of the Payment Term
     * @type {string}
     * @memberof PaymentTerm
     */
    'term': string;
    /**
     * Description of the Payment Term
     * @type {string}
     * @memberof PaymentTerm
     */
    'description': string;
}
/**
 * Serialize payment term.
 * @export
 * @interface PaymentTermRequest
 */
export interface PaymentTermRequest {
    /**
     * Name of the Payment Term
     * @type {string}
     * @memberof PaymentTermRequest
     */
    'term': string;
    /**
     * Description of the Payment Term
     * @type {string}
     * @memberof PaymentTermRequest
     */
    'description': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const PaymentTypeEnum = {
    Other: 'other',
    Cash: 'cash',
    Check: 'check',
    Credit: 'credit',
    Trade: 'trade',
    Ach: 'ach',
    Wire: 'wire',
    Cashier: 'cashier',
    LeaflinkDirectPayment: 'leaflink_direct_payment',
    LeaflinkFlexiblePayment: 'leaflink_flexible_payment',
    LeaflinkFinancial: 'leaflink_financial'
} as const;

export type PaymentTypeEnum = typeof PaymentTypeEnum[keyof typeof PaymentTypeEnum];


/**
 * 
 * @export
 * @enum {string}
 */

export const PeriodEnum = {
    Daily: 'Daily',
    Weekly: 'Weekly',
    Monthly: 'Monthly'
} as const;

export type PeriodEnum = typeof PeriodEnum[keyof typeof PeriodEnum];


/**
 * @type PolymorphicDeliveryPackageVendorFields
 * @export
 */
export type PolymorphicDeliveryPackageVendorFields = { resource_type: 'BiotrackDeliveryPackageFields' } & BiotrackDeliveryPackage | { resource_type: 'MetrcDeliveryPackageFields' } & MetrcDeliveryPackage;

/**
 * @type PolymorphicDriverVendorFields
 * @export
 */
export type PolymorphicDriverVendorFields = { resource_type: 'BiotrackDriverFields' } & BiotrackDriver | { resource_type: 'MetrcDriverFields' } & MetrcDriver;

/**
 * @type PolymorphicTransfer
 * @export
 */
export type PolymorphicTransfer = { resource_type: 'LegacyTransfer' } & Transfer | { resource_type: 'TraceabilityTransfer' } & TraceabilityTransfer;

/**
 * @type PolymorphicTransferVendorFields
 * @export
 */
export type PolymorphicTransferVendorFields = { resource_type: 'BiotrackTransferFields' } & BiotrackTransfer | { resource_type: 'MetrcTransferFields' } & MetrcTransfer;

/**
 * @type PolymorphicVehicleVendorFields
 * @export
 */
export type PolymorphicVehicleVendorFields = { resource_type: 'BiotrackVehicleFields' } & BiotrackVehicle | { resource_type: 'MetrcVehicleFields' } & MetrcVehicle;

/**
 * 
 * @export
 * @enum {string}
 */

export const PreferredPaymentProgramEnum = {
    DoNotProcess: 'do_not_process',
    Flexible: 'flexible',
    Direct: 'direct'
} as const;

export type PreferredPaymentProgramEnum = typeof PreferredPaymentProgramEnum[keyof typeof PreferredPaymentProgramEnum];


/**
 * 
 * @export
 * @interface ProductBulkUpdateResponse
 */
export interface ProductBulkUpdateResponse {
    /**
     * 
     * @type {number}
     * @memberof ProductBulkUpdateResponse
     */
    'updated': number;
    /**
     * 
     * @type {number}
     * @memberof ProductBulkUpdateResponse
     */
    'expected': number;
    /**
     * 
     * @type {{ [key: string]: Array<ProductBulkUpdateResponseErrorDetail>; }}
     * @memberof ProductBulkUpdateResponse
     */
    'errors': { [key: string]: Array<ProductBulkUpdateResponseErrorDetail>; };
}
/**
 * 
 * @export
 * @interface ProductBulkUpdateResponseErrorDetail
 */
export interface ProductBulkUpdateResponseErrorDetail {
    /**
     * 
     * @type {Array<ProductBulkUpdateResponseProduct>}
     * @memberof ProductBulkUpdateResponseErrorDetail
     */
    'products': Array<ProductBulkUpdateResponseProduct>;
    /**
     * 
     * @type {string}
     * @memberof ProductBulkUpdateResponseErrorDetail
     */
    'message': string;
}
/**
 * 
 * @export
 * @interface ProductBulkUpdateResponseProduct
 */
export interface ProductBulkUpdateResponseProduct {
    /**
     * 
     * @type {number}
     * @memberof ProductBulkUpdateResponseProduct
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof ProductBulkUpdateResponseProduct
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ProductBulkUpdateResponseProduct
     */
    'display_name': string;
}
/**
 * Product category serializer.
 * @export
 * @interface ProductCategory
 */
export interface ProductCategory {
    /**
     * 
     * @type {number}
     * @memberof ProductCategory
     */
    'id': number;
    /**
     * Name of Category
     * @type {string}
     * @memberof ProductCategory
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ProductCategory
     */
    'slug': string;
    /**
     * Brand Description
     * @type {string}
     * @memberof ProductCategory
     */
    'description': string;
}
/**
 * @type ProductInventoryManagement
 * The state that determines how inventory is handled for the Product
 * @export
 */
export type ProductInventoryManagement = BlankEnumUnifiedUpstreamMarketplace | InventoryManagementEnum;

/**
 * 
 * @export
 * @interface ProductPromotion
 */
export interface ProductPromotion {
    /**
     * 
     * @type {number}
     * @memberof ProductPromotion
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof ProductPromotion
     */
    'moloco_id'?: string;
    /**
     * 
     * @type {ProductPromotionStatusEnum}
     * @memberof ProductPromotion
     */
    'status': ProductPromotionStatusEnum;
    /**
     * 
     * @type {PeriodEnum}
     * @memberof ProductPromotion
     */
    'period'?: PeriodEnum;
    /**
     * 
     * @type {string}
     * @memberof ProductPromotion
     */
    'start_date': string;
    /**
     * 
     * @type {string}
     * @memberof ProductPromotion
     */
    'end_date'?: string | null;
    /**
     * 
     * @type {PatchedProductPromotionRequestMaxCpc}
     * @memberof ProductPromotion
     */
    'max_cpc': PatchedProductPromotionRequestMaxCpc;
    /**
     * 
     * @type {PatchedProductPromotionRequestMaxCpc}
     * @memberof ProductPromotion
     */
    'max_budget': PatchedProductPromotionRequestMaxCpc;
    /**
     * 
     * @type {PatchedProductPromotionRequestMaxCpc}
     * @memberof ProductPromotion
     */
    'budget_per_period': PatchedProductPromotionRequestMaxCpc;
    /**
     * 
     * @type {string}
     * @memberof ProductPromotion
     */
    'approver_email'?: string | null;
    /**
     * 
     * @type {UnifiedBrand}
     * @memberof ProductPromotion
     */
    'brand': UnifiedBrand;
    /**
     * 
     * @type {UnifiedCompany}
     * @memberof ProductPromotion
     */
    'company': UnifiedCompany;
    /**
     * 
     * @type {UnifiedCompany}
     * @memberof ProductPromotion
     */
    'billing_company': UnifiedCompany;
    /**
     * 
     * @type {Array<number>}
     * @memberof ProductPromotion
     */
    'products': Array<number>;
}


/**
 * 
 * @export
 * @interface ProductPromotionRequest
 */
export interface ProductPromotionRequest {
    /**
     * 
     * @type {string}
     * @memberof ProductPromotionRequest
     */
    'moloco_id'?: string;
    /**
     * 
     * @type {ProductPromotionStatusEnum}
     * @memberof ProductPromotionRequest
     */
    'status': ProductPromotionStatusEnum;
    /**
     * 
     * @type {PeriodEnum}
     * @memberof ProductPromotionRequest
     */
    'period'?: PeriodEnum;
    /**
     * 
     * @type {string}
     * @memberof ProductPromotionRequest
     */
    'start_date': string;
    /**
     * 
     * @type {string}
     * @memberof ProductPromotionRequest
     */
    'end_date'?: string | null;
    /**
     * 
     * @type {PatchedProductPromotionRequestMaxCpc}
     * @memberof ProductPromotionRequest
     */
    'max_cpc': PatchedProductPromotionRequestMaxCpc;
    /**
     * 
     * @type {PatchedProductPromotionRequestMaxCpc}
     * @memberof ProductPromotionRequest
     */
    'max_budget': PatchedProductPromotionRequestMaxCpc;
    /**
     * 
     * @type {PatchedProductPromotionRequestMaxCpc}
     * @memberof ProductPromotionRequest
     */
    'budget_per_period': PatchedProductPromotionRequestMaxCpc;
    /**
     * 
     * @type {string}
     * @memberof ProductPromotionRequest
     */
    'approver_email'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ProductPromotionRequest
     */
    'brand_id': number;
    /**
     * 
     * @type {number}
     * @memberof ProductPromotionRequest
     */
    'company_id': number;
    /**
     * 
     * @type {number}
     * @memberof ProductPromotionRequest
     */
    'billing_company_id'?: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof ProductPromotionRequest
     */
    'products': Array<number>;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const ProductPromotionStatusEnum = {
    Pending: 'Pending',
    Approved: 'Approved',
    Completed: 'Completed'
} as const;

export type ProductPromotionStatusEnum = typeof ProductPromotionStatusEnum[keyof typeof ProductPromotionStatusEnum];


/**
 * Product subcategory serializer.
 * @export
 * @interface ProductSubCategory
 */
export interface ProductSubCategory {
    /**
     * 
     * @type {number}
     * @memberof ProductSubCategory
     */
    'id': number;
    /**
     * Name of Sub-Category
     * @type {string}
     * @memberof ProductSubCategory
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ProductSubCategory
     */
    'slug': string;
    /**
     * Description of Sub-Category
     * @type {string}
     * @memberof ProductSubCategory
     */
    'description'?: string;
    /**
     * The parent category of this sub-category
     * @type {number}
     * @memberof ProductSubCategory
     */
    'category': number;
}
/**
 * Serializer for Recommended Products
 * @export
 * @interface RecommendedProduct
 */
export interface RecommendedProduct {
    /**
     * 
     * @type {number}
     * @memberof RecommendedProduct
     */
    'id': number;
    /**
     * Product Name
     * @type {string}
     * @memberof RecommendedProduct
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof RecommendedProduct
     */
    'company_id': string;
    /**
     * 
     * @type {string}
     * @memberof RecommendedProduct
     */
    'company_name': string;
    /**
     * 
     * @type {boolean}
     * @memberof RecommendedProduct
     */
    'enable_vendor_menu': boolean;
    /**
     * 
     * @type {string}
     * @memberof RecommendedProduct
     */
    'slug': string;
    /**
     * 
     * @type {string}
     * @memberof RecommendedProduct
     */
    'image': string;
    /**
     * This product is featured for it\'s brand.
     * @type {boolean}
     * @memberof RecommendedProduct
     */
    'featured'?: boolean;
    /**
     * 
     * @type {Array<SpotlightBadgesEnum>}
     * @memberof RecommendedProduct
     */
    'spotlight_badges': Array<SpotlightBadgesEnum>;
    /**
     * 
     * @type {string}
     * @memberof RecommendedProduct
     */
    'display_price': string;
    /**
     * 
     * @type {string}
     * @memberof RecommendedProduct
     */
    'display_unit_price': string;
    /**
     * 
     * @type {string}
     * @memberof RecommendedProduct
     */
    'unit_price': string;
    /**
     * 
     * @type {string}
     * @memberof RecommendedProduct
     */
    'base_unit_price': string;
    /**
     * 
     * @type {number}
     * @memberof RecommendedProduct
     */
    'sale_or_deal_price': number;
    /**
     * 
     * @type {FeaturedProductDiscountPercent}
     * @memberof RecommendedProduct
     */
    'discount_percent': FeaturedProductDiscountPercent;
    /**
     * Minimum Units per Order
     * @type {string}
     * @memberof RecommendedProduct
     */
    'minimum_order'?: string;
    /**
     * 
     * @type {FeaturedBrand}
     * @memberof RecommendedProduct
     */
    'brand': FeaturedBrand;
    /**
     * 
     * @type {Sponsorship}
     * @memberof RecommendedProduct
     */
    'sponsorship': Sponsorship;
    /**
     * 
     * @type {number}
     * @memberof RecommendedProduct
     */
    'score': number;
    /**
     * 
     * @type {boolean}
     * @memberof RecommendedProduct
     */
    'is_on_purchase_list': boolean;
}
/**
 * Creating a recorded payment on an Invoice
 * @export
 * @interface RecordInvoicePayment
 */
export interface RecordInvoicePayment {
    /**
     * Quantity in USD
     * @type {string}
     * @memberof RecordInvoicePayment
     */
    'amount': string;
    /**
     * Date payment was made in YYYY-MM-DD
     * @type {string}
     * @memberof RecordInvoicePayment
     */
    'payment_date': string;
    /**
     * Reason payment was made. choices: [\'invoice_purchase\', \'reversal\', \'adjustment\', \'principal\', \'extension_fee\', \'factor_fee\', \'direct_pay_fee\', \'direct_pay_fee_reversal\', \'direct_pay_fee_batch\', \'cashback_reward\', \'standard\', \'ach_error\', \'marketplace_payment\', \'other\', \'sell_through\']
     * @type {string}
     * @memberof RecordInvoicePayment
     */
    'payment_reason': string;
    /**
     * The way the payment was made. choices:[\'ach\', \'wire\', \'money_order\', \'cash_pickup\', \'check\', \'other\']
     * @type {string}
     * @memberof RecordInvoicePayment
     */
    'payment_method': string;
    /**
     * Check number if the method is check
     * @type {string}
     * @memberof RecordInvoicePayment
     */
    'check_number'?: string;
    /**
     * The ID of this payment in your system
     * @type {string}
     * @memberof RecordInvoicePayment
     */
    'source_id': string;
}
/**
 * Creating a recorded payment on an Invoice
 * @export
 * @interface RecordInvoicePaymentRequest
 */
export interface RecordInvoicePaymentRequest {
    /**
     * Quantity in USD
     * @type {string}
     * @memberof RecordInvoicePaymentRequest
     */
    'amount': string;
    /**
     * Date payment was made in YYYY-MM-DD
     * @type {string}
     * @memberof RecordInvoicePaymentRequest
     */
    'payment_date': string;
    /**
     * Reason payment was made. choices: [\'invoice_purchase\', \'reversal\', \'adjustment\', \'principal\', \'extension_fee\', \'factor_fee\', \'direct_pay_fee\', \'direct_pay_fee_reversal\', \'direct_pay_fee_batch\', \'cashback_reward\', \'standard\', \'ach_error\', \'marketplace_payment\', \'other\', \'sell_through\']
     * @type {string}
     * @memberof RecordInvoicePaymentRequest
     */
    'payment_reason': string;
    /**
     * The way the payment was made. choices:[\'ach\', \'wire\', \'money_order\', \'cash_pickup\', \'check\', \'other\']
     * @type {string}
     * @memberof RecordInvoicePaymentRequest
     */
    'payment_method': string;
    /**
     * Check number if the method is check
     * @type {string}
     * @memberof RecordInvoicePaymentRequest
     */
    'check_number'?: string;
    /**
     * The ID of this payment in your system
     * @type {string}
     * @memberof RecordInvoicePaymentRequest
     */
    'source_id': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const RegularActionEnum = {
    Default: 'default',
    Backorder: 'backorder',
    Unavailable: 'unavailable',
    Internal: 'internal'
} as const;

export type RegularActionEnum = typeof RegularActionEnum[keyof typeof RegularActionEnum];


/**
 * 
 * @export
 * @enum {string}
 */

export const ReverseActionEnum = {
    Default: 'default',
    Available: 'available',
    Internal: 'internal'
} as const;

export type ReverseActionEnum = typeof ReverseActionEnum[keyof typeof ReverseActionEnum];


/**
 * 
 * @export
 * @enum {string}
 */

export const SelectorEnum = {
    ProductLine: 'product_line'
} as const;

export type SelectorEnum = typeof SelectorEnum[keyof typeof SelectorEnum];


/**
 * Used to serialize seller data (a seller is a company where `type` = `seller`)
 * @export
 * @interface Seller
 */
export interface Seller {
    /**
     * 
     * @type {string}
     * @memberof Seller
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof Seller
     */
    'dba': string;
    /**
     * 
     * @type {string}
     * @memberof Seller
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Seller
     */
    'street_address'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Seller
     */
    'unit_number'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Seller
     */
    'city'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Seller
     */
    'state'?: string | null;
    /**
     * 
     * @type {Array<License>}
     * @memberof Seller
     */
    'licenses'?: Array<License>;
    /**
     * 
     * @type {string}
     * @memberof Seller
     */
    'zipcode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Seller
     */
    'country'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Seller
     */
    'phone'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Seller
     */
    'marketplace_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof Seller
     */
    'marketplace_slug'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Seller
     */
    'marketplace_dashboard_url': string;
    /**
     * 
     * @type {string}
     * @memberof Seller
     */
    'has_signed_terms_and_conditions': string;
    /**
     * 
     * @type {string}
     * @memberof Seller
     */
    'in_direct_enabled_state': string;
    /**
     * 
     * @type {Type7a8Enum}
     * @memberof Seller
     */
    'type': Type7a8Enum | null;
    /**
     * 
     * @type {string}
     * @memberof Seller
     */
    'url'?: string | null;
    /**
     * 
     * @type {LegalEntity}
     * @memberof Seller
     */
    'legal_entity'?: LegalEntity;
    /**
     * 
     * @type {StatusEnum}
     * @memberof Seller
     */
    'status'?: StatusEnum;
    /**
     * 
     * @type {boolean}
     * @memberof Seller
     */
    'b2b_enabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Seller
     */
    'flexible_enabled'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Seller
     */
    'image'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Seller
     */
    'timezone'?: string;
    /**
     * 
     * @type {string}
     * @memberof Seller
     */
    'created_on': string;
    /**
     * 
     * @type {string}
     * @memberof Seller
     */
    'modified': string;
    /**
     * 
     * @type {boolean}
     * @memberof Seller
     */
    'excluded_from_automated_payments'?: boolean;
    /**
     * 
     * @type {PreferredPaymentProgramEnum}
     * @memberof Seller
     */
    'preferred_payment_program'?: PreferredPaymentProgramEnum | null;
    /**
     * 
     * @type {string}
     * @memberof Seller
     */
    'docusign_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Seller
     */
    'brands': string;
    /**
     * 
     * @type {string}
     * @memberof Seller
     */
    'marketplace_customers_url': string;
    /**
     * 
     * @type {number}
     * @memberof Seller
     */
    'direct_payment_processing_rate'?: number | null;
    /**
     * 
     * @type {DefaultFlexiblePaymentStrategyEnum}
     * @memberof Seller
     */
    'default_flexible_payment_strategy'?: DefaultFlexiblePaymentStrategyEnum | null;
    /**
     * 
     * @type {string}
     * @memberof Seller
     */
    'default_flexible_payment_term': string;
    /**
     * 
     * @type {BuyerCollectionDayPreference}
     * @memberof Seller
     */
    'collection_day_preference'?: BuyerCollectionDayPreference | null;
    /**
     * 
     * @type {boolean}
     * @memberof Seller
     */
    'excluded_from_funding_on_t'?: boolean;
}


/**
 * Used to serialize seller data (a seller is a company where `type` = `seller`)
 * @export
 * @interface SellerRequest
 */
export interface SellerRequest {
    /**
     * 
     * @type {string}
     * @memberof SellerRequest
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof SellerRequest
     */
    'dba': string;
    /**
     * 
     * @type {string}
     * @memberof SellerRequest
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SellerRequest
     */
    'street_address'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SellerRequest
     */
    'unit_number'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SellerRequest
     */
    'city'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SellerRequest
     */
    'state'?: string | null;
    /**
     * 
     * @type {Array<LicenseRequest>}
     * @memberof SellerRequest
     */
    'licenses'?: Array<LicenseRequest>;
    /**
     * 
     * @type {string}
     * @memberof SellerRequest
     */
    'zipcode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SellerRequest
     */
    'country'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SellerRequest
     */
    'phone'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SellerRequest
     */
    'marketplace_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof SellerRequest
     */
    'marketplace_slug'?: string | null;
    /**
     * 
     * @type {Type7a8Enum}
     * @memberof SellerRequest
     */
    'type': Type7a8Enum | null;
    /**
     * 
     * @type {string}
     * @memberof SellerRequest
     */
    'url'?: string | null;
    /**
     * 
     * @type {LegalEntityRequest}
     * @memberof SellerRequest
     */
    'legal_entity'?: LegalEntityRequest;
    /**
     * 
     * @type {string}
     * @memberof SellerRequest
     */
    'legal_entity_id'?: string;
    /**
     * 
     * @type {StatusEnum}
     * @memberof SellerRequest
     */
    'status'?: StatusEnum;
    /**
     * 
     * @type {boolean}
     * @memberof SellerRequest
     */
    'b2b_enabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SellerRequest
     */
    'flexible_enabled'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SellerRequest
     */
    'image'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SellerRequest
     */
    'timezone'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SellerRequest
     */
    'excluded_from_automated_payments'?: boolean;
    /**
     * 
     * @type {PreferredPaymentProgramEnum}
     * @memberof SellerRequest
     */
    'preferred_payment_program'?: PreferredPaymentProgramEnum | null;
    /**
     * 
     * @type {string}
     * @memberof SellerRequest
     */
    'docusign_id'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SellerRequest
     */
    'direct_payment_processing_rate'?: number | null;
    /**
     * 
     * @type {DefaultFlexiblePaymentStrategyEnum}
     * @memberof SellerRequest
     */
    'default_flexible_payment_strategy'?: DefaultFlexiblePaymentStrategyEnum | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof SellerRequest
     */
    'reviewed_eligible_flexible_buyers'?: Array<string>;
    /**
     * 
     * @type {BuyerCollectionDayPreference}
     * @memberof SellerRequest
     */
    'collection_day_preference'?: BuyerCollectionDayPreference | null;
    /**
     * 
     * @type {boolean}
     * @memberof SellerRequest
     */
    'excluded_from_funding_on_t'?: boolean;
}


/**
 * Serializer for the ServiceZone model.
 * @export
 * @interface ServiceZone
 */
export interface ServiceZone {
    /**
     * 
     * @type {number}
     * @memberof ServiceZone
     */
    'id': number;
    /**
     * Service Zone Name
     * @type {string}
     * @memberof ServiceZone
     */
    'name': string;
    /**
     * Detailed description of the service zone.
     * @type {string}
     * @memberof ServiceZone
     */
    'description'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ServiceZone
     */
    'company': number;
}
/**
 * Serializer for the ServiceZone model.
 * @export
 * @interface ServiceZoneRequest
 */
export interface ServiceZoneRequest {
    /**
     * Service Zone Name
     * @type {string}
     * @memberof ServiceZoneRequest
     */
    'name': string;
    /**
     * Detailed description of the service zone.
     * @type {string}
     * @memberof ServiceZoneRequest
     */
    'description'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ServiceZoneRequest
     */
    'company': number;
}
/**
 * Short serializer for payment methods.
 * @export
 * @interface ShortPaymentMethod
 */
export interface ShortPaymentMethod {
    /**
     * 
     * @type {number}
     * @memberof ShortPaymentMethod
     */
    'id': number;
    /**
     * Name of the Payment Method
     * @type {string}
     * @memberof ShortPaymentMethod
     */
    'method': string;
}
/**
 * Short serializer for payment methods.
 * @export
 * @interface ShortPaymentMethodRequest
 */
export interface ShortPaymentMethodRequest {
    /**
     * Name of the Payment Method
     * @type {string}
     * @memberof ShortPaymentMethodRequest
     */
    'method': string;
}
/**
 * Short serializer for payment terms.
 * @export
 * @interface ShortPaymentTerm
 */
export interface ShortPaymentTerm {
    /**
     * 
     * @type {number}
     * @memberof ShortPaymentTerm
     */
    'id': number;
    /**
     * Name of the Payment Term
     * @type {string}
     * @memberof ShortPaymentTerm
     */
    'term': string;
    /**
     * 
     * @type {number}
     * @memberof ShortPaymentTerm
     */
    'days': number;
    /**
     * Term of Payment (code)
     * @type {string}
     * @memberof ShortPaymentTerm
     */
    'code'?: string | null;
}
/**
 * Short serializer for payment terms.
 * @export
 * @interface ShortPaymentTermRequest
 */
export interface ShortPaymentTermRequest {
    /**
     * Name of the Payment Term
     * @type {string}
     * @memberof ShortPaymentTermRequest
     */
    'term': string;
    /**
     * 
     * @type {number}
     * @memberof ShortPaymentTermRequest
     */
    'days': number;
    /**
     * Term of Payment (code)
     * @type {string}
     * @memberof ShortPaymentTermRequest
     */
    'code'?: string | null;
}
/**
 * Serializer for Brand resource.
 * @export
 * @interface SkyscraperBrand
 */
export interface SkyscraperBrand {
    /**
     * 
     * @type {string}
     * @memberof SkyscraperBrand
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SkyscraperBrand
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof SkyscraperBrand
     */
    'image_url': string;
    /**
     * 
     * @type {string}
     * @memberof SkyscraperBrand
     */
    'company_name': string;
    /**
     * 
     * @type {string}
     * @memberof SkyscraperBrand
     */
    'company_id': string;
    /**
     * 
     * @type {boolean}
     * @memberof SkyscraperBrand
     */
    'enable_vendor_menu': boolean;
}
/**
 * Serializer for an individual Skyscraper style sponsorship result.
 * @export
 * @interface SkyscraperSponsorshipContent
 */
export interface SkyscraperSponsorshipContent {
    /**
     * 
     * @type {string}
     * @memberof SkyscraperSponsorshipContent
     */
    'ad_id': string;
    /**
     * 
     * @type {string}
     * @memberof SkyscraperSponsorshipContent
     */
    'campaign_id': string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof SkyscraperSponsorshipContent
     */
    'creative': { [key: string]: any; };
    /**
     * 
     * @type {string}
     * @memberof SkyscraperSponsorshipContent
     */
    'creative_id': string;
    /**
     * 
     * @type {string}
     * @memberof SkyscraperSponsorshipContent
     */
    'custom_text': string;
    /**
     * 
     * @type {string}
     * @memberof SkyscraperSponsorshipContent
     */
    'page_load_id': string;
    /**
     * 
     * @type {string}
     * @memberof SkyscraperSponsorshipContent
     */
    'placement_name': string;
    /**
     * 
     * @type {Array<SkyscraperSponsorshipItem>}
     * @memberof SkyscraperSponsorshipContent
     */
    'products': Array<SkyscraperSponsorshipItem>;
    /**
     * 
     * @type {string}
     * @memberof SkyscraperSponsorshipContent
     */
    'provider_id': string;
    /**
     * 
     * @type {number}
     * @memberof SkyscraperSponsorshipContent
     */
    'target_company_id': number;
    /**
     * 
     * @type {number}
     * @memberof SkyscraperSponsorshipContent
     */
    'target_user_id': number;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof SkyscraperSponsorshipContent
     */
    'banner': { [key: string]: any; };
    /**
     * 
     * @type {SkyscraperBrand}
     * @memberof SkyscraperSponsorshipContent
     */
    'brand': SkyscraperBrand;
}
/**
 * Serializer for ll.ads.data_models.SkyscraperSponsorshipItem
 * @export
 * @interface SkyscraperSponsorshipItem
 */
export interface SkyscraperSponsorshipItem {
    /**
     * 
     * @type {string}
     * @memberof SkyscraperSponsorshipItem
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SkyscraperSponsorshipItem
     */
    'impression_url': string;
    /**
     * 
     * @type {string}
     * @memberof SkyscraperSponsorshipItem
     */
    'click_url': string;
    /**
     * 
     * @type {string}
     * @memberof SkyscraperSponsorshipItem
     */
    'display_price': string;
    /**
     * 
     * @type {string}
     * @memberof SkyscraperSponsorshipItem
     */
    'image_url': string;
    /**
     * 
     * @type {string}
     * @memberof SkyscraperSponsorshipItem
     */
    'name': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const SplitNameEnum = {
    CommerceAcceptPaymentsPaymentEvents: 'commerce__accept_payments_payment_events',
    ActiveExperiments: 'active_experiments',
    AdsDashboardRecentlyPurchasedCarousel: 'ads_dashboard_recently_purchased_carousel',
    AdsPodEnableMolocoAdReporting: 'ads_pod_enable_moloco_ad_reporting',
    AdsEnableRecentlyPurchasedBrandsCarousel: 'ads_enable_recently_purchased_brands_carousel',
    AdsEnableShareMenu: 'ads_enable_share_menu',
    AdsEnableTopPurchasedProductsCarousel: 'ads_enable_top_purchased_products_carousel',
    AdsEnableVueifiedShareLeaflink: 'ads_enable_vueified_share_leaflink',
    AdsInPlatformProductPromotion: 'ads_in_platform_product_promotion',
    AdsProductRecommendation: 'ads_product_recommendation',
    AdsProductSpotlight: 'ads_product_spotlight',
    AdsShoppableSkyscraper: 'ads_shoppable_skyscraper',
    AdsSponsorshipsInProductSearch: 'ads_sponsorships_in_product_search',
    FirePodMpAutoPausing: 'fire_pod__mp_auto_pausing',
    FirePodMpAutoPausingUpdate: 'fire_pod__mp_auto_pausing_update',
    LogisticsPodEnableAutoUpdateOfMetrcTemplates: 'logistics_pod__enable_auto_update_of_metrc_templates',
    TraceabilityPodAutomatedMetrcLicenseValidation: 'traceability_pod__automated_metrc_license_validation',
    FirePodMpBalanceChecks: 'fire_pod__mp_balance_checks',
    CopPodBankLinking: 'cop_pod__bank_linking',
    TraceabilityPodBiotrackNewYork: 'traceability_pod__biotrack_new_york',
    TraceabilityBiotrackBuyerOnboarding: 'traceability__biotrack_buyer_onboarding',
    PsxPodBuyerDashboard: 'psx_pod__buyer_dashboard',
    CePodBuyerMetrcOnboarding: 'ce_pod__buyer_metrc_onboarding',
    BuyerSettingsStoreRequestsVue: 'buyer_settings_store_requests_vue',
    RetentionPodBuyerReports: 'retention_pod__buyer_reports',
    CanAccessCompanyGroupFeatures: 'can_access_company_group_features',
    RetPodSplitOrders: 'ret_pod__split_orders',
    RetentionPodBrandMenuSocialLinks: 'retention_pod__brand_menu_social_links',
    ComPodCartPaymentCta: 'com_pod__cart_payment_cta',
    ComPodCartPaymentOption: 'com_pod__cart_payment_option',
    ComPodReverseFactor: 'com_pod__reverse_factor',
    FirePodCashbackRewards: 'fire_pod__cashback_rewards',
    TraceabilityPodCredentialEncryption: 'traceability_pod__credential_encryption',
    CustomMenusEditProductRedirect: 'custom_menus__edit_product_redirect',
    SpliffPodCollabNotification: 'spliff_pod__collab_notification',
    FirePodDelinquentLockdown: 'fire_pod__delinquent_lockdown',
    FirePodDirectPayAutoAuthorization: 'fire_pod__direct_pay_auto_authorization',
    FirePodDirectPayEnabledStates: 'fire_pod__direct_pay_enabled_states',
    FirePodPostSettings: 'fire_pod__post_settings',
    LogisticsPodEnableCustomersToSelectTransportPartner: 'logistics_pod__enable_customers_to_select_transport_partner',
    EnableLogisticsPermissionToAllUsers: 'enable_logistics_permission_to_all_users',
    PlatArchPodOsoCloud: 'plat_arch_pod__oso_cloud',
    AcctManPodEnrollmentNueIntegration: 'acct_man_pod__enrollment_nue_integration',
    EnterprisePodMultPaymentMethods: 'enterprise_pod__mult_payment_methods',
    EnterprisePodOrderFees: 'enterprise_pod__order_fees',
    ForceSegmentReporting: 'force_segment_reporting',
    RetPodOrderMinimum: 'ret_pod__order_minimum',
    InboundShipmentsCreate: 'inbound_shipments_create',
    TraceabilityPodIntegrationSettings: 'traceability_pod__integration_settings',
    NprPodIntegrationsSeller: 'npr_pod__integrations_seller',
    OrdersInternalApprovals: 'orders_internal_approvals',
    InventoryPodInventoryBatchSupport: 'inventory_pod__inventory_batch_support',
    InventoryNegativeAvailableQuantityLogging: 'inventory_negative_available_quantity_logging',
    InventoryPodInventoryWarehouseSupport: 'inventory_pod__inventory_warehouse_support',
    OgkPodKnockNotifications: 'ogk_pod__knock_notifications',
    KnockNotificationsToaster: 'knock_notifications_toaster',
    LlmLeaflinkPlusEnrollmentBilling: 'llm_leaflink_plus_enrollment_billing',
    LlmLeaflinkPlusEnrollmentUpdates: 'llm_leaflink_plus_enrollment_updates',
    InventoryPodListingsAllocations: 'inventory_pod__listings_allocations',
    LiveInventoryIndicator: 'live_inventory_indicator',
    ManageLicenseAddIntegrationBuyer: 'manage_license__add_integration__buyer',
    MessagingNotifications: 'messaging_notifications',
    OmsDataSyncEvents: 'oms_data_sync_events',
    OmsHistoricalDataSync: 'oms_historical_data_sync',
    OmsProductSyncEvents: 'oms_product_sync_events',
    FirePodOrderAdjustmentsEventConsumer: 'fire_pod__order_adjustments_event_consumer',
    OrderLatency: 'order_latency',
    IntPodOrderPdfReport: 'int_pod__order_pdf_report',
    OrderSummaryAncillaryEnhancements: 'order_summary_ancillary_enhancements',
    GroPodOrderSummaryInvitations: 'gro_pod__order_summary_invitations',
    OrderSummaryReceiptLog: 'order_summary_receipt_log',
    OrdersReceivedDataview: 'orders_received_dataview',
    AdsProductRecommendationOrganicRecommendations: 'ads_product_recommendation_organic_recommendations',
    PauseInactiveLicenseCompanies: 'pause_inactive_license_companies',
    PaymentOnSellThroughEnrollment: 'payment_on_sell_through__enrollment',
    CopPodPaymentsExplorationDashboardWidget: 'cop_pod__payments_exploration_dashboard_widget',
    CollabPodPaymentsInCrm: 'collab_pod__payments_in_crm',
    ShopBrandsPerformanceImprovement: 'shop_brands_performance_improvement',
    AcctManPodPlansAndBilling: 'acct_man_pod__plans_and_billing',
    AcctManPodPlanPrice: 'acct_man_pod__plan_price',
    AdsPlatformPromotionAutomation: 'ads_platform_promotion_automation',
    PostAllowRemovePostFlagFromOrder: 'post_allow_remove_post_flag_from_order',
    PostAutomatedPaymentsCalculation: 'post_automated_payments__calculation',
    FirePodEnablePostWeeklySumView: 'fire_pod__enable_post_weekly_sum_view',
    PostOrderPreagreementSettings: 'post_order_preagreement_settings',
    FirePodPostPackageServices: 'fire_pod__post_package_services',
    PostSignTermsAndConditionsForAllStaffUsers: 'post__sign_terms_and_conditions_for_all_staff_users',
    PostStsUnitConversion: 'post_sts_unit_conversion',
    GroPodPrintedMenu: 'gro_pod__printed_menu',
    InventoryPodNewProductListPage: 'inventory_pod__new_product_list_page',
    CollabPodPromoCodeDisplay: 'collab_pod__promo_code_display',
    ReplenishmentCatalogPage: 'replenishment_catalog_page',
    RetailCategoryManagementSelfService: 'retail_category_management_self_service',
    RetailProductLeaderboardNegotiate: 'retail_product_leaderboard_negotiate',
    SeedToSaleCoaDownload: 'seed_to_sale_coa_download',
    TraceabilityPodExperimentReconcileInventory: 'traceability_pod__experiment__reconcile_inventory',
    SeedToSaleTransferTemplate: 'seed_to_sale__transfer_template',
    TracePodS2sTransfers: 'trace_pod__s2s_transfers',
    TraceabilityBiotrackSellerTransfersPage: 'traceability__biotrack_seller_transfers_page',
    EappsSageEnabled: 'eapps_sage_enabled',
    CollabPodSalesRepEmailActions: 'collab_pod__sales_rep_email_actions',
    TracePodSearchByAssignedPackages: 'trace_pod__search_by_assigned_packages',
    SeedToSaleBuyerNav: 'seed_to_sale__buyer_nav',
    TraceabilityBiotrackSellerAttachManifest: 'traceability__biotrack_seller_attach_manifest',
    LlmSigmaGpoReport: 'llm_sigma_gpo_report',
    LlmGpoSellerReportV2: 'llm_gpo_seller_report_v2',
    ManageLicensesNewMetrcFlow: 'manage_licenses__new_metrc_flow',
    AcctPodSellerOrderSummary: 'acct_pod__seller_order_summary',
    SellerSettingsVue: 'seller_settings_vue',
    AdsServeAlgoliaRecommendations: 'ads_serve_algolia_recommendations',
    SettingsBuyerAccountDetails: 'settings__buyer_account_details',
    SettingsTaxSchedules: 'settings__tax_schedules',
    ShippingRequestDeliveryModal: 'shipping_request_delivery_modal',
    ShowSellThroughForNonPost: 'show_sell_through_for_non_post',
    SipsPodMpLicenseServiceApi: 'sips_pod__mp_license_service_api',
    SsrIframe: 'ssr_iframe',
    LogisticsPodSubmitOrderViaCsvUpload: 'logistics_pod__submit_order_via_csv_upload',
    SupplyChainDeliveredStatus: 'supply_chain_delivered_status',
    SwitchCustomerForClonedOrders: 'switch_customer_for_cloned_orders',
    CopPodTermsAndConditions: 'cop_pod__terms_and_conditions',
    TransportPodShippingSetOrderPayments: 'transport_pod__shipping_set_order_payments',
    TransportPodMaNextDayDelivery: 'transport_pod__ma_next_day_delivery',
    PlatArchPodUnifiedHijacking: 'plat_arch_pod__unified_hijacking',
    AdsKevelBuyerSellerDash: 'ads_kevel_buyer_seller_dash',
    AdsMolocoShopBrandsSidebarBanners: 'ads_moloco_shop_brands_sidebar_banners',
    AdsMolocoShopBrandsFeaturedBrands: 'ads_moloco_shop_brands_featured_brands',
    ComPodVendorMenu: 'com_pod__vendor_menu',
    GroPodVendorMenuUiEnhancement: 'gro_pod__vendor_menu_ui_enhancement',
    VueBuyerNotificationSettings: 'vue_buyer_notification_settings',
    VueInventoryBulkPriceUpdate: 'vue_inventory_bulk_price_update',
    VueInventoryProductAddEditPage: 'vue_inventory_product_add_edit_page',
    VueInventoryProductLinePage: 'vue_inventory_product_line_page',
    VueMessagesPage: 'vue_messages_page',
    LlmVueSellerReports: 'llm_vue_seller_reports',
    VueSettingsBrandsPage: 'vue_settings_brands_page',
    CretPodVueifiedCompanyProfile: 'cret_pod__vueified_company_profile',
    LlmBuyersClubRollout: 'llm_buyers_club_rollout',
    FirePodEnablePostCascade: 'fire_pod__enable_post_cascade',
    FirePodSellerGlobalPostSettings: 'fire_pod__seller_global_post_settings'
} as const;

export type SplitNameEnum = typeof SplitNameEnum[keyof typeof SplitNameEnum];


/**
 * Serializer for Split.io overrides request Shape of the request is { \'commerce__accept_payments_payment_events\': \'on\', \'fire_pod__mp_auto_pausing\': \'on\' }
 * @export
 * @interface SplitTreatment
 */
export interface SplitTreatment {
    /**
     * 
     * @type {string}
     * @memberof SplitTreatment
     */
    'commerce__accept_payments_payment_events'?: string;
    /**
     * 
     * @type {string}
     * @memberof SplitTreatment
     */
    'active_experiments'?: string;
    /**
     * 
     * @type {string}
     * @memberof SplitTreatment
     */
    'ads_dashboard_recently_purchased_carousel'?: string;
    /**
     * 
     * @type {string}
     * @memberof SplitTreatment
     */
    'ads_pod_enable_moloco_ad_reporting'?: string;
    /**
     * 
     * @type {string}
     * @memberof SplitTreatment
     */
    'ads_enable_recently_purchased_brands_carousel'?: string;
    /**
     * 
     * @type {string}
     * @memberof SplitTreatment
     */
    'ads_enable_share_menu'?: string;
    /**
     * 
     * @type {string}
     * @memberof SplitTreatment
     */
    'ads_enable_top_purchased_products_carousel'?: string;
    /**
     * 
     * @type {string}
     * @memberof SplitTreatment
     */
    'ads_enable_vueified_share_leaflink'?: string;
    /**
     * 
     * @type {string}
     * @memberof SplitTreatment
     */
    'ads_in_platform_product_promotion'?: string;
    /**
     * 
     * @type {string}
     * @memberof SplitTreatment
     */
    'ads_product_recommendation'?: string;
    /**
     * 
     * @type {string}
     * @memberof SplitTreatment
     */
    'ads_product_spotlight'?: string;
    /**
     * 
     * @type {string}
     * @memberof SplitTreatment
     */
    'ads_shoppable_skyscraper'?: string;
    /**
     * 
     * @type {string}
     * @memberof SplitTreatment
     */
    'ads_sponsorships_in_product_search'?: string;
    /**
     * 
     * @type {string}
     * @memberof SplitTreatment
     */
    'fire_pod__mp_auto_pausing'?: string;
    /**
     * 
     * @type {string}
     * @memberof SplitTreatment
     */
    'fire_pod__mp_auto_pausing_update'?: string;
    /**
     * 
     * @type {string}
     * @memberof SplitTreatment
     */
    'logistics_pod__enable_auto_update_of_metrc_templates'?: string;
    /**
     * 
     * @type {string}
     * @memberof SplitTreatment
     */
    'traceability_pod__automated_metrc_license_validation'?: string;
    /**
     * 
     * @type {string}
     * @memberof SplitTreatment
     */
    'fire_pod__mp_balance_checks'?: string;
    /**
     * 
     * @type {string}
     * @memberof SplitTreatment
     */
    'cop_pod__bank_linking'?: string;
    /**
     * 
     * @type {string}
     * @memberof SplitTreatment
     */
    'traceability_pod__biotrack_new_york'?: string;
    /**
     * 
     * @type {string}
     * @memberof SplitTreatment
     */
    'traceability__biotrack_buyer_onboarding'?: string;
    /**
     * 
     * @type {string}
     * @memberof SplitTreatment
     */
    'psx_pod__buyer_dashboard'?: string;
    /**
     * 
     * @type {string}
     * @memberof SplitTreatment
     */
    'ce_pod__buyer_metrc_onboarding'?: string;
    /**
     * 
     * @type {string}
     * @memberof SplitTreatment
     */
    'buyer_settings_store_requests_vue'?: string;
    /**
     * 
     * @type {string}
     * @memberof SplitTreatment
     */
    'retention_pod__buyer_reports'?: string;
    /**
     * 
     * @type {string}
     * @memberof SplitTreatment
     */
    'can_access_company_group_features'?: string;
    /**
     * 
     * @type {string}
     * @memberof SplitTreatment
     */
    'ret_pod__split_orders'?: string;
    /**
     * 
     * @type {string}
     * @memberof SplitTreatment
     */
    'retention_pod__brand_menu_social_links'?: string;
    /**
     * 
     * @type {string}
     * @memberof SplitTreatment
     */
    'com_pod__cart_payment_cta'?: string;
    /**
     * 
     * @type {string}
     * @memberof SplitTreatment
     */
    'com_pod__cart_payment_option'?: string;
    /**
     * 
     * @type {string}
     * @memberof SplitTreatment
     */
    'com_pod__reverse_factor'?: string;
    /**
     * 
     * @type {string}
     * @memberof SplitTreatment
     */
    'fire_pod__cashback_rewards'?: string;
    /**
     * 
     * @type {string}
     * @memberof SplitTreatment
     */
    'traceability_pod__credential_encryption'?: string;
    /**
     * 
     * @type {string}
     * @memberof SplitTreatment
     */
    'custom_menus__edit_product_redirect'?: string;
    /**
     * 
     * @type {string}
     * @memberof SplitTreatment
     */
    'spliff_pod__collab_notification'?: string;
    /**
     * 
     * @type {string}
     * @memberof SplitTreatment
     */
    'fire_pod__delinquent_lockdown'?: string;
    /**
     * 
     * @type {string}
     * @memberof SplitTreatment
     */
    'fire_pod__direct_pay_auto_authorization'?: string;
    /**
     * 
     * @type {string}
     * @memberof SplitTreatment
     */
    'fire_pod__direct_pay_enabled_states'?: string;
    /**
     * 
     * @type {string}
     * @memberof SplitTreatment
     */
    'fire_pod__post_settings'?: string;
    /**
     * 
     * @type {string}
     * @memberof SplitTreatment
     */
    'logistics_pod__enable_customers_to_select_transport_partner'?: string;
    /**
     * 
     * @type {string}
     * @memberof SplitTreatment
     */
    'enable_logistics_permission_to_all_users'?: string;
    /**
     * 
     * @type {string}
     * @memberof SplitTreatment
     */
    'plat_arch_pod__oso_cloud'?: string;
    /**
     * 
     * @type {string}
     * @memberof SplitTreatment
     */
    'acct_man_pod__enrollment_nue_integration'?: string;
    /**
     * 
     * @type {string}
     * @memberof SplitTreatment
     */
    'enterprise_pod__mult_payment_methods'?: string;
    /**
     * 
     * @type {string}
     * @memberof SplitTreatment
     */
    'enterprise_pod__order_fees'?: string;
    /**
     * 
     * @type {string}
     * @memberof SplitTreatment
     */
    'force_segment_reporting'?: string;
    /**
     * 
     * @type {string}
     * @memberof SplitTreatment
     */
    'ret_pod__order_minimum'?: string;
    /**
     * 
     * @type {string}
     * @memberof SplitTreatment
     */
    'inbound_shipments_create'?: string;
    /**
     * 
     * @type {string}
     * @memberof SplitTreatment
     */
    'traceability_pod__integration_settings'?: string;
    /**
     * 
     * @type {string}
     * @memberof SplitTreatment
     */
    'npr_pod__integrations_seller'?: string;
    /**
     * 
     * @type {string}
     * @memberof SplitTreatment
     */
    'orders_internal_approvals'?: string;
    /**
     * 
     * @type {string}
     * @memberof SplitTreatment
     */
    'inventory_pod__inventory_batch_support'?: string;
    /**
     * 
     * @type {string}
     * @memberof SplitTreatment
     */
    'inventory_negative_available_quantity_logging'?: string;
    /**
     * 
     * @type {string}
     * @memberof SplitTreatment
     */
    'inventory_pod__inventory_warehouse_support'?: string;
    /**
     * 
     * @type {string}
     * @memberof SplitTreatment
     */
    'ogk_pod__knock_notifications'?: string;
    /**
     * 
     * @type {string}
     * @memberof SplitTreatment
     */
    'knock_notifications_toaster'?: string;
    /**
     * 
     * @type {string}
     * @memberof SplitTreatment
     */
    'llm_leaflink_plus_enrollment_billing'?: string;
    /**
     * 
     * @type {string}
     * @memberof SplitTreatment
     */
    'llm_leaflink_plus_enrollment_updates'?: string;
    /**
     * 
     * @type {string}
     * @memberof SplitTreatment
     */
    'inventory_pod__listings_allocations'?: string;
    /**
     * 
     * @type {string}
     * @memberof SplitTreatment
     */
    'live_inventory_indicator'?: string;
    /**
     * 
     * @type {string}
     * @memberof SplitTreatment
     */
    'manage_license__add_integration__buyer'?: string;
    /**
     * 
     * @type {string}
     * @memberof SplitTreatment
     */
    'messaging_notifications'?: string;
    /**
     * 
     * @type {string}
     * @memberof SplitTreatment
     */
    'oms_data_sync_events'?: string;
    /**
     * 
     * @type {string}
     * @memberof SplitTreatment
     */
    'oms_historical_data_sync'?: string;
    /**
     * 
     * @type {string}
     * @memberof SplitTreatment
     */
    'oms_product_sync_events'?: string;
    /**
     * 
     * @type {string}
     * @memberof SplitTreatment
     */
    'fire_pod__order_adjustments_event_consumer'?: string;
    /**
     * 
     * @type {string}
     * @memberof SplitTreatment
     */
    'order_latency'?: string;
    /**
     * 
     * @type {string}
     * @memberof SplitTreatment
     */
    'int_pod__order_pdf_report'?: string;
    /**
     * 
     * @type {string}
     * @memberof SplitTreatment
     */
    'order_summary_ancillary_enhancements'?: string;
    /**
     * 
     * @type {string}
     * @memberof SplitTreatment
     */
    'gro_pod__order_summary_invitations'?: string;
    /**
     * 
     * @type {string}
     * @memberof SplitTreatment
     */
    'order_summary_receipt_log'?: string;
    /**
     * 
     * @type {string}
     * @memberof SplitTreatment
     */
    'orders_received_dataview'?: string;
    /**
     * 
     * @type {string}
     * @memberof SplitTreatment
     */
    'ads_product_recommendation_organic_recommendations'?: string;
    /**
     * 
     * @type {string}
     * @memberof SplitTreatment
     */
    'pause_inactive_license_companies'?: string;
    /**
     * 
     * @type {string}
     * @memberof SplitTreatment
     */
    'payment_on_sell_through__enrollment'?: string;
    /**
     * 
     * @type {string}
     * @memberof SplitTreatment
     */
    'cop_pod__payments_exploration_dashboard_widget'?: string;
    /**
     * 
     * @type {string}
     * @memberof SplitTreatment
     */
    'collab_pod__payments_in_crm'?: string;
    /**
     * 
     * @type {string}
     * @memberof SplitTreatment
     */
    'shop_brands_performance_improvement'?: string;
    /**
     * 
     * @type {string}
     * @memberof SplitTreatment
     */
    'acct_man_pod__plans_and_billing'?: string;
    /**
     * 
     * @type {string}
     * @memberof SplitTreatment
     */
    'acct_man_pod__plan_price'?: string;
    /**
     * 
     * @type {string}
     * @memberof SplitTreatment
     */
    'ads_platform_promotion_automation'?: string;
    /**
     * 
     * @type {string}
     * @memberof SplitTreatment
     */
    'post_allow_remove_post_flag_from_order'?: string;
    /**
     * 
     * @type {string}
     * @memberof SplitTreatment
     */
    'post_automated_payments__calculation'?: string;
    /**
     * 
     * @type {string}
     * @memberof SplitTreatment
     */
    'fire_pod__enable_post_weekly_sum_view'?: string;
    /**
     * 
     * @type {string}
     * @memberof SplitTreatment
     */
    'post_order_preagreement_settings'?: string;
    /**
     * 
     * @type {string}
     * @memberof SplitTreatment
     */
    'fire_pod__post_package_services'?: string;
    /**
     * 
     * @type {string}
     * @memberof SplitTreatment
     */
    'post__sign_terms_and_conditions_for_all_staff_users'?: string;
    /**
     * 
     * @type {string}
     * @memberof SplitTreatment
     */
    'post_sts_unit_conversion'?: string;
    /**
     * 
     * @type {string}
     * @memberof SplitTreatment
     */
    'gro_pod__printed_menu'?: string;
    /**
     * 
     * @type {string}
     * @memberof SplitTreatment
     */
    'inventory_pod__new_product_list_page'?: string;
    /**
     * 
     * @type {string}
     * @memberof SplitTreatment
     */
    'collab_pod__promo_code_display'?: string;
    /**
     * 
     * @type {string}
     * @memberof SplitTreatment
     */
    'replenishment_catalog_page'?: string;
    /**
     * 
     * @type {string}
     * @memberof SplitTreatment
     */
    'retail_category_management_self_service'?: string;
    /**
     * 
     * @type {string}
     * @memberof SplitTreatment
     */
    'retail_product_leaderboard_negotiate'?: string;
    /**
     * 
     * @type {string}
     * @memberof SplitTreatment
     */
    'seed_to_sale_coa_download'?: string;
    /**
     * 
     * @type {string}
     * @memberof SplitTreatment
     */
    'traceability_pod__experiment__reconcile_inventory'?: string;
    /**
     * 
     * @type {string}
     * @memberof SplitTreatment
     */
    'seed_to_sale__transfer_template'?: string;
    /**
     * 
     * @type {string}
     * @memberof SplitTreatment
     */
    'trace_pod__s2s_transfers'?: string;
    /**
     * 
     * @type {string}
     * @memberof SplitTreatment
     */
    'traceability__biotrack_seller_transfers_page'?: string;
    /**
     * 
     * @type {string}
     * @memberof SplitTreatment
     */
    'eapps_sage_enabled'?: string;
    /**
     * 
     * @type {string}
     * @memberof SplitTreatment
     */
    'collab_pod__sales_rep_email_actions'?: string;
    /**
     * 
     * @type {string}
     * @memberof SplitTreatment
     */
    'trace_pod__search_by_assigned_packages'?: string;
    /**
     * 
     * @type {string}
     * @memberof SplitTreatment
     */
    'seed_to_sale__buyer_nav'?: string;
    /**
     * 
     * @type {string}
     * @memberof SplitTreatment
     */
    'traceability__biotrack_seller_attach_manifest'?: string;
    /**
     * 
     * @type {string}
     * @memberof SplitTreatment
     */
    'llm_sigma_gpo_report'?: string;
    /**
     * 
     * @type {string}
     * @memberof SplitTreatment
     */
    'llm_gpo_seller_report_v2'?: string;
    /**
     * 
     * @type {string}
     * @memberof SplitTreatment
     */
    'manage_licenses__new_metrc_flow'?: string;
    /**
     * 
     * @type {string}
     * @memberof SplitTreatment
     */
    'acct_pod__seller_order_summary'?: string;
    /**
     * 
     * @type {string}
     * @memberof SplitTreatment
     */
    'seller_settings_vue'?: string;
    /**
     * 
     * @type {string}
     * @memberof SplitTreatment
     */
    'ads_serve_algolia_recommendations'?: string;
    /**
     * 
     * @type {string}
     * @memberof SplitTreatment
     */
    'settings__buyer_account_details'?: string;
    /**
     * 
     * @type {string}
     * @memberof SplitTreatment
     */
    'settings__tax_schedules'?: string;
    /**
     * 
     * @type {string}
     * @memberof SplitTreatment
     */
    'shipping_request_delivery_modal'?: string;
    /**
     * 
     * @type {string}
     * @memberof SplitTreatment
     */
    'show_sell_through_for_non_post'?: string;
    /**
     * 
     * @type {string}
     * @memberof SplitTreatment
     */
    'sips_pod__mp_license_service_api'?: string;
    /**
     * 
     * @type {string}
     * @memberof SplitTreatment
     */
    'ssr_iframe'?: string;
    /**
     * 
     * @type {string}
     * @memberof SplitTreatment
     */
    'logistics_pod__submit_order_via_csv_upload'?: string;
    /**
     * 
     * @type {string}
     * @memberof SplitTreatment
     */
    'supply_chain_delivered_status'?: string;
    /**
     * 
     * @type {string}
     * @memberof SplitTreatment
     */
    'switch_customer_for_cloned_orders'?: string;
    /**
     * 
     * @type {string}
     * @memberof SplitTreatment
     */
    'cop_pod__terms_and_conditions'?: string;
    /**
     * 
     * @type {string}
     * @memberof SplitTreatment
     */
    'transport_pod__shipping_set_order_payments'?: string;
    /**
     * 
     * @type {string}
     * @memberof SplitTreatment
     */
    'transport_pod__ma_next_day_delivery'?: string;
    /**
     * 
     * @type {string}
     * @memberof SplitTreatment
     */
    'plat_arch_pod__unified_hijacking'?: string;
    /**
     * 
     * @type {string}
     * @memberof SplitTreatment
     */
    'ads_kevel_buyer_seller_dash'?: string;
    /**
     * 
     * @type {string}
     * @memberof SplitTreatment
     */
    'ads_moloco_shop_brands_sidebar_banners'?: string;
    /**
     * 
     * @type {string}
     * @memberof SplitTreatment
     */
    'ads_moloco_shop_brands_featured_brands'?: string;
    /**
     * 
     * @type {string}
     * @memberof SplitTreatment
     */
    'com_pod__vendor_menu'?: string;
    /**
     * 
     * @type {string}
     * @memberof SplitTreatment
     */
    'gro_pod__vendor_menu_ui_enhancement'?: string;
    /**
     * 
     * @type {string}
     * @memberof SplitTreatment
     */
    'vue_buyer_notification_settings'?: string;
    /**
     * 
     * @type {string}
     * @memberof SplitTreatment
     */
    'vue_inventory_bulk_price_update'?: string;
    /**
     * 
     * @type {string}
     * @memberof SplitTreatment
     */
    'vue_inventory_product_add_edit_page'?: string;
    /**
     * 
     * @type {string}
     * @memberof SplitTreatment
     */
    'vue_inventory_product_line_page'?: string;
    /**
     * 
     * @type {string}
     * @memberof SplitTreatment
     */
    'vue_messages_page'?: string;
    /**
     * 
     * @type {string}
     * @memberof SplitTreatment
     */
    'llm_vue_seller_reports'?: string;
    /**
     * 
     * @type {string}
     * @memberof SplitTreatment
     */
    'vue_settings_brands_page'?: string;
    /**
     * 
     * @type {string}
     * @memberof SplitTreatment
     */
    'cret_pod__vueified_company_profile'?: string;
    /**
     * 
     * @type {string}
     * @memberof SplitTreatment
     */
    'llm_buyers_club_rollout'?: string;
    /**
     * 
     * @type {string}
     * @memberof SplitTreatment
     */
    'fire_pod__enable_post_cascade'?: string;
    /**
     * 
     * @type {string}
     * @memberof SplitTreatment
     */
    'fire_pod__seller_global_post_settings'?: string;
}
/**
 * Serializer for ll.ads.data_models.Sponsorship
 * @export
 * @interface Sponsorship
 */
export interface Sponsorship {
    /**
     * 
     * @type {number}
     * @memberof Sponsorship
     */
    'rank': number;
    /**
     * 
     * @type {string}
     * @memberof Sponsorship
     */
    'provider_id': string;
    /**
     * 
     * @type {string}
     * @memberof Sponsorship
     */
    'ad_id': string;
    /**
     * 
     * @type {string}
     * @memberof Sponsorship
     */
    'campaign_id': string;
    /**
     * 
     * @type {string}
     * @memberof Sponsorship
     */
    'target_url': string;
    /**
     * 
     * @type {string}
     * @memberof Sponsorship
     */
    'click_url': string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof Sponsorship
     */
    'creative': { [key: string]: any; };
    /**
     * 
     * @type {string}
     * @memberof Sponsorship
     */
    'impression_url': string;
    /**
     * 
     * @type {Array<SponsorshipItem>}
     * @memberof Sponsorship
     */
    'items': Array<SponsorshipItem>;
    /**
     * 
     * @type {string}
     * @memberof Sponsorship
     */
    'page_load_id': string;
    /**
     * 
     * @type {AdPlacement}
     * @memberof Sponsorship
     */
    'placement': AdPlacement;
    /**
     * 
     * @type {number}
     * @memberof Sponsorship
     */
    'target_company_id': number;
    /**
     * 
     * @type {number}
     * @memberof Sponsorship
     */
    'target_user_id': number;
    /**
     * 
     * @type {string}
     * @memberof Sponsorship
     */
    'target_resource_id': string;
    /**
     * 
     * @type {string}
     * @memberof Sponsorship
     */
    'target_resource_name': string;
}
/**
 * Serializer for an individual sponsorship result.
 * @export
 * @interface SponsorshipContent
 */
export interface SponsorshipContent {
    /**
     * 
     * @type {Sponsorship}
     * @memberof SponsorshipContent
     */
    'sponsorship': Sponsorship;
}
/**
 * Serializer for ll.ads.data_models.SponsorshipItem
 * @export
 * @interface SponsorshipItem
 */
export interface SponsorshipItem {
    /**
     * 
     * @type {string}
     * @memberof SponsorshipItem
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SponsorshipItem
     */
    'impression_url': string;
    /**
     * 
     * @type {string}
     * @memberof SponsorshipItem
     */
    'click_url': string;
}
/**
 * Serializer for sponsorship content.  \"sponsorships\": {     \"banners\": [         {\"sponsorship\": {}},         {\"sponsorship\": {}},         …     ],     \"listing\": [         {\"resource\": {}, \"sponsorship\": {}},         {\"resource\": {}, \"sponsorship\": {}},         …     ],     \"skyscrapers\": [         {\"brand\": {}, \"banner\": {}, \"products\": [], ...},         {\"brand\": {}, \"banner\": {}, \"products\": [], ...}     ] }
 * @export
 * @interface SponsorshipPayload
 */
export interface SponsorshipPayload {
    /**
     * 
     * @type {Array<SponsorshipContent>}
     * @memberof SponsorshipPayload
     */
    'banners': Array<SponsorshipContent>;
    /**
     * 
     * @type {Array<SponsorshipResource>}
     * @memberof SponsorshipPayload
     */
    'listing': Array<SponsorshipResource>;
    /**
     * 
     * @type {Array<SkyscraperSponsorshipContent>}
     * @memberof SponsorshipPayload
     */
    'skyscrapers': Array<SkyscraperSponsorshipContent>;
}
/**
 * Serializer for an individual sponsorship with Brand details.
 * @export
 * @interface SponsorshipResource
 */
export interface SponsorshipResource {
    /**
     * 
     * @type {Sponsorship}
     * @memberof SponsorshipResource
     */
    'sponsorship': Sponsorship;
    /**
     * 
     * @type {BrandResource}
     * @memberof SponsorshipResource
     */
    'resource': BrandResource;
}
/**
 * 
 * @export
 * @interface SponsorshipsContent
 */
export interface SponsorshipsContent {
    /**
     * 
     * @type {SponsorshipPayload}
     * @memberof SponsorshipsContent
     */
    'sponsorships': SponsorshipPayload;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const SpotlightBadgesEnum = {
    Deal: 'deal',
    New: 'new',
    Sponsored: 'sponsored'
} as const;

export type SpotlightBadgesEnum = typeof SpotlightBadgesEnum[keyof typeof SpotlightBadgesEnum];


/**
 * State Serializer
 * @export
 * @interface State
 */
export interface State {
    /**
     * 
     * @type {string}
     * @memberof State
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof State
     */
    'name': string;
}
/**
 * Serializer for State models via the internal API
 * @export
 * @interface StateRequest
 */
export interface StateRequest {
    /**
     * 
     * @type {string}
     * @memberof StateRequest
     */
    'abbr': string;
    /**
     * 
     * @type {string}
     * @memberof StateRequest
     */
    'name': string;
    /**
     * 
     * @type {CountryRequest}
     * @memberof StateRequest
     */
    'country': CountryRequest;
}
/**
 * Serializer for State models via the internal API
 * @export
 * @interface StateUnifiedUpstreamMarketplace
 */
export interface StateUnifiedUpstreamMarketplace {
    /**
     * 
     * @type {number}
     * @memberof StateUnifiedUpstreamMarketplace
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof StateUnifiedUpstreamMarketplace
     */
    'abbr': string;
    /**
     * 
     * @type {string}
     * @memberof StateUnifiedUpstreamMarketplace
     */
    'name': string;
    /**
     * 
     * @type {Country}
     * @memberof StateUnifiedUpstreamMarketplace
     */
    'country': Country;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const StatusBcfEnum = {
    InProgress: 'in_progress',
    Completed: 'completed'
} as const;

export type StatusBcfEnum = typeof StatusBcfEnum[keyof typeof StatusBcfEnum];


/**
 * 
 * @export
 * @enum {string}
 */

export const StatusEnum = {
    NotOnboarded: 'not_onboarded',
    Onboarded: 'onboarded',
    Paused: 'paused',
    Offboarded: 'offboarded'
} as const;

export type StatusEnum = typeof StatusEnum[keyof typeof StatusEnum];


/**
 * 
 * @export
 * @enum {string}
 */

export const StrainClassificationEnum = {
    Sativa: 'sativa',
    Indica: 'indica',
    Hybrid: 'hybrid',
    _11Cbd: '11-cbd',
    HighCbd: 'high-cbd',
    SativaHybrid: 'sativa-hybrid',
    IndicaHybrid: 'indica-hybrid',
    _21Cbd: '21-cbd',
    Thc: 'thc',
    Na: 'na'
} as const;

export type StrainClassificationEnum = typeof StrainClassificationEnum[keyof typeof StrainClassificationEnum];


/**
 * 
 * @export
 * @interface TemplateCreateRequest
 */
export interface TemplateCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof TemplateCreateRequest
     */
    'estimated_departure_datetime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TemplateCreateRequest
     */
    'estimated_arrival_datetime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TemplateCreateRequest
     */
    'shipment_type_name'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TemplateCreateRequest
     */
    'll_order_id'?: number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof TemplateCreateRequest
     */
    'package_labels'?: Array<string> | null;
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof TemplateCreateRequest
     */
    'packages'?: { [key: string]: Array<string>; } | null;
    /**
     * 
     * @type {number}
     * @memberof TemplateCreateRequest
     */
    'driver_id'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TemplateCreateRequest
     */
    'vehicle_id'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TemplateCreateRequest
     */
    'turn_by_turn_directions'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TemplateCreateRequest
     */
    'license_number'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TemplateCreateRequest
     */
    'destination_company_id': number | null;
    /**
     * 
     * @type {string}
     * @memberof TemplateCreateRequest
     */
    'destination_license_number'?: string | null;
}
/**
 * 
 * @export
 * @interface TemplateWriteSuccessResponse
 */
export interface TemplateWriteSuccessResponse {
    /**
     * 
     * @type {number}
     * @memberof TemplateWriteSuccessResponse
     */
    'template_id': number;
}
/**
 * 
 * @export
 * @interface Threshold
 */
export interface Threshold {
    /**
     * When Product inventory reaches below this value, take various actions
     * @type {number}
     * @memberof Threshold
     */
    'regular_value'?: number | null;
    /**
     * 
     * @type {RegularActionEnum}
     * @memberof Threshold
     */
    'regular_action'?: RegularActionEnum | null;
    /**
     * When Product inventory reaches above this value, take various actions
     * @type {number}
     * @memberof Threshold
     */
    'reverse_value'?: number | null;
    /**
     * 
     * @type {ReverseActionEnum}
     * @memberof Threshold
     */
    'reverse_action'?: ReverseActionEnum | null;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const ThresholdActionEnum = {
    Default: 'default',
    Backorder: 'backorder',
    Unavailable: 'unavailable',
    Internal: 'internal'
} as const;

export type ThresholdActionEnum = typeof ThresholdActionEnum[keyof typeof ThresholdActionEnum];


/**
 * 
 * @export
 * @interface ThresholdRequest
 */
export interface ThresholdRequest {
    /**
     * When Product inventory reaches below this value, take various actions
     * @type {number}
     * @memberof ThresholdRequest
     */
    'regular_value'?: number | null;
    /**
     * 
     * @type {RegularActionEnum}
     * @memberof ThresholdRequest
     */
    'regular_action'?: RegularActionEnum | null;
    /**
     * When Product inventory reaches above this value, take various actions
     * @type {number}
     * @memberof ThresholdRequest
     */
    'reverse_value'?: number | null;
    /**
     * 
     * @type {ReverseActionEnum}
     * @memberof ThresholdRequest
     */
    'reverse_action'?: ReverseActionEnum | null;
}


/**
 * 
 * @export
 * @enum {number}
 */

export const TierEnum = {
    NUMBER_1: 1,
    NUMBER_2: 2,
    NUMBER_3: 3
} as const;

export type TierEnum = typeof TierEnum[keyof typeof TierEnum];


/**
 * 
 * @export
 * @interface TraceabilityCompany
 */
export interface TraceabilityCompany {
    /**
     * 
     * @type {boolean}
     * @memberof TraceabilityCompany
     */
    'enable_seed_to_sale': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TraceabilityCompany
     */
    'enable_lab_test_result_sync': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TraceabilityCompany
     */
    'enable_transfer_manifest': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TraceabilityCompany
     */
    'enable_sales_data': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TraceabilityCompany
     */
    'enable_hide_attached_packages': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TraceabilityCompany
     */
    'enable_license_verification'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityCompany
     */
    'integration_type': string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof TraceabilityCompany
     */
    'excluded_lab_test_states': Array<string>;
    /**
     * 
     * @type {Array<TraceabilityCompanyIncludedLocation>}
     * @memberof TraceabilityCompany
     */
    'included_locations': Array<TraceabilityCompanyIncludedLocation>;
    /**
     * 
     * @type {Array<number>}
     * @memberof TraceabilityCompany
     */
    'integration_ids': Array<number>;
    /**
     * 
     * @type {Array<InternalCompanyAPIConfig>}
     * @memberof TraceabilityCompany
     */
    'api_configs': Array<InternalCompanyAPIConfig>;
}
/**
 * 
 * @export
 * @interface TraceabilityCompanyIncludedLocation
 */
export interface TraceabilityCompanyIncludedLocation {
    /**
     * 
     * @type {number}
     * @memberof TraceabilityCompanyIncludedLocation
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityCompanyIncludedLocation
     */
    'external_id': string;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityCompanyIncludedLocation
     */
    'license_number': string;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityCompanyIncludedLocation
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface TraceabilityCompanyOnboarding
 */
export interface TraceabilityCompanyOnboarding {
    /**
     * 
     * @type {string}
     * @memberof TraceabilityCompanyOnboarding
     */
    'status': string;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityCompanyOnboarding
     */
    'vendor_type': string;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityCompanyOnboarding
     */
    'external_id': string;
}
/**
 * Serializer for traceability Deliveries. Uses CommonDelivery + vendor-specific data.  Metrc will return one instance and BioTrack will have none as there is no use-case for delivery data at the time.
 * @export
 * @interface TraceabilityDelivery
 */
export interface TraceabilityDelivery {
    /**
     * 
     * @type {string}
     * @memberof TraceabilityDelivery
     */
    'company_id': string;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityDelivery
     */
    'license_number': string;
    /**
     * 
     * @type {number}
     * @memberof TraceabilityDelivery
     */
    'delivery_package_count': number;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityDelivery
     */
    'recipient_facility_license_number': string | null;
    /**
     * 
     * @type {number}
     * @memberof TraceabilityDelivery
     */
    'id'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityDelivery
     */
    'reference_id': string;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityDelivery
     */
    'transfer_external_id': string;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityDelivery
     */
    'vendor_type': string;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityDelivery
     */
    'actual_departure_datetime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityDelivery
     */
    'actual_arrival_datetime'?: string | null;
    /**
     * 
     * @type {MetrcDelivery}
     * @memberof TraceabilityDelivery
     */
    'vendor_fields': MetrcDelivery;
}
/**
 * Serializer for traceability DeliveryPackages.
 * @export
 * @interface TraceabilityDeliveryPackage
 */
export interface TraceabilityDeliveryPackage {
    /**
     * 
     * @type {number}
     * @memberof TraceabilityDeliveryPackage
     */
    'id'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityDeliveryPackage
     */
    'company_id': string;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityDeliveryPackage
     */
    'license_number': string;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityDeliveryPackage
     */
    'package_label': string;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityDeliveryPackage
     */
    'shipment_package_state': string | null;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityDeliveryPackage
     */
    'shipped_quantity': string | null;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityDeliveryPackage
     */
    'received_quantity': string | null;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityDeliveryPackage
     */
    'delivery_reference_id': string;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityDeliveryPackage
     */
    'package_external_id': string;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityDeliveryPackage
     */
    'transfer_external_id': string;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityDeliveryPackage
     */
    'vendor_type': string;
    /**
     * 
     * @type {PolymorphicDeliveryPackageVendorFields}
     * @memberof TraceabilityDeliveryPackage
     */
    'vendor_fields': PolymorphicDeliveryPackageVendorFields;
}
/**
 * 
 * @export
 * @interface TraceabilityDriver
 */
export interface TraceabilityDriver {
    /**
     * 
     * @type {number}
     * @memberof TraceabilityDriver
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof TraceabilityDriver
     */
    'company_id': number;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityDriver
     */
    'external_id': string;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityDriver
     */
    'vendor_type': string;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityDriver
     */
    'license_number': string;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityDriver
     */
    'resource_type': string;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityDriver
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityDriver
     */
    'drivers_license_number': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TraceabilityDriver
     */
    'is_active': boolean;
    /**
     * 
     * @type {PolymorphicDriverVendorFields}
     * @memberof TraceabilityDriver
     */
    'vendor_fields': PolymorphicDriverVendorFields;
}
/**
 * 
 * @export
 * @interface TraceabilityDriverCreateUpdateInputRequest
 */
export interface TraceabilityDriverCreateUpdateInputRequest {
    /**
     * 
     * @type {string}
     * @memberof TraceabilityDriverCreateUpdateInputRequest
     */
    'drivers_license_number': string | null;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityDriverCreateUpdateInputRequest
     */
    'birth_date': string;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityDriverCreateUpdateInputRequest
     */
    'hire_date': string;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityDriverCreateUpdateInputRequest
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityDriverCreateUpdateInputRequest
     */
    'state_issued': string | null;
}
/**
 * 
 * @export
 * @interface TraceabilityItem
 */
export interface TraceabilityItem {
    /**
     * 
     * @type {number}
     * @memberof TraceabilityItem
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof TraceabilityItem
     */
    'metrc_id': number;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityItem
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityItem
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityItem
     */
    'ingredients': string;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityItem
     */
    'category_name': string;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityItem
     */
    'category_type': string;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityItem
     */
    'quantity_type': string;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityItem
     */
    'unit_of_measure_name': string;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityItem
     */
    'serving_size': string;
    /**
     * 
     * @type {boolean}
     * @memberof TraceabilityItem
     */
    'used': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TraceabilityItem
     */
    'imported_from_package': boolean | null;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityItem
     */
    'strain_name': string | null;
    /**
     * 
     * @type {TraceabilityStrain}
     * @memberof TraceabilityItem
     */
    'strain': TraceabilityStrain | null;
    /**
     * 
     * @type {number}
     * @memberof TraceabilityItem
     */
    'metrc_strain_id': number | null;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityItem
     */
    'doses': string | null;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityItem
     */
    'unit_cbd_percent': string | null;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityItem
     */
    'unit_cbd_content': string | null;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityItem
     */
    'unit_cbd_content_unit_of_measure_name': string | null;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityItem
     */
    'unit_thc_percent': string | null;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityItem
     */
    'unit_thc_content': string | null;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityItem
     */
    'unit_thc_content_unit_of_measure_name': string | null;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityItem
     */
    'unit_volume': string | null;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityItem
     */
    'unit_volume_unit_of_measure_name': string | null;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityItem
     */
    'unit_weight': string | null;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityItem
     */
    'unit_weight_unit_of_measure_name': string | null;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityItem
     */
    'unit_quantity': string | null;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityItem
     */
    'unit_quantity_unit_of_measure_name': string | null;
}
/**
 * 
 * @export
 * @interface TraceabilityLicense
 */
export interface TraceabilityLicense {
    /**
     * 
     * @type {string}
     * @memberof TraceabilityLicense
     */
    'number': string;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityLicense
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityLicense
     */
    'start_date': string;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityLicense
     */
    'end_date': string;
}
/**
 * 
 * @export
 * @interface TraceabilityLicenses
 */
export interface TraceabilityLicenses {
    /**
     * 
     * @type {Array<string>}
     * @memberof TraceabilityLicenses
     */
    'errors': Array<string>;
    /**
     * 
     * @type {Array<TraceabilityLicense>}
     * @memberof TraceabilityLicenses
     */
    'licenses': Array<TraceabilityLicense>;
}
/**
 * Location object from the Traceability.common_location and Traceability.(vendor)_location tables.
 * @export
 * @interface TraceabilityLocation
 */
export interface TraceabilityLocation {
    /**
     * ID of the location in the Traceability Service
     * @type {number}
     * @memberof TraceabilityLocation
     */
    'id': number;
    /**
     * ID of the company in the Traceability Service
     * @type {number}
     * @memberof TraceabilityLocation
     */
    'company_id': number;
    /**
     * ID of the location in the vendor\'s system
     * @type {string}
     * @memberof TraceabilityLocation
     */
    'external_id': string;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityLocation
     */
    'vendor_type': string;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityLocation
     */
    'label': string;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityLocation
     */
    'license_number': string;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityLocation
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityLocation
     */
    'status': string;
    /**
     * 
     * @type {boolean}
     * @memberof TraceabilityLocation
     */
    'is_excluded'?: boolean;
    /**
     * 
     * @type {MetrcLocation}
     * @memberof TraceabilityLocation
     */
    'vendor_fields': MetrcLocation;
}
/**
 * 
 * @export
 * @interface TraceabilityOrder
 */
export interface TraceabilityOrder {
    /**
     * 
     * @type {string}
     * @memberof TraceabilityOrder
     */
    'order_number': string;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityOrder
     */
    'order_seller_number': string;
    /**
     * 
     * @type {LightCompany}
     * @memberof TraceabilityOrder
     */
    'seller': LightCompany;
}
/**
 * Traceability package fields from the Traceability.common_package and Traceability.metrc_package tables.
 * @export
 * @interface TraceabilityPackage
 */
export interface TraceabilityPackage {
    /**
     * ID of the package in the Traceability Service
     * @type {number}
     * @memberof TraceabilityPackage
     */
    'id': number;
    /**
     * ID of the package in the vendor\'s system
     * @type {string}
     * @memberof TraceabilityPackage
     */
    'external_id': string;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityPackage
     */
    'label': string;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityPackage
     */
    'license_number': string;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityPackage
     */
    'status': string;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityPackage
     */
    'quantity': string | null;
    /**
     * Name of vendor\'s system (Biotrack, Metrc, ...
     * @type {string}
     * @memberof TraceabilityPackage
     */
    'vendor_type': string;
    /**
     * 
     * @type {MetrcPackage}
     * @memberof TraceabilityPackage
     */
    'vendor_fields': MetrcPackage;
    /**
     * 
     * @type {number}
     * @memberof TraceabilityPackage
     */
    'location_id': number;
    /**
     * 
     * @type {TraceabilityLocation}
     * @memberof TraceabilityPackage
     */
    'location': TraceabilityLocation;
    /**
     * 
     * @type {boolean}
     * @memberof TraceabilityPackage
     */
    'in_transit': boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof TraceabilityPackage
     */
    'is_testing_sample': boolean | null;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityPackage
     */
    'lab_test_unit_of_measure': string | null;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityPackage
     */
    'lab_testing_status': string | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof TraceabilityPackage
     */
    'll_product_ids': Array<number>;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityPackage
     */
    'result_cbd': string;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityPackage
     */
    'result_cbda': string;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityPackage
     */
    'result_thc': string;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityPackage
     */
    'result_thca': string;
}
/**
 * 
 * @export
 * @interface TraceabilityRefreshRequest
 */
export interface TraceabilityRefreshRequest {
    /**
     * 
     * @type {string}
     * @memberof TraceabilityRefreshRequest
     */
    'created_at': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof TraceabilityRefreshRequest
     */
    'errors': Array<string>;
    /**
     * 
     * @type {number}
     * @memberof TraceabilityRefreshRequest
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityRefreshRequest
     */
    'refresh_type': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof TraceabilityRefreshRequest
     */
    'resource_types': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityRefreshRequest
     */
    'status': string;
}
/**
 * 
 * @export
 * @interface TraceabilityStrain
 */
export interface TraceabilityStrain {
    /**
     * 
     * @type {number}
     * @memberof TraceabilityStrain
     */
    'company_id': number;
    /**
     * 
     * @type {number}
     * @memberof TraceabilityStrain
     */
    'metrc_id': number;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityStrain
     */
    'license_number': string;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityStrain
     */
    'name': string;
    /**
     * 
     * @type {boolean}
     * @memberof TraceabilityStrain
     */
    'is_active': boolean;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityStrain
     */
    'indica_percentage': string;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityStrain
     */
    'sativa_percentage': string;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityStrain
     */
    'thc_level': string | null;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityStrain
     */
    'cbd_level': string | null;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityStrain
     */
    'testing_status': string | null;
}
/**
 * 
 * @export
 * @interface TraceabilityTemplate
 */
export interface TraceabilityTemplate {
    /**
     * 
     * @type {string}
     * @memberof TraceabilityTemplate
     */
    'actual_arrival_datetime': string | null;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityTemplate
     */
    'actual_departure_datetime': string | null;
    /**
     * 
     * @type {number}
     * @memberof TraceabilityTemplate
     */
    'company_id': number;
    /**
     * 
     * @type {number}
     * @memberof TraceabilityTemplate
     */
    'delivery_count': number;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityTemplate
     */
    'estimated_arrival_datetime': string | null;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityTemplate
     */
    'estimated_departure_datetime': string | null;
    /**
     * 
     * @type {number}
     * @memberof TraceabilityTemplate
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityTemplate
     */
    'last_modified_datetime': string | null;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityTemplate
     */
    'license_number': string;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityTemplate
     */
    'manifest_number': string;
    /**
     * 
     * @type {number}
     * @memberof TraceabilityTemplate
     */
    'metrc_delivery_id': number;
    /**
     * 
     * @type {number}
     * @memberof TraceabilityTemplate
     */
    'metrc_id': number;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityTemplate
     */
    'name': string | null;
    /**
     * 
     * @type {number}
     * @memberof TraceabilityTemplate
     */
    'package_count': number;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityTemplate
     */
    'received_datetime': string | null;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityTemplate
     */
    'recipient_facility_license_number': string | null;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityTemplate
     */
    'recipient_facility_name': string | null;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityTemplate
     */
    'shipment_license_type': string | null;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityTemplate
     */
    'shipment_transaction_type': string | null;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityTemplate
     */
    'shipment_type_name': string | null;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityTemplate
     */
    'shipper_facility_license_number': string;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityTemplate
     */
    'shipper_facility_name': string;
    /**
     * 
     * @type {TraceabilityDriver}
     * @memberof TraceabilityTemplate
     */
    'driver'?: TraceabilityDriver | null;
    /**
     * 
     * @type {TraceabilityVehicle}
     * @memberof TraceabilityTemplate
     */
    'vehicle'?: TraceabilityVehicle | null;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityTemplate
     */
    'turn_by_turn_directions'?: string | null;
}
/**
 * 
 * @export
 * @interface TraceabilityTemplateDetail
 */
export interface TraceabilityTemplateDetail {
    /**
     * 
     * @type {string}
     * @memberof TraceabilityTemplateDetail
     */
    'actual_arrival_datetime': string | null;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityTemplateDetail
     */
    'actual_departure_datetime': string | null;
    /**
     * 
     * @type {number}
     * @memberof TraceabilityTemplateDetail
     */
    'company_id': number;
    /**
     * 
     * @type {number}
     * @memberof TraceabilityTemplateDetail
     */
    'delivery_count': number;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityTemplateDetail
     */
    'estimated_arrival_datetime': string | null;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityTemplateDetail
     */
    'estimated_departure_datetime': string | null;
    /**
     * 
     * @type {number}
     * @memberof TraceabilityTemplateDetail
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityTemplateDetail
     */
    'last_modified_datetime': string | null;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityTemplateDetail
     */
    'license_number': string;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityTemplateDetail
     */
    'manifest_number': string;
    /**
     * 
     * @type {number}
     * @memberof TraceabilityTemplateDetail
     */
    'metrc_delivery_id': number;
    /**
     * 
     * @type {number}
     * @memberof TraceabilityTemplateDetail
     */
    'metrc_id': number;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityTemplateDetail
     */
    'name': string | null;
    /**
     * 
     * @type {number}
     * @memberof TraceabilityTemplateDetail
     */
    'package_count': number;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityTemplateDetail
     */
    'received_datetime': string | null;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityTemplateDetail
     */
    'recipient_facility_license_number': string | null;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityTemplateDetail
     */
    'recipient_facility_name': string | null;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityTemplateDetail
     */
    'shipment_license_type': string | null;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityTemplateDetail
     */
    'shipment_transaction_type': string | null;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityTemplateDetail
     */
    'shipment_type_name': string | null;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityTemplateDetail
     */
    'shipper_facility_license_number': string;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityTemplateDetail
     */
    'shipper_facility_name': string;
    /**
     * 
     * @type {TraceabilityDriver}
     * @memberof TraceabilityTemplateDetail
     */
    'driver': TraceabilityDriver | null;
    /**
     * 
     * @type {TraceabilityVehicle}
     * @memberof TraceabilityTemplateDetail
     */
    'vehicle': TraceabilityVehicle | null;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityTemplateDetail
     */
    'turn_by_turn_directions': string | null;
}
/**
 * Serializer for traceability transfers. Composed of CommonTransfer + vendor-specific transfer data.
 * @export
 * @interface TraceabilityTransfer
 */
export interface TraceabilityTransfer {
    /**
     * 
     * @type {number}
     * @memberof TraceabilityTransfer
     */
    'id'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityTransfer
     */
    'company_id': string;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityTransfer
     */
    'license_number': string;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityTransfer
     */
    'manifest_number': string;
    /**
     * 
     * @type {number}
     * @memberof TraceabilityTransfer
     */
    'package_count': number;
    /**
     * 
     * @type {number}
     * @memberof TraceabilityTransfer
     */
    'delivery_count': number;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityTransfer
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityTransfer
     */
    'status': string;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityTransfer
     */
    'shipper_facility_license_number'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityTransfer
     */
    'shipper_facility_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityTransfer
     */
    'recipient_facility_license_number'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityTransfer
     */
    'actual_departure_datetime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityTransfer
     */
    'actual_arrival_datetime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityTransfer
     */
    'last_modified_datetime'?: string | null;
    /**
     * 
     * @type {Array<TraceabilityOrder>}
     * @memberof TraceabilityTransfer
     */
    'orders'?: Array<TraceabilityOrder>;
    /**
     * 
     * @type {TraceabilityTransferBuyer}
     * @memberof TraceabilityTransfer
     */
    'buyer': TraceabilityTransferBuyer | null;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityTransfer
     */
    'resource_type': string;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityTransfer
     */
    'external_id': string;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityTransfer
     */
    'vendor_type': string;
    /**
     * 
     * @type {PolymorphicTransferVendorFields}
     * @memberof TraceabilityTransfer
     */
    'vendor_fields': PolymorphicTransferVendorFields;
    /**
     * 
     * @type {Array<TraceabilityDelivery>}
     * @memberof TraceabilityTransfer
     */
    'deliveries': Array<TraceabilityDelivery>;
    /**
     * 
     * @type {Array<TraceabilityDeliveryPackage>}
     * @memberof TraceabilityTransfer
     */
    'delivery_packages': Array<TraceabilityDeliveryPackage>;
}
/**
 * 
 * @export
 * @interface TraceabilityTransferBuyer
 */
export interface TraceabilityTransferBuyer {
    /**
     * Name of Company (Note this is not the same as Brand)
     * @type {string}
     * @memberof TraceabilityTransferBuyer
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface TraceabilityVehicle
 */
export interface TraceabilityVehicle {
    /**
     * 
     * @type {number}
     * @memberof TraceabilityVehicle
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof TraceabilityVehicle
     */
    'company_id': number;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityVehicle
     */
    'external_id': string;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityVehicle
     */
    'vendor_type': string;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityVehicle
     */
    'license_number': string;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityVehicle
     */
    'resource_type': string;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityVehicle
     */
    'make': string;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityVehicle
     */
    'model': string;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityVehicle
     */
    'license_plate_number': string;
    /**
     * 
     * @type {boolean}
     * @memberof TraceabilityVehicle
     */
    'is_active': boolean;
    /**
     * 
     * @type {PolymorphicVehicleVendorFields}
     * @memberof TraceabilityVehicle
     */
    'vendor_fields': PolymorphicVehicleVendorFields;
}
/**
 * 
 * @export
 * @interface TraceabilityVehicleCreateUpdateInputRequest
 */
export interface TraceabilityVehicleCreateUpdateInputRequest {
    /**
     * 
     * @type {string}
     * @memberof TraceabilityVehicleCreateUpdateInputRequest
     */
    'license_plate_number': string;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityVehicleCreateUpdateInputRequest
     */
    'make': string;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityVehicleCreateUpdateInputRequest
     */
    'model': string;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityVehicleCreateUpdateInputRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityVehicleCreateUpdateInputRequest
     */
    'color': string;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityVehicleCreateUpdateInputRequest
     */
    'vin': string;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityVehicleCreateUpdateInputRequest
     */
    'year': string;
}
/**
 * Transfer object from the Traceability.transfer table.
 * @export
 * @interface Transfer
 */
export interface Transfer {
    /**
     * 
     * @type {number}
     * @memberof Transfer
     */
    'id'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof Transfer
     */
    'company_id': string;
    /**
     * 
     * @type {string}
     * @memberof Transfer
     */
    'license_number': string;
    /**
     * 
     * @type {string}
     * @memberof Transfer
     */
    'manifest_number': string;
    /**
     * 
     * @type {number}
     * @memberof Transfer
     */
    'package_count': number;
    /**
     * 
     * @type {number}
     * @memberof Transfer
     */
    'delivery_count': number;
    /**
     * 
     * @type {string}
     * @memberof Transfer
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof Transfer
     */
    'status': string;
    /**
     * 
     * @type {string}
     * @memberof Transfer
     */
    'shipper_facility_license_number'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Transfer
     */
    'shipper_facility_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Transfer
     */
    'recipient_facility_license_number'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Transfer
     */
    'actual_departure_datetime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Transfer
     */
    'actual_arrival_datetime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Transfer
     */
    'last_modified_datetime'?: string | null;
    /**
     * 
     * @type {Array<TraceabilityOrder>}
     * @memberof Transfer
     */
    'orders'?: Array<TraceabilityOrder>;
    /**
     * 
     * @type {TraceabilityTransferBuyer}
     * @memberof Transfer
     */
    'buyer': TraceabilityTransferBuyer | null;
    /**
     * 
     * @type {string}
     * @memberof Transfer
     */
    'resource_type': string;
    /**
     * 
     * @type {number}
     * @memberof Transfer
     */
    'metrc_delivery_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof Transfer
     */
    'recipient_facility_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Transfer
     */
    'shipment_type_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Transfer
     */
    'shipment_license_type'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Transfer
     */
    'shipment_transaction_type'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Transfer
     */
    'received_datetime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Transfer
     */
    'estimated_departure_datetime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Transfer
     */
    'estimated_arrival_datetime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Transfer
     */
    'company_type': string;
    /**
     * 
     * @type {number}
     * @memberof Transfer
     */
    'metrc_id': number;
    /**
     * 
     * @type {Delivery}
     * @memberof Transfer
     */
    'delivery': Delivery | null;
    /**
     * 
     * @type {Array<DeliveryPackage>}
     * @memberof Transfer
     */
    'delivery_packages': Array<DeliveryPackage>;
}
/**
 * Name + license_number combination of a shipper or recipient from the Traceability.transfer table.
 * @export
 * @interface TransferCompany
 */
export interface TransferCompany {
    /**
     * 
     * @type {string}
     * @memberof TransferCompany
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof TransferCompany
     */
    'license_number': string;
}
/**
 * Serializer for TransportCompany model
 * @export
 * @interface TransportCompany
 */
export interface TransportCompany {
    /**
     * 
     * @type {number}
     * @memberof TransportCompany
     */
    'transport_company_id': number;
    /**
     * 
     * @type {string}
     * @memberof TransportCompany
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof TransportCompany
     */
    'medical_license_number': string;
    /**
     * 
     * @type {string}
     * @memberof TransportCompany
     */
    'adult_use_license_number': string;
    /**
     * 
     * @type {string}
     * @memberof TransportCompany
     */
    'state': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const Type7a8Enum = {
    Seller: 'seller',
    Buyer: 'buyer'
} as const;

export type Type7a8Enum = typeof Type7a8Enum[keyof typeof Type7a8Enum];


/**
 * 
 * @export
 * @enum {string}
 */

export const TypeEnum = {
    PercentageDelta: 'percentage_delta',
    Delta: 'delta',
    Absolute: 'absolute'
} as const;

export type TypeEnum = typeof TypeEnum[keyof typeof TypeEnum];


/**
 * Inherits AddressSerializer but sets the FK relation on the resource Model
 * @export
 * @interface UnifiedAddress
 */
export interface UnifiedAddress {
    /**
     * Address
     * @type {string}
     * @memberof UnifiedAddress
     */
    'address': string;
    /**
     * Unit #
     * @type {string}
     * @memberof UnifiedAddress
     */
    'unit_number'?: string;
    /**
     * City
     * @type {string}
     * @memberof UnifiedAddress
     */
    'city': string;
    /**
     * County
     * @type {string}
     * @memberof UnifiedAddress
     */
    'county'?: string;
    /**
     * 
     * @type {string}
     * @memberof UnifiedAddress
     */
    'state'?: string;
    /**
     * Zipcode
     * @type {string}
     * @memberof UnifiedAddress
     */
    'zipcode': string;
}
/**
 * Inherits AddressSerializer but sets the FK relation on the resource Model
 * @export
 * @interface UnifiedAddressRequest
 */
export interface UnifiedAddressRequest {
    /**
     * Address
     * @type {string}
     * @memberof UnifiedAddressRequest
     */
    'address': string;
    /**
     * Unit #
     * @type {string}
     * @memberof UnifiedAddressRequest
     */
    'unit_number'?: string;
    /**
     * City
     * @type {string}
     * @memberof UnifiedAddressRequest
     */
    'city': string;
    /**
     * County
     * @type {string}
     * @memberof UnifiedAddressRequest
     */
    'county'?: string;
    /**
     * 
     * @type {string}
     * @memberof UnifiedAddressRequest
     */
    'state'?: string;
    /**
     * Zipcode
     * @type {string}
     * @memberof UnifiedAddressRequest
     */
    'zipcode': string;
}
/**
 * 
 * @export
 * @interface UnifiedBrand
 */
export interface UnifiedBrand {
    /**
     * 
     * @type {number}
     * @memberof UnifiedBrand
     */
    'id': number;
    /**
     * Name of the Brand
     * @type {string}
     * @memberof UnifiedBrand
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface UnifiedBrandRequest
 */
export interface UnifiedBrandRequest {
    /**
     * Name of the Brand
     * @type {string}
     * @memberof UnifiedBrandRequest
     */
    'name': string;
}
/**
 * Unified ProductImage serializer.
 * @export
 * @interface UnifiedBuyerProductImage
 */
export interface UnifiedBuyerProductImage {
    /**
     * 
     * @type {number}
     * @memberof UnifiedBuyerProductImage
     */
    'id': number;
    /**
     * Date and time the resource was created
     * @type {string}
     * @memberof UnifiedBuyerProductImage
     */
    'created_date': string;
    /**
     * Date and time of the last edit
     * @type {string}
     * @memberof UnifiedBuyerProductImage
     */
    'modified_date': string;
    /**
     * The uploaded file, sent via multipart form data. Retrieved as a url link.
     * @type {string}
     * @memberof UnifiedBuyerProductImage
     */
    'image': string;
    /**
     * The Product this image is attached to
     * @type {number}
     * @memberof UnifiedBuyerProductImage
     */
    'product': number;
    /**
     * The position of ordering
     * @type {number}
     * @memberof UnifiedBuyerProductImage
     */
    'position'?: number | null;
}
/**
 * Unified Chats serializer
 * @export
 * @interface UnifiedChats
 */
export interface UnifiedChats {
    /**
     * 
     * @type {number}
     * @memberof UnifiedChats
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof UnifiedChats
     */
    'topic': string;
    /**
     * 
     * @type {StatusBcfEnum}
     * @memberof UnifiedChats
     */
    'status': StatusBcfEnum;
    /**
     * 
     * @type {CompanyUnifiedUpstreamMarketplace}
     * @memberof UnifiedChats
     */
    'sender_company': CompanyUnifiedUpstreamMarketplace;
    /**
     * 
     * @type {CompanyUnifiedUpstreamMarketplace}
     * @memberof UnifiedChats
     */
    'recipient_company': CompanyUnifiedUpstreamMarketplace;
    /**
     * Discussion Creator
     * @type {number}
     * @memberof UnifiedChats
     */
    'creator'?: number | null;
    /**
     * 
     * @type {Message}
     * @memberof UnifiedChats
     */
    'latest_message': Message;
}


/**
 * Unified Chats serializer
 * @export
 * @interface UnifiedChatsRequest
 */
export interface UnifiedChatsRequest {
    /**
     * 
     * @type {string}
     * @memberof UnifiedChatsRequest
     */
    'topic': string;
    /**
     * 
     * @type {CompanyRequest}
     * @memberof UnifiedChatsRequest
     */
    'sender_company': CompanyRequest;
    /**
     * 
     * @type {CompanyRequest}
     * @memberof UnifiedChatsRequest
     */
    'recipient_company': CompanyRequest;
    /**
     * Discussion Creator
     * @type {number}
     * @memberof UnifiedChatsRequest
     */
    'creator'?: number | null;
    /**
     * 
     * @type {MessageRequest}
     * @memberof UnifiedChatsRequest
     */
    'first_message': MessageRequest;
}
/**
 * Unified Product Image serializer for cloning product images.
 * @export
 * @interface UnifiedCloneProductImage
 */
export interface UnifiedCloneProductImage {
    /**
     * 
     * @type {number}
     * @memberof UnifiedCloneProductImage
     */
    'id': number;
    /**
     * Date and time the resource was created
     * @type {string}
     * @memberof UnifiedCloneProductImage
     */
    'created_date': string;
    /**
     * Date and time of the last edit
     * @type {string}
     * @memberof UnifiedCloneProductImage
     */
    'modified_date': string;
    /**
     * The uploaded file, sent via multipart form data. Retrieved as a url link.
     * @type {string}
     * @memberof UnifiedCloneProductImage
     */
    'image': string;
    /**
     * The Product this image is attached to
     * @type {number}
     * @memberof UnifiedCloneProductImage
     */
    'product': number;
    /**
     * The position of the image in the product image gallery
     * @type {number}
     * @memberof UnifiedCloneProductImage
     */
    'position': number;
    /**
     * The X position of the image crop box
     * @type {number}
     * @memberof UnifiedCloneProductImage
     */
    'crop_x'?: number | null;
    /**
     * The Y position of the image crop box
     * @type {number}
     * @memberof UnifiedCloneProductImage
     */
    'crop_y'?: number | null;
    /**
     * The width of the image crop box
     * @type {number}
     * @memberof UnifiedCloneProductImage
     */
    'crop_w'?: number | null;
    /**
     * The height of the image crop box
     * @type {number}
     * @memberof UnifiedCloneProductImage
     */
    'crop_h'?: number | null;
}
/**
 * 
 * @export
 * @interface UnifiedCompany
 */
export interface UnifiedCompany {
    /**
     * 
     * @type {number}
     * @memberof UnifiedCompany
     */
    'id': number;
    /**
     * Name of Company (Note this is not the same as Brand)
     * @type {string}
     * @memberof UnifiedCompany
     */
    'name': string;
}
/**
 * Unified serializer for the CompanyCustomerStatus model.
 * @export
 * @interface UnifiedCompanyCustomerStatus
 */
export interface UnifiedCompanyCustomerStatus {
    /**
     * 
     * @type {number}
     * @memberof UnifiedCompanyCustomerStatus
     */
    'id': number;
    /**
     * Customer Status State
     * @type {string}
     * @memberof UnifiedCompanyCustomerStatus
     */
    'state': string;
    /**
     * Sort order, lower is first.
     * @type {number}
     * @memberof UnifiedCompanyCustomerStatus
     */
    'order'?: number;
    /**
     * Description of status
     * @type {string}
     * @memberof UnifiedCompanyCustomerStatus
     */
    'description'?: string | null;
    /**
     * The Company that created the custom status.
     * @type {number}
     * @memberof UnifiedCompanyCustomerStatus
     */
    'owner': number | null;
    /**
     * Is this a stock LeafLink status?
     * @type {boolean}
     * @memberof UnifiedCompanyCustomerStatus
     */
    'is_stock'?: boolean;
    /**
     * Hex color for customer status
     * @type {string}
     * @memberof UnifiedCompanyCustomerStatus
     */
    'hex_color'?: string | null;
}
/**
 * Unified serializer for the CompanyCustomerStatus model.
 * @export
 * @interface UnifiedCompanyCustomerStatusRequest
 */
export interface UnifiedCompanyCustomerStatusRequest {
    /**
     * Customer Status State
     * @type {string}
     * @memberof UnifiedCompanyCustomerStatusRequest
     */
    'state': string;
    /**
     * Sort order, lower is first.
     * @type {number}
     * @memberof UnifiedCompanyCustomerStatusRequest
     */
    'order'?: number;
    /**
     * Description of status
     * @type {string}
     * @memberof UnifiedCompanyCustomerStatusRequest
     */
    'description'?: string | null;
    /**
     * The Company that created the custom status.
     * @type {number}
     * @memberof UnifiedCompanyCustomerStatusRequest
     */
    'owner': number | null;
    /**
     * Is this a stock LeafLink status?
     * @type {boolean}
     * @memberof UnifiedCompanyCustomerStatusRequest
     */
    'is_stock'?: boolean;
    /**
     * Hex color for customer status
     * @type {string}
     * @memberof UnifiedCompanyCustomerStatusRequest
     */
    'hex_color'?: string | null;
}
/**
 * 
 * @export
 * @interface UnifiedCompanyRequest
 */
export interface UnifiedCompanyRequest {
    /**
     * Name of Company (Note this is not the same as Brand)
     * @type {string}
     * @memberof UnifiedCompanyRequest
     */
    'name': string;
}
/**
 * Unified Contact serializer
 * @export
 * @interface UnifiedContact
 */
export interface UnifiedContact {
    /**
     * 
     * @type {number}
     * @memberof UnifiedContact
     */
    'id': number;
    /**
     * Date and time the resource was created
     * @type {string}
     * @memberof UnifiedContact
     */
    'created_date': string;
    /**
     * Date and time of the last edit
     * @type {string}
     * @memberof UnifiedContact
     */
    'modified_date': string;
    /**
     * 
     * @type {number}
     * @memberof UnifiedContact
     */
    'owner': number;
    /**
     * 
     * @type {string}
     * @memberof UnifiedContact
     */
    'first_name': string;
    /**
     * 
     * @type {string}
     * @memberof UnifiedContact
     */
    'last_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof UnifiedContact
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UnifiedContact
     */
    'secondary_email'?: string | null;
    /**
     * Position or role at company
     * @type {string}
     * @memberof UnifiedContact
     */
    'role'?: string | null;
    /**
     * An overview of the contact
     * @type {string}
     * @memberof UnifiedContact
     */
    'description'?: string | null;
    /**
     * Phone Number of Brand
     * @type {string}
     * @memberof UnifiedContact
     */
    'phone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UnifiedContact
     */
    'phone_extension'?: string | null;
    /**
     * Secondary Phone Number of Brand
     * @type {string}
     * @memberof UnifiedContact
     */
    'secondary_phone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UnifiedContact
     */
    'secondary_phone_extension'?: string | null;
    /**
     * Is this Contact marked as deleted?
     * @type {boolean}
     * @memberof UnifiedContact
     */
    'delete'?: boolean;
}
/**
 * Unified Contact serializer
 * @export
 * @interface UnifiedContactRequest
 */
export interface UnifiedContactRequest {
    /**
     * 
     * @type {number}
     * @memberof UnifiedContactRequest
     */
    'owner': number;
    /**
     * 
     * @type {string}
     * @memberof UnifiedContactRequest
     */
    'first_name': string;
    /**
     * 
     * @type {string}
     * @memberof UnifiedContactRequest
     */
    'last_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof UnifiedContactRequest
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UnifiedContactRequest
     */
    'secondary_email'?: string | null;
    /**
     * Position or role at company
     * @type {string}
     * @memberof UnifiedContactRequest
     */
    'role'?: string | null;
    /**
     * An overview of the contact
     * @type {string}
     * @memberof UnifiedContactRequest
     */
    'description'?: string | null;
    /**
     * Phone Number of Brand
     * @type {string}
     * @memberof UnifiedContactRequest
     */
    'phone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UnifiedContactRequest
     */
    'phone_extension'?: string | null;
    /**
     * Secondary Phone Number of Brand
     * @type {string}
     * @memberof UnifiedContactRequest
     */
    'secondary_phone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UnifiedContactRequest
     */
    'secondary_phone_extension'?: string | null;
    /**
     * Is this Contact marked as deleted?
     * @type {boolean}
     * @memberof UnifiedContactRequest
     */
    'delete'?: boolean;
}
/**
 * UnifiedCustomerSerializer inherits existing v2 CompanyCustomerSerializer for validations
 * @export
 * @interface UnifiedCustomer
 */
export interface UnifiedCustomer {
    /**
     * 
     * @type {number}
     * @memberof UnifiedCustomer
     */
    'id': number;
    /**
     * Date and time the resource was created
     * @type {string}
     * @memberof UnifiedCustomer
     */
    'created_date': string;
    /**
     * Date and time of the last edit
     * @type {string}
     * @memberof UnifiedCustomer
     */
    'modified_date': string;
    /**
     * 
     * @type {string}
     * @memberof UnifiedCustomer
     */
    'dba': string | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof UnifiedCustomer
     */
    'managers'?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof UnifiedCustomer
     */
    'phone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UnifiedCustomer
     */
    'phone_extension'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UnifiedCustomer
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UnifiedCustomer
     */
    'website'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UnifiedCustomer
     */
    'next_contact_date'?: string | null;
    /**
     * 
     * @type {TierEnum}
     * @memberof UnifiedCustomer
     */
    'tier'?: TierEnum | null;
    /**
     * 
     * @type {string}
     * @memberof UnifiedCustomer
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof UnifiedCustomer
     */
    'nickname': string | null;
    /**
     * 
     * @type {string}
     * @memberof UnifiedCustomer
     */
    'license_number'?: string;
    /**
     * Old License Number (stored after a transfer)
     * @type {string}
     * @memberof UnifiedCustomer
     */
    'old_license_number'?: string | null;
    /**
     * License inactive or transferred for this customer
     * @type {boolean}
     * @memberof UnifiedCustomer
     */
    'is_license_inactive'?: boolean;
    /**
     * Company identifier distinct from license numbers
     * @type {string}
     * @memberof UnifiedCustomer
     */
    'business_identifier'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UnifiedCustomer
     */
    'ein': string | null;
    /**
     * (Driving) Directions to the Customer location for deliveries
     * @type {string}
     * @memberof UnifiedCustomer
     */
    'directions'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UnifiedCustomer
     */
    'delivery_preferences'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UnifiedCustomer
     */
    'currency': string;
    /**
     * Additional Shipping Charge
     * @type {string}
     * @memberof UnifiedCustomer
     */
    'shipping_charge'?: string | null;
    /**
     * Known Brand name of Company or Parent Company
     * @type {string}
     * @memberof UnifiedCustomer
     */
    'brand'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UnifiedCustomer
     */
    'business_license_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UnifiedCustomer
     */
    'description'?: string | null;
    /**
     * 
     * @type {UnifiedAddress}
     * @memberof UnifiedCustomer
     */
    'corporate_address': UnifiedAddress;
    /**
     * 
     * @type {UnifiedAddress}
     * @memberof UnifiedCustomer
     */
    'delivery_address': UnifiedAddress;
    /**
     * Other information on customer
     * @type {string}
     * @memberof UnifiedCustomer
     */
    'notes'?: string | null;
    /**
     * The last time this customer viewed your products on Leaflink
     * @type {string}
     * @memberof UnifiedCustomer
     */
    'leaflink_last_viewed': string;
    /**
     * Was this customer added to your CRM by Leaflink
     * @type {boolean}
     * @memberof UnifiedCustomer
     */
    'leaflink_source': boolean;
    /**
     * Is the customer a relevent part of your CRM
     * @type {boolean}
     * @memberof UnifiedCustomer
     */
    'is_archived'?: boolean;
    /**
     * Is this account delinquent on billing
     * @type {boolean}
     * @memberof UnifiedCustomer
     */
    'is_delinquent'?: boolean;
    /**
     * Discount percent for orders of company customer
     * @type {string}
     * @memberof UnifiedCustomer
     */
    'discount_percent'?: string;
    /**
     * 
     * @type {string}
     * @memberof UnifiedCustomer
     */
    'external_ids'?: string;
    /**
     * Owner ID for customer
     * @type {number}
     * @memberof UnifiedCustomer
     */
    'owner_id': number;
    /**
     * Partner ID for customer
     * @type {number}
     * @memberof UnifiedCustomer
     */
    'partner_id'?: number;
    /**
     * Price schedule ID for the customer
     * @type {number}
     * @memberof UnifiedCustomer
     */
    'price_schedule_id'?: number;
    /**
     * Service zone for the customer
     * @type {ServiceZone}
     * @memberof UnifiedCustomer
     */
    'service_zone': ServiceZone;
    /**
     * 
     * @type {number}
     * @memberof UnifiedCustomer
     */
    'license_type': number;
    /**
     * Status for a customer
     * @type {UnifiedCompanyCustomerStatus}
     * @memberof UnifiedCustomer
     */
    'status': UnifiedCompanyCustomerStatus;
    /**
     * Available payment options for the customer
     * @type {Array<CustomerPaymentOptionSerializerV2>}
     * @memberof UnifiedCustomer
     */
    'available_payment_options': Array<CustomerPaymentOptionSerializerV2> | null;
}


/**
 * UnifiedCustomerSerializer inherits existing v2 CompanyCustomerSerializer for validations
 * @export
 * @interface UnifiedCustomerRequest
 */
export interface UnifiedCustomerRequest {
    /**
     * 
     * @type {Array<number>}
     * @memberof UnifiedCustomerRequest
     */
    'managers'?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof UnifiedCustomerRequest
     */
    'phone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UnifiedCustomerRequest
     */
    'phone_extension'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UnifiedCustomerRequest
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UnifiedCustomerRequest
     */
    'website'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UnifiedCustomerRequest
     */
    'next_contact_date'?: string | null;
    /**
     * 
     * @type {TierEnum}
     * @memberof UnifiedCustomerRequest
     */
    'tier'?: TierEnum | null;
    /**
     * 
     * @type {string}
     * @memberof UnifiedCustomerRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof UnifiedCustomerRequest
     */
    'license_number'?: string;
    /**
     * Old License Number (stored after a transfer)
     * @type {string}
     * @memberof UnifiedCustomerRequest
     */
    'old_license_number'?: string | null;
    /**
     * License inactive or transferred for this customer
     * @type {boolean}
     * @memberof UnifiedCustomerRequest
     */
    'is_license_inactive'?: boolean;
    /**
     * Company identifier distinct from license numbers
     * @type {string}
     * @memberof UnifiedCustomerRequest
     */
    'business_identifier'?: string | null;
    /**
     * (Driving) Directions to the Customer location for deliveries
     * @type {string}
     * @memberof UnifiedCustomerRequest
     */
    'directions'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UnifiedCustomerRequest
     */
    'delivery_preferences'?: string | null;
    /**
     * Additional Shipping Charge
     * @type {string}
     * @memberof UnifiedCustomerRequest
     */
    'shipping_charge'?: string | null;
    /**
     * Known Brand name of Company or Parent Company
     * @type {string}
     * @memberof UnifiedCustomerRequest
     */
    'brand'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UnifiedCustomerRequest
     */
    'business_license_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UnifiedCustomerRequest
     */
    'description'?: string | null;
    /**
     * Other information on customer
     * @type {string}
     * @memberof UnifiedCustomerRequest
     */
    'notes'?: string | null;
    /**
     * Is the customer a relevent part of your CRM
     * @type {boolean}
     * @memberof UnifiedCustomerRequest
     */
    'is_archived'?: boolean;
    /**
     * Is this account delinquent on billing
     * @type {boolean}
     * @memberof UnifiedCustomerRequest
     */
    'is_delinquent'?: boolean;
    /**
     * Discount percent for orders of company customer
     * @type {string}
     * @memberof UnifiedCustomerRequest
     */
    'discount_percent'?: string;
    /**
     * 
     * @type {string}
     * @memberof UnifiedCustomerRequest
     */
    'external_ids'?: string;
    /**
     * Owner ID for customer
     * @type {number}
     * @memberof UnifiedCustomerRequest
     */
    'owner_id': number;
    /**
     * Partner ID for customer
     * @type {number}
     * @memberof UnifiedCustomerRequest
     */
    'partner_id'?: number;
    /**
     * Price schedule ID for the customer
     * @type {number}
     * @memberof UnifiedCustomerRequest
     */
    'price_schedule_id'?: number;
    /**
     * Service zone ID for the customer
     * @type {number}
     * @memberof UnifiedCustomerRequest
     */
    'service_zone_id'?: number;
    /**
     * Status ID for the customer
     * @type {number}
     * @memberof UnifiedCustomerRequest
     */
    'status_id'?: number;
}


/**
 * 
 * @export
 * @interface UnifiedExpressProductMenu
 */
export interface UnifiedExpressProductMenu {
    /**
     * 
     * @type {number}
     * @memberof UnifiedExpressProductMenu
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof UnifiedExpressProductMenu
     */
    'brand': number;
    /**
     * 
     * @type {string}
     * @memberof UnifiedExpressProductMenu
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof UnifiedExpressProductMenu
     */
    'price_schedule': number;
    /**
     * 
     * @type {Array<number>}
     * @memberof UnifiedExpressProductMenu
     */
    'products': Array<number>;
    /**
     * 
     * @type {number}
     * @memberof UnifiedExpressProductMenu
     */
    'products_count': number;
    /**
     * 
     * @type {string}
     * @memberof UnifiedExpressProductMenu
     */
    'slug': string;
}
/**
 * 
 * @export
 * @interface UnifiedExpressProductMenuRequest
 */
export interface UnifiedExpressProductMenuRequest {
    /**
     * 
     * @type {number}
     * @memberof UnifiedExpressProductMenuRequest
     */
    'brand': number;
    /**
     * 
     * @type {number}
     * @memberof UnifiedExpressProductMenuRequest
     */
    'price_schedule': number;
    /**
     * 
     * @type {Array<number>}
     * @memberof UnifiedExpressProductMenuRequest
     */
    'products': Array<number>;
}
/**
 * 
 * @export
 * @interface UnifiedInvoiceCustomer
 */
export interface UnifiedInvoiceCustomer {
    /**
     * Name of Company (Note this is not the same as Brand)
     * @type {string}
     * @memberof UnifiedInvoiceCustomer
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof UnifiedInvoiceCustomer
     */
    'id': number;
}
/**
 * Internal serializer for L3Order Model.
 * @export
 * @interface UnifiedL3Order
 */
export interface UnifiedL3Order {
    /**
     * 
     * @type {string}
     * @memberof UnifiedL3Order
     */
    'number': string;
    /**
     * 
     * @type {string}
     * @memberof UnifiedL3Order
     */
    'invoice_number': string;
    /**
     * 
     * @type {string}
     * @memberof UnifiedL3Order
     */
    'mp_order_number': string;
    /**
     * 
     * @type {string}
     * @memberof UnifiedL3Order
     */
    'transport_order_id': string;
    /**
     * 
     * @type {string}
     * @memberof UnifiedL3Order
     */
    'payment_expected': string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof UnifiedL3Order
     */
    'customer': { [key: string]: any; };
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof UnifiedL3Order
     */
    'pickup_address': { [key: string]: any; };
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof UnifiedL3Order
     */
    'destination': { [key: string]: any; };
    /**
     * 
     * @type {UnifiedL3OrderStatusEnum}
     * @memberof UnifiedL3Order
     */
    'status'?: UnifiedL3OrderStatusEnum;
    /**
     * Requested pick up date
     * @type {string}
     * @memberof UnifiedL3Order
     */
    'requested_pickup_date'?: string | null;
    /**
     * Expected pick up date and time
     * @type {string}
     * @memberof UnifiedL3Order
     */
    'expected_pickup_datetime'?: string | null;
    /**
     * Actual date time the order was picked up
     * @type {string}
     * @memberof UnifiedL3Order
     */
    'actual_pickup_datetime'?: string | null;
    /**
     * Requested delivery date for the order
     * @type {string}
     * @memberof UnifiedL3Order
     */
    'requested_delivery_date'?: string | null;
    /**
     * Expected delivery date and time for the order
     * @type {string}
     * @memberof UnifiedL3Order
     */
    'expected_delivery_datetime'?: string | null;
    /**
     * Actual delivery date and time for the order
     * @type {string}
     * @memberof UnifiedL3Order
     */
    'actual_delivery_datetime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UnifiedL3Order
     */
    'display_delivery_date': string | null;
    /**
     * 
     * @type {Driver}
     * @memberof UnifiedL3Order
     */
    'pickup_driver': Driver;
    /**
     * 
     * @type {Array<{ [key: string]: any; }>}
     * @memberof UnifiedL3Order
     */
    'additional_pickup_drivers': Array<{ [key: string]: any; }>;
    /**
     * 
     * @type {InternalVehicle}
     * @memberof UnifiedL3Order
     */
    'pickup_vehicle': InternalVehicle;
    /**
     * 
     * @type {Driver}
     * @memberof UnifiedL3Order
     */
    'delivery_driver': Driver;
    /**
     * 
     * @type {InternalVehicle}
     * @memberof UnifiedL3Order
     */
    'delivery_vehicle': InternalVehicle;
    /**
     * 
     * @type {PaymentMethod}
     * @memberof UnifiedL3Order
     */
    'payment_method': PaymentMethod;
    /**
     * 
     * @type {PaymentTerm}
     * @memberof UnifiedL3Order
     */
    'payment_term': PaymentTerm;
    /**
     * Customer notes for the L3 Order
     * @type {string}
     * @memberof UnifiedL3Order
     */
    'customer_notes'?: string | null;
    /**
     * Additional notes for the L3 Order
     * @type {string}
     * @memberof UnifiedL3Order
     */
    'notes'?: string | null;
    /**
     * A selection of eligible payment methods for this order
     * @type {Array<string>}
     * @memberof UnifiedL3Order
     */
    'eligible_payment_methods'?: Array<string>;
    /**
     * Payment method used for this order
     * @type {string}
     * @memberof UnifiedL3Order
     */
    'payment_method_collected'?: string;
    /**
     * Payment collected at delivery
     * @type {string}
     * @memberof UnifiedL3Order
     */
    'collected_payment_amount'?: string | null;
    /**
     * Comment from delivery driver for this order
     * @type {string}
     * @memberof UnifiedL3Order
     */
    'delivery_driver_comment'?: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof UnifiedL3Order
     */
    'metrc_transfer': { [key: string]: any; } | null;
    /**
     * 
     * @type {string}
     * @memberof UnifiedL3Order
     */
    'created_on': string;
    /**
     * 
     * @type {TransportCompany}
     * @memberof UnifiedL3Order
     */
    'transport_company': TransportCompany;
    /**
     * 
     * @type {InternalLogisticsCompany}
     * @memberof UnifiedL3Order
     */
    'brand': InternalLogisticsCompany;
}


/**
 * Internal serializer for L3Order Model.
 * @export
 * @interface UnifiedL3OrderRequest
 */
export interface UnifiedL3OrderRequest {
    /**
     * 
     * @type {string}
     * @memberof UnifiedL3OrderRequest
     */
    'payment_expected': string;
    /**
     * 
     * @type {UnifiedL3OrderStatusEnum}
     * @memberof UnifiedL3OrderRequest
     */
    'status'?: UnifiedL3OrderStatusEnum;
    /**
     * Requested pick up date
     * @type {string}
     * @memberof UnifiedL3OrderRequest
     */
    'requested_pickup_date'?: string | null;
    /**
     * Expected pick up date and time
     * @type {string}
     * @memberof UnifiedL3OrderRequest
     */
    'expected_pickup_datetime'?: string | null;
    /**
     * Actual date time the order was picked up
     * @type {string}
     * @memberof UnifiedL3OrderRequest
     */
    'actual_pickup_datetime'?: string | null;
    /**
     * Requested delivery date for the order
     * @type {string}
     * @memberof UnifiedL3OrderRequest
     */
    'requested_delivery_date'?: string | null;
    /**
     * Expected delivery date and time for the order
     * @type {string}
     * @memberof UnifiedL3OrderRequest
     */
    'expected_delivery_datetime'?: string | null;
    /**
     * Actual delivery date and time for the order
     * @type {string}
     * @memberof UnifiedL3OrderRequest
     */
    'actual_delivery_datetime'?: string | null;
    /**
     * 
     * @type {DriverRequest}
     * @memberof UnifiedL3OrderRequest
     */
    'pickup_driver': DriverRequest;
    /**
     * 
     * @type {InternalVehicleRequest}
     * @memberof UnifiedL3OrderRequest
     */
    'pickup_vehicle': InternalVehicleRequest;
    /**
     * 
     * @type {DriverRequest}
     * @memberof UnifiedL3OrderRequest
     */
    'delivery_driver': DriverRequest;
    /**
     * 
     * @type {InternalVehicleRequest}
     * @memberof UnifiedL3OrderRequest
     */
    'delivery_vehicle': InternalVehicleRequest;
    /**
     * 
     * @type {PaymentMethodRequest}
     * @memberof UnifiedL3OrderRequest
     */
    'payment_method': PaymentMethodRequest;
    /**
     * 
     * @type {PaymentTermRequest}
     * @memberof UnifiedL3OrderRequest
     */
    'payment_term': PaymentTermRequest;
    /**
     * Customer notes for the L3 Order
     * @type {string}
     * @memberof UnifiedL3OrderRequest
     */
    'customer_notes'?: string | null;
    /**
     * Additional notes for the L3 Order
     * @type {string}
     * @memberof UnifiedL3OrderRequest
     */
    'notes'?: string | null;
    /**
     * A selection of eligible payment methods for this order
     * @type {Array<string>}
     * @memberof UnifiedL3OrderRequest
     */
    'eligible_payment_methods'?: Array<string>;
    /**
     * Payment method used for this order
     * @type {string}
     * @memberof UnifiedL3OrderRequest
     */
    'payment_method_collected'?: string;
    /**
     * Payment collected at delivery
     * @type {string}
     * @memberof UnifiedL3OrderRequest
     */
    'collected_payment_amount'?: string | null;
    /**
     * Comment from delivery driver for this order
     * @type {string}
     * @memberof UnifiedL3OrderRequest
     */
    'delivery_driver_comment'?: string;
    /**
     * 
     * @type {InternalLogisticsCompanyRequest}
     * @memberof UnifiedL3OrderRequest
     */
    'brand': InternalLogisticsCompanyRequest;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const UnifiedL3OrderStatusEnum = {
    Uploaded: 'uploaded',
    Created: 'created',
    Assigned: 'assigned',
    Planned: 'planned',
    Shipped: 'shipped',
    Delivered: 'delivered',
    Deleted: 'deleted'
} as const;

export type UnifiedL3OrderStatusEnum = typeof UnifiedL3OrderStatusEnum[keyof typeof UnifiedL3OrderStatusEnum];


/**
 * 
 * @export
 * @interface UnifiedMessagingFindSeller
 */
export interface UnifiedMessagingFindSeller {
    /**
     * 
     * @type {number}
     * @memberof UnifiedMessagingFindSeller
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof UnifiedMessagingFindSeller
     */
    'address': string;
    /**
     * 
     * @type {string}
     * @memberof UnifiedMessagingFindSeller
     */
    'city': string;
    /**
     * 
     * @type {string}
     * @memberof UnifiedMessagingFindSeller
     */
    'state'?: string;
    /**
     * 
     * @type {string}
     * @memberof UnifiedMessagingFindSeller
     */
    'zipcode': string;
    /**
     * Company identifier distinct from license numbers
     * @type {string}
     * @memberof UnifiedMessagingFindSeller
     */
    'business_identifier'?: string | null;
    /**
     * Business License Name
     * @type {string}
     * @memberof UnifiedMessagingFindSeller
     */
    'business_license_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UnifiedMessagingFindSeller
     */
    'image'?: string | null;
    /**
     * Name of Company (Note this is not the same as Brand)
     * @type {string}
     * @memberof UnifiedMessagingFindSeller
     */
    'name': string;
    /**
     * Company sells on LeafLink
     * @type {boolean}
     * @memberof UnifiedMessagingFindSeller
     */
    'seller'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UnifiedMessagingFindSeller
     */
    'slug'?: string;
}
/**
 * Base serializer class to rename created_on and modified fields to follow new naming standard of created_date and modified_date
 * @export
 * @interface UnifiedOrderAsSalesInvoice
 */
export interface UnifiedOrderAsSalesInvoice {
    /**
     * 
     * @type {number}
     * @memberof UnifiedOrderAsSalesInvoice
     */
    'id': number;
    /**
     * Date and time the resource was created
     * @type {string}
     * @memberof UnifiedOrderAsSalesInvoice
     */
    'created_date': string;
    /**
     * Date and time of the last edit
     * @type {string}
     * @memberof UnifiedOrderAsSalesInvoice
     */
    'modified_date': string;
    /**
     * Date the Order is fully paid
     * @type {string}
     * @memberof UnifiedOrderAsSalesInvoice
     */
    'paid_date'?: string | null;
    /**
     * 
     * @type {UnifiedInvoiceCustomer}
     * @memberof UnifiedOrderAsSalesInvoice
     */
    'buyer': UnifiedInvoiceCustomer;
    /**
     * Order total
     * @type {string}
     * @memberof UnifiedOrderAsSalesInvoice
     */
    'total'?: string;
    /**
     * 
     * @type {string}
     * @memberof UnifiedOrderAsSalesInvoice
     */
    'order': string;
    /**
     * Date that the Payment is due
     * @type {string}
     * @memberof UnifiedOrderAsSalesInvoice
     */
    'payment_due_date'?: string | null;
    /**
     * Date the Order is shipped
     * @type {string}
     * @memberof UnifiedOrderAsSalesInvoice
     */
    'ship_date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UnifiedOrderAsSalesInvoice
     */
    'balance': string;
    /**
     * 
     * @type {Array<UnifiedOrderedProductAsInvoiceLineItem>}
     * @memberof UnifiedOrderAsSalesInvoice
     */
    'line_items': Array<UnifiedOrderedProductAsInvoiceLineItem>;
}
/**
 * Serializer for handling order payment data and validations.
 * @export
 * @interface UnifiedOrderPayment
 */
export interface UnifiedOrderPayment {
    /**
     * 
     * @type {number}
     * @memberof UnifiedOrderPayment
     */
    'id': number;
    /**
     * Date and time the resource was created
     * @type {string}
     * @memberof UnifiedOrderPayment
     */
    'created_date': string;
    /**
     * Date and time of the last edit
     * @type {string}
     * @memberof UnifiedOrderPayment
     */
    'modified_date': string;
    /**
     * 
     * @type {string}
     * @memberof UnifiedOrderPayment
     */
    'order': string;
    /**
     * Date that the was submitted.
     * @type {string}
     * @memberof UnifiedOrderPayment
     */
    'payment_date'?: string | null;
    /**
     * Total Paid
     * @type {string}
     * @memberof UnifiedOrderPayment
     */
    'total': string;
    /**
     * 
     * @type {string}
     * @memberof UnifiedOrderPayment
     */
    'currency': string;
    /**
     * How this payment was submitted.
     * @type {PaymentTypeEnum}
     * @memberof UnifiedOrderPayment
     */
    'payment_type'?: PaymentTypeEnum;
    /**
     * 
     * @type {UnifiedCustomer}
     * @memberof UnifiedOrderPayment
     */
    'customer': UnifiedCustomer;
}


/**
 * Serializer for handling order payment data and validations.
 * @export
 * @interface UnifiedOrderPaymentRequest
 */
export interface UnifiedOrderPaymentRequest {
    /**
     * 
     * @type {string}
     * @memberof UnifiedOrderPaymentRequest
     */
    'order': string;
    /**
     * Date that the was submitted.
     * @type {string}
     * @memberof UnifiedOrderPaymentRequest
     */
    'payment_date'?: string | null;
    /**
     * Total Paid
     * @type {string}
     * @memberof UnifiedOrderPaymentRequest
     */
    'total': string;
    /**
     * How this payment was submitted.
     * @type {PaymentTypeEnum}
     * @memberof UnifiedOrderPaymentRequest
     */
    'payment_type'?: PaymentTypeEnum;
}


/**
 * 
 * @export
 * @interface UnifiedOrderedProductAsInvoiceLineItem
 */
export interface UnifiedOrderedProductAsInvoiceLineItem {
    /**
     * 
     * @type {string}
     * @memberof UnifiedOrderedProductAsInvoiceLineItem
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof UnifiedOrderedProductAsInvoiceLineItem
     */
    'name': string;
    /**
     * The number of units ordered
     * @type {string}
     * @memberof UnifiedOrderedProductAsInvoiceLineItem
     */
    'quantity': string;
    /**
     * The price at the time of order.
     * @type {string}
     * @memberof UnifiedOrderedProductAsInvoiceLineItem
     */
    'ordered_unit_price'?: string;
}
/**
 * Unified POMS Order Approval serializer for request data.
 * @export
 * @interface UnifiedPomsOrderApprovalRequestData
 */
export interface UnifiedPomsOrderApprovalRequestData {
    /**
     * Order ID from POMS system
     * @type {number}
     * @memberof UnifiedPomsOrderApprovalRequestData
     */
    'order_id'?: number;
    /**
     * UUID of Order for approval
     * @type {string}
     * @memberof UnifiedPomsOrderApprovalRequestData
     */
    'purchase_order_number': string;
    /**
     * Status of the POMS order that defines the action to be taken
     * @type {UnifiedPomsOrderApprovalRequestDataStatusEnum}
     * @memberof UnifiedPomsOrderApprovalRequestData
     */
    'status': UnifiedPomsOrderApprovalRequestDataStatusEnum;
    /**
     * Optional message
     * @type {string}
     * @memberof UnifiedPomsOrderApprovalRequestData
     */
    'message'?: string;
}


/**
 * Unified POMS Order Approval serializer for request data.
 * @export
 * @interface UnifiedPomsOrderApprovalRequestDataRequest
 */
export interface UnifiedPomsOrderApprovalRequestDataRequest {
    /**
     * Order ID from POMS system
     * @type {number}
     * @memberof UnifiedPomsOrderApprovalRequestDataRequest
     */
    'order_id'?: number;
    /**
     * UUID of Order for approval
     * @type {string}
     * @memberof UnifiedPomsOrderApprovalRequestDataRequest
     */
    'purchase_order_number': string;
    /**
     * Status of the POMS order that defines the action to be taken
     * @type {UnifiedPomsOrderApprovalRequestDataStatusEnum}
     * @memberof UnifiedPomsOrderApprovalRequestDataRequest
     */
    'status': UnifiedPomsOrderApprovalRequestDataStatusEnum;
    /**
     * Optional message
     * @type {string}
     * @memberof UnifiedPomsOrderApprovalRequestDataRequest
     */
    'message'?: string;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const UnifiedPomsOrderApprovalRequestDataStatusEnum = {
    Approved: 'approved',
    Rejected: 'rejected',
    Completed: 'completed',
    Error: 'error'
} as const;

export type UnifiedPomsOrderApprovalRequestDataStatusEnum = typeof UnifiedPomsOrderApprovalRequestDataStatusEnum[keyof typeof UnifiedPomsOrderApprovalRequestDataStatusEnum];


/**
 * Unified Product serializer.
 * @export
 * @interface UnifiedProduct
 */
export interface UnifiedProduct {
    /**
     * 
     * @type {number}
     * @memberof UnifiedProduct
     */
    'id': number;
    /**
     * Date and time the resource was created
     * @type {string}
     * @memberof UnifiedProduct
     */
    'created_date': string;
    /**
     * Date and time of the last edit
     * @type {string}
     * @memberof UnifiedProduct
     */
    'modified_date': string;
    /**
     * Product name
     * @type {string}
     * @memberof UnifiedProduct
     */
    'name': string;
    /**
     * product name that is displayed
     * @type {string}
     * @memberof UnifiedProduct
     */
    'display_name': string;
    /**
     * Product details
     * @type {string}
     * @memberof UnifiedProduct
     */
    'description': string;
    /**
     * Product category for the product
     * @type {UnifiedProductCategory}
     * @memberof UnifiedProduct
     */
    'category': UnifiedProductCategory;
    /**
     * Product listing state. Values available at the /listing-states/ endpoint.
     * @type {ListingStateEnum}
     * @memberof UnifiedProduct
     */
    'listing_state': ListingStateEnum;
    /**
     * 
     * @type {PatchedUnifiedProductMVPRequestWholesalePrice}
     * @memberof UnifiedProduct
     */
    'wholesale_price': PatchedUnifiedProductMVPRequestWholesalePrice;
    /**
     * How many individual units are sold when compared to the assigned unit of measure
     * @type {number}
     * @memberof UnifiedProduct
     */
    'unit_multiplier'?: number;
    /**
     * The amount of individual products in one sale unit
     * @type {string}
     * @memberof UnifiedProduct
     */
    'unit_denomination': string;
    /**
     * Total and reserved inventory for product
     * @type {UnifiedProductInventory}
     * @memberof UnifiedProduct
     */
    'inventory': UnifiedProductInventory;
    /**
     * Stock keeping unit for the product
     * @type {string}
     * @memberof UnifiedProduct
     */
    'sku'?: string | null;
    /**
     * Brand of the product
     * @type {UnifiedBrand}
     * @memberof UnifiedProduct
     */
    'brand': UnifiedBrand;
    /**
     * Company who is selling the Product
     * @type {number}
     * @memberof UnifiedProduct
     */
    'seller_id': number;
    /**
     * External IDs associated with the product
     * @type {{ [key: string]: any; }}
     * @memberof UnifiedProduct
     */
    'external_ids': { [key: string]: any; };
    /**
     * Base unit of measure for this product
     * @type {string}
     * @memberof UnifiedProduct
     */
    'unit_of_measure': string;
}


/**
 * Unified ProductImage bulk create serializer.
 * @export
 * @interface UnifiedProductBulkCreate
 */
export interface UnifiedProductBulkCreate {
    /**
     * Product ID
     * @type {number}
     * @memberof UnifiedProductBulkCreate
     */
    'product_id': number;
    /**
     * 
     * @type {Array<string>}
     * @memberof UnifiedProductBulkCreate
     */
    'images': Array<string>;
    /**
     * 
     * @type {Array<number>}
     * @memberof UnifiedProductBulkCreate
     */
    'positions': Array<number>;
}
/**
 * Unified Product Bulk Update Data Serializer
 * @export
 * @interface UnifiedProductBulkUpdateDataRequest
 */
export interface UnifiedProductBulkUpdateDataRequest {
    /**
     * 
     * @type {TypeEnum}
     * @memberof UnifiedProductBulkUpdateDataRequest
     */
    'type': TypeEnum;
    /**
     * 
     * @type {FieldEnum}
     * @memberof UnifiedProductBulkUpdateDataRequest
     */
    'field': FieldEnum;
    /**
     * 
     * @type {number}
     * @memberof UnifiedProductBulkUpdateDataRequest
     */
    'value': number;
}


/**
 * Unified Product Bulk Update Serializer
 * @export
 * @interface UnifiedProductBulkUpdateRequest
 */
export interface UnifiedProductBulkUpdateRequest {
    /**
     * association or field to select products. Currently only supports \'product_line\'.
     * @type {SelectorEnum}
     * @memberof UnifiedProductBulkUpdateRequest
     */
    'selector': SelectorEnum;
    /**
     * 
     * @type {Array<number>}
     * @memberof UnifiedProductBulkUpdateRequest
     */
    'selector_values': Array<number>;
    /**
     * 
     * @type {Array<UnifiedProductBulkUpdateDataRequest>}
     * @memberof UnifiedProductBulkUpdateRequest
     */
    'update_data': Array<UnifiedProductBulkUpdateDataRequest>;
}


/**
 * Unified Product category serializer
 * @export
 * @interface UnifiedProductCategory
 */
export interface UnifiedProductCategory {
    /**
     * 
     * @type {number}
     * @memberof UnifiedProductCategory
     */
    'id': number;
    /**
     * Name of Category
     * @type {string}
     * @memberof UnifiedProductCategory
     */
    'name': string;
}
/**
 * Unified Product category serializer
 * @export
 * @interface UnifiedProductCategoryRequest
 */
export interface UnifiedProductCategoryRequest {
    /**
     * Name of Category
     * @type {string}
     * @memberof UnifiedProductCategoryRequest
     */
    'name': string;
}
/**
 * Unified Product Dosage Unit serializer.
 * @export
 * @interface UnifiedProductDosageUnit
 */
export interface UnifiedProductDosageUnit {
    /**
     * 
     * @type {number}
     * @memberof UnifiedProductDosageUnit
     */
    'id': number;
    /**
     * Date and time the resource was created
     * @type {string}
     * @memberof UnifiedProductDosageUnit
     */
    'created_date': string;
    /**
     * Date and time of the last edit
     * @type {string}
     * @memberof UnifiedProductDosageUnit
     */
    'modified_date': string;
    /**
     * Name of Unit
     * @type {string}
     * @memberof UnifiedProductDosageUnit
     */
    'name': string;
    /**
     * Dosage Unit of Measure
     * @type {string}
     * @memberof UnifiedProductDosageUnit
     */
    'unit': string;
    /**
     * Unit Description
     * @type {string}
     * @memberof UnifiedProductDosageUnit
     */
    'description': string | null;
}
/**
 * Unified ProductImage serializer.
 * @export
 * @interface UnifiedProductImage
 */
export interface UnifiedProductImage {
    /**
     * 
     * @type {number}
     * @memberof UnifiedProductImage
     */
    'id': number;
    /**
     * Date and time the resource was created
     * @type {string}
     * @memberof UnifiedProductImage
     */
    'created_date': string;
    /**
     * Date and time of the last edit
     * @type {string}
     * @memberof UnifiedProductImage
     */
    'modified_date': string;
    /**
     * The uploaded file, sent via multipart form data. Retrieved as a url link.
     * @type {string}
     * @memberof UnifiedProductImage
     */
    'image': string;
    /**
     * The Product this image is attached to
     * @type {number}
     * @memberof UnifiedProductImage
     */
    'product': number;
    /**
     * The position of the image in the product image gallery
     * @type {number}
     * @memberof UnifiedProductImage
     */
    'position': number;
    /**
     * The X position of the image crop box
     * @type {number}
     * @memberof UnifiedProductImage
     */
    'crop_x'?: number | null;
    /**
     * The Y position of the image crop box
     * @type {number}
     * @memberof UnifiedProductImage
     */
    'crop_y'?: number | null;
    /**
     * The width of the image crop box
     * @type {number}
     * @memberof UnifiedProductImage
     */
    'crop_w'?: number | null;
    /**
     * The height of the image crop box
     * @type {number}
     * @memberof UnifiedProductImage
     */
    'crop_h'?: number | null;
}
/**
 * Unified Product inventory serializer
 * @export
 * @interface UnifiedProductInventory
 */
export interface UnifiedProductInventory {
    /**
     * 
     * @type {number}
     * @memberof UnifiedProductInventory
     */
    'total_qty': number;
    /**
     * 
     * @type {number}
     * @memberof UnifiedProductInventory
     */
    'reserved_qty': number;
}
/**
 * Unified Product inventory serializer
 * @export
 * @interface UnifiedProductInventoryRequest
 */
export interface UnifiedProductInventoryRequest {
    /**
     * 
     * @type {number}
     * @memberof UnifiedProductInventoryRequest
     */
    'total_qty': number;
}
/**
 * Base Unified ProductLine serializer.
 * @export
 * @interface UnifiedProductLine
 */
export interface UnifiedProductLine {
    /**
     * 
     * @type {number}
     * @memberof UnifiedProductLine
     */
    'id': number;
    /**
     * Date and time the resource was created
     * @type {string}
     * @memberof UnifiedProductLine
     */
    'created_date': string;
    /**
     * Date and time of the last edit
     * @type {string}
     * @memberof UnifiedProductLine
     */
    'modified_date': string;
    /**
     * Name of Product Line
     * @type {string}
     * @memberof UnifiedProductLine
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof UnifiedProductLine
     */
    'display_name': string;
    /**
     * Brand of the product line
     * @type {UnifiedBrand}
     * @memberof UnifiedProductLine
     */
    'brand': UnifiedBrand;
    /**
     * The position of ordering
     * @type {number}
     * @memberof UnifiedProductLine
     */
    'menu_position'?: number | null;
    /**
     * Products associated with the product line
     * @type {Array<UnifiedProductLineProduct>}
     * @memberof UnifiedProductLine
     */
    'products': Array<UnifiedProductLineProduct>;
}
/**
 * Serializer for creating product lines.
 * @export
 * @interface UnifiedProductLineCreate
 */
export interface UnifiedProductLineCreate {
    /**
     * 
     * @type {number}
     * @memberof UnifiedProductLineCreate
     */
    'id': number;
    /**
     * Date and time the resource was created
     * @type {string}
     * @memberof UnifiedProductLineCreate
     */
    'created_date': string;
    /**
     * Date and time of the last edit
     * @type {string}
     * @memberof UnifiedProductLineCreate
     */
    'modified_date': string;
    /**
     * Name of Product Line
     * @type {string}
     * @memberof UnifiedProductLineCreate
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof UnifiedProductLineCreate
     */
    'display_name': string;
    /**
     * Brand of the product line
     * @type {UnifiedBrand}
     * @memberof UnifiedProductLineCreate
     */
    'brand': UnifiedBrand;
    /**
     * The position of ordering
     * @type {number}
     * @memberof UnifiedProductLineCreate
     */
    'menu_position'?: number | null;
    /**
     * Products associated with the product line
     * @type {Array<UnifiedProductLineProduct>}
     * @memberof UnifiedProductLineCreate
     */
    'products': Array<UnifiedProductLineProduct>;
}
/**
 * Serializer for creating product lines.
 * @export
 * @interface UnifiedProductLineCreateRequest
 */
export interface UnifiedProductLineCreateRequest {
    /**
     * Name of Product Line
     * @type {string}
     * @memberof UnifiedProductLineCreateRequest
     */
    'name': string;
    /**
     * Brand ID for the product line
     * @type {number}
     * @memberof UnifiedProductLineCreateRequest
     */
    'brand_id': number;
    /**
     * The position of ordering
     * @type {number}
     * @memberof UnifiedProductLineCreateRequest
     */
    'menu_position'?: number | null;
    /**
     * List of product IDs associated with this product line
     * @type {Array<number>}
     * @memberof UnifiedProductLineCreateRequest
     */
    'product_ids'?: Array<number>;
}
/**
 * Serializer for a product in a product line.
 * @export
 * @interface UnifiedProductLineProduct
 */
export interface UnifiedProductLineProduct {
    /**
     * 
     * @type {number}
     * @memberof UnifiedProductLineProduct
     */
    'id': number;
    /**
     * Product Name
     * @type {string}
     * @memberof UnifiedProductLineProduct
     */
    'name': string;
}
/**
 * Unified Product serializer.
 * @export
 * @interface UnifiedProductMVP
 */
export interface UnifiedProductMVP {
    /**
     * 
     * @type {number}
     * @memberof UnifiedProductMVP
     */
    'id': number;
    /**
     * Date and time the resource was created
     * @type {string}
     * @memberof UnifiedProductMVP
     */
    'created_date': string;
    /**
     * Date and time of the last edit
     * @type {string}
     * @memberof UnifiedProductMVP
     */
    'modified_date': string;
    /**
     * Stock Keeping Unit. A unique identifier for a Product, alternative to id.
     * @type {string}
     * @memberof UnifiedProductMVP
     */
    'sku'?: string | null;
    /**
     * Seller of the product
     * @type {UnifiedCompany}
     * @memberof UnifiedProductMVP
     */
    'seller': UnifiedCompany;
    /**
     * Brand of the product
     * @type {UnifiedBrand}
     * @memberof UnifiedProductMVP
     */
    'brand': UnifiedBrand;
    /**
     * Product Line of product
     * @type {number}
     * @memberof UnifiedProductMVP
     */
    'product_line': number | null;
    /**
     * Product Name
     * @type {string}
     * @memberof UnifiedProductMVP
     */
    'name': string;
    /**
     * product name that is displayed
     * @type {string}
     * @memberof UnifiedProductMVP
     */
    'display_name': string;
    /**
     * License for the product
     * @type {ComplianceLicense}
     * @memberof UnifiedProductMVP
     */
    'license': ComplianceLicense;
    /**
     * Product category for the product
     * @type {UnifiedProductCategory}
     * @memberof UnifiedProductMVP
     */
    'category': UnifiedProductCategory;
    /**
     * The sub-category of the Product (e.g. Bulk Flower, Live Resin, etc)
     * @type {number}
     * @memberof UnifiedProductMVP
     */
    'sub_category': number | null;
    /**
     * Base unit of measure for this product
     * @type {UnifiedUnitOfMeasure}
     * @memberof UnifiedProductMVP
     */
    'unit_of_measure': UnifiedUnitOfMeasure;
    /**
     * The of amount of individual products in one sale unit
     * @type {UnifiedUnitDenomination}
     * @memberof UnifiedProductMVP
     */
    'unit_denomination': UnifiedUnitDenomination;
    /**
     * Product listing state. Values available at the /listing-states/ endpoint.
     * @type {ListingStateEnum}
     * @memberof UnifiedProductMVP
     */
    'listing_state': ListingStateEnum;
    /**
     * Brand Description
     * @type {string}
     * @memberof UnifiedProductMVP
     */
    'description': string;
    /**
     * 
     * @type {PatchedUnifiedProductMVPRequestWholesalePrice}
     * @memberof UnifiedProductMVP
     */
    'wholesale_price': PatchedUnifiedProductMVPRequestWholesalePrice;
    /**
     * 
     * @type {PatchedUnifiedProductMVPRequestRetailPrice}
     * @memberof UnifiedProductMVP
     */
    'retail_price': PatchedUnifiedProductMVPRequestRetailPrice;
    /**
     * The cannabis strains associated with this product
     * @type {Array<number>}
     * @memberof UnifiedProductMVP
     */
    'strains'?: Array<number>;
    /**
     * 
     * @type {PatchedUnifiedProductMVPRequestStrainClassification}
     * @memberof UnifiedProductMVP
     */
    'strain_classification'?: PatchedUnifiedProductMVPRequestStrainClassification;
    /**
     * Is this a medical line item?
     * @type {boolean}
     * @memberof UnifiedProductMVP
     */
    'is_medical_line_item'?: boolean;
    /**
     * 
     * @type {PatchedUnifiedProductMVPRequestGrowType}
     * @memberof UnifiedProductMVP
     */
    'grow_type'?: PatchedUnifiedProductMVPRequestGrowType;
    /**
     * Number of base units in one unit of this product
     * @type {string}
     * @memberof UnifiedProductMVP
     */
    'base_units_per_unit'?: string | null;
    /**
     * Threshold configuration for inventory alerts
     * @type {Threshold}
     * @memberof UnifiedProductMVP
     */
    'threshold'?: Threshold | null;
    /**
     * 
     * @type {Array<UnifiedProductSpecificationItem>}
     * @memberof UnifiedProductMVP
     */
    'product_specification_items'?: Array<UnifiedProductSpecificationItem>;
}


/**
 * Unified Product serializer for adding from template.
 * @export
 * @interface UnifiedProductMVPFromTemplate
 */
export interface UnifiedProductMVPFromTemplate {
    /**
     * 
     * @type {number}
     * @memberof UnifiedProductMVPFromTemplate
     */
    'id': number | null;
    /**
     * Date and time the resource was created
     * @type {string}
     * @memberof UnifiedProductMVPFromTemplate
     */
    'created_date': string | null;
    /**
     * Date and time of the last edit
     * @type {string}
     * @memberof UnifiedProductMVPFromTemplate
     */
    'modified_date': string | null;
    /**
     * Stock Keeping Unit. A unique identifier for a Product, alternative to id.
     * @type {string}
     * @memberof UnifiedProductMVPFromTemplate
     */
    'sku'?: string | null;
    /**
     * Seller of the product
     * @type {UnifiedCompany}
     * @memberof UnifiedProductMVPFromTemplate
     */
    'seller': UnifiedCompany;
    /**
     * Brand of the product
     * @type {UnifiedBrand}
     * @memberof UnifiedProductMVPFromTemplate
     */
    'brand': UnifiedBrand;
    /**
     * Product Line of product
     * @type {number}
     * @memberof UnifiedProductMVPFromTemplate
     */
    'product_line': number | null;
    /**
     * Product Name
     * @type {string}
     * @memberof UnifiedProductMVPFromTemplate
     */
    'name': string;
    /**
     * product name that is displayed
     * @type {string}
     * @memberof UnifiedProductMVPFromTemplate
     */
    'display_name': string;
    /**
     * License for the product
     * @type {ComplianceLicense}
     * @memberof UnifiedProductMVPFromTemplate
     */
    'license': ComplianceLicense;
    /**
     * Product category for the product
     * @type {UnifiedProductCategory}
     * @memberof UnifiedProductMVPFromTemplate
     */
    'category': UnifiedProductCategory;
    /**
     * The sub-category of the Product (e.g. Bulk Flower, Live Resin, etc)
     * @type {number}
     * @memberof UnifiedProductMVPFromTemplate
     */
    'sub_category': number | null;
    /**
     * Base unit of measure for this product
     * @type {UnifiedUnitOfMeasure}
     * @memberof UnifiedProductMVPFromTemplate
     */
    'unit_of_measure': UnifiedUnitOfMeasure;
    /**
     * The of amount of individual products in one sale unit
     * @type {UnifiedUnitDenomination}
     * @memberof UnifiedProductMVPFromTemplate
     */
    'unit_denomination': UnifiedUnitDenomination;
    /**
     * Product listing state. Values available at the /listing-states/ endpoint.
     * @type {ListingStateEnum}
     * @memberof UnifiedProductMVPFromTemplate
     */
    'listing_state': ListingStateEnum;
    /**
     * Brand Description
     * @type {string}
     * @memberof UnifiedProductMVPFromTemplate
     */
    'description': string;
    /**
     * 
     * @type {PatchedUnifiedProductMVPRequestWholesalePrice}
     * @memberof UnifiedProductMVPFromTemplate
     */
    'wholesale_price': PatchedUnifiedProductMVPRequestWholesalePrice;
    /**
     * 
     * @type {PatchedUnifiedProductMVPRequestRetailPrice}
     * @memberof UnifiedProductMVPFromTemplate
     */
    'retail_price': PatchedUnifiedProductMVPRequestRetailPrice;
    /**
     * The cannabis strains associated with this product
     * @type {Array<number>}
     * @memberof UnifiedProductMVPFromTemplate
     */
    'strains'?: Array<number>;
    /**
     * 
     * @type {PatchedUnifiedProductMVPRequestStrainClassification}
     * @memberof UnifiedProductMVPFromTemplate
     */
    'strain_classification'?: PatchedUnifiedProductMVPRequestStrainClassification;
    /**
     * Is this a medical line item?
     * @type {boolean}
     * @memberof UnifiedProductMVPFromTemplate
     */
    'is_medical_line_item'?: boolean;
    /**
     * 
     * @type {PatchedUnifiedProductMVPRequestGrowType}
     * @memberof UnifiedProductMVPFromTemplate
     */
    'grow_type'?: PatchedUnifiedProductMVPRequestGrowType;
    /**
     * Number of base units in one unit of this product
     * @type {string}
     * @memberof UnifiedProductMVPFromTemplate
     */
    'base_units_per_unit'?: string | null;
    /**
     * Threshold configuration for inventory alerts
     * @type {Threshold}
     * @memberof UnifiedProductMVPFromTemplate
     */
    'threshold'?: Threshold | null;
    /**
     * 
     * @type {Array<UnifiedProductSpecificationItem>}
     * @memberof UnifiedProductMVPFromTemplate
     */
    'product_specification_items'?: Array<UnifiedProductSpecificationItem>;
}


/**
 * Unified Product serializer.
 * @export
 * @interface UnifiedProductMVPRequest
 */
export interface UnifiedProductMVPRequest {
    /**
     * Stock Keeping Unit. A unique identifier for a Product, alternative to id.
     * @type {string}
     * @memberof UnifiedProductMVPRequest
     */
    'sku'?: string | null;
    /**
     * Company who is selling the Product
     * @type {number}
     * @memberof UnifiedProductMVPRequest
     */
    'seller_id': number;
    /**
     * Brand ID for the product
     * @type {number}
     * @memberof UnifiedProductMVPRequest
     */
    'brand_id': number;
    /**
     * Product Line ID of product
     * @type {number}
     * @memberof UnifiedProductMVPRequest
     */
    'product_line_id'?: number;
    /**
     * Product Name
     * @type {string}
     * @memberof UnifiedProductMVPRequest
     */
    'name': string;
    /**
     * License ID for the product
     * @type {number}
     * @memberof UnifiedProductMVPRequest
     */
    'license_id'?: number | null;
    /**
     * Product category ID for the product
     * @type {number}
     * @memberof UnifiedProductMVPRequest
     */
    'category_id': number;
    /**
     * Product sub-category ID for the product
     * @type {number}
     * @memberof UnifiedProductMVPRequest
     */
    'sub_category_id'?: number;
    /**
     * Base unit of measure ID for this product
     * @type {number}
     * @memberof UnifiedProductMVPRequest
     */
    'unit_of_measure_id': number;
    /**
     * The ID of amount of individual products in one sale unit
     * @type {number}
     * @memberof UnifiedProductMVPRequest
     */
    'unit_denomination_id': number;
    /**
     * Product listing state. Values available at the /listing-states/ endpoint.
     * @type {ListingStateEnum}
     * @memberof UnifiedProductMVPRequest
     */
    'listing_state': ListingStateEnum;
    /**
     * Brand Description
     * @type {string}
     * @memberof UnifiedProductMVPRequest
     */
    'description': string;
    /**
     * 
     * @type {PatchedUnifiedProductMVPRequestWholesalePrice}
     * @memberof UnifiedProductMVPRequest
     */
    'wholesale_price': PatchedUnifiedProductMVPRequestWholesalePrice;
    /**
     * 
     * @type {PatchedUnifiedProductMVPRequestRetailPrice}
     * @memberof UnifiedProductMVPRequest
     */
    'retail_price': PatchedUnifiedProductMVPRequestRetailPrice;
    /**
     * The cannabis strains associated with this product
     * @type {Array<number>}
     * @memberof UnifiedProductMVPRequest
     */
    'strains'?: Array<number>;
    /**
     * 
     * @type {PatchedUnifiedProductMVPRequestStrainClassification}
     * @memberof UnifiedProductMVPRequest
     */
    'strain_classification'?: PatchedUnifiedProductMVPRequestStrainClassification;
    /**
     * Is this a medical line item?
     * @type {boolean}
     * @memberof UnifiedProductMVPRequest
     */
    'is_medical_line_item'?: boolean;
    /**
     * 
     * @type {PatchedUnifiedProductMVPRequestGrowType}
     * @memberof UnifiedProductMVPRequest
     */
    'grow_type'?: PatchedUnifiedProductMVPRequestGrowType;
    /**
     * Number of base units in one unit of this product
     * @type {string}
     * @memberof UnifiedProductMVPRequest
     */
    'base_units_per_unit'?: string | null;
    /**
     * Threshold configuration for inventory alerts
     * @type {ThresholdRequest}
     * @memberof UnifiedProductMVPRequest
     */
    'threshold'?: ThresholdRequest | null;
    /**
     * 
     * @type {Array<UnifiedProductSpecificationItemRequest>}
     * @memberof UnifiedProductMVPRequest
     */
    'product_specification_items'?: Array<UnifiedProductSpecificationItemRequest>;
}


/**
 * Unified Product serializer.
 * @export
 * @interface UnifiedProductRequest
 */
export interface UnifiedProductRequest {
    /**
     * Product name
     * @type {string}
     * @memberof UnifiedProductRequest
     */
    'name': string;
    /**
     * Product details
     * @type {string}
     * @memberof UnifiedProductRequest
     */
    'description': string;
    /**
     * Product category ID for the product
     * @type {number}
     * @memberof UnifiedProductRequest
     */
    'category_id': number;
    /**
     * Product listing state. Values available at the /listing-states/ endpoint.
     * @type {ListingStateEnum}
     * @memberof UnifiedProductRequest
     */
    'listing_state': ListingStateEnum;
    /**
     * 
     * @type {PatchedUnifiedProductMVPRequestWholesalePrice}
     * @memberof UnifiedProductRequest
     */
    'wholesale_price': PatchedUnifiedProductMVPRequestWholesalePrice;
    /**
     * How many individual units are sold when compared to the assigned unit of measure
     * @type {number}
     * @memberof UnifiedProductRequest
     */
    'unit_multiplier'?: number;
    /**
     * The amount of individual products in one sale unit
     * @type {string}
     * @memberof UnifiedProductRequest
     */
    'unit_denomination': string;
    /**
     * Stock keeping unit for the product
     * @type {string}
     * @memberof UnifiedProductRequest
     */
    'sku'?: string | null;
    /**
     * Brand ID for the product
     * @type {number}
     * @memberof UnifiedProductRequest
     */
    'brand_id': number;
    /**
     * ID of the Company that manufactured the product
     * @type {number}
     * @memberof UnifiedProductRequest
     */
    'manufacturer_id': number;
    /**
     * Company who is selling the Product
     * @type {number}
     * @memberof UnifiedProductRequest
     */
    'seller_id': number;
    /**
     * Base unit of measure for this product
     * @type {string}
     * @memberof UnifiedProductRequest
     */
    'unit_of_measure': string;
}


/**
 * Unified Product Specification serializer.
 * @export
 * @interface UnifiedProductSpecification
 */
export interface UnifiedProductSpecification {
    /**
     * 
     * @type {number}
     * @memberof UnifiedProductSpecification
     */
    'id': number;
    /**
     * Date and time the resource was created
     * @type {string}
     * @memberof UnifiedProductSpecification
     */
    'created_date': string;
    /**
     * Date and time of the last edit
     * @type {string}
     * @memberof UnifiedProductSpecification
     */
    'modified_date': string;
    /**
     * 
     * @type {string}
     * @memberof UnifiedProductSpecification
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof UnifiedProductSpecification
     */
    'slug': string;
    /**
     * 
     * @type {boolean}
     * @memberof UnifiedProductSpecification
     */
    'show_text': boolean;
    /**
     * Product Data Parent
     * @type {number}
     * @memberof UnifiedProductSpecification
     */
    'parent_id': number | null;
}
/**
 * Serializer for a product data item.
 * @export
 * @interface UnifiedProductSpecificationItem
 */
export interface UnifiedProductSpecificationItem {
    /**
     * 
     * @type {number}
     * @memberof UnifiedProductSpecificationItem
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof UnifiedProductSpecificationItem
     */
    'decimal_value'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UnifiedProductSpecificationItem
     */
    'max_decimal_value'?: string | null;
    /**
     * Text value of product data
     * @type {string}
     * @memberof UnifiedProductSpecificationItem
     */
    'text_value'?: string;
    /**
     * 
     * @type {UnifiedProductSpecification}
     * @memberof UnifiedProductSpecificationItem
     */
    'product_specification': UnifiedProductSpecification;
    /**
     * 
     * @type {UnifiedProductDosageUnit}
     * @memberof UnifiedProductSpecificationItem
     */
    'unit': UnifiedProductDosageUnit;
}
/**
 * Serializer for a product data item.
 * @export
 * @interface UnifiedProductSpecificationItemRequest
 */
export interface UnifiedProductSpecificationItemRequest {
    /**
     * 
     * @type {number}
     * @memberof UnifiedProductSpecificationItemRequest
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof UnifiedProductSpecificationItemRequest
     */
    'decimal_value'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UnifiedProductSpecificationItemRequest
     */
    'max_decimal_value'?: string | null;
    /**
     * Text value of product data
     * @type {string}
     * @memberof UnifiedProductSpecificationItemRequest
     */
    'text_value'?: string;
    /**
     * Product Specification ID for the product
     * @type {number}
     * @memberof UnifiedProductSpecificationItemRequest
     */
    'product_specification_id': number;
    /**
     * Product Dosage Unit ID for the product
     * @type {number}
     * @memberof UnifiedProductSpecificationItemRequest
     */
    'unit_id': number;
}
/**
 * Unified Product Subcategory serializer
 * @export
 * @interface UnifiedProductSubCategory
 */
export interface UnifiedProductSubCategory {
    /**
     * 
     * @type {number}
     * @memberof UnifiedProductSubCategory
     */
    'id': number;
    /**
     * Name of Sub-Category
     * @type {string}
     * @memberof UnifiedProductSubCategory
     */
    'name': string;
    /**
     * The parent category of this sub-category
     * @type {number}
     * @memberof UnifiedProductSubCategory
     */
    'category': number;
    /**
     * The base unit of measure for this sub-category. Used for price comparisons.
     * @type {number}
     * @memberof UnifiedProductSubCategory
     */
    'base_unit_of_measure'?: number | null;
}
/**
 * Base serializer class to rename created_on and modified fields to follow new naming standard of created_date and modified_date
 * @export
 * @interface UnifiedProductTemplate
 */
export interface UnifiedProductTemplate {
    /**
     * 
     * @type {number}
     * @memberof UnifiedProductTemplate
     */
    'id': number;
    /**
     * Date and time the resource was created
     * @type {string}
     * @memberof UnifiedProductTemplate
     */
    'created_date': string;
    /**
     * Date and time of the last edit
     * @type {string}
     * @memberof UnifiedProductTemplate
     */
    'modified_date': string;
    /**
     * Template Name
     * @type {string}
     * @memberof UnifiedProductTemplate
     */
    'template_name': string;
    /**
     * 
     * @type {PatchedUnifiedProductTemplateRequestListingState}
     * @memberof UnifiedProductTemplate
     */
    'listing_state'?: PatchedUnifiedProductTemplateRequestListingState | null;
    /**
     * 
     * @type {ProductInventoryManagement}
     * @memberof UnifiedProductTemplate
     */
    'inventory_management'?: ProductInventoryManagement;
    /**
     * Unit of measure
     * @type {number}
     * @memberof UnifiedProductTemplate
     */
    'unit_of_measure'?: number | null;
    /**
     * Unit of measure that buyers see
     * @type {number}
     * @memberof UnifiedProductTemplate
     */
    'sell_in_unit_of_measure'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof UnifiedProductTemplate
     */
    'sell_in_multiples'?: boolean;
    /**
     * How many individual units are sold when checking out by Unit of Measure
     * @type {number}
     * @memberof UnifiedProductTemplate
     */
    'unit_multiplier'?: number | null;
    /**
     * The denomination of unit for the Product.
     * @type {number}
     * @memberof UnifiedProductTemplate
     */
    'unit_denomination'?: number | null;
    /**
     * Number of base units in one unit of this product template
     * @type {string}
     * @memberof UnifiedProductTemplate
     */
    'base_units_per_unit'?: string | null;
    /**
     * Manufacturer\'s Suggested Retail Price (MSRP)
     * @type {string}
     * @memberof UnifiedProductTemplate
     */
    'retail_price'?: string | null;
    /**
     * Max Wholesale Price
     * @type {string}
     * @memberof UnifiedProductTemplate
     */
    'wholesale_price'?: string | null;
    /**
     * Sale Price
     * @type {string}
     * @memberof UnifiedProductTemplate
     */
    'sale_price'?: string | null;
    /**
     * Minimum Units per Order
     * @type {string}
     * @memberof UnifiedProductTemplate
     */
    'minimum_order'?: string | null;
    /**
     * Maximum Units per Order
     * @type {string}
     * @memberof UnifiedProductTemplate
     */
    'maximum_order'?: string | null;
    /**
     * Brand Description
     * @type {string}
     * @memberof UnifiedProductTemplate
     */
    'description'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UnifiedProductTemplate
     */
    'category'?: number | null;
    /**
     * The sub-category of the Product (e.g. Bulk Flower, Live Resin, etc)
     * @type {number}
     * @memberof UnifiedProductTemplate
     */
    'sub_category'?: number | null;
    /**
     * Company who is selling the Product
     * @type {number}
     * @memberof UnifiedProductTemplate
     */
    'seller': number;
    /**
     * Brand of product
     * @type {number}
     * @memberof UnifiedProductTemplate
     */
    'brand'?: number | null;
    /**
     * Product Line of product
     * @type {number}
     * @memberof UnifiedProductTemplate
     */
    'product_line'?: number | null;
    /**
     * 
     * @type {PatchedUnifiedProductTemplateRequestStrainClassification}
     * @memberof UnifiedProductTemplate
     */
    'strain_classification'?: PatchedUnifiedProductTemplateRequestStrainClassification | null;
    /**
     * 
     * @type {number}
     * @memberof UnifiedProductTemplate
     */
    'license'?: number | null;
    /**
     * Show Product Quantity
     * @type {boolean}
     * @memberof UnifiedProductTemplate
     */
    'SHOW_QUANTITY'?: boolean | null;
    /**
     * This product is available for samples
     * @type {boolean}
     * @memberof UnifiedProductTemplate
     */
    'AVAILABLE_FOR_SAMPLES'?: boolean | null;
    /**
     * When Product inventory reaches below this value, take various actions
     * @type {number}
     * @memberof UnifiedProductTemplate
     */
    'threshold_value'?: number | null;
    /**
     * Action to take when Product inventory reaches below a specified value
     * @type {ThresholdActionEnum}
     * @memberof UnifiedProductTemplate
     */
    'threshold_action'?: ThresholdActionEnum;
    /**
     * Is this a medical line item?
     * @type {boolean}
     * @memberof UnifiedProductTemplate
     */
    'is_medical_line_item'?: boolean;
    /**
     * This product quantity can contain decimal places
     * @type {boolean}
     * @memberof UnifiedProductTemplate
     */
    'allow_fractional_quantities'?: boolean | null;
    /**
     * The ID number for an external income account
     * @type {string}
     * @memberof UnifiedProductTemplate
     */
    'extern_income_acct_id': string | null;
    /**
     * Maximum Units per Order
     * @type {string}
     * @memberof UnifiedProductTemplate
     */
    'cost': string | null;
}


/**
 * Base serializer class to rename created_on and modified fields to follow new naming standard of created_date and modified_date
 * @export
 * @interface UnifiedProductTemplateRequest
 */
export interface UnifiedProductTemplateRequest {
    /**
     * Template Name
     * @type {string}
     * @memberof UnifiedProductTemplateRequest
     */
    'template_name': string;
    /**
     * 
     * @type {PatchedUnifiedProductTemplateRequestListingState}
     * @memberof UnifiedProductTemplateRequest
     */
    'listing_state'?: PatchedUnifiedProductTemplateRequestListingState | null;
    /**
     * 
     * @type {ProductInventoryManagement}
     * @memberof UnifiedProductTemplateRequest
     */
    'inventory_management'?: ProductInventoryManagement;
    /**
     * Unit of measure
     * @type {number}
     * @memberof UnifiedProductTemplateRequest
     */
    'unit_of_measure'?: number | null;
    /**
     * Unit of measure that buyers see
     * @type {number}
     * @memberof UnifiedProductTemplateRequest
     */
    'sell_in_unit_of_measure'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof UnifiedProductTemplateRequest
     */
    'sell_in_multiples'?: boolean;
    /**
     * How many individual units are sold when checking out by Unit of Measure
     * @type {number}
     * @memberof UnifiedProductTemplateRequest
     */
    'unit_multiplier'?: number | null;
    /**
     * The denomination of unit for the Product.
     * @type {number}
     * @memberof UnifiedProductTemplateRequest
     */
    'unit_denomination'?: number | null;
    /**
     * Number of base units in one unit of this product template
     * @type {string}
     * @memberof UnifiedProductTemplateRequest
     */
    'base_units_per_unit'?: string | null;
    /**
     * Manufacturer\'s Suggested Retail Price (MSRP)
     * @type {string}
     * @memberof UnifiedProductTemplateRequest
     */
    'retail_price'?: string | null;
    /**
     * Max Wholesale Price
     * @type {string}
     * @memberof UnifiedProductTemplateRequest
     */
    'wholesale_price'?: string | null;
    /**
     * Sale Price
     * @type {string}
     * @memberof UnifiedProductTemplateRequest
     */
    'sale_price'?: string | null;
    /**
     * Minimum Units per Order
     * @type {string}
     * @memberof UnifiedProductTemplateRequest
     */
    'minimum_order'?: string | null;
    /**
     * Maximum Units per Order
     * @type {string}
     * @memberof UnifiedProductTemplateRequest
     */
    'maximum_order'?: string | null;
    /**
     * Brand Description
     * @type {string}
     * @memberof UnifiedProductTemplateRequest
     */
    'description'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UnifiedProductTemplateRequest
     */
    'category'?: number | null;
    /**
     * The sub-category of the Product (e.g. Bulk Flower, Live Resin, etc)
     * @type {number}
     * @memberof UnifiedProductTemplateRequest
     */
    'sub_category'?: number | null;
    /**
     * Company who is selling the Product
     * @type {number}
     * @memberof UnifiedProductTemplateRequest
     */
    'seller': number;
    /**
     * Brand of product
     * @type {number}
     * @memberof UnifiedProductTemplateRequest
     */
    'brand'?: number | null;
    /**
     * Product Line of product
     * @type {number}
     * @memberof UnifiedProductTemplateRequest
     */
    'product_line'?: number | null;
    /**
     * 
     * @type {PatchedUnifiedProductTemplateRequestStrainClassification}
     * @memberof UnifiedProductTemplateRequest
     */
    'strain_classification'?: PatchedUnifiedProductTemplateRequestStrainClassification | null;
    /**
     * 
     * @type {number}
     * @memberof UnifiedProductTemplateRequest
     */
    'license'?: number | null;
    /**
     * Show Product Quantity
     * @type {boolean}
     * @memberof UnifiedProductTemplateRequest
     */
    'SHOW_QUANTITY'?: boolean | null;
    /**
     * This product is available for samples
     * @type {boolean}
     * @memberof UnifiedProductTemplateRequest
     */
    'AVAILABLE_FOR_SAMPLES'?: boolean | null;
    /**
     * When Product inventory reaches below this value, take various actions
     * @type {number}
     * @memberof UnifiedProductTemplateRequest
     */
    'threshold_value'?: number | null;
    /**
     * Action to take when Product inventory reaches below a specified value
     * @type {ThresholdActionEnum}
     * @memberof UnifiedProductTemplateRequest
     */
    'threshold_action'?: ThresholdActionEnum;
    /**
     * Is this a medical line item?
     * @type {boolean}
     * @memberof UnifiedProductTemplateRequest
     */
    'is_medical_line_item'?: boolean;
    /**
     * This product quantity can contain decimal places
     * @type {boolean}
     * @memberof UnifiedProductTemplateRequest
     */
    'allow_fractional_quantities'?: boolean | null;
}


/**
 * 
 * @export
 * @interface UnifiedRecommendedBrand
 */
export interface UnifiedRecommendedBrand {
    /**
     * 
     * @type {number}
     * @memberof UnifiedRecommendedBrand
     */
    'id': number;
    /**
     * Name of the Brand
     * @type {string}
     * @memberof UnifiedRecommendedBrand
     */
    'name': string;
    /**
     * 
     * @type {Sponsorship}
     * @memberof UnifiedRecommendedBrand
     */
    'sponsorship': Sponsorship;
    /**
     * 
     * @type {string}
     * @memberof UnifiedRecommendedBrand
     */
    'image': string;
}
/**
 * 
 * @export
 * @interface UnifiedRecommendedCompany
 */
export interface UnifiedRecommendedCompany {
    /**
     * 
     * @type {number}
     * @memberof UnifiedRecommendedCompany
     */
    'id': number;
    /**
     * Name of Company (Note this is not the same as Brand)
     * @type {string}
     * @memberof UnifiedRecommendedCompany
     */
    'name': string;
    /**
     * 
     * @type {Sponsorship}
     * @memberof UnifiedRecommendedCompany
     */
    'sponsorship': Sponsorship;
    /**
     * 
     * @type {string}
     * @memberof UnifiedRecommendedCompany
     */
    'image': string;
}
/**
 * Unified Strain serializer.
 * @export
 * @interface UnifiedStrain
 */
export interface UnifiedStrain {
    /**
     * 
     * @type {number}
     * @memberof UnifiedStrain
     */
    'id': number;
    /**
     * Date and time the resource was created
     * @type {string}
     * @memberof UnifiedStrain
     */
    'created_date': string;
    /**
     * Date and time of the last edit
     * @type {string}
     * @memberof UnifiedStrain
     */
    'modified_date': string;
    /**
     * Name of Strain
     * @type {string}
     * @memberof UnifiedStrain
     */
    'name': string;
    /**
     * The Company that created the strain.
     * @type {number}
     * @memberof UnifiedStrain
     */
    'company'?: number | null;
    /**
     * 
     * @type {PatchedUnifiedProductMVPRequestStrainClassification}
     * @memberof UnifiedStrain
     */
    'strain_classification': PatchedUnifiedProductMVPRequestStrainClassification;
}
/**
 * TaxSchedule GET Serializer
 * @export
 * @interface UnifiedTaxSchedule
 */
export interface UnifiedTaxSchedule {
    /**
     * 
     * @type {number}
     * @memberof UnifiedTaxSchedule
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof UnifiedTaxSchedule
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof UnifiedTaxSchedule
     */
    'tax_type': string;
    /**
     * 
     * @type {string}
     * @memberof UnifiedTaxSchedule
     */
    'tax_rate': string;
    /**
     * 
     * @type {string}
     * @memberof UnifiedTaxSchedule
     */
    'unit_type': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UnifiedTaxSchedule
     */
    'product_categories': Array<string>;
}
/**
 * Traceability Company Customer Serializer - returns very limited information
 * @export
 * @interface UnifiedTraceabilityCompanyCustomer
 */
export interface UnifiedTraceabilityCompanyCustomer {
    /**
     * 
     * @type {number}
     * @memberof UnifiedTraceabilityCompanyCustomer
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof UnifiedTraceabilityCompanyCustomer
     */
    'display_name': string;
    /**
     * 
     * @type {string}
     * @memberof UnifiedTraceabilityCompanyCustomer
     */
    'license_number': string | null;
    /**
     * 
     * @type {number}
     * @memberof UnifiedTraceabilityCompanyCustomer
     */
    'partner_id': number;
}
/**
 * 
 * @export
 * @interface UnifiedTraceabilityPackageOrders
 */
export interface UnifiedTraceabilityPackageOrders {
    /**
     * 
     * @type {string}
     * @memberof UnifiedTraceabilityPackageOrders
     */
    'short_id': string;
    /**
     * 
     * @type {string}
     * @memberof UnifiedTraceabilityPackageOrders
     */
    'order_number': string;
    /**
     * 
     * @type {boolean}
     * @memberof UnifiedTraceabilityPackageOrders
     */
    'is_post': boolean;
}
/**
 * Unified UnitDenomination serializer.
 * @export
 * @interface UnifiedUnitDenomination
 */
export interface UnifiedUnitDenomination {
    /**
     * 
     * @type {number}
     * @memberof UnifiedUnitDenomination
     */
    'id': number;
    /**
     * Date and time the resource was created
     * @type {string}
     * @memberof UnifiedUnitDenomination
     */
    'created_date': string;
    /**
     * Date and time of the last edit
     * @type {string}
     * @memberof UnifiedUnitDenomination
     */
    'modified_date': string;
    /**
     * Unit Denomination Value
     * @type {string}
     * @memberof UnifiedUnitDenomination
     */
    'value': string;
    /**
     * Name of Unit Denomination
     * @type {string}
     * @memberof UnifiedUnitDenomination
     */
    'name': string;
    /**
     * Unit Denomination label
     * @type {string}
     * @memberof UnifiedUnitDenomination
     */
    'label': string;
    /**
     * Description of Unit Denomination
     * @type {string}
     * @memberof UnifiedUnitDenomination
     */
    'description': string | null;
}
/**
 * Unified UnitOfMeasure serializer.
 * @export
 * @interface UnifiedUnitOfMeasure
 */
export interface UnifiedUnitOfMeasure {
    /**
     * 
     * @type {number}
     * @memberof UnifiedUnitOfMeasure
     */
    'id': number;
    /**
     * Date and time the resource was created
     * @type {string}
     * @memberof UnifiedUnitOfMeasure
     */
    'created_date': string;
    /**
     * Date and time of the last edit
     * @type {string}
     * @memberof UnifiedUnitOfMeasure
     */
    'modified_date': string;
    /**
     * 
     * @type {string}
     * @memberof UnifiedUnitOfMeasure
     */
    'unit': string;
    /**
     * 
     * @type {string}
     * @memberof UnifiedUnitOfMeasure
     */
    'plural': string;
    /**
     * 
     * @type {string}
     * @memberof UnifiedUnitOfMeasure
     */
    'abbreviation': string;
    /**
     * 
     * @type {boolean}
     * @memberof UnifiedUnitOfMeasure
     */
    'multiple': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UnifiedUnitOfMeasure
     */
    'ALLOW_FRACTIONAL': boolean;
    /**
     * 
     * @type {string}
     * @memberof UnifiedUnitOfMeasure
     */
    'universal_name': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UnifiedUnitOfMeasure
     */
    'unconvertible': boolean;
    /**
     * This Unit of Measure is meant to be attached only to SubCategories and not to Products
     * @type {boolean}
     * @memberof UnifiedUnitOfMeasure
     */
    'base_only': boolean;
}
/**
 * 
 * @export
 * @interface UnifiedVendorBrand
 */
export interface UnifiedVendorBrand {
    /**
     * 
     * @type {number}
     * @memberof UnifiedVendorBrand
     */
    'id': number;
    /**
     * Name of the Brand
     * @type {string}
     * @memberof UnifiedVendorBrand
     */
    'name': string;
    /**
     * Image of the Brand\'s logo
     * @type {string}
     * @memberof UnifiedVendorBrand
     */
    'image'?: string | null;
}
/**
 * Unified API Vendor Company Serializer.
 * @export
 * @interface UnifiedVendorCompany
 */
export interface UnifiedVendorCompany {
    /**
     * 
     * @type {number}
     * @memberof UnifiedVendorCompany
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof UnifiedVendorCompany
     */
    'address': string;
    /**
     * 
     * @type {Array<UnifiedVendorBrand>}
     * @memberof UnifiedVendorCompany
     */
    'brands': Array<UnifiedVendorBrand>;
    /**
     * 
     * @type {string}
     * @memberof UnifiedVendorCompany
     */
    'city': string;
    /**
     * An overview of the company
     * @type {string}
     * @memberof UnifiedVendorCompany
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof UnifiedVendorCompany
     */
    'image'?: string | null;
    /**
     * 
     * @type {Array<ComplianceLicense>}
     * @memberof UnifiedVendorCompany
     */
    'licenses': Array<ComplianceLicense>;
    /**
     * Name of Company (Note this is not the same as Brand)
     * @type {string}
     * @memberof UnifiedVendorCompany
     */
    'name': string;
    /**
     * Phone Number of Company
     * @type {string}
     * @memberof UnifiedVendorCompany
     */
    'phone'?: string | null;
    /**
     * company\'s website
     * @type {string}
     * @memberof UnifiedVendorCompany
     */
    'website'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UnifiedVendorCompany
     */
    'address_1': string;
    /**
     * 
     * @type {string}
     * @memberof UnifiedVendorCompany
     */
    'address_2': string;
    /**
     * 
     * @type {Array<BuyerOrder>}
     * @memberof UnifiedVendorCompany
     */
    'orders': Array<BuyerOrder>;
    /**
     * Company tagline
     * @type {string}
     * @memberof UnifiedVendorCompany
     */
    'tagline'?: string | null;
}
/**
 * 
 * @export
 * @interface User
 */
export interface User {
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'display_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'email'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof User
     */
    'id'?: number | null;
}
/**
 * 
 * @export
 * @interface UserRequest
 */
export interface UserRequest {
    /**
     * 
     * @type {string}
     * @memberof UserRequest
     */
    'display_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserRequest
     */
    'email'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UserRequest
     */
    'id'?: number | null;
}
/**
 * Internal serializer for Vehicle Model.
 * @export
 * @interface Vehicle
 */
export interface Vehicle {
    /**
     * 
     * @type {number}
     * @memberof Vehicle
     */
    'id': number;
    /**
     * Vehicle Make
     * @type {string}
     * @memberof Vehicle
     */
    'make'?: string | null;
    /**
     * Vehicle Model Year
     * @type {number}
     * @memberof Vehicle
     */
    'model_year'?: number | null;
    /**
     * Vehicle Model Name
     * @type {string}
     * @memberof Vehicle
     */
    'model_name'?: string | null;
    /**
     * License Number of Vehicle
     * @type {string}
     * @memberof Vehicle
     */
    'license_number': string | null;
    /**
     * Vehicle Capacity
     * @type {number}
     * @memberof Vehicle
     */
    'capacity'?: number | null;
    /**
     * Vehicle Has Air Conditioner
     * @type {boolean}
     * @memberof Vehicle
     */
    'has_air_conditioner'?: boolean;
    /**
     * 
     * @type {StateUnifiedUpstreamMarketplace}
     * @memberof Vehicle
     */
    'state': StateUnifiedUpstreamMarketplace;
}
/**
 * Internal serializer for Vehicle Model.
 * @export
 * @interface VehicleRequest
 */
export interface VehicleRequest {
    /**
     * Vehicle Make
     * @type {string}
     * @memberof VehicleRequest
     */
    'make'?: string | null;
    /**
     * Vehicle Model Year
     * @type {number}
     * @memberof VehicleRequest
     */
    'model_year'?: number | null;
    /**
     * Vehicle Model Name
     * @type {string}
     * @memberof VehicleRequest
     */
    'model_name'?: string | null;
    /**
     * License Number of Vehicle
     * @type {string}
     * @memberof VehicleRequest
     */
    'license_number': string | null;
    /**
     * Vehicle Capacity
     * @type {number}
     * @memberof VehicleRequest
     */
    'capacity'?: number | null;
    /**
     * Vehicle Has Air Conditioner
     * @type {boolean}
     * @memberof VehicleRequest
     */
    'has_air_conditioner'?: boolean;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const VerificationStatusEnum = {
    Active: 'active',
    Pending: 'pending',
    Applied: 'applied',
    Expired: 'expired',
    Inactive: 'inactive',
    NotFound: 'not_found',
    InvalidFormat: 'invalid_format',
    NotVerified: 'not_verified'
} as const;

export type VerificationStatusEnum = typeof VerificationStatusEnum[keyof typeof VerificationStatusEnum];



/**
 * ActiveEntryApi - axios parameter creator
 * @export
 */
export const ActiveEntryApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * List multiple Company Active Entries.
         * @summary List Company Active Entries
         * @param {number} [author] 
         * @param {Array<number>} [authorId] Multiple values may be separated by commas.
         * @param {Array<number>} [brand] Multiple values may be separated by commas.
         * @param {Array<number>} [brandId] Multiple values may be separated by commas.
         * @param {number} [company] 
         * @param {Array<number>} [companyId] Multiple values may be separated by commas.
         * @param {string} [companySlug] 
         * @param {Array<number>} [contact] Multiple values may be separated by commas.
         * @param {Array<number>} [contactId] Multiple values may be separated by commas.
         * @param {string} [createdOnGt] 
         * @param {string} [createdOnGte] 
         * @param {string} [createdOnLt] 
         * @param {string} [createdOnLte] 
         * @param {number} [customer] 
         * @param {Array<number>} [customerId] Multiple values may be separated by commas.
         * @param {string} [dateGt] 
         * @param {string} [dateGte] 
         * @param {string} [dateLt] 
         * @param {string} [dateLte] 
         * @param {boolean} [_delete] 
         * @param {string} [entry] 
         * @param {Array<string>} [entryIn] Multiple values may be separated by commas.
         * @param {string} [entryStartswith] 
         * @param {number} [id] 
         * @param {boolean} [isDeleted] 
         * @param {string} [modifiedGt] 
         * @param {string} [modifiedGte] 
         * @param {string} [modifiedLt] 
         * @param {string} [modifiedLte] 
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [owner] 
         * @param {Array<number>} [ownerId] Multiple values may be separated by commas.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {number} [staff] 
         * @param {Array<number>} [staffId] Multiple values may be separated by commas.
         * @param {Array<string>} [type] Multiple values may be separated by commas.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersActiveEntriesList: async (author?: number, authorId?: Array<number>, brand?: Array<number>, brandId?: Array<number>, company?: number, companyId?: Array<number>, companySlug?: string, contact?: Array<number>, contactId?: Array<number>, createdOnGt?: string, createdOnGte?: string, createdOnLt?: string, createdOnLte?: string, customer?: number, customerId?: Array<number>, dateGt?: string, dateGte?: string, dateLt?: string, dateLte?: string, _delete?: boolean, entry?: string, entryIn?: Array<string>, entryStartswith?: string, id?: number, isDeleted?: boolean, modifiedGt?: string, modifiedGte?: string, modifiedLt?: string, modifiedLte?: string, ordering?: string, owner?: number, ownerId?: Array<number>, page?: number, pageSize?: number, search?: string, staff?: number, staffId?: Array<number>, type?: Array<string>, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/customers/active_entries`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (author !== undefined) {
                localVarQueryParameter['author'] = author;
            }

            if (authorId) {
                localVarQueryParameter['author_id'] = authorId.join(COLLECTION_FORMATS.csv);
            }

            if (brand) {
                localVarQueryParameter['brand'] = brand.join(COLLECTION_FORMATS.csv);
            }

            if (brandId) {
                localVarQueryParameter['brand_id'] = brandId.join(COLLECTION_FORMATS.csv);
            }

            if (company !== undefined) {
                localVarQueryParameter['company'] = company;
            }

            if (companyId) {
                localVarQueryParameter['company_id'] = companyId.join(COLLECTION_FORMATS.csv);
            }

            if (companySlug !== undefined) {
                localVarQueryParameter['company_slug'] = companySlug;
            }

            if (contact) {
                localVarQueryParameter['contact'] = contact.join(COLLECTION_FORMATS.csv);
            }

            if (contactId) {
                localVarQueryParameter['contact_id'] = contactId.join(COLLECTION_FORMATS.csv);
            }

            if (createdOnGt !== undefined) {
                localVarQueryParameter['created_on__gt'] = (createdOnGt as any instanceof Date) ?
                    (createdOnGt as any).toISOString() :
                    createdOnGt;
            }

            if (createdOnGte !== undefined) {
                localVarQueryParameter['created_on__gte'] = (createdOnGte as any instanceof Date) ?
                    (createdOnGte as any).toISOString() :
                    createdOnGte;
            }

            if (createdOnLt !== undefined) {
                localVarQueryParameter['created_on__lt'] = (createdOnLt as any instanceof Date) ?
                    (createdOnLt as any).toISOString() :
                    createdOnLt;
            }

            if (createdOnLte !== undefined) {
                localVarQueryParameter['created_on__lte'] = (createdOnLte as any instanceof Date) ?
                    (createdOnLte as any).toISOString() :
                    createdOnLte;
            }

            if (customer !== undefined) {
                localVarQueryParameter['customer'] = customer;
            }

            if (customerId) {
                localVarQueryParameter['customer_id'] = customerId.join(COLLECTION_FORMATS.csv);
            }

            if (dateGt !== undefined) {
                localVarQueryParameter['date__gt'] = (dateGt as any instanceof Date) ?
                    (dateGt as any).toISOString() :
                    dateGt;
            }

            if (dateGte !== undefined) {
                localVarQueryParameter['date__gte'] = (dateGte as any instanceof Date) ?
                    (dateGte as any).toISOString() :
                    dateGte;
            }

            if (dateLt !== undefined) {
                localVarQueryParameter['date__lt'] = (dateLt as any instanceof Date) ?
                    (dateLt as any).toISOString() :
                    dateLt;
            }

            if (dateLte !== undefined) {
                localVarQueryParameter['date__lte'] = (dateLte as any instanceof Date) ?
                    (dateLte as any).toISOString() :
                    dateLte;
            }

            if (_delete !== undefined) {
                localVarQueryParameter['delete'] = _delete;
            }

            if (entry !== undefined) {
                localVarQueryParameter['entry'] = entry;
            }

            if (entryIn) {
                localVarQueryParameter['entry__in'] = entryIn.join(COLLECTION_FORMATS.csv);
            }

            if (entryStartswith !== undefined) {
                localVarQueryParameter['entry__startswith'] = entryStartswith;
            }

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (isDeleted !== undefined) {
                localVarQueryParameter['is_deleted'] = isDeleted;
            }

            if (modifiedGt !== undefined) {
                localVarQueryParameter['modified__gt'] = (modifiedGt as any instanceof Date) ?
                    (modifiedGt as any).toISOString() :
                    modifiedGt;
            }

            if (modifiedGte !== undefined) {
                localVarQueryParameter['modified__gte'] = (modifiedGte as any instanceof Date) ?
                    (modifiedGte as any).toISOString() :
                    modifiedGte;
            }

            if (modifiedLt !== undefined) {
                localVarQueryParameter['modified__lt'] = (modifiedLt as any instanceof Date) ?
                    (modifiedLt as any).toISOString() :
                    modifiedLt;
            }

            if (modifiedLte !== undefined) {
                localVarQueryParameter['modified__lte'] = (modifiedLte as any instanceof Date) ?
                    (modifiedLte as any).toISOString() :
                    modifiedLte;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }

            if (owner !== undefined) {
                localVarQueryParameter['owner'] = owner;
            }

            if (ownerId) {
                localVarQueryParameter['owner_id'] = ownerId.join(COLLECTION_FORMATS.csv);
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (staff !== undefined) {
                localVarQueryParameter['staff'] = staff;
            }

            if (staffId) {
                localVarQueryParameter['staff_id'] = staffId.join(COLLECTION_FORMATS.csv);
            }

            if (type) {
                localVarQueryParameter['type'] = type.join(COLLECTION_FORMATS.csv);
            }


    
            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a single Company Active Entry.
         * @summary Get Active Entry
         * @param {number} id A unique integer value identifying this company activity entry.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersActiveEntriesRetrieve: async (id: number, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('customersActiveEntriesRetrieve', 'id', id)
            const localVarPath = `/customers/active_entries/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ActiveEntryApi - functional programming interface
 * @export
 */
export const ActiveEntryApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ActiveEntryApiAxiosParamCreator(configuration)
    return {
        /**
         * List multiple Company Active Entries.
         * @summary List Company Active Entries
         * @param {number} [author] 
         * @param {Array<number>} [authorId] Multiple values may be separated by commas.
         * @param {Array<number>} [brand] Multiple values may be separated by commas.
         * @param {Array<number>} [brandId] Multiple values may be separated by commas.
         * @param {number} [company] 
         * @param {Array<number>} [companyId] Multiple values may be separated by commas.
         * @param {string} [companySlug] 
         * @param {Array<number>} [contact] Multiple values may be separated by commas.
         * @param {Array<number>} [contactId] Multiple values may be separated by commas.
         * @param {string} [createdOnGt] 
         * @param {string} [createdOnGte] 
         * @param {string} [createdOnLt] 
         * @param {string} [createdOnLte] 
         * @param {number} [customer] 
         * @param {Array<number>} [customerId] Multiple values may be separated by commas.
         * @param {string} [dateGt] 
         * @param {string} [dateGte] 
         * @param {string} [dateLt] 
         * @param {string} [dateLte] 
         * @param {boolean} [_delete] 
         * @param {string} [entry] 
         * @param {Array<string>} [entryIn] Multiple values may be separated by commas.
         * @param {string} [entryStartswith] 
         * @param {number} [id] 
         * @param {boolean} [isDeleted] 
         * @param {string} [modifiedGt] 
         * @param {string} [modifiedGte] 
         * @param {string} [modifiedLt] 
         * @param {string} [modifiedLte] 
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [owner] 
         * @param {Array<number>} [ownerId] Multiple values may be separated by commas.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {number} [staff] 
         * @param {Array<number>} [staffId] Multiple values may be separated by commas.
         * @param {Array<string>} [type] Multiple values may be separated by commas.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async customersActiveEntriesList(author?: number, authorId?: Array<number>, brand?: Array<number>, brandId?: Array<number>, company?: number, companyId?: Array<number>, companySlug?: string, contact?: Array<number>, contactId?: Array<number>, createdOnGt?: string, createdOnGte?: string, createdOnLt?: string, createdOnLte?: string, customer?: number, customerId?: Array<number>, dateGt?: string, dateGte?: string, dateLt?: string, dateLte?: string, _delete?: boolean, entry?: string, entryIn?: Array<string>, entryStartswith?: string, id?: number, isDeleted?: boolean, modifiedGt?: string, modifiedGte?: string, modifiedLt?: string, modifiedLte?: string, ordering?: string, owner?: number, ownerId?: Array<number>, page?: number, pageSize?: number, search?: string, staff?: number, staffId?: Array<number>, type?: Array<string>, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.customersActiveEntriesList(author, authorId, brand, brandId, company, companyId, companySlug, contact, contactId, createdOnGt, createdOnGte, createdOnLt, createdOnLte, customer, customerId, dateGt, dateGte, dateLt, dateLte, _delete, entry, entryIn, entryStartswith, id, isDeleted, modifiedGt, modifiedGte, modifiedLt, modifiedLte, ordering, owner, ownerId, page, pageSize, search, staff, staffId, type, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActiveEntryApi.customersActiveEntriesList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a single Company Active Entry.
         * @summary Get Active Entry
         * @param {number} id A unique integer value identifying this company activity entry.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async customersActiveEntriesRetrieve(id: number, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.customersActiveEntriesRetrieve(id, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActiveEntryApi.customersActiveEntriesRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ActiveEntryApi - factory interface
 * @export
 */
export const ActiveEntryApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ActiveEntryApiFp(configuration)
    return {
        /**
         * List multiple Company Active Entries.
         * @summary List Company Active Entries
         * @param {ActiveEntryApiCustomersActiveEntriesListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersActiveEntriesList(requestParameters: ActiveEntryApiCustomersActiveEntriesListRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.customersActiveEntriesList(requestParameters.author, requestParameters.authorId, requestParameters.brand, requestParameters.brandId, requestParameters.company, requestParameters.companyId, requestParameters.companySlug, requestParameters.contact, requestParameters.contactId, requestParameters.createdOnGt, requestParameters.createdOnGte, requestParameters.createdOnLt, requestParameters.createdOnLte, requestParameters.customer, requestParameters.customerId, requestParameters.dateGt, requestParameters.dateGte, requestParameters.dateLt, requestParameters.dateLte, requestParameters._delete, requestParameters.entry, requestParameters.entryIn, requestParameters.entryStartswith, requestParameters.id, requestParameters.isDeleted, requestParameters.modifiedGt, requestParameters.modifiedGte, requestParameters.modifiedLt, requestParameters.modifiedLte, requestParameters.ordering, requestParameters.owner, requestParameters.ownerId, requestParameters.page, requestParameters.pageSize, requestParameters.search, requestParameters.staff, requestParameters.staffId, requestParameters.type, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a single Company Active Entry.
         * @summary Get Active Entry
         * @param {ActiveEntryApiCustomersActiveEntriesRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersActiveEntriesRetrieve(requestParameters: ActiveEntryApiCustomersActiveEntriesRetrieveRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.customersActiveEntriesRetrieve(requestParameters.id, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for customersActiveEntriesList operation in ActiveEntryApi.
 * @export
 * @interface ActiveEntryApiCustomersActiveEntriesListRequest
 */
export interface ActiveEntryApiCustomersActiveEntriesListRequest {
    /**
     * 
     * @type {number}
     * @memberof ActiveEntryApiCustomersActiveEntriesList
     */
    readonly author?: number

    /**
     * Multiple values may be separated by commas.
     * @type {Array<number>}
     * @memberof ActiveEntryApiCustomersActiveEntriesList
     */
    readonly authorId?: Array<number>

    /**
     * Multiple values may be separated by commas.
     * @type {Array<number>}
     * @memberof ActiveEntryApiCustomersActiveEntriesList
     */
    readonly brand?: Array<number>

    /**
     * Multiple values may be separated by commas.
     * @type {Array<number>}
     * @memberof ActiveEntryApiCustomersActiveEntriesList
     */
    readonly brandId?: Array<number>

    /**
     * 
     * @type {number}
     * @memberof ActiveEntryApiCustomersActiveEntriesList
     */
    readonly company?: number

    /**
     * Multiple values may be separated by commas.
     * @type {Array<number>}
     * @memberof ActiveEntryApiCustomersActiveEntriesList
     */
    readonly companyId?: Array<number>

    /**
     * 
     * @type {string}
     * @memberof ActiveEntryApiCustomersActiveEntriesList
     */
    readonly companySlug?: string

    /**
     * Multiple values may be separated by commas.
     * @type {Array<number>}
     * @memberof ActiveEntryApiCustomersActiveEntriesList
     */
    readonly contact?: Array<number>

    /**
     * Multiple values may be separated by commas.
     * @type {Array<number>}
     * @memberof ActiveEntryApiCustomersActiveEntriesList
     */
    readonly contactId?: Array<number>

    /**
     * 
     * @type {string}
     * @memberof ActiveEntryApiCustomersActiveEntriesList
     */
    readonly createdOnGt?: string

    /**
     * 
     * @type {string}
     * @memberof ActiveEntryApiCustomersActiveEntriesList
     */
    readonly createdOnGte?: string

    /**
     * 
     * @type {string}
     * @memberof ActiveEntryApiCustomersActiveEntriesList
     */
    readonly createdOnLt?: string

    /**
     * 
     * @type {string}
     * @memberof ActiveEntryApiCustomersActiveEntriesList
     */
    readonly createdOnLte?: string

    /**
     * 
     * @type {number}
     * @memberof ActiveEntryApiCustomersActiveEntriesList
     */
    readonly customer?: number

    /**
     * Multiple values may be separated by commas.
     * @type {Array<number>}
     * @memberof ActiveEntryApiCustomersActiveEntriesList
     */
    readonly customerId?: Array<number>

    /**
     * 
     * @type {string}
     * @memberof ActiveEntryApiCustomersActiveEntriesList
     */
    readonly dateGt?: string

    /**
     * 
     * @type {string}
     * @memberof ActiveEntryApiCustomersActiveEntriesList
     */
    readonly dateGte?: string

    /**
     * 
     * @type {string}
     * @memberof ActiveEntryApiCustomersActiveEntriesList
     */
    readonly dateLt?: string

    /**
     * 
     * @type {string}
     * @memberof ActiveEntryApiCustomersActiveEntriesList
     */
    readonly dateLte?: string

    /**
     * 
     * @type {boolean}
     * @memberof ActiveEntryApiCustomersActiveEntriesList
     */
    readonly _delete?: boolean

    /**
     * 
     * @type {string}
     * @memberof ActiveEntryApiCustomersActiveEntriesList
     */
    readonly entry?: string

    /**
     * Multiple values may be separated by commas.
     * @type {Array<string>}
     * @memberof ActiveEntryApiCustomersActiveEntriesList
     */
    readonly entryIn?: Array<string>

    /**
     * 
     * @type {string}
     * @memberof ActiveEntryApiCustomersActiveEntriesList
     */
    readonly entryStartswith?: string

    /**
     * 
     * @type {number}
     * @memberof ActiveEntryApiCustomersActiveEntriesList
     */
    readonly id?: number

    /**
     * 
     * @type {boolean}
     * @memberof ActiveEntryApiCustomersActiveEntriesList
     */
    readonly isDeleted?: boolean

    /**
     * 
     * @type {string}
     * @memberof ActiveEntryApiCustomersActiveEntriesList
     */
    readonly modifiedGt?: string

    /**
     * 
     * @type {string}
     * @memberof ActiveEntryApiCustomersActiveEntriesList
     */
    readonly modifiedGte?: string

    /**
     * 
     * @type {string}
     * @memberof ActiveEntryApiCustomersActiveEntriesList
     */
    readonly modifiedLt?: string

    /**
     * 
     * @type {string}
     * @memberof ActiveEntryApiCustomersActiveEntriesList
     */
    readonly modifiedLte?: string

    /**
     * Which field to use when ordering the results.
     * @type {string}
     * @memberof ActiveEntryApiCustomersActiveEntriesList
     */
    readonly ordering?: string

    /**
     * 
     * @type {number}
     * @memberof ActiveEntryApiCustomersActiveEntriesList
     */
    readonly owner?: number

    /**
     * Multiple values may be separated by commas.
     * @type {Array<number>}
     * @memberof ActiveEntryApiCustomersActiveEntriesList
     */
    readonly ownerId?: Array<number>

    /**
     * A page number within the paginated result set.
     * @type {number}
     * @memberof ActiveEntryApiCustomersActiveEntriesList
     */
    readonly page?: number

    /**
     * Number of results to return per page.
     * @type {number}
     * @memberof ActiveEntryApiCustomersActiveEntriesList
     */
    readonly pageSize?: number

    /**
     * A search term.
     * @type {string}
     * @memberof ActiveEntryApiCustomersActiveEntriesList
     */
    readonly search?: string

    /**
     * 
     * @type {number}
     * @memberof ActiveEntryApiCustomersActiveEntriesList
     */
    readonly staff?: number

    /**
     * Multiple values may be separated by commas.
     * @type {Array<number>}
     * @memberof ActiveEntryApiCustomersActiveEntriesList
     */
    readonly staffId?: Array<number>

    /**
     * Multiple values may be separated by commas.
     * @type {Array<string>}
     * @memberof ActiveEntryApiCustomersActiveEntriesList
     */
    readonly type?: Array<string>

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof ActiveEntryApiCustomersActiveEntriesList
     */
    readonly leafLinkVersion?: string
}

/**
 * Request parameters for customersActiveEntriesRetrieve operation in ActiveEntryApi.
 * @export
 * @interface ActiveEntryApiCustomersActiveEntriesRetrieveRequest
 */
export interface ActiveEntryApiCustomersActiveEntriesRetrieveRequest {
    /**
     * A unique integer value identifying this company activity entry.
     * @type {number}
     * @memberof ActiveEntryApiCustomersActiveEntriesRetrieve
     */
    readonly id: number

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof ActiveEntryApiCustomersActiveEntriesRetrieve
     */
    readonly leafLinkVersion?: string
}

/**
 * ActiveEntryApi - object-oriented interface
 * @export
 * @class ActiveEntryApi
 * @extends {BaseAPI}
 */
export class ActiveEntryApi extends BaseAPI {
    /**
     * List multiple Company Active Entries.
     * @summary List Company Active Entries
     * @param {ActiveEntryApiCustomersActiveEntriesListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActiveEntryApi
     */
    public customersActiveEntriesList(requestParameters: ActiveEntryApiCustomersActiveEntriesListRequest = {}, options?: RawAxiosRequestConfig) {
        return ActiveEntryApiFp(this.configuration).customersActiveEntriesList(requestParameters.author, requestParameters.authorId, requestParameters.brand, requestParameters.brandId, requestParameters.company, requestParameters.companyId, requestParameters.companySlug, requestParameters.contact, requestParameters.contactId, requestParameters.createdOnGt, requestParameters.createdOnGte, requestParameters.createdOnLt, requestParameters.createdOnLte, requestParameters.customer, requestParameters.customerId, requestParameters.dateGt, requestParameters.dateGte, requestParameters.dateLt, requestParameters.dateLte, requestParameters._delete, requestParameters.entry, requestParameters.entryIn, requestParameters.entryStartswith, requestParameters.id, requestParameters.isDeleted, requestParameters.modifiedGt, requestParameters.modifiedGte, requestParameters.modifiedLt, requestParameters.modifiedLte, requestParameters.ordering, requestParameters.owner, requestParameters.ownerId, requestParameters.page, requestParameters.pageSize, requestParameters.search, requestParameters.staff, requestParameters.staffId, requestParameters.type, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a single Company Active Entry.
     * @summary Get Active Entry
     * @param {ActiveEntryApiCustomersActiveEntriesRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActiveEntryApi
     */
    public customersActiveEntriesRetrieve(requestParameters: ActiveEntryApiCustomersActiveEntriesRetrieveRequest, options?: RawAxiosRequestConfig) {
        return ActiveEntryApiFp(this.configuration).customersActiveEntriesRetrieve(requestParameters.id, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * BillingApi - axios parameter creator
 * @export
 */
export const BillingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Handle GET request for OrderUsage.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        billingM2mOrderUsagesRetrieve: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/billing/m2m/order_usages`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BillingApi - functional programming interface
 * @export
 */
export const BillingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BillingApiAxiosParamCreator(configuration)
    return {
        /**
         * Handle GET request for OrderUsage.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async billingM2mOrderUsagesRetrieve(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.billingM2mOrderUsagesRetrieve(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BillingApi.billingM2mOrderUsagesRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * BillingApi - factory interface
 * @export
 */
export const BillingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BillingApiFp(configuration)
    return {
        /**
         * Handle GET request for OrderUsage.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        billingM2mOrderUsagesRetrieve(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.billingM2mOrderUsagesRetrieve(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BillingApi - object-oriented interface
 * @export
 * @class BillingApi
 * @extends {BaseAPI}
 */
export class BillingApi extends BaseAPI {
    /**
     * Handle GET request for OrderUsage.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillingApi
     */
    public billingM2mOrderUsagesRetrieve(options?: RawAxiosRequestConfig) {
        return BillingApiFp(this.configuration).billingM2mOrderUsagesRetrieve(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * BrandApi - axios parameter creator
 * @export
 */
export const BrandApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * List multiple Brands.
         * @summary List Brands
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        brandsList: async (ordering?: string, page?: number, pageSize?: number, search?: string, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/brands`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List recommended recently purchased Brands.
         * @summary List Recently Purchased Brands
         * @param {number} companyId The ID of the viewing company
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        brandsRecommendedList: async (companyId: number, ordering?: string, page?: number, pageSize?: number, search?: string, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('brandsRecommendedList', 'companyId', companyId)
            const localVarPath = `/brands/recommended`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (companyId !== undefined) {
                localVarQueryParameter['company_id'] = companyId;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a single Brand.
         * @summary Get Brand
         * @param {number} id A unique integer value identifying this brand.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        brandsRetrieve: async (id: number, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('brandsRetrieve', 'id', id)
            const localVarPath = `/brands/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List brands and sponsorships for the Shop Brands page.
         * @summary Shop Brands
         * @param {number} companyId The ID of the viewing company
         * @param {ContentBrandsListingListAncillaryTypeEnum} [ancillaryType] 
         * @param {Array<string>} [badge] Filter by badge code
         * @param {Array<string>} [category] Filter by category slug
         * @param {boolean} [hasOrderedFrom] Filter by brands that were ordered from previously
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {Array<ContentBrandsListingListPaymentMethodEnum>} [paymentMethod] 
         * @param {string} [search] A search term.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contentBrandsListingList: async (companyId: number, ancillaryType?: ContentBrandsListingListAncillaryTypeEnum, badge?: Array<string>, category?: Array<string>, hasOrderedFrom?: boolean, ordering?: string, page?: number, pageSize?: number, paymentMethod?: Array<ContentBrandsListingListPaymentMethodEnum>, search?: string, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('contentBrandsListingList', 'companyId', companyId)
            const localVarPath = `/content/brands/listing`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (ancillaryType !== undefined) {
                localVarQueryParameter['ancillary_type'] = ancillaryType;
            }

            if (badge) {
                localVarQueryParameter['badge'] = badge;
            }

            if (category) {
                localVarQueryParameter['category'] = category;
            }

            if (companyId !== undefined) {
                localVarQueryParameter['company_id'] = companyId;
            }

            if (hasOrderedFrom !== undefined) {
                localVarQueryParameter['has_ordered_from'] = hasOrderedFrom;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (paymentMethod) {
                localVarQueryParameter['payment_method'] = paymentMethod;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BrandApi - functional programming interface
 * @export
 */
export const BrandApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BrandApiAxiosParamCreator(configuration)
    return {
        /**
         * List multiple Brands.
         * @summary List Brands
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async brandsList(ordering?: string, page?: number, pageSize?: number, search?: string, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.brandsList(ordering, page, pageSize, search, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BrandApi.brandsList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List recommended recently purchased Brands.
         * @summary List Recently Purchased Brands
         * @param {number} companyId The ID of the viewing company
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async brandsRecommendedList(companyId: number, ordering?: string, page?: number, pageSize?: number, search?: string, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedUnifiedRecommendedBrandList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.brandsRecommendedList(companyId, ordering, page, pageSize, search, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BrandApi.brandsRecommendedList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a single Brand.
         * @summary Get Brand
         * @param {number} id A unique integer value identifying this brand.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async brandsRetrieve(id: number, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.brandsRetrieve(id, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BrandApi.brandsRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List brands and sponsorships for the Shop Brands page.
         * @summary Shop Brands
         * @param {number} companyId The ID of the viewing company
         * @param {ContentBrandsListingListAncillaryTypeEnum} [ancillaryType] 
         * @param {Array<string>} [badge] Filter by badge code
         * @param {Array<string>} [category] Filter by category slug
         * @param {boolean} [hasOrderedFrom] Filter by brands that were ordered from previously
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {Array<ContentBrandsListingListPaymentMethodEnum>} [paymentMethod] 
         * @param {string} [search] A search term.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async contentBrandsListingList(companyId: number, ancillaryType?: ContentBrandsListingListAncillaryTypeEnum, badge?: Array<string>, category?: Array<string>, hasOrderedFrom?: boolean, ordering?: string, page?: number, pageSize?: number, paymentMethod?: Array<ContentBrandsListingListPaymentMethodEnum>, search?: string, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedBrandListingContentList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.contentBrandsListingList(companyId, ancillaryType, badge, category, hasOrderedFrom, ordering, page, pageSize, paymentMethod, search, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BrandApi.contentBrandsListingList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * BrandApi - factory interface
 * @export
 */
export const BrandApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BrandApiFp(configuration)
    return {
        /**
         * List multiple Brands.
         * @summary List Brands
         * @param {BrandApiBrandsListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        brandsList(requestParameters: BrandApiBrandsListRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.brandsList(requestParameters.ordering, requestParameters.page, requestParameters.pageSize, requestParameters.search, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * List recommended recently purchased Brands.
         * @summary List Recently Purchased Brands
         * @param {BrandApiBrandsRecommendedListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        brandsRecommendedList(requestParameters: BrandApiBrandsRecommendedListRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedUnifiedRecommendedBrandList> {
            return localVarFp.brandsRecommendedList(requestParameters.companyId, requestParameters.ordering, requestParameters.page, requestParameters.pageSize, requestParameters.search, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a single Brand.
         * @summary Get Brand
         * @param {BrandApiBrandsRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        brandsRetrieve(requestParameters: BrandApiBrandsRetrieveRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.brandsRetrieve(requestParameters.id, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * List brands and sponsorships for the Shop Brands page.
         * @summary Shop Brands
         * @param {BrandApiContentBrandsListingListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contentBrandsListingList(requestParameters: BrandApiContentBrandsListingListRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedBrandListingContentList> {
            return localVarFp.contentBrandsListingList(requestParameters.companyId, requestParameters.ancillaryType, requestParameters.badge, requestParameters.category, requestParameters.hasOrderedFrom, requestParameters.ordering, requestParameters.page, requestParameters.pageSize, requestParameters.paymentMethod, requestParameters.search, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for brandsList operation in BrandApi.
 * @export
 * @interface BrandApiBrandsListRequest
 */
export interface BrandApiBrandsListRequest {
    /**
     * Which field to use when ordering the results.
     * @type {string}
     * @memberof BrandApiBrandsList
     */
    readonly ordering?: string

    /**
     * A page number within the paginated result set.
     * @type {number}
     * @memberof BrandApiBrandsList
     */
    readonly page?: number

    /**
     * Number of results to return per page.
     * @type {number}
     * @memberof BrandApiBrandsList
     */
    readonly pageSize?: number

    /**
     * A search term.
     * @type {string}
     * @memberof BrandApiBrandsList
     */
    readonly search?: string

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof BrandApiBrandsList
     */
    readonly leafLinkVersion?: string
}

/**
 * Request parameters for brandsRecommendedList operation in BrandApi.
 * @export
 * @interface BrandApiBrandsRecommendedListRequest
 */
export interface BrandApiBrandsRecommendedListRequest {
    /**
     * The ID of the viewing company
     * @type {number}
     * @memberof BrandApiBrandsRecommendedList
     */
    readonly companyId: number

    /**
     * Which field to use when ordering the results.
     * @type {string}
     * @memberof BrandApiBrandsRecommendedList
     */
    readonly ordering?: string

    /**
     * A page number within the paginated result set.
     * @type {number}
     * @memberof BrandApiBrandsRecommendedList
     */
    readonly page?: number

    /**
     * Number of results to return per page.
     * @type {number}
     * @memberof BrandApiBrandsRecommendedList
     */
    readonly pageSize?: number

    /**
     * A search term.
     * @type {string}
     * @memberof BrandApiBrandsRecommendedList
     */
    readonly search?: string

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof BrandApiBrandsRecommendedList
     */
    readonly leafLinkVersion?: string
}

/**
 * Request parameters for brandsRetrieve operation in BrandApi.
 * @export
 * @interface BrandApiBrandsRetrieveRequest
 */
export interface BrandApiBrandsRetrieveRequest {
    /**
     * A unique integer value identifying this brand.
     * @type {number}
     * @memberof BrandApiBrandsRetrieve
     */
    readonly id: number

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof BrandApiBrandsRetrieve
     */
    readonly leafLinkVersion?: string
}

/**
 * Request parameters for contentBrandsListingList operation in BrandApi.
 * @export
 * @interface BrandApiContentBrandsListingListRequest
 */
export interface BrandApiContentBrandsListingListRequest {
    /**
     * The ID of the viewing company
     * @type {number}
     * @memberof BrandApiContentBrandsListingList
     */
    readonly companyId: number

    /**
     * 
     * @type {'all' | 'preferred'}
     * @memberof BrandApiContentBrandsListingList
     */
    readonly ancillaryType?: ContentBrandsListingListAncillaryTypeEnum

    /**
     * Filter by badge code
     * @type {Array<string>}
     * @memberof BrandApiContentBrandsListingList
     */
    readonly badge?: Array<string>

    /**
     * Filter by category slug
     * @type {Array<string>}
     * @memberof BrandApiContentBrandsListingList
     */
    readonly category?: Array<string>

    /**
     * Filter by brands that were ordered from previously
     * @type {boolean}
     * @memberof BrandApiContentBrandsListingList
     */
    readonly hasOrderedFrom?: boolean

    /**
     * Which field to use when ordering the results.
     * @type {string}
     * @memberof BrandApiContentBrandsListingList
     */
    readonly ordering?: string

    /**
     * A page number within the paginated result set.
     * @type {number}
     * @memberof BrandApiContentBrandsListingList
     */
    readonly page?: number

    /**
     * Number of results to return per page.
     * @type {number}
     * @memberof BrandApiContentBrandsListingList
     */
    readonly pageSize?: number

    /**
     * 
     * @type {Array<'direct_pay' | 'flex_pay' | 'payment_on_sell_through'>}
     * @memberof BrandApiContentBrandsListingList
     */
    readonly paymentMethod?: Array<ContentBrandsListingListPaymentMethodEnum>

    /**
     * A search term.
     * @type {string}
     * @memberof BrandApiContentBrandsListingList
     */
    readonly search?: string

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof BrandApiContentBrandsListingList
     */
    readonly leafLinkVersion?: string
}

/**
 * BrandApi - object-oriented interface
 * @export
 * @class BrandApi
 * @extends {BaseAPI}
 */
export class BrandApi extends BaseAPI {
    /**
     * List multiple Brands.
     * @summary List Brands
     * @param {BrandApiBrandsListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandApi
     */
    public brandsList(requestParameters: BrandApiBrandsListRequest = {}, options?: RawAxiosRequestConfig) {
        return BrandApiFp(this.configuration).brandsList(requestParameters.ordering, requestParameters.page, requestParameters.pageSize, requestParameters.search, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List recommended recently purchased Brands.
     * @summary List Recently Purchased Brands
     * @param {BrandApiBrandsRecommendedListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandApi
     */
    public brandsRecommendedList(requestParameters: BrandApiBrandsRecommendedListRequest, options?: RawAxiosRequestConfig) {
        return BrandApiFp(this.configuration).brandsRecommendedList(requestParameters.companyId, requestParameters.ordering, requestParameters.page, requestParameters.pageSize, requestParameters.search, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a single Brand.
     * @summary Get Brand
     * @param {BrandApiBrandsRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandApi
     */
    public brandsRetrieve(requestParameters: BrandApiBrandsRetrieveRequest, options?: RawAxiosRequestConfig) {
        return BrandApiFp(this.configuration).brandsRetrieve(requestParameters.id, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List brands and sponsorships for the Shop Brands page.
     * @summary Shop Brands
     * @param {BrandApiContentBrandsListingListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandApi
     */
    public contentBrandsListingList(requestParameters: BrandApiContentBrandsListingListRequest, options?: RawAxiosRequestConfig) {
        return BrandApiFp(this.configuration).contentBrandsListingList(requestParameters.companyId, requestParameters.ancillaryType, requestParameters.badge, requestParameters.category, requestParameters.hasOrderedFrom, requestParameters.ordering, requestParameters.page, requestParameters.pageSize, requestParameters.paymentMethod, requestParameters.search, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const ContentBrandsListingListAncillaryTypeEnum = {
    All: 'all',
    Preferred: 'preferred'
} as const;
export type ContentBrandsListingListAncillaryTypeEnum = typeof ContentBrandsListingListAncillaryTypeEnum[keyof typeof ContentBrandsListingListAncillaryTypeEnum];
/**
 * @export
 */
export const ContentBrandsListingListPaymentMethodEnum = {
    DirectPay: 'direct_pay',
    FlexPay: 'flex_pay',
    PaymentOnSellThrough: 'payment_on_sell_through'
} as const;
export type ContentBrandsListingListPaymentMethodEnum = typeof ContentBrandsListingListPaymentMethodEnum[keyof typeof ContentBrandsListingListPaymentMethodEnum];


/**
 * BrandsApi - axios parameter creator
 * @export
 */
export const BrandsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        brandsRecommendedRetrieve: async (id: string, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('brandsRecommendedRetrieve', 'id', id)
            const localVarPath = `/brands/recommended/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BrandsApi - functional programming interface
 * @export
 */
export const BrandsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BrandsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} id 
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async brandsRecommendedRetrieve(id: string, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.brandsRecommendedRetrieve(id, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BrandsApi.brandsRecommendedRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * BrandsApi - factory interface
 * @export
 */
export const BrandsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BrandsApiFp(configuration)
    return {
        /**
         * 
         * @param {BrandsApiBrandsRecommendedRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        brandsRecommendedRetrieve(requestParameters: BrandsApiBrandsRecommendedRetrieveRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.brandsRecommendedRetrieve(requestParameters.id, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for brandsRecommendedRetrieve operation in BrandsApi.
 * @export
 * @interface BrandsApiBrandsRecommendedRetrieveRequest
 */
export interface BrandsApiBrandsRecommendedRetrieveRequest {
    /**
     * 
     * @type {string}
     * @memberof BrandsApiBrandsRecommendedRetrieve
     */
    readonly id: string

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof BrandsApiBrandsRecommendedRetrieve
     */
    readonly leafLinkVersion?: string
}

/**
 * BrandsApi - object-oriented interface
 * @export
 * @class BrandsApi
 * @extends {BaseAPI}
 */
export class BrandsApi extends BaseAPI {
    /**
     * 
     * @param {BrandsApiBrandsRecommendedRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandsApi
     */
    public brandsRecommendedRetrieve(requestParameters: BrandsApiBrandsRecommendedRetrieveRequest, options?: RawAxiosRequestConfig) {
        return BrandsApiFp(this.configuration).brandsRecommendedRetrieve(requestParameters.id, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * BuyerProductImageApi - axios parameter creator
 * @export
 */
export const BuyerProductImageApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * List multiple Product Images.
         * @summary List Product Images
         * @param {number} [company] 
         * @param {string} [companySlug] 
         * @param {Array<number>} [id] Multiple values may be separated by commas.
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {number} [product] 
         * @param {Array<number>} [productId] Multiple values may be separated by commas.
         * @param {string} [search] A search term.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        buyersProductImagesList: async (company?: number, companySlug?: string, id?: Array<number>, ordering?: string, page?: number, pageSize?: number, product?: number, productId?: Array<number>, search?: string, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/buyers/product_images`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (company !== undefined) {
                localVarQueryParameter['company'] = company;
            }

            if (companySlug !== undefined) {
                localVarQueryParameter['company_slug'] = companySlug;
            }

            if (id) {
                localVarQueryParameter['id'] = id.join(COLLECTION_FORMATS.csv);
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (product !== undefined) {
                localVarQueryParameter['product'] = product;
            }

            if (productId) {
                localVarQueryParameter['product__id'] = productId.join(COLLECTION_FORMATS.csv);
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a single Product Image.
         * @summary Get Product Image
         * @param {number} id A unique integer value identifying this product image.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        buyersProductImagesRetrieve: async (id: number, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('buyersProductImagesRetrieve', 'id', id)
            const localVarPath = `/buyers/product_images/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BuyerProductImageApi - functional programming interface
 * @export
 */
export const BuyerProductImageApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BuyerProductImageApiAxiosParamCreator(configuration)
    return {
        /**
         * List multiple Product Images.
         * @summary List Product Images
         * @param {number} [company] 
         * @param {string} [companySlug] 
         * @param {Array<number>} [id] Multiple values may be separated by commas.
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {number} [product] 
         * @param {Array<number>} [productId] Multiple values may be separated by commas.
         * @param {string} [search] A search term.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async buyersProductImagesList(company?: number, companySlug?: string, id?: Array<number>, ordering?: string, page?: number, pageSize?: number, product?: number, productId?: Array<number>, search?: string, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedUnifiedBuyerProductImageList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.buyersProductImagesList(company, companySlug, id, ordering, page, pageSize, product, productId, search, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BuyerProductImageApi.buyersProductImagesList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a single Product Image.
         * @summary Get Product Image
         * @param {number} id A unique integer value identifying this product image.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async buyersProductImagesRetrieve(id: number, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnifiedBuyerProductImage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.buyersProductImagesRetrieve(id, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BuyerProductImageApi.buyersProductImagesRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * BuyerProductImageApi - factory interface
 * @export
 */
export const BuyerProductImageApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BuyerProductImageApiFp(configuration)
    return {
        /**
         * List multiple Product Images.
         * @summary List Product Images
         * @param {BuyerProductImageApiBuyersProductImagesListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        buyersProductImagesList(requestParameters: BuyerProductImageApiBuyersProductImagesListRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedUnifiedBuyerProductImageList> {
            return localVarFp.buyersProductImagesList(requestParameters.company, requestParameters.companySlug, requestParameters.id, requestParameters.ordering, requestParameters.page, requestParameters.pageSize, requestParameters.product, requestParameters.productId, requestParameters.search, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a single Product Image.
         * @summary Get Product Image
         * @param {BuyerProductImageApiBuyersProductImagesRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        buyersProductImagesRetrieve(requestParameters: BuyerProductImageApiBuyersProductImagesRetrieveRequest, options?: RawAxiosRequestConfig): AxiosPromise<UnifiedBuyerProductImage> {
            return localVarFp.buyersProductImagesRetrieve(requestParameters.id, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for buyersProductImagesList operation in BuyerProductImageApi.
 * @export
 * @interface BuyerProductImageApiBuyersProductImagesListRequest
 */
export interface BuyerProductImageApiBuyersProductImagesListRequest {
    /**
     * 
     * @type {number}
     * @memberof BuyerProductImageApiBuyersProductImagesList
     */
    readonly company?: number

    /**
     * 
     * @type {string}
     * @memberof BuyerProductImageApiBuyersProductImagesList
     */
    readonly companySlug?: string

    /**
     * Multiple values may be separated by commas.
     * @type {Array<number>}
     * @memberof BuyerProductImageApiBuyersProductImagesList
     */
    readonly id?: Array<number>

    /**
     * Which field to use when ordering the results.
     * @type {string}
     * @memberof BuyerProductImageApiBuyersProductImagesList
     */
    readonly ordering?: string

    /**
     * A page number within the paginated result set.
     * @type {number}
     * @memberof BuyerProductImageApiBuyersProductImagesList
     */
    readonly page?: number

    /**
     * Number of results to return per page.
     * @type {number}
     * @memberof BuyerProductImageApiBuyersProductImagesList
     */
    readonly pageSize?: number

    /**
     * 
     * @type {number}
     * @memberof BuyerProductImageApiBuyersProductImagesList
     */
    readonly product?: number

    /**
     * Multiple values may be separated by commas.
     * @type {Array<number>}
     * @memberof BuyerProductImageApiBuyersProductImagesList
     */
    readonly productId?: Array<number>

    /**
     * A search term.
     * @type {string}
     * @memberof BuyerProductImageApiBuyersProductImagesList
     */
    readonly search?: string

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof BuyerProductImageApiBuyersProductImagesList
     */
    readonly leafLinkVersion?: string
}

/**
 * Request parameters for buyersProductImagesRetrieve operation in BuyerProductImageApi.
 * @export
 * @interface BuyerProductImageApiBuyersProductImagesRetrieveRequest
 */
export interface BuyerProductImageApiBuyersProductImagesRetrieveRequest {
    /**
     * A unique integer value identifying this product image.
     * @type {number}
     * @memberof BuyerProductImageApiBuyersProductImagesRetrieve
     */
    readonly id: number

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof BuyerProductImageApiBuyersProductImagesRetrieve
     */
    readonly leafLinkVersion?: string
}

/**
 * BuyerProductImageApi - object-oriented interface
 * @export
 * @class BuyerProductImageApi
 * @extends {BaseAPI}
 */
export class BuyerProductImageApi extends BaseAPI {
    /**
     * List multiple Product Images.
     * @summary List Product Images
     * @param {BuyerProductImageApiBuyersProductImagesListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BuyerProductImageApi
     */
    public buyersProductImagesList(requestParameters: BuyerProductImageApiBuyersProductImagesListRequest = {}, options?: RawAxiosRequestConfig) {
        return BuyerProductImageApiFp(this.configuration).buyersProductImagesList(requestParameters.company, requestParameters.companySlug, requestParameters.id, requestParameters.ordering, requestParameters.page, requestParameters.pageSize, requestParameters.product, requestParameters.productId, requestParameters.search, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a single Product Image.
     * @summary Get Product Image
     * @param {BuyerProductImageApiBuyersProductImagesRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BuyerProductImageApi
     */
    public buyersProductImagesRetrieve(requestParameters: BuyerProductImageApiBuyersProductImagesRetrieveRequest, options?: RawAxiosRequestConfig) {
        return BuyerProductImageApiFp(this.configuration).buyersProductImagesRetrieve(requestParameters.id, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ChatsApi - axios parameter creator
 * @export
 */
export const ChatsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Takes a list of chat IDs and updates their status to the given status. Status must be one of: in_progress, completed
         * @summary Bulk update chat status
         * @param {PatchedBulkChatUpdateRequest} [patchedBulkChatUpdateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatsBulkUpdatePartialUpdate: async (patchedBulkChatUpdateRequest?: PatchedBulkChatUpdateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/chats/bulk_update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchedBulkChatUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new discussion with the first message.
         * @param {UnifiedChatsRequest} unifiedChatsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatsCreate: async (unifiedChatsRequest: UnifiedChatsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'unifiedChatsRequest' is not null or undefined
            assertParamExists('chatsCreate', 'unifiedChatsRequest', unifiedChatsRequest)
            const localVarPath = `/chats`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(unifiedChatsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * LeafLink API for Marketplace discussions.
         * @param {number} id A unique integer value identifying this chat.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatsDestroy: async (id: number, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('chatsDestroy', 'id', id)
            const localVarPath = `/chats/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List all discussions
         * @param {string} [fromDate] Filter discussions from this date (YYYY-MM-DD)
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] Search term for filtering messages content
         * @param {string} [status] Filter by discussion status (\&#39;in_progress\&#39; or \&#39;completed\&#39;)
         * @param {string} [toDate] Filter discussions until this date (YYYY-MM-DD)
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatsList: async (fromDate?: string, ordering?: string, page?: number, pageSize?: number, search?: string, status?: string, toDate?: string, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/chats`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (fromDate !== undefined) {
                localVarQueryParameter['from_date'] = fromDate;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (toDate !== undefined) {
                localVarQueryParameter['to_date'] = toDate;
            }


    
            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Mark a specific message as read
         * @param {number} id A unique integer value identifying this chat.
         * @param {number} messageId A unique integer value identifying this message.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {PatchedMessageReadRequest} [patchedMessageReadRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatsMessagesReadPartialUpdate: async (id: number, messageId: number, leafLinkVersion?: string, patchedMessageReadRequest?: PatchedMessageReadRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('chatsMessagesReadPartialUpdate', 'id', id)
            // verify required parameter 'messageId' is not null or undefined
            assertParamExists('chatsMessagesReadPartialUpdate', 'messageId', messageId)
            const localVarPath = `/chats/{id}/messages/{message_id}/read`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"message_id"}}`, encodeURIComponent(String(messageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchedMessageReadRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * LeafLink API for Marketplace discussions.
         * @param {number} id A unique integer value identifying this chat.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {PatchedUnifiedChatsRequest} [patchedUnifiedChatsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatsPartialUpdate: async (id: number, leafLinkVersion?: string, patchedUnifiedChatsRequest?: PatchedUnifiedChatsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('chatsPartialUpdate', 'id', id)
            const localVarPath = `/chats/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchedUnifiedChatsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * LeafLink API for Marketplace discussions.
         * @param {number} id A unique integer value identifying this chat.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatsRetrieve: async (id: number, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('chatsRetrieve', 'id', id)
            const localVarPath = `/chats/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * LeafLink API for Marketplace discussions.
         * @param {number} id A unique integer value identifying this chat.
         * @param {UnifiedChatsRequest} unifiedChatsRequest 
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatsUpdate: async (id: number, unifiedChatsRequest: UnifiedChatsRequest, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('chatsUpdate', 'id', id)
            // verify required parameter 'unifiedChatsRequest' is not null or undefined
            assertParamExists('chatsUpdate', 'unifiedChatsRequest', unifiedChatsRequest)
            const localVarPath = `/chats/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(unifiedChatsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ChatsApi - functional programming interface
 * @export
 */
export const ChatsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ChatsApiAxiosParamCreator(configuration)
    return {
        /**
         * Takes a list of chat IDs and updates their status to the given status. Status must be one of: in_progress, completed
         * @summary Bulk update chat status
         * @param {PatchedBulkChatUpdateRequest} [patchedBulkChatUpdateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async chatsBulkUpdatePartialUpdate(patchedBulkChatUpdateRequest?: PatchedBulkChatUpdateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.chatsBulkUpdatePartialUpdate(patchedBulkChatUpdateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatsApi.chatsBulkUpdatePartialUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new discussion with the first message.
         * @param {UnifiedChatsRequest} unifiedChatsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async chatsCreate(unifiedChatsRequest: UnifiedChatsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnifiedChats>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.chatsCreate(unifiedChatsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatsApi.chatsCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * LeafLink API for Marketplace discussions.
         * @param {number} id A unique integer value identifying this chat.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async chatsDestroy(id: number, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.chatsDestroy(id, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatsApi.chatsDestroy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List all discussions
         * @param {string} [fromDate] Filter discussions from this date (YYYY-MM-DD)
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] Search term for filtering messages content
         * @param {string} [status] Filter by discussion status (\&#39;in_progress\&#39; or \&#39;completed\&#39;)
         * @param {string} [toDate] Filter discussions until this date (YYYY-MM-DD)
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async chatsList(fromDate?: string, ordering?: string, page?: number, pageSize?: number, search?: string, status?: string, toDate?: string, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedUnifiedChatsList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.chatsList(fromDate, ordering, page, pageSize, search, status, toDate, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatsApi.chatsList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Mark a specific message as read
         * @param {number} id A unique integer value identifying this chat.
         * @param {number} messageId A unique integer value identifying this message.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {PatchedMessageReadRequest} [patchedMessageReadRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async chatsMessagesReadPartialUpdate(id: number, messageId: number, leafLinkVersion?: string, patchedMessageReadRequest?: PatchedMessageReadRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnifiedChats>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.chatsMessagesReadPartialUpdate(id, messageId, leafLinkVersion, patchedMessageReadRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatsApi.chatsMessagesReadPartialUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * LeafLink API for Marketplace discussions.
         * @param {number} id A unique integer value identifying this chat.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {PatchedUnifiedChatsRequest} [patchedUnifiedChatsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async chatsPartialUpdate(id: number, leafLinkVersion?: string, patchedUnifiedChatsRequest?: PatchedUnifiedChatsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnifiedChats>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.chatsPartialUpdate(id, leafLinkVersion, patchedUnifiedChatsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatsApi.chatsPartialUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * LeafLink API for Marketplace discussions.
         * @param {number} id A unique integer value identifying this chat.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async chatsRetrieve(id: number, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnifiedChats>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.chatsRetrieve(id, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatsApi.chatsRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * LeafLink API for Marketplace discussions.
         * @param {number} id A unique integer value identifying this chat.
         * @param {UnifiedChatsRequest} unifiedChatsRequest 
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async chatsUpdate(id: number, unifiedChatsRequest: UnifiedChatsRequest, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnifiedChats>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.chatsUpdate(id, unifiedChatsRequest, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatsApi.chatsUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ChatsApi - factory interface
 * @export
 */
export const ChatsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ChatsApiFp(configuration)
    return {
        /**
         * Takes a list of chat IDs and updates their status to the given status. Status must be one of: in_progress, completed
         * @summary Bulk update chat status
         * @param {ChatsApiChatsBulkUpdatePartialUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatsBulkUpdatePartialUpdate(requestParameters: ChatsApiChatsBulkUpdatePartialUpdateRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.chatsBulkUpdatePartialUpdate(requestParameters.patchedBulkChatUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new discussion with the first message.
         * @param {ChatsApiChatsCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatsCreate(requestParameters: ChatsApiChatsCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<UnifiedChats> {
            return localVarFp.chatsCreate(requestParameters.unifiedChatsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * LeafLink API for Marketplace discussions.
         * @param {ChatsApiChatsDestroyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatsDestroy(requestParameters: ChatsApiChatsDestroyRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.chatsDestroy(requestParameters.id, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * List all discussions
         * @param {ChatsApiChatsListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatsList(requestParameters: ChatsApiChatsListRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedUnifiedChatsList> {
            return localVarFp.chatsList(requestParameters.fromDate, requestParameters.ordering, requestParameters.page, requestParameters.pageSize, requestParameters.search, requestParameters.status, requestParameters.toDate, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * Mark a specific message as read
         * @param {ChatsApiChatsMessagesReadPartialUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatsMessagesReadPartialUpdate(requestParameters: ChatsApiChatsMessagesReadPartialUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<UnifiedChats> {
            return localVarFp.chatsMessagesReadPartialUpdate(requestParameters.id, requestParameters.messageId, requestParameters.leafLinkVersion, requestParameters.patchedMessageReadRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * LeafLink API for Marketplace discussions.
         * @param {ChatsApiChatsPartialUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatsPartialUpdate(requestParameters: ChatsApiChatsPartialUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<UnifiedChats> {
            return localVarFp.chatsPartialUpdate(requestParameters.id, requestParameters.leafLinkVersion, requestParameters.patchedUnifiedChatsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * LeafLink API for Marketplace discussions.
         * @param {ChatsApiChatsRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatsRetrieve(requestParameters: ChatsApiChatsRetrieveRequest, options?: RawAxiosRequestConfig): AxiosPromise<UnifiedChats> {
            return localVarFp.chatsRetrieve(requestParameters.id, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * LeafLink API for Marketplace discussions.
         * @param {ChatsApiChatsUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatsUpdate(requestParameters: ChatsApiChatsUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<UnifiedChats> {
            return localVarFp.chatsUpdate(requestParameters.id, requestParameters.unifiedChatsRequest, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for chatsBulkUpdatePartialUpdate operation in ChatsApi.
 * @export
 * @interface ChatsApiChatsBulkUpdatePartialUpdateRequest
 */
export interface ChatsApiChatsBulkUpdatePartialUpdateRequest {
    /**
     * 
     * @type {PatchedBulkChatUpdateRequest}
     * @memberof ChatsApiChatsBulkUpdatePartialUpdate
     */
    readonly patchedBulkChatUpdateRequest?: PatchedBulkChatUpdateRequest
}

/**
 * Request parameters for chatsCreate operation in ChatsApi.
 * @export
 * @interface ChatsApiChatsCreateRequest
 */
export interface ChatsApiChatsCreateRequest {
    /**
     * 
     * @type {UnifiedChatsRequest}
     * @memberof ChatsApiChatsCreate
     */
    readonly unifiedChatsRequest: UnifiedChatsRequest
}

/**
 * Request parameters for chatsDestroy operation in ChatsApi.
 * @export
 * @interface ChatsApiChatsDestroyRequest
 */
export interface ChatsApiChatsDestroyRequest {
    /**
     * A unique integer value identifying this chat.
     * @type {number}
     * @memberof ChatsApiChatsDestroy
     */
    readonly id: number

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof ChatsApiChatsDestroy
     */
    readonly leafLinkVersion?: string
}

/**
 * Request parameters for chatsList operation in ChatsApi.
 * @export
 * @interface ChatsApiChatsListRequest
 */
export interface ChatsApiChatsListRequest {
    /**
     * Filter discussions from this date (YYYY-MM-DD)
     * @type {string}
     * @memberof ChatsApiChatsList
     */
    readonly fromDate?: string

    /**
     * Which field to use when ordering the results.
     * @type {string}
     * @memberof ChatsApiChatsList
     */
    readonly ordering?: string

    /**
     * A page number within the paginated result set.
     * @type {number}
     * @memberof ChatsApiChatsList
     */
    readonly page?: number

    /**
     * Number of results to return per page.
     * @type {number}
     * @memberof ChatsApiChatsList
     */
    readonly pageSize?: number

    /**
     * Search term for filtering messages content
     * @type {string}
     * @memberof ChatsApiChatsList
     */
    readonly search?: string

    /**
     * Filter by discussion status (\&#39;in_progress\&#39; or \&#39;completed\&#39;)
     * @type {string}
     * @memberof ChatsApiChatsList
     */
    readonly status?: string

    /**
     * Filter discussions until this date (YYYY-MM-DD)
     * @type {string}
     * @memberof ChatsApiChatsList
     */
    readonly toDate?: string

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof ChatsApiChatsList
     */
    readonly leafLinkVersion?: string
}

/**
 * Request parameters for chatsMessagesReadPartialUpdate operation in ChatsApi.
 * @export
 * @interface ChatsApiChatsMessagesReadPartialUpdateRequest
 */
export interface ChatsApiChatsMessagesReadPartialUpdateRequest {
    /**
     * A unique integer value identifying this chat.
     * @type {number}
     * @memberof ChatsApiChatsMessagesReadPartialUpdate
     */
    readonly id: number

    /**
     * A unique integer value identifying this message.
     * @type {number}
     * @memberof ChatsApiChatsMessagesReadPartialUpdate
     */
    readonly messageId: number

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof ChatsApiChatsMessagesReadPartialUpdate
     */
    readonly leafLinkVersion?: string

    /**
     * 
     * @type {PatchedMessageReadRequest}
     * @memberof ChatsApiChatsMessagesReadPartialUpdate
     */
    readonly patchedMessageReadRequest?: PatchedMessageReadRequest
}

/**
 * Request parameters for chatsPartialUpdate operation in ChatsApi.
 * @export
 * @interface ChatsApiChatsPartialUpdateRequest
 */
export interface ChatsApiChatsPartialUpdateRequest {
    /**
     * A unique integer value identifying this chat.
     * @type {number}
     * @memberof ChatsApiChatsPartialUpdate
     */
    readonly id: number

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof ChatsApiChatsPartialUpdate
     */
    readonly leafLinkVersion?: string

    /**
     * 
     * @type {PatchedUnifiedChatsRequest}
     * @memberof ChatsApiChatsPartialUpdate
     */
    readonly patchedUnifiedChatsRequest?: PatchedUnifiedChatsRequest
}

/**
 * Request parameters for chatsRetrieve operation in ChatsApi.
 * @export
 * @interface ChatsApiChatsRetrieveRequest
 */
export interface ChatsApiChatsRetrieveRequest {
    /**
     * A unique integer value identifying this chat.
     * @type {number}
     * @memberof ChatsApiChatsRetrieve
     */
    readonly id: number

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof ChatsApiChatsRetrieve
     */
    readonly leafLinkVersion?: string
}

/**
 * Request parameters for chatsUpdate operation in ChatsApi.
 * @export
 * @interface ChatsApiChatsUpdateRequest
 */
export interface ChatsApiChatsUpdateRequest {
    /**
     * A unique integer value identifying this chat.
     * @type {number}
     * @memberof ChatsApiChatsUpdate
     */
    readonly id: number

    /**
     * 
     * @type {UnifiedChatsRequest}
     * @memberof ChatsApiChatsUpdate
     */
    readonly unifiedChatsRequest: UnifiedChatsRequest

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof ChatsApiChatsUpdate
     */
    readonly leafLinkVersion?: string
}

/**
 * ChatsApi - object-oriented interface
 * @export
 * @class ChatsApi
 * @extends {BaseAPI}
 */
export class ChatsApi extends BaseAPI {
    /**
     * Takes a list of chat IDs and updates their status to the given status. Status must be one of: in_progress, completed
     * @summary Bulk update chat status
     * @param {ChatsApiChatsBulkUpdatePartialUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatsApi
     */
    public chatsBulkUpdatePartialUpdate(requestParameters: ChatsApiChatsBulkUpdatePartialUpdateRequest = {}, options?: RawAxiosRequestConfig) {
        return ChatsApiFp(this.configuration).chatsBulkUpdatePartialUpdate(requestParameters.patchedBulkChatUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new discussion with the first message.
     * @param {ChatsApiChatsCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatsApi
     */
    public chatsCreate(requestParameters: ChatsApiChatsCreateRequest, options?: RawAxiosRequestConfig) {
        return ChatsApiFp(this.configuration).chatsCreate(requestParameters.unifiedChatsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * LeafLink API for Marketplace discussions.
     * @param {ChatsApiChatsDestroyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatsApi
     */
    public chatsDestroy(requestParameters: ChatsApiChatsDestroyRequest, options?: RawAxiosRequestConfig) {
        return ChatsApiFp(this.configuration).chatsDestroy(requestParameters.id, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List all discussions
     * @param {ChatsApiChatsListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatsApi
     */
    public chatsList(requestParameters: ChatsApiChatsListRequest = {}, options?: RawAxiosRequestConfig) {
        return ChatsApiFp(this.configuration).chatsList(requestParameters.fromDate, requestParameters.ordering, requestParameters.page, requestParameters.pageSize, requestParameters.search, requestParameters.status, requestParameters.toDate, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Mark a specific message as read
     * @param {ChatsApiChatsMessagesReadPartialUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatsApi
     */
    public chatsMessagesReadPartialUpdate(requestParameters: ChatsApiChatsMessagesReadPartialUpdateRequest, options?: RawAxiosRequestConfig) {
        return ChatsApiFp(this.configuration).chatsMessagesReadPartialUpdate(requestParameters.id, requestParameters.messageId, requestParameters.leafLinkVersion, requestParameters.patchedMessageReadRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * LeafLink API for Marketplace discussions.
     * @param {ChatsApiChatsPartialUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatsApi
     */
    public chatsPartialUpdate(requestParameters: ChatsApiChatsPartialUpdateRequest, options?: RawAxiosRequestConfig) {
        return ChatsApiFp(this.configuration).chatsPartialUpdate(requestParameters.id, requestParameters.leafLinkVersion, requestParameters.patchedUnifiedChatsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * LeafLink API for Marketplace discussions.
     * @param {ChatsApiChatsRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatsApi
     */
    public chatsRetrieve(requestParameters: ChatsApiChatsRetrieveRequest, options?: RawAxiosRequestConfig) {
        return ChatsApiFp(this.configuration).chatsRetrieve(requestParameters.id, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * LeafLink API for Marketplace discussions.
     * @param {ChatsApiChatsUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatsApi
     */
    public chatsUpdate(requestParameters: ChatsApiChatsUpdateRequest, options?: RawAxiosRequestConfig) {
        return ChatsApiFp(this.configuration).chatsUpdate(requestParameters.id, requestParameters.unifiedChatsRequest, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CompanyApi - axios parameter creator
 * @export
 */
export const CompanyApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns cashback statistics for a company.
         * @summary Provide potential cashback earnings for the given marketplace company slug.
         * @param {string} marketplaceSlug 
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesStatsCashbackRetrieve: async (marketplaceSlug: string, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'marketplaceSlug' is not null or undefined
            assertParamExists('companiesStatsCashbackRetrieve', 'marketplaceSlug', marketplaceSlug)
            const localVarPath = `/companies/{marketplace_slug}/stats_cashback`
                .replace(`{${"marketplace_slug"}}`, encodeURIComponent(String(marketplaceSlug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CompanyApi - functional programming interface
 * @export
 */
export const CompanyApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CompanyApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns cashback statistics for a company.
         * @summary Provide potential cashback earnings for the given marketplace company slug.
         * @param {string} marketplaceSlug 
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async companiesStatsCashbackRetrieve(marketplaceSlug: string, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompanyCashbackStats>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.companiesStatsCashbackRetrieve(marketplaceSlug, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompanyApi.companiesStatsCashbackRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CompanyApi - factory interface
 * @export
 */
export const CompanyApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CompanyApiFp(configuration)
    return {
        /**
         * Returns cashback statistics for a company.
         * @summary Provide potential cashback earnings for the given marketplace company slug.
         * @param {CompanyApiCompaniesStatsCashbackRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesStatsCashbackRetrieve(requestParameters: CompanyApiCompaniesStatsCashbackRetrieveRequest, options?: RawAxiosRequestConfig): AxiosPromise<CompanyCashbackStats> {
            return localVarFp.companiesStatsCashbackRetrieve(requestParameters.marketplaceSlug, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for companiesStatsCashbackRetrieve operation in CompanyApi.
 * @export
 * @interface CompanyApiCompaniesStatsCashbackRetrieveRequest
 */
export interface CompanyApiCompaniesStatsCashbackRetrieveRequest {
    /**
     * 
     * @type {string}
     * @memberof CompanyApiCompaniesStatsCashbackRetrieve
     */
    readonly marketplaceSlug: string

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof CompanyApiCompaniesStatsCashbackRetrieve
     */
    readonly leafLinkVersion?: string
}

/**
 * CompanyApi - object-oriented interface
 * @export
 * @class CompanyApi
 * @extends {BaseAPI}
 */
export class CompanyApi extends BaseAPI {
    /**
     * Returns cashback statistics for a company.
     * @summary Provide potential cashback earnings for the given marketplace company slug.
     * @param {CompanyApiCompaniesStatsCashbackRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public companiesStatsCashbackRetrieve(requestParameters: CompanyApiCompaniesStatsCashbackRetrieveRequest, options?: RawAxiosRequestConfig) {
        return CompanyApiFp(this.configuration).companiesStatsCashbackRetrieve(requestParameters.marketplaceSlug, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CompanyMessagesApi - axios parameter creator
 * @export
 */
export const CompanyMessagesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Unified API Buyer Notification Settings.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] Search term for filtering companies by name
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companyMessagesFindSellerList: async (page?: number, pageSize?: number, search?: string, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/company_messages/find_seller`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Unified API Buyer Notification Settings.
         * @param {number} id A unique integer value identifying this company.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companyMessagesFindSellerRetrieve: async (id: number, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('companyMessagesFindSellerRetrieve', 'id', id)
            const localVarPath = `/company_messages/find_seller/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CompanyMessagesApi - functional programming interface
 * @export
 */
export const CompanyMessagesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CompanyMessagesApiAxiosParamCreator(configuration)
    return {
        /**
         * Unified API Buyer Notification Settings.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] Search term for filtering companies by name
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async companyMessagesFindSellerList(page?: number, pageSize?: number, search?: string, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedUnifiedMessagingFindSellerList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.companyMessagesFindSellerList(page, pageSize, search, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompanyMessagesApi.companyMessagesFindSellerList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Unified API Buyer Notification Settings.
         * @param {number} id A unique integer value identifying this company.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async companyMessagesFindSellerRetrieve(id: number, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnifiedMessagingFindSeller>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.companyMessagesFindSellerRetrieve(id, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompanyMessagesApi.companyMessagesFindSellerRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CompanyMessagesApi - factory interface
 * @export
 */
export const CompanyMessagesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CompanyMessagesApiFp(configuration)
    return {
        /**
         * Unified API Buyer Notification Settings.
         * @param {CompanyMessagesApiCompanyMessagesFindSellerListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companyMessagesFindSellerList(requestParameters: CompanyMessagesApiCompanyMessagesFindSellerListRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedUnifiedMessagingFindSellerList> {
            return localVarFp.companyMessagesFindSellerList(requestParameters.page, requestParameters.pageSize, requestParameters.search, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * Unified API Buyer Notification Settings.
         * @param {CompanyMessagesApiCompanyMessagesFindSellerRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companyMessagesFindSellerRetrieve(requestParameters: CompanyMessagesApiCompanyMessagesFindSellerRetrieveRequest, options?: RawAxiosRequestConfig): AxiosPromise<UnifiedMessagingFindSeller> {
            return localVarFp.companyMessagesFindSellerRetrieve(requestParameters.id, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for companyMessagesFindSellerList operation in CompanyMessagesApi.
 * @export
 * @interface CompanyMessagesApiCompanyMessagesFindSellerListRequest
 */
export interface CompanyMessagesApiCompanyMessagesFindSellerListRequest {
    /**
     * A page number within the paginated result set.
     * @type {number}
     * @memberof CompanyMessagesApiCompanyMessagesFindSellerList
     */
    readonly page?: number

    /**
     * Number of results to return per page.
     * @type {number}
     * @memberof CompanyMessagesApiCompanyMessagesFindSellerList
     */
    readonly pageSize?: number

    /**
     * Search term for filtering companies by name
     * @type {string}
     * @memberof CompanyMessagesApiCompanyMessagesFindSellerList
     */
    readonly search?: string

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof CompanyMessagesApiCompanyMessagesFindSellerList
     */
    readonly leafLinkVersion?: string
}

/**
 * Request parameters for companyMessagesFindSellerRetrieve operation in CompanyMessagesApi.
 * @export
 * @interface CompanyMessagesApiCompanyMessagesFindSellerRetrieveRequest
 */
export interface CompanyMessagesApiCompanyMessagesFindSellerRetrieveRequest {
    /**
     * A unique integer value identifying this company.
     * @type {number}
     * @memberof CompanyMessagesApiCompanyMessagesFindSellerRetrieve
     */
    readonly id: number

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof CompanyMessagesApiCompanyMessagesFindSellerRetrieve
     */
    readonly leafLinkVersion?: string
}

/**
 * CompanyMessagesApi - object-oriented interface
 * @export
 * @class CompanyMessagesApi
 * @extends {BaseAPI}
 */
export class CompanyMessagesApi extends BaseAPI {
    /**
     * Unified API Buyer Notification Settings.
     * @param {CompanyMessagesApiCompanyMessagesFindSellerListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyMessagesApi
     */
    public companyMessagesFindSellerList(requestParameters: CompanyMessagesApiCompanyMessagesFindSellerListRequest = {}, options?: RawAxiosRequestConfig) {
        return CompanyMessagesApiFp(this.configuration).companyMessagesFindSellerList(requestParameters.page, requestParameters.pageSize, requestParameters.search, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Unified API Buyer Notification Settings.
     * @param {CompanyMessagesApiCompanyMessagesFindSellerRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyMessagesApi
     */
    public companyMessagesFindSellerRetrieve(requestParameters: CompanyMessagesApiCompanyMessagesFindSellerRetrieveRequest, options?: RawAxiosRequestConfig) {
        return CompanyMessagesApiFp(this.configuration).companyMessagesFindSellerRetrieve(requestParameters.id, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ComplianceApi - axios parameter creator
 * @export
 */
export const ComplianceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Unified API to list company license types
         * @param {number} companyId The ID of the viewing company
         * @param {boolean} [isBuyerLicense] Return buyer license types
         * @param {boolean} [isSellerLicense] Return seller license types
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {boolean} [usedByCompany] Only return license types that are used by the provide company, otherwise return all for the company\&#39;s state
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        complianceLicenseTypesList: async (companyId: number, isBuyerLicense?: boolean, isSellerLicense?: boolean, ordering?: string, page?: number, pageSize?: number, search?: string, usedByCompany?: boolean, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('complianceLicenseTypesList', 'companyId', companyId)
            const localVarPath = `/compliance/license_types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (companyId !== undefined) {
                localVarQueryParameter['company_id'] = companyId;
            }

            if (isBuyerLicense !== undefined) {
                localVarQueryParameter['is_buyer_license'] = isBuyerLicense;
            }

            if (isSellerLicense !== undefined) {
                localVarQueryParameter['is_seller_license'] = isSellerLicense;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (usedByCompany !== undefined) {
                localVarQueryParameter['used_by_company'] = usedByCompany;
            }


    
            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Unified API to list company license types
         * @param {string} id 
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        complianceLicenseTypesRetrieve: async (id: string, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('complianceLicenseTypesRetrieve', 'id', id)
            const localVarPath = `/compliance/license_types/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create new licenses from a list of licenses directly from a seed-to-sale vendor.
         * @param {number} companyId The ID of the viewing company
         * @param {Array<LicenseCreateUpdateRequest>} licenseCreateUpdateRequest 
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        complianceLicensesCreate: async (companyId: number, licenseCreateUpdateRequest: Array<LicenseCreateUpdateRequest>, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('complianceLicensesCreate', 'companyId', companyId)
            // verify required parameter 'licenseCreateUpdateRequest' is not null or undefined
            assertParamExists('complianceLicensesCreate', 'licenseCreateUpdateRequest', licenseCreateUpdateRequest)
            const localVarPath = `/compliance/licenses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (companyId !== undefined) {
                localVarQueryParameter['company_id'] = companyId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(licenseCreateUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Unified API to list company licenses
         * @param {Array<number>} [companyId] Multiple values may be separated by commas.
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        complianceLicensesList: async (companyId?: Array<number>, ordering?: string, page?: number, pageSize?: number, search?: string, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/compliance/licenses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (companyId) {
                localVarQueryParameter['company_id'] = companyId.join(COLLECTION_FORMATS.csv);
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Unified API to list company licenses
         * @param {number} id A unique integer value identifying this license.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        complianceLicensesRetrieve: async (id: number, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('complianceLicensesRetrieve', 'id', id)
            const localVarPath = `/compliance/licenses/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ComplianceApi - functional programming interface
 * @export
 */
export const ComplianceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ComplianceApiAxiosParamCreator(configuration)
    return {
        /**
         * Unified API to list company license types
         * @param {number} companyId The ID of the viewing company
         * @param {boolean} [isBuyerLicense] Return buyer license types
         * @param {boolean} [isSellerLicense] Return seller license types
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {boolean} [usedByCompany] Only return license types that are used by the provide company, otherwise return all for the company\&#39;s state
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async complianceLicenseTypesList(companyId: number, isBuyerLicense?: boolean, isSellerLicense?: boolean, ordering?: string, page?: number, pageSize?: number, search?: string, usedByCompany?: boolean, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedLicenseTypeResponseList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.complianceLicenseTypesList(companyId, isBuyerLicense, isSellerLicense, ordering, page, pageSize, search, usedByCompany, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ComplianceApi.complianceLicenseTypesList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Unified API to list company license types
         * @param {string} id 
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async complianceLicenseTypesRetrieve(id: string, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LicenseTypeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.complianceLicenseTypesRetrieve(id, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ComplianceApi.complianceLicenseTypesRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create new licenses from a list of licenses directly from a seed-to-sale vendor.
         * @param {number} companyId The ID of the viewing company
         * @param {Array<LicenseCreateUpdateRequest>} licenseCreateUpdateRequest 
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async complianceLicensesCreate(companyId: number, licenseCreateUpdateRequest: Array<LicenseCreateUpdateRequest>, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LicensesCreateUpdateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.complianceLicensesCreate(companyId, licenseCreateUpdateRequest, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ComplianceApi.complianceLicensesCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Unified API to list company licenses
         * @param {Array<number>} [companyId] Multiple values may be separated by commas.
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async complianceLicensesList(companyId?: Array<number>, ordering?: string, page?: number, pageSize?: number, search?: string, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedCompanyLicenseList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.complianceLicensesList(companyId, ordering, page, pageSize, search, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ComplianceApi.complianceLicensesList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Unified API to list company licenses
         * @param {number} id A unique integer value identifying this license.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async complianceLicensesRetrieve(id: number, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LicenseCreateUpdateRequest>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.complianceLicensesRetrieve(id, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ComplianceApi.complianceLicensesRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ComplianceApi - factory interface
 * @export
 */
export const ComplianceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ComplianceApiFp(configuration)
    return {
        /**
         * Unified API to list company license types
         * @param {ComplianceApiComplianceLicenseTypesListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        complianceLicenseTypesList(requestParameters: ComplianceApiComplianceLicenseTypesListRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedLicenseTypeResponseList> {
            return localVarFp.complianceLicenseTypesList(requestParameters.companyId, requestParameters.isBuyerLicense, requestParameters.isSellerLicense, requestParameters.ordering, requestParameters.page, requestParameters.pageSize, requestParameters.search, requestParameters.usedByCompany, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * Unified API to list company license types
         * @param {ComplianceApiComplianceLicenseTypesRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        complianceLicenseTypesRetrieve(requestParameters: ComplianceApiComplianceLicenseTypesRetrieveRequest, options?: RawAxiosRequestConfig): AxiosPromise<LicenseTypeResponse> {
            return localVarFp.complianceLicenseTypesRetrieve(requestParameters.id, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * Create new licenses from a list of licenses directly from a seed-to-sale vendor.
         * @param {ComplianceApiComplianceLicensesCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        complianceLicensesCreate(requestParameters: ComplianceApiComplianceLicensesCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<LicensesCreateUpdateResponse> {
            return localVarFp.complianceLicensesCreate(requestParameters.companyId, requestParameters.licenseCreateUpdateRequest, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * Unified API to list company licenses
         * @param {ComplianceApiComplianceLicensesListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        complianceLicensesList(requestParameters: ComplianceApiComplianceLicensesListRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedCompanyLicenseList> {
            return localVarFp.complianceLicensesList(requestParameters.companyId, requestParameters.ordering, requestParameters.page, requestParameters.pageSize, requestParameters.search, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * Unified API to list company licenses
         * @param {ComplianceApiComplianceLicensesRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        complianceLicensesRetrieve(requestParameters: ComplianceApiComplianceLicensesRetrieveRequest, options?: RawAxiosRequestConfig): AxiosPromise<LicenseCreateUpdateRequest> {
            return localVarFp.complianceLicensesRetrieve(requestParameters.id, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for complianceLicenseTypesList operation in ComplianceApi.
 * @export
 * @interface ComplianceApiComplianceLicenseTypesListRequest
 */
export interface ComplianceApiComplianceLicenseTypesListRequest {
    /**
     * The ID of the viewing company
     * @type {number}
     * @memberof ComplianceApiComplianceLicenseTypesList
     */
    readonly companyId: number

    /**
     * Return buyer license types
     * @type {boolean}
     * @memberof ComplianceApiComplianceLicenseTypesList
     */
    readonly isBuyerLicense?: boolean

    /**
     * Return seller license types
     * @type {boolean}
     * @memberof ComplianceApiComplianceLicenseTypesList
     */
    readonly isSellerLicense?: boolean

    /**
     * Which field to use when ordering the results.
     * @type {string}
     * @memberof ComplianceApiComplianceLicenseTypesList
     */
    readonly ordering?: string

    /**
     * A page number within the paginated result set.
     * @type {number}
     * @memberof ComplianceApiComplianceLicenseTypesList
     */
    readonly page?: number

    /**
     * Number of results to return per page.
     * @type {number}
     * @memberof ComplianceApiComplianceLicenseTypesList
     */
    readonly pageSize?: number

    /**
     * A search term.
     * @type {string}
     * @memberof ComplianceApiComplianceLicenseTypesList
     */
    readonly search?: string

    /**
     * Only return license types that are used by the provide company, otherwise return all for the company\&#39;s state
     * @type {boolean}
     * @memberof ComplianceApiComplianceLicenseTypesList
     */
    readonly usedByCompany?: boolean

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof ComplianceApiComplianceLicenseTypesList
     */
    readonly leafLinkVersion?: string
}

/**
 * Request parameters for complianceLicenseTypesRetrieve operation in ComplianceApi.
 * @export
 * @interface ComplianceApiComplianceLicenseTypesRetrieveRequest
 */
export interface ComplianceApiComplianceLicenseTypesRetrieveRequest {
    /**
     * 
     * @type {string}
     * @memberof ComplianceApiComplianceLicenseTypesRetrieve
     */
    readonly id: string

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof ComplianceApiComplianceLicenseTypesRetrieve
     */
    readonly leafLinkVersion?: string
}

/**
 * Request parameters for complianceLicensesCreate operation in ComplianceApi.
 * @export
 * @interface ComplianceApiComplianceLicensesCreateRequest
 */
export interface ComplianceApiComplianceLicensesCreateRequest {
    /**
     * The ID of the viewing company
     * @type {number}
     * @memberof ComplianceApiComplianceLicensesCreate
     */
    readonly companyId: number

    /**
     * 
     * @type {Array<LicenseCreateUpdateRequest>}
     * @memberof ComplianceApiComplianceLicensesCreate
     */
    readonly licenseCreateUpdateRequest: Array<LicenseCreateUpdateRequest>

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof ComplianceApiComplianceLicensesCreate
     */
    readonly leafLinkVersion?: string
}

/**
 * Request parameters for complianceLicensesList operation in ComplianceApi.
 * @export
 * @interface ComplianceApiComplianceLicensesListRequest
 */
export interface ComplianceApiComplianceLicensesListRequest {
    /**
     * Multiple values may be separated by commas.
     * @type {Array<number>}
     * @memberof ComplianceApiComplianceLicensesList
     */
    readonly companyId?: Array<number>

    /**
     * Which field to use when ordering the results.
     * @type {string}
     * @memberof ComplianceApiComplianceLicensesList
     */
    readonly ordering?: string

    /**
     * A page number within the paginated result set.
     * @type {number}
     * @memberof ComplianceApiComplianceLicensesList
     */
    readonly page?: number

    /**
     * Number of results to return per page.
     * @type {number}
     * @memberof ComplianceApiComplianceLicensesList
     */
    readonly pageSize?: number

    /**
     * A search term.
     * @type {string}
     * @memberof ComplianceApiComplianceLicensesList
     */
    readonly search?: string

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof ComplianceApiComplianceLicensesList
     */
    readonly leafLinkVersion?: string
}

/**
 * Request parameters for complianceLicensesRetrieve operation in ComplianceApi.
 * @export
 * @interface ComplianceApiComplianceLicensesRetrieveRequest
 */
export interface ComplianceApiComplianceLicensesRetrieveRequest {
    /**
     * A unique integer value identifying this license.
     * @type {number}
     * @memberof ComplianceApiComplianceLicensesRetrieve
     */
    readonly id: number

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof ComplianceApiComplianceLicensesRetrieve
     */
    readonly leafLinkVersion?: string
}

/**
 * ComplianceApi - object-oriented interface
 * @export
 * @class ComplianceApi
 * @extends {BaseAPI}
 */
export class ComplianceApi extends BaseAPI {
    /**
     * Unified API to list company license types
     * @param {ComplianceApiComplianceLicenseTypesListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComplianceApi
     */
    public complianceLicenseTypesList(requestParameters: ComplianceApiComplianceLicenseTypesListRequest, options?: RawAxiosRequestConfig) {
        return ComplianceApiFp(this.configuration).complianceLicenseTypesList(requestParameters.companyId, requestParameters.isBuyerLicense, requestParameters.isSellerLicense, requestParameters.ordering, requestParameters.page, requestParameters.pageSize, requestParameters.search, requestParameters.usedByCompany, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Unified API to list company license types
     * @param {ComplianceApiComplianceLicenseTypesRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComplianceApi
     */
    public complianceLicenseTypesRetrieve(requestParameters: ComplianceApiComplianceLicenseTypesRetrieveRequest, options?: RawAxiosRequestConfig) {
        return ComplianceApiFp(this.configuration).complianceLicenseTypesRetrieve(requestParameters.id, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create new licenses from a list of licenses directly from a seed-to-sale vendor.
     * @param {ComplianceApiComplianceLicensesCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComplianceApi
     */
    public complianceLicensesCreate(requestParameters: ComplianceApiComplianceLicensesCreateRequest, options?: RawAxiosRequestConfig) {
        return ComplianceApiFp(this.configuration).complianceLicensesCreate(requestParameters.companyId, requestParameters.licenseCreateUpdateRequest, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Unified API to list company licenses
     * @param {ComplianceApiComplianceLicensesListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComplianceApi
     */
    public complianceLicensesList(requestParameters: ComplianceApiComplianceLicensesListRequest = {}, options?: RawAxiosRequestConfig) {
        return ComplianceApiFp(this.configuration).complianceLicensesList(requestParameters.companyId, requestParameters.ordering, requestParameters.page, requestParameters.pageSize, requestParameters.search, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Unified API to list company licenses
     * @param {ComplianceApiComplianceLicensesRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComplianceApi
     */
    public complianceLicensesRetrieve(requestParameters: ComplianceApiComplianceLicensesRetrieveRequest, options?: RawAxiosRequestConfig) {
        return ComplianceApiFp(this.configuration).complianceLicensesRetrieve(requestParameters.id, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ContactApi - axios parameter creator
 * @export
 */
export const ContactApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * List multiple Contacts.
         * @summary List Contacts
         * @param {string} [companySlug] 
         * @param {string} [createdDate] 
         * @param {string} [_delete] 
         * @param {string} [email] 
         * @param {string} [firstName] 
         * @param {number} [id] 
         * @param {string} [lastName] 
         * @param {string} [modifiedDate] 
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [owner] 
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contactsList: async (companySlug?: string, createdDate?: string, _delete?: string, email?: string, firstName?: string, id?: number, lastName?: string, modifiedDate?: string, ordering?: string, owner?: number, page?: number, pageSize?: number, search?: string, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/contacts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (companySlug !== undefined) {
                localVarQueryParameter['company_slug'] = companySlug;
            }

            if (createdDate !== undefined) {
                localVarQueryParameter['created_date'] = (createdDate as any instanceof Date) ?
                    (createdDate as any).toISOString() :
                    createdDate;
            }

            if (_delete !== undefined) {
                localVarQueryParameter['delete'] = (_delete as any instanceof Date) ?
                    (_delete as any).toISOString() :
                    _delete;
            }

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }

            if (firstName !== undefined) {
                localVarQueryParameter['first_name'] = firstName;
            }

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (lastName !== undefined) {
                localVarQueryParameter['last_name'] = lastName;
            }

            if (modifiedDate !== undefined) {
                localVarQueryParameter['modified_date'] = (modifiedDate as any instanceof Date) ?
                    (modifiedDate as any).toISOString() :
                    modifiedDate;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }

            if (owner !== undefined) {
                localVarQueryParameter['owner'] = owner;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a single Contact.
         * @summary Get Contact
         * @param {string} id 
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contactsRetrieve: async (id: string, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('contactsRetrieve', 'id', id)
            const localVarPath = `/contacts/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ContactApi - functional programming interface
 * @export
 */
export const ContactApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ContactApiAxiosParamCreator(configuration)
    return {
        /**
         * List multiple Contacts.
         * @summary List Contacts
         * @param {string} [companySlug] 
         * @param {string} [createdDate] 
         * @param {string} [_delete] 
         * @param {string} [email] 
         * @param {string} [firstName] 
         * @param {number} [id] 
         * @param {string} [lastName] 
         * @param {string} [modifiedDate] 
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [owner] 
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async contactsList(companySlug?: string, createdDate?: string, _delete?: string, email?: string, firstName?: string, id?: number, lastName?: string, modifiedDate?: string, ordering?: string, owner?: number, page?: number, pageSize?: number, search?: string, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.contactsList(companySlug, createdDate, _delete, email, firstName, id, lastName, modifiedDate, ordering, owner, page, pageSize, search, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContactApi.contactsList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a single Contact.
         * @summary Get Contact
         * @param {string} id 
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async contactsRetrieve(id: string, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnifiedContact>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.contactsRetrieve(id, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContactApi.contactsRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ContactApi - factory interface
 * @export
 */
export const ContactApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ContactApiFp(configuration)
    return {
        /**
         * List multiple Contacts.
         * @summary List Contacts
         * @param {ContactApiContactsListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contactsList(requestParameters: ContactApiContactsListRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.contactsList(requestParameters.companySlug, requestParameters.createdDate, requestParameters._delete, requestParameters.email, requestParameters.firstName, requestParameters.id, requestParameters.lastName, requestParameters.modifiedDate, requestParameters.ordering, requestParameters.owner, requestParameters.page, requestParameters.pageSize, requestParameters.search, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a single Contact.
         * @summary Get Contact
         * @param {ContactApiContactsRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contactsRetrieve(requestParameters: ContactApiContactsRetrieveRequest, options?: RawAxiosRequestConfig): AxiosPromise<UnifiedContact> {
            return localVarFp.contactsRetrieve(requestParameters.id, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for contactsList operation in ContactApi.
 * @export
 * @interface ContactApiContactsListRequest
 */
export interface ContactApiContactsListRequest {
    /**
     * 
     * @type {string}
     * @memberof ContactApiContactsList
     */
    readonly companySlug?: string

    /**
     * 
     * @type {string}
     * @memberof ContactApiContactsList
     */
    readonly createdDate?: string

    /**
     * 
     * @type {string}
     * @memberof ContactApiContactsList
     */
    readonly _delete?: string

    /**
     * 
     * @type {string}
     * @memberof ContactApiContactsList
     */
    readonly email?: string

    /**
     * 
     * @type {string}
     * @memberof ContactApiContactsList
     */
    readonly firstName?: string

    /**
     * 
     * @type {number}
     * @memberof ContactApiContactsList
     */
    readonly id?: number

    /**
     * 
     * @type {string}
     * @memberof ContactApiContactsList
     */
    readonly lastName?: string

    /**
     * 
     * @type {string}
     * @memberof ContactApiContactsList
     */
    readonly modifiedDate?: string

    /**
     * Which field to use when ordering the results.
     * @type {string}
     * @memberof ContactApiContactsList
     */
    readonly ordering?: string

    /**
     * 
     * @type {number}
     * @memberof ContactApiContactsList
     */
    readonly owner?: number

    /**
     * A page number within the paginated result set.
     * @type {number}
     * @memberof ContactApiContactsList
     */
    readonly page?: number

    /**
     * Number of results to return per page.
     * @type {number}
     * @memberof ContactApiContactsList
     */
    readonly pageSize?: number

    /**
     * A search term.
     * @type {string}
     * @memberof ContactApiContactsList
     */
    readonly search?: string

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof ContactApiContactsList
     */
    readonly leafLinkVersion?: string
}

/**
 * Request parameters for contactsRetrieve operation in ContactApi.
 * @export
 * @interface ContactApiContactsRetrieveRequest
 */
export interface ContactApiContactsRetrieveRequest {
    /**
     * 
     * @type {string}
     * @memberof ContactApiContactsRetrieve
     */
    readonly id: string

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof ContactApiContactsRetrieve
     */
    readonly leafLinkVersion?: string
}

/**
 * ContactApi - object-oriented interface
 * @export
 * @class ContactApi
 * @extends {BaseAPI}
 */
export class ContactApi extends BaseAPI {
    /**
     * List multiple Contacts.
     * @summary List Contacts
     * @param {ContactApiContactsListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactApi
     */
    public contactsList(requestParameters: ContactApiContactsListRequest = {}, options?: RawAxiosRequestConfig) {
        return ContactApiFp(this.configuration).contactsList(requestParameters.companySlug, requestParameters.createdDate, requestParameters._delete, requestParameters.email, requestParameters.firstName, requestParameters.id, requestParameters.lastName, requestParameters.modifiedDate, requestParameters.ordering, requestParameters.owner, requestParameters.page, requestParameters.pageSize, requestParameters.search, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a single Contact.
     * @summary Get Contact
     * @param {ContactApiContactsRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactApi
     */
    public contactsRetrieve(requestParameters: ContactApiContactsRetrieveRequest, options?: RawAxiosRequestConfig) {
        return ContactApiFp(this.configuration).contactsRetrieve(requestParameters.id, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ContactsApi - axios parameter creator
 * @export
 */
export const ContactsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * LeafLink API for Marketplace contacts.
         * @param {UnifiedContactRequest} unifiedContactRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contactsCreate: async (unifiedContactRequest: UnifiedContactRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'unifiedContactRequest' is not null or undefined
            assertParamExists('contactsCreate', 'unifiedContactRequest', unifiedContactRequest)
            const localVarPath = `/contacts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(unifiedContactRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Perform a \'DELETE\' on a contact. It will mark the specified contact as Deleted.
         * @param {string} id 
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contactsDestroy: async (id: string, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('contactsDestroy', 'id', id)
            const localVarPath = `/contacts/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * LeafLink API for Marketplace contacts.
         * @param {string} id 
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {PatchedUnifiedContactRequest} [patchedUnifiedContactRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contactsPartialUpdate: async (id: string, leafLinkVersion?: string, patchedUnifiedContactRequest?: PatchedUnifiedContactRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('contactsPartialUpdate', 'id', id)
            const localVarPath = `/contacts/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchedUnifiedContactRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * LeafLink API for Marketplace contacts.
         * @param {string} id 
         * @param {UnifiedContactRequest} unifiedContactRequest 
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contactsUpdate: async (id: string, unifiedContactRequest: UnifiedContactRequest, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('contactsUpdate', 'id', id)
            // verify required parameter 'unifiedContactRequest' is not null or undefined
            assertParamExists('contactsUpdate', 'unifiedContactRequest', unifiedContactRequest)
            const localVarPath = `/contacts/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(unifiedContactRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ContactsApi - functional programming interface
 * @export
 */
export const ContactsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ContactsApiAxiosParamCreator(configuration)
    return {
        /**
         * LeafLink API for Marketplace contacts.
         * @param {UnifiedContactRequest} unifiedContactRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async contactsCreate(unifiedContactRequest: UnifiedContactRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnifiedContact>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.contactsCreate(unifiedContactRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContactsApi.contactsCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Perform a \'DELETE\' on a contact. It will mark the specified contact as Deleted.
         * @param {string} id 
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async contactsDestroy(id: string, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.contactsDestroy(id, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContactsApi.contactsDestroy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * LeafLink API for Marketplace contacts.
         * @param {string} id 
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {PatchedUnifiedContactRequest} [patchedUnifiedContactRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async contactsPartialUpdate(id: string, leafLinkVersion?: string, patchedUnifiedContactRequest?: PatchedUnifiedContactRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnifiedContact>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.contactsPartialUpdate(id, leafLinkVersion, patchedUnifiedContactRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContactsApi.contactsPartialUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * LeafLink API for Marketplace contacts.
         * @param {string} id 
         * @param {UnifiedContactRequest} unifiedContactRequest 
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async contactsUpdate(id: string, unifiedContactRequest: UnifiedContactRequest, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnifiedContact>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.contactsUpdate(id, unifiedContactRequest, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContactsApi.contactsUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ContactsApi - factory interface
 * @export
 */
export const ContactsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ContactsApiFp(configuration)
    return {
        /**
         * LeafLink API for Marketplace contacts.
         * @param {ContactsApiContactsCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contactsCreate(requestParameters: ContactsApiContactsCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<UnifiedContact> {
            return localVarFp.contactsCreate(requestParameters.unifiedContactRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Perform a \'DELETE\' on a contact. It will mark the specified contact as Deleted.
         * @param {ContactsApiContactsDestroyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contactsDestroy(requestParameters: ContactsApiContactsDestroyRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.contactsDestroy(requestParameters.id, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * LeafLink API for Marketplace contacts.
         * @param {ContactsApiContactsPartialUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contactsPartialUpdate(requestParameters: ContactsApiContactsPartialUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<UnifiedContact> {
            return localVarFp.contactsPartialUpdate(requestParameters.id, requestParameters.leafLinkVersion, requestParameters.patchedUnifiedContactRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * LeafLink API for Marketplace contacts.
         * @param {ContactsApiContactsUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contactsUpdate(requestParameters: ContactsApiContactsUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<UnifiedContact> {
            return localVarFp.contactsUpdate(requestParameters.id, requestParameters.unifiedContactRequest, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for contactsCreate operation in ContactsApi.
 * @export
 * @interface ContactsApiContactsCreateRequest
 */
export interface ContactsApiContactsCreateRequest {
    /**
     * 
     * @type {UnifiedContactRequest}
     * @memberof ContactsApiContactsCreate
     */
    readonly unifiedContactRequest: UnifiedContactRequest
}

/**
 * Request parameters for contactsDestroy operation in ContactsApi.
 * @export
 * @interface ContactsApiContactsDestroyRequest
 */
export interface ContactsApiContactsDestroyRequest {
    /**
     * 
     * @type {string}
     * @memberof ContactsApiContactsDestroy
     */
    readonly id: string

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof ContactsApiContactsDestroy
     */
    readonly leafLinkVersion?: string
}

/**
 * Request parameters for contactsPartialUpdate operation in ContactsApi.
 * @export
 * @interface ContactsApiContactsPartialUpdateRequest
 */
export interface ContactsApiContactsPartialUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof ContactsApiContactsPartialUpdate
     */
    readonly id: string

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof ContactsApiContactsPartialUpdate
     */
    readonly leafLinkVersion?: string

    /**
     * 
     * @type {PatchedUnifiedContactRequest}
     * @memberof ContactsApiContactsPartialUpdate
     */
    readonly patchedUnifiedContactRequest?: PatchedUnifiedContactRequest
}

/**
 * Request parameters for contactsUpdate operation in ContactsApi.
 * @export
 * @interface ContactsApiContactsUpdateRequest
 */
export interface ContactsApiContactsUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof ContactsApiContactsUpdate
     */
    readonly id: string

    /**
     * 
     * @type {UnifiedContactRequest}
     * @memberof ContactsApiContactsUpdate
     */
    readonly unifiedContactRequest: UnifiedContactRequest

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof ContactsApiContactsUpdate
     */
    readonly leafLinkVersion?: string
}

/**
 * ContactsApi - object-oriented interface
 * @export
 * @class ContactsApi
 * @extends {BaseAPI}
 */
export class ContactsApi extends BaseAPI {
    /**
     * LeafLink API for Marketplace contacts.
     * @param {ContactsApiContactsCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactsApi
     */
    public contactsCreate(requestParameters: ContactsApiContactsCreateRequest, options?: RawAxiosRequestConfig) {
        return ContactsApiFp(this.configuration).contactsCreate(requestParameters.unifiedContactRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Perform a \'DELETE\' on a contact. It will mark the specified contact as Deleted.
     * @param {ContactsApiContactsDestroyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactsApi
     */
    public contactsDestroy(requestParameters: ContactsApiContactsDestroyRequest, options?: RawAxiosRequestConfig) {
        return ContactsApiFp(this.configuration).contactsDestroy(requestParameters.id, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * LeafLink API for Marketplace contacts.
     * @param {ContactsApiContactsPartialUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactsApi
     */
    public contactsPartialUpdate(requestParameters: ContactsApiContactsPartialUpdateRequest, options?: RawAxiosRequestConfig) {
        return ContactsApiFp(this.configuration).contactsPartialUpdate(requestParameters.id, requestParameters.leafLinkVersion, requestParameters.patchedUnifiedContactRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * LeafLink API for Marketplace contacts.
     * @param {ContactsApiContactsUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactsApi
     */
    public contactsUpdate(requestParameters: ContactsApiContactsUpdateRequest, options?: RawAxiosRequestConfig) {
        return ContactsApiFp(this.configuration).contactsUpdate(requestParameters.id, requestParameters.unifiedContactRequest, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CustomerApi - axios parameter creator
 * @export
 */
export const CustomerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * List multiple Company Customer Status.
         * @summary List Company Customer Status
         * @param {string} [companySlug] 
         * @param {string} [description] 
         * @param {string} [hexColor] 
         * @param {number} [id] 
         * @param {boolean} [isStock] 
         * @param {number} [order] 
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [owner] 
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {string} [state] 
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerStatusesList: async (companySlug?: string, description?: string, hexColor?: string, id?: number, isStock?: boolean, order?: number, ordering?: string, owner?: number, page?: number, pageSize?: number, search?: string, state?: string, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/customer_statuses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (companySlug !== undefined) {
                localVarQueryParameter['company_slug'] = companySlug;
            }

            if (description !== undefined) {
                localVarQueryParameter['description'] = description;
            }

            if (hexColor !== undefined) {
                localVarQueryParameter['hex_color'] = hexColor;
            }

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (isStock !== undefined) {
                localVarQueryParameter['is_stock'] = isStock;
            }

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }

            if (owner !== undefined) {
                localVarQueryParameter['owner'] = owner;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (state !== undefined) {
                localVarQueryParameter['state'] = state;
            }


    
            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a single Company Customer Status.
         * @summary Get Company Customer Status
         * @param {number} id A unique integer value identifying this company customer status.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerStatusesRetrieve: async (id: number, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('customerStatusesRetrieve', 'id', id)
            const localVarPath = `/customer_statuses/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List multiple Customers.
         * @summary List Customers
         * @param {string} [address] 
         * @param {string} [addressIn] 
         * @param {string} [addressStartswith] 
         * @param {boolean} [archived] 
         * @param {string} [brand] 
         * @param {Array<string>} [brandIn] Multiple values may be separated by commas.
         * @param {string} [brandStartswith] 
         * @param {string} [businessIdentifier] 
         * @param {Array<string>} [businessIdentifierIn] Multiple values may be separated by commas.
         * @param {string} [businessIdentifierStartswith] 
         * @param {string} [businessLicenseName] 
         * @param {string} [businessLicenseNameIn] 
         * @param {string} [businessLicenseNameStartswith] 
         * @param {string} [companySlug] 
         * @param {string} [createdOnGt] 
         * @param {string} [createdOnGte] 
         * @param {string} [createdOnLt] 
         * @param {string} [createdOnLte] 
         * @param {string} [dba] 
         * @param {string} [dbaIn] 
         * @param {string} [dbaStartswith] 
         * @param {boolean} [delinquent] 
         * @param {number} [discountPercentGt] 
         * @param {number} [discountPercentGte] 
         * @param {number} [discountPercentLt] 
         * @param {number} [discountPercentLte] 
         * @param {string} [ein] 
         * @param {string} [einIn] 
         * @param {string} [einStartswith] 
         * @param {string} [email] 
         * @param {Array<string>} [emailIn] Multiple values may be separated by commas.
         * @param {string} [emailStartswith] 
         * @param {string} [extAcctId] 
         * @param {Array<string>} [extAcctIdIn] Multiple values may be separated by commas.
         * @param {boolean} [extAcctIdIsnull] 
         * @param {string} [extAcctIdStartswith] 
         * @param {string} [externalId] 
         * @param {Array<string>} [externalIdIn] Multiple values may be separated by commas.
         * @param {string} [externalIdStartswith] 
         * @param {string} [externalIdKey] 
         * @param {boolean} [externalIdUnmapped] 
         * @param {string} [externalIdValues] 
         * @param {Array<number>} [id] Multiple values may be separated by commas.
         * @param {Array<number>} [idIn] Multiple values may be separated by commas.
         * @param {boolean} [isArchived] 
         * @param {boolean} [leaflinkSource] 
         * @param {boolean} [licenseInactive] 
         * @param {string} [licenseNumber] 
         * @param {string} [licenseType] 
         * @param {string} [modifiedGt] 
         * @param {string} [modifiedGte] 
         * @param {string} [modifiedLt] 
         * @param {string} [modifiedLte] 
         * @param {string} [name] 
         * @param {string} [nameIn] 
         * @param {string} [nameStartswith] 
         * @param {string} [nextContactDateGt] 
         * @param {string} [nextContactDateGte] 
         * @param {string} [nextContactDateLt] 
         * @param {string} [nextContactDateLte] 
         * @param {string} [nickname] 
         * @param {Array<string>} [nicknameIn] Multiple values may be separated by commas.
         * @param {string} [nicknameStartswith] 
         * @param {string} [oldLicenseNumber] 
         * @param {Array<string>} [oldLicenseNumberIn] Multiple values may be separated by commas.
         * @param {string} [oldLicenseNumberStartswith] 
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [owner] 
         * @param {string} [ownerSlug] 
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {number} [partner] 
         * @param {Array<number>} [paymentTerm] Multiple values may be separated by commas.
         * @param {string} [phone] 
         * @param {string} [phoneIn] 
         * @param {string} [phoneStartswith] 
         * @param {Array<number>} [priceSchedule] Multiple values may be separated by commas.
         * @param {string} [search] A search term.
         * @param {Array<number>} [serviceZone] Multiple values may be separated by commas.
         * @param {Array<number>} [state] Multiple values may be separated by commas.
         * @param {Array<number>} [status] Multiple values may be separated by commas.
         * @param {Array<number>} [tier] Multiple values may be separated by commas.
         * @param {string} [website] 
         * @param {string} [websiteIn] 
         * @param {string} [websiteStartswith] 
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersList: async (address?: string, addressIn?: string, addressStartswith?: string, archived?: boolean, brand?: string, brandIn?: Array<string>, brandStartswith?: string, businessIdentifier?: string, businessIdentifierIn?: Array<string>, businessIdentifierStartswith?: string, businessLicenseName?: string, businessLicenseNameIn?: string, businessLicenseNameStartswith?: string, companySlug?: string, createdOnGt?: string, createdOnGte?: string, createdOnLt?: string, createdOnLte?: string, dba?: string, dbaIn?: string, dbaStartswith?: string, delinquent?: boolean, discountPercentGt?: number, discountPercentGte?: number, discountPercentLt?: number, discountPercentLte?: number, ein?: string, einIn?: string, einStartswith?: string, email?: string, emailIn?: Array<string>, emailStartswith?: string, extAcctId?: string, extAcctIdIn?: Array<string>, extAcctIdIsnull?: boolean, extAcctIdStartswith?: string, externalId?: string, externalIdIn?: Array<string>, externalIdStartswith?: string, externalIdKey?: string, externalIdUnmapped?: boolean, externalIdValues?: string, id?: Array<number>, idIn?: Array<number>, isArchived?: boolean, leaflinkSource?: boolean, licenseInactive?: boolean, licenseNumber?: string, licenseType?: string, modifiedGt?: string, modifiedGte?: string, modifiedLt?: string, modifiedLte?: string, name?: string, nameIn?: string, nameStartswith?: string, nextContactDateGt?: string, nextContactDateGte?: string, nextContactDateLt?: string, nextContactDateLte?: string, nickname?: string, nicknameIn?: Array<string>, nicknameStartswith?: string, oldLicenseNumber?: string, oldLicenseNumberIn?: Array<string>, oldLicenseNumberStartswith?: string, ordering?: string, owner?: number, ownerSlug?: string, page?: number, pageSize?: number, partner?: number, paymentTerm?: Array<number>, phone?: string, phoneIn?: string, phoneStartswith?: string, priceSchedule?: Array<number>, search?: string, serviceZone?: Array<number>, state?: Array<number>, status?: Array<number>, tier?: Array<number>, website?: string, websiteIn?: string, websiteStartswith?: string, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/customers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (address !== undefined) {
                localVarQueryParameter['address'] = address;
            }

            if (addressIn !== undefined) {
                localVarQueryParameter['address__in'] = addressIn;
            }

            if (addressStartswith !== undefined) {
                localVarQueryParameter['address__startswith'] = addressStartswith;
            }

            if (archived !== undefined) {
                localVarQueryParameter['archived'] = archived;
            }

            if (brand !== undefined) {
                localVarQueryParameter['brand'] = brand;
            }

            if (brandIn) {
                localVarQueryParameter['brand__in'] = brandIn.join(COLLECTION_FORMATS.csv);
            }

            if (brandStartswith !== undefined) {
                localVarQueryParameter['brand__startswith'] = brandStartswith;
            }

            if (businessIdentifier !== undefined) {
                localVarQueryParameter['business_identifier'] = businessIdentifier;
            }

            if (businessIdentifierIn) {
                localVarQueryParameter['business_identifier__in'] = businessIdentifierIn.join(COLLECTION_FORMATS.csv);
            }

            if (businessIdentifierStartswith !== undefined) {
                localVarQueryParameter['business_identifier__startswith'] = businessIdentifierStartswith;
            }

            if (businessLicenseName !== undefined) {
                localVarQueryParameter['business_license_name'] = businessLicenseName;
            }

            if (businessLicenseNameIn !== undefined) {
                localVarQueryParameter['business_license_name__in'] = businessLicenseNameIn;
            }

            if (businessLicenseNameStartswith !== undefined) {
                localVarQueryParameter['business_license_name__startswith'] = businessLicenseNameStartswith;
            }

            if (companySlug !== undefined) {
                localVarQueryParameter['company_slug'] = companySlug;
            }

            if (createdOnGt !== undefined) {
                localVarQueryParameter['created_on__gt'] = (createdOnGt as any instanceof Date) ?
                    (createdOnGt as any).toISOString() :
                    createdOnGt;
            }

            if (createdOnGte !== undefined) {
                localVarQueryParameter['created_on__gte'] = (createdOnGte as any instanceof Date) ?
                    (createdOnGte as any).toISOString() :
                    createdOnGte;
            }

            if (createdOnLt !== undefined) {
                localVarQueryParameter['created_on__lt'] = (createdOnLt as any instanceof Date) ?
                    (createdOnLt as any).toISOString() :
                    createdOnLt;
            }

            if (createdOnLte !== undefined) {
                localVarQueryParameter['created_on__lte'] = (createdOnLte as any instanceof Date) ?
                    (createdOnLte as any).toISOString() :
                    createdOnLte;
            }

            if (dba !== undefined) {
                localVarQueryParameter['dba'] = dba;
            }

            if (dbaIn !== undefined) {
                localVarQueryParameter['dba__in'] = dbaIn;
            }

            if (dbaStartswith !== undefined) {
                localVarQueryParameter['dba__startswith'] = dbaStartswith;
            }

            if (delinquent !== undefined) {
                localVarQueryParameter['delinquent'] = delinquent;
            }

            if (discountPercentGt !== undefined) {
                localVarQueryParameter['discount_percent__gt'] = discountPercentGt;
            }

            if (discountPercentGte !== undefined) {
                localVarQueryParameter['discount_percent__gte'] = discountPercentGte;
            }

            if (discountPercentLt !== undefined) {
                localVarQueryParameter['discount_percent__lt'] = discountPercentLt;
            }

            if (discountPercentLte !== undefined) {
                localVarQueryParameter['discount_percent__lte'] = discountPercentLte;
            }

            if (ein !== undefined) {
                localVarQueryParameter['ein'] = ein;
            }

            if (einIn !== undefined) {
                localVarQueryParameter['ein__in'] = einIn;
            }

            if (einStartswith !== undefined) {
                localVarQueryParameter['ein__startswith'] = einStartswith;
            }

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }

            if (emailIn) {
                localVarQueryParameter['email__in'] = emailIn.join(COLLECTION_FORMATS.csv);
            }

            if (emailStartswith !== undefined) {
                localVarQueryParameter['email__startswith'] = emailStartswith;
            }

            if (extAcctId !== undefined) {
                localVarQueryParameter['ext_acct_id'] = extAcctId;
            }

            if (extAcctIdIn) {
                localVarQueryParameter['ext_acct_id__in'] = extAcctIdIn.join(COLLECTION_FORMATS.csv);
            }

            if (extAcctIdIsnull !== undefined) {
                localVarQueryParameter['ext_acct_id__isnull'] = extAcctIdIsnull;
            }

            if (extAcctIdStartswith !== undefined) {
                localVarQueryParameter['ext_acct_id__startswith'] = extAcctIdStartswith;
            }

            if (externalId !== undefined) {
                localVarQueryParameter['external_id'] = externalId;
            }

            if (externalIdIn) {
                localVarQueryParameter['external_id__in'] = externalIdIn.join(COLLECTION_FORMATS.csv);
            }

            if (externalIdStartswith !== undefined) {
                localVarQueryParameter['external_id__startswith'] = externalIdStartswith;
            }

            if (externalIdKey !== undefined) {
                localVarQueryParameter['external_id_key'] = externalIdKey;
            }

            if (externalIdUnmapped !== undefined) {
                localVarQueryParameter['external_id_unmapped'] = externalIdUnmapped;
            }

            if (externalIdValues !== undefined) {
                localVarQueryParameter['external_id_values'] = externalIdValues;
            }

            if (id) {
                localVarQueryParameter['id'] = id.join(COLLECTION_FORMATS.csv);
            }

            if (idIn) {
                localVarQueryParameter['id__in'] = idIn.join(COLLECTION_FORMATS.csv);
            }

            if (isArchived !== undefined) {
                localVarQueryParameter['is_archived'] = isArchived;
            }

            if (leaflinkSource !== undefined) {
                localVarQueryParameter['leaflink_source'] = leaflinkSource;
            }

            if (licenseInactive !== undefined) {
                localVarQueryParameter['license_inactive'] = licenseInactive;
            }

            if (licenseNumber !== undefined) {
                localVarQueryParameter['license_number'] = licenseNumber;
            }

            if (licenseType !== undefined) {
                localVarQueryParameter['license_type'] = licenseType;
            }

            if (modifiedGt !== undefined) {
                localVarQueryParameter['modified__gt'] = (modifiedGt as any instanceof Date) ?
                    (modifiedGt as any).toISOString() :
                    modifiedGt;
            }

            if (modifiedGte !== undefined) {
                localVarQueryParameter['modified__gte'] = (modifiedGte as any instanceof Date) ?
                    (modifiedGte as any).toISOString() :
                    modifiedGte;
            }

            if (modifiedLt !== undefined) {
                localVarQueryParameter['modified__lt'] = (modifiedLt as any instanceof Date) ?
                    (modifiedLt as any).toISOString() :
                    modifiedLt;
            }

            if (modifiedLte !== undefined) {
                localVarQueryParameter['modified__lte'] = (modifiedLte as any instanceof Date) ?
                    (modifiedLte as any).toISOString() :
                    modifiedLte;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (nameIn !== undefined) {
                localVarQueryParameter['name__in'] = nameIn;
            }

            if (nameStartswith !== undefined) {
                localVarQueryParameter['name__startswith'] = nameStartswith;
            }

            if (nextContactDateGt !== undefined) {
                localVarQueryParameter['next_contact_date__gt'] = (nextContactDateGt as any instanceof Date) ?
                    (nextContactDateGt as any).toISOString().substring(0,10) :
                    nextContactDateGt;
            }

            if (nextContactDateGte !== undefined) {
                localVarQueryParameter['next_contact_date__gte'] = (nextContactDateGte as any instanceof Date) ?
                    (nextContactDateGte as any).toISOString().substring(0,10) :
                    nextContactDateGte;
            }

            if (nextContactDateLt !== undefined) {
                localVarQueryParameter['next_contact_date__lt'] = (nextContactDateLt as any instanceof Date) ?
                    (nextContactDateLt as any).toISOString().substring(0,10) :
                    nextContactDateLt;
            }

            if (nextContactDateLte !== undefined) {
                localVarQueryParameter['next_contact_date__lte'] = (nextContactDateLte as any instanceof Date) ?
                    (nextContactDateLte as any).toISOString().substring(0,10) :
                    nextContactDateLte;
            }

            if (nickname !== undefined) {
                localVarQueryParameter['nickname'] = nickname;
            }

            if (nicknameIn) {
                localVarQueryParameter['nickname__in'] = nicknameIn.join(COLLECTION_FORMATS.csv);
            }

            if (nicknameStartswith !== undefined) {
                localVarQueryParameter['nickname__startswith'] = nicknameStartswith;
            }

            if (oldLicenseNumber !== undefined) {
                localVarQueryParameter['old_license_number'] = oldLicenseNumber;
            }

            if (oldLicenseNumberIn) {
                localVarQueryParameter['old_license_number__in'] = oldLicenseNumberIn.join(COLLECTION_FORMATS.csv);
            }

            if (oldLicenseNumberStartswith !== undefined) {
                localVarQueryParameter['old_license_number__startswith'] = oldLicenseNumberStartswith;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }

            if (owner !== undefined) {
                localVarQueryParameter['owner'] = owner;
            }

            if (ownerSlug !== undefined) {
                localVarQueryParameter['owner__slug'] = ownerSlug;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (partner !== undefined) {
                localVarQueryParameter['partner'] = partner;
            }

            if (paymentTerm) {
                localVarQueryParameter['payment_term'] = paymentTerm.join(COLLECTION_FORMATS.csv);
            }

            if (phone !== undefined) {
                localVarQueryParameter['phone'] = phone;
            }

            if (phoneIn !== undefined) {
                localVarQueryParameter['phone__in'] = phoneIn;
            }

            if (phoneStartswith !== undefined) {
                localVarQueryParameter['phone__startswith'] = phoneStartswith;
            }

            if (priceSchedule) {
                localVarQueryParameter['price_schedule'] = priceSchedule.join(COLLECTION_FORMATS.csv);
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (serviceZone) {
                localVarQueryParameter['service_zone'] = serviceZone.join(COLLECTION_FORMATS.csv);
            }

            if (state) {
                localVarQueryParameter['state'] = state.join(COLLECTION_FORMATS.csv);
            }

            if (status) {
                localVarQueryParameter['status'] = status.join(COLLECTION_FORMATS.csv);
            }

            if (tier) {
                localVarQueryParameter['tier'] = tier.join(COLLECTION_FORMATS.csv);
            }

            if (website !== undefined) {
                localVarQueryParameter['website'] = website;
            }

            if (websiteIn !== undefined) {
                localVarQueryParameter['website__in'] = websiteIn;
            }

            if (websiteStartswith !== undefined) {
                localVarQueryParameter['website__startswith'] = websiteStartswith;
            }


    
            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a single Customer.
         * @summary Get Customer
         * @param {number} id A unique integer value identifying this company customer.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersRetrieve: async (id: number, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('customersRetrieve', 'id', id)
            const localVarPath = `/customers/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CustomerApi - functional programming interface
 * @export
 */
export const CustomerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CustomerApiAxiosParamCreator(configuration)
    return {
        /**
         * List multiple Company Customer Status.
         * @summary List Company Customer Status
         * @param {string} [companySlug] 
         * @param {string} [description] 
         * @param {string} [hexColor] 
         * @param {number} [id] 
         * @param {boolean} [isStock] 
         * @param {number} [order] 
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [owner] 
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {string} [state] 
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async customerStatusesList(companySlug?: string, description?: string, hexColor?: string, id?: number, isStock?: boolean, order?: number, ordering?: string, owner?: number, page?: number, pageSize?: number, search?: string, state?: string, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.customerStatusesList(companySlug, description, hexColor, id, isStock, order, ordering, owner, page, pageSize, search, state, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerApi.customerStatusesList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a single Company Customer Status.
         * @summary Get Company Customer Status
         * @param {number} id A unique integer value identifying this company customer status.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async customerStatusesRetrieve(id: number, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.customerStatusesRetrieve(id, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerApi.customerStatusesRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List multiple Customers.
         * @summary List Customers
         * @param {string} [address] 
         * @param {string} [addressIn] 
         * @param {string} [addressStartswith] 
         * @param {boolean} [archived] 
         * @param {string} [brand] 
         * @param {Array<string>} [brandIn] Multiple values may be separated by commas.
         * @param {string} [brandStartswith] 
         * @param {string} [businessIdentifier] 
         * @param {Array<string>} [businessIdentifierIn] Multiple values may be separated by commas.
         * @param {string} [businessIdentifierStartswith] 
         * @param {string} [businessLicenseName] 
         * @param {string} [businessLicenseNameIn] 
         * @param {string} [businessLicenseNameStartswith] 
         * @param {string} [companySlug] 
         * @param {string} [createdOnGt] 
         * @param {string} [createdOnGte] 
         * @param {string} [createdOnLt] 
         * @param {string} [createdOnLte] 
         * @param {string} [dba] 
         * @param {string} [dbaIn] 
         * @param {string} [dbaStartswith] 
         * @param {boolean} [delinquent] 
         * @param {number} [discountPercentGt] 
         * @param {number} [discountPercentGte] 
         * @param {number} [discountPercentLt] 
         * @param {number} [discountPercentLte] 
         * @param {string} [ein] 
         * @param {string} [einIn] 
         * @param {string} [einStartswith] 
         * @param {string} [email] 
         * @param {Array<string>} [emailIn] Multiple values may be separated by commas.
         * @param {string} [emailStartswith] 
         * @param {string} [extAcctId] 
         * @param {Array<string>} [extAcctIdIn] Multiple values may be separated by commas.
         * @param {boolean} [extAcctIdIsnull] 
         * @param {string} [extAcctIdStartswith] 
         * @param {string} [externalId] 
         * @param {Array<string>} [externalIdIn] Multiple values may be separated by commas.
         * @param {string} [externalIdStartswith] 
         * @param {string} [externalIdKey] 
         * @param {boolean} [externalIdUnmapped] 
         * @param {string} [externalIdValues] 
         * @param {Array<number>} [id] Multiple values may be separated by commas.
         * @param {Array<number>} [idIn] Multiple values may be separated by commas.
         * @param {boolean} [isArchived] 
         * @param {boolean} [leaflinkSource] 
         * @param {boolean} [licenseInactive] 
         * @param {string} [licenseNumber] 
         * @param {string} [licenseType] 
         * @param {string} [modifiedGt] 
         * @param {string} [modifiedGte] 
         * @param {string} [modifiedLt] 
         * @param {string} [modifiedLte] 
         * @param {string} [name] 
         * @param {string} [nameIn] 
         * @param {string} [nameStartswith] 
         * @param {string} [nextContactDateGt] 
         * @param {string} [nextContactDateGte] 
         * @param {string} [nextContactDateLt] 
         * @param {string} [nextContactDateLte] 
         * @param {string} [nickname] 
         * @param {Array<string>} [nicknameIn] Multiple values may be separated by commas.
         * @param {string} [nicknameStartswith] 
         * @param {string} [oldLicenseNumber] 
         * @param {Array<string>} [oldLicenseNumberIn] Multiple values may be separated by commas.
         * @param {string} [oldLicenseNumberStartswith] 
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [owner] 
         * @param {string} [ownerSlug] 
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {number} [partner] 
         * @param {Array<number>} [paymentTerm] Multiple values may be separated by commas.
         * @param {string} [phone] 
         * @param {string} [phoneIn] 
         * @param {string} [phoneStartswith] 
         * @param {Array<number>} [priceSchedule] Multiple values may be separated by commas.
         * @param {string} [search] A search term.
         * @param {Array<number>} [serviceZone] Multiple values may be separated by commas.
         * @param {Array<number>} [state] Multiple values may be separated by commas.
         * @param {Array<number>} [status] Multiple values may be separated by commas.
         * @param {Array<number>} [tier] Multiple values may be separated by commas.
         * @param {string} [website] 
         * @param {string} [websiteIn] 
         * @param {string} [websiteStartswith] 
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async customersList(address?: string, addressIn?: string, addressStartswith?: string, archived?: boolean, brand?: string, brandIn?: Array<string>, brandStartswith?: string, businessIdentifier?: string, businessIdentifierIn?: Array<string>, businessIdentifierStartswith?: string, businessLicenseName?: string, businessLicenseNameIn?: string, businessLicenseNameStartswith?: string, companySlug?: string, createdOnGt?: string, createdOnGte?: string, createdOnLt?: string, createdOnLte?: string, dba?: string, dbaIn?: string, dbaStartswith?: string, delinquent?: boolean, discountPercentGt?: number, discountPercentGte?: number, discountPercentLt?: number, discountPercentLte?: number, ein?: string, einIn?: string, einStartswith?: string, email?: string, emailIn?: Array<string>, emailStartswith?: string, extAcctId?: string, extAcctIdIn?: Array<string>, extAcctIdIsnull?: boolean, extAcctIdStartswith?: string, externalId?: string, externalIdIn?: Array<string>, externalIdStartswith?: string, externalIdKey?: string, externalIdUnmapped?: boolean, externalIdValues?: string, id?: Array<number>, idIn?: Array<number>, isArchived?: boolean, leaflinkSource?: boolean, licenseInactive?: boolean, licenseNumber?: string, licenseType?: string, modifiedGt?: string, modifiedGte?: string, modifiedLt?: string, modifiedLte?: string, name?: string, nameIn?: string, nameStartswith?: string, nextContactDateGt?: string, nextContactDateGte?: string, nextContactDateLt?: string, nextContactDateLte?: string, nickname?: string, nicknameIn?: Array<string>, nicknameStartswith?: string, oldLicenseNumber?: string, oldLicenseNumberIn?: Array<string>, oldLicenseNumberStartswith?: string, ordering?: string, owner?: number, ownerSlug?: string, page?: number, pageSize?: number, partner?: number, paymentTerm?: Array<number>, phone?: string, phoneIn?: string, phoneStartswith?: string, priceSchedule?: Array<number>, search?: string, serviceZone?: Array<number>, state?: Array<number>, status?: Array<number>, tier?: Array<number>, website?: string, websiteIn?: string, websiteStartswith?: string, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.customersList(address, addressIn, addressStartswith, archived, brand, brandIn, brandStartswith, businessIdentifier, businessIdentifierIn, businessIdentifierStartswith, businessLicenseName, businessLicenseNameIn, businessLicenseNameStartswith, companySlug, createdOnGt, createdOnGte, createdOnLt, createdOnLte, dba, dbaIn, dbaStartswith, delinquent, discountPercentGt, discountPercentGte, discountPercentLt, discountPercentLte, ein, einIn, einStartswith, email, emailIn, emailStartswith, extAcctId, extAcctIdIn, extAcctIdIsnull, extAcctIdStartswith, externalId, externalIdIn, externalIdStartswith, externalIdKey, externalIdUnmapped, externalIdValues, id, idIn, isArchived, leaflinkSource, licenseInactive, licenseNumber, licenseType, modifiedGt, modifiedGte, modifiedLt, modifiedLte, name, nameIn, nameStartswith, nextContactDateGt, nextContactDateGte, nextContactDateLt, nextContactDateLte, nickname, nicknameIn, nicknameStartswith, oldLicenseNumber, oldLicenseNumberIn, oldLicenseNumberStartswith, ordering, owner, ownerSlug, page, pageSize, partner, paymentTerm, phone, phoneIn, phoneStartswith, priceSchedule, search, serviceZone, state, status, tier, website, websiteIn, websiteStartswith, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerApi.customersList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a single Customer.
         * @summary Get Customer
         * @param {number} id A unique integer value identifying this company customer.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async customersRetrieve(id: number, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.customersRetrieve(id, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerApi.customersRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CustomerApi - factory interface
 * @export
 */
export const CustomerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CustomerApiFp(configuration)
    return {
        /**
         * List multiple Company Customer Status.
         * @summary List Company Customer Status
         * @param {CustomerApiCustomerStatusesListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerStatusesList(requestParameters: CustomerApiCustomerStatusesListRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.customerStatusesList(requestParameters.companySlug, requestParameters.description, requestParameters.hexColor, requestParameters.id, requestParameters.isStock, requestParameters.order, requestParameters.ordering, requestParameters.owner, requestParameters.page, requestParameters.pageSize, requestParameters.search, requestParameters.state, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a single Company Customer Status.
         * @summary Get Company Customer Status
         * @param {CustomerApiCustomerStatusesRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerStatusesRetrieve(requestParameters: CustomerApiCustomerStatusesRetrieveRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.customerStatusesRetrieve(requestParameters.id, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * List multiple Customers.
         * @summary List Customers
         * @param {CustomerApiCustomersListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersList(requestParameters: CustomerApiCustomersListRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.customersList(requestParameters.address, requestParameters.addressIn, requestParameters.addressStartswith, requestParameters.archived, requestParameters.brand, requestParameters.brandIn, requestParameters.brandStartswith, requestParameters.businessIdentifier, requestParameters.businessIdentifierIn, requestParameters.businessIdentifierStartswith, requestParameters.businessLicenseName, requestParameters.businessLicenseNameIn, requestParameters.businessLicenseNameStartswith, requestParameters.companySlug, requestParameters.createdOnGt, requestParameters.createdOnGte, requestParameters.createdOnLt, requestParameters.createdOnLte, requestParameters.dba, requestParameters.dbaIn, requestParameters.dbaStartswith, requestParameters.delinquent, requestParameters.discountPercentGt, requestParameters.discountPercentGte, requestParameters.discountPercentLt, requestParameters.discountPercentLte, requestParameters.ein, requestParameters.einIn, requestParameters.einStartswith, requestParameters.email, requestParameters.emailIn, requestParameters.emailStartswith, requestParameters.extAcctId, requestParameters.extAcctIdIn, requestParameters.extAcctIdIsnull, requestParameters.extAcctIdStartswith, requestParameters.externalId, requestParameters.externalIdIn, requestParameters.externalIdStartswith, requestParameters.externalIdKey, requestParameters.externalIdUnmapped, requestParameters.externalIdValues, requestParameters.id, requestParameters.idIn, requestParameters.isArchived, requestParameters.leaflinkSource, requestParameters.licenseInactive, requestParameters.licenseNumber, requestParameters.licenseType, requestParameters.modifiedGt, requestParameters.modifiedGte, requestParameters.modifiedLt, requestParameters.modifiedLte, requestParameters.name, requestParameters.nameIn, requestParameters.nameStartswith, requestParameters.nextContactDateGt, requestParameters.nextContactDateGte, requestParameters.nextContactDateLt, requestParameters.nextContactDateLte, requestParameters.nickname, requestParameters.nicknameIn, requestParameters.nicknameStartswith, requestParameters.oldLicenseNumber, requestParameters.oldLicenseNumberIn, requestParameters.oldLicenseNumberStartswith, requestParameters.ordering, requestParameters.owner, requestParameters.ownerSlug, requestParameters.page, requestParameters.pageSize, requestParameters.partner, requestParameters.paymentTerm, requestParameters.phone, requestParameters.phoneIn, requestParameters.phoneStartswith, requestParameters.priceSchedule, requestParameters.search, requestParameters.serviceZone, requestParameters.state, requestParameters.status, requestParameters.tier, requestParameters.website, requestParameters.websiteIn, requestParameters.websiteStartswith, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a single Customer.
         * @summary Get Customer
         * @param {CustomerApiCustomersRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersRetrieve(requestParameters: CustomerApiCustomersRetrieveRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.customersRetrieve(requestParameters.id, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for customerStatusesList operation in CustomerApi.
 * @export
 * @interface CustomerApiCustomerStatusesListRequest
 */
export interface CustomerApiCustomerStatusesListRequest {
    /**
     * 
     * @type {string}
     * @memberof CustomerApiCustomerStatusesList
     */
    readonly companySlug?: string

    /**
     * 
     * @type {string}
     * @memberof CustomerApiCustomerStatusesList
     */
    readonly description?: string

    /**
     * 
     * @type {string}
     * @memberof CustomerApiCustomerStatusesList
     */
    readonly hexColor?: string

    /**
     * 
     * @type {number}
     * @memberof CustomerApiCustomerStatusesList
     */
    readonly id?: number

    /**
     * 
     * @type {boolean}
     * @memberof CustomerApiCustomerStatusesList
     */
    readonly isStock?: boolean

    /**
     * 
     * @type {number}
     * @memberof CustomerApiCustomerStatusesList
     */
    readonly order?: number

    /**
     * Which field to use when ordering the results.
     * @type {string}
     * @memberof CustomerApiCustomerStatusesList
     */
    readonly ordering?: string

    /**
     * 
     * @type {number}
     * @memberof CustomerApiCustomerStatusesList
     */
    readonly owner?: number

    /**
     * A page number within the paginated result set.
     * @type {number}
     * @memberof CustomerApiCustomerStatusesList
     */
    readonly page?: number

    /**
     * Number of results to return per page.
     * @type {number}
     * @memberof CustomerApiCustomerStatusesList
     */
    readonly pageSize?: number

    /**
     * A search term.
     * @type {string}
     * @memberof CustomerApiCustomerStatusesList
     */
    readonly search?: string

    /**
     * 
     * @type {string}
     * @memberof CustomerApiCustomerStatusesList
     */
    readonly state?: string

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof CustomerApiCustomerStatusesList
     */
    readonly leafLinkVersion?: string
}

/**
 * Request parameters for customerStatusesRetrieve operation in CustomerApi.
 * @export
 * @interface CustomerApiCustomerStatusesRetrieveRequest
 */
export interface CustomerApiCustomerStatusesRetrieveRequest {
    /**
     * A unique integer value identifying this company customer status.
     * @type {number}
     * @memberof CustomerApiCustomerStatusesRetrieve
     */
    readonly id: number

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof CustomerApiCustomerStatusesRetrieve
     */
    readonly leafLinkVersion?: string
}

/**
 * Request parameters for customersList operation in CustomerApi.
 * @export
 * @interface CustomerApiCustomersListRequest
 */
export interface CustomerApiCustomersListRequest {
    /**
     * 
     * @type {string}
     * @memberof CustomerApiCustomersList
     */
    readonly address?: string

    /**
     * 
     * @type {string}
     * @memberof CustomerApiCustomersList
     */
    readonly addressIn?: string

    /**
     * 
     * @type {string}
     * @memberof CustomerApiCustomersList
     */
    readonly addressStartswith?: string

    /**
     * 
     * @type {boolean}
     * @memberof CustomerApiCustomersList
     */
    readonly archived?: boolean

    /**
     * 
     * @type {string}
     * @memberof CustomerApiCustomersList
     */
    readonly brand?: string

    /**
     * Multiple values may be separated by commas.
     * @type {Array<string>}
     * @memberof CustomerApiCustomersList
     */
    readonly brandIn?: Array<string>

    /**
     * 
     * @type {string}
     * @memberof CustomerApiCustomersList
     */
    readonly brandStartswith?: string

    /**
     * 
     * @type {string}
     * @memberof CustomerApiCustomersList
     */
    readonly businessIdentifier?: string

    /**
     * Multiple values may be separated by commas.
     * @type {Array<string>}
     * @memberof CustomerApiCustomersList
     */
    readonly businessIdentifierIn?: Array<string>

    /**
     * 
     * @type {string}
     * @memberof CustomerApiCustomersList
     */
    readonly businessIdentifierStartswith?: string

    /**
     * 
     * @type {string}
     * @memberof CustomerApiCustomersList
     */
    readonly businessLicenseName?: string

    /**
     * 
     * @type {string}
     * @memberof CustomerApiCustomersList
     */
    readonly businessLicenseNameIn?: string

    /**
     * 
     * @type {string}
     * @memberof CustomerApiCustomersList
     */
    readonly businessLicenseNameStartswith?: string

    /**
     * 
     * @type {string}
     * @memberof CustomerApiCustomersList
     */
    readonly companySlug?: string

    /**
     * 
     * @type {string}
     * @memberof CustomerApiCustomersList
     */
    readonly createdOnGt?: string

    /**
     * 
     * @type {string}
     * @memberof CustomerApiCustomersList
     */
    readonly createdOnGte?: string

    /**
     * 
     * @type {string}
     * @memberof CustomerApiCustomersList
     */
    readonly createdOnLt?: string

    /**
     * 
     * @type {string}
     * @memberof CustomerApiCustomersList
     */
    readonly createdOnLte?: string

    /**
     * 
     * @type {string}
     * @memberof CustomerApiCustomersList
     */
    readonly dba?: string

    /**
     * 
     * @type {string}
     * @memberof CustomerApiCustomersList
     */
    readonly dbaIn?: string

    /**
     * 
     * @type {string}
     * @memberof CustomerApiCustomersList
     */
    readonly dbaStartswith?: string

    /**
     * 
     * @type {boolean}
     * @memberof CustomerApiCustomersList
     */
    readonly delinquent?: boolean

    /**
     * 
     * @type {number}
     * @memberof CustomerApiCustomersList
     */
    readonly discountPercentGt?: number

    /**
     * 
     * @type {number}
     * @memberof CustomerApiCustomersList
     */
    readonly discountPercentGte?: number

    /**
     * 
     * @type {number}
     * @memberof CustomerApiCustomersList
     */
    readonly discountPercentLt?: number

    /**
     * 
     * @type {number}
     * @memberof CustomerApiCustomersList
     */
    readonly discountPercentLte?: number

    /**
     * 
     * @type {string}
     * @memberof CustomerApiCustomersList
     */
    readonly ein?: string

    /**
     * 
     * @type {string}
     * @memberof CustomerApiCustomersList
     */
    readonly einIn?: string

    /**
     * 
     * @type {string}
     * @memberof CustomerApiCustomersList
     */
    readonly einStartswith?: string

    /**
     * 
     * @type {string}
     * @memberof CustomerApiCustomersList
     */
    readonly email?: string

    /**
     * Multiple values may be separated by commas.
     * @type {Array<string>}
     * @memberof CustomerApiCustomersList
     */
    readonly emailIn?: Array<string>

    /**
     * 
     * @type {string}
     * @memberof CustomerApiCustomersList
     */
    readonly emailStartswith?: string

    /**
     * 
     * @type {string}
     * @memberof CustomerApiCustomersList
     */
    readonly extAcctId?: string

    /**
     * Multiple values may be separated by commas.
     * @type {Array<string>}
     * @memberof CustomerApiCustomersList
     */
    readonly extAcctIdIn?: Array<string>

    /**
     * 
     * @type {boolean}
     * @memberof CustomerApiCustomersList
     */
    readonly extAcctIdIsnull?: boolean

    /**
     * 
     * @type {string}
     * @memberof CustomerApiCustomersList
     */
    readonly extAcctIdStartswith?: string

    /**
     * 
     * @type {string}
     * @memberof CustomerApiCustomersList
     */
    readonly externalId?: string

    /**
     * Multiple values may be separated by commas.
     * @type {Array<string>}
     * @memberof CustomerApiCustomersList
     */
    readonly externalIdIn?: Array<string>

    /**
     * 
     * @type {string}
     * @memberof CustomerApiCustomersList
     */
    readonly externalIdStartswith?: string

    /**
     * 
     * @type {string}
     * @memberof CustomerApiCustomersList
     */
    readonly externalIdKey?: string

    /**
     * 
     * @type {boolean}
     * @memberof CustomerApiCustomersList
     */
    readonly externalIdUnmapped?: boolean

    /**
     * 
     * @type {string}
     * @memberof CustomerApiCustomersList
     */
    readonly externalIdValues?: string

    /**
     * Multiple values may be separated by commas.
     * @type {Array<number>}
     * @memberof CustomerApiCustomersList
     */
    readonly id?: Array<number>

    /**
     * Multiple values may be separated by commas.
     * @type {Array<number>}
     * @memberof CustomerApiCustomersList
     */
    readonly idIn?: Array<number>

    /**
     * 
     * @type {boolean}
     * @memberof CustomerApiCustomersList
     */
    readonly isArchived?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof CustomerApiCustomersList
     */
    readonly leaflinkSource?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof CustomerApiCustomersList
     */
    readonly licenseInactive?: boolean

    /**
     * 
     * @type {string}
     * @memberof CustomerApiCustomersList
     */
    readonly licenseNumber?: string

    /**
     * 
     * @type {string}
     * @memberof CustomerApiCustomersList
     */
    readonly licenseType?: string

    /**
     * 
     * @type {string}
     * @memberof CustomerApiCustomersList
     */
    readonly modifiedGt?: string

    /**
     * 
     * @type {string}
     * @memberof CustomerApiCustomersList
     */
    readonly modifiedGte?: string

    /**
     * 
     * @type {string}
     * @memberof CustomerApiCustomersList
     */
    readonly modifiedLt?: string

    /**
     * 
     * @type {string}
     * @memberof CustomerApiCustomersList
     */
    readonly modifiedLte?: string

    /**
     * 
     * @type {string}
     * @memberof CustomerApiCustomersList
     */
    readonly name?: string

    /**
     * 
     * @type {string}
     * @memberof CustomerApiCustomersList
     */
    readonly nameIn?: string

    /**
     * 
     * @type {string}
     * @memberof CustomerApiCustomersList
     */
    readonly nameStartswith?: string

    /**
     * 
     * @type {string}
     * @memberof CustomerApiCustomersList
     */
    readonly nextContactDateGt?: string

    /**
     * 
     * @type {string}
     * @memberof CustomerApiCustomersList
     */
    readonly nextContactDateGte?: string

    /**
     * 
     * @type {string}
     * @memberof CustomerApiCustomersList
     */
    readonly nextContactDateLt?: string

    /**
     * 
     * @type {string}
     * @memberof CustomerApiCustomersList
     */
    readonly nextContactDateLte?: string

    /**
     * 
     * @type {string}
     * @memberof CustomerApiCustomersList
     */
    readonly nickname?: string

    /**
     * Multiple values may be separated by commas.
     * @type {Array<string>}
     * @memberof CustomerApiCustomersList
     */
    readonly nicknameIn?: Array<string>

    /**
     * 
     * @type {string}
     * @memberof CustomerApiCustomersList
     */
    readonly nicknameStartswith?: string

    /**
     * 
     * @type {string}
     * @memberof CustomerApiCustomersList
     */
    readonly oldLicenseNumber?: string

    /**
     * Multiple values may be separated by commas.
     * @type {Array<string>}
     * @memberof CustomerApiCustomersList
     */
    readonly oldLicenseNumberIn?: Array<string>

    /**
     * 
     * @type {string}
     * @memberof CustomerApiCustomersList
     */
    readonly oldLicenseNumberStartswith?: string

    /**
     * Which field to use when ordering the results.
     * @type {string}
     * @memberof CustomerApiCustomersList
     */
    readonly ordering?: string

    /**
     * 
     * @type {number}
     * @memberof CustomerApiCustomersList
     */
    readonly owner?: number

    /**
     * 
     * @type {string}
     * @memberof CustomerApiCustomersList
     */
    readonly ownerSlug?: string

    /**
     * A page number within the paginated result set.
     * @type {number}
     * @memberof CustomerApiCustomersList
     */
    readonly page?: number

    /**
     * Number of results to return per page.
     * @type {number}
     * @memberof CustomerApiCustomersList
     */
    readonly pageSize?: number

    /**
     * 
     * @type {number}
     * @memberof CustomerApiCustomersList
     */
    readonly partner?: number

    /**
     * Multiple values may be separated by commas.
     * @type {Array<number>}
     * @memberof CustomerApiCustomersList
     */
    readonly paymentTerm?: Array<number>

    /**
     * 
     * @type {string}
     * @memberof CustomerApiCustomersList
     */
    readonly phone?: string

    /**
     * 
     * @type {string}
     * @memberof CustomerApiCustomersList
     */
    readonly phoneIn?: string

    /**
     * 
     * @type {string}
     * @memberof CustomerApiCustomersList
     */
    readonly phoneStartswith?: string

    /**
     * Multiple values may be separated by commas.
     * @type {Array<number>}
     * @memberof CustomerApiCustomersList
     */
    readonly priceSchedule?: Array<number>

    /**
     * A search term.
     * @type {string}
     * @memberof CustomerApiCustomersList
     */
    readonly search?: string

    /**
     * Multiple values may be separated by commas.
     * @type {Array<number>}
     * @memberof CustomerApiCustomersList
     */
    readonly serviceZone?: Array<number>

    /**
     * Multiple values may be separated by commas.
     * @type {Array<number>}
     * @memberof CustomerApiCustomersList
     */
    readonly state?: Array<number>

    /**
     * Multiple values may be separated by commas.
     * @type {Array<number>}
     * @memberof CustomerApiCustomersList
     */
    readonly status?: Array<number>

    /**
     * Multiple values may be separated by commas.
     * @type {Array<number>}
     * @memberof CustomerApiCustomersList
     */
    readonly tier?: Array<number>

    /**
     * 
     * @type {string}
     * @memberof CustomerApiCustomersList
     */
    readonly website?: string

    /**
     * 
     * @type {string}
     * @memberof CustomerApiCustomersList
     */
    readonly websiteIn?: string

    /**
     * 
     * @type {string}
     * @memberof CustomerApiCustomersList
     */
    readonly websiteStartswith?: string

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof CustomerApiCustomersList
     */
    readonly leafLinkVersion?: string
}

/**
 * Request parameters for customersRetrieve operation in CustomerApi.
 * @export
 * @interface CustomerApiCustomersRetrieveRequest
 */
export interface CustomerApiCustomersRetrieveRequest {
    /**
     * A unique integer value identifying this company customer.
     * @type {number}
     * @memberof CustomerApiCustomersRetrieve
     */
    readonly id: number

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof CustomerApiCustomersRetrieve
     */
    readonly leafLinkVersion?: string
}

/**
 * CustomerApi - object-oriented interface
 * @export
 * @class CustomerApi
 * @extends {BaseAPI}
 */
export class CustomerApi extends BaseAPI {
    /**
     * List multiple Company Customer Status.
     * @summary List Company Customer Status
     * @param {CustomerApiCustomerStatusesListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerApi
     */
    public customerStatusesList(requestParameters: CustomerApiCustomerStatusesListRequest = {}, options?: RawAxiosRequestConfig) {
        return CustomerApiFp(this.configuration).customerStatusesList(requestParameters.companySlug, requestParameters.description, requestParameters.hexColor, requestParameters.id, requestParameters.isStock, requestParameters.order, requestParameters.ordering, requestParameters.owner, requestParameters.page, requestParameters.pageSize, requestParameters.search, requestParameters.state, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a single Company Customer Status.
     * @summary Get Company Customer Status
     * @param {CustomerApiCustomerStatusesRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerApi
     */
    public customerStatusesRetrieve(requestParameters: CustomerApiCustomerStatusesRetrieveRequest, options?: RawAxiosRequestConfig) {
        return CustomerApiFp(this.configuration).customerStatusesRetrieve(requestParameters.id, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List multiple Customers.
     * @summary List Customers
     * @param {CustomerApiCustomersListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerApi
     */
    public customersList(requestParameters: CustomerApiCustomersListRequest = {}, options?: RawAxiosRequestConfig) {
        return CustomerApiFp(this.configuration).customersList(requestParameters.address, requestParameters.addressIn, requestParameters.addressStartswith, requestParameters.archived, requestParameters.brand, requestParameters.brandIn, requestParameters.brandStartswith, requestParameters.businessIdentifier, requestParameters.businessIdentifierIn, requestParameters.businessIdentifierStartswith, requestParameters.businessLicenseName, requestParameters.businessLicenseNameIn, requestParameters.businessLicenseNameStartswith, requestParameters.companySlug, requestParameters.createdOnGt, requestParameters.createdOnGte, requestParameters.createdOnLt, requestParameters.createdOnLte, requestParameters.dba, requestParameters.dbaIn, requestParameters.dbaStartswith, requestParameters.delinquent, requestParameters.discountPercentGt, requestParameters.discountPercentGte, requestParameters.discountPercentLt, requestParameters.discountPercentLte, requestParameters.ein, requestParameters.einIn, requestParameters.einStartswith, requestParameters.email, requestParameters.emailIn, requestParameters.emailStartswith, requestParameters.extAcctId, requestParameters.extAcctIdIn, requestParameters.extAcctIdIsnull, requestParameters.extAcctIdStartswith, requestParameters.externalId, requestParameters.externalIdIn, requestParameters.externalIdStartswith, requestParameters.externalIdKey, requestParameters.externalIdUnmapped, requestParameters.externalIdValues, requestParameters.id, requestParameters.idIn, requestParameters.isArchived, requestParameters.leaflinkSource, requestParameters.licenseInactive, requestParameters.licenseNumber, requestParameters.licenseType, requestParameters.modifiedGt, requestParameters.modifiedGte, requestParameters.modifiedLt, requestParameters.modifiedLte, requestParameters.name, requestParameters.nameIn, requestParameters.nameStartswith, requestParameters.nextContactDateGt, requestParameters.nextContactDateGte, requestParameters.nextContactDateLt, requestParameters.nextContactDateLte, requestParameters.nickname, requestParameters.nicknameIn, requestParameters.nicknameStartswith, requestParameters.oldLicenseNumber, requestParameters.oldLicenseNumberIn, requestParameters.oldLicenseNumberStartswith, requestParameters.ordering, requestParameters.owner, requestParameters.ownerSlug, requestParameters.page, requestParameters.pageSize, requestParameters.partner, requestParameters.paymentTerm, requestParameters.phone, requestParameters.phoneIn, requestParameters.phoneStartswith, requestParameters.priceSchedule, requestParameters.search, requestParameters.serviceZone, requestParameters.state, requestParameters.status, requestParameters.tier, requestParameters.website, requestParameters.websiteIn, requestParameters.websiteStartswith, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a single Customer.
     * @summary Get Customer
     * @param {CustomerApiCustomersRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerApi
     */
    public customersRetrieve(requestParameters: CustomerApiCustomersRetrieveRequest, options?: RawAxiosRequestConfig) {
        return CustomerApiFp(this.configuration).customersRetrieve(requestParameters.id, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CustomerStatusesApi - axios parameter creator
 * @export
 */
export const CustomerStatusesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * LeafLink API for Marketplace company customer status.
         * @param {UnifiedCompanyCustomerStatusRequest} unifiedCompanyCustomerStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerStatusesCreate: async (unifiedCompanyCustomerStatusRequest: UnifiedCompanyCustomerStatusRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'unifiedCompanyCustomerStatusRequest' is not null or undefined
            assertParamExists('customerStatusesCreate', 'unifiedCompanyCustomerStatusRequest', unifiedCompanyCustomerStatusRequest)
            const localVarPath = `/customer_statuses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(unifiedCompanyCustomerStatusRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * LeafLink API for Marketplace company customer status.
         * @param {number} id A unique integer value identifying this company customer status.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerStatusesDestroy: async (id: number, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('customerStatusesDestroy', 'id', id)
            const localVarPath = `/customer_statuses/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * LeafLink API for Marketplace company customer status.
         * @param {number} id A unique integer value identifying this company customer status.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {PatchedUnifiedCompanyCustomerStatusRequest} [patchedUnifiedCompanyCustomerStatusRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerStatusesPartialUpdate: async (id: number, leafLinkVersion?: string, patchedUnifiedCompanyCustomerStatusRequest?: PatchedUnifiedCompanyCustomerStatusRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('customerStatusesPartialUpdate', 'id', id)
            const localVarPath = `/customer_statuses/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchedUnifiedCompanyCustomerStatusRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * LeafLink API for Marketplace company customer status.
         * @param {number} id A unique integer value identifying this company customer status.
         * @param {UnifiedCompanyCustomerStatusRequest} unifiedCompanyCustomerStatusRequest 
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerStatusesUpdate: async (id: number, unifiedCompanyCustomerStatusRequest: UnifiedCompanyCustomerStatusRequest, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('customerStatusesUpdate', 'id', id)
            // verify required parameter 'unifiedCompanyCustomerStatusRequest' is not null or undefined
            assertParamExists('customerStatusesUpdate', 'unifiedCompanyCustomerStatusRequest', unifiedCompanyCustomerStatusRequest)
            const localVarPath = `/customer_statuses/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(unifiedCompanyCustomerStatusRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CustomerStatusesApi - functional programming interface
 * @export
 */
export const CustomerStatusesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CustomerStatusesApiAxiosParamCreator(configuration)
    return {
        /**
         * LeafLink API for Marketplace company customer status.
         * @param {UnifiedCompanyCustomerStatusRequest} unifiedCompanyCustomerStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async customerStatusesCreate(unifiedCompanyCustomerStatusRequest: UnifiedCompanyCustomerStatusRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnifiedCompanyCustomerStatus>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.customerStatusesCreate(unifiedCompanyCustomerStatusRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerStatusesApi.customerStatusesCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * LeafLink API for Marketplace company customer status.
         * @param {number} id A unique integer value identifying this company customer status.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async customerStatusesDestroy(id: number, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.customerStatusesDestroy(id, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerStatusesApi.customerStatusesDestroy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * LeafLink API for Marketplace company customer status.
         * @param {number} id A unique integer value identifying this company customer status.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {PatchedUnifiedCompanyCustomerStatusRequest} [patchedUnifiedCompanyCustomerStatusRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async customerStatusesPartialUpdate(id: number, leafLinkVersion?: string, patchedUnifiedCompanyCustomerStatusRequest?: PatchedUnifiedCompanyCustomerStatusRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnifiedCompanyCustomerStatus>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.customerStatusesPartialUpdate(id, leafLinkVersion, patchedUnifiedCompanyCustomerStatusRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerStatusesApi.customerStatusesPartialUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * LeafLink API for Marketplace company customer status.
         * @param {number} id A unique integer value identifying this company customer status.
         * @param {UnifiedCompanyCustomerStatusRequest} unifiedCompanyCustomerStatusRequest 
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async customerStatusesUpdate(id: number, unifiedCompanyCustomerStatusRequest: UnifiedCompanyCustomerStatusRequest, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnifiedCompanyCustomerStatus>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.customerStatusesUpdate(id, unifiedCompanyCustomerStatusRequest, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerStatusesApi.customerStatusesUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CustomerStatusesApi - factory interface
 * @export
 */
export const CustomerStatusesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CustomerStatusesApiFp(configuration)
    return {
        /**
         * LeafLink API for Marketplace company customer status.
         * @param {CustomerStatusesApiCustomerStatusesCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerStatusesCreate(requestParameters: CustomerStatusesApiCustomerStatusesCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<UnifiedCompanyCustomerStatus> {
            return localVarFp.customerStatusesCreate(requestParameters.unifiedCompanyCustomerStatusRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * LeafLink API for Marketplace company customer status.
         * @param {CustomerStatusesApiCustomerStatusesDestroyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerStatusesDestroy(requestParameters: CustomerStatusesApiCustomerStatusesDestroyRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.customerStatusesDestroy(requestParameters.id, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * LeafLink API for Marketplace company customer status.
         * @param {CustomerStatusesApiCustomerStatusesPartialUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerStatusesPartialUpdate(requestParameters: CustomerStatusesApiCustomerStatusesPartialUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<UnifiedCompanyCustomerStatus> {
            return localVarFp.customerStatusesPartialUpdate(requestParameters.id, requestParameters.leafLinkVersion, requestParameters.patchedUnifiedCompanyCustomerStatusRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * LeafLink API for Marketplace company customer status.
         * @param {CustomerStatusesApiCustomerStatusesUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerStatusesUpdate(requestParameters: CustomerStatusesApiCustomerStatusesUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<UnifiedCompanyCustomerStatus> {
            return localVarFp.customerStatusesUpdate(requestParameters.id, requestParameters.unifiedCompanyCustomerStatusRequest, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for customerStatusesCreate operation in CustomerStatusesApi.
 * @export
 * @interface CustomerStatusesApiCustomerStatusesCreateRequest
 */
export interface CustomerStatusesApiCustomerStatusesCreateRequest {
    /**
     * 
     * @type {UnifiedCompanyCustomerStatusRequest}
     * @memberof CustomerStatusesApiCustomerStatusesCreate
     */
    readonly unifiedCompanyCustomerStatusRequest: UnifiedCompanyCustomerStatusRequest
}

/**
 * Request parameters for customerStatusesDestroy operation in CustomerStatusesApi.
 * @export
 * @interface CustomerStatusesApiCustomerStatusesDestroyRequest
 */
export interface CustomerStatusesApiCustomerStatusesDestroyRequest {
    /**
     * A unique integer value identifying this company customer status.
     * @type {number}
     * @memberof CustomerStatusesApiCustomerStatusesDestroy
     */
    readonly id: number

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof CustomerStatusesApiCustomerStatusesDestroy
     */
    readonly leafLinkVersion?: string
}

/**
 * Request parameters for customerStatusesPartialUpdate operation in CustomerStatusesApi.
 * @export
 * @interface CustomerStatusesApiCustomerStatusesPartialUpdateRequest
 */
export interface CustomerStatusesApiCustomerStatusesPartialUpdateRequest {
    /**
     * A unique integer value identifying this company customer status.
     * @type {number}
     * @memberof CustomerStatusesApiCustomerStatusesPartialUpdate
     */
    readonly id: number

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof CustomerStatusesApiCustomerStatusesPartialUpdate
     */
    readonly leafLinkVersion?: string

    /**
     * 
     * @type {PatchedUnifiedCompanyCustomerStatusRequest}
     * @memberof CustomerStatusesApiCustomerStatusesPartialUpdate
     */
    readonly patchedUnifiedCompanyCustomerStatusRequest?: PatchedUnifiedCompanyCustomerStatusRequest
}

/**
 * Request parameters for customerStatusesUpdate operation in CustomerStatusesApi.
 * @export
 * @interface CustomerStatusesApiCustomerStatusesUpdateRequest
 */
export interface CustomerStatusesApiCustomerStatusesUpdateRequest {
    /**
     * A unique integer value identifying this company customer status.
     * @type {number}
     * @memberof CustomerStatusesApiCustomerStatusesUpdate
     */
    readonly id: number

    /**
     * 
     * @type {UnifiedCompanyCustomerStatusRequest}
     * @memberof CustomerStatusesApiCustomerStatusesUpdate
     */
    readonly unifiedCompanyCustomerStatusRequest: UnifiedCompanyCustomerStatusRequest

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof CustomerStatusesApiCustomerStatusesUpdate
     */
    readonly leafLinkVersion?: string
}

/**
 * CustomerStatusesApi - object-oriented interface
 * @export
 * @class CustomerStatusesApi
 * @extends {BaseAPI}
 */
export class CustomerStatusesApi extends BaseAPI {
    /**
     * LeafLink API for Marketplace company customer status.
     * @param {CustomerStatusesApiCustomerStatusesCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerStatusesApi
     */
    public customerStatusesCreate(requestParameters: CustomerStatusesApiCustomerStatusesCreateRequest, options?: RawAxiosRequestConfig) {
        return CustomerStatusesApiFp(this.configuration).customerStatusesCreate(requestParameters.unifiedCompanyCustomerStatusRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * LeafLink API for Marketplace company customer status.
     * @param {CustomerStatusesApiCustomerStatusesDestroyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerStatusesApi
     */
    public customerStatusesDestroy(requestParameters: CustomerStatusesApiCustomerStatusesDestroyRequest, options?: RawAxiosRequestConfig) {
        return CustomerStatusesApiFp(this.configuration).customerStatusesDestroy(requestParameters.id, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * LeafLink API for Marketplace company customer status.
     * @param {CustomerStatusesApiCustomerStatusesPartialUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerStatusesApi
     */
    public customerStatusesPartialUpdate(requestParameters: CustomerStatusesApiCustomerStatusesPartialUpdateRequest, options?: RawAxiosRequestConfig) {
        return CustomerStatusesApiFp(this.configuration).customerStatusesPartialUpdate(requestParameters.id, requestParameters.leafLinkVersion, requestParameters.patchedUnifiedCompanyCustomerStatusRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * LeafLink API for Marketplace company customer status.
     * @param {CustomerStatusesApiCustomerStatusesUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerStatusesApi
     */
    public customerStatusesUpdate(requestParameters: CustomerStatusesApiCustomerStatusesUpdateRequest, options?: RawAxiosRequestConfig) {
        return CustomerStatusesApiFp(this.configuration).customerStatusesUpdate(requestParameters.id, requestParameters.unifiedCompanyCustomerStatusRequest, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CustomersApi - axios parameter creator
 * @export
 */
export const CustomersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Delete an Active Entry for a company
         * @param {number} id A unique integer value identifying this company activity entry.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersActiveEntriesDestroy: async (id: number, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('customersActiveEntriesDestroy', 'id', id)
            const localVarPath = `/customers/active_entries/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Action route for interfacing with the corporate address
         * @param {number} id A unique integer value identifying this company customer.
         * @param {UnifiedAddressRequest} unifiedAddressRequest 
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCorporateAddressCreate: async (id: number, unifiedAddressRequest: UnifiedAddressRequest, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('customersCorporateAddressCreate', 'id', id)
            // verify required parameter 'unifiedAddressRequest' is not null or undefined
            assertParamExists('customersCorporateAddressCreate', 'unifiedAddressRequest', unifiedAddressRequest)
            const localVarPath = `/customers/{id}/corporate_address`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(unifiedAddressRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Action route for interfacing with the corporate address
         * @param {number} id A unique integer value identifying this company customer.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCorporateAddressDestroy: async (id: number, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('customersCorporateAddressDestroy', 'id', id)
            const localVarPath = `/customers/{id}/corporate_address`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Action route for interfacing with the corporate address
         * @param {number} id A unique integer value identifying this company customer.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {PatchedUnifiedAddressRequest} [patchedUnifiedAddressRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCorporateAddressPartialUpdate: async (id: number, leafLinkVersion?: string, patchedUnifiedAddressRequest?: PatchedUnifiedAddressRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('customersCorporateAddressPartialUpdate', 'id', id)
            const localVarPath = `/customers/{id}/corporate_address`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchedUnifiedAddressRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * LeafLink API for Marketplace customers.
         * @param {UnifiedCustomerRequest} unifiedCustomerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCreate: async (unifiedCustomerRequest: UnifiedCustomerRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'unifiedCustomerRequest' is not null or undefined
            assertParamExists('customersCreate', 'unifiedCustomerRequest', unifiedCustomerRequest)
            const localVarPath = `/customers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(unifiedCustomerRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Action route for interfacing with the delivery address
         * @param {number} id A unique integer value identifying this company customer.
         * @param {UnifiedAddressRequest} unifiedAddressRequest 
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersDeliveryAddressCreate: async (id: number, unifiedAddressRequest: UnifiedAddressRequest, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('customersDeliveryAddressCreate', 'id', id)
            // verify required parameter 'unifiedAddressRequest' is not null or undefined
            assertParamExists('customersDeliveryAddressCreate', 'unifiedAddressRequest', unifiedAddressRequest)
            const localVarPath = `/customers/{id}/delivery_address`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(unifiedAddressRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Action route for interfacing with the delivery address
         * @param {number} id A unique integer value identifying this company customer.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersDeliveryAddressDestroy: async (id: number, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('customersDeliveryAddressDestroy', 'id', id)
            const localVarPath = `/customers/{id}/delivery_address`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Action route for interfacing with the delivery address
         * @param {number} id A unique integer value identifying this company customer.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {PatchedUnifiedAddressRequest} [patchedUnifiedAddressRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersDeliveryAddressPartialUpdate: async (id: number, leafLinkVersion?: string, patchedUnifiedAddressRequest?: PatchedUnifiedAddressRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('customersDeliveryAddressPartialUpdate', 'id', id)
            const localVarPath = `/customers/{id}/delivery_address`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchedUnifiedAddressRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * For delete request
         * @param {number} id A unique integer value identifying this company customer.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersDestroy: async (id: number, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('customersDestroy', 'id', id)
            const localVarPath = `/customers/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * LeafLink API for Marketplace customers.
         * @param {number} id A unique integer value identifying this company customer.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {PatchedUnifiedCustomerRequest} [patchedUnifiedCustomerRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersPartialUpdate: async (id: number, leafLinkVersion?: string, patchedUnifiedCustomerRequest?: PatchedUnifiedCustomerRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('customersPartialUpdate', 'id', id)
            const localVarPath = `/customers/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchedUnifiedCustomerRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * LeafLink API for Marketplace customers.
         * @param {number} id A unique integer value identifying this company customer.
         * @param {UnifiedCustomerRequest} unifiedCustomerRequest 
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersUpdate: async (id: number, unifiedCustomerRequest: UnifiedCustomerRequest, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('customersUpdate', 'id', id)
            // verify required parameter 'unifiedCustomerRequest' is not null or undefined
            assertParamExists('customersUpdate', 'unifiedCustomerRequest', unifiedCustomerRequest)
            const localVarPath = `/customers/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(unifiedCustomerRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CustomersApi - functional programming interface
 * @export
 */
export const CustomersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CustomersApiAxiosParamCreator(configuration)
    return {
        /**
         * Delete an Active Entry for a company
         * @param {number} id A unique integer value identifying this company activity entry.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async customersActiveEntriesDestroy(id: number, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.customersActiveEntriesDestroy(id, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomersApi.customersActiveEntriesDestroy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Action route for interfacing with the corporate address
         * @param {number} id A unique integer value identifying this company customer.
         * @param {UnifiedAddressRequest} unifiedAddressRequest 
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async customersCorporateAddressCreate(id: number, unifiedAddressRequest: UnifiedAddressRequest, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnifiedAddress>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.customersCorporateAddressCreate(id, unifiedAddressRequest, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomersApi.customersCorporateAddressCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Action route for interfacing with the corporate address
         * @param {number} id A unique integer value identifying this company customer.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async customersCorporateAddressDestroy(id: number, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.customersCorporateAddressDestroy(id, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomersApi.customersCorporateAddressDestroy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Action route for interfacing with the corporate address
         * @param {number} id A unique integer value identifying this company customer.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {PatchedUnifiedAddressRequest} [patchedUnifiedAddressRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async customersCorporateAddressPartialUpdate(id: number, leafLinkVersion?: string, patchedUnifiedAddressRequest?: PatchedUnifiedAddressRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnifiedAddress>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.customersCorporateAddressPartialUpdate(id, leafLinkVersion, patchedUnifiedAddressRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomersApi.customersCorporateAddressPartialUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * LeafLink API for Marketplace customers.
         * @param {UnifiedCustomerRequest} unifiedCustomerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async customersCreate(unifiedCustomerRequest: UnifiedCustomerRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnifiedCustomer>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.customersCreate(unifiedCustomerRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomersApi.customersCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Action route for interfacing with the delivery address
         * @param {number} id A unique integer value identifying this company customer.
         * @param {UnifiedAddressRequest} unifiedAddressRequest 
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async customersDeliveryAddressCreate(id: number, unifiedAddressRequest: UnifiedAddressRequest, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnifiedAddress>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.customersDeliveryAddressCreate(id, unifiedAddressRequest, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomersApi.customersDeliveryAddressCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Action route for interfacing with the delivery address
         * @param {number} id A unique integer value identifying this company customer.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async customersDeliveryAddressDestroy(id: number, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.customersDeliveryAddressDestroy(id, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomersApi.customersDeliveryAddressDestroy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Action route for interfacing with the delivery address
         * @param {number} id A unique integer value identifying this company customer.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {PatchedUnifiedAddressRequest} [patchedUnifiedAddressRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async customersDeliveryAddressPartialUpdate(id: number, leafLinkVersion?: string, patchedUnifiedAddressRequest?: PatchedUnifiedAddressRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnifiedAddress>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.customersDeliveryAddressPartialUpdate(id, leafLinkVersion, patchedUnifiedAddressRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomersApi.customersDeliveryAddressPartialUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * For delete request
         * @param {number} id A unique integer value identifying this company customer.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async customersDestroy(id: number, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.customersDestroy(id, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomersApi.customersDestroy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * LeafLink API for Marketplace customers.
         * @param {number} id A unique integer value identifying this company customer.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {PatchedUnifiedCustomerRequest} [patchedUnifiedCustomerRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async customersPartialUpdate(id: number, leafLinkVersion?: string, patchedUnifiedCustomerRequest?: PatchedUnifiedCustomerRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnifiedCustomer>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.customersPartialUpdate(id, leafLinkVersion, patchedUnifiedCustomerRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomersApi.customersPartialUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * LeafLink API for Marketplace customers.
         * @param {number} id A unique integer value identifying this company customer.
         * @param {UnifiedCustomerRequest} unifiedCustomerRequest 
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async customersUpdate(id: number, unifiedCustomerRequest: UnifiedCustomerRequest, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnifiedCustomer>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.customersUpdate(id, unifiedCustomerRequest, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomersApi.customersUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CustomersApi - factory interface
 * @export
 */
export const CustomersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CustomersApiFp(configuration)
    return {
        /**
         * Delete an Active Entry for a company
         * @param {CustomersApiCustomersActiveEntriesDestroyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersActiveEntriesDestroy(requestParameters: CustomersApiCustomersActiveEntriesDestroyRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.customersActiveEntriesDestroy(requestParameters.id, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * Action route for interfacing with the corporate address
         * @param {CustomersApiCustomersCorporateAddressCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCorporateAddressCreate(requestParameters: CustomersApiCustomersCorporateAddressCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<UnifiedAddress> {
            return localVarFp.customersCorporateAddressCreate(requestParameters.id, requestParameters.unifiedAddressRequest, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * Action route for interfacing with the corporate address
         * @param {CustomersApiCustomersCorporateAddressDestroyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCorporateAddressDestroy(requestParameters: CustomersApiCustomersCorporateAddressDestroyRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.customersCorporateAddressDestroy(requestParameters.id, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * Action route for interfacing with the corporate address
         * @param {CustomersApiCustomersCorporateAddressPartialUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCorporateAddressPartialUpdate(requestParameters: CustomersApiCustomersCorporateAddressPartialUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<UnifiedAddress> {
            return localVarFp.customersCorporateAddressPartialUpdate(requestParameters.id, requestParameters.leafLinkVersion, requestParameters.patchedUnifiedAddressRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * LeafLink API for Marketplace customers.
         * @param {CustomersApiCustomersCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCreate(requestParameters: CustomersApiCustomersCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<UnifiedCustomer> {
            return localVarFp.customersCreate(requestParameters.unifiedCustomerRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Action route for interfacing with the delivery address
         * @param {CustomersApiCustomersDeliveryAddressCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersDeliveryAddressCreate(requestParameters: CustomersApiCustomersDeliveryAddressCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<UnifiedAddress> {
            return localVarFp.customersDeliveryAddressCreate(requestParameters.id, requestParameters.unifiedAddressRequest, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * Action route for interfacing with the delivery address
         * @param {CustomersApiCustomersDeliveryAddressDestroyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersDeliveryAddressDestroy(requestParameters: CustomersApiCustomersDeliveryAddressDestroyRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.customersDeliveryAddressDestroy(requestParameters.id, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * Action route for interfacing with the delivery address
         * @param {CustomersApiCustomersDeliveryAddressPartialUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersDeliveryAddressPartialUpdate(requestParameters: CustomersApiCustomersDeliveryAddressPartialUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<UnifiedAddress> {
            return localVarFp.customersDeliveryAddressPartialUpdate(requestParameters.id, requestParameters.leafLinkVersion, requestParameters.patchedUnifiedAddressRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * For delete request
         * @param {CustomersApiCustomersDestroyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersDestroy(requestParameters: CustomersApiCustomersDestroyRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.customersDestroy(requestParameters.id, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * LeafLink API for Marketplace customers.
         * @param {CustomersApiCustomersPartialUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersPartialUpdate(requestParameters: CustomersApiCustomersPartialUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<UnifiedCustomer> {
            return localVarFp.customersPartialUpdate(requestParameters.id, requestParameters.leafLinkVersion, requestParameters.patchedUnifiedCustomerRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * LeafLink API for Marketplace customers.
         * @param {CustomersApiCustomersUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersUpdate(requestParameters: CustomersApiCustomersUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<UnifiedCustomer> {
            return localVarFp.customersUpdate(requestParameters.id, requestParameters.unifiedCustomerRequest, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for customersActiveEntriesDestroy operation in CustomersApi.
 * @export
 * @interface CustomersApiCustomersActiveEntriesDestroyRequest
 */
export interface CustomersApiCustomersActiveEntriesDestroyRequest {
    /**
     * A unique integer value identifying this company activity entry.
     * @type {number}
     * @memberof CustomersApiCustomersActiveEntriesDestroy
     */
    readonly id: number

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof CustomersApiCustomersActiveEntriesDestroy
     */
    readonly leafLinkVersion?: string
}

/**
 * Request parameters for customersCorporateAddressCreate operation in CustomersApi.
 * @export
 * @interface CustomersApiCustomersCorporateAddressCreateRequest
 */
export interface CustomersApiCustomersCorporateAddressCreateRequest {
    /**
     * A unique integer value identifying this company customer.
     * @type {number}
     * @memberof CustomersApiCustomersCorporateAddressCreate
     */
    readonly id: number

    /**
     * 
     * @type {UnifiedAddressRequest}
     * @memberof CustomersApiCustomersCorporateAddressCreate
     */
    readonly unifiedAddressRequest: UnifiedAddressRequest

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof CustomersApiCustomersCorporateAddressCreate
     */
    readonly leafLinkVersion?: string
}

/**
 * Request parameters for customersCorporateAddressDestroy operation in CustomersApi.
 * @export
 * @interface CustomersApiCustomersCorporateAddressDestroyRequest
 */
export interface CustomersApiCustomersCorporateAddressDestroyRequest {
    /**
     * A unique integer value identifying this company customer.
     * @type {number}
     * @memberof CustomersApiCustomersCorporateAddressDestroy
     */
    readonly id: number

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof CustomersApiCustomersCorporateAddressDestroy
     */
    readonly leafLinkVersion?: string
}

/**
 * Request parameters for customersCorporateAddressPartialUpdate operation in CustomersApi.
 * @export
 * @interface CustomersApiCustomersCorporateAddressPartialUpdateRequest
 */
export interface CustomersApiCustomersCorporateAddressPartialUpdateRequest {
    /**
     * A unique integer value identifying this company customer.
     * @type {number}
     * @memberof CustomersApiCustomersCorporateAddressPartialUpdate
     */
    readonly id: number

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof CustomersApiCustomersCorporateAddressPartialUpdate
     */
    readonly leafLinkVersion?: string

    /**
     * 
     * @type {PatchedUnifiedAddressRequest}
     * @memberof CustomersApiCustomersCorporateAddressPartialUpdate
     */
    readonly patchedUnifiedAddressRequest?: PatchedUnifiedAddressRequest
}

/**
 * Request parameters for customersCreate operation in CustomersApi.
 * @export
 * @interface CustomersApiCustomersCreateRequest
 */
export interface CustomersApiCustomersCreateRequest {
    /**
     * 
     * @type {UnifiedCustomerRequest}
     * @memberof CustomersApiCustomersCreate
     */
    readonly unifiedCustomerRequest: UnifiedCustomerRequest
}

/**
 * Request parameters for customersDeliveryAddressCreate operation in CustomersApi.
 * @export
 * @interface CustomersApiCustomersDeliveryAddressCreateRequest
 */
export interface CustomersApiCustomersDeliveryAddressCreateRequest {
    /**
     * A unique integer value identifying this company customer.
     * @type {number}
     * @memberof CustomersApiCustomersDeliveryAddressCreate
     */
    readonly id: number

    /**
     * 
     * @type {UnifiedAddressRequest}
     * @memberof CustomersApiCustomersDeliveryAddressCreate
     */
    readonly unifiedAddressRequest: UnifiedAddressRequest

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof CustomersApiCustomersDeliveryAddressCreate
     */
    readonly leafLinkVersion?: string
}

/**
 * Request parameters for customersDeliveryAddressDestroy operation in CustomersApi.
 * @export
 * @interface CustomersApiCustomersDeliveryAddressDestroyRequest
 */
export interface CustomersApiCustomersDeliveryAddressDestroyRequest {
    /**
     * A unique integer value identifying this company customer.
     * @type {number}
     * @memberof CustomersApiCustomersDeliveryAddressDestroy
     */
    readonly id: number

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof CustomersApiCustomersDeliveryAddressDestroy
     */
    readonly leafLinkVersion?: string
}

/**
 * Request parameters for customersDeliveryAddressPartialUpdate operation in CustomersApi.
 * @export
 * @interface CustomersApiCustomersDeliveryAddressPartialUpdateRequest
 */
export interface CustomersApiCustomersDeliveryAddressPartialUpdateRequest {
    /**
     * A unique integer value identifying this company customer.
     * @type {number}
     * @memberof CustomersApiCustomersDeliveryAddressPartialUpdate
     */
    readonly id: number

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof CustomersApiCustomersDeliveryAddressPartialUpdate
     */
    readonly leafLinkVersion?: string

    /**
     * 
     * @type {PatchedUnifiedAddressRequest}
     * @memberof CustomersApiCustomersDeliveryAddressPartialUpdate
     */
    readonly patchedUnifiedAddressRequest?: PatchedUnifiedAddressRequest
}

/**
 * Request parameters for customersDestroy operation in CustomersApi.
 * @export
 * @interface CustomersApiCustomersDestroyRequest
 */
export interface CustomersApiCustomersDestroyRequest {
    /**
     * A unique integer value identifying this company customer.
     * @type {number}
     * @memberof CustomersApiCustomersDestroy
     */
    readonly id: number

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof CustomersApiCustomersDestroy
     */
    readonly leafLinkVersion?: string
}

/**
 * Request parameters for customersPartialUpdate operation in CustomersApi.
 * @export
 * @interface CustomersApiCustomersPartialUpdateRequest
 */
export interface CustomersApiCustomersPartialUpdateRequest {
    /**
     * A unique integer value identifying this company customer.
     * @type {number}
     * @memberof CustomersApiCustomersPartialUpdate
     */
    readonly id: number

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof CustomersApiCustomersPartialUpdate
     */
    readonly leafLinkVersion?: string

    /**
     * 
     * @type {PatchedUnifiedCustomerRequest}
     * @memberof CustomersApiCustomersPartialUpdate
     */
    readonly patchedUnifiedCustomerRequest?: PatchedUnifiedCustomerRequest
}

/**
 * Request parameters for customersUpdate operation in CustomersApi.
 * @export
 * @interface CustomersApiCustomersUpdateRequest
 */
export interface CustomersApiCustomersUpdateRequest {
    /**
     * A unique integer value identifying this company customer.
     * @type {number}
     * @memberof CustomersApiCustomersUpdate
     */
    readonly id: number

    /**
     * 
     * @type {UnifiedCustomerRequest}
     * @memberof CustomersApiCustomersUpdate
     */
    readonly unifiedCustomerRequest: UnifiedCustomerRequest

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof CustomersApiCustomersUpdate
     */
    readonly leafLinkVersion?: string
}

/**
 * CustomersApi - object-oriented interface
 * @export
 * @class CustomersApi
 * @extends {BaseAPI}
 */
export class CustomersApi extends BaseAPI {
    /**
     * Delete an Active Entry for a company
     * @param {CustomersApiCustomersActiveEntriesDestroyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    public customersActiveEntriesDestroy(requestParameters: CustomersApiCustomersActiveEntriesDestroyRequest, options?: RawAxiosRequestConfig) {
        return CustomersApiFp(this.configuration).customersActiveEntriesDestroy(requestParameters.id, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Action route for interfacing with the corporate address
     * @param {CustomersApiCustomersCorporateAddressCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    public customersCorporateAddressCreate(requestParameters: CustomersApiCustomersCorporateAddressCreateRequest, options?: RawAxiosRequestConfig) {
        return CustomersApiFp(this.configuration).customersCorporateAddressCreate(requestParameters.id, requestParameters.unifiedAddressRequest, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Action route for interfacing with the corporate address
     * @param {CustomersApiCustomersCorporateAddressDestroyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    public customersCorporateAddressDestroy(requestParameters: CustomersApiCustomersCorporateAddressDestroyRequest, options?: RawAxiosRequestConfig) {
        return CustomersApiFp(this.configuration).customersCorporateAddressDestroy(requestParameters.id, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Action route for interfacing with the corporate address
     * @param {CustomersApiCustomersCorporateAddressPartialUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    public customersCorporateAddressPartialUpdate(requestParameters: CustomersApiCustomersCorporateAddressPartialUpdateRequest, options?: RawAxiosRequestConfig) {
        return CustomersApiFp(this.configuration).customersCorporateAddressPartialUpdate(requestParameters.id, requestParameters.leafLinkVersion, requestParameters.patchedUnifiedAddressRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * LeafLink API for Marketplace customers.
     * @param {CustomersApiCustomersCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    public customersCreate(requestParameters: CustomersApiCustomersCreateRequest, options?: RawAxiosRequestConfig) {
        return CustomersApiFp(this.configuration).customersCreate(requestParameters.unifiedCustomerRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Action route for interfacing with the delivery address
     * @param {CustomersApiCustomersDeliveryAddressCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    public customersDeliveryAddressCreate(requestParameters: CustomersApiCustomersDeliveryAddressCreateRequest, options?: RawAxiosRequestConfig) {
        return CustomersApiFp(this.configuration).customersDeliveryAddressCreate(requestParameters.id, requestParameters.unifiedAddressRequest, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Action route for interfacing with the delivery address
     * @param {CustomersApiCustomersDeliveryAddressDestroyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    public customersDeliveryAddressDestroy(requestParameters: CustomersApiCustomersDeliveryAddressDestroyRequest, options?: RawAxiosRequestConfig) {
        return CustomersApiFp(this.configuration).customersDeliveryAddressDestroy(requestParameters.id, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Action route for interfacing with the delivery address
     * @param {CustomersApiCustomersDeliveryAddressPartialUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    public customersDeliveryAddressPartialUpdate(requestParameters: CustomersApiCustomersDeliveryAddressPartialUpdateRequest, options?: RawAxiosRequestConfig) {
        return CustomersApiFp(this.configuration).customersDeliveryAddressPartialUpdate(requestParameters.id, requestParameters.leafLinkVersion, requestParameters.patchedUnifiedAddressRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * For delete request
     * @param {CustomersApiCustomersDestroyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    public customersDestroy(requestParameters: CustomersApiCustomersDestroyRequest, options?: RawAxiosRequestConfig) {
        return CustomersApiFp(this.configuration).customersDestroy(requestParameters.id, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * LeafLink API for Marketplace customers.
     * @param {CustomersApiCustomersPartialUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    public customersPartialUpdate(requestParameters: CustomersApiCustomersPartialUpdateRequest, options?: RawAxiosRequestConfig) {
        return CustomersApiFp(this.configuration).customersPartialUpdate(requestParameters.id, requestParameters.leafLinkVersion, requestParameters.patchedUnifiedCustomerRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * LeafLink API for Marketplace customers.
     * @param {CustomersApiCustomersUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    public customersUpdate(requestParameters: CustomersApiCustomersUpdateRequest, options?: RawAxiosRequestConfig) {
        return CustomersApiFp(this.configuration).customersUpdate(requestParameters.id, requestParameters.unifiedCustomerRequest, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DashboardApi - axios parameter creator
 * @export
 */
export const DashboardApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * General purpose Sponsorship Content
         * @summary Sponsorships
         * @param {number} companyId The ID of the viewing company
         * @param {Array<ContentSponsoredRetrievePlacementEnum>} placement The ID of an ad location (can be repeated)
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contentSponsoredRetrieve: async (companyId: number, placement: Array<ContentSponsoredRetrievePlacementEnum>, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('contentSponsoredRetrieve', 'companyId', companyId)
            // verify required parameter 'placement' is not null or undefined
            assertParamExists('contentSponsoredRetrieve', 'placement', placement)
            const localVarPath = `/content/sponsored`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (companyId !== undefined) {
                localVarQueryParameter['company_id'] = companyId;
            }

            if (placement) {
                localVarQueryParameter['placement'] = placement;
            }


    
            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DashboardApi - functional programming interface
 * @export
 */
export const DashboardApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DashboardApiAxiosParamCreator(configuration)
    return {
        /**
         * General purpose Sponsorship Content
         * @summary Sponsorships
         * @param {number} companyId The ID of the viewing company
         * @param {Array<ContentSponsoredRetrievePlacementEnum>} placement The ID of an ad location (can be repeated)
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async contentSponsoredRetrieve(companyId: number, placement: Array<ContentSponsoredRetrievePlacementEnum>, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SponsorshipsContent>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.contentSponsoredRetrieve(companyId, placement, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DashboardApi.contentSponsoredRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DashboardApi - factory interface
 * @export
 */
export const DashboardApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DashboardApiFp(configuration)
    return {
        /**
         * General purpose Sponsorship Content
         * @summary Sponsorships
         * @param {DashboardApiContentSponsoredRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contentSponsoredRetrieve(requestParameters: DashboardApiContentSponsoredRetrieveRequest, options?: RawAxiosRequestConfig): AxiosPromise<SponsorshipsContent> {
            return localVarFp.contentSponsoredRetrieve(requestParameters.companyId, requestParameters.placement, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for contentSponsoredRetrieve operation in DashboardApi.
 * @export
 * @interface DashboardApiContentSponsoredRetrieveRequest
 */
export interface DashboardApiContentSponsoredRetrieveRequest {
    /**
     * The ID of the viewing company
     * @type {number}
     * @memberof DashboardApiContentSponsoredRetrieve
     */
    readonly companyId: number

    /**
     * The ID of an ad location (can be repeated)
     * @type {Array<'buyer-dash-hero-1' | 'buyer-dash-hero-2' | 'buyer-dash-hero-3' | 'buyer-dash-hero-4' | 'buyer-dash-hero-5' | 'buyer-dash-hero-6' | 'deals-page-1' | 'deals-page-2' | 'deals-page-3' | 'deals-page-4' | 'discovery-left' | 'discovery-right' | 'order-submit-1' | 'order-submit-2' | 'order-submit-3' | 'order-submit-4' | 'product-spotlight-carousel' | 'recommended-brands-recently-purchased' | 'recommended-products-cart' | 'recommended-products-order' | 'recommended-products-pdm-alternative' | 'recommended-products-pdp-alternative' | 'recommended-products-shop-brands' | 'recommended-products-shop-discover-products' | 'recommended-products-shop-products' | 'recommended-products-top-purchased' | 'seller-dash-hero-1' | 'seller-dash-hero-2' | 'seller-dash-hero-3' | 'seller-dash-hero-4' | 'seller-dash-hero-5' | 'seller-dash-hero-6' | 'shop-brands-featured-brand' | 'shop-brands-featured-brand-2' | 'shop-brands-featured-brand-3' | 'shop-brands-featured-brand-4' | 'shop-brands-featured-brand-5' | 'shop-brands-sidebar-3' | 'shop-brands-sidebar-4' | 'shop-brands-sidebar-bottom' | 'shop-brands-sidebar-top' | 'shop-brands-skyscraper-1' | 'shop-brands-skyscraper-2' | 'shop-brands-skyscraper-3' | 'shop-brands-skyscraper-4' | 'shop-products-1' | 'shop-products-2' | 'shop-products-3' | 'shop-products-4' | 'shop-products-5'>}
     * @memberof DashboardApiContentSponsoredRetrieve
     */
    readonly placement: Array<ContentSponsoredRetrievePlacementEnum>

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof DashboardApiContentSponsoredRetrieve
     */
    readonly leafLinkVersion?: string
}

/**
 * DashboardApi - object-oriented interface
 * @export
 * @class DashboardApi
 * @extends {BaseAPI}
 */
export class DashboardApi extends BaseAPI {
    /**
     * General purpose Sponsorship Content
     * @summary Sponsorships
     * @param {DashboardApiContentSponsoredRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardApi
     */
    public contentSponsoredRetrieve(requestParameters: DashboardApiContentSponsoredRetrieveRequest, options?: RawAxiosRequestConfig) {
        return DashboardApiFp(this.configuration).contentSponsoredRetrieve(requestParameters.companyId, requestParameters.placement, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const ContentSponsoredRetrievePlacementEnum = {
    BuyerDashHero1: 'buyer-dash-hero-1',
    BuyerDashHero2: 'buyer-dash-hero-2',
    BuyerDashHero3: 'buyer-dash-hero-3',
    BuyerDashHero4: 'buyer-dash-hero-4',
    BuyerDashHero5: 'buyer-dash-hero-5',
    BuyerDashHero6: 'buyer-dash-hero-6',
    DealsPage1: 'deals-page-1',
    DealsPage2: 'deals-page-2',
    DealsPage3: 'deals-page-3',
    DealsPage4: 'deals-page-4',
    DiscoveryLeft: 'discovery-left',
    DiscoveryRight: 'discovery-right',
    OrderSubmit1: 'order-submit-1',
    OrderSubmit2: 'order-submit-2',
    OrderSubmit3: 'order-submit-3',
    OrderSubmit4: 'order-submit-4',
    ProductSpotlightCarousel: 'product-spotlight-carousel',
    RecommendedBrandsRecentlyPurchased: 'recommended-brands-recently-purchased',
    RecommendedProductsCart: 'recommended-products-cart',
    RecommendedProductsOrder: 'recommended-products-order',
    RecommendedProductsPdmAlternative: 'recommended-products-pdm-alternative',
    RecommendedProductsPdpAlternative: 'recommended-products-pdp-alternative',
    RecommendedProductsShopBrands: 'recommended-products-shop-brands',
    RecommendedProductsShopDiscoverProducts: 'recommended-products-shop-discover-products',
    RecommendedProductsShopProducts: 'recommended-products-shop-products',
    RecommendedProductsTopPurchased: 'recommended-products-top-purchased',
    SellerDashHero1: 'seller-dash-hero-1',
    SellerDashHero2: 'seller-dash-hero-2',
    SellerDashHero3: 'seller-dash-hero-3',
    SellerDashHero4: 'seller-dash-hero-4',
    SellerDashHero5: 'seller-dash-hero-5',
    SellerDashHero6: 'seller-dash-hero-6',
    ShopBrandsFeaturedBrand: 'shop-brands-featured-brand',
    ShopBrandsFeaturedBrand2: 'shop-brands-featured-brand-2',
    ShopBrandsFeaturedBrand3: 'shop-brands-featured-brand-3',
    ShopBrandsFeaturedBrand4: 'shop-brands-featured-brand-4',
    ShopBrandsFeaturedBrand5: 'shop-brands-featured-brand-5',
    ShopBrandsSidebar3: 'shop-brands-sidebar-3',
    ShopBrandsSidebar4: 'shop-brands-sidebar-4',
    ShopBrandsSidebarBottom: 'shop-brands-sidebar-bottom',
    ShopBrandsSidebarTop: 'shop-brands-sidebar-top',
    ShopBrandsSkyscraper1: 'shop-brands-skyscraper-1',
    ShopBrandsSkyscraper2: 'shop-brands-skyscraper-2',
    ShopBrandsSkyscraper3: 'shop-brands-skyscraper-3',
    ShopBrandsSkyscraper4: 'shop-brands-skyscraper-4',
    ShopProducts1: 'shop-products-1',
    ShopProducts2: 'shop-products-2',
    ShopProducts3: 'shop-products-3',
    ShopProducts4: 'shop-products-4',
    ShopProducts5: 'shop-products-5'
} as const;
export type ContentSponsoredRetrievePlacementEnum = typeof ContentSponsoredRetrievePlacementEnum[keyof typeof ContentSponsoredRetrievePlacementEnum];


/**
 * DeliveriesApi - axios parameter creator
 * @export
 */
export const DeliveriesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Unified API product categories.
         * @param {UnifiedL3OrderRequest} unifiedL3OrderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deliveriesCreate: async (unifiedL3OrderRequest: UnifiedL3OrderRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'unifiedL3OrderRequest' is not null or undefined
            assertParamExists('deliveriesCreate', 'unifiedL3OrderRequest', unifiedL3OrderRequest)
            const localVarPath = `/deliveries`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(unifiedL3OrderRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Unified API product categories.
         * @param {string} [buyer] 
         * @param {string} [deliveryDate] 
         * @param {number} [limit] Number of results to return per page.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {string} [orderInvoiceNumber] 
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {string} [pickupDate] 
         * @param {string} [requestedDate] 
         * @param {string} [search] A search term.
         * @param {Array<DeliveriesListSortByEnum>} [sortBy] Ordering
         * @param {Array<DeliveriesListStatusEnum>} [status] 
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deliveriesList: async (buyer?: string, deliveryDate?: string, limit?: number, offset?: number, orderInvoiceNumber?: string, ordering?: string, pickupDate?: string, requestedDate?: string, search?: string, sortBy?: Array<DeliveriesListSortByEnum>, status?: Array<DeliveriesListStatusEnum>, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/deliveries`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (buyer !== undefined) {
                localVarQueryParameter['buyer'] = buyer;
            }

            if (deliveryDate !== undefined) {
                localVarQueryParameter['delivery_date'] = (deliveryDate as any instanceof Date) ?
                    (deliveryDate as any).toISOString().substring(0,10) :
                    deliveryDate;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (orderInvoiceNumber !== undefined) {
                localVarQueryParameter['order_invoice_number'] = orderInvoiceNumber;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }

            if (pickupDate !== undefined) {
                localVarQueryParameter['pickup_date'] = (pickupDate as any instanceof Date) ?
                    (pickupDate as any).toISOString().substring(0,10) :
                    pickupDate;
            }

            if (requestedDate !== undefined) {
                localVarQueryParameter['requested_date'] = (requestedDate as any instanceof Date) ?
                    (requestedDate as any).toISOString().substring(0,10) :
                    requestedDate;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (sortBy) {
                localVarQueryParameter['sort_by'] = sortBy.join(COLLECTION_FORMATS.csv);
            }

            if (status) {
                localVarQueryParameter['status'] = status;
            }


    
            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DeliveriesApi - functional programming interface
 * @export
 */
export const DeliveriesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DeliveriesApiAxiosParamCreator(configuration)
    return {
        /**
         * Unified API product categories.
         * @param {UnifiedL3OrderRequest} unifiedL3OrderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deliveriesCreate(unifiedL3OrderRequest: UnifiedL3OrderRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnifiedL3Order>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deliveriesCreate(unifiedL3OrderRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeliveriesApi.deliveriesCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Unified API product categories.
         * @param {string} [buyer] 
         * @param {string} [deliveryDate] 
         * @param {number} [limit] Number of results to return per page.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {string} [orderInvoiceNumber] 
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {string} [pickupDate] 
         * @param {string} [requestedDate] 
         * @param {string} [search] A search term.
         * @param {Array<DeliveriesListSortByEnum>} [sortBy] Ordering
         * @param {Array<DeliveriesListStatusEnum>} [status] 
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deliveriesList(buyer?: string, deliveryDate?: string, limit?: number, offset?: number, orderInvoiceNumber?: string, ordering?: string, pickupDate?: string, requestedDate?: string, search?: string, sortBy?: Array<DeliveriesListSortByEnum>, status?: Array<DeliveriesListStatusEnum>, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedUnifiedL3OrderList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deliveriesList(buyer, deliveryDate, limit, offset, orderInvoiceNumber, ordering, pickupDate, requestedDate, search, sortBy, status, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeliveriesApi.deliveriesList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DeliveriesApi - factory interface
 * @export
 */
export const DeliveriesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DeliveriesApiFp(configuration)
    return {
        /**
         * Unified API product categories.
         * @param {DeliveriesApiDeliveriesCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deliveriesCreate(requestParameters: DeliveriesApiDeliveriesCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<UnifiedL3Order> {
            return localVarFp.deliveriesCreate(requestParameters.unifiedL3OrderRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Unified API product categories.
         * @param {DeliveriesApiDeliveriesListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deliveriesList(requestParameters: DeliveriesApiDeliveriesListRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedUnifiedL3OrderList> {
            return localVarFp.deliveriesList(requestParameters.buyer, requestParameters.deliveryDate, requestParameters.limit, requestParameters.offset, requestParameters.orderInvoiceNumber, requestParameters.ordering, requestParameters.pickupDate, requestParameters.requestedDate, requestParameters.search, requestParameters.sortBy, requestParameters.status, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for deliveriesCreate operation in DeliveriesApi.
 * @export
 * @interface DeliveriesApiDeliveriesCreateRequest
 */
export interface DeliveriesApiDeliveriesCreateRequest {
    /**
     * 
     * @type {UnifiedL3OrderRequest}
     * @memberof DeliveriesApiDeliveriesCreate
     */
    readonly unifiedL3OrderRequest: UnifiedL3OrderRequest
}

/**
 * Request parameters for deliveriesList operation in DeliveriesApi.
 * @export
 * @interface DeliveriesApiDeliveriesListRequest
 */
export interface DeliveriesApiDeliveriesListRequest {
    /**
     * 
     * @type {string}
     * @memberof DeliveriesApiDeliveriesList
     */
    readonly buyer?: string

    /**
     * 
     * @type {string}
     * @memberof DeliveriesApiDeliveriesList
     */
    readonly deliveryDate?: string

    /**
     * Number of results to return per page.
     * @type {number}
     * @memberof DeliveriesApiDeliveriesList
     */
    readonly limit?: number

    /**
     * The initial index from which to return the results.
     * @type {number}
     * @memberof DeliveriesApiDeliveriesList
     */
    readonly offset?: number

    /**
     * 
     * @type {string}
     * @memberof DeliveriesApiDeliveriesList
     */
    readonly orderInvoiceNumber?: string

    /**
     * Which field to use when ordering the results.
     * @type {string}
     * @memberof DeliveriesApiDeliveriesList
     */
    readonly ordering?: string

    /**
     * 
     * @type {string}
     * @memberof DeliveriesApiDeliveriesList
     */
    readonly pickupDate?: string

    /**
     * 
     * @type {string}
     * @memberof DeliveriesApiDeliveriesList
     */
    readonly requestedDate?: string

    /**
     * A search term.
     * @type {string}
     * @memberof DeliveriesApiDeliveriesList
     */
    readonly search?: string

    /**
     * Ordering
     * @type {Array<'-created_on' | '-display_delivery_date' | '-requested_pickup_date' | 'created_on' | 'display_delivery_date' | 'requested_pickup_date'>}
     * @memberof DeliveriesApiDeliveriesList
     */
    readonly sortBy?: Array<DeliveriesListSortByEnum>

    /**
     * 
     * @type {Array<'assigned' | 'created' | 'delivered' | 'planned' | 'shipped' | 'uploaded'>}
     * @memberof DeliveriesApiDeliveriesList
     */
    readonly status?: Array<DeliveriesListStatusEnum>

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof DeliveriesApiDeliveriesList
     */
    readonly leafLinkVersion?: string
}

/**
 * DeliveriesApi - object-oriented interface
 * @export
 * @class DeliveriesApi
 * @extends {BaseAPI}
 */
export class DeliveriesApi extends BaseAPI {
    /**
     * Unified API product categories.
     * @param {DeliveriesApiDeliveriesCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeliveriesApi
     */
    public deliveriesCreate(requestParameters: DeliveriesApiDeliveriesCreateRequest, options?: RawAxiosRequestConfig) {
        return DeliveriesApiFp(this.configuration).deliveriesCreate(requestParameters.unifiedL3OrderRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Unified API product categories.
     * @param {DeliveriesApiDeliveriesListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeliveriesApi
     */
    public deliveriesList(requestParameters: DeliveriesApiDeliveriesListRequest = {}, options?: RawAxiosRequestConfig) {
        return DeliveriesApiFp(this.configuration).deliveriesList(requestParameters.buyer, requestParameters.deliveryDate, requestParameters.limit, requestParameters.offset, requestParameters.orderInvoiceNumber, requestParameters.ordering, requestParameters.pickupDate, requestParameters.requestedDate, requestParameters.search, requestParameters.sortBy, requestParameters.status, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const DeliveriesListSortByEnum = {
    CreatedOn: '-created_on',
    DisplayDeliveryDate: '-display_delivery_date',
    RequestedPickupDate: '-requested_pickup_date',
    CreatedOn2: 'created_on',
    DisplayDeliveryDate2: 'display_delivery_date',
    RequestedPickupDate2: 'requested_pickup_date'
} as const;
export type DeliveriesListSortByEnum = typeof DeliveriesListSortByEnum[keyof typeof DeliveriesListSortByEnum];
/**
 * @export
 */
export const DeliveriesListStatusEnum = {
    Assigned: 'assigned',
    Created: 'created',
    Delivered: 'delivered',
    Planned: 'planned',
    Shipped: 'shipped',
    Uploaded: 'uploaded'
} as const;
export type DeliveriesListStatusEnum = typeof DeliveriesListStatusEnum[keyof typeof DeliveriesListStatusEnum];


/**
 * ExpressMenusApi - axios parameter creator
 * @export
 */
export const ExpressMenusApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * LeafLink API for Marketplace Express Product Menus.
         * @param {UnifiedExpressProductMenuRequest} unifiedExpressProductMenuRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        expressMenusCreate: async (unifiedExpressProductMenuRequest: UnifiedExpressProductMenuRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'unifiedExpressProductMenuRequest' is not null or undefined
            assertParamExists('expressMenusCreate', 'unifiedExpressProductMenuRequest', unifiedExpressProductMenuRequest)
            const localVarPath = `/express_menus`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(unifiedExpressProductMenuRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * LeafLink API for Marketplace Express Product Menus.
         * @param {number} id A unique integer value identifying this express product menu.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        expressMenusDestroy: async (id: number, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('expressMenusDestroy', 'id', id)
            const localVarPath = `/express_menus/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * LeafLink API for Marketplace Express Product Menus.
         * @param {number} id A unique integer value identifying this express product menu.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {PatchedUnifiedExpressProductMenuRequest} [patchedUnifiedExpressProductMenuRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        expressMenusPartialUpdate: async (id: number, leafLinkVersion?: string, patchedUnifiedExpressProductMenuRequest?: PatchedUnifiedExpressProductMenuRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('expressMenusPartialUpdate', 'id', id)
            const localVarPath = `/express_menus/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchedUnifiedExpressProductMenuRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * LeafLink API for Marketplace Express Product Menus.
         * @param {number} id A unique integer value identifying this express product menu.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        expressMenusRetrieve: async (id: number, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('expressMenusRetrieve', 'id', id)
            const localVarPath = `/express_menus/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * LeafLink API for Marketplace Express Product Menus.
         * @param {number} id A unique integer value identifying this express product menu.
         * @param {UnifiedExpressProductMenuRequest} unifiedExpressProductMenuRequest 
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        expressMenusUpdate: async (id: number, unifiedExpressProductMenuRequest: UnifiedExpressProductMenuRequest, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('expressMenusUpdate', 'id', id)
            // verify required parameter 'unifiedExpressProductMenuRequest' is not null or undefined
            assertParamExists('expressMenusUpdate', 'unifiedExpressProductMenuRequest', unifiedExpressProductMenuRequest)
            const localVarPath = `/express_menus/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(unifiedExpressProductMenuRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ExpressMenusApi - functional programming interface
 * @export
 */
export const ExpressMenusApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ExpressMenusApiAxiosParamCreator(configuration)
    return {
        /**
         * LeafLink API for Marketplace Express Product Menus.
         * @param {UnifiedExpressProductMenuRequest} unifiedExpressProductMenuRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async expressMenusCreate(unifiedExpressProductMenuRequest: UnifiedExpressProductMenuRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnifiedExpressProductMenu>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.expressMenusCreate(unifiedExpressProductMenuRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExpressMenusApi.expressMenusCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * LeafLink API for Marketplace Express Product Menus.
         * @param {number} id A unique integer value identifying this express product menu.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async expressMenusDestroy(id: number, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.expressMenusDestroy(id, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExpressMenusApi.expressMenusDestroy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * LeafLink API for Marketplace Express Product Menus.
         * @param {number} id A unique integer value identifying this express product menu.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {PatchedUnifiedExpressProductMenuRequest} [patchedUnifiedExpressProductMenuRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async expressMenusPartialUpdate(id: number, leafLinkVersion?: string, patchedUnifiedExpressProductMenuRequest?: PatchedUnifiedExpressProductMenuRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnifiedExpressProductMenu>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.expressMenusPartialUpdate(id, leafLinkVersion, patchedUnifiedExpressProductMenuRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExpressMenusApi.expressMenusPartialUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * LeafLink API for Marketplace Express Product Menus.
         * @param {number} id A unique integer value identifying this express product menu.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async expressMenusRetrieve(id: number, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnifiedExpressProductMenu>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.expressMenusRetrieve(id, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExpressMenusApi.expressMenusRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * LeafLink API for Marketplace Express Product Menus.
         * @param {number} id A unique integer value identifying this express product menu.
         * @param {UnifiedExpressProductMenuRequest} unifiedExpressProductMenuRequest 
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async expressMenusUpdate(id: number, unifiedExpressProductMenuRequest: UnifiedExpressProductMenuRequest, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnifiedExpressProductMenu>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.expressMenusUpdate(id, unifiedExpressProductMenuRequest, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExpressMenusApi.expressMenusUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ExpressMenusApi - factory interface
 * @export
 */
export const ExpressMenusApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ExpressMenusApiFp(configuration)
    return {
        /**
         * LeafLink API for Marketplace Express Product Menus.
         * @param {ExpressMenusApiExpressMenusCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        expressMenusCreate(requestParameters: ExpressMenusApiExpressMenusCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<UnifiedExpressProductMenu> {
            return localVarFp.expressMenusCreate(requestParameters.unifiedExpressProductMenuRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * LeafLink API for Marketplace Express Product Menus.
         * @param {ExpressMenusApiExpressMenusDestroyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        expressMenusDestroy(requestParameters: ExpressMenusApiExpressMenusDestroyRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.expressMenusDestroy(requestParameters.id, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * LeafLink API for Marketplace Express Product Menus.
         * @param {ExpressMenusApiExpressMenusPartialUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        expressMenusPartialUpdate(requestParameters: ExpressMenusApiExpressMenusPartialUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<UnifiedExpressProductMenu> {
            return localVarFp.expressMenusPartialUpdate(requestParameters.id, requestParameters.leafLinkVersion, requestParameters.patchedUnifiedExpressProductMenuRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * LeafLink API for Marketplace Express Product Menus.
         * @param {ExpressMenusApiExpressMenusRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        expressMenusRetrieve(requestParameters: ExpressMenusApiExpressMenusRetrieveRequest, options?: RawAxiosRequestConfig): AxiosPromise<UnifiedExpressProductMenu> {
            return localVarFp.expressMenusRetrieve(requestParameters.id, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * LeafLink API for Marketplace Express Product Menus.
         * @param {ExpressMenusApiExpressMenusUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        expressMenusUpdate(requestParameters: ExpressMenusApiExpressMenusUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<UnifiedExpressProductMenu> {
            return localVarFp.expressMenusUpdate(requestParameters.id, requestParameters.unifiedExpressProductMenuRequest, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for expressMenusCreate operation in ExpressMenusApi.
 * @export
 * @interface ExpressMenusApiExpressMenusCreateRequest
 */
export interface ExpressMenusApiExpressMenusCreateRequest {
    /**
     * 
     * @type {UnifiedExpressProductMenuRequest}
     * @memberof ExpressMenusApiExpressMenusCreate
     */
    readonly unifiedExpressProductMenuRequest: UnifiedExpressProductMenuRequest
}

/**
 * Request parameters for expressMenusDestroy operation in ExpressMenusApi.
 * @export
 * @interface ExpressMenusApiExpressMenusDestroyRequest
 */
export interface ExpressMenusApiExpressMenusDestroyRequest {
    /**
     * A unique integer value identifying this express product menu.
     * @type {number}
     * @memberof ExpressMenusApiExpressMenusDestroy
     */
    readonly id: number

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof ExpressMenusApiExpressMenusDestroy
     */
    readonly leafLinkVersion?: string
}

/**
 * Request parameters for expressMenusPartialUpdate operation in ExpressMenusApi.
 * @export
 * @interface ExpressMenusApiExpressMenusPartialUpdateRequest
 */
export interface ExpressMenusApiExpressMenusPartialUpdateRequest {
    /**
     * A unique integer value identifying this express product menu.
     * @type {number}
     * @memberof ExpressMenusApiExpressMenusPartialUpdate
     */
    readonly id: number

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof ExpressMenusApiExpressMenusPartialUpdate
     */
    readonly leafLinkVersion?: string

    /**
     * 
     * @type {PatchedUnifiedExpressProductMenuRequest}
     * @memberof ExpressMenusApiExpressMenusPartialUpdate
     */
    readonly patchedUnifiedExpressProductMenuRequest?: PatchedUnifiedExpressProductMenuRequest
}

/**
 * Request parameters for expressMenusRetrieve operation in ExpressMenusApi.
 * @export
 * @interface ExpressMenusApiExpressMenusRetrieveRequest
 */
export interface ExpressMenusApiExpressMenusRetrieveRequest {
    /**
     * A unique integer value identifying this express product menu.
     * @type {number}
     * @memberof ExpressMenusApiExpressMenusRetrieve
     */
    readonly id: number

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof ExpressMenusApiExpressMenusRetrieve
     */
    readonly leafLinkVersion?: string
}

/**
 * Request parameters for expressMenusUpdate operation in ExpressMenusApi.
 * @export
 * @interface ExpressMenusApiExpressMenusUpdateRequest
 */
export interface ExpressMenusApiExpressMenusUpdateRequest {
    /**
     * A unique integer value identifying this express product menu.
     * @type {number}
     * @memberof ExpressMenusApiExpressMenusUpdate
     */
    readonly id: number

    /**
     * 
     * @type {UnifiedExpressProductMenuRequest}
     * @memberof ExpressMenusApiExpressMenusUpdate
     */
    readonly unifiedExpressProductMenuRequest: UnifiedExpressProductMenuRequest

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof ExpressMenusApiExpressMenusUpdate
     */
    readonly leafLinkVersion?: string
}

/**
 * ExpressMenusApi - object-oriented interface
 * @export
 * @class ExpressMenusApi
 * @extends {BaseAPI}
 */
export class ExpressMenusApi extends BaseAPI {
    /**
     * LeafLink API for Marketplace Express Product Menus.
     * @param {ExpressMenusApiExpressMenusCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExpressMenusApi
     */
    public expressMenusCreate(requestParameters: ExpressMenusApiExpressMenusCreateRequest, options?: RawAxiosRequestConfig) {
        return ExpressMenusApiFp(this.configuration).expressMenusCreate(requestParameters.unifiedExpressProductMenuRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * LeafLink API for Marketplace Express Product Menus.
     * @param {ExpressMenusApiExpressMenusDestroyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExpressMenusApi
     */
    public expressMenusDestroy(requestParameters: ExpressMenusApiExpressMenusDestroyRequest, options?: RawAxiosRequestConfig) {
        return ExpressMenusApiFp(this.configuration).expressMenusDestroy(requestParameters.id, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * LeafLink API for Marketplace Express Product Menus.
     * @param {ExpressMenusApiExpressMenusPartialUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExpressMenusApi
     */
    public expressMenusPartialUpdate(requestParameters: ExpressMenusApiExpressMenusPartialUpdateRequest, options?: RawAxiosRequestConfig) {
        return ExpressMenusApiFp(this.configuration).expressMenusPartialUpdate(requestParameters.id, requestParameters.leafLinkVersion, requestParameters.patchedUnifiedExpressProductMenuRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * LeafLink API for Marketplace Express Product Menus.
     * @param {ExpressMenusApiExpressMenusRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExpressMenusApi
     */
    public expressMenusRetrieve(requestParameters: ExpressMenusApiExpressMenusRetrieveRequest, options?: RawAxiosRequestConfig) {
        return ExpressMenusApiFp(this.configuration).expressMenusRetrieve(requestParameters.id, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * LeafLink API for Marketplace Express Product Menus.
     * @param {ExpressMenusApiExpressMenusUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExpressMenusApi
     */
    public expressMenusUpdate(requestParameters: ExpressMenusApiExpressMenusUpdateRequest, options?: RawAxiosRequestConfig) {
        return ExpressMenusApiFp(this.configuration).expressMenusUpdate(requestParameters.id, requestParameters.unifiedExpressProductMenuRequest, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * InvoiceRecordedPaymentApi - axios parameter creator
 * @export
 */
export const InvoiceRecordedPaymentApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create an invoice\'s recorded payment.
         * @summary Create an Invoice Recorded Payment
         * @param {RecordInvoicePaymentRequest} recordInvoicePaymentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invoiceRecordedPaymentsCreate: async (recordInvoicePaymentRequest: RecordInvoicePaymentRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'recordInvoicePaymentRequest' is not null or undefined
            assertParamExists('invoiceRecordedPaymentsCreate', 'recordInvoicePaymentRequest', recordInvoicePaymentRequest)
            const localVarPath = `/invoice_recorded_payments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(recordInvoicePaymentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InvoiceRecordedPaymentApi - functional programming interface
 * @export
 */
export const InvoiceRecordedPaymentApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = InvoiceRecordedPaymentApiAxiosParamCreator(configuration)
    return {
        /**
         * Create an invoice\'s recorded payment.
         * @summary Create an Invoice Recorded Payment
         * @param {RecordInvoicePaymentRequest} recordInvoicePaymentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async invoiceRecordedPaymentsCreate(recordInvoicePaymentRequest: RecordInvoicePaymentRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RecordInvoicePayment>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.invoiceRecordedPaymentsCreate(recordInvoicePaymentRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoiceRecordedPaymentApi.invoiceRecordedPaymentsCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * InvoiceRecordedPaymentApi - factory interface
 * @export
 */
export const InvoiceRecordedPaymentApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = InvoiceRecordedPaymentApiFp(configuration)
    return {
        /**
         * Create an invoice\'s recorded payment.
         * @summary Create an Invoice Recorded Payment
         * @param {InvoiceRecordedPaymentApiInvoiceRecordedPaymentsCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invoiceRecordedPaymentsCreate(requestParameters: InvoiceRecordedPaymentApiInvoiceRecordedPaymentsCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<RecordInvoicePayment> {
            return localVarFp.invoiceRecordedPaymentsCreate(requestParameters.recordInvoicePaymentRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for invoiceRecordedPaymentsCreate operation in InvoiceRecordedPaymentApi.
 * @export
 * @interface InvoiceRecordedPaymentApiInvoiceRecordedPaymentsCreateRequest
 */
export interface InvoiceRecordedPaymentApiInvoiceRecordedPaymentsCreateRequest {
    /**
     * 
     * @type {RecordInvoicePaymentRequest}
     * @memberof InvoiceRecordedPaymentApiInvoiceRecordedPaymentsCreate
     */
    readonly recordInvoicePaymentRequest: RecordInvoicePaymentRequest
}

/**
 * InvoiceRecordedPaymentApi - object-oriented interface
 * @export
 * @class InvoiceRecordedPaymentApi
 * @extends {BaseAPI}
 */
export class InvoiceRecordedPaymentApi extends BaseAPI {
    /**
     * Create an invoice\'s recorded payment.
     * @summary Create an Invoice Recorded Payment
     * @param {InvoiceRecordedPaymentApiInvoiceRecordedPaymentsCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoiceRecordedPaymentApi
     */
    public invoiceRecordedPaymentsCreate(requestParameters: InvoiceRecordedPaymentApiInvoiceRecordedPaymentsCreateRequest, options?: RawAxiosRequestConfig) {
        return InvoiceRecordedPaymentApiFp(this.configuration).invoiceRecordedPaymentsCreate(requestParameters.recordInvoicePaymentRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * LogisticsTransportApi - axios parameter creator
 * @export
 */
export const LogisticsTransportApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get a single Transport Order.
         * @summary Get Transport Order
         * @param {number} id A unique integer value identifying this l3 order.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deliveriesRetrieve: async (id: number, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deliveriesRetrieve', 'id', id)
            const localVarPath = `/deliveries/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List all transport companies.
         * @summary List Transport Companies
         * @param {number} [limit] Number of results to return per page.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {string} [search] A search term.
         * @param {string} [stateAbbr] 
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transportationCompaniesList: async (limit?: number, offset?: number, ordering?: string, search?: string, stateAbbr?: string, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/transportation/companies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (stateAbbr !== undefined) {
                localVarQueryParameter['state_abbr'] = stateAbbr;
            }


    
            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create Driver
         * @summary Create Driver
         * @param {InternalDriverRequest} internalDriverRequest 
         * @param {string} [email] 
         * @param {string} [firstName] 
         * @param {string} [lastName] 
         * @param {string} [licenseNumber] 
         * @param {string} [metrcEmployeeId] 
         * @param {string} [phone] 
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transportationDriversCreate: async (internalDriverRequest: InternalDriverRequest, email?: string, firstName?: string, lastName?: string, licenseNumber?: string, metrcEmployeeId?: string, phone?: string, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'internalDriverRequest' is not null or undefined
            assertParamExists('transportationDriversCreate', 'internalDriverRequest', internalDriverRequest)
            const localVarPath = `/transportation/drivers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication tokenAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }

            if (firstName !== undefined) {
                localVarQueryParameter['first_name'] = firstName;
            }

            if (lastName !== undefined) {
                localVarQueryParameter['last_name'] = lastName;
            }

            if (licenseNumber !== undefined) {
                localVarQueryParameter['license_number'] = licenseNumber;
            }

            if (metrcEmployeeId !== undefined) {
                localVarQueryParameter['metrc_employee_id'] = metrcEmployeeId;
            }

            if (phone !== undefined) {
                localVarQueryParameter['phone'] = phone;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(internalDriverRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get active drivers for given transport partner, by default returns only active drivers.
         * @summary List Drivers
         * @param {any} includeInactive If set to \&#39;true\&#39; endpoint will return all Drivers, both active and inactive.
         * @param {number} [limit] Number of results to return per page.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {string} [search] A search term.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transportationDriversList: async (includeInactive: any, limit?: number, offset?: number, ordering?: string, search?: string, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'includeInactive' is not null or undefined
            assertParamExists('transportationDriversList', 'includeInactive', includeInactive)
            const localVarPath = `/transportation/drivers`
                .replace(`{${"include_inactive"}}`, encodeURIComponent(String(includeInactive)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication tokenAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List multiple Transport Order.
         * @summary List Transport Order
         * @param {string} [buyer] 
         * @param {string} [deliveryDate] 
         * @param {number} [limit] Number of results to return per page.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {string} [orderInvoiceNumber] 
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {string} [pickupDate] 
         * @param {string} [requestedDate] 
         * @param {string} [search] A search term.
         * @param {Array<TransportationOrdersListSortByEnum>} [sortBy] Ordering
         * @param {Array<TransportationOrdersListStatusEnum>} [status] 
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transportationOrdersList: async (buyer?: string, deliveryDate?: string, limit?: number, offset?: number, orderInvoiceNumber?: string, ordering?: string, pickupDate?: string, requestedDate?: string, search?: string, sortBy?: Array<TransportationOrdersListSortByEnum>, status?: Array<TransportationOrdersListStatusEnum>, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/transportation/orders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication tokenAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (buyer !== undefined) {
                localVarQueryParameter['buyer'] = buyer;
            }

            if (deliveryDate !== undefined) {
                localVarQueryParameter['delivery_date'] = (deliveryDate as any instanceof Date) ?
                    (deliveryDate as any).toISOString().substring(0,10) :
                    deliveryDate;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (orderInvoiceNumber !== undefined) {
                localVarQueryParameter['order_invoice_number'] = orderInvoiceNumber;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }

            if (pickupDate !== undefined) {
                localVarQueryParameter['pickup_date'] = (pickupDate as any instanceof Date) ?
                    (pickupDate as any).toISOString().substring(0,10) :
                    pickupDate;
            }

            if (requestedDate !== undefined) {
                localVarQueryParameter['requested_date'] = (requestedDate as any instanceof Date) ?
                    (requestedDate as any).toISOString().substring(0,10) :
                    requestedDate;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (sortBy) {
                localVarQueryParameter['sort_by'] = sortBy.join(COLLECTION_FORMATS.csv);
            }

            if (status) {
                localVarQueryParameter['status'] = status;
            }


    
            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a single Transport Order.
         * @summary Get Transport Order
         * @param {number} id A unique integer value identifying this l3 order.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transportationOrdersRetrieve: async (id: number, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('transportationOrdersRetrieve', 'id', id)
            const localVarPath = `/transportation/orders/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication tokenAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Company transport partner view set.
         * @summary Create Company Transport Partner
         * @param {CompanyTransportPartnerRequest} companyTransportPartnerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transportationPartnersCreate: async (companyTransportPartnerRequest: CompanyTransportPartnerRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyTransportPartnerRequest' is not null or undefined
            assertParamExists('transportationPartnersCreate', 'companyTransportPartnerRequest', companyTransportPartnerRequest)
            const localVarPath = `/transportation/partners`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(companyTransportPartnerRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List all transport partners for all companies to which the requesting user has access.
         * @summary List Company Transport Partner
         * @param {string} [companySlug] 
         * @param {number} [limit] Number of results to return per page.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {string} [search] A search term.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transportationPartnersList: async (companySlug?: string, limit?: number, offset?: number, ordering?: string, search?: string, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/transportation/partners`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (companySlug !== undefined) {
                localVarQueryParameter['company_slug'] = companySlug;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Company transport partner view set.
         * @summary Update Company Transport Partner
         * @param {number} id A unique integer value identifying this company transport partner.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {PatchedCompanyTransportPartnerRequest} [patchedCompanyTransportPartnerRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transportationPartnersPartialUpdate: async (id: number, leafLinkVersion?: string, patchedCompanyTransportPartnerRequest?: PatchedCompanyTransportPartnerRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('transportationPartnersPartialUpdate', 'id', id)
            const localVarPath = `/transportation/partners/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchedCompanyTransportPartnerRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create Vehicle
         * @summary Create Vehicle
         * @param {VehicleRequest} vehicleRequest 
         * @param {boolean} [hasAirConditioner] 
         * @param {string} [licenseNumber] 
         * @param {string} [make] 
         * @param {string} [modelName] 
         * @param {number} [modelYear] 
         * @param {number} [stateId] 
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transportationVehiclesCreate: async (vehicleRequest: VehicleRequest, hasAirConditioner?: boolean, licenseNumber?: string, make?: string, modelName?: string, modelYear?: number, stateId?: number, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vehicleRequest' is not null or undefined
            assertParamExists('transportationVehiclesCreate', 'vehicleRequest', vehicleRequest)
            const localVarPath = `/transportation/vehicles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication tokenAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (hasAirConditioner !== undefined) {
                localVarQueryParameter['has_air_conditioner'] = hasAirConditioner;
            }

            if (licenseNumber !== undefined) {
                localVarQueryParameter['license_number'] = licenseNumber;
            }

            if (make !== undefined) {
                localVarQueryParameter['make'] = make;
            }

            if (modelName !== undefined) {
                localVarQueryParameter['model_name'] = modelName;
            }

            if (modelYear !== undefined) {
                localVarQueryParameter['model_year'] = modelYear;
            }

            if (stateId !== undefined) {
                localVarQueryParameter['state_id'] = stateId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(vehicleRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get vehicles for given transport partner.
         * @summary List Vehicles
         * @param {number} [limit] Number of results to return per page.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {string} [search] A search term.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transportationVehiclesList: async (limit?: number, offset?: number, ordering?: string, search?: string, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/transportation/vehicles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication tokenAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LogisticsTransportApi - functional programming interface
 * @export
 */
export const LogisticsTransportApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LogisticsTransportApiAxiosParamCreator(configuration)
    return {
        /**
         * Get a single Transport Order.
         * @summary Get Transport Order
         * @param {number} id A unique integer value identifying this l3 order.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deliveriesRetrieve(id: number, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnifiedL3Order>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deliveriesRetrieve(id, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LogisticsTransportApi.deliveriesRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List all transport companies.
         * @summary List Transport Companies
         * @param {number} [limit] Number of results to return per page.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {string} [search] A search term.
         * @param {string} [stateAbbr] 
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async transportationCompaniesList(limit?: number, offset?: number, ordering?: string, search?: string, stateAbbr?: string, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedTransportCompanyList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.transportationCompaniesList(limit, offset, ordering, search, stateAbbr, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LogisticsTransportApi.transportationCompaniesList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create Driver
         * @summary Create Driver
         * @param {InternalDriverRequest} internalDriverRequest 
         * @param {string} [email] 
         * @param {string} [firstName] 
         * @param {string} [lastName] 
         * @param {string} [licenseNumber] 
         * @param {string} [metrcEmployeeId] 
         * @param {string} [phone] 
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async transportationDriversCreate(internalDriverRequest: InternalDriverRequest, email?: string, firstName?: string, lastName?: string, licenseNumber?: string, metrcEmployeeId?: string, phone?: string, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InternalDriver>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.transportationDriversCreate(internalDriverRequest, email, firstName, lastName, licenseNumber, metrcEmployeeId, phone, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LogisticsTransportApi.transportationDriversCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get active drivers for given transport partner, by default returns only active drivers.
         * @summary List Drivers
         * @param {any} includeInactive If set to \&#39;true\&#39; endpoint will return all Drivers, both active and inactive.
         * @param {number} [limit] Number of results to return per page.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {string} [search] A search term.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async transportationDriversList(includeInactive: any, limit?: number, offset?: number, ordering?: string, search?: string, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedInternalDriverList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.transportationDriversList(includeInactive, limit, offset, ordering, search, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LogisticsTransportApi.transportationDriversList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List multiple Transport Order.
         * @summary List Transport Order
         * @param {string} [buyer] 
         * @param {string} [deliveryDate] 
         * @param {number} [limit] Number of results to return per page.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {string} [orderInvoiceNumber] 
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {string} [pickupDate] 
         * @param {string} [requestedDate] 
         * @param {string} [search] A search term.
         * @param {Array<TransportationOrdersListSortByEnum>} [sortBy] Ordering
         * @param {Array<TransportationOrdersListStatusEnum>} [status] 
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async transportationOrdersList(buyer?: string, deliveryDate?: string, limit?: number, offset?: number, orderInvoiceNumber?: string, ordering?: string, pickupDate?: string, requestedDate?: string, search?: string, sortBy?: Array<TransportationOrdersListSortByEnum>, status?: Array<TransportationOrdersListStatusEnum>, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedUnifiedL3OrderList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.transportationOrdersList(buyer, deliveryDate, limit, offset, orderInvoiceNumber, ordering, pickupDate, requestedDate, search, sortBy, status, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LogisticsTransportApi.transportationOrdersList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a single Transport Order.
         * @summary Get Transport Order
         * @param {number} id A unique integer value identifying this l3 order.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async transportationOrdersRetrieve(id: number, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnifiedL3Order>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.transportationOrdersRetrieve(id, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LogisticsTransportApi.transportationOrdersRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Company transport partner view set.
         * @summary Create Company Transport Partner
         * @param {CompanyTransportPartnerRequest} companyTransportPartnerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async transportationPartnersCreate(companyTransportPartnerRequest: CompanyTransportPartnerRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompanyTransportPartner>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.transportationPartnersCreate(companyTransportPartnerRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LogisticsTransportApi.transportationPartnersCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List all transport partners for all companies to which the requesting user has access.
         * @summary List Company Transport Partner
         * @param {string} [companySlug] 
         * @param {number} [limit] Number of results to return per page.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {string} [search] A search term.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async transportationPartnersList(companySlug?: string, limit?: number, offset?: number, ordering?: string, search?: string, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedCompanyTransportPartnerList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.transportationPartnersList(companySlug, limit, offset, ordering, search, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LogisticsTransportApi.transportationPartnersList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Company transport partner view set.
         * @summary Update Company Transport Partner
         * @param {number} id A unique integer value identifying this company transport partner.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {PatchedCompanyTransportPartnerRequest} [patchedCompanyTransportPartnerRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async transportationPartnersPartialUpdate(id: number, leafLinkVersion?: string, patchedCompanyTransportPartnerRequest?: PatchedCompanyTransportPartnerRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompanyTransportPartner>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.transportationPartnersPartialUpdate(id, leafLinkVersion, patchedCompanyTransportPartnerRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LogisticsTransportApi.transportationPartnersPartialUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create Vehicle
         * @summary Create Vehicle
         * @param {VehicleRequest} vehicleRequest 
         * @param {boolean} [hasAirConditioner] 
         * @param {string} [licenseNumber] 
         * @param {string} [make] 
         * @param {string} [modelName] 
         * @param {number} [modelYear] 
         * @param {number} [stateId] 
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async transportationVehiclesCreate(vehicleRequest: VehicleRequest, hasAirConditioner?: boolean, licenseNumber?: string, make?: string, modelName?: string, modelYear?: number, stateId?: number, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Vehicle>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.transportationVehiclesCreate(vehicleRequest, hasAirConditioner, licenseNumber, make, modelName, modelYear, stateId, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LogisticsTransportApi.transportationVehiclesCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get vehicles for given transport partner.
         * @summary List Vehicles
         * @param {number} [limit] Number of results to return per page.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {string} [search] A search term.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async transportationVehiclesList(limit?: number, offset?: number, ordering?: string, search?: string, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedVehicleList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.transportationVehiclesList(limit, offset, ordering, search, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LogisticsTransportApi.transportationVehiclesList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * LogisticsTransportApi - factory interface
 * @export
 */
export const LogisticsTransportApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LogisticsTransportApiFp(configuration)
    return {
        /**
         * Get a single Transport Order.
         * @summary Get Transport Order
         * @param {LogisticsTransportApiDeliveriesRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deliveriesRetrieve(requestParameters: LogisticsTransportApiDeliveriesRetrieveRequest, options?: RawAxiosRequestConfig): AxiosPromise<UnifiedL3Order> {
            return localVarFp.deliveriesRetrieve(requestParameters.id, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * List all transport companies.
         * @summary List Transport Companies
         * @param {LogisticsTransportApiTransportationCompaniesListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transportationCompaniesList(requestParameters: LogisticsTransportApiTransportationCompaniesListRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedTransportCompanyList> {
            return localVarFp.transportationCompaniesList(requestParameters.limit, requestParameters.offset, requestParameters.ordering, requestParameters.search, requestParameters.stateAbbr, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * Create Driver
         * @summary Create Driver
         * @param {LogisticsTransportApiTransportationDriversCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transportationDriversCreate(requestParameters: LogisticsTransportApiTransportationDriversCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<InternalDriver> {
            return localVarFp.transportationDriversCreate(requestParameters.internalDriverRequest, requestParameters.email, requestParameters.firstName, requestParameters.lastName, requestParameters.licenseNumber, requestParameters.metrcEmployeeId, requestParameters.phone, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * Get active drivers for given transport partner, by default returns only active drivers.
         * @summary List Drivers
         * @param {LogisticsTransportApiTransportationDriversListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transportationDriversList(requestParameters: LogisticsTransportApiTransportationDriversListRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedInternalDriverList> {
            return localVarFp.transportationDriversList(requestParameters.includeInactive, requestParameters.limit, requestParameters.offset, requestParameters.ordering, requestParameters.search, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * List multiple Transport Order.
         * @summary List Transport Order
         * @param {LogisticsTransportApiTransportationOrdersListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transportationOrdersList(requestParameters: LogisticsTransportApiTransportationOrdersListRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedUnifiedL3OrderList> {
            return localVarFp.transportationOrdersList(requestParameters.buyer, requestParameters.deliveryDate, requestParameters.limit, requestParameters.offset, requestParameters.orderInvoiceNumber, requestParameters.ordering, requestParameters.pickupDate, requestParameters.requestedDate, requestParameters.search, requestParameters.sortBy, requestParameters.status, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a single Transport Order.
         * @summary Get Transport Order
         * @param {LogisticsTransportApiTransportationOrdersRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transportationOrdersRetrieve(requestParameters: LogisticsTransportApiTransportationOrdersRetrieveRequest, options?: RawAxiosRequestConfig): AxiosPromise<UnifiedL3Order> {
            return localVarFp.transportationOrdersRetrieve(requestParameters.id, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * Company transport partner view set.
         * @summary Create Company Transport Partner
         * @param {LogisticsTransportApiTransportationPartnersCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transportationPartnersCreate(requestParameters: LogisticsTransportApiTransportationPartnersCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<CompanyTransportPartner> {
            return localVarFp.transportationPartnersCreate(requestParameters.companyTransportPartnerRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * List all transport partners for all companies to which the requesting user has access.
         * @summary List Company Transport Partner
         * @param {LogisticsTransportApiTransportationPartnersListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transportationPartnersList(requestParameters: LogisticsTransportApiTransportationPartnersListRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedCompanyTransportPartnerList> {
            return localVarFp.transportationPartnersList(requestParameters.companySlug, requestParameters.limit, requestParameters.offset, requestParameters.ordering, requestParameters.search, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * Company transport partner view set.
         * @summary Update Company Transport Partner
         * @param {LogisticsTransportApiTransportationPartnersPartialUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transportationPartnersPartialUpdate(requestParameters: LogisticsTransportApiTransportationPartnersPartialUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<CompanyTransportPartner> {
            return localVarFp.transportationPartnersPartialUpdate(requestParameters.id, requestParameters.leafLinkVersion, requestParameters.patchedCompanyTransportPartnerRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Create Vehicle
         * @summary Create Vehicle
         * @param {LogisticsTransportApiTransportationVehiclesCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transportationVehiclesCreate(requestParameters: LogisticsTransportApiTransportationVehiclesCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<Vehicle> {
            return localVarFp.transportationVehiclesCreate(requestParameters.vehicleRequest, requestParameters.hasAirConditioner, requestParameters.licenseNumber, requestParameters.make, requestParameters.modelName, requestParameters.modelYear, requestParameters.stateId, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * Get vehicles for given transport partner.
         * @summary List Vehicles
         * @param {LogisticsTransportApiTransportationVehiclesListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transportationVehiclesList(requestParameters: LogisticsTransportApiTransportationVehiclesListRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedVehicleList> {
            return localVarFp.transportationVehiclesList(requestParameters.limit, requestParameters.offset, requestParameters.ordering, requestParameters.search, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for deliveriesRetrieve operation in LogisticsTransportApi.
 * @export
 * @interface LogisticsTransportApiDeliveriesRetrieveRequest
 */
export interface LogisticsTransportApiDeliveriesRetrieveRequest {
    /**
     * A unique integer value identifying this l3 order.
     * @type {number}
     * @memberof LogisticsTransportApiDeliveriesRetrieve
     */
    readonly id: number

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof LogisticsTransportApiDeliveriesRetrieve
     */
    readonly leafLinkVersion?: string
}

/**
 * Request parameters for transportationCompaniesList operation in LogisticsTransportApi.
 * @export
 * @interface LogisticsTransportApiTransportationCompaniesListRequest
 */
export interface LogisticsTransportApiTransportationCompaniesListRequest {
    /**
     * Number of results to return per page.
     * @type {number}
     * @memberof LogisticsTransportApiTransportationCompaniesList
     */
    readonly limit?: number

    /**
     * The initial index from which to return the results.
     * @type {number}
     * @memberof LogisticsTransportApiTransportationCompaniesList
     */
    readonly offset?: number

    /**
     * Which field to use when ordering the results.
     * @type {string}
     * @memberof LogisticsTransportApiTransportationCompaniesList
     */
    readonly ordering?: string

    /**
     * A search term.
     * @type {string}
     * @memberof LogisticsTransportApiTransportationCompaniesList
     */
    readonly search?: string

    /**
     * 
     * @type {string}
     * @memberof LogisticsTransportApiTransportationCompaniesList
     */
    readonly stateAbbr?: string

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof LogisticsTransportApiTransportationCompaniesList
     */
    readonly leafLinkVersion?: string
}

/**
 * Request parameters for transportationDriversCreate operation in LogisticsTransportApi.
 * @export
 * @interface LogisticsTransportApiTransportationDriversCreateRequest
 */
export interface LogisticsTransportApiTransportationDriversCreateRequest {
    /**
     * 
     * @type {InternalDriverRequest}
     * @memberof LogisticsTransportApiTransportationDriversCreate
     */
    readonly internalDriverRequest: InternalDriverRequest

    /**
     * 
     * @type {string}
     * @memberof LogisticsTransportApiTransportationDriversCreate
     */
    readonly email?: string

    /**
     * 
     * @type {string}
     * @memberof LogisticsTransportApiTransportationDriversCreate
     */
    readonly firstName?: string

    /**
     * 
     * @type {string}
     * @memberof LogisticsTransportApiTransportationDriversCreate
     */
    readonly lastName?: string

    /**
     * 
     * @type {string}
     * @memberof LogisticsTransportApiTransportationDriversCreate
     */
    readonly licenseNumber?: string

    /**
     * 
     * @type {string}
     * @memberof LogisticsTransportApiTransportationDriversCreate
     */
    readonly metrcEmployeeId?: string

    /**
     * 
     * @type {string}
     * @memberof LogisticsTransportApiTransportationDriversCreate
     */
    readonly phone?: string

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof LogisticsTransportApiTransportationDriversCreate
     */
    readonly leafLinkVersion?: string
}

/**
 * Request parameters for transportationDriversList operation in LogisticsTransportApi.
 * @export
 * @interface LogisticsTransportApiTransportationDriversListRequest
 */
export interface LogisticsTransportApiTransportationDriversListRequest {
    /**
     * If set to \&#39;true\&#39; endpoint will return all Drivers, both active and inactive.
     * @type {any}
     * @memberof LogisticsTransportApiTransportationDriversList
     */
    readonly includeInactive: any

    /**
     * Number of results to return per page.
     * @type {number}
     * @memberof LogisticsTransportApiTransportationDriversList
     */
    readonly limit?: number

    /**
     * The initial index from which to return the results.
     * @type {number}
     * @memberof LogisticsTransportApiTransportationDriversList
     */
    readonly offset?: number

    /**
     * Which field to use when ordering the results.
     * @type {string}
     * @memberof LogisticsTransportApiTransportationDriversList
     */
    readonly ordering?: string

    /**
     * A search term.
     * @type {string}
     * @memberof LogisticsTransportApiTransportationDriversList
     */
    readonly search?: string

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof LogisticsTransportApiTransportationDriversList
     */
    readonly leafLinkVersion?: string
}

/**
 * Request parameters for transportationOrdersList operation in LogisticsTransportApi.
 * @export
 * @interface LogisticsTransportApiTransportationOrdersListRequest
 */
export interface LogisticsTransportApiTransportationOrdersListRequest {
    /**
     * 
     * @type {string}
     * @memberof LogisticsTransportApiTransportationOrdersList
     */
    readonly buyer?: string

    /**
     * 
     * @type {string}
     * @memberof LogisticsTransportApiTransportationOrdersList
     */
    readonly deliveryDate?: string

    /**
     * Number of results to return per page.
     * @type {number}
     * @memberof LogisticsTransportApiTransportationOrdersList
     */
    readonly limit?: number

    /**
     * The initial index from which to return the results.
     * @type {number}
     * @memberof LogisticsTransportApiTransportationOrdersList
     */
    readonly offset?: number

    /**
     * 
     * @type {string}
     * @memberof LogisticsTransportApiTransportationOrdersList
     */
    readonly orderInvoiceNumber?: string

    /**
     * Which field to use when ordering the results.
     * @type {string}
     * @memberof LogisticsTransportApiTransportationOrdersList
     */
    readonly ordering?: string

    /**
     * 
     * @type {string}
     * @memberof LogisticsTransportApiTransportationOrdersList
     */
    readonly pickupDate?: string

    /**
     * 
     * @type {string}
     * @memberof LogisticsTransportApiTransportationOrdersList
     */
    readonly requestedDate?: string

    /**
     * A search term.
     * @type {string}
     * @memberof LogisticsTransportApiTransportationOrdersList
     */
    readonly search?: string

    /**
     * Ordering
     * @type {Array<'-created_on' | '-display_delivery_date' | '-requested_pickup_date' | 'created_on' | 'display_delivery_date' | 'requested_pickup_date'>}
     * @memberof LogisticsTransportApiTransportationOrdersList
     */
    readonly sortBy?: Array<TransportationOrdersListSortByEnum>

    /**
     * 
     * @type {Array<'assigned' | 'created' | 'delivered' | 'planned' | 'shipped' | 'uploaded'>}
     * @memberof LogisticsTransportApiTransportationOrdersList
     */
    readonly status?: Array<TransportationOrdersListStatusEnum>

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof LogisticsTransportApiTransportationOrdersList
     */
    readonly leafLinkVersion?: string
}

/**
 * Request parameters for transportationOrdersRetrieve operation in LogisticsTransportApi.
 * @export
 * @interface LogisticsTransportApiTransportationOrdersRetrieveRequest
 */
export interface LogisticsTransportApiTransportationOrdersRetrieveRequest {
    /**
     * A unique integer value identifying this l3 order.
     * @type {number}
     * @memberof LogisticsTransportApiTransportationOrdersRetrieve
     */
    readonly id: number

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof LogisticsTransportApiTransportationOrdersRetrieve
     */
    readonly leafLinkVersion?: string
}

/**
 * Request parameters for transportationPartnersCreate operation in LogisticsTransportApi.
 * @export
 * @interface LogisticsTransportApiTransportationPartnersCreateRequest
 */
export interface LogisticsTransportApiTransportationPartnersCreateRequest {
    /**
     * 
     * @type {CompanyTransportPartnerRequest}
     * @memberof LogisticsTransportApiTransportationPartnersCreate
     */
    readonly companyTransportPartnerRequest: CompanyTransportPartnerRequest
}

/**
 * Request parameters for transportationPartnersList operation in LogisticsTransportApi.
 * @export
 * @interface LogisticsTransportApiTransportationPartnersListRequest
 */
export interface LogisticsTransportApiTransportationPartnersListRequest {
    /**
     * 
     * @type {string}
     * @memberof LogisticsTransportApiTransportationPartnersList
     */
    readonly companySlug?: string

    /**
     * Number of results to return per page.
     * @type {number}
     * @memberof LogisticsTransportApiTransportationPartnersList
     */
    readonly limit?: number

    /**
     * The initial index from which to return the results.
     * @type {number}
     * @memberof LogisticsTransportApiTransportationPartnersList
     */
    readonly offset?: number

    /**
     * Which field to use when ordering the results.
     * @type {string}
     * @memberof LogisticsTransportApiTransportationPartnersList
     */
    readonly ordering?: string

    /**
     * A search term.
     * @type {string}
     * @memberof LogisticsTransportApiTransportationPartnersList
     */
    readonly search?: string

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof LogisticsTransportApiTransportationPartnersList
     */
    readonly leafLinkVersion?: string
}

/**
 * Request parameters for transportationPartnersPartialUpdate operation in LogisticsTransportApi.
 * @export
 * @interface LogisticsTransportApiTransportationPartnersPartialUpdateRequest
 */
export interface LogisticsTransportApiTransportationPartnersPartialUpdateRequest {
    /**
     * A unique integer value identifying this company transport partner.
     * @type {number}
     * @memberof LogisticsTransportApiTransportationPartnersPartialUpdate
     */
    readonly id: number

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof LogisticsTransportApiTransportationPartnersPartialUpdate
     */
    readonly leafLinkVersion?: string

    /**
     * 
     * @type {PatchedCompanyTransportPartnerRequest}
     * @memberof LogisticsTransportApiTransportationPartnersPartialUpdate
     */
    readonly patchedCompanyTransportPartnerRequest?: PatchedCompanyTransportPartnerRequest
}

/**
 * Request parameters for transportationVehiclesCreate operation in LogisticsTransportApi.
 * @export
 * @interface LogisticsTransportApiTransportationVehiclesCreateRequest
 */
export interface LogisticsTransportApiTransportationVehiclesCreateRequest {
    /**
     * 
     * @type {VehicleRequest}
     * @memberof LogisticsTransportApiTransportationVehiclesCreate
     */
    readonly vehicleRequest: VehicleRequest

    /**
     * 
     * @type {boolean}
     * @memberof LogisticsTransportApiTransportationVehiclesCreate
     */
    readonly hasAirConditioner?: boolean

    /**
     * 
     * @type {string}
     * @memberof LogisticsTransportApiTransportationVehiclesCreate
     */
    readonly licenseNumber?: string

    /**
     * 
     * @type {string}
     * @memberof LogisticsTransportApiTransportationVehiclesCreate
     */
    readonly make?: string

    /**
     * 
     * @type {string}
     * @memberof LogisticsTransportApiTransportationVehiclesCreate
     */
    readonly modelName?: string

    /**
     * 
     * @type {number}
     * @memberof LogisticsTransportApiTransportationVehiclesCreate
     */
    readonly modelYear?: number

    /**
     * 
     * @type {number}
     * @memberof LogisticsTransportApiTransportationVehiclesCreate
     */
    readonly stateId?: number

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof LogisticsTransportApiTransportationVehiclesCreate
     */
    readonly leafLinkVersion?: string
}

/**
 * Request parameters for transportationVehiclesList operation in LogisticsTransportApi.
 * @export
 * @interface LogisticsTransportApiTransportationVehiclesListRequest
 */
export interface LogisticsTransportApiTransportationVehiclesListRequest {
    /**
     * Number of results to return per page.
     * @type {number}
     * @memberof LogisticsTransportApiTransportationVehiclesList
     */
    readonly limit?: number

    /**
     * The initial index from which to return the results.
     * @type {number}
     * @memberof LogisticsTransportApiTransportationVehiclesList
     */
    readonly offset?: number

    /**
     * Which field to use when ordering the results.
     * @type {string}
     * @memberof LogisticsTransportApiTransportationVehiclesList
     */
    readonly ordering?: string

    /**
     * A search term.
     * @type {string}
     * @memberof LogisticsTransportApiTransportationVehiclesList
     */
    readonly search?: string

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof LogisticsTransportApiTransportationVehiclesList
     */
    readonly leafLinkVersion?: string
}

/**
 * LogisticsTransportApi - object-oriented interface
 * @export
 * @class LogisticsTransportApi
 * @extends {BaseAPI}
 */
export class LogisticsTransportApi extends BaseAPI {
    /**
     * Get a single Transport Order.
     * @summary Get Transport Order
     * @param {LogisticsTransportApiDeliveriesRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LogisticsTransportApi
     */
    public deliveriesRetrieve(requestParameters: LogisticsTransportApiDeliveriesRetrieveRequest, options?: RawAxiosRequestConfig) {
        return LogisticsTransportApiFp(this.configuration).deliveriesRetrieve(requestParameters.id, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List all transport companies.
     * @summary List Transport Companies
     * @param {LogisticsTransportApiTransportationCompaniesListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LogisticsTransportApi
     */
    public transportationCompaniesList(requestParameters: LogisticsTransportApiTransportationCompaniesListRequest = {}, options?: RawAxiosRequestConfig) {
        return LogisticsTransportApiFp(this.configuration).transportationCompaniesList(requestParameters.limit, requestParameters.offset, requestParameters.ordering, requestParameters.search, requestParameters.stateAbbr, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create Driver
     * @summary Create Driver
     * @param {LogisticsTransportApiTransportationDriversCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LogisticsTransportApi
     */
    public transportationDriversCreate(requestParameters: LogisticsTransportApiTransportationDriversCreateRequest, options?: RawAxiosRequestConfig) {
        return LogisticsTransportApiFp(this.configuration).transportationDriversCreate(requestParameters.internalDriverRequest, requestParameters.email, requestParameters.firstName, requestParameters.lastName, requestParameters.licenseNumber, requestParameters.metrcEmployeeId, requestParameters.phone, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get active drivers for given transport partner, by default returns only active drivers.
     * @summary List Drivers
     * @param {LogisticsTransportApiTransportationDriversListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LogisticsTransportApi
     */
    public transportationDriversList(requestParameters: LogisticsTransportApiTransportationDriversListRequest, options?: RawAxiosRequestConfig) {
        return LogisticsTransportApiFp(this.configuration).transportationDriversList(requestParameters.includeInactive, requestParameters.limit, requestParameters.offset, requestParameters.ordering, requestParameters.search, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List multiple Transport Order.
     * @summary List Transport Order
     * @param {LogisticsTransportApiTransportationOrdersListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LogisticsTransportApi
     */
    public transportationOrdersList(requestParameters: LogisticsTransportApiTransportationOrdersListRequest = {}, options?: RawAxiosRequestConfig) {
        return LogisticsTransportApiFp(this.configuration).transportationOrdersList(requestParameters.buyer, requestParameters.deliveryDate, requestParameters.limit, requestParameters.offset, requestParameters.orderInvoiceNumber, requestParameters.ordering, requestParameters.pickupDate, requestParameters.requestedDate, requestParameters.search, requestParameters.sortBy, requestParameters.status, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a single Transport Order.
     * @summary Get Transport Order
     * @param {LogisticsTransportApiTransportationOrdersRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LogisticsTransportApi
     */
    public transportationOrdersRetrieve(requestParameters: LogisticsTransportApiTransportationOrdersRetrieveRequest, options?: RawAxiosRequestConfig) {
        return LogisticsTransportApiFp(this.configuration).transportationOrdersRetrieve(requestParameters.id, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Company transport partner view set.
     * @summary Create Company Transport Partner
     * @param {LogisticsTransportApiTransportationPartnersCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LogisticsTransportApi
     */
    public transportationPartnersCreate(requestParameters: LogisticsTransportApiTransportationPartnersCreateRequest, options?: RawAxiosRequestConfig) {
        return LogisticsTransportApiFp(this.configuration).transportationPartnersCreate(requestParameters.companyTransportPartnerRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List all transport partners for all companies to which the requesting user has access.
     * @summary List Company Transport Partner
     * @param {LogisticsTransportApiTransportationPartnersListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LogisticsTransportApi
     */
    public transportationPartnersList(requestParameters: LogisticsTransportApiTransportationPartnersListRequest = {}, options?: RawAxiosRequestConfig) {
        return LogisticsTransportApiFp(this.configuration).transportationPartnersList(requestParameters.companySlug, requestParameters.limit, requestParameters.offset, requestParameters.ordering, requestParameters.search, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Company transport partner view set.
     * @summary Update Company Transport Partner
     * @param {LogisticsTransportApiTransportationPartnersPartialUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LogisticsTransportApi
     */
    public transportationPartnersPartialUpdate(requestParameters: LogisticsTransportApiTransportationPartnersPartialUpdateRequest, options?: RawAxiosRequestConfig) {
        return LogisticsTransportApiFp(this.configuration).transportationPartnersPartialUpdate(requestParameters.id, requestParameters.leafLinkVersion, requestParameters.patchedCompanyTransportPartnerRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create Vehicle
     * @summary Create Vehicle
     * @param {LogisticsTransportApiTransportationVehiclesCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LogisticsTransportApi
     */
    public transportationVehiclesCreate(requestParameters: LogisticsTransportApiTransportationVehiclesCreateRequest, options?: RawAxiosRequestConfig) {
        return LogisticsTransportApiFp(this.configuration).transportationVehiclesCreate(requestParameters.vehicleRequest, requestParameters.hasAirConditioner, requestParameters.licenseNumber, requestParameters.make, requestParameters.modelName, requestParameters.modelYear, requestParameters.stateId, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get vehicles for given transport partner.
     * @summary List Vehicles
     * @param {LogisticsTransportApiTransportationVehiclesListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LogisticsTransportApi
     */
    public transportationVehiclesList(requestParameters: LogisticsTransportApiTransportationVehiclesListRequest = {}, options?: RawAxiosRequestConfig) {
        return LogisticsTransportApiFp(this.configuration).transportationVehiclesList(requestParameters.limit, requestParameters.offset, requestParameters.ordering, requestParameters.search, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const TransportationOrdersListSortByEnum = {
    CreatedOn: '-created_on',
    DisplayDeliveryDate: '-display_delivery_date',
    RequestedPickupDate: '-requested_pickup_date',
    CreatedOn2: 'created_on',
    DisplayDeliveryDate2: 'display_delivery_date',
    RequestedPickupDate2: 'requested_pickup_date'
} as const;
export type TransportationOrdersListSortByEnum = typeof TransportationOrdersListSortByEnum[keyof typeof TransportationOrdersListSortByEnum];
/**
 * @export
 */
export const TransportationOrdersListStatusEnum = {
    Assigned: 'assigned',
    Created: 'created',
    Delivered: 'delivered',
    Planned: 'planned',
    Shipped: 'shipped',
    Uploaded: 'uploaded'
} as const;
export type TransportationOrdersListStatusEnum = typeof TransportationOrdersListStatusEnum[keyof typeof TransportationOrdersListStatusEnum];


/**
 * ManagedCompaniesApi - axios parameter creator
 * @export
 */
export const ManagedCompaniesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Licenses for a company
         * @param {string} id 
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        managedCompaniesLicensesList: async (id: string, ordering?: string, page?: number, pageSize?: number, search?: string, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('managedCompaniesLicensesList', 'id', id)
            const localVarPath = `/managed_companies/{id}/licenses`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Managed Companies collection view. Companies you are the admin of
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        managedCompaniesList: async (ordering?: string, page?: number, pageSize?: number, search?: string, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/managed_companies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Managed Companies collection view. Companies you are the admin of
         * @param {string} id 
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        managedCompaniesRetrieve: async (id: string, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('managedCompaniesRetrieve', 'id', id)
            const localVarPath = `/managed_companies/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Managed Companies collection view. Companies you are the admin of
         * @param {string} marketplaceSlug 
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        managedCompaniesRetrieve2: async (marketplaceSlug: string, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'marketplaceSlug' is not null or undefined
            assertParamExists('managedCompaniesRetrieve2', 'marketplaceSlug', marketplaceSlug)
            const localVarPath = `/managed_companies/{marketplace_slug}`
                .replace(`{${"marketplace_slug"}}`, encodeURIComponent(String(marketplaceSlug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ManagedCompaniesApi - functional programming interface
 * @export
 */
export const ManagedCompaniesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ManagedCompaniesApiAxiosParamCreator(configuration)
    return {
        /**
         * Licenses for a company
         * @param {string} id 
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async managedCompaniesLicensesList(id: string, ordering?: string, page?: number, pageSize?: number, search?: string, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedLicenseList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.managedCompaniesLicensesList(id, ordering, page, pageSize, search, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ManagedCompaniesApi.managedCompaniesLicensesList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Managed Companies collection view. Companies you are the admin of
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async managedCompaniesList(ordering?: string, page?: number, pageSize?: number, search?: string, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedCompanyList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.managedCompaniesList(ordering, page, pageSize, search, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ManagedCompaniesApi.managedCompaniesList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Managed Companies collection view. Companies you are the admin of
         * @param {string} id 
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async managedCompaniesRetrieve(id: string, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Company>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.managedCompaniesRetrieve(id, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ManagedCompaniesApi.managedCompaniesRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Managed Companies collection view. Companies you are the admin of
         * @param {string} marketplaceSlug 
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async managedCompaniesRetrieve2(marketplaceSlug: string, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Company>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.managedCompaniesRetrieve2(marketplaceSlug, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ManagedCompaniesApi.managedCompaniesRetrieve2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ManagedCompaniesApi - factory interface
 * @export
 */
export const ManagedCompaniesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ManagedCompaniesApiFp(configuration)
    return {
        /**
         * Licenses for a company
         * @param {ManagedCompaniesApiManagedCompaniesLicensesListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        managedCompaniesLicensesList(requestParameters: ManagedCompaniesApiManagedCompaniesLicensesListRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedLicenseList> {
            return localVarFp.managedCompaniesLicensesList(requestParameters.id, requestParameters.ordering, requestParameters.page, requestParameters.pageSize, requestParameters.search, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * Managed Companies collection view. Companies you are the admin of
         * @param {ManagedCompaniesApiManagedCompaniesListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        managedCompaniesList(requestParameters: ManagedCompaniesApiManagedCompaniesListRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedCompanyList> {
            return localVarFp.managedCompaniesList(requestParameters.ordering, requestParameters.page, requestParameters.pageSize, requestParameters.search, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * Managed Companies collection view. Companies you are the admin of
         * @param {ManagedCompaniesApiManagedCompaniesRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        managedCompaniesRetrieve(requestParameters: ManagedCompaniesApiManagedCompaniesRetrieveRequest, options?: RawAxiosRequestConfig): AxiosPromise<Company> {
            return localVarFp.managedCompaniesRetrieve(requestParameters.id, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * Managed Companies collection view. Companies you are the admin of
         * @param {ManagedCompaniesApiManagedCompaniesRetrieve2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        managedCompaniesRetrieve2(requestParameters: ManagedCompaniesApiManagedCompaniesRetrieve2Request, options?: RawAxiosRequestConfig): AxiosPromise<Company> {
            return localVarFp.managedCompaniesRetrieve2(requestParameters.marketplaceSlug, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for managedCompaniesLicensesList operation in ManagedCompaniesApi.
 * @export
 * @interface ManagedCompaniesApiManagedCompaniesLicensesListRequest
 */
export interface ManagedCompaniesApiManagedCompaniesLicensesListRequest {
    /**
     * 
     * @type {string}
     * @memberof ManagedCompaniesApiManagedCompaniesLicensesList
     */
    readonly id: string

    /**
     * Which field to use when ordering the results.
     * @type {string}
     * @memberof ManagedCompaniesApiManagedCompaniesLicensesList
     */
    readonly ordering?: string

    /**
     * A page number within the paginated result set.
     * @type {number}
     * @memberof ManagedCompaniesApiManagedCompaniesLicensesList
     */
    readonly page?: number

    /**
     * Number of results to return per page.
     * @type {number}
     * @memberof ManagedCompaniesApiManagedCompaniesLicensesList
     */
    readonly pageSize?: number

    /**
     * A search term.
     * @type {string}
     * @memberof ManagedCompaniesApiManagedCompaniesLicensesList
     */
    readonly search?: string

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof ManagedCompaniesApiManagedCompaniesLicensesList
     */
    readonly leafLinkVersion?: string
}

/**
 * Request parameters for managedCompaniesList operation in ManagedCompaniesApi.
 * @export
 * @interface ManagedCompaniesApiManagedCompaniesListRequest
 */
export interface ManagedCompaniesApiManagedCompaniesListRequest {
    /**
     * Which field to use when ordering the results.
     * @type {string}
     * @memberof ManagedCompaniesApiManagedCompaniesList
     */
    readonly ordering?: string

    /**
     * A page number within the paginated result set.
     * @type {number}
     * @memberof ManagedCompaniesApiManagedCompaniesList
     */
    readonly page?: number

    /**
     * Number of results to return per page.
     * @type {number}
     * @memberof ManagedCompaniesApiManagedCompaniesList
     */
    readonly pageSize?: number

    /**
     * A search term.
     * @type {string}
     * @memberof ManagedCompaniesApiManagedCompaniesList
     */
    readonly search?: string

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof ManagedCompaniesApiManagedCompaniesList
     */
    readonly leafLinkVersion?: string
}

/**
 * Request parameters for managedCompaniesRetrieve operation in ManagedCompaniesApi.
 * @export
 * @interface ManagedCompaniesApiManagedCompaniesRetrieveRequest
 */
export interface ManagedCompaniesApiManagedCompaniesRetrieveRequest {
    /**
     * 
     * @type {string}
     * @memberof ManagedCompaniesApiManagedCompaniesRetrieve
     */
    readonly id: string

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof ManagedCompaniesApiManagedCompaniesRetrieve
     */
    readonly leafLinkVersion?: string
}

/**
 * Request parameters for managedCompaniesRetrieve2 operation in ManagedCompaniesApi.
 * @export
 * @interface ManagedCompaniesApiManagedCompaniesRetrieve2Request
 */
export interface ManagedCompaniesApiManagedCompaniesRetrieve2Request {
    /**
     * 
     * @type {string}
     * @memberof ManagedCompaniesApiManagedCompaniesRetrieve2
     */
    readonly marketplaceSlug: string

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof ManagedCompaniesApiManagedCompaniesRetrieve2
     */
    readonly leafLinkVersion?: string
}

/**
 * ManagedCompaniesApi - object-oriented interface
 * @export
 * @class ManagedCompaniesApi
 * @extends {BaseAPI}
 */
export class ManagedCompaniesApi extends BaseAPI {
    /**
     * Licenses for a company
     * @param {ManagedCompaniesApiManagedCompaniesLicensesListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManagedCompaniesApi
     */
    public managedCompaniesLicensesList(requestParameters: ManagedCompaniesApiManagedCompaniesLicensesListRequest, options?: RawAxiosRequestConfig) {
        return ManagedCompaniesApiFp(this.configuration).managedCompaniesLicensesList(requestParameters.id, requestParameters.ordering, requestParameters.page, requestParameters.pageSize, requestParameters.search, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Managed Companies collection view. Companies you are the admin of
     * @param {ManagedCompaniesApiManagedCompaniesListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManagedCompaniesApi
     */
    public managedCompaniesList(requestParameters: ManagedCompaniesApiManagedCompaniesListRequest = {}, options?: RawAxiosRequestConfig) {
        return ManagedCompaniesApiFp(this.configuration).managedCompaniesList(requestParameters.ordering, requestParameters.page, requestParameters.pageSize, requestParameters.search, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Managed Companies collection view. Companies you are the admin of
     * @param {ManagedCompaniesApiManagedCompaniesRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManagedCompaniesApi
     */
    public managedCompaniesRetrieve(requestParameters: ManagedCompaniesApiManagedCompaniesRetrieveRequest, options?: RawAxiosRequestConfig) {
        return ManagedCompaniesApiFp(this.configuration).managedCompaniesRetrieve(requestParameters.id, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Managed Companies collection view. Companies you are the admin of
     * @param {ManagedCompaniesApiManagedCompaniesRetrieve2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManagedCompaniesApi
     */
    public managedCompaniesRetrieve2(requestParameters: ManagedCompaniesApiManagedCompaniesRetrieve2Request, options?: RawAxiosRequestConfig) {
        return ManagedCompaniesApiFp(this.configuration).managedCompaniesRetrieve2(requestParameters.marketplaceSlug, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * MessagesApi - axios parameter creator
 * @export
 */
export const MessagesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get or post messages for a discussion
         * @param {number} id A unique integer value identifying this chat.
         * @param {MessageRequest} messageRequest 
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatsMessagesCreate: async (id: number, messageRequest: MessageRequest, ordering?: string, page?: number, pageSize?: number, search?: string, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('chatsMessagesCreate', 'id', id)
            // verify required parameter 'messageRequest' is not null or undefined
            assertParamExists('chatsMessagesCreate', 'messageRequest', messageRequest)
            const localVarPath = `/chats/{id}/messages`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(messageRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get or post messages for a discussion
         * @param {number} id A unique integer value identifying this chat.
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatsMessagesList: async (id: number, ordering?: string, page?: number, pageSize?: number, search?: string, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('chatsMessagesList', 'id', id)
            const localVarPath = `/chats/{id}/messages`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MessagesApi - functional programming interface
 * @export
 */
export const MessagesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MessagesApiAxiosParamCreator(configuration)
    return {
        /**
         * Get or post messages for a discussion
         * @param {number} id A unique integer value identifying this chat.
         * @param {MessageRequest} messageRequest 
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async chatsMessagesCreate(id: number, messageRequest: MessageRequest, ordering?: string, page?: number, pageSize?: number, search?: string, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedMessageList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.chatsMessagesCreate(id, messageRequest, ordering, page, pageSize, search, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MessagesApi.chatsMessagesCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get or post messages for a discussion
         * @param {number} id A unique integer value identifying this chat.
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async chatsMessagesList(id: number, ordering?: string, page?: number, pageSize?: number, search?: string, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedMessageList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.chatsMessagesList(id, ordering, page, pageSize, search, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MessagesApi.chatsMessagesList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MessagesApi - factory interface
 * @export
 */
export const MessagesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MessagesApiFp(configuration)
    return {
        /**
         * Get or post messages for a discussion
         * @param {MessagesApiChatsMessagesCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatsMessagesCreate(requestParameters: MessagesApiChatsMessagesCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedMessageList> {
            return localVarFp.chatsMessagesCreate(requestParameters.id, requestParameters.messageRequest, requestParameters.ordering, requestParameters.page, requestParameters.pageSize, requestParameters.search, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * Get or post messages for a discussion
         * @param {MessagesApiChatsMessagesListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatsMessagesList(requestParameters: MessagesApiChatsMessagesListRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedMessageList> {
            return localVarFp.chatsMessagesList(requestParameters.id, requestParameters.ordering, requestParameters.page, requestParameters.pageSize, requestParameters.search, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for chatsMessagesCreate operation in MessagesApi.
 * @export
 * @interface MessagesApiChatsMessagesCreateRequest
 */
export interface MessagesApiChatsMessagesCreateRequest {
    /**
     * A unique integer value identifying this chat.
     * @type {number}
     * @memberof MessagesApiChatsMessagesCreate
     */
    readonly id: number

    /**
     * 
     * @type {MessageRequest}
     * @memberof MessagesApiChatsMessagesCreate
     */
    readonly messageRequest: MessageRequest

    /**
     * Which field to use when ordering the results.
     * @type {string}
     * @memberof MessagesApiChatsMessagesCreate
     */
    readonly ordering?: string

    /**
     * A page number within the paginated result set.
     * @type {number}
     * @memberof MessagesApiChatsMessagesCreate
     */
    readonly page?: number

    /**
     * Number of results to return per page.
     * @type {number}
     * @memberof MessagesApiChatsMessagesCreate
     */
    readonly pageSize?: number

    /**
     * A search term.
     * @type {string}
     * @memberof MessagesApiChatsMessagesCreate
     */
    readonly search?: string

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof MessagesApiChatsMessagesCreate
     */
    readonly leafLinkVersion?: string
}

/**
 * Request parameters for chatsMessagesList operation in MessagesApi.
 * @export
 * @interface MessagesApiChatsMessagesListRequest
 */
export interface MessagesApiChatsMessagesListRequest {
    /**
     * A unique integer value identifying this chat.
     * @type {number}
     * @memberof MessagesApiChatsMessagesList
     */
    readonly id: number

    /**
     * Which field to use when ordering the results.
     * @type {string}
     * @memberof MessagesApiChatsMessagesList
     */
    readonly ordering?: string

    /**
     * A page number within the paginated result set.
     * @type {number}
     * @memberof MessagesApiChatsMessagesList
     */
    readonly page?: number

    /**
     * Number of results to return per page.
     * @type {number}
     * @memberof MessagesApiChatsMessagesList
     */
    readonly pageSize?: number

    /**
     * A search term.
     * @type {string}
     * @memberof MessagesApiChatsMessagesList
     */
    readonly search?: string

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof MessagesApiChatsMessagesList
     */
    readonly leafLinkVersion?: string
}

/**
 * MessagesApi - object-oriented interface
 * @export
 * @class MessagesApi
 * @extends {BaseAPI}
 */
export class MessagesApi extends BaseAPI {
    /**
     * Get or post messages for a discussion
     * @param {MessagesApiChatsMessagesCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MessagesApi
     */
    public chatsMessagesCreate(requestParameters: MessagesApiChatsMessagesCreateRequest, options?: RawAxiosRequestConfig) {
        return MessagesApiFp(this.configuration).chatsMessagesCreate(requestParameters.id, requestParameters.messageRequest, requestParameters.ordering, requestParameters.page, requestParameters.pageSize, requestParameters.search, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get or post messages for a discussion
     * @param {MessagesApiChatsMessagesListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MessagesApi
     */
    public chatsMessagesList(requestParameters: MessagesApiChatsMessagesListRequest, options?: RawAxiosRequestConfig) {
        return MessagesApiFp(this.configuration).chatsMessagesList(requestParameters.id, requestParameters.ordering, requestParameters.page, requestParameters.pageSize, requestParameters.search, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * NotificationApi - axios parameter creator
 * @export
 */
export const NotificationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Unified Notification Preferences view set.
         * @param {number} id A unique integer value identifying this notification preference group.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationPreferencesRetrieve: async (id: number, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('notificationPreferencesRetrieve', 'id', id)
            const localVarPath = `/notification/preferences/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NotificationApi - functional programming interface
 * @export
 */
export const NotificationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = NotificationApiAxiosParamCreator(configuration)
    return {
        /**
         * Unified Notification Preferences view set.
         * @param {number} id A unique integer value identifying this notification preference group.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async notificationPreferencesRetrieve(id: number, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NotificationPreferences>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.notificationPreferencesRetrieve(id, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationApi.notificationPreferencesRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * NotificationApi - factory interface
 * @export
 */
export const NotificationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = NotificationApiFp(configuration)
    return {
        /**
         * Unified Notification Preferences view set.
         * @param {NotificationApiNotificationPreferencesRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationPreferencesRetrieve(requestParameters: NotificationApiNotificationPreferencesRetrieveRequest, options?: RawAxiosRequestConfig): AxiosPromise<NotificationPreferences> {
            return localVarFp.notificationPreferencesRetrieve(requestParameters.id, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for notificationPreferencesRetrieve operation in NotificationApi.
 * @export
 * @interface NotificationApiNotificationPreferencesRetrieveRequest
 */
export interface NotificationApiNotificationPreferencesRetrieveRequest {
    /**
     * A unique integer value identifying this notification preference group.
     * @type {number}
     * @memberof NotificationApiNotificationPreferencesRetrieve
     */
    readonly id: number

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof NotificationApiNotificationPreferencesRetrieve
     */
    readonly leafLinkVersion?: string
}

/**
 * NotificationApi - object-oriented interface
 * @export
 * @class NotificationApi
 * @extends {BaseAPI}
 */
export class NotificationApi extends BaseAPI {
    /**
     * Unified Notification Preferences view set.
     * @param {NotificationApiNotificationPreferencesRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationApi
     */
    public notificationPreferencesRetrieve(requestParameters: NotificationApiNotificationPreferencesRetrieveRequest, options?: RawAxiosRequestConfig) {
        return NotificationApiFp(this.configuration).notificationPreferencesRetrieve(requestParameters.id, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * NotificationPreferencesApi - axios parameter creator
 * @export
 */
export const NotificationPreferencesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * List Notification Preferences Groups.
         * @summary List Notification Preferences Groups
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationPreferencesList: async (ordering?: string, page?: number, pageSize?: number, search?: string, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/notification/preferences`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a user\'s notification preferences.
         * @summary Get a user\'s notification preferences.
         * @param {string} userId 
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationPreferencesUserUserIdGet: async (userId: string, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('notificationPreferencesUserUserIdGet', 'userId', userId)
            const localVarPath = `/notification/preferences/user/{user_id}`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a user\'s notification preferences.
         * @summary Update a user\'s notification preferences.
         * @param {string} userId 
         * @param {Array<NotificationPreferencesPayloadSchema>} notificationPreferencesPayloadSchema 
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationPreferencesUserUserIdPatch: async (userId: string, notificationPreferencesPayloadSchema: Array<NotificationPreferencesPayloadSchema>, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('notificationPreferencesUserUserIdPatch', 'userId', userId)
            // verify required parameter 'notificationPreferencesPayloadSchema' is not null or undefined
            assertParamExists('notificationPreferencesUserUserIdPatch', 'notificationPreferencesPayloadSchema', notificationPreferencesPayloadSchema)
            const localVarPath = `/notification/preferences/user/{user_id}`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(notificationPreferencesPayloadSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NotificationPreferencesApi - functional programming interface
 * @export
 */
export const NotificationPreferencesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = NotificationPreferencesApiAxiosParamCreator(configuration)
    return {
        /**
         * List Notification Preferences Groups.
         * @summary List Notification Preferences Groups
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async notificationPreferencesList(ordering?: string, page?: number, pageSize?: number, search?: string, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedNotificationPreferencesList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.notificationPreferencesList(ordering, page, pageSize, search, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationPreferencesApi.notificationPreferencesList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a user\'s notification preferences.
         * @summary Get a user\'s notification preferences.
         * @param {string} userId 
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async notificationPreferencesUserUserIdGet(userId: string, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<NotificationPreferencesUnifiedUpstreamNotificationService>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.notificationPreferencesUserUserIdGet(userId, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationPreferencesApi.notificationPreferencesUserUserIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update a user\'s notification preferences.
         * @summary Update a user\'s notification preferences.
         * @param {string} userId 
         * @param {Array<NotificationPreferencesPayloadSchema>} notificationPreferencesPayloadSchema 
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async notificationPreferencesUserUserIdPatch(userId: string, notificationPreferencesPayloadSchema: Array<NotificationPreferencesPayloadSchema>, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<NotificationPreferencesUnifiedUpstreamNotificationService>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.notificationPreferencesUserUserIdPatch(userId, notificationPreferencesPayloadSchema, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationPreferencesApi.notificationPreferencesUserUserIdPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * NotificationPreferencesApi - factory interface
 * @export
 */
export const NotificationPreferencesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = NotificationPreferencesApiFp(configuration)
    return {
        /**
         * List Notification Preferences Groups.
         * @summary List Notification Preferences Groups
         * @param {NotificationPreferencesApiNotificationPreferencesListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationPreferencesList(requestParameters: NotificationPreferencesApiNotificationPreferencesListRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedNotificationPreferencesList> {
            return localVarFp.notificationPreferencesList(requestParameters.ordering, requestParameters.page, requestParameters.pageSize, requestParameters.search, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a user\'s notification preferences.
         * @summary Get a user\'s notification preferences.
         * @param {NotificationPreferencesApiNotificationPreferencesUserUserIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationPreferencesUserUserIdGet(requestParameters: NotificationPreferencesApiNotificationPreferencesUserUserIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<NotificationPreferencesUnifiedUpstreamNotificationService>> {
            return localVarFp.notificationPreferencesUserUserIdGet(requestParameters.userId, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a user\'s notification preferences.
         * @summary Update a user\'s notification preferences.
         * @param {NotificationPreferencesApiNotificationPreferencesUserUserIdPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationPreferencesUserUserIdPatch(requestParameters: NotificationPreferencesApiNotificationPreferencesUserUserIdPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<NotificationPreferencesUnifiedUpstreamNotificationService>> {
            return localVarFp.notificationPreferencesUserUserIdPatch(requestParameters.userId, requestParameters.notificationPreferencesPayloadSchema, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for notificationPreferencesList operation in NotificationPreferencesApi.
 * @export
 * @interface NotificationPreferencesApiNotificationPreferencesListRequest
 */
export interface NotificationPreferencesApiNotificationPreferencesListRequest {
    /**
     * Which field to use when ordering the results.
     * @type {string}
     * @memberof NotificationPreferencesApiNotificationPreferencesList
     */
    readonly ordering?: string

    /**
     * A page number within the paginated result set.
     * @type {number}
     * @memberof NotificationPreferencesApiNotificationPreferencesList
     */
    readonly page?: number

    /**
     * Number of results to return per page.
     * @type {number}
     * @memberof NotificationPreferencesApiNotificationPreferencesList
     */
    readonly pageSize?: number

    /**
     * A search term.
     * @type {string}
     * @memberof NotificationPreferencesApiNotificationPreferencesList
     */
    readonly search?: string

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof NotificationPreferencesApiNotificationPreferencesList
     */
    readonly leafLinkVersion?: string
}

/**
 * Request parameters for notificationPreferencesUserUserIdGet operation in NotificationPreferencesApi.
 * @export
 * @interface NotificationPreferencesApiNotificationPreferencesUserUserIdGetRequest
 */
export interface NotificationPreferencesApiNotificationPreferencesUserUserIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof NotificationPreferencesApiNotificationPreferencesUserUserIdGet
     */
    readonly userId: string

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof NotificationPreferencesApiNotificationPreferencesUserUserIdGet
     */
    readonly leafLinkVersion?: string
}

/**
 * Request parameters for notificationPreferencesUserUserIdPatch operation in NotificationPreferencesApi.
 * @export
 * @interface NotificationPreferencesApiNotificationPreferencesUserUserIdPatchRequest
 */
export interface NotificationPreferencesApiNotificationPreferencesUserUserIdPatchRequest {
    /**
     * 
     * @type {string}
     * @memberof NotificationPreferencesApiNotificationPreferencesUserUserIdPatch
     */
    readonly userId: string

    /**
     * 
     * @type {Array<NotificationPreferencesPayloadSchema>}
     * @memberof NotificationPreferencesApiNotificationPreferencesUserUserIdPatch
     */
    readonly notificationPreferencesPayloadSchema: Array<NotificationPreferencesPayloadSchema>

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof NotificationPreferencesApiNotificationPreferencesUserUserIdPatch
     */
    readonly leafLinkVersion?: string
}

/**
 * NotificationPreferencesApi - object-oriented interface
 * @export
 * @class NotificationPreferencesApi
 * @extends {BaseAPI}
 */
export class NotificationPreferencesApi extends BaseAPI {
    /**
     * List Notification Preferences Groups.
     * @summary List Notification Preferences Groups
     * @param {NotificationPreferencesApiNotificationPreferencesListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationPreferencesApi
     */
    public notificationPreferencesList(requestParameters: NotificationPreferencesApiNotificationPreferencesListRequest = {}, options?: RawAxiosRequestConfig) {
        return NotificationPreferencesApiFp(this.configuration).notificationPreferencesList(requestParameters.ordering, requestParameters.page, requestParameters.pageSize, requestParameters.search, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a user\'s notification preferences.
     * @summary Get a user\'s notification preferences.
     * @param {NotificationPreferencesApiNotificationPreferencesUserUserIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationPreferencesApi
     */
    public notificationPreferencesUserUserIdGet(requestParameters: NotificationPreferencesApiNotificationPreferencesUserUserIdGetRequest, options?: RawAxiosRequestConfig) {
        return NotificationPreferencesApiFp(this.configuration).notificationPreferencesUserUserIdGet(requestParameters.userId, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a user\'s notification preferences.
     * @summary Update a user\'s notification preferences.
     * @param {NotificationPreferencesApiNotificationPreferencesUserUserIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationPreferencesApi
     */
    public notificationPreferencesUserUserIdPatch(requestParameters: NotificationPreferencesApiNotificationPreferencesUserUserIdPatchRequest, options?: RawAxiosRequestConfig) {
        return NotificationPreferencesApiFp(this.configuration).notificationPreferencesUserUserIdPatch(requestParameters.userId, requestParameters.notificationPreferencesPayloadSchema, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PaymentContractApi - axios parameter creator
 * @export
 */
export const PaymentContractApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create a payment contract.
         * @summary Create a Payment Contract
         * @param {ContractRequest} contractRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentContractsCreate: async (contractRequest: ContractRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'contractRequest' is not null or undefined
            assertParamExists('paymentContractsCreate', 'contractRequest', contractRequest)
            const localVarPath = `/payment_contracts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(contractRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a single payment contract.
         * @summary Delete a Payment Contract
         * @param {string} contractId 
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentContractsDestroy: async (contractId: string, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'contractId' is not null or undefined
            assertParamExists('paymentContractsDestroy', 'contractId', contractId)
            const localVarPath = `/payment_contracts/{contract_id}`
                .replace(`{${"contract_id"}}`, encodeURIComponent(String(contractId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List multiple payment contracts.
         * @summary List Payment Contracts
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentContractsList: async (ordering?: string, page?: number, pageSize?: number, search?: string, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/payment_contracts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a single payment contract.
         * @summary Update a Payment Contract
         * @param {string} contractId 
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {PatchedContractRequest} [patchedContractRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentContractsPartialUpdate: async (contractId: string, leafLinkVersion?: string, patchedContractRequest?: PatchedContractRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'contractId' is not null or undefined
            assertParamExists('paymentContractsPartialUpdate', 'contractId', contractId)
            const localVarPath = `/payment_contracts/{contract_id}`
                .replace(`{${"contract_id"}}`, encodeURIComponent(String(contractId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchedContractRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a single payment contracts.
         * @summary Get a Payment Contract
         * @param {string} contractId 
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentContractsRetrieve: async (contractId: string, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'contractId' is not null or undefined
            assertParamExists('paymentContractsRetrieve', 'contractId', contractId)
            const localVarPath = `/payment_contracts/{contract_id}`
                .replace(`{${"contract_id"}}`, encodeURIComponent(String(contractId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Replace a single payment contracts.
         * @summary Replace a Payment Contract
         * @param {string} contractId 
         * @param {ContractRequest} contractRequest 
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentContractsUpdate: async (contractId: string, contractRequest: ContractRequest, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'contractId' is not null or undefined
            assertParamExists('paymentContractsUpdate', 'contractId', contractId)
            // verify required parameter 'contractRequest' is not null or undefined
            assertParamExists('paymentContractsUpdate', 'contractRequest', contractRequest)
            const localVarPath = `/payment_contracts/{contract_id}`
                .replace(`{${"contract_id"}}`, encodeURIComponent(String(contractId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(contractRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PaymentContractApi - functional programming interface
 * @export
 */
export const PaymentContractApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PaymentContractApiAxiosParamCreator(configuration)
    return {
        /**
         * Create a payment contract.
         * @summary Create a Payment Contract
         * @param {ContractRequest} contractRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentContractsCreate(contractRequest: ContractRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Contract>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentContractsCreate(contractRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentContractApi.paymentContractsCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a single payment contract.
         * @summary Delete a Payment Contract
         * @param {string} contractId 
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentContractsDestroy(contractId: string, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentContractsDestroy(contractId, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentContractApi.paymentContractsDestroy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List multiple payment contracts.
         * @summary List Payment Contracts
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentContractsList(ordering?: string, page?: number, pageSize?: number, search?: string, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedContractList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentContractsList(ordering, page, pageSize, search, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentContractApi.paymentContractsList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update a single payment contract.
         * @summary Update a Payment Contract
         * @param {string} contractId 
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {PatchedContractRequest} [patchedContractRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentContractsPartialUpdate(contractId: string, leafLinkVersion?: string, patchedContractRequest?: PatchedContractRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Contract>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentContractsPartialUpdate(contractId, leafLinkVersion, patchedContractRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentContractApi.paymentContractsPartialUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a single payment contracts.
         * @summary Get a Payment Contract
         * @param {string} contractId 
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentContractsRetrieve(contractId: string, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Contract>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentContractsRetrieve(contractId, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentContractApi.paymentContractsRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Replace a single payment contracts.
         * @summary Replace a Payment Contract
         * @param {string} contractId 
         * @param {ContractRequest} contractRequest 
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentContractsUpdate(contractId: string, contractRequest: ContractRequest, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Contract>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentContractsUpdate(contractId, contractRequest, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentContractApi.paymentContractsUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PaymentContractApi - factory interface
 * @export
 */
export const PaymentContractApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PaymentContractApiFp(configuration)
    return {
        /**
         * Create a payment contract.
         * @summary Create a Payment Contract
         * @param {PaymentContractApiPaymentContractsCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentContractsCreate(requestParameters: PaymentContractApiPaymentContractsCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<Contract> {
            return localVarFp.paymentContractsCreate(requestParameters.contractRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a single payment contract.
         * @summary Delete a Payment Contract
         * @param {PaymentContractApiPaymentContractsDestroyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentContractsDestroy(requestParameters: PaymentContractApiPaymentContractsDestroyRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.paymentContractsDestroy(requestParameters.contractId, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * List multiple payment contracts.
         * @summary List Payment Contracts
         * @param {PaymentContractApiPaymentContractsListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentContractsList(requestParameters: PaymentContractApiPaymentContractsListRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedContractList> {
            return localVarFp.paymentContractsList(requestParameters.ordering, requestParameters.page, requestParameters.pageSize, requestParameters.search, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a single payment contract.
         * @summary Update a Payment Contract
         * @param {PaymentContractApiPaymentContractsPartialUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentContractsPartialUpdate(requestParameters: PaymentContractApiPaymentContractsPartialUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<Contract> {
            return localVarFp.paymentContractsPartialUpdate(requestParameters.contractId, requestParameters.leafLinkVersion, requestParameters.patchedContractRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a single payment contracts.
         * @summary Get a Payment Contract
         * @param {PaymentContractApiPaymentContractsRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentContractsRetrieve(requestParameters: PaymentContractApiPaymentContractsRetrieveRequest, options?: RawAxiosRequestConfig): AxiosPromise<Contract> {
            return localVarFp.paymentContractsRetrieve(requestParameters.contractId, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * Replace a single payment contracts.
         * @summary Replace a Payment Contract
         * @param {PaymentContractApiPaymentContractsUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentContractsUpdate(requestParameters: PaymentContractApiPaymentContractsUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<Contract> {
            return localVarFp.paymentContractsUpdate(requestParameters.contractId, requestParameters.contractRequest, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for paymentContractsCreate operation in PaymentContractApi.
 * @export
 * @interface PaymentContractApiPaymentContractsCreateRequest
 */
export interface PaymentContractApiPaymentContractsCreateRequest {
    /**
     * 
     * @type {ContractRequest}
     * @memberof PaymentContractApiPaymentContractsCreate
     */
    readonly contractRequest: ContractRequest
}

/**
 * Request parameters for paymentContractsDestroy operation in PaymentContractApi.
 * @export
 * @interface PaymentContractApiPaymentContractsDestroyRequest
 */
export interface PaymentContractApiPaymentContractsDestroyRequest {
    /**
     * 
     * @type {string}
     * @memberof PaymentContractApiPaymentContractsDestroy
     */
    readonly contractId: string

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof PaymentContractApiPaymentContractsDestroy
     */
    readonly leafLinkVersion?: string
}

/**
 * Request parameters for paymentContractsList operation in PaymentContractApi.
 * @export
 * @interface PaymentContractApiPaymentContractsListRequest
 */
export interface PaymentContractApiPaymentContractsListRequest {
    /**
     * Which field to use when ordering the results.
     * @type {string}
     * @memberof PaymentContractApiPaymentContractsList
     */
    readonly ordering?: string

    /**
     * A page number within the paginated result set.
     * @type {number}
     * @memberof PaymentContractApiPaymentContractsList
     */
    readonly page?: number

    /**
     * Number of results to return per page.
     * @type {number}
     * @memberof PaymentContractApiPaymentContractsList
     */
    readonly pageSize?: number

    /**
     * A search term.
     * @type {string}
     * @memberof PaymentContractApiPaymentContractsList
     */
    readonly search?: string

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof PaymentContractApiPaymentContractsList
     */
    readonly leafLinkVersion?: string
}

/**
 * Request parameters for paymentContractsPartialUpdate operation in PaymentContractApi.
 * @export
 * @interface PaymentContractApiPaymentContractsPartialUpdateRequest
 */
export interface PaymentContractApiPaymentContractsPartialUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof PaymentContractApiPaymentContractsPartialUpdate
     */
    readonly contractId: string

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof PaymentContractApiPaymentContractsPartialUpdate
     */
    readonly leafLinkVersion?: string

    /**
     * 
     * @type {PatchedContractRequest}
     * @memberof PaymentContractApiPaymentContractsPartialUpdate
     */
    readonly patchedContractRequest?: PatchedContractRequest
}

/**
 * Request parameters for paymentContractsRetrieve operation in PaymentContractApi.
 * @export
 * @interface PaymentContractApiPaymentContractsRetrieveRequest
 */
export interface PaymentContractApiPaymentContractsRetrieveRequest {
    /**
     * 
     * @type {string}
     * @memberof PaymentContractApiPaymentContractsRetrieve
     */
    readonly contractId: string

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof PaymentContractApiPaymentContractsRetrieve
     */
    readonly leafLinkVersion?: string
}

/**
 * Request parameters for paymentContractsUpdate operation in PaymentContractApi.
 * @export
 * @interface PaymentContractApiPaymentContractsUpdateRequest
 */
export interface PaymentContractApiPaymentContractsUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof PaymentContractApiPaymentContractsUpdate
     */
    readonly contractId: string

    /**
     * 
     * @type {ContractRequest}
     * @memberof PaymentContractApiPaymentContractsUpdate
     */
    readonly contractRequest: ContractRequest

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof PaymentContractApiPaymentContractsUpdate
     */
    readonly leafLinkVersion?: string
}

/**
 * PaymentContractApi - object-oriented interface
 * @export
 * @class PaymentContractApi
 * @extends {BaseAPI}
 */
export class PaymentContractApi extends BaseAPI {
    /**
     * Create a payment contract.
     * @summary Create a Payment Contract
     * @param {PaymentContractApiPaymentContractsCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentContractApi
     */
    public paymentContractsCreate(requestParameters: PaymentContractApiPaymentContractsCreateRequest, options?: RawAxiosRequestConfig) {
        return PaymentContractApiFp(this.configuration).paymentContractsCreate(requestParameters.contractRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a single payment contract.
     * @summary Delete a Payment Contract
     * @param {PaymentContractApiPaymentContractsDestroyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentContractApi
     */
    public paymentContractsDestroy(requestParameters: PaymentContractApiPaymentContractsDestroyRequest, options?: RawAxiosRequestConfig) {
        return PaymentContractApiFp(this.configuration).paymentContractsDestroy(requestParameters.contractId, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List multiple payment contracts.
     * @summary List Payment Contracts
     * @param {PaymentContractApiPaymentContractsListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentContractApi
     */
    public paymentContractsList(requestParameters: PaymentContractApiPaymentContractsListRequest = {}, options?: RawAxiosRequestConfig) {
        return PaymentContractApiFp(this.configuration).paymentContractsList(requestParameters.ordering, requestParameters.page, requestParameters.pageSize, requestParameters.search, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a single payment contract.
     * @summary Update a Payment Contract
     * @param {PaymentContractApiPaymentContractsPartialUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentContractApi
     */
    public paymentContractsPartialUpdate(requestParameters: PaymentContractApiPaymentContractsPartialUpdateRequest, options?: RawAxiosRequestConfig) {
        return PaymentContractApiFp(this.configuration).paymentContractsPartialUpdate(requestParameters.contractId, requestParameters.leafLinkVersion, requestParameters.patchedContractRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a single payment contracts.
     * @summary Get a Payment Contract
     * @param {PaymentContractApiPaymentContractsRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentContractApi
     */
    public paymentContractsRetrieve(requestParameters: PaymentContractApiPaymentContractsRetrieveRequest, options?: RawAxiosRequestConfig) {
        return PaymentContractApiFp(this.configuration).paymentContractsRetrieve(requestParameters.contractId, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Replace a single payment contracts.
     * @summary Replace a Payment Contract
     * @param {PaymentContractApiPaymentContractsUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentContractApi
     */
    public paymentContractsUpdate(requestParameters: PaymentContractApiPaymentContractsUpdateRequest, options?: RawAxiosRequestConfig) {
        return PaymentContractApiFp(this.configuration).paymentContractsUpdate(requestParameters.contractId, requestParameters.contractRequest, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PaymentsApi - axios parameter creator
 * @export
 */
export const PaymentsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * ViewSet for handling requests related to order payments.
         * @param {UnifiedOrderPaymentRequest} unifiedOrderPaymentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsCreate: async (unifiedOrderPaymentRequest: UnifiedOrderPaymentRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'unifiedOrderPaymentRequest' is not null or undefined
            assertParamExists('paymentsCreate', 'unifiedOrderPaymentRequest', unifiedOrderPaymentRequest)
            const localVarPath = `/payments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(unifiedOrderPaymentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ViewSet for handling requests related to order payments.
         * @param {string} [createdDateFrom] 
         * @param {string} [createdDateTo] 
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsList: async (createdDateFrom?: string, createdDateTo?: string, ordering?: string, page?: number, pageSize?: number, search?: string, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/payments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (createdDateFrom !== undefined) {
                localVarQueryParameter['created_date_from'] = (createdDateFrom as any instanceof Date) ?
                    (createdDateFrom as any).toISOString().substring(0,10) :
                    createdDateFrom;
            }

            if (createdDateTo !== undefined) {
                localVarQueryParameter['created_date_to'] = (createdDateTo as any instanceof Date) ?
                    (createdDateTo as any).toISOString().substring(0,10) :
                    createdDateTo;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ViewSet for handling requests related to order payments.
         * @param {number} id A unique integer value identifying this order payment.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsRetrieve: async (id: number, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('paymentsRetrieve', 'id', id)
            const localVarPath = `/payments/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PaymentsApi - functional programming interface
 * @export
 */
export const PaymentsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PaymentsApiAxiosParamCreator(configuration)
    return {
        /**
         * ViewSet for handling requests related to order payments.
         * @param {UnifiedOrderPaymentRequest} unifiedOrderPaymentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentsCreate(unifiedOrderPaymentRequest: UnifiedOrderPaymentRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnifiedOrderPayment>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentsCreate(unifiedOrderPaymentRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentsApi.paymentsCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * ViewSet for handling requests related to order payments.
         * @param {string} [createdDateFrom] 
         * @param {string} [createdDateTo] 
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentsList(createdDateFrom?: string, createdDateTo?: string, ordering?: string, page?: number, pageSize?: number, search?: string, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedUnifiedOrderPaymentList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentsList(createdDateFrom, createdDateTo, ordering, page, pageSize, search, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentsApi.paymentsList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * ViewSet for handling requests related to order payments.
         * @param {number} id A unique integer value identifying this order payment.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentsRetrieve(id: number, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnifiedOrderPayment>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentsRetrieve(id, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentsApi.paymentsRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PaymentsApi - factory interface
 * @export
 */
export const PaymentsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PaymentsApiFp(configuration)
    return {
        /**
         * ViewSet for handling requests related to order payments.
         * @param {PaymentsApiPaymentsCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsCreate(requestParameters: PaymentsApiPaymentsCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<UnifiedOrderPayment> {
            return localVarFp.paymentsCreate(requestParameters.unifiedOrderPaymentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * ViewSet for handling requests related to order payments.
         * @param {PaymentsApiPaymentsListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsList(requestParameters: PaymentsApiPaymentsListRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedUnifiedOrderPaymentList> {
            return localVarFp.paymentsList(requestParameters.createdDateFrom, requestParameters.createdDateTo, requestParameters.ordering, requestParameters.page, requestParameters.pageSize, requestParameters.search, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * ViewSet for handling requests related to order payments.
         * @param {PaymentsApiPaymentsRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsRetrieve(requestParameters: PaymentsApiPaymentsRetrieveRequest, options?: RawAxiosRequestConfig): AxiosPromise<UnifiedOrderPayment> {
            return localVarFp.paymentsRetrieve(requestParameters.id, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for paymentsCreate operation in PaymentsApi.
 * @export
 * @interface PaymentsApiPaymentsCreateRequest
 */
export interface PaymentsApiPaymentsCreateRequest {
    /**
     * 
     * @type {UnifiedOrderPaymentRequest}
     * @memberof PaymentsApiPaymentsCreate
     */
    readonly unifiedOrderPaymentRequest: UnifiedOrderPaymentRequest
}

/**
 * Request parameters for paymentsList operation in PaymentsApi.
 * @export
 * @interface PaymentsApiPaymentsListRequest
 */
export interface PaymentsApiPaymentsListRequest {
    /**
     * 
     * @type {string}
     * @memberof PaymentsApiPaymentsList
     */
    readonly createdDateFrom?: string

    /**
     * 
     * @type {string}
     * @memberof PaymentsApiPaymentsList
     */
    readonly createdDateTo?: string

    /**
     * Which field to use when ordering the results.
     * @type {string}
     * @memberof PaymentsApiPaymentsList
     */
    readonly ordering?: string

    /**
     * A page number within the paginated result set.
     * @type {number}
     * @memberof PaymentsApiPaymentsList
     */
    readonly page?: number

    /**
     * Number of results to return per page.
     * @type {number}
     * @memberof PaymentsApiPaymentsList
     */
    readonly pageSize?: number

    /**
     * A search term.
     * @type {string}
     * @memberof PaymentsApiPaymentsList
     */
    readonly search?: string

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof PaymentsApiPaymentsList
     */
    readonly leafLinkVersion?: string
}

/**
 * Request parameters for paymentsRetrieve operation in PaymentsApi.
 * @export
 * @interface PaymentsApiPaymentsRetrieveRequest
 */
export interface PaymentsApiPaymentsRetrieveRequest {
    /**
     * A unique integer value identifying this order payment.
     * @type {number}
     * @memberof PaymentsApiPaymentsRetrieve
     */
    readonly id: number

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof PaymentsApiPaymentsRetrieve
     */
    readonly leafLinkVersion?: string
}

/**
 * PaymentsApi - object-oriented interface
 * @export
 * @class PaymentsApi
 * @extends {BaseAPI}
 */
export class PaymentsApi extends BaseAPI {
    /**
     * ViewSet for handling requests related to order payments.
     * @param {PaymentsApiPaymentsCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    public paymentsCreate(requestParameters: PaymentsApiPaymentsCreateRequest, options?: RawAxiosRequestConfig) {
        return PaymentsApiFp(this.configuration).paymentsCreate(requestParameters.unifiedOrderPaymentRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ViewSet for handling requests related to order payments.
     * @param {PaymentsApiPaymentsListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    public paymentsList(requestParameters: PaymentsApiPaymentsListRequest = {}, options?: RawAxiosRequestConfig) {
        return PaymentsApiFp(this.configuration).paymentsList(requestParameters.createdDateFrom, requestParameters.createdDateTo, requestParameters.ordering, requestParameters.page, requestParameters.pageSize, requestParameters.search, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ViewSet for handling requests related to order payments.
     * @param {PaymentsApiPaymentsRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    public paymentsRetrieve(requestParameters: PaymentsApiPaymentsRetrieveRequest, options?: RawAxiosRequestConfig) {
        return PaymentsApiFp(this.configuration).paymentsRetrieve(requestParameters.id, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PomsApi - axios parameter creator
 * @export
 */
export const PomsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Handle the \'APPROVAL\' endpoint for a POMS Order. See the CartOrderApprovalAction choices for supported actions that can be performed.
         * @param {UnifiedPomsOrderApprovalRequestDataRequest} unifiedPomsOrderApprovalRequestDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pomsOrdersApprovalCreate: async (unifiedPomsOrderApprovalRequestDataRequest: UnifiedPomsOrderApprovalRequestDataRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'unifiedPomsOrderApprovalRequestDataRequest' is not null or undefined
            assertParamExists('pomsOrdersApprovalCreate', 'unifiedPomsOrderApprovalRequestDataRequest', unifiedPomsOrderApprovalRequestDataRequest)
            const localVarPath = `/poms/orders/approval`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(unifiedPomsOrderApprovalRequestDataRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PomsApi - functional programming interface
 * @export
 */
export const PomsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PomsApiAxiosParamCreator(configuration)
    return {
        /**
         * Handle the \'APPROVAL\' endpoint for a POMS Order. See the CartOrderApprovalAction choices for supported actions that can be performed.
         * @param {UnifiedPomsOrderApprovalRequestDataRequest} unifiedPomsOrderApprovalRequestDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pomsOrdersApprovalCreate(unifiedPomsOrderApprovalRequestDataRequest: UnifiedPomsOrderApprovalRequestDataRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnifiedPomsOrderApprovalRequestData>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pomsOrdersApprovalCreate(unifiedPomsOrderApprovalRequestDataRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PomsApi.pomsOrdersApprovalCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PomsApi - factory interface
 * @export
 */
export const PomsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PomsApiFp(configuration)
    return {
        /**
         * Handle the \'APPROVAL\' endpoint for a POMS Order. See the CartOrderApprovalAction choices for supported actions that can be performed.
         * @param {PomsApiPomsOrdersApprovalCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pomsOrdersApprovalCreate(requestParameters: PomsApiPomsOrdersApprovalCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<UnifiedPomsOrderApprovalRequestData> {
            return localVarFp.pomsOrdersApprovalCreate(requestParameters.unifiedPomsOrderApprovalRequestDataRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for pomsOrdersApprovalCreate operation in PomsApi.
 * @export
 * @interface PomsApiPomsOrdersApprovalCreateRequest
 */
export interface PomsApiPomsOrdersApprovalCreateRequest {
    /**
     * 
     * @type {UnifiedPomsOrderApprovalRequestDataRequest}
     * @memberof PomsApiPomsOrdersApprovalCreate
     */
    readonly unifiedPomsOrderApprovalRequestDataRequest: UnifiedPomsOrderApprovalRequestDataRequest
}

/**
 * PomsApi - object-oriented interface
 * @export
 * @class PomsApi
 * @extends {BaseAPI}
 */
export class PomsApi extends BaseAPI {
    /**
     * Handle the \'APPROVAL\' endpoint for a POMS Order. See the CartOrderApprovalAction choices for supported actions that can be performed.
     * @param {PomsApiPomsOrdersApprovalCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PomsApi
     */
    public pomsOrdersApprovalCreate(requestParameters: PomsApiPomsOrdersApprovalCreateRequest, options?: RawAxiosRequestConfig) {
        return PomsApiFp(this.configuration).pomsOrdersApprovalCreate(requestParameters.unifiedPomsOrderApprovalRequestDataRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ProductApi - axios parameter creator
 * @export
 */
export const ProductApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * List new brands, products with deals, and sponsored products on the dashboard.
         * @summary Featured Products
         * @param {number} companyId The ID of the viewing company
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dashboardProductSpotlightList: async (companyId: number, ordering?: string, page?: number, pageSize?: number, search?: string, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('dashboardProductSpotlightList', 'companyId', companyId)
            const localVarPath = `/dashboard/product_spotlight`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (companyId !== undefined) {
                localVarQueryParameter['company_id'] = companyId;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List multiple ExpressProductMenus.
         * @summary List Express Product Menus
         * @param {number} [brand] 
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [priceSchedule] 
         * @param {string} [products] Set to \&#39;false\&#39; to avoid an unnecessary query for product IDs
         * @param {string} [search] A search term.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        expressMenusList: async (brand?: number, ordering?: string, priceSchedule?: number, products?: string, search?: string, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/express_menus`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (brand !== undefined) {
                localVarQueryParameter['brand'] = brand;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }

            if (priceSchedule !== undefined) {
                localVarQueryParameter['price_schedule'] = priceSchedule;
            }

            if (products !== undefined) {
                localVarQueryParameter['products'] = products;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update Multiple Products.
         * @summary Bulk Product Update
         * @param {Array<UnifiedProductBulkUpdateRequest>} unifiedProductBulkUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsBulkUpdate: async (unifiedProductBulkUpdateRequest: Array<UnifiedProductBulkUpdateRequest>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'unifiedProductBulkUpdateRequest' is not null or undefined
            assertParamExists('productsBulkUpdate', 'unifiedProductBulkUpdateRequest', unifiedProductBulkUpdateRequest)
            const localVarPath = `/products/bulk/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(unifiedProductBulkUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List multiple Products.
         * @summary List Products
         * @param {boolean} [archived] 
         * @param {boolean} [baseUnitsPerUnitIsnull] 
         * @param {boolean} [batchAssociatedIsnull] 
         * @param {number} [brand] 
         * @param {number} [buyer] 
         * @param {number} [category] 
         * @param {number} [company] 
         * @param {string} [companySlug] 
         * @param {string} [createdOnGt] 
         * @param {string} [createdOnGte] 
         * @param {string} [createdOnLt] 
         * @param {string} [createdOnLte] 
         * @param {string} [displayName] 
         * @param {Array<number>} [externStsIds] Multiple values may be separated by commas.
         * @param {string} [externalIdKey] 
         * @param {boolean} [externalIdUnmapped] 
         * @param {string} [externalIdValues] 
         * @param {string} [externalIds] 
         * @param {boolean} [hasChildren] 
         * @param {Array<number>} [id] Multiple values may be separated by commas.
         * @param {string} [lastEditGt] 
         * @param {string} [lastEditGte] 
         * @param {string} [lastEditLt] 
         * @param {string} [lastEditLte] 
         * @param {Array<number>} [license] Multiple values may be separated by commas.
         * @param {boolean} [licenseIsnull] 
         * @param {Array<number>} [licenseType] Multiple values may be separated by commas.
         * @param {string} [listingState] 
         * @param {string} [modifiedGt] 
         * @param {string} [modifiedGte] 
         * @param {string} [modifiedLt] 
         * @param {string} [modifiedLte] 
         * @param {string} [name] 
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {Array<number>} [parent] Multiple values may be separated by commas.
         * @param {boolean} [parentIsnull] 
         * @param {Array<number>} [productLine] Multiple values may be separated by commas.
         * @param {boolean} [reconcileInventory] 
         * @param {boolean} [s2sConnected] 
         * @param {string} [search] A search term.
         * @param {Array<string>} [sku] Multiple values may be separated by commas.
         * @param {Array<number>} [strains] Multiple values may be separated by commas.
         * @param {Array<number>} [subCategory] Multiple values may be separated by commas.
         * @param {boolean} [subCategoryIsnull] 
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsList: async (archived?: boolean, baseUnitsPerUnitIsnull?: boolean, batchAssociatedIsnull?: boolean, brand?: number, buyer?: number, category?: number, company?: number, companySlug?: string, createdOnGt?: string, createdOnGte?: string, createdOnLt?: string, createdOnLte?: string, displayName?: string, externStsIds?: Array<number>, externalIdKey?: string, externalIdUnmapped?: boolean, externalIdValues?: string, externalIds?: string, hasChildren?: boolean, id?: Array<number>, lastEditGt?: string, lastEditGte?: string, lastEditLt?: string, lastEditLte?: string, license?: Array<number>, licenseIsnull?: boolean, licenseType?: Array<number>, listingState?: string, modifiedGt?: string, modifiedGte?: string, modifiedLt?: string, modifiedLte?: string, name?: string, ordering?: string, page?: number, pageSize?: number, parent?: Array<number>, parentIsnull?: boolean, productLine?: Array<number>, reconcileInventory?: boolean, s2sConnected?: boolean, search?: string, sku?: Array<string>, strains?: Array<number>, subCategory?: Array<number>, subCategoryIsnull?: boolean, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/products`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (archived !== undefined) {
                localVarQueryParameter['archived'] = archived;
            }

            if (baseUnitsPerUnitIsnull !== undefined) {
                localVarQueryParameter['base_units_per_unit__isnull'] = baseUnitsPerUnitIsnull;
            }

            if (batchAssociatedIsnull !== undefined) {
                localVarQueryParameter['batch_associated__isnull'] = batchAssociatedIsnull;
            }

            if (brand !== undefined) {
                localVarQueryParameter['brand'] = brand;
            }

            if (buyer !== undefined) {
                localVarQueryParameter['buyer'] = buyer;
            }

            if (category !== undefined) {
                localVarQueryParameter['category'] = category;
            }

            if (company !== undefined) {
                localVarQueryParameter['company'] = company;
            }

            if (companySlug !== undefined) {
                localVarQueryParameter['company_slug'] = companySlug;
            }

            if (createdOnGt !== undefined) {
                localVarQueryParameter['created_on__gt'] = (createdOnGt as any instanceof Date) ?
                    (createdOnGt as any).toISOString() :
                    createdOnGt;
            }

            if (createdOnGte !== undefined) {
                localVarQueryParameter['created_on__gte'] = (createdOnGte as any instanceof Date) ?
                    (createdOnGte as any).toISOString() :
                    createdOnGte;
            }

            if (createdOnLt !== undefined) {
                localVarQueryParameter['created_on__lt'] = (createdOnLt as any instanceof Date) ?
                    (createdOnLt as any).toISOString() :
                    createdOnLt;
            }

            if (createdOnLte !== undefined) {
                localVarQueryParameter['created_on__lte'] = (createdOnLte as any instanceof Date) ?
                    (createdOnLte as any).toISOString() :
                    createdOnLte;
            }

            if (displayName !== undefined) {
                localVarQueryParameter['display_name'] = displayName;
            }

            if (externStsIds) {
                localVarQueryParameter['extern_sts_ids'] = externStsIds.join(COLLECTION_FORMATS.csv);
            }

            if (externalIdKey !== undefined) {
                localVarQueryParameter['external_id_key'] = externalIdKey;
            }

            if (externalIdUnmapped !== undefined) {
                localVarQueryParameter['external_id_unmapped'] = externalIdUnmapped;
            }

            if (externalIdValues !== undefined) {
                localVarQueryParameter['external_id_values'] = externalIdValues;
            }

            if (externalIds !== undefined) {
                localVarQueryParameter['external_ids'] = externalIds;
            }

            if (hasChildren !== undefined) {
                localVarQueryParameter['has_children'] = hasChildren;
            }

            if (id) {
                localVarQueryParameter['id'] = id.join(COLLECTION_FORMATS.csv);
            }

            if (lastEditGt !== undefined) {
                localVarQueryParameter['last_edit__gt'] = (lastEditGt as any instanceof Date) ?
                    (lastEditGt as any).toISOString() :
                    lastEditGt;
            }

            if (lastEditGte !== undefined) {
                localVarQueryParameter['last_edit__gte'] = (lastEditGte as any instanceof Date) ?
                    (lastEditGte as any).toISOString() :
                    lastEditGte;
            }

            if (lastEditLt !== undefined) {
                localVarQueryParameter['last_edit__lt'] = (lastEditLt as any instanceof Date) ?
                    (lastEditLt as any).toISOString() :
                    lastEditLt;
            }

            if (lastEditLte !== undefined) {
                localVarQueryParameter['last_edit__lte'] = (lastEditLte as any instanceof Date) ?
                    (lastEditLte as any).toISOString() :
                    lastEditLte;
            }

            if (license) {
                localVarQueryParameter['license'] = license.join(COLLECTION_FORMATS.csv);
            }

            if (licenseIsnull !== undefined) {
                localVarQueryParameter['license__isnull'] = licenseIsnull;
            }

            if (licenseType) {
                localVarQueryParameter['license__type'] = licenseType.join(COLLECTION_FORMATS.csv);
            }

            if (listingState !== undefined) {
                localVarQueryParameter['listing_state'] = listingState;
            }

            if (modifiedGt !== undefined) {
                localVarQueryParameter['modified__gt'] = (modifiedGt as any instanceof Date) ?
                    (modifiedGt as any).toISOString() :
                    modifiedGt;
            }

            if (modifiedGte !== undefined) {
                localVarQueryParameter['modified__gte'] = (modifiedGte as any instanceof Date) ?
                    (modifiedGte as any).toISOString() :
                    modifiedGte;
            }

            if (modifiedLt !== undefined) {
                localVarQueryParameter['modified__lt'] = (modifiedLt as any instanceof Date) ?
                    (modifiedLt as any).toISOString() :
                    modifiedLt;
            }

            if (modifiedLte !== undefined) {
                localVarQueryParameter['modified__lte'] = (modifiedLte as any instanceof Date) ?
                    (modifiedLte as any).toISOString() :
                    modifiedLte;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (parent) {
                localVarQueryParameter['parent'] = parent.join(COLLECTION_FORMATS.csv);
            }

            if (parentIsnull !== undefined) {
                localVarQueryParameter['parent__isnull'] = parentIsnull;
            }

            if (productLine) {
                localVarQueryParameter['product_line'] = productLine.join(COLLECTION_FORMATS.csv);
            }

            if (reconcileInventory !== undefined) {
                localVarQueryParameter['reconcile_inventory'] = reconcileInventory;
            }

            if (s2sConnected !== undefined) {
                localVarQueryParameter['s2s_connected'] = s2sConnected;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (sku) {
                localVarQueryParameter['sku'] = sku.join(COLLECTION_FORMATS.csv);
            }

            if (strains) {
                localVarQueryParameter['strains'] = strains.join(COLLECTION_FORMATS.csv);
            }

            if (subCategory) {
                localVarQueryParameter['sub_category'] = subCategory.join(COLLECTION_FORMATS.csv);
            }

            if (subCategoryIsnull !== undefined) {
                localVarQueryParameter['sub_category__isnull'] = subCategoryIsnull;
            }


    
            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List product recommendations.
         * @summary Recommended Products
         * @param {number} companyId The ID of the viewing company
         * @param {ProductsRecommendedListPlacementEnum} placement The ID of an ad location
         * @param {number} [adCount] The number of ads to request
         * @param {string} [brandId] The brand to restrict recommendations to.
         * @param {Array<number>} [category] Filter by category id
         * @param {Array<number>} [objectId] One or more Object IDs
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {number} [productCount] The number of products to request
         * @param {string} [search] A search term.
         * @param {string} [subcategory] The product sub-category id to restrict recommendations to.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsRecommendedList: async (companyId: number, placement: ProductsRecommendedListPlacementEnum, adCount?: number, brandId?: string, category?: Array<number>, objectId?: Array<number>, ordering?: string, page?: number, pageSize?: number, productCount?: number, search?: string, subcategory?: string, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('productsRecommendedList', 'companyId', companyId)
            // verify required parameter 'placement' is not null or undefined
            assertParamExists('productsRecommendedList', 'placement', placement)
            const localVarPath = `/products/recommended`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (adCount !== undefined) {
                localVarQueryParameter['ad_count'] = adCount;
            }

            if (brandId !== undefined) {
                localVarQueryParameter['brand_id'] = brandId;
            }

            if (category) {
                localVarQueryParameter['category'] = category;
            }

            if (companyId !== undefined) {
                localVarQueryParameter['company_id'] = companyId;
            }

            if (objectId) {
                localVarQueryParameter['object_id'] = objectId;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (placement !== undefined) {
                localVarQueryParameter['placement'] = placement;
            }

            if (productCount !== undefined) {
                localVarQueryParameter['product_count'] = productCount;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (subcategory !== undefined) {
                localVarQueryParameter['subcategory'] = subcategory;
            }


    
            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a single Product.
         * @summary Get Product
         * @param {number} id A unique integer value identifying this product.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsRetrieve: async (id: number, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('productsRetrieve', 'id', id)
            const localVarPath = `/products/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProductApi - functional programming interface
 * @export
 */
export const ProductApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProductApiAxiosParamCreator(configuration)
    return {
        /**
         * List new brands, products with deals, and sponsored products on the dashboard.
         * @summary Featured Products
         * @param {number} companyId The ID of the viewing company
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dashboardProductSpotlightList(companyId: number, ordering?: string, page?: number, pageSize?: number, search?: string, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedFeaturedProductList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dashboardProductSpotlightList(companyId, ordering, page, pageSize, search, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductApi.dashboardProductSpotlightList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List multiple ExpressProductMenus.
         * @summary List Express Product Menus
         * @param {number} [brand] 
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [priceSchedule] 
         * @param {string} [products] Set to \&#39;false\&#39; to avoid an unnecessary query for product IDs
         * @param {string} [search] A search term.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async expressMenusList(brand?: number, ordering?: string, priceSchedule?: number, products?: string, search?: string, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.expressMenusList(brand, ordering, priceSchedule, products, search, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductApi.expressMenusList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update Multiple Products.
         * @summary Bulk Product Update
         * @param {Array<UnifiedProductBulkUpdateRequest>} unifiedProductBulkUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productsBulkUpdate(unifiedProductBulkUpdateRequest: Array<UnifiedProductBulkUpdateRequest>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductBulkUpdateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productsBulkUpdate(unifiedProductBulkUpdateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductApi.productsBulkUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List multiple Products.
         * @summary List Products
         * @param {boolean} [archived] 
         * @param {boolean} [baseUnitsPerUnitIsnull] 
         * @param {boolean} [batchAssociatedIsnull] 
         * @param {number} [brand] 
         * @param {number} [buyer] 
         * @param {number} [category] 
         * @param {number} [company] 
         * @param {string} [companySlug] 
         * @param {string} [createdOnGt] 
         * @param {string} [createdOnGte] 
         * @param {string} [createdOnLt] 
         * @param {string} [createdOnLte] 
         * @param {string} [displayName] 
         * @param {Array<number>} [externStsIds] Multiple values may be separated by commas.
         * @param {string} [externalIdKey] 
         * @param {boolean} [externalIdUnmapped] 
         * @param {string} [externalIdValues] 
         * @param {string} [externalIds] 
         * @param {boolean} [hasChildren] 
         * @param {Array<number>} [id] Multiple values may be separated by commas.
         * @param {string} [lastEditGt] 
         * @param {string} [lastEditGte] 
         * @param {string} [lastEditLt] 
         * @param {string} [lastEditLte] 
         * @param {Array<number>} [license] Multiple values may be separated by commas.
         * @param {boolean} [licenseIsnull] 
         * @param {Array<number>} [licenseType] Multiple values may be separated by commas.
         * @param {string} [listingState] 
         * @param {string} [modifiedGt] 
         * @param {string} [modifiedGte] 
         * @param {string} [modifiedLt] 
         * @param {string} [modifiedLte] 
         * @param {string} [name] 
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {Array<number>} [parent] Multiple values may be separated by commas.
         * @param {boolean} [parentIsnull] 
         * @param {Array<number>} [productLine] Multiple values may be separated by commas.
         * @param {boolean} [reconcileInventory] 
         * @param {boolean} [s2sConnected] 
         * @param {string} [search] A search term.
         * @param {Array<string>} [sku] Multiple values may be separated by commas.
         * @param {Array<number>} [strains] Multiple values may be separated by commas.
         * @param {Array<number>} [subCategory] Multiple values may be separated by commas.
         * @param {boolean} [subCategoryIsnull] 
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productsList(archived?: boolean, baseUnitsPerUnitIsnull?: boolean, batchAssociatedIsnull?: boolean, brand?: number, buyer?: number, category?: number, company?: number, companySlug?: string, createdOnGt?: string, createdOnGte?: string, createdOnLt?: string, createdOnLte?: string, displayName?: string, externStsIds?: Array<number>, externalIdKey?: string, externalIdUnmapped?: boolean, externalIdValues?: string, externalIds?: string, hasChildren?: boolean, id?: Array<number>, lastEditGt?: string, lastEditGte?: string, lastEditLt?: string, lastEditLte?: string, license?: Array<number>, licenseIsnull?: boolean, licenseType?: Array<number>, listingState?: string, modifiedGt?: string, modifiedGte?: string, modifiedLt?: string, modifiedLte?: string, name?: string, ordering?: string, page?: number, pageSize?: number, parent?: Array<number>, parentIsnull?: boolean, productLine?: Array<number>, reconcileInventory?: boolean, s2sConnected?: boolean, search?: string, sku?: Array<string>, strains?: Array<number>, subCategory?: Array<number>, subCategoryIsnull?: boolean, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productsList(archived, baseUnitsPerUnitIsnull, batchAssociatedIsnull, brand, buyer, category, company, companySlug, createdOnGt, createdOnGte, createdOnLt, createdOnLte, displayName, externStsIds, externalIdKey, externalIdUnmapped, externalIdValues, externalIds, hasChildren, id, lastEditGt, lastEditGte, lastEditLt, lastEditLte, license, licenseIsnull, licenseType, listingState, modifiedGt, modifiedGte, modifiedLt, modifiedLte, name, ordering, page, pageSize, parent, parentIsnull, productLine, reconcileInventory, s2sConnected, search, sku, strains, subCategory, subCategoryIsnull, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductApi.productsList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List product recommendations.
         * @summary Recommended Products
         * @param {number} companyId The ID of the viewing company
         * @param {ProductsRecommendedListPlacementEnum} placement The ID of an ad location
         * @param {number} [adCount] The number of ads to request
         * @param {string} [brandId] The brand to restrict recommendations to.
         * @param {Array<number>} [category] Filter by category id
         * @param {Array<number>} [objectId] One or more Object IDs
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {number} [productCount] The number of products to request
         * @param {string} [search] A search term.
         * @param {string} [subcategory] The product sub-category id to restrict recommendations to.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productsRecommendedList(companyId: number, placement: ProductsRecommendedListPlacementEnum, adCount?: number, brandId?: string, category?: Array<number>, objectId?: Array<number>, ordering?: string, page?: number, pageSize?: number, productCount?: number, search?: string, subcategory?: string, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedRecommendedProductList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productsRecommendedList(companyId, placement, adCount, brandId, category, objectId, ordering, page, pageSize, productCount, search, subcategory, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductApi.productsRecommendedList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a single Product.
         * @summary Get Product
         * @param {number} id A unique integer value identifying this product.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productsRetrieve(id: number, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productsRetrieve(id, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductApi.productsRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ProductApi - factory interface
 * @export
 */
export const ProductApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProductApiFp(configuration)
    return {
        /**
         * List new brands, products with deals, and sponsored products on the dashboard.
         * @summary Featured Products
         * @param {ProductApiDashboardProductSpotlightListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dashboardProductSpotlightList(requestParameters: ProductApiDashboardProductSpotlightListRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedFeaturedProductList> {
            return localVarFp.dashboardProductSpotlightList(requestParameters.companyId, requestParameters.ordering, requestParameters.page, requestParameters.pageSize, requestParameters.search, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * List multiple ExpressProductMenus.
         * @summary List Express Product Menus
         * @param {ProductApiExpressMenusListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        expressMenusList(requestParameters: ProductApiExpressMenusListRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.expressMenusList(requestParameters.brand, requestParameters.ordering, requestParameters.priceSchedule, requestParameters.products, requestParameters.search, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * Update Multiple Products.
         * @summary Bulk Product Update
         * @param {ProductApiProductsBulkUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsBulkUpdate(requestParameters: ProductApiProductsBulkUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProductBulkUpdateResponse> {
            return localVarFp.productsBulkUpdate(requestParameters.unifiedProductBulkUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * List multiple Products.
         * @summary List Products
         * @param {ProductApiProductsListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsList(requestParameters: ProductApiProductsListRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.productsList(requestParameters.archived, requestParameters.baseUnitsPerUnitIsnull, requestParameters.batchAssociatedIsnull, requestParameters.brand, requestParameters.buyer, requestParameters.category, requestParameters.company, requestParameters.companySlug, requestParameters.createdOnGt, requestParameters.createdOnGte, requestParameters.createdOnLt, requestParameters.createdOnLte, requestParameters.displayName, requestParameters.externStsIds, requestParameters.externalIdKey, requestParameters.externalIdUnmapped, requestParameters.externalIdValues, requestParameters.externalIds, requestParameters.hasChildren, requestParameters.id, requestParameters.lastEditGt, requestParameters.lastEditGte, requestParameters.lastEditLt, requestParameters.lastEditLte, requestParameters.license, requestParameters.licenseIsnull, requestParameters.licenseType, requestParameters.listingState, requestParameters.modifiedGt, requestParameters.modifiedGte, requestParameters.modifiedLt, requestParameters.modifiedLte, requestParameters.name, requestParameters.ordering, requestParameters.page, requestParameters.pageSize, requestParameters.parent, requestParameters.parentIsnull, requestParameters.productLine, requestParameters.reconcileInventory, requestParameters.s2sConnected, requestParameters.search, requestParameters.sku, requestParameters.strains, requestParameters.subCategory, requestParameters.subCategoryIsnull, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * List product recommendations.
         * @summary Recommended Products
         * @param {ProductApiProductsRecommendedListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsRecommendedList(requestParameters: ProductApiProductsRecommendedListRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedRecommendedProductList> {
            return localVarFp.productsRecommendedList(requestParameters.companyId, requestParameters.placement, requestParameters.adCount, requestParameters.brandId, requestParameters.category, requestParameters.objectId, requestParameters.ordering, requestParameters.page, requestParameters.pageSize, requestParameters.productCount, requestParameters.search, requestParameters.subcategory, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a single Product.
         * @summary Get Product
         * @param {ProductApiProductsRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsRetrieve(requestParameters: ProductApiProductsRetrieveRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.productsRetrieve(requestParameters.id, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for dashboardProductSpotlightList operation in ProductApi.
 * @export
 * @interface ProductApiDashboardProductSpotlightListRequest
 */
export interface ProductApiDashboardProductSpotlightListRequest {
    /**
     * The ID of the viewing company
     * @type {number}
     * @memberof ProductApiDashboardProductSpotlightList
     */
    readonly companyId: number

    /**
     * Which field to use when ordering the results.
     * @type {string}
     * @memberof ProductApiDashboardProductSpotlightList
     */
    readonly ordering?: string

    /**
     * A page number within the paginated result set.
     * @type {number}
     * @memberof ProductApiDashboardProductSpotlightList
     */
    readonly page?: number

    /**
     * Number of results to return per page.
     * @type {number}
     * @memberof ProductApiDashboardProductSpotlightList
     */
    readonly pageSize?: number

    /**
     * A search term.
     * @type {string}
     * @memberof ProductApiDashboardProductSpotlightList
     */
    readonly search?: string

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof ProductApiDashboardProductSpotlightList
     */
    readonly leafLinkVersion?: string
}

/**
 * Request parameters for expressMenusList operation in ProductApi.
 * @export
 * @interface ProductApiExpressMenusListRequest
 */
export interface ProductApiExpressMenusListRequest {
    /**
     * 
     * @type {number}
     * @memberof ProductApiExpressMenusList
     */
    readonly brand?: number

    /**
     * Which field to use when ordering the results.
     * @type {string}
     * @memberof ProductApiExpressMenusList
     */
    readonly ordering?: string

    /**
     * 
     * @type {number}
     * @memberof ProductApiExpressMenusList
     */
    readonly priceSchedule?: number

    /**
     * Set to \&#39;false\&#39; to avoid an unnecessary query for product IDs
     * @type {string}
     * @memberof ProductApiExpressMenusList
     */
    readonly products?: string

    /**
     * A search term.
     * @type {string}
     * @memberof ProductApiExpressMenusList
     */
    readonly search?: string

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof ProductApiExpressMenusList
     */
    readonly leafLinkVersion?: string
}

/**
 * Request parameters for productsBulkUpdate operation in ProductApi.
 * @export
 * @interface ProductApiProductsBulkUpdateRequest
 */
export interface ProductApiProductsBulkUpdateRequest {
    /**
     * 
     * @type {Array<UnifiedProductBulkUpdateRequest>}
     * @memberof ProductApiProductsBulkUpdate
     */
    readonly unifiedProductBulkUpdateRequest: Array<UnifiedProductBulkUpdateRequest>
}

/**
 * Request parameters for productsList operation in ProductApi.
 * @export
 * @interface ProductApiProductsListRequest
 */
export interface ProductApiProductsListRequest {
    /**
     * 
     * @type {boolean}
     * @memberof ProductApiProductsList
     */
    readonly archived?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof ProductApiProductsList
     */
    readonly baseUnitsPerUnitIsnull?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof ProductApiProductsList
     */
    readonly batchAssociatedIsnull?: boolean

    /**
     * 
     * @type {number}
     * @memberof ProductApiProductsList
     */
    readonly brand?: number

    /**
     * 
     * @type {number}
     * @memberof ProductApiProductsList
     */
    readonly buyer?: number

    /**
     * 
     * @type {number}
     * @memberof ProductApiProductsList
     */
    readonly category?: number

    /**
     * 
     * @type {number}
     * @memberof ProductApiProductsList
     */
    readonly company?: number

    /**
     * 
     * @type {string}
     * @memberof ProductApiProductsList
     */
    readonly companySlug?: string

    /**
     * 
     * @type {string}
     * @memberof ProductApiProductsList
     */
    readonly createdOnGt?: string

    /**
     * 
     * @type {string}
     * @memberof ProductApiProductsList
     */
    readonly createdOnGte?: string

    /**
     * 
     * @type {string}
     * @memberof ProductApiProductsList
     */
    readonly createdOnLt?: string

    /**
     * 
     * @type {string}
     * @memberof ProductApiProductsList
     */
    readonly createdOnLte?: string

    /**
     * 
     * @type {string}
     * @memberof ProductApiProductsList
     */
    readonly displayName?: string

    /**
     * Multiple values may be separated by commas.
     * @type {Array<number>}
     * @memberof ProductApiProductsList
     */
    readonly externStsIds?: Array<number>

    /**
     * 
     * @type {string}
     * @memberof ProductApiProductsList
     */
    readonly externalIdKey?: string

    /**
     * 
     * @type {boolean}
     * @memberof ProductApiProductsList
     */
    readonly externalIdUnmapped?: boolean

    /**
     * 
     * @type {string}
     * @memberof ProductApiProductsList
     */
    readonly externalIdValues?: string

    /**
     * 
     * @type {string}
     * @memberof ProductApiProductsList
     */
    readonly externalIds?: string

    /**
     * 
     * @type {boolean}
     * @memberof ProductApiProductsList
     */
    readonly hasChildren?: boolean

    /**
     * Multiple values may be separated by commas.
     * @type {Array<number>}
     * @memberof ProductApiProductsList
     */
    readonly id?: Array<number>

    /**
     * 
     * @type {string}
     * @memberof ProductApiProductsList
     */
    readonly lastEditGt?: string

    /**
     * 
     * @type {string}
     * @memberof ProductApiProductsList
     */
    readonly lastEditGte?: string

    /**
     * 
     * @type {string}
     * @memberof ProductApiProductsList
     */
    readonly lastEditLt?: string

    /**
     * 
     * @type {string}
     * @memberof ProductApiProductsList
     */
    readonly lastEditLte?: string

    /**
     * Multiple values may be separated by commas.
     * @type {Array<number>}
     * @memberof ProductApiProductsList
     */
    readonly license?: Array<number>

    /**
     * 
     * @type {boolean}
     * @memberof ProductApiProductsList
     */
    readonly licenseIsnull?: boolean

    /**
     * Multiple values may be separated by commas.
     * @type {Array<number>}
     * @memberof ProductApiProductsList
     */
    readonly licenseType?: Array<number>

    /**
     * 
     * @type {string}
     * @memberof ProductApiProductsList
     */
    readonly listingState?: string

    /**
     * 
     * @type {string}
     * @memberof ProductApiProductsList
     */
    readonly modifiedGt?: string

    /**
     * 
     * @type {string}
     * @memberof ProductApiProductsList
     */
    readonly modifiedGte?: string

    /**
     * 
     * @type {string}
     * @memberof ProductApiProductsList
     */
    readonly modifiedLt?: string

    /**
     * 
     * @type {string}
     * @memberof ProductApiProductsList
     */
    readonly modifiedLte?: string

    /**
     * 
     * @type {string}
     * @memberof ProductApiProductsList
     */
    readonly name?: string

    /**
     * Which field to use when ordering the results.
     * @type {string}
     * @memberof ProductApiProductsList
     */
    readonly ordering?: string

    /**
     * A page number within the paginated result set.
     * @type {number}
     * @memberof ProductApiProductsList
     */
    readonly page?: number

    /**
     * Number of results to return per page.
     * @type {number}
     * @memberof ProductApiProductsList
     */
    readonly pageSize?: number

    /**
     * Multiple values may be separated by commas.
     * @type {Array<number>}
     * @memberof ProductApiProductsList
     */
    readonly parent?: Array<number>

    /**
     * 
     * @type {boolean}
     * @memberof ProductApiProductsList
     */
    readonly parentIsnull?: boolean

    /**
     * Multiple values may be separated by commas.
     * @type {Array<number>}
     * @memberof ProductApiProductsList
     */
    readonly productLine?: Array<number>

    /**
     * 
     * @type {boolean}
     * @memberof ProductApiProductsList
     */
    readonly reconcileInventory?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof ProductApiProductsList
     */
    readonly s2sConnected?: boolean

    /**
     * A search term.
     * @type {string}
     * @memberof ProductApiProductsList
     */
    readonly search?: string

    /**
     * Multiple values may be separated by commas.
     * @type {Array<string>}
     * @memberof ProductApiProductsList
     */
    readonly sku?: Array<string>

    /**
     * Multiple values may be separated by commas.
     * @type {Array<number>}
     * @memberof ProductApiProductsList
     */
    readonly strains?: Array<number>

    /**
     * Multiple values may be separated by commas.
     * @type {Array<number>}
     * @memberof ProductApiProductsList
     */
    readonly subCategory?: Array<number>

    /**
     * 
     * @type {boolean}
     * @memberof ProductApiProductsList
     */
    readonly subCategoryIsnull?: boolean

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof ProductApiProductsList
     */
    readonly leafLinkVersion?: string
}

/**
 * Request parameters for productsRecommendedList operation in ProductApi.
 * @export
 * @interface ProductApiProductsRecommendedListRequest
 */
export interface ProductApiProductsRecommendedListRequest {
    /**
     * The ID of the viewing company
     * @type {number}
     * @memberof ProductApiProductsRecommendedList
     */
    readonly companyId: number

    /**
     * The ID of an ad location
     * @type {'buyer-dash-hero-1' | 'buyer-dash-hero-2' | 'buyer-dash-hero-3' | 'buyer-dash-hero-4' | 'buyer-dash-hero-5' | 'buyer-dash-hero-6' | 'deals-page-1' | 'deals-page-2' | 'deals-page-3' | 'deals-page-4' | 'discovery-left' | 'discovery-right' | 'order-submit-1' | 'order-submit-2' | 'order-submit-3' | 'order-submit-4' | 'product-spotlight-carousel' | 'recommended-brands-recently-purchased' | 'recommended-products-cart' | 'recommended-products-order' | 'recommended-products-pdm-alternative' | 'recommended-products-pdp-alternative' | 'recommended-products-shop-brands' | 'recommended-products-shop-discover-products' | 'recommended-products-shop-products' | 'recommended-products-top-purchased' | 'seller-dash-hero-1' | 'seller-dash-hero-2' | 'seller-dash-hero-3' | 'seller-dash-hero-4' | 'seller-dash-hero-5' | 'seller-dash-hero-6' | 'shop-brands-featured-brand' | 'shop-brands-featured-brand-2' | 'shop-brands-featured-brand-3' | 'shop-brands-featured-brand-4' | 'shop-brands-featured-brand-5' | 'shop-brands-sidebar-3' | 'shop-brands-sidebar-4' | 'shop-brands-sidebar-bottom' | 'shop-brands-sidebar-top' | 'shop-brands-skyscraper-1' | 'shop-brands-skyscraper-2' | 'shop-brands-skyscraper-3' | 'shop-brands-skyscraper-4' | 'shop-products-1' | 'shop-products-2' | 'shop-products-3' | 'shop-products-4' | 'shop-products-5'}
     * @memberof ProductApiProductsRecommendedList
     */
    readonly placement: ProductsRecommendedListPlacementEnum

    /**
     * The number of ads to request
     * @type {number}
     * @memberof ProductApiProductsRecommendedList
     */
    readonly adCount?: number

    /**
     * The brand to restrict recommendations to.
     * @type {string}
     * @memberof ProductApiProductsRecommendedList
     */
    readonly brandId?: string

    /**
     * Filter by category id
     * @type {Array<number>}
     * @memberof ProductApiProductsRecommendedList
     */
    readonly category?: Array<number>

    /**
     * One or more Object IDs
     * @type {Array<number>}
     * @memberof ProductApiProductsRecommendedList
     */
    readonly objectId?: Array<number>

    /**
     * Which field to use when ordering the results.
     * @type {string}
     * @memberof ProductApiProductsRecommendedList
     */
    readonly ordering?: string

    /**
     * A page number within the paginated result set.
     * @type {number}
     * @memberof ProductApiProductsRecommendedList
     */
    readonly page?: number

    /**
     * Number of results to return per page.
     * @type {number}
     * @memberof ProductApiProductsRecommendedList
     */
    readonly pageSize?: number

    /**
     * The number of products to request
     * @type {number}
     * @memberof ProductApiProductsRecommendedList
     */
    readonly productCount?: number

    /**
     * A search term.
     * @type {string}
     * @memberof ProductApiProductsRecommendedList
     */
    readonly search?: string

    /**
     * The product sub-category id to restrict recommendations to.
     * @type {string}
     * @memberof ProductApiProductsRecommendedList
     */
    readonly subcategory?: string

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof ProductApiProductsRecommendedList
     */
    readonly leafLinkVersion?: string
}

/**
 * Request parameters for productsRetrieve operation in ProductApi.
 * @export
 * @interface ProductApiProductsRetrieveRequest
 */
export interface ProductApiProductsRetrieveRequest {
    /**
     * A unique integer value identifying this product.
     * @type {number}
     * @memberof ProductApiProductsRetrieve
     */
    readonly id: number

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof ProductApiProductsRetrieve
     */
    readonly leafLinkVersion?: string
}

/**
 * ProductApi - object-oriented interface
 * @export
 * @class ProductApi
 * @extends {BaseAPI}
 */
export class ProductApi extends BaseAPI {
    /**
     * List new brands, products with deals, and sponsored products on the dashboard.
     * @summary Featured Products
     * @param {ProductApiDashboardProductSpotlightListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductApi
     */
    public dashboardProductSpotlightList(requestParameters: ProductApiDashboardProductSpotlightListRequest, options?: RawAxiosRequestConfig) {
        return ProductApiFp(this.configuration).dashboardProductSpotlightList(requestParameters.companyId, requestParameters.ordering, requestParameters.page, requestParameters.pageSize, requestParameters.search, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List multiple ExpressProductMenus.
     * @summary List Express Product Menus
     * @param {ProductApiExpressMenusListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductApi
     */
    public expressMenusList(requestParameters: ProductApiExpressMenusListRequest = {}, options?: RawAxiosRequestConfig) {
        return ProductApiFp(this.configuration).expressMenusList(requestParameters.brand, requestParameters.ordering, requestParameters.priceSchedule, requestParameters.products, requestParameters.search, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update Multiple Products.
     * @summary Bulk Product Update
     * @param {ProductApiProductsBulkUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductApi
     */
    public productsBulkUpdate(requestParameters: ProductApiProductsBulkUpdateRequest, options?: RawAxiosRequestConfig) {
        return ProductApiFp(this.configuration).productsBulkUpdate(requestParameters.unifiedProductBulkUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List multiple Products.
     * @summary List Products
     * @param {ProductApiProductsListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductApi
     */
    public productsList(requestParameters: ProductApiProductsListRequest = {}, options?: RawAxiosRequestConfig) {
        return ProductApiFp(this.configuration).productsList(requestParameters.archived, requestParameters.baseUnitsPerUnitIsnull, requestParameters.batchAssociatedIsnull, requestParameters.brand, requestParameters.buyer, requestParameters.category, requestParameters.company, requestParameters.companySlug, requestParameters.createdOnGt, requestParameters.createdOnGte, requestParameters.createdOnLt, requestParameters.createdOnLte, requestParameters.displayName, requestParameters.externStsIds, requestParameters.externalIdKey, requestParameters.externalIdUnmapped, requestParameters.externalIdValues, requestParameters.externalIds, requestParameters.hasChildren, requestParameters.id, requestParameters.lastEditGt, requestParameters.lastEditGte, requestParameters.lastEditLt, requestParameters.lastEditLte, requestParameters.license, requestParameters.licenseIsnull, requestParameters.licenseType, requestParameters.listingState, requestParameters.modifiedGt, requestParameters.modifiedGte, requestParameters.modifiedLt, requestParameters.modifiedLte, requestParameters.name, requestParameters.ordering, requestParameters.page, requestParameters.pageSize, requestParameters.parent, requestParameters.parentIsnull, requestParameters.productLine, requestParameters.reconcileInventory, requestParameters.s2sConnected, requestParameters.search, requestParameters.sku, requestParameters.strains, requestParameters.subCategory, requestParameters.subCategoryIsnull, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List product recommendations.
     * @summary Recommended Products
     * @param {ProductApiProductsRecommendedListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductApi
     */
    public productsRecommendedList(requestParameters: ProductApiProductsRecommendedListRequest, options?: RawAxiosRequestConfig) {
        return ProductApiFp(this.configuration).productsRecommendedList(requestParameters.companyId, requestParameters.placement, requestParameters.adCount, requestParameters.brandId, requestParameters.category, requestParameters.objectId, requestParameters.ordering, requestParameters.page, requestParameters.pageSize, requestParameters.productCount, requestParameters.search, requestParameters.subcategory, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a single Product.
     * @summary Get Product
     * @param {ProductApiProductsRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductApi
     */
    public productsRetrieve(requestParameters: ProductApiProductsRetrieveRequest, options?: RawAxiosRequestConfig) {
        return ProductApiFp(this.configuration).productsRetrieve(requestParameters.id, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const ProductsRecommendedListPlacementEnum = {
    BuyerDashHero1: 'buyer-dash-hero-1',
    BuyerDashHero2: 'buyer-dash-hero-2',
    BuyerDashHero3: 'buyer-dash-hero-3',
    BuyerDashHero4: 'buyer-dash-hero-4',
    BuyerDashHero5: 'buyer-dash-hero-5',
    BuyerDashHero6: 'buyer-dash-hero-6',
    DealsPage1: 'deals-page-1',
    DealsPage2: 'deals-page-2',
    DealsPage3: 'deals-page-3',
    DealsPage4: 'deals-page-4',
    DiscoveryLeft: 'discovery-left',
    DiscoveryRight: 'discovery-right',
    OrderSubmit1: 'order-submit-1',
    OrderSubmit2: 'order-submit-2',
    OrderSubmit3: 'order-submit-3',
    OrderSubmit4: 'order-submit-4',
    ProductSpotlightCarousel: 'product-spotlight-carousel',
    RecommendedBrandsRecentlyPurchased: 'recommended-brands-recently-purchased',
    RecommendedProductsCart: 'recommended-products-cart',
    RecommendedProductsOrder: 'recommended-products-order',
    RecommendedProductsPdmAlternative: 'recommended-products-pdm-alternative',
    RecommendedProductsPdpAlternative: 'recommended-products-pdp-alternative',
    RecommendedProductsShopBrands: 'recommended-products-shop-brands',
    RecommendedProductsShopDiscoverProducts: 'recommended-products-shop-discover-products',
    RecommendedProductsShopProducts: 'recommended-products-shop-products',
    RecommendedProductsTopPurchased: 'recommended-products-top-purchased',
    SellerDashHero1: 'seller-dash-hero-1',
    SellerDashHero2: 'seller-dash-hero-2',
    SellerDashHero3: 'seller-dash-hero-3',
    SellerDashHero4: 'seller-dash-hero-4',
    SellerDashHero5: 'seller-dash-hero-5',
    SellerDashHero6: 'seller-dash-hero-6',
    ShopBrandsFeaturedBrand: 'shop-brands-featured-brand',
    ShopBrandsFeaturedBrand2: 'shop-brands-featured-brand-2',
    ShopBrandsFeaturedBrand3: 'shop-brands-featured-brand-3',
    ShopBrandsFeaturedBrand4: 'shop-brands-featured-brand-4',
    ShopBrandsFeaturedBrand5: 'shop-brands-featured-brand-5',
    ShopBrandsSidebar3: 'shop-brands-sidebar-3',
    ShopBrandsSidebar4: 'shop-brands-sidebar-4',
    ShopBrandsSidebarBottom: 'shop-brands-sidebar-bottom',
    ShopBrandsSidebarTop: 'shop-brands-sidebar-top',
    ShopBrandsSkyscraper1: 'shop-brands-skyscraper-1',
    ShopBrandsSkyscraper2: 'shop-brands-skyscraper-2',
    ShopBrandsSkyscraper3: 'shop-brands-skyscraper-3',
    ShopBrandsSkyscraper4: 'shop-brands-skyscraper-4',
    ShopProducts1: 'shop-products-1',
    ShopProducts2: 'shop-products-2',
    ShopProducts3: 'shop-products-3',
    ShopProducts4: 'shop-products-4',
    ShopProducts5: 'shop-products-5'
} as const;
export type ProductsRecommendedListPlacementEnum = typeof ProductsRecommendedListPlacementEnum[keyof typeof ProductsRecommendedListPlacementEnum];


/**
 * ProductCategoryApi - axios parameter creator
 * @export
 */
export const ProductCategoryApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * List multiple product categories.
         * @summary List Product Categories
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productCategoriesList: async (ordering?: string, page?: number, pageSize?: number, search?: string, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/product_categories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a single product category.
         * @summary Get a Product Category
         * @param {number} id A unique integer value identifying this product category.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productCategoriesRetrieve: async (id: number, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('productCategoriesRetrieve', 'id', id)
            const localVarPath = `/product_categories/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProductCategoryApi - functional programming interface
 * @export
 */
export const ProductCategoryApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProductCategoryApiAxiosParamCreator(configuration)
    return {
        /**
         * List multiple product categories.
         * @summary List Product Categories
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productCategoriesList(ordering?: string, page?: number, pageSize?: number, search?: string, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedProductCategoryList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productCategoriesList(ordering, page, pageSize, search, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductCategoryApi.productCategoriesList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a single product category.
         * @summary Get a Product Category
         * @param {number} id A unique integer value identifying this product category.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productCategoriesRetrieve(id: number, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductCategory>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productCategoriesRetrieve(id, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductCategoryApi.productCategoriesRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ProductCategoryApi - factory interface
 * @export
 */
export const ProductCategoryApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProductCategoryApiFp(configuration)
    return {
        /**
         * List multiple product categories.
         * @summary List Product Categories
         * @param {ProductCategoryApiProductCategoriesListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productCategoriesList(requestParameters: ProductCategoryApiProductCategoriesListRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedProductCategoryList> {
            return localVarFp.productCategoriesList(requestParameters.ordering, requestParameters.page, requestParameters.pageSize, requestParameters.search, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a single product category.
         * @summary Get a Product Category
         * @param {ProductCategoryApiProductCategoriesRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productCategoriesRetrieve(requestParameters: ProductCategoryApiProductCategoriesRetrieveRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProductCategory> {
            return localVarFp.productCategoriesRetrieve(requestParameters.id, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for productCategoriesList operation in ProductCategoryApi.
 * @export
 * @interface ProductCategoryApiProductCategoriesListRequest
 */
export interface ProductCategoryApiProductCategoriesListRequest {
    /**
     * Which field to use when ordering the results.
     * @type {string}
     * @memberof ProductCategoryApiProductCategoriesList
     */
    readonly ordering?: string

    /**
     * A page number within the paginated result set.
     * @type {number}
     * @memberof ProductCategoryApiProductCategoriesList
     */
    readonly page?: number

    /**
     * Number of results to return per page.
     * @type {number}
     * @memberof ProductCategoryApiProductCategoriesList
     */
    readonly pageSize?: number

    /**
     * A search term.
     * @type {string}
     * @memberof ProductCategoryApiProductCategoriesList
     */
    readonly search?: string

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof ProductCategoryApiProductCategoriesList
     */
    readonly leafLinkVersion?: string
}

/**
 * Request parameters for productCategoriesRetrieve operation in ProductCategoryApi.
 * @export
 * @interface ProductCategoryApiProductCategoriesRetrieveRequest
 */
export interface ProductCategoryApiProductCategoriesRetrieveRequest {
    /**
     * A unique integer value identifying this product category.
     * @type {number}
     * @memberof ProductCategoryApiProductCategoriesRetrieve
     */
    readonly id: number

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof ProductCategoryApiProductCategoriesRetrieve
     */
    readonly leafLinkVersion?: string
}

/**
 * ProductCategoryApi - object-oriented interface
 * @export
 * @class ProductCategoryApi
 * @extends {BaseAPI}
 */
export class ProductCategoryApi extends BaseAPI {
    /**
     * List multiple product categories.
     * @summary List Product Categories
     * @param {ProductCategoryApiProductCategoriesListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductCategoryApi
     */
    public productCategoriesList(requestParameters: ProductCategoryApiProductCategoriesListRequest = {}, options?: RawAxiosRequestConfig) {
        return ProductCategoryApiFp(this.configuration).productCategoriesList(requestParameters.ordering, requestParameters.page, requestParameters.pageSize, requestParameters.search, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a single product category.
     * @summary Get a Product Category
     * @param {ProductCategoryApiProductCategoriesRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductCategoryApi
     */
    public productCategoriesRetrieve(requestParameters: ProductCategoryApiProductCategoriesRetrieveRequest, options?: RawAxiosRequestConfig) {
        return ProductCategoryApiFp(this.configuration).productCategoriesRetrieve(requestParameters.id, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ProductDosageUnitApi - axios parameter creator
 * @export
 */
export const ProductDosageUnitApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * List all Product Dosage Units
         * @summary List Product Dosage Units
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productDosageUnitsList: async (ordering?: string, page?: number, pageSize?: number, search?: string, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/product_dosage_units`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication tokenAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a Product Dosage Unit by ID
         * @summary Get a Product Dosage Unit
         * @param {number} id A unique integer value identifying this product dosage unit.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productDosageUnitsRetrieve: async (id: number, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('productDosageUnitsRetrieve', 'id', id)
            const localVarPath = `/product_dosage_units/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication tokenAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProductDosageUnitApi - functional programming interface
 * @export
 */
export const ProductDosageUnitApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProductDosageUnitApiAxiosParamCreator(configuration)
    return {
        /**
         * List all Product Dosage Units
         * @summary List Product Dosage Units
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productDosageUnitsList(ordering?: string, page?: number, pageSize?: number, search?: string, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedUnifiedProductDosageUnitList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productDosageUnitsList(ordering, page, pageSize, search, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductDosageUnitApi.productDosageUnitsList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a Product Dosage Unit by ID
         * @summary Get a Product Dosage Unit
         * @param {number} id A unique integer value identifying this product dosage unit.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productDosageUnitsRetrieve(id: number, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnifiedProductDosageUnit>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productDosageUnitsRetrieve(id, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductDosageUnitApi.productDosageUnitsRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ProductDosageUnitApi - factory interface
 * @export
 */
export const ProductDosageUnitApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProductDosageUnitApiFp(configuration)
    return {
        /**
         * List all Product Dosage Units
         * @summary List Product Dosage Units
         * @param {ProductDosageUnitApiProductDosageUnitsListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productDosageUnitsList(requestParameters: ProductDosageUnitApiProductDosageUnitsListRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedUnifiedProductDosageUnitList> {
            return localVarFp.productDosageUnitsList(requestParameters.ordering, requestParameters.page, requestParameters.pageSize, requestParameters.search, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a Product Dosage Unit by ID
         * @summary Get a Product Dosage Unit
         * @param {ProductDosageUnitApiProductDosageUnitsRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productDosageUnitsRetrieve(requestParameters: ProductDosageUnitApiProductDosageUnitsRetrieveRequest, options?: RawAxiosRequestConfig): AxiosPromise<UnifiedProductDosageUnit> {
            return localVarFp.productDosageUnitsRetrieve(requestParameters.id, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for productDosageUnitsList operation in ProductDosageUnitApi.
 * @export
 * @interface ProductDosageUnitApiProductDosageUnitsListRequest
 */
export interface ProductDosageUnitApiProductDosageUnitsListRequest {
    /**
     * Which field to use when ordering the results.
     * @type {string}
     * @memberof ProductDosageUnitApiProductDosageUnitsList
     */
    readonly ordering?: string

    /**
     * A page number within the paginated result set.
     * @type {number}
     * @memberof ProductDosageUnitApiProductDosageUnitsList
     */
    readonly page?: number

    /**
     * Number of results to return per page.
     * @type {number}
     * @memberof ProductDosageUnitApiProductDosageUnitsList
     */
    readonly pageSize?: number

    /**
     * A search term.
     * @type {string}
     * @memberof ProductDosageUnitApiProductDosageUnitsList
     */
    readonly search?: string

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof ProductDosageUnitApiProductDosageUnitsList
     */
    readonly leafLinkVersion?: string
}

/**
 * Request parameters for productDosageUnitsRetrieve operation in ProductDosageUnitApi.
 * @export
 * @interface ProductDosageUnitApiProductDosageUnitsRetrieveRequest
 */
export interface ProductDosageUnitApiProductDosageUnitsRetrieveRequest {
    /**
     * A unique integer value identifying this product dosage unit.
     * @type {number}
     * @memberof ProductDosageUnitApiProductDosageUnitsRetrieve
     */
    readonly id: number

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof ProductDosageUnitApiProductDosageUnitsRetrieve
     */
    readonly leafLinkVersion?: string
}

/**
 * ProductDosageUnitApi - object-oriented interface
 * @export
 * @class ProductDosageUnitApi
 * @extends {BaseAPI}
 */
export class ProductDosageUnitApi extends BaseAPI {
    /**
     * List all Product Dosage Units
     * @summary List Product Dosage Units
     * @param {ProductDosageUnitApiProductDosageUnitsListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductDosageUnitApi
     */
    public productDosageUnitsList(requestParameters: ProductDosageUnitApiProductDosageUnitsListRequest = {}, options?: RawAxiosRequestConfig) {
        return ProductDosageUnitApiFp(this.configuration).productDosageUnitsList(requestParameters.ordering, requestParameters.page, requestParameters.pageSize, requestParameters.search, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a Product Dosage Unit by ID
     * @summary Get a Product Dosage Unit
     * @param {ProductDosageUnitApiProductDosageUnitsRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductDosageUnitApi
     */
    public productDosageUnitsRetrieve(requestParameters: ProductDosageUnitApiProductDosageUnitsRetrieveRequest, options?: RawAxiosRequestConfig) {
        return ProductDosageUnitApiFp(this.configuration).productDosageUnitsRetrieve(requestParameters.id, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ProductGrowOperationTypeApi - axios parameter creator
 * @export
 */
export const ProductGrowOperationTypeApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * List Grow Operation Types.
         * @summary List Grow Operation Types
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {string} [search] A search term.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productGrowOperationTypesList: async (ordering?: string, search?: string, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/product_grow_operation_types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProductGrowOperationTypeApi - functional programming interface
 * @export
 */
export const ProductGrowOperationTypeApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProductGrowOperationTypeApiAxiosParamCreator(configuration)
    return {
        /**
         * List Grow Operation Types.
         * @summary List Grow Operation Types
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {string} [search] A search term.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productGrowOperationTypesList(ordering?: string, search?: string, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Choice>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productGrowOperationTypesList(ordering, search, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductGrowOperationTypeApi.productGrowOperationTypesList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ProductGrowOperationTypeApi - factory interface
 * @export
 */
export const ProductGrowOperationTypeApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProductGrowOperationTypeApiFp(configuration)
    return {
        /**
         * List Grow Operation Types.
         * @summary List Grow Operation Types
         * @param {ProductGrowOperationTypeApiProductGrowOperationTypesListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productGrowOperationTypesList(requestParameters: ProductGrowOperationTypeApiProductGrowOperationTypesListRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<Choice>> {
            return localVarFp.productGrowOperationTypesList(requestParameters.ordering, requestParameters.search, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for productGrowOperationTypesList operation in ProductGrowOperationTypeApi.
 * @export
 * @interface ProductGrowOperationTypeApiProductGrowOperationTypesListRequest
 */
export interface ProductGrowOperationTypeApiProductGrowOperationTypesListRequest {
    /**
     * Which field to use when ordering the results.
     * @type {string}
     * @memberof ProductGrowOperationTypeApiProductGrowOperationTypesList
     */
    readonly ordering?: string

    /**
     * A search term.
     * @type {string}
     * @memberof ProductGrowOperationTypeApiProductGrowOperationTypesList
     */
    readonly search?: string

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof ProductGrowOperationTypeApiProductGrowOperationTypesList
     */
    readonly leafLinkVersion?: string
}

/**
 * ProductGrowOperationTypeApi - object-oriented interface
 * @export
 * @class ProductGrowOperationTypeApi
 * @extends {BaseAPI}
 */
export class ProductGrowOperationTypeApi extends BaseAPI {
    /**
     * List Grow Operation Types.
     * @summary List Grow Operation Types
     * @param {ProductGrowOperationTypeApiProductGrowOperationTypesListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductGrowOperationTypeApi
     */
    public productGrowOperationTypesList(requestParameters: ProductGrowOperationTypeApiProductGrowOperationTypesListRequest = {}, options?: RawAxiosRequestConfig) {
        return ProductGrowOperationTypeApiFp(this.configuration).productGrowOperationTypesList(requestParameters.ordering, requestParameters.search, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ProductImageApi - axios parameter creator
 * @export
 */
export const ProductImageApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * LeafLink API for Marketplace product images.
         * @summary Bulk Create Product Images
         * @param {number} productId Product ID
         * @param {Array<File>} images 
         * @param {Array<number>} positions 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productImagesBulkCreateCreate: async (productId: number, images: Array<File>, positions: Array<number>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('productImagesBulkCreateCreate', 'productId', productId)
            // verify required parameter 'images' is not null or undefined
            assertParamExists('productImagesBulkCreateCreate', 'images', images)
            // verify required parameter 'positions' is not null or undefined
            assertParamExists('productImagesBulkCreateCreate', 'positions', positions)
            const localVarPath = `/product_images/bulk_create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication tokenAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


            if (productId !== undefined) { 
                localVarFormParams.append('product_id', productId as any);
            }
                if (images) {
                images.forEach((element) => {
                    localVarFormParams.append('images', element as any);
                })
            }

                if (positions) {
                localVarFormParams.append('positions', positions.join(COLLECTION_FORMATS.csv));
            }

    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Clone a Product Image via the CloneProductImageService service.
         * @summary Clone Product Image
         * @param {number} id A unique integer value identifying this product image.
         * @param {number} product The Product this image is attached to
         * @param {number} position The position of the image in the product image gallery
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {number | null} [cropX] The X position of the image crop box
         * @param {number | null} [cropY] The Y position of the image crop box
         * @param {number | null} [cropW] The width of the image crop box
         * @param {number | null} [cropH] The height of the image crop box
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productImagesCloneCreate: async (id: number, product: number, position: number, leafLinkVersion?: string, cropX?: number | null, cropY?: number | null, cropW?: number | null, cropH?: number | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('productImagesCloneCreate', 'id', id)
            // verify required parameter 'product' is not null or undefined
            assertParamExists('productImagesCloneCreate', 'product', product)
            // verify required parameter 'position' is not null or undefined
            assertParamExists('productImagesCloneCreate', 'position', position)
            const localVarPath = `/product_images/{id}/clone`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication tokenAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


            if (product !== undefined) { 
                localVarFormParams.append('product', product as any);
            }
    
            if (position !== undefined) { 
                localVarFormParams.append('position', position as any);
            }
    
            if (cropX !== undefined) { 
                localVarFormParams.append('crop_x', cropX as any);
            }
    
            if (cropY !== undefined) { 
                localVarFormParams.append('crop_y', cropY as any);
            }
    
            if (cropW !== undefined) { 
                localVarFormParams.append('crop_w', cropW as any);
            }
    
            if (cropH !== undefined) { 
                localVarFormParams.append('crop_h', cropH as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * LeafLink API for Marketplace product images.
         * @summary Create Product Image
         * @param {File} image The uploaded file, sent via multipart form data. Retrieved as a url link.
         * @param {number} product The Product this image is attached to
         * @param {number} position The position of the image in the product image gallery
         * @param {number | null} [cropX] The X position of the image crop box
         * @param {number | null} [cropY] The Y position of the image crop box
         * @param {number | null} [cropW] The width of the image crop box
         * @param {number | null} [cropH] The height of the image crop box
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productImagesCreate: async (image: File, product: number, position: number, cropX?: number | null, cropY?: number | null, cropW?: number | null, cropH?: number | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'image' is not null or undefined
            assertParamExists('productImagesCreate', 'image', image)
            // verify required parameter 'product' is not null or undefined
            assertParamExists('productImagesCreate', 'product', product)
            // verify required parameter 'position' is not null or undefined
            assertParamExists('productImagesCreate', 'position', position)
            const localVarPath = `/product_images`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication tokenAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


            if (image !== undefined) { 
                localVarFormParams.append('image', image as any);
            }
    
            if (product !== undefined) { 
                localVarFormParams.append('product', product as any);
            }
    
            if (position !== undefined) { 
                localVarFormParams.append('position', position as any);
            }
    
            if (cropX !== undefined) { 
                localVarFormParams.append('crop_x', cropX as any);
            }
    
            if (cropY !== undefined) { 
                localVarFormParams.append('crop_y', cropY as any);
            }
    
            if (cropW !== undefined) { 
                localVarFormParams.append('crop_w', cropW as any);
            }
    
            if (cropH !== undefined) { 
                localVarFormParams.append('crop_h', cropH as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * LeafLink API for Marketplace product images.
         * @summary Delete Product Image
         * @param {number} id A unique integer value identifying this product image.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productImagesDestroy: async (id: number, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('productImagesDestroy', 'id', id)
            const localVarPath = `/product_images/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication tokenAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List multiple Product Images.
         * @summary List Product Images
         * @param {number} [company] 
         * @param {string} [companySlug] 
         * @param {Array<number>} [id] Multiple values may be separated by commas.
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {number} [product] 
         * @param {Array<number>} [productId] Multiple values may be separated by commas.
         * @param {string} [search] A search term.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productImagesList: async (company?: number, companySlug?: string, id?: Array<number>, ordering?: string, page?: number, pageSize?: number, product?: number, productId?: Array<number>, search?: string, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/product_images`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication tokenAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (company !== undefined) {
                localVarQueryParameter['company'] = company;
            }

            if (companySlug !== undefined) {
                localVarQueryParameter['company_slug'] = companySlug;
            }

            if (id) {
                localVarQueryParameter['id'] = id.join(COLLECTION_FORMATS.csv);
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (product !== undefined) {
                localVarQueryParameter['product'] = product;
            }

            if (productId) {
                localVarQueryParameter['product__id'] = productId.join(COLLECTION_FORMATS.csv);
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a single Product Image.
         * @summary Get Product Image
         * @param {number} id A unique integer value identifying this product image.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productImagesRetrieve: async (id: number, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('productImagesRetrieve', 'id', id)
            const localVarPath = `/product_images/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication tokenAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProductImageApi - functional programming interface
 * @export
 */
export const ProductImageApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProductImageApiAxiosParamCreator(configuration)
    return {
        /**
         * LeafLink API for Marketplace product images.
         * @summary Bulk Create Product Images
         * @param {number} productId Product ID
         * @param {Array<File>} images 
         * @param {Array<number>} positions 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productImagesBulkCreateCreate(productId: number, images: Array<File>, positions: Array<number>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnifiedProductBulkCreate>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productImagesBulkCreateCreate(productId, images, positions, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductImageApi.productImagesBulkCreateCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Clone a Product Image via the CloneProductImageService service.
         * @summary Clone Product Image
         * @param {number} id A unique integer value identifying this product image.
         * @param {number} product The Product this image is attached to
         * @param {number} position The position of the image in the product image gallery
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {number | null} [cropX] The X position of the image crop box
         * @param {number | null} [cropY] The Y position of the image crop box
         * @param {number | null} [cropW] The width of the image crop box
         * @param {number | null} [cropH] The height of the image crop box
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productImagesCloneCreate(id: number, product: number, position: number, leafLinkVersion?: string, cropX?: number | null, cropY?: number | null, cropW?: number | null, cropH?: number | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnifiedCloneProductImage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productImagesCloneCreate(id, product, position, leafLinkVersion, cropX, cropY, cropW, cropH, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductImageApi.productImagesCloneCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * LeafLink API for Marketplace product images.
         * @summary Create Product Image
         * @param {File} image The uploaded file, sent via multipart form data. Retrieved as a url link.
         * @param {number} product The Product this image is attached to
         * @param {number} position The position of the image in the product image gallery
         * @param {number | null} [cropX] The X position of the image crop box
         * @param {number | null} [cropY] The Y position of the image crop box
         * @param {number | null} [cropW] The width of the image crop box
         * @param {number | null} [cropH] The height of the image crop box
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productImagesCreate(image: File, product: number, position: number, cropX?: number | null, cropY?: number | null, cropW?: number | null, cropH?: number | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnifiedProductImage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productImagesCreate(image, product, position, cropX, cropY, cropW, cropH, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductImageApi.productImagesCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * LeafLink API for Marketplace product images.
         * @summary Delete Product Image
         * @param {number} id A unique integer value identifying this product image.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productImagesDestroy(id: number, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productImagesDestroy(id, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductImageApi.productImagesDestroy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List multiple Product Images.
         * @summary List Product Images
         * @param {number} [company] 
         * @param {string} [companySlug] 
         * @param {Array<number>} [id] Multiple values may be separated by commas.
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {number} [product] 
         * @param {Array<number>} [productId] Multiple values may be separated by commas.
         * @param {string} [search] A search term.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productImagesList(company?: number, companySlug?: string, id?: Array<number>, ordering?: string, page?: number, pageSize?: number, product?: number, productId?: Array<number>, search?: string, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedUnifiedProductImageList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productImagesList(company, companySlug, id, ordering, page, pageSize, product, productId, search, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductImageApi.productImagesList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a single Product Image.
         * @summary Get Product Image
         * @param {number} id A unique integer value identifying this product image.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productImagesRetrieve(id: number, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnifiedProductImage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productImagesRetrieve(id, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductImageApi.productImagesRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ProductImageApi - factory interface
 * @export
 */
export const ProductImageApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProductImageApiFp(configuration)
    return {
        /**
         * LeafLink API for Marketplace product images.
         * @summary Bulk Create Product Images
         * @param {ProductImageApiProductImagesBulkCreateCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productImagesBulkCreateCreate(requestParameters: ProductImageApiProductImagesBulkCreateCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<UnifiedProductBulkCreate> {
            return localVarFp.productImagesBulkCreateCreate(requestParameters.productId, requestParameters.images, requestParameters.positions, options).then((request) => request(axios, basePath));
        },
        /**
         * Clone a Product Image via the CloneProductImageService service.
         * @summary Clone Product Image
         * @param {ProductImageApiProductImagesCloneCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productImagesCloneCreate(requestParameters: ProductImageApiProductImagesCloneCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<UnifiedCloneProductImage> {
            return localVarFp.productImagesCloneCreate(requestParameters.id, requestParameters.product, requestParameters.position, requestParameters.leafLinkVersion, requestParameters.cropX, requestParameters.cropY, requestParameters.cropW, requestParameters.cropH, options).then((request) => request(axios, basePath));
        },
        /**
         * LeafLink API for Marketplace product images.
         * @summary Create Product Image
         * @param {ProductImageApiProductImagesCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productImagesCreate(requestParameters: ProductImageApiProductImagesCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<UnifiedProductImage> {
            return localVarFp.productImagesCreate(requestParameters.image, requestParameters.product, requestParameters.position, requestParameters.cropX, requestParameters.cropY, requestParameters.cropW, requestParameters.cropH, options).then((request) => request(axios, basePath));
        },
        /**
         * LeafLink API for Marketplace product images.
         * @summary Delete Product Image
         * @param {ProductImageApiProductImagesDestroyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productImagesDestroy(requestParameters: ProductImageApiProductImagesDestroyRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.productImagesDestroy(requestParameters.id, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * List multiple Product Images.
         * @summary List Product Images
         * @param {ProductImageApiProductImagesListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productImagesList(requestParameters: ProductImageApiProductImagesListRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedUnifiedProductImageList> {
            return localVarFp.productImagesList(requestParameters.company, requestParameters.companySlug, requestParameters.id, requestParameters.ordering, requestParameters.page, requestParameters.pageSize, requestParameters.product, requestParameters.productId, requestParameters.search, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a single Product Image.
         * @summary Get Product Image
         * @param {ProductImageApiProductImagesRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productImagesRetrieve(requestParameters: ProductImageApiProductImagesRetrieveRequest, options?: RawAxiosRequestConfig): AxiosPromise<UnifiedProductImage> {
            return localVarFp.productImagesRetrieve(requestParameters.id, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for productImagesBulkCreateCreate operation in ProductImageApi.
 * @export
 * @interface ProductImageApiProductImagesBulkCreateCreateRequest
 */
export interface ProductImageApiProductImagesBulkCreateCreateRequest {
    /**
     * Product ID
     * @type {number}
     * @memberof ProductImageApiProductImagesBulkCreateCreate
     */
    readonly productId: number

    /**
     * 
     * @type {Array<File>}
     * @memberof ProductImageApiProductImagesBulkCreateCreate
     */
    readonly images: Array<File>

    /**
     * 
     * @type {Array<number>}
     * @memberof ProductImageApiProductImagesBulkCreateCreate
     */
    readonly positions: Array<number>
}

/**
 * Request parameters for productImagesCloneCreate operation in ProductImageApi.
 * @export
 * @interface ProductImageApiProductImagesCloneCreateRequest
 */
export interface ProductImageApiProductImagesCloneCreateRequest {
    /**
     * A unique integer value identifying this product image.
     * @type {number}
     * @memberof ProductImageApiProductImagesCloneCreate
     */
    readonly id: number

    /**
     * The Product this image is attached to
     * @type {number}
     * @memberof ProductImageApiProductImagesCloneCreate
     */
    readonly product: number

    /**
     * The position of the image in the product image gallery
     * @type {number}
     * @memberof ProductImageApiProductImagesCloneCreate
     */
    readonly position: number

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof ProductImageApiProductImagesCloneCreate
     */
    readonly leafLinkVersion?: string

    /**
     * The X position of the image crop box
     * @type {number}
     * @memberof ProductImageApiProductImagesCloneCreate
     */
    readonly cropX?: number | null

    /**
     * The Y position of the image crop box
     * @type {number}
     * @memberof ProductImageApiProductImagesCloneCreate
     */
    readonly cropY?: number | null

    /**
     * The width of the image crop box
     * @type {number}
     * @memberof ProductImageApiProductImagesCloneCreate
     */
    readonly cropW?: number | null

    /**
     * The height of the image crop box
     * @type {number}
     * @memberof ProductImageApiProductImagesCloneCreate
     */
    readonly cropH?: number | null
}

/**
 * Request parameters for productImagesCreate operation in ProductImageApi.
 * @export
 * @interface ProductImageApiProductImagesCreateRequest
 */
export interface ProductImageApiProductImagesCreateRequest {
    /**
     * The uploaded file, sent via multipart form data. Retrieved as a url link.
     * @type {File}
     * @memberof ProductImageApiProductImagesCreate
     */
    readonly image: File

    /**
     * The Product this image is attached to
     * @type {number}
     * @memberof ProductImageApiProductImagesCreate
     */
    readonly product: number

    /**
     * The position of the image in the product image gallery
     * @type {number}
     * @memberof ProductImageApiProductImagesCreate
     */
    readonly position: number

    /**
     * The X position of the image crop box
     * @type {number}
     * @memberof ProductImageApiProductImagesCreate
     */
    readonly cropX?: number | null

    /**
     * The Y position of the image crop box
     * @type {number}
     * @memberof ProductImageApiProductImagesCreate
     */
    readonly cropY?: number | null

    /**
     * The width of the image crop box
     * @type {number}
     * @memberof ProductImageApiProductImagesCreate
     */
    readonly cropW?: number | null

    /**
     * The height of the image crop box
     * @type {number}
     * @memberof ProductImageApiProductImagesCreate
     */
    readonly cropH?: number | null
}

/**
 * Request parameters for productImagesDestroy operation in ProductImageApi.
 * @export
 * @interface ProductImageApiProductImagesDestroyRequest
 */
export interface ProductImageApiProductImagesDestroyRequest {
    /**
     * A unique integer value identifying this product image.
     * @type {number}
     * @memberof ProductImageApiProductImagesDestroy
     */
    readonly id: number

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof ProductImageApiProductImagesDestroy
     */
    readonly leafLinkVersion?: string
}

/**
 * Request parameters for productImagesList operation in ProductImageApi.
 * @export
 * @interface ProductImageApiProductImagesListRequest
 */
export interface ProductImageApiProductImagesListRequest {
    /**
     * 
     * @type {number}
     * @memberof ProductImageApiProductImagesList
     */
    readonly company?: number

    /**
     * 
     * @type {string}
     * @memberof ProductImageApiProductImagesList
     */
    readonly companySlug?: string

    /**
     * Multiple values may be separated by commas.
     * @type {Array<number>}
     * @memberof ProductImageApiProductImagesList
     */
    readonly id?: Array<number>

    /**
     * Which field to use when ordering the results.
     * @type {string}
     * @memberof ProductImageApiProductImagesList
     */
    readonly ordering?: string

    /**
     * A page number within the paginated result set.
     * @type {number}
     * @memberof ProductImageApiProductImagesList
     */
    readonly page?: number

    /**
     * Number of results to return per page.
     * @type {number}
     * @memberof ProductImageApiProductImagesList
     */
    readonly pageSize?: number

    /**
     * 
     * @type {number}
     * @memberof ProductImageApiProductImagesList
     */
    readonly product?: number

    /**
     * Multiple values may be separated by commas.
     * @type {Array<number>}
     * @memberof ProductImageApiProductImagesList
     */
    readonly productId?: Array<number>

    /**
     * A search term.
     * @type {string}
     * @memberof ProductImageApiProductImagesList
     */
    readonly search?: string

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof ProductImageApiProductImagesList
     */
    readonly leafLinkVersion?: string
}

/**
 * Request parameters for productImagesRetrieve operation in ProductImageApi.
 * @export
 * @interface ProductImageApiProductImagesRetrieveRequest
 */
export interface ProductImageApiProductImagesRetrieveRequest {
    /**
     * A unique integer value identifying this product image.
     * @type {number}
     * @memberof ProductImageApiProductImagesRetrieve
     */
    readonly id: number

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof ProductImageApiProductImagesRetrieve
     */
    readonly leafLinkVersion?: string
}

/**
 * ProductImageApi - object-oriented interface
 * @export
 * @class ProductImageApi
 * @extends {BaseAPI}
 */
export class ProductImageApi extends BaseAPI {
    /**
     * LeafLink API for Marketplace product images.
     * @summary Bulk Create Product Images
     * @param {ProductImageApiProductImagesBulkCreateCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductImageApi
     */
    public productImagesBulkCreateCreate(requestParameters: ProductImageApiProductImagesBulkCreateCreateRequest, options?: RawAxiosRequestConfig) {
        return ProductImageApiFp(this.configuration).productImagesBulkCreateCreate(requestParameters.productId, requestParameters.images, requestParameters.positions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Clone a Product Image via the CloneProductImageService service.
     * @summary Clone Product Image
     * @param {ProductImageApiProductImagesCloneCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductImageApi
     */
    public productImagesCloneCreate(requestParameters: ProductImageApiProductImagesCloneCreateRequest, options?: RawAxiosRequestConfig) {
        return ProductImageApiFp(this.configuration).productImagesCloneCreate(requestParameters.id, requestParameters.product, requestParameters.position, requestParameters.leafLinkVersion, requestParameters.cropX, requestParameters.cropY, requestParameters.cropW, requestParameters.cropH, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * LeafLink API for Marketplace product images.
     * @summary Create Product Image
     * @param {ProductImageApiProductImagesCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductImageApi
     */
    public productImagesCreate(requestParameters: ProductImageApiProductImagesCreateRequest, options?: RawAxiosRequestConfig) {
        return ProductImageApiFp(this.configuration).productImagesCreate(requestParameters.image, requestParameters.product, requestParameters.position, requestParameters.cropX, requestParameters.cropY, requestParameters.cropW, requestParameters.cropH, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * LeafLink API for Marketplace product images.
     * @summary Delete Product Image
     * @param {ProductImageApiProductImagesDestroyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductImageApi
     */
    public productImagesDestroy(requestParameters: ProductImageApiProductImagesDestroyRequest, options?: RawAxiosRequestConfig) {
        return ProductImageApiFp(this.configuration).productImagesDestroy(requestParameters.id, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List multiple Product Images.
     * @summary List Product Images
     * @param {ProductImageApiProductImagesListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductImageApi
     */
    public productImagesList(requestParameters: ProductImageApiProductImagesListRequest = {}, options?: RawAxiosRequestConfig) {
        return ProductImageApiFp(this.configuration).productImagesList(requestParameters.company, requestParameters.companySlug, requestParameters.id, requestParameters.ordering, requestParameters.page, requestParameters.pageSize, requestParameters.product, requestParameters.productId, requestParameters.search, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a single Product Image.
     * @summary Get Product Image
     * @param {ProductImageApiProductImagesRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductImageApi
     */
    public productImagesRetrieve(requestParameters: ProductImageApiProductImagesRetrieveRequest, options?: RawAxiosRequestConfig) {
        return ProductImageApiFp(this.configuration).productImagesRetrieve(requestParameters.id, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ProductLineApi - axios parameter creator
 * @export
 */
export const ProductLineApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * LeafLink API for Marketplace product lines.
         * @summary Create Product Line
         * @param {UnifiedProductLineCreateRequest} unifiedProductLineCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productLinesCreate: async (unifiedProductLineCreateRequest: UnifiedProductLineCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'unifiedProductLineCreateRequest' is not null or undefined
            assertParamExists('productLinesCreate', 'unifiedProductLineCreateRequest', unifiedProductLineCreateRequest)
            const localVarPath = `/product_lines`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication tokenAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(unifiedProductLineCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * LeafLink API for Marketplace product lines.
         * @summary Delete Product Line
         * @param {number} id A unique integer value identifying this product line.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productLinesDestroy: async (id: number, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('productLinesDestroy', 'id', id)
            const localVarPath = `/product_lines/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication tokenAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List multiple Product Lines.
         * @summary List Product Lines
         * @param {number} [brand] 
         * @param {number} [company] 
         * @param {string} [companySlug] 
         * @param {Array<number>} [id] Multiple values may be separated by commas.
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productLinesList: async (brand?: number, company?: number, companySlug?: string, id?: Array<number>, ordering?: string, page?: number, pageSize?: number, search?: string, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/product_lines`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication tokenAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (brand !== undefined) {
                localVarQueryParameter['brand'] = brand;
            }

            if (company !== undefined) {
                localVarQueryParameter['company'] = company;
            }

            if (companySlug !== undefined) {
                localVarQueryParameter['company_slug'] = companySlug;
            }

            if (id) {
                localVarQueryParameter['id'] = id.join(COLLECTION_FORMATS.csv);
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * LeafLink API for Marketplace product lines.
         * @summary Update Product Line
         * @param {number} id A unique integer value identifying this product line.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {PatchedUnifiedProductLineRequest} [patchedUnifiedProductLineRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productLinesPartialUpdate: async (id: number, leafLinkVersion?: string, patchedUnifiedProductLineRequest?: PatchedUnifiedProductLineRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('productLinesPartialUpdate', 'id', id)
            const localVarPath = `/product_lines/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication tokenAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchedUnifiedProductLineRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a single Product Line.
         * @summary Get Product Line
         * @param {number} id A unique integer value identifying this product line.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productLinesRetrieve: async (id: number, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('productLinesRetrieve', 'id', id)
            const localVarPath = `/product_lines/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication tokenAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProductLineApi - functional programming interface
 * @export
 */
export const ProductLineApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProductLineApiAxiosParamCreator(configuration)
    return {
        /**
         * LeafLink API for Marketplace product lines.
         * @summary Create Product Line
         * @param {UnifiedProductLineCreateRequest} unifiedProductLineCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productLinesCreate(unifiedProductLineCreateRequest: UnifiedProductLineCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnifiedProductLineCreate>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productLinesCreate(unifiedProductLineCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductLineApi.productLinesCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * LeafLink API for Marketplace product lines.
         * @summary Delete Product Line
         * @param {number} id A unique integer value identifying this product line.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productLinesDestroy(id: number, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productLinesDestroy(id, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductLineApi.productLinesDestroy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List multiple Product Lines.
         * @summary List Product Lines
         * @param {number} [brand] 
         * @param {number} [company] 
         * @param {string} [companySlug] 
         * @param {Array<number>} [id] Multiple values may be separated by commas.
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productLinesList(brand?: number, company?: number, companySlug?: string, id?: Array<number>, ordering?: string, page?: number, pageSize?: number, search?: string, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedUnifiedProductLineList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productLinesList(brand, company, companySlug, id, ordering, page, pageSize, search, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductLineApi.productLinesList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * LeafLink API for Marketplace product lines.
         * @summary Update Product Line
         * @param {number} id A unique integer value identifying this product line.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {PatchedUnifiedProductLineRequest} [patchedUnifiedProductLineRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productLinesPartialUpdate(id: number, leafLinkVersion?: string, patchedUnifiedProductLineRequest?: PatchedUnifiedProductLineRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnifiedProductLine>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productLinesPartialUpdate(id, leafLinkVersion, patchedUnifiedProductLineRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductLineApi.productLinesPartialUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a single Product Line.
         * @summary Get Product Line
         * @param {number} id A unique integer value identifying this product line.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productLinesRetrieve(id: number, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnifiedProductLine>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productLinesRetrieve(id, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductLineApi.productLinesRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ProductLineApi - factory interface
 * @export
 */
export const ProductLineApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProductLineApiFp(configuration)
    return {
        /**
         * LeafLink API for Marketplace product lines.
         * @summary Create Product Line
         * @param {ProductLineApiProductLinesCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productLinesCreate(requestParameters: ProductLineApiProductLinesCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<UnifiedProductLineCreate> {
            return localVarFp.productLinesCreate(requestParameters.unifiedProductLineCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * LeafLink API for Marketplace product lines.
         * @summary Delete Product Line
         * @param {ProductLineApiProductLinesDestroyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productLinesDestroy(requestParameters: ProductLineApiProductLinesDestroyRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.productLinesDestroy(requestParameters.id, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * List multiple Product Lines.
         * @summary List Product Lines
         * @param {ProductLineApiProductLinesListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productLinesList(requestParameters: ProductLineApiProductLinesListRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedUnifiedProductLineList> {
            return localVarFp.productLinesList(requestParameters.brand, requestParameters.company, requestParameters.companySlug, requestParameters.id, requestParameters.ordering, requestParameters.page, requestParameters.pageSize, requestParameters.search, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * LeafLink API for Marketplace product lines.
         * @summary Update Product Line
         * @param {ProductLineApiProductLinesPartialUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productLinesPartialUpdate(requestParameters: ProductLineApiProductLinesPartialUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<UnifiedProductLine> {
            return localVarFp.productLinesPartialUpdate(requestParameters.id, requestParameters.leafLinkVersion, requestParameters.patchedUnifiedProductLineRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a single Product Line.
         * @summary Get Product Line
         * @param {ProductLineApiProductLinesRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productLinesRetrieve(requestParameters: ProductLineApiProductLinesRetrieveRequest, options?: RawAxiosRequestConfig): AxiosPromise<UnifiedProductLine> {
            return localVarFp.productLinesRetrieve(requestParameters.id, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for productLinesCreate operation in ProductLineApi.
 * @export
 * @interface ProductLineApiProductLinesCreateRequest
 */
export interface ProductLineApiProductLinesCreateRequest {
    /**
     * 
     * @type {UnifiedProductLineCreateRequest}
     * @memberof ProductLineApiProductLinesCreate
     */
    readonly unifiedProductLineCreateRequest: UnifiedProductLineCreateRequest
}

/**
 * Request parameters for productLinesDestroy operation in ProductLineApi.
 * @export
 * @interface ProductLineApiProductLinesDestroyRequest
 */
export interface ProductLineApiProductLinesDestroyRequest {
    /**
     * A unique integer value identifying this product line.
     * @type {number}
     * @memberof ProductLineApiProductLinesDestroy
     */
    readonly id: number

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof ProductLineApiProductLinesDestroy
     */
    readonly leafLinkVersion?: string
}

/**
 * Request parameters for productLinesList operation in ProductLineApi.
 * @export
 * @interface ProductLineApiProductLinesListRequest
 */
export interface ProductLineApiProductLinesListRequest {
    /**
     * 
     * @type {number}
     * @memberof ProductLineApiProductLinesList
     */
    readonly brand?: number

    /**
     * 
     * @type {number}
     * @memberof ProductLineApiProductLinesList
     */
    readonly company?: number

    /**
     * 
     * @type {string}
     * @memberof ProductLineApiProductLinesList
     */
    readonly companySlug?: string

    /**
     * Multiple values may be separated by commas.
     * @type {Array<number>}
     * @memberof ProductLineApiProductLinesList
     */
    readonly id?: Array<number>

    /**
     * Which field to use when ordering the results.
     * @type {string}
     * @memberof ProductLineApiProductLinesList
     */
    readonly ordering?: string

    /**
     * A page number within the paginated result set.
     * @type {number}
     * @memberof ProductLineApiProductLinesList
     */
    readonly page?: number

    /**
     * Number of results to return per page.
     * @type {number}
     * @memberof ProductLineApiProductLinesList
     */
    readonly pageSize?: number

    /**
     * A search term.
     * @type {string}
     * @memberof ProductLineApiProductLinesList
     */
    readonly search?: string

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof ProductLineApiProductLinesList
     */
    readonly leafLinkVersion?: string
}

/**
 * Request parameters for productLinesPartialUpdate operation in ProductLineApi.
 * @export
 * @interface ProductLineApiProductLinesPartialUpdateRequest
 */
export interface ProductLineApiProductLinesPartialUpdateRequest {
    /**
     * A unique integer value identifying this product line.
     * @type {number}
     * @memberof ProductLineApiProductLinesPartialUpdate
     */
    readonly id: number

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof ProductLineApiProductLinesPartialUpdate
     */
    readonly leafLinkVersion?: string

    /**
     * 
     * @type {PatchedUnifiedProductLineRequest}
     * @memberof ProductLineApiProductLinesPartialUpdate
     */
    readonly patchedUnifiedProductLineRequest?: PatchedUnifiedProductLineRequest
}

/**
 * Request parameters for productLinesRetrieve operation in ProductLineApi.
 * @export
 * @interface ProductLineApiProductLinesRetrieveRequest
 */
export interface ProductLineApiProductLinesRetrieveRequest {
    /**
     * A unique integer value identifying this product line.
     * @type {number}
     * @memberof ProductLineApiProductLinesRetrieve
     */
    readonly id: number

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof ProductLineApiProductLinesRetrieve
     */
    readonly leafLinkVersion?: string
}

/**
 * ProductLineApi - object-oriented interface
 * @export
 * @class ProductLineApi
 * @extends {BaseAPI}
 */
export class ProductLineApi extends BaseAPI {
    /**
     * LeafLink API for Marketplace product lines.
     * @summary Create Product Line
     * @param {ProductLineApiProductLinesCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductLineApi
     */
    public productLinesCreate(requestParameters: ProductLineApiProductLinesCreateRequest, options?: RawAxiosRequestConfig) {
        return ProductLineApiFp(this.configuration).productLinesCreate(requestParameters.unifiedProductLineCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * LeafLink API for Marketplace product lines.
     * @summary Delete Product Line
     * @param {ProductLineApiProductLinesDestroyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductLineApi
     */
    public productLinesDestroy(requestParameters: ProductLineApiProductLinesDestroyRequest, options?: RawAxiosRequestConfig) {
        return ProductLineApiFp(this.configuration).productLinesDestroy(requestParameters.id, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List multiple Product Lines.
     * @summary List Product Lines
     * @param {ProductLineApiProductLinesListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductLineApi
     */
    public productLinesList(requestParameters: ProductLineApiProductLinesListRequest = {}, options?: RawAxiosRequestConfig) {
        return ProductLineApiFp(this.configuration).productLinesList(requestParameters.brand, requestParameters.company, requestParameters.companySlug, requestParameters.id, requestParameters.ordering, requestParameters.page, requestParameters.pageSize, requestParameters.search, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * LeafLink API for Marketplace product lines.
     * @summary Update Product Line
     * @param {ProductLineApiProductLinesPartialUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductLineApi
     */
    public productLinesPartialUpdate(requestParameters: ProductLineApiProductLinesPartialUpdateRequest, options?: RawAxiosRequestConfig) {
        return ProductLineApiFp(this.configuration).productLinesPartialUpdate(requestParameters.id, requestParameters.leafLinkVersion, requestParameters.patchedUnifiedProductLineRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a single Product Line.
     * @summary Get Product Line
     * @param {ProductLineApiProductLinesRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductLineApi
     */
    public productLinesRetrieve(requestParameters: ProductLineApiProductLinesRetrieveRequest, options?: RawAxiosRequestConfig) {
        return ProductLineApiFp(this.configuration).productLinesRetrieve(requestParameters.id, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ProductListingStateApi - axios parameter creator
 * @export
 */
export const ProductListingStateApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * List Listing States.
         * @summary List Listing States
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {string} [search] A search term.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productListingStatesList: async (ordering?: string, search?: string, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/product_listing_states`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProductListingStateApi - functional programming interface
 * @export
 */
export const ProductListingStateApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProductListingStateApiAxiosParamCreator(configuration)
    return {
        /**
         * List Listing States.
         * @summary List Listing States
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {string} [search] A search term.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productListingStatesList(ordering?: string, search?: string, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Choice>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productListingStatesList(ordering, search, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductListingStateApi.productListingStatesList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ProductListingStateApi - factory interface
 * @export
 */
export const ProductListingStateApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProductListingStateApiFp(configuration)
    return {
        /**
         * List Listing States.
         * @summary List Listing States
         * @param {ProductListingStateApiProductListingStatesListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productListingStatesList(requestParameters: ProductListingStateApiProductListingStatesListRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<Choice>> {
            return localVarFp.productListingStatesList(requestParameters.ordering, requestParameters.search, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for productListingStatesList operation in ProductListingStateApi.
 * @export
 * @interface ProductListingStateApiProductListingStatesListRequest
 */
export interface ProductListingStateApiProductListingStatesListRequest {
    /**
     * Which field to use when ordering the results.
     * @type {string}
     * @memberof ProductListingStateApiProductListingStatesList
     */
    readonly ordering?: string

    /**
     * A search term.
     * @type {string}
     * @memberof ProductListingStateApiProductListingStatesList
     */
    readonly search?: string

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof ProductListingStateApiProductListingStatesList
     */
    readonly leafLinkVersion?: string
}

/**
 * ProductListingStateApi - object-oriented interface
 * @export
 * @class ProductListingStateApi
 * @extends {BaseAPI}
 */
export class ProductListingStateApi extends BaseAPI {
    /**
     * List Listing States.
     * @summary List Listing States
     * @param {ProductListingStateApiProductListingStatesListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductListingStateApi
     */
    public productListingStatesList(requestParameters: ProductListingStateApiProductListingStatesListRequest = {}, options?: RawAxiosRequestConfig) {
        return ProductListingStateApiFp(this.configuration).productListingStatesList(requestParameters.ordering, requestParameters.search, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ProductMVPApi - axios parameter creator
 * @export
 */
export const ProductMVPApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Add a Product from a Template.
         * @summary Add Product from Template
         * @param {string} templateId 
         * @param {UnifiedProductMVPRequest} unifiedProductMVPRequest 
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsMvpAddFromTemplateCreate: async (templateId: string, unifiedProductMVPRequest: UnifiedProductMVPRequest, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'templateId' is not null or undefined
            assertParamExists('productsMvpAddFromTemplateCreate', 'templateId', templateId)
            // verify required parameter 'unifiedProductMVPRequest' is not null or undefined
            assertParamExists('productsMvpAddFromTemplateCreate', 'unifiedProductMVPRequest', unifiedProductMVPRequest)
            const localVarPath = `/products_mvp/{template_id}/add_from_template`
                .replace(`{${"template_id"}}`, encodeURIComponent(String(templateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(unifiedProductMVPRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add a Product from a Template.
         * @summary Add Product from Template
         * @param {string} templateId 
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsMvpAddFromTemplateRetrieve: async (templateId: string, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'templateId' is not null or undefined
            assertParamExists('productsMvpAddFromTemplateRetrieve', 'templateId', templateId)
            const localVarPath = `/products_mvp/{template_id}/add_from_template`
                .replace(`{${"template_id"}}`, encodeURIComponent(String(templateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Clone a Product.
         * @summary Clone Product
         * @param {number} id A unique integer value identifying this product.
         * @param {UnifiedProductMVPRequest} unifiedProductMVPRequest 
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsMvpCloneCreate: async (id: number, unifiedProductMVPRequest: UnifiedProductMVPRequest, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('productsMvpCloneCreate', 'id', id)
            // verify required parameter 'unifiedProductMVPRequest' is not null or undefined
            assertParamExists('productsMvpCloneCreate', 'unifiedProductMVPRequest', unifiedProductMVPRequest)
            const localVarPath = `/products_mvp/{id}/clone`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(unifiedProductMVPRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Clone a Product.
         * @summary Clone Product
         * @param {number} id A unique integer value identifying this product.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsMvpCloneRetrieve: async (id: number, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('productsMvpCloneRetrieve', 'id', id)
            const localVarPath = `/products_mvp/{id}/clone`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * LeafLink API for Marketplace products.
         * @summary Create Product
         * @param {UnifiedProductMVPRequest} unifiedProductMVPRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsMvpCreate: async (unifiedProductMVPRequest: UnifiedProductMVPRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'unifiedProductMVPRequest' is not null or undefined
            assertParamExists('productsMvpCreate', 'unifiedProductMVPRequest', unifiedProductMVPRequest)
            const localVarPath = `/products_mvp`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(unifiedProductMVPRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List multiple Products.
         * @summary List Products
         * @param {boolean} [archived] 
         * @param {boolean} [baseUnitsPerUnitIsnull] 
         * @param {boolean} [batchAssociatedIsnull] 
         * @param {number} [brand] 
         * @param {number} [buyer] 
         * @param {number} [category] 
         * @param {number} [company] 
         * @param {string} [companySlug] 
         * @param {string} [createdOnGt] 
         * @param {string} [createdOnGte] 
         * @param {string} [createdOnLt] 
         * @param {string} [createdOnLte] 
         * @param {string} [displayName] 
         * @param {Array<number>} [externStsIds] Multiple values may be separated by commas.
         * @param {string} [externalIdKey] 
         * @param {boolean} [externalIdUnmapped] 
         * @param {string} [externalIdValues] 
         * @param {boolean} [hasChildren] 
         * @param {Array<number>} [id] Multiple values may be separated by commas.
         * @param {string} [lastEditGt] 
         * @param {string} [lastEditGte] 
         * @param {string} [lastEditLt] 
         * @param {string} [lastEditLte] 
         * @param {Array<number>} [license] Multiple values may be separated by commas.
         * @param {boolean} [licenseIsnull] 
         * @param {Array<number>} [licenseType] Multiple values may be separated by commas.
         * @param {string} [listingState] 
         * @param {string} [modifiedGt] 
         * @param {string} [modifiedGte] 
         * @param {string} [modifiedLt] 
         * @param {string} [modifiedLte] 
         * @param {string} [name] 
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {Array<number>} [parent] Multiple values may be separated by commas.
         * @param {boolean} [parentIsnull] 
         * @param {Array<number>} [productLine] Multiple values may be separated by commas.
         * @param {boolean} [reconcileInventory] 
         * @param {boolean} [s2sConnected] 
         * @param {string} [search] A search term.
         * @param {Array<string>} [sku] Multiple values may be separated by commas.
         * @param {Array<number>} [strains] Multiple values may be separated by commas.
         * @param {Array<number>} [subCategory] Multiple values may be separated by commas.
         * @param {boolean} [subCategoryIsnull] 
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsMvpList: async (archived?: boolean, baseUnitsPerUnitIsnull?: boolean, batchAssociatedIsnull?: boolean, brand?: number, buyer?: number, category?: number, company?: number, companySlug?: string, createdOnGt?: string, createdOnGte?: string, createdOnLt?: string, createdOnLte?: string, displayName?: string, externStsIds?: Array<number>, externalIdKey?: string, externalIdUnmapped?: boolean, externalIdValues?: string, hasChildren?: boolean, id?: Array<number>, lastEditGt?: string, lastEditGte?: string, lastEditLt?: string, lastEditLte?: string, license?: Array<number>, licenseIsnull?: boolean, licenseType?: Array<number>, listingState?: string, modifiedGt?: string, modifiedGte?: string, modifiedLt?: string, modifiedLte?: string, name?: string, ordering?: string, page?: number, pageSize?: number, parent?: Array<number>, parentIsnull?: boolean, productLine?: Array<number>, reconcileInventory?: boolean, s2sConnected?: boolean, search?: string, sku?: Array<string>, strains?: Array<number>, subCategory?: Array<number>, subCategoryIsnull?: boolean, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/products_mvp`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (archived !== undefined) {
                localVarQueryParameter['archived'] = archived;
            }

            if (baseUnitsPerUnitIsnull !== undefined) {
                localVarQueryParameter['base_units_per_unit__isnull'] = baseUnitsPerUnitIsnull;
            }

            if (batchAssociatedIsnull !== undefined) {
                localVarQueryParameter['batch_associated__isnull'] = batchAssociatedIsnull;
            }

            if (brand !== undefined) {
                localVarQueryParameter['brand'] = brand;
            }

            if (buyer !== undefined) {
                localVarQueryParameter['buyer'] = buyer;
            }

            if (category !== undefined) {
                localVarQueryParameter['category'] = category;
            }

            if (company !== undefined) {
                localVarQueryParameter['company'] = company;
            }

            if (companySlug !== undefined) {
                localVarQueryParameter['company_slug'] = companySlug;
            }

            if (createdOnGt !== undefined) {
                localVarQueryParameter['created_on__gt'] = (createdOnGt as any instanceof Date) ?
                    (createdOnGt as any).toISOString() :
                    createdOnGt;
            }

            if (createdOnGte !== undefined) {
                localVarQueryParameter['created_on__gte'] = (createdOnGte as any instanceof Date) ?
                    (createdOnGte as any).toISOString() :
                    createdOnGte;
            }

            if (createdOnLt !== undefined) {
                localVarQueryParameter['created_on__lt'] = (createdOnLt as any instanceof Date) ?
                    (createdOnLt as any).toISOString() :
                    createdOnLt;
            }

            if (createdOnLte !== undefined) {
                localVarQueryParameter['created_on__lte'] = (createdOnLte as any instanceof Date) ?
                    (createdOnLte as any).toISOString() :
                    createdOnLte;
            }

            if (displayName !== undefined) {
                localVarQueryParameter['display_name'] = displayName;
            }

            if (externStsIds) {
                localVarQueryParameter['extern_sts_ids'] = externStsIds.join(COLLECTION_FORMATS.csv);
            }

            if (externalIdKey !== undefined) {
                localVarQueryParameter['external_id_key'] = externalIdKey;
            }

            if (externalIdUnmapped !== undefined) {
                localVarQueryParameter['external_id_unmapped'] = externalIdUnmapped;
            }

            if (externalIdValues !== undefined) {
                localVarQueryParameter['external_id_values'] = externalIdValues;
            }

            if (hasChildren !== undefined) {
                localVarQueryParameter['has_children'] = hasChildren;
            }

            if (id) {
                localVarQueryParameter['id'] = id.join(COLLECTION_FORMATS.csv);
            }

            if (lastEditGt !== undefined) {
                localVarQueryParameter['last_edit__gt'] = (lastEditGt as any instanceof Date) ?
                    (lastEditGt as any).toISOString() :
                    lastEditGt;
            }

            if (lastEditGte !== undefined) {
                localVarQueryParameter['last_edit__gte'] = (lastEditGte as any instanceof Date) ?
                    (lastEditGte as any).toISOString() :
                    lastEditGte;
            }

            if (lastEditLt !== undefined) {
                localVarQueryParameter['last_edit__lt'] = (lastEditLt as any instanceof Date) ?
                    (lastEditLt as any).toISOString() :
                    lastEditLt;
            }

            if (lastEditLte !== undefined) {
                localVarQueryParameter['last_edit__lte'] = (lastEditLte as any instanceof Date) ?
                    (lastEditLte as any).toISOString() :
                    lastEditLte;
            }

            if (license) {
                localVarQueryParameter['license'] = license.join(COLLECTION_FORMATS.csv);
            }

            if (licenseIsnull !== undefined) {
                localVarQueryParameter['license__isnull'] = licenseIsnull;
            }

            if (licenseType) {
                localVarQueryParameter['license__type'] = licenseType.join(COLLECTION_FORMATS.csv);
            }

            if (listingState !== undefined) {
                localVarQueryParameter['listing_state'] = listingState;
            }

            if (modifiedGt !== undefined) {
                localVarQueryParameter['modified__gt'] = (modifiedGt as any instanceof Date) ?
                    (modifiedGt as any).toISOString() :
                    modifiedGt;
            }

            if (modifiedGte !== undefined) {
                localVarQueryParameter['modified__gte'] = (modifiedGte as any instanceof Date) ?
                    (modifiedGte as any).toISOString() :
                    modifiedGte;
            }

            if (modifiedLt !== undefined) {
                localVarQueryParameter['modified__lt'] = (modifiedLt as any instanceof Date) ?
                    (modifiedLt as any).toISOString() :
                    modifiedLt;
            }

            if (modifiedLte !== undefined) {
                localVarQueryParameter['modified__lte'] = (modifiedLte as any instanceof Date) ?
                    (modifiedLte as any).toISOString() :
                    modifiedLte;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (parent) {
                localVarQueryParameter['parent'] = parent.join(COLLECTION_FORMATS.csv);
            }

            if (parentIsnull !== undefined) {
                localVarQueryParameter['parent__isnull'] = parentIsnull;
            }

            if (productLine) {
                localVarQueryParameter['product_line'] = productLine.join(COLLECTION_FORMATS.csv);
            }

            if (reconcileInventory !== undefined) {
                localVarQueryParameter['reconcile_inventory'] = reconcileInventory;
            }

            if (s2sConnected !== undefined) {
                localVarQueryParameter['s2s_connected'] = s2sConnected;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (sku) {
                localVarQueryParameter['sku'] = sku.join(COLLECTION_FORMATS.csv);
            }

            if (strains) {
                localVarQueryParameter['strains'] = strains.join(COLLECTION_FORMATS.csv);
            }

            if (subCategory) {
                localVarQueryParameter['sub_category'] = subCategory.join(COLLECTION_FORMATS.csv);
            }

            if (subCategoryIsnull !== undefined) {
                localVarQueryParameter['sub_category__isnull'] = subCategoryIsnull;
            }


    
            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * LeafLink API for Marketplace products.
         * @summary Update Product
         * @param {number} id A unique integer value identifying this product.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {PatchedUnifiedProductMVPRequest} [patchedUnifiedProductMVPRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsMvpPartialUpdate: async (id: number, leafLinkVersion?: string, patchedUnifiedProductMVPRequest?: PatchedUnifiedProductMVPRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('productsMvpPartialUpdate', 'id', id)
            const localVarPath = `/products_mvp/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchedUnifiedProductMVPRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a single Product.
         * @summary Get Product
         * @param {number} id A unique integer value identifying this product.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsMvpRetrieve: async (id: number, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('productsMvpRetrieve', 'id', id)
            const localVarPath = `/products_mvp/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProductMVPApi - functional programming interface
 * @export
 */
export const ProductMVPApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProductMVPApiAxiosParamCreator(configuration)
    return {
        /**
         * Add a Product from a Template.
         * @summary Add Product from Template
         * @param {string} templateId 
         * @param {UnifiedProductMVPRequest} unifiedProductMVPRequest 
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productsMvpAddFromTemplateCreate(templateId: string, unifiedProductMVPRequest: UnifiedProductMVPRequest, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnifiedProductMVP>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productsMvpAddFromTemplateCreate(templateId, unifiedProductMVPRequest, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductMVPApi.productsMvpAddFromTemplateCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Add a Product from a Template.
         * @summary Add Product from Template
         * @param {string} templateId 
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productsMvpAddFromTemplateRetrieve(templateId: string, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnifiedProductMVPFromTemplate>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productsMvpAddFromTemplateRetrieve(templateId, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductMVPApi.productsMvpAddFromTemplateRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Clone a Product.
         * @summary Clone Product
         * @param {number} id A unique integer value identifying this product.
         * @param {UnifiedProductMVPRequest} unifiedProductMVPRequest 
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productsMvpCloneCreate(id: number, unifiedProductMVPRequest: UnifiedProductMVPRequest, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnifiedProductMVP>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productsMvpCloneCreate(id, unifiedProductMVPRequest, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductMVPApi.productsMvpCloneCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Clone a Product.
         * @summary Clone Product
         * @param {number} id A unique integer value identifying this product.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productsMvpCloneRetrieve(id: number, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnifiedProductMVP>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productsMvpCloneRetrieve(id, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductMVPApi.productsMvpCloneRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * LeafLink API for Marketplace products.
         * @summary Create Product
         * @param {UnifiedProductMVPRequest} unifiedProductMVPRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productsMvpCreate(unifiedProductMVPRequest: UnifiedProductMVPRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnifiedProductMVP>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productsMvpCreate(unifiedProductMVPRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductMVPApi.productsMvpCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List multiple Products.
         * @summary List Products
         * @param {boolean} [archived] 
         * @param {boolean} [baseUnitsPerUnitIsnull] 
         * @param {boolean} [batchAssociatedIsnull] 
         * @param {number} [brand] 
         * @param {number} [buyer] 
         * @param {number} [category] 
         * @param {number} [company] 
         * @param {string} [companySlug] 
         * @param {string} [createdOnGt] 
         * @param {string} [createdOnGte] 
         * @param {string} [createdOnLt] 
         * @param {string} [createdOnLte] 
         * @param {string} [displayName] 
         * @param {Array<number>} [externStsIds] Multiple values may be separated by commas.
         * @param {string} [externalIdKey] 
         * @param {boolean} [externalIdUnmapped] 
         * @param {string} [externalIdValues] 
         * @param {boolean} [hasChildren] 
         * @param {Array<number>} [id] Multiple values may be separated by commas.
         * @param {string} [lastEditGt] 
         * @param {string} [lastEditGte] 
         * @param {string} [lastEditLt] 
         * @param {string} [lastEditLte] 
         * @param {Array<number>} [license] Multiple values may be separated by commas.
         * @param {boolean} [licenseIsnull] 
         * @param {Array<number>} [licenseType] Multiple values may be separated by commas.
         * @param {string} [listingState] 
         * @param {string} [modifiedGt] 
         * @param {string} [modifiedGte] 
         * @param {string} [modifiedLt] 
         * @param {string} [modifiedLte] 
         * @param {string} [name] 
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {Array<number>} [parent] Multiple values may be separated by commas.
         * @param {boolean} [parentIsnull] 
         * @param {Array<number>} [productLine] Multiple values may be separated by commas.
         * @param {boolean} [reconcileInventory] 
         * @param {boolean} [s2sConnected] 
         * @param {string} [search] A search term.
         * @param {Array<string>} [sku] Multiple values may be separated by commas.
         * @param {Array<number>} [strains] Multiple values may be separated by commas.
         * @param {Array<number>} [subCategory] Multiple values may be separated by commas.
         * @param {boolean} [subCategoryIsnull] 
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productsMvpList(archived?: boolean, baseUnitsPerUnitIsnull?: boolean, batchAssociatedIsnull?: boolean, brand?: number, buyer?: number, category?: number, company?: number, companySlug?: string, createdOnGt?: string, createdOnGte?: string, createdOnLt?: string, createdOnLte?: string, displayName?: string, externStsIds?: Array<number>, externalIdKey?: string, externalIdUnmapped?: boolean, externalIdValues?: string, hasChildren?: boolean, id?: Array<number>, lastEditGt?: string, lastEditGte?: string, lastEditLt?: string, lastEditLte?: string, license?: Array<number>, licenseIsnull?: boolean, licenseType?: Array<number>, listingState?: string, modifiedGt?: string, modifiedGte?: string, modifiedLt?: string, modifiedLte?: string, name?: string, ordering?: string, page?: number, pageSize?: number, parent?: Array<number>, parentIsnull?: boolean, productLine?: Array<number>, reconcileInventory?: boolean, s2sConnected?: boolean, search?: string, sku?: Array<string>, strains?: Array<number>, subCategory?: Array<number>, subCategoryIsnull?: boolean, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedUnifiedProductMVPList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productsMvpList(archived, baseUnitsPerUnitIsnull, batchAssociatedIsnull, brand, buyer, category, company, companySlug, createdOnGt, createdOnGte, createdOnLt, createdOnLte, displayName, externStsIds, externalIdKey, externalIdUnmapped, externalIdValues, hasChildren, id, lastEditGt, lastEditGte, lastEditLt, lastEditLte, license, licenseIsnull, licenseType, listingState, modifiedGt, modifiedGte, modifiedLt, modifiedLte, name, ordering, page, pageSize, parent, parentIsnull, productLine, reconcileInventory, s2sConnected, search, sku, strains, subCategory, subCategoryIsnull, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductMVPApi.productsMvpList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * LeafLink API for Marketplace products.
         * @summary Update Product
         * @param {number} id A unique integer value identifying this product.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {PatchedUnifiedProductMVPRequest} [patchedUnifiedProductMVPRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productsMvpPartialUpdate(id: number, leafLinkVersion?: string, patchedUnifiedProductMVPRequest?: PatchedUnifiedProductMVPRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnifiedProductMVP>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productsMvpPartialUpdate(id, leafLinkVersion, patchedUnifiedProductMVPRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductMVPApi.productsMvpPartialUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a single Product.
         * @summary Get Product
         * @param {number} id A unique integer value identifying this product.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productsMvpRetrieve(id: number, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnifiedProductMVP>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productsMvpRetrieve(id, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductMVPApi.productsMvpRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ProductMVPApi - factory interface
 * @export
 */
export const ProductMVPApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProductMVPApiFp(configuration)
    return {
        /**
         * Add a Product from a Template.
         * @summary Add Product from Template
         * @param {ProductMVPApiProductsMvpAddFromTemplateCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsMvpAddFromTemplateCreate(requestParameters: ProductMVPApiProductsMvpAddFromTemplateCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<UnifiedProductMVP> {
            return localVarFp.productsMvpAddFromTemplateCreate(requestParameters.templateId, requestParameters.unifiedProductMVPRequest, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * Add a Product from a Template.
         * @summary Add Product from Template
         * @param {ProductMVPApiProductsMvpAddFromTemplateRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsMvpAddFromTemplateRetrieve(requestParameters: ProductMVPApiProductsMvpAddFromTemplateRetrieveRequest, options?: RawAxiosRequestConfig): AxiosPromise<UnifiedProductMVPFromTemplate> {
            return localVarFp.productsMvpAddFromTemplateRetrieve(requestParameters.templateId, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * Clone a Product.
         * @summary Clone Product
         * @param {ProductMVPApiProductsMvpCloneCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsMvpCloneCreate(requestParameters: ProductMVPApiProductsMvpCloneCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<UnifiedProductMVP> {
            return localVarFp.productsMvpCloneCreate(requestParameters.id, requestParameters.unifiedProductMVPRequest, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * Clone a Product.
         * @summary Clone Product
         * @param {ProductMVPApiProductsMvpCloneRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsMvpCloneRetrieve(requestParameters: ProductMVPApiProductsMvpCloneRetrieveRequest, options?: RawAxiosRequestConfig): AxiosPromise<UnifiedProductMVP> {
            return localVarFp.productsMvpCloneRetrieve(requestParameters.id, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * LeafLink API for Marketplace products.
         * @summary Create Product
         * @param {ProductMVPApiProductsMvpCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsMvpCreate(requestParameters: ProductMVPApiProductsMvpCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<UnifiedProductMVP> {
            return localVarFp.productsMvpCreate(requestParameters.unifiedProductMVPRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * List multiple Products.
         * @summary List Products
         * @param {ProductMVPApiProductsMvpListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsMvpList(requestParameters: ProductMVPApiProductsMvpListRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedUnifiedProductMVPList> {
            return localVarFp.productsMvpList(requestParameters.archived, requestParameters.baseUnitsPerUnitIsnull, requestParameters.batchAssociatedIsnull, requestParameters.brand, requestParameters.buyer, requestParameters.category, requestParameters.company, requestParameters.companySlug, requestParameters.createdOnGt, requestParameters.createdOnGte, requestParameters.createdOnLt, requestParameters.createdOnLte, requestParameters.displayName, requestParameters.externStsIds, requestParameters.externalIdKey, requestParameters.externalIdUnmapped, requestParameters.externalIdValues, requestParameters.hasChildren, requestParameters.id, requestParameters.lastEditGt, requestParameters.lastEditGte, requestParameters.lastEditLt, requestParameters.lastEditLte, requestParameters.license, requestParameters.licenseIsnull, requestParameters.licenseType, requestParameters.listingState, requestParameters.modifiedGt, requestParameters.modifiedGte, requestParameters.modifiedLt, requestParameters.modifiedLte, requestParameters.name, requestParameters.ordering, requestParameters.page, requestParameters.pageSize, requestParameters.parent, requestParameters.parentIsnull, requestParameters.productLine, requestParameters.reconcileInventory, requestParameters.s2sConnected, requestParameters.search, requestParameters.sku, requestParameters.strains, requestParameters.subCategory, requestParameters.subCategoryIsnull, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * LeafLink API for Marketplace products.
         * @summary Update Product
         * @param {ProductMVPApiProductsMvpPartialUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsMvpPartialUpdate(requestParameters: ProductMVPApiProductsMvpPartialUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<UnifiedProductMVP> {
            return localVarFp.productsMvpPartialUpdate(requestParameters.id, requestParameters.leafLinkVersion, requestParameters.patchedUnifiedProductMVPRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a single Product.
         * @summary Get Product
         * @param {ProductMVPApiProductsMvpRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsMvpRetrieve(requestParameters: ProductMVPApiProductsMvpRetrieveRequest, options?: RawAxiosRequestConfig): AxiosPromise<UnifiedProductMVP> {
            return localVarFp.productsMvpRetrieve(requestParameters.id, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for productsMvpAddFromTemplateCreate operation in ProductMVPApi.
 * @export
 * @interface ProductMVPApiProductsMvpAddFromTemplateCreateRequest
 */
export interface ProductMVPApiProductsMvpAddFromTemplateCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof ProductMVPApiProductsMvpAddFromTemplateCreate
     */
    readonly templateId: string

    /**
     * 
     * @type {UnifiedProductMVPRequest}
     * @memberof ProductMVPApiProductsMvpAddFromTemplateCreate
     */
    readonly unifiedProductMVPRequest: UnifiedProductMVPRequest

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof ProductMVPApiProductsMvpAddFromTemplateCreate
     */
    readonly leafLinkVersion?: string
}

/**
 * Request parameters for productsMvpAddFromTemplateRetrieve operation in ProductMVPApi.
 * @export
 * @interface ProductMVPApiProductsMvpAddFromTemplateRetrieveRequest
 */
export interface ProductMVPApiProductsMvpAddFromTemplateRetrieveRequest {
    /**
     * 
     * @type {string}
     * @memberof ProductMVPApiProductsMvpAddFromTemplateRetrieve
     */
    readonly templateId: string

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof ProductMVPApiProductsMvpAddFromTemplateRetrieve
     */
    readonly leafLinkVersion?: string
}

/**
 * Request parameters for productsMvpCloneCreate operation in ProductMVPApi.
 * @export
 * @interface ProductMVPApiProductsMvpCloneCreateRequest
 */
export interface ProductMVPApiProductsMvpCloneCreateRequest {
    /**
     * A unique integer value identifying this product.
     * @type {number}
     * @memberof ProductMVPApiProductsMvpCloneCreate
     */
    readonly id: number

    /**
     * 
     * @type {UnifiedProductMVPRequest}
     * @memberof ProductMVPApiProductsMvpCloneCreate
     */
    readonly unifiedProductMVPRequest: UnifiedProductMVPRequest

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof ProductMVPApiProductsMvpCloneCreate
     */
    readonly leafLinkVersion?: string
}

/**
 * Request parameters for productsMvpCloneRetrieve operation in ProductMVPApi.
 * @export
 * @interface ProductMVPApiProductsMvpCloneRetrieveRequest
 */
export interface ProductMVPApiProductsMvpCloneRetrieveRequest {
    /**
     * A unique integer value identifying this product.
     * @type {number}
     * @memberof ProductMVPApiProductsMvpCloneRetrieve
     */
    readonly id: number

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof ProductMVPApiProductsMvpCloneRetrieve
     */
    readonly leafLinkVersion?: string
}

/**
 * Request parameters for productsMvpCreate operation in ProductMVPApi.
 * @export
 * @interface ProductMVPApiProductsMvpCreateRequest
 */
export interface ProductMVPApiProductsMvpCreateRequest {
    /**
     * 
     * @type {UnifiedProductMVPRequest}
     * @memberof ProductMVPApiProductsMvpCreate
     */
    readonly unifiedProductMVPRequest: UnifiedProductMVPRequest
}

/**
 * Request parameters for productsMvpList operation in ProductMVPApi.
 * @export
 * @interface ProductMVPApiProductsMvpListRequest
 */
export interface ProductMVPApiProductsMvpListRequest {
    /**
     * 
     * @type {boolean}
     * @memberof ProductMVPApiProductsMvpList
     */
    readonly archived?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof ProductMVPApiProductsMvpList
     */
    readonly baseUnitsPerUnitIsnull?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof ProductMVPApiProductsMvpList
     */
    readonly batchAssociatedIsnull?: boolean

    /**
     * 
     * @type {number}
     * @memberof ProductMVPApiProductsMvpList
     */
    readonly brand?: number

    /**
     * 
     * @type {number}
     * @memberof ProductMVPApiProductsMvpList
     */
    readonly buyer?: number

    /**
     * 
     * @type {number}
     * @memberof ProductMVPApiProductsMvpList
     */
    readonly category?: number

    /**
     * 
     * @type {number}
     * @memberof ProductMVPApiProductsMvpList
     */
    readonly company?: number

    /**
     * 
     * @type {string}
     * @memberof ProductMVPApiProductsMvpList
     */
    readonly companySlug?: string

    /**
     * 
     * @type {string}
     * @memberof ProductMVPApiProductsMvpList
     */
    readonly createdOnGt?: string

    /**
     * 
     * @type {string}
     * @memberof ProductMVPApiProductsMvpList
     */
    readonly createdOnGte?: string

    /**
     * 
     * @type {string}
     * @memberof ProductMVPApiProductsMvpList
     */
    readonly createdOnLt?: string

    /**
     * 
     * @type {string}
     * @memberof ProductMVPApiProductsMvpList
     */
    readonly createdOnLte?: string

    /**
     * 
     * @type {string}
     * @memberof ProductMVPApiProductsMvpList
     */
    readonly displayName?: string

    /**
     * Multiple values may be separated by commas.
     * @type {Array<number>}
     * @memberof ProductMVPApiProductsMvpList
     */
    readonly externStsIds?: Array<number>

    /**
     * 
     * @type {string}
     * @memberof ProductMVPApiProductsMvpList
     */
    readonly externalIdKey?: string

    /**
     * 
     * @type {boolean}
     * @memberof ProductMVPApiProductsMvpList
     */
    readonly externalIdUnmapped?: boolean

    /**
     * 
     * @type {string}
     * @memberof ProductMVPApiProductsMvpList
     */
    readonly externalIdValues?: string

    /**
     * 
     * @type {boolean}
     * @memberof ProductMVPApiProductsMvpList
     */
    readonly hasChildren?: boolean

    /**
     * Multiple values may be separated by commas.
     * @type {Array<number>}
     * @memberof ProductMVPApiProductsMvpList
     */
    readonly id?: Array<number>

    /**
     * 
     * @type {string}
     * @memberof ProductMVPApiProductsMvpList
     */
    readonly lastEditGt?: string

    /**
     * 
     * @type {string}
     * @memberof ProductMVPApiProductsMvpList
     */
    readonly lastEditGte?: string

    /**
     * 
     * @type {string}
     * @memberof ProductMVPApiProductsMvpList
     */
    readonly lastEditLt?: string

    /**
     * 
     * @type {string}
     * @memberof ProductMVPApiProductsMvpList
     */
    readonly lastEditLte?: string

    /**
     * Multiple values may be separated by commas.
     * @type {Array<number>}
     * @memberof ProductMVPApiProductsMvpList
     */
    readonly license?: Array<number>

    /**
     * 
     * @type {boolean}
     * @memberof ProductMVPApiProductsMvpList
     */
    readonly licenseIsnull?: boolean

    /**
     * Multiple values may be separated by commas.
     * @type {Array<number>}
     * @memberof ProductMVPApiProductsMvpList
     */
    readonly licenseType?: Array<number>

    /**
     * 
     * @type {string}
     * @memberof ProductMVPApiProductsMvpList
     */
    readonly listingState?: string

    /**
     * 
     * @type {string}
     * @memberof ProductMVPApiProductsMvpList
     */
    readonly modifiedGt?: string

    /**
     * 
     * @type {string}
     * @memberof ProductMVPApiProductsMvpList
     */
    readonly modifiedGte?: string

    /**
     * 
     * @type {string}
     * @memberof ProductMVPApiProductsMvpList
     */
    readonly modifiedLt?: string

    /**
     * 
     * @type {string}
     * @memberof ProductMVPApiProductsMvpList
     */
    readonly modifiedLte?: string

    /**
     * 
     * @type {string}
     * @memberof ProductMVPApiProductsMvpList
     */
    readonly name?: string

    /**
     * Which field to use when ordering the results.
     * @type {string}
     * @memberof ProductMVPApiProductsMvpList
     */
    readonly ordering?: string

    /**
     * A page number within the paginated result set.
     * @type {number}
     * @memberof ProductMVPApiProductsMvpList
     */
    readonly page?: number

    /**
     * Number of results to return per page.
     * @type {number}
     * @memberof ProductMVPApiProductsMvpList
     */
    readonly pageSize?: number

    /**
     * Multiple values may be separated by commas.
     * @type {Array<number>}
     * @memberof ProductMVPApiProductsMvpList
     */
    readonly parent?: Array<number>

    /**
     * 
     * @type {boolean}
     * @memberof ProductMVPApiProductsMvpList
     */
    readonly parentIsnull?: boolean

    /**
     * Multiple values may be separated by commas.
     * @type {Array<number>}
     * @memberof ProductMVPApiProductsMvpList
     */
    readonly productLine?: Array<number>

    /**
     * 
     * @type {boolean}
     * @memberof ProductMVPApiProductsMvpList
     */
    readonly reconcileInventory?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof ProductMVPApiProductsMvpList
     */
    readonly s2sConnected?: boolean

    /**
     * A search term.
     * @type {string}
     * @memberof ProductMVPApiProductsMvpList
     */
    readonly search?: string

    /**
     * Multiple values may be separated by commas.
     * @type {Array<string>}
     * @memberof ProductMVPApiProductsMvpList
     */
    readonly sku?: Array<string>

    /**
     * Multiple values may be separated by commas.
     * @type {Array<number>}
     * @memberof ProductMVPApiProductsMvpList
     */
    readonly strains?: Array<number>

    /**
     * Multiple values may be separated by commas.
     * @type {Array<number>}
     * @memberof ProductMVPApiProductsMvpList
     */
    readonly subCategory?: Array<number>

    /**
     * 
     * @type {boolean}
     * @memberof ProductMVPApiProductsMvpList
     */
    readonly subCategoryIsnull?: boolean

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof ProductMVPApiProductsMvpList
     */
    readonly leafLinkVersion?: string
}

/**
 * Request parameters for productsMvpPartialUpdate operation in ProductMVPApi.
 * @export
 * @interface ProductMVPApiProductsMvpPartialUpdateRequest
 */
export interface ProductMVPApiProductsMvpPartialUpdateRequest {
    /**
     * A unique integer value identifying this product.
     * @type {number}
     * @memberof ProductMVPApiProductsMvpPartialUpdate
     */
    readonly id: number

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof ProductMVPApiProductsMvpPartialUpdate
     */
    readonly leafLinkVersion?: string

    /**
     * 
     * @type {PatchedUnifiedProductMVPRequest}
     * @memberof ProductMVPApiProductsMvpPartialUpdate
     */
    readonly patchedUnifiedProductMVPRequest?: PatchedUnifiedProductMVPRequest
}

/**
 * Request parameters for productsMvpRetrieve operation in ProductMVPApi.
 * @export
 * @interface ProductMVPApiProductsMvpRetrieveRequest
 */
export interface ProductMVPApiProductsMvpRetrieveRequest {
    /**
     * A unique integer value identifying this product.
     * @type {number}
     * @memberof ProductMVPApiProductsMvpRetrieve
     */
    readonly id: number

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof ProductMVPApiProductsMvpRetrieve
     */
    readonly leafLinkVersion?: string
}

/**
 * ProductMVPApi - object-oriented interface
 * @export
 * @class ProductMVPApi
 * @extends {BaseAPI}
 */
export class ProductMVPApi extends BaseAPI {
    /**
     * Add a Product from a Template.
     * @summary Add Product from Template
     * @param {ProductMVPApiProductsMvpAddFromTemplateCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductMVPApi
     */
    public productsMvpAddFromTemplateCreate(requestParameters: ProductMVPApiProductsMvpAddFromTemplateCreateRequest, options?: RawAxiosRequestConfig) {
        return ProductMVPApiFp(this.configuration).productsMvpAddFromTemplateCreate(requestParameters.templateId, requestParameters.unifiedProductMVPRequest, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add a Product from a Template.
     * @summary Add Product from Template
     * @param {ProductMVPApiProductsMvpAddFromTemplateRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductMVPApi
     */
    public productsMvpAddFromTemplateRetrieve(requestParameters: ProductMVPApiProductsMvpAddFromTemplateRetrieveRequest, options?: RawAxiosRequestConfig) {
        return ProductMVPApiFp(this.configuration).productsMvpAddFromTemplateRetrieve(requestParameters.templateId, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Clone a Product.
     * @summary Clone Product
     * @param {ProductMVPApiProductsMvpCloneCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductMVPApi
     */
    public productsMvpCloneCreate(requestParameters: ProductMVPApiProductsMvpCloneCreateRequest, options?: RawAxiosRequestConfig) {
        return ProductMVPApiFp(this.configuration).productsMvpCloneCreate(requestParameters.id, requestParameters.unifiedProductMVPRequest, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Clone a Product.
     * @summary Clone Product
     * @param {ProductMVPApiProductsMvpCloneRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductMVPApi
     */
    public productsMvpCloneRetrieve(requestParameters: ProductMVPApiProductsMvpCloneRetrieveRequest, options?: RawAxiosRequestConfig) {
        return ProductMVPApiFp(this.configuration).productsMvpCloneRetrieve(requestParameters.id, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * LeafLink API for Marketplace products.
     * @summary Create Product
     * @param {ProductMVPApiProductsMvpCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductMVPApi
     */
    public productsMvpCreate(requestParameters: ProductMVPApiProductsMvpCreateRequest, options?: RawAxiosRequestConfig) {
        return ProductMVPApiFp(this.configuration).productsMvpCreate(requestParameters.unifiedProductMVPRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List multiple Products.
     * @summary List Products
     * @param {ProductMVPApiProductsMvpListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductMVPApi
     */
    public productsMvpList(requestParameters: ProductMVPApiProductsMvpListRequest = {}, options?: RawAxiosRequestConfig) {
        return ProductMVPApiFp(this.configuration).productsMvpList(requestParameters.archived, requestParameters.baseUnitsPerUnitIsnull, requestParameters.batchAssociatedIsnull, requestParameters.brand, requestParameters.buyer, requestParameters.category, requestParameters.company, requestParameters.companySlug, requestParameters.createdOnGt, requestParameters.createdOnGte, requestParameters.createdOnLt, requestParameters.createdOnLte, requestParameters.displayName, requestParameters.externStsIds, requestParameters.externalIdKey, requestParameters.externalIdUnmapped, requestParameters.externalIdValues, requestParameters.hasChildren, requestParameters.id, requestParameters.lastEditGt, requestParameters.lastEditGte, requestParameters.lastEditLt, requestParameters.lastEditLte, requestParameters.license, requestParameters.licenseIsnull, requestParameters.licenseType, requestParameters.listingState, requestParameters.modifiedGt, requestParameters.modifiedGte, requestParameters.modifiedLt, requestParameters.modifiedLte, requestParameters.name, requestParameters.ordering, requestParameters.page, requestParameters.pageSize, requestParameters.parent, requestParameters.parentIsnull, requestParameters.productLine, requestParameters.reconcileInventory, requestParameters.s2sConnected, requestParameters.search, requestParameters.sku, requestParameters.strains, requestParameters.subCategory, requestParameters.subCategoryIsnull, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * LeafLink API for Marketplace products.
     * @summary Update Product
     * @param {ProductMVPApiProductsMvpPartialUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductMVPApi
     */
    public productsMvpPartialUpdate(requestParameters: ProductMVPApiProductsMvpPartialUpdateRequest, options?: RawAxiosRequestConfig) {
        return ProductMVPApiFp(this.configuration).productsMvpPartialUpdate(requestParameters.id, requestParameters.leafLinkVersion, requestParameters.patchedUnifiedProductMVPRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a single Product.
     * @summary Get Product
     * @param {ProductMVPApiProductsMvpRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductMVPApi
     */
    public productsMvpRetrieve(requestParameters: ProductMVPApiProductsMvpRetrieveRequest, options?: RawAxiosRequestConfig) {
        return ProductMVPApiFp(this.configuration).productsMvpRetrieve(requestParameters.id, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ProductPromotionApi - axios parameter creator
 * @export
 */
export const ProductPromotionApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create a product promotion.
         * @summary Create a Product Promotion
         * @param {ProductPromotionRequest} productPromotionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productPromotionsCreate: async (productPromotionRequest: ProductPromotionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productPromotionRequest' is not null or undefined
            assertParamExists('productPromotionsCreate', 'productPromotionRequest', productPromotionRequest)
            const localVarPath = `/product_promotions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(productPromotionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List multiple product promotions.
         * @summary List Product Promotions
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productPromotionsList: async (ordering?: string, page?: number, pageSize?: number, search?: string, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/product_promotions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a product promotion.
         * @summary Update a Product Promotion
         * @param {string} id 
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {PatchedProductPromotionRequest} [patchedProductPromotionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productPromotionsPartialUpdate: async (id: string, leafLinkVersion?: string, patchedProductPromotionRequest?: PatchedProductPromotionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('productPromotionsPartialUpdate', 'id', id)
            const localVarPath = `/product_promotions/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchedProductPromotionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a single product promotion.
         * @summary Get a Product Promotion
         * @param {string} id 
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productPromotionsRetrieve: async (id: string, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('productPromotionsRetrieve', 'id', id)
            const localVarPath = `/product_promotions/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProductPromotionApi - functional programming interface
 * @export
 */
export const ProductPromotionApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProductPromotionApiAxiosParamCreator(configuration)
    return {
        /**
         * Create a product promotion.
         * @summary Create a Product Promotion
         * @param {ProductPromotionRequest} productPromotionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productPromotionsCreate(productPromotionRequest: ProductPromotionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductPromotion>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productPromotionsCreate(productPromotionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductPromotionApi.productPromotionsCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List multiple product promotions.
         * @summary List Product Promotions
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productPromotionsList(ordering?: string, page?: number, pageSize?: number, search?: string, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedProductPromotionList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productPromotionsList(ordering, page, pageSize, search, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductPromotionApi.productPromotionsList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update a product promotion.
         * @summary Update a Product Promotion
         * @param {string} id 
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {PatchedProductPromotionRequest} [patchedProductPromotionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productPromotionsPartialUpdate(id: string, leafLinkVersion?: string, patchedProductPromotionRequest?: PatchedProductPromotionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductPromotion>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productPromotionsPartialUpdate(id, leafLinkVersion, patchedProductPromotionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductPromotionApi.productPromotionsPartialUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a single product promotion.
         * @summary Get a Product Promotion
         * @param {string} id 
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productPromotionsRetrieve(id: string, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductPromotion>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productPromotionsRetrieve(id, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductPromotionApi.productPromotionsRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ProductPromotionApi - factory interface
 * @export
 */
export const ProductPromotionApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProductPromotionApiFp(configuration)
    return {
        /**
         * Create a product promotion.
         * @summary Create a Product Promotion
         * @param {ProductPromotionApiProductPromotionsCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productPromotionsCreate(requestParameters: ProductPromotionApiProductPromotionsCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProductPromotion> {
            return localVarFp.productPromotionsCreate(requestParameters.productPromotionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * List multiple product promotions.
         * @summary List Product Promotions
         * @param {ProductPromotionApiProductPromotionsListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productPromotionsList(requestParameters: ProductPromotionApiProductPromotionsListRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedProductPromotionList> {
            return localVarFp.productPromotionsList(requestParameters.ordering, requestParameters.page, requestParameters.pageSize, requestParameters.search, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a product promotion.
         * @summary Update a Product Promotion
         * @param {ProductPromotionApiProductPromotionsPartialUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productPromotionsPartialUpdate(requestParameters: ProductPromotionApiProductPromotionsPartialUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProductPromotion> {
            return localVarFp.productPromotionsPartialUpdate(requestParameters.id, requestParameters.leafLinkVersion, requestParameters.patchedProductPromotionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a single product promotion.
         * @summary Get a Product Promotion
         * @param {ProductPromotionApiProductPromotionsRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productPromotionsRetrieve(requestParameters: ProductPromotionApiProductPromotionsRetrieveRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProductPromotion> {
            return localVarFp.productPromotionsRetrieve(requestParameters.id, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for productPromotionsCreate operation in ProductPromotionApi.
 * @export
 * @interface ProductPromotionApiProductPromotionsCreateRequest
 */
export interface ProductPromotionApiProductPromotionsCreateRequest {
    /**
     * 
     * @type {ProductPromotionRequest}
     * @memberof ProductPromotionApiProductPromotionsCreate
     */
    readonly productPromotionRequest: ProductPromotionRequest
}

/**
 * Request parameters for productPromotionsList operation in ProductPromotionApi.
 * @export
 * @interface ProductPromotionApiProductPromotionsListRequest
 */
export interface ProductPromotionApiProductPromotionsListRequest {
    /**
     * Which field to use when ordering the results.
     * @type {string}
     * @memberof ProductPromotionApiProductPromotionsList
     */
    readonly ordering?: string

    /**
     * A page number within the paginated result set.
     * @type {number}
     * @memberof ProductPromotionApiProductPromotionsList
     */
    readonly page?: number

    /**
     * Number of results to return per page.
     * @type {number}
     * @memberof ProductPromotionApiProductPromotionsList
     */
    readonly pageSize?: number

    /**
     * A search term.
     * @type {string}
     * @memberof ProductPromotionApiProductPromotionsList
     */
    readonly search?: string

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof ProductPromotionApiProductPromotionsList
     */
    readonly leafLinkVersion?: string
}

/**
 * Request parameters for productPromotionsPartialUpdate operation in ProductPromotionApi.
 * @export
 * @interface ProductPromotionApiProductPromotionsPartialUpdateRequest
 */
export interface ProductPromotionApiProductPromotionsPartialUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof ProductPromotionApiProductPromotionsPartialUpdate
     */
    readonly id: string

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof ProductPromotionApiProductPromotionsPartialUpdate
     */
    readonly leafLinkVersion?: string

    /**
     * 
     * @type {PatchedProductPromotionRequest}
     * @memberof ProductPromotionApiProductPromotionsPartialUpdate
     */
    readonly patchedProductPromotionRequest?: PatchedProductPromotionRequest
}

/**
 * Request parameters for productPromotionsRetrieve operation in ProductPromotionApi.
 * @export
 * @interface ProductPromotionApiProductPromotionsRetrieveRequest
 */
export interface ProductPromotionApiProductPromotionsRetrieveRequest {
    /**
     * 
     * @type {string}
     * @memberof ProductPromotionApiProductPromotionsRetrieve
     */
    readonly id: string

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof ProductPromotionApiProductPromotionsRetrieve
     */
    readonly leafLinkVersion?: string
}

/**
 * ProductPromotionApi - object-oriented interface
 * @export
 * @class ProductPromotionApi
 * @extends {BaseAPI}
 */
export class ProductPromotionApi extends BaseAPI {
    /**
     * Create a product promotion.
     * @summary Create a Product Promotion
     * @param {ProductPromotionApiProductPromotionsCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductPromotionApi
     */
    public productPromotionsCreate(requestParameters: ProductPromotionApiProductPromotionsCreateRequest, options?: RawAxiosRequestConfig) {
        return ProductPromotionApiFp(this.configuration).productPromotionsCreate(requestParameters.productPromotionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List multiple product promotions.
     * @summary List Product Promotions
     * @param {ProductPromotionApiProductPromotionsListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductPromotionApi
     */
    public productPromotionsList(requestParameters: ProductPromotionApiProductPromotionsListRequest = {}, options?: RawAxiosRequestConfig) {
        return ProductPromotionApiFp(this.configuration).productPromotionsList(requestParameters.ordering, requestParameters.page, requestParameters.pageSize, requestParameters.search, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a product promotion.
     * @summary Update a Product Promotion
     * @param {ProductPromotionApiProductPromotionsPartialUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductPromotionApi
     */
    public productPromotionsPartialUpdate(requestParameters: ProductPromotionApiProductPromotionsPartialUpdateRequest, options?: RawAxiosRequestConfig) {
        return ProductPromotionApiFp(this.configuration).productPromotionsPartialUpdate(requestParameters.id, requestParameters.leafLinkVersion, requestParameters.patchedProductPromotionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a single product promotion.
     * @summary Get a Product Promotion
     * @param {ProductPromotionApiProductPromotionsRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductPromotionApi
     */
    public productPromotionsRetrieve(requestParameters: ProductPromotionApiProductPromotionsRetrieveRequest, options?: RawAxiosRequestConfig) {
        return ProductPromotionApiFp(this.configuration).productPromotionsRetrieve(requestParameters.id, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ProductPromotionsApi - axios parameter creator
 * @export
 */
export const ProductPromotionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * API endpoint to create, view, and edit ProductPromotions for a company.
         * @param {string} id 
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productPromotionsDestroy: async (id: string, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('productPromotionsDestroy', 'id', id)
            const localVarPath = `/product_promotions/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API endpoint to create, view, and edit ProductPromotions for a company.
         * @param {string} id 
         * @param {ProductPromotionRequest} productPromotionRequest 
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productPromotionsUpdate: async (id: string, productPromotionRequest: ProductPromotionRequest, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('productPromotionsUpdate', 'id', id)
            // verify required parameter 'productPromotionRequest' is not null or undefined
            assertParamExists('productPromotionsUpdate', 'productPromotionRequest', productPromotionRequest)
            const localVarPath = `/product_promotions/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(productPromotionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProductPromotionsApi - functional programming interface
 * @export
 */
export const ProductPromotionsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProductPromotionsApiAxiosParamCreator(configuration)
    return {
        /**
         * API endpoint to create, view, and edit ProductPromotions for a company.
         * @param {string} id 
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productPromotionsDestroy(id: string, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productPromotionsDestroy(id, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductPromotionsApi.productPromotionsDestroy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * API endpoint to create, view, and edit ProductPromotions for a company.
         * @param {string} id 
         * @param {ProductPromotionRequest} productPromotionRequest 
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productPromotionsUpdate(id: string, productPromotionRequest: ProductPromotionRequest, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductPromotion>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productPromotionsUpdate(id, productPromotionRequest, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductPromotionsApi.productPromotionsUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ProductPromotionsApi - factory interface
 * @export
 */
export const ProductPromotionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProductPromotionsApiFp(configuration)
    return {
        /**
         * API endpoint to create, view, and edit ProductPromotions for a company.
         * @param {ProductPromotionsApiProductPromotionsDestroyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productPromotionsDestroy(requestParameters: ProductPromotionsApiProductPromotionsDestroyRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.productPromotionsDestroy(requestParameters.id, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * API endpoint to create, view, and edit ProductPromotions for a company.
         * @param {ProductPromotionsApiProductPromotionsUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productPromotionsUpdate(requestParameters: ProductPromotionsApiProductPromotionsUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProductPromotion> {
            return localVarFp.productPromotionsUpdate(requestParameters.id, requestParameters.productPromotionRequest, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for productPromotionsDestroy operation in ProductPromotionsApi.
 * @export
 * @interface ProductPromotionsApiProductPromotionsDestroyRequest
 */
export interface ProductPromotionsApiProductPromotionsDestroyRequest {
    /**
     * 
     * @type {string}
     * @memberof ProductPromotionsApiProductPromotionsDestroy
     */
    readonly id: string

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof ProductPromotionsApiProductPromotionsDestroy
     */
    readonly leafLinkVersion?: string
}

/**
 * Request parameters for productPromotionsUpdate operation in ProductPromotionsApi.
 * @export
 * @interface ProductPromotionsApiProductPromotionsUpdateRequest
 */
export interface ProductPromotionsApiProductPromotionsUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof ProductPromotionsApiProductPromotionsUpdate
     */
    readonly id: string

    /**
     * 
     * @type {ProductPromotionRequest}
     * @memberof ProductPromotionsApiProductPromotionsUpdate
     */
    readonly productPromotionRequest: ProductPromotionRequest

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof ProductPromotionsApiProductPromotionsUpdate
     */
    readonly leafLinkVersion?: string
}

/**
 * ProductPromotionsApi - object-oriented interface
 * @export
 * @class ProductPromotionsApi
 * @extends {BaseAPI}
 */
export class ProductPromotionsApi extends BaseAPI {
    /**
     * API endpoint to create, view, and edit ProductPromotions for a company.
     * @param {ProductPromotionsApiProductPromotionsDestroyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductPromotionsApi
     */
    public productPromotionsDestroy(requestParameters: ProductPromotionsApiProductPromotionsDestroyRequest, options?: RawAxiosRequestConfig) {
        return ProductPromotionsApiFp(this.configuration).productPromotionsDestroy(requestParameters.id, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API endpoint to create, view, and edit ProductPromotions for a company.
     * @param {ProductPromotionsApiProductPromotionsUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductPromotionsApi
     */
    public productPromotionsUpdate(requestParameters: ProductPromotionsApiProductPromotionsUpdateRequest, options?: RawAxiosRequestConfig) {
        return ProductPromotionsApiFp(this.configuration).productPromotionsUpdate(requestParameters.id, requestParameters.productPromotionRequest, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ProductSpecificationApi - axios parameter creator
 * @export
 */
export const ProductSpecificationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * List all Product Specifications
         * @summary List Product Specifications
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productSpecificationsList: async (ordering?: string, page?: number, pageSize?: number, search?: string, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/product_specifications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication tokenAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a Product Specification by ID
         * @summary Get a Product Specification
         * @param {number} id A unique integer value identifying this product data.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productSpecificationsRetrieve: async (id: number, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('productSpecificationsRetrieve', 'id', id)
            const localVarPath = `/product_specifications/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication tokenAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProductSpecificationApi - functional programming interface
 * @export
 */
export const ProductSpecificationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProductSpecificationApiAxiosParamCreator(configuration)
    return {
        /**
         * List all Product Specifications
         * @summary List Product Specifications
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productSpecificationsList(ordering?: string, page?: number, pageSize?: number, search?: string, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedUnifiedProductSpecificationList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productSpecificationsList(ordering, page, pageSize, search, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductSpecificationApi.productSpecificationsList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a Product Specification by ID
         * @summary Get a Product Specification
         * @param {number} id A unique integer value identifying this product data.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productSpecificationsRetrieve(id: number, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnifiedProductSpecification>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productSpecificationsRetrieve(id, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductSpecificationApi.productSpecificationsRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ProductSpecificationApi - factory interface
 * @export
 */
export const ProductSpecificationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProductSpecificationApiFp(configuration)
    return {
        /**
         * List all Product Specifications
         * @summary List Product Specifications
         * @param {ProductSpecificationApiProductSpecificationsListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productSpecificationsList(requestParameters: ProductSpecificationApiProductSpecificationsListRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedUnifiedProductSpecificationList> {
            return localVarFp.productSpecificationsList(requestParameters.ordering, requestParameters.page, requestParameters.pageSize, requestParameters.search, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a Product Specification by ID
         * @summary Get a Product Specification
         * @param {ProductSpecificationApiProductSpecificationsRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productSpecificationsRetrieve(requestParameters: ProductSpecificationApiProductSpecificationsRetrieveRequest, options?: RawAxiosRequestConfig): AxiosPromise<UnifiedProductSpecification> {
            return localVarFp.productSpecificationsRetrieve(requestParameters.id, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for productSpecificationsList operation in ProductSpecificationApi.
 * @export
 * @interface ProductSpecificationApiProductSpecificationsListRequest
 */
export interface ProductSpecificationApiProductSpecificationsListRequest {
    /**
     * Which field to use when ordering the results.
     * @type {string}
     * @memberof ProductSpecificationApiProductSpecificationsList
     */
    readonly ordering?: string

    /**
     * A page number within the paginated result set.
     * @type {number}
     * @memberof ProductSpecificationApiProductSpecificationsList
     */
    readonly page?: number

    /**
     * Number of results to return per page.
     * @type {number}
     * @memberof ProductSpecificationApiProductSpecificationsList
     */
    readonly pageSize?: number

    /**
     * A search term.
     * @type {string}
     * @memberof ProductSpecificationApiProductSpecificationsList
     */
    readonly search?: string

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof ProductSpecificationApiProductSpecificationsList
     */
    readonly leafLinkVersion?: string
}

/**
 * Request parameters for productSpecificationsRetrieve operation in ProductSpecificationApi.
 * @export
 * @interface ProductSpecificationApiProductSpecificationsRetrieveRequest
 */
export interface ProductSpecificationApiProductSpecificationsRetrieveRequest {
    /**
     * A unique integer value identifying this product data.
     * @type {number}
     * @memberof ProductSpecificationApiProductSpecificationsRetrieve
     */
    readonly id: number

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof ProductSpecificationApiProductSpecificationsRetrieve
     */
    readonly leafLinkVersion?: string
}

/**
 * ProductSpecificationApi - object-oriented interface
 * @export
 * @class ProductSpecificationApi
 * @extends {BaseAPI}
 */
export class ProductSpecificationApi extends BaseAPI {
    /**
     * List all Product Specifications
     * @summary List Product Specifications
     * @param {ProductSpecificationApiProductSpecificationsListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductSpecificationApi
     */
    public productSpecificationsList(requestParameters: ProductSpecificationApiProductSpecificationsListRequest = {}, options?: RawAxiosRequestConfig) {
        return ProductSpecificationApiFp(this.configuration).productSpecificationsList(requestParameters.ordering, requestParameters.page, requestParameters.pageSize, requestParameters.search, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a Product Specification by ID
     * @summary Get a Product Specification
     * @param {ProductSpecificationApiProductSpecificationsRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductSpecificationApi
     */
    public productSpecificationsRetrieve(requestParameters: ProductSpecificationApiProductSpecificationsRetrieveRequest, options?: RawAxiosRequestConfig) {
        return ProductSpecificationApiFp(this.configuration).productSpecificationsRetrieve(requestParameters.id, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ProductSubcategoryApi - axios parameter creator
 * @export
 */
export const ProductSubcategoryApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * List multiple product subcategories.
         * @summary List Product Subcategories
         * @param {number} [categoryId] 
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {number} [subcategoryId] 
         * @param {string} [subcategoryName] 
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productSubcategoriesList: async (categoryId?: number, ordering?: string, page?: number, pageSize?: number, search?: string, subcategoryId?: number, subcategoryName?: string, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/product_subcategories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication tokenAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (categoryId !== undefined) {
                localVarQueryParameter['category_id'] = categoryId;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (subcategoryId !== undefined) {
                localVarQueryParameter['subcategory_id'] = subcategoryId;
            }

            if (subcategoryName !== undefined) {
                localVarQueryParameter['subcategory_name'] = subcategoryName;
            }


    
            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a single product subcategory.
         * @summary Get a Product Subcategory
         * @param {number} id A unique integer value identifying this product sub category.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productSubcategoriesRetrieve: async (id: number, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('productSubcategoriesRetrieve', 'id', id)
            const localVarPath = `/product_subcategories/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication tokenAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProductSubcategoryApi - functional programming interface
 * @export
 */
export const ProductSubcategoryApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProductSubcategoryApiAxiosParamCreator(configuration)
    return {
        /**
         * List multiple product subcategories.
         * @summary List Product Subcategories
         * @param {number} [categoryId] 
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {number} [subcategoryId] 
         * @param {string} [subcategoryName] 
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productSubcategoriesList(categoryId?: number, ordering?: string, page?: number, pageSize?: number, search?: string, subcategoryId?: number, subcategoryName?: string, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedUnifiedProductSubCategoryList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productSubcategoriesList(categoryId, ordering, page, pageSize, search, subcategoryId, subcategoryName, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductSubcategoryApi.productSubcategoriesList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a single product subcategory.
         * @summary Get a Product Subcategory
         * @param {number} id A unique integer value identifying this product sub category.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productSubcategoriesRetrieve(id: number, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnifiedProductSubCategory>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productSubcategoriesRetrieve(id, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductSubcategoryApi.productSubcategoriesRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ProductSubcategoryApi - factory interface
 * @export
 */
export const ProductSubcategoryApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProductSubcategoryApiFp(configuration)
    return {
        /**
         * List multiple product subcategories.
         * @summary List Product Subcategories
         * @param {ProductSubcategoryApiProductSubcategoriesListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productSubcategoriesList(requestParameters: ProductSubcategoryApiProductSubcategoriesListRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedUnifiedProductSubCategoryList> {
            return localVarFp.productSubcategoriesList(requestParameters.categoryId, requestParameters.ordering, requestParameters.page, requestParameters.pageSize, requestParameters.search, requestParameters.subcategoryId, requestParameters.subcategoryName, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a single product subcategory.
         * @summary Get a Product Subcategory
         * @param {ProductSubcategoryApiProductSubcategoriesRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productSubcategoriesRetrieve(requestParameters: ProductSubcategoryApiProductSubcategoriesRetrieveRequest, options?: RawAxiosRequestConfig): AxiosPromise<UnifiedProductSubCategory> {
            return localVarFp.productSubcategoriesRetrieve(requestParameters.id, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for productSubcategoriesList operation in ProductSubcategoryApi.
 * @export
 * @interface ProductSubcategoryApiProductSubcategoriesListRequest
 */
export interface ProductSubcategoryApiProductSubcategoriesListRequest {
    /**
     * 
     * @type {number}
     * @memberof ProductSubcategoryApiProductSubcategoriesList
     */
    readonly categoryId?: number

    /**
     * Which field to use when ordering the results.
     * @type {string}
     * @memberof ProductSubcategoryApiProductSubcategoriesList
     */
    readonly ordering?: string

    /**
     * A page number within the paginated result set.
     * @type {number}
     * @memberof ProductSubcategoryApiProductSubcategoriesList
     */
    readonly page?: number

    /**
     * Number of results to return per page.
     * @type {number}
     * @memberof ProductSubcategoryApiProductSubcategoriesList
     */
    readonly pageSize?: number

    /**
     * A search term.
     * @type {string}
     * @memberof ProductSubcategoryApiProductSubcategoriesList
     */
    readonly search?: string

    /**
     * 
     * @type {number}
     * @memberof ProductSubcategoryApiProductSubcategoriesList
     */
    readonly subcategoryId?: number

    /**
     * 
     * @type {string}
     * @memberof ProductSubcategoryApiProductSubcategoriesList
     */
    readonly subcategoryName?: string

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof ProductSubcategoryApiProductSubcategoriesList
     */
    readonly leafLinkVersion?: string
}

/**
 * Request parameters for productSubcategoriesRetrieve operation in ProductSubcategoryApi.
 * @export
 * @interface ProductSubcategoryApiProductSubcategoriesRetrieveRequest
 */
export interface ProductSubcategoryApiProductSubcategoriesRetrieveRequest {
    /**
     * A unique integer value identifying this product sub category.
     * @type {number}
     * @memberof ProductSubcategoryApiProductSubcategoriesRetrieve
     */
    readonly id: number

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof ProductSubcategoryApiProductSubcategoriesRetrieve
     */
    readonly leafLinkVersion?: string
}

/**
 * ProductSubcategoryApi - object-oriented interface
 * @export
 * @class ProductSubcategoryApi
 * @extends {BaseAPI}
 */
export class ProductSubcategoryApi extends BaseAPI {
    /**
     * List multiple product subcategories.
     * @summary List Product Subcategories
     * @param {ProductSubcategoryApiProductSubcategoriesListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductSubcategoryApi
     */
    public productSubcategoriesList(requestParameters: ProductSubcategoryApiProductSubcategoriesListRequest = {}, options?: RawAxiosRequestConfig) {
        return ProductSubcategoryApiFp(this.configuration).productSubcategoriesList(requestParameters.categoryId, requestParameters.ordering, requestParameters.page, requestParameters.pageSize, requestParameters.search, requestParameters.subcategoryId, requestParameters.subcategoryName, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a single product subcategory.
     * @summary Get a Product Subcategory
     * @param {ProductSubcategoryApiProductSubcategoriesRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductSubcategoryApi
     */
    public productSubcategoriesRetrieve(requestParameters: ProductSubcategoryApiProductSubcategoriesRetrieveRequest, options?: RawAxiosRequestConfig) {
        return ProductSubcategoryApiFp(this.configuration).productSubcategoriesRetrieve(requestParameters.id, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ProductTemplateApi - axios parameter creator
 * @export
 */
export const ProductTemplateApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create a new product template.
         * @summary Create Product Template
         * @param {number} companyId 
         * @param {UnifiedProductTemplateRequest} unifiedProductTemplateRequest 
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productTemplatesCreate: async (companyId: number, unifiedProductTemplateRequest: UnifiedProductTemplateRequest, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('productTemplatesCreate', 'companyId', companyId)
            // verify required parameter 'unifiedProductTemplateRequest' is not null or undefined
            assertParamExists('productTemplatesCreate', 'unifiedProductTemplateRequest', unifiedProductTemplateRequest)
            const localVarPath = `/product_templates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (companyId !== undefined) {
                localVarQueryParameter['company_id'] = companyId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(unifiedProductTemplateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete an existing product template.
         * @summary Delete Product Template
         * @param {number} companyId 
         * @param {string} id 
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productTemplatesDestroy: async (companyId: number, id: string, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('productTemplatesDestroy', 'companyId', companyId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('productTemplatesDestroy', 'id', id)
            const localVarPath = `/product_templates/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (companyId !== undefined) {
                localVarQueryParameter['company_id'] = companyId;
            }


    
            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List multiple product templates.
         * @summary List Product Templates
         * @param {number} companyId 
         * @param {string} [name] 
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productTemplatesList: async (companyId: number, name?: string, ordering?: string, page?: number, pageSize?: number, search?: string, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('productTemplatesList', 'companyId', companyId)
            const localVarPath = `/product_templates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (companyId !== undefined) {
                localVarQueryParameter['company_id'] = companyId;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update an existing product template.
         * @summary Update Product Template
         * @param {number} companyId 
         * @param {string} id 
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {PatchedUnifiedProductTemplateRequest} [patchedUnifiedProductTemplateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productTemplatesPartialUpdate: async (companyId: number, id: string, leafLinkVersion?: string, patchedUnifiedProductTemplateRequest?: PatchedUnifiedProductTemplateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('productTemplatesPartialUpdate', 'companyId', companyId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('productTemplatesPartialUpdate', 'id', id)
            const localVarPath = `/product_templates/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (companyId !== undefined) {
                localVarQueryParameter['company_id'] = companyId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchedUnifiedProductTemplateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a single product template.
         * @summary Retrieve Product Template
         * @param {number} companyId 
         * @param {string} id 
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productTemplatesRetrieve: async (companyId: number, id: string, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('productTemplatesRetrieve', 'companyId', companyId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('productTemplatesRetrieve', 'id', id)
            const localVarPath = `/product_templates/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (companyId !== undefined) {
                localVarQueryParameter['company_id'] = companyId;
            }


    
            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProductTemplateApi - functional programming interface
 * @export
 */
export const ProductTemplateApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProductTemplateApiAxiosParamCreator(configuration)
    return {
        /**
         * Create a new product template.
         * @summary Create Product Template
         * @param {number} companyId 
         * @param {UnifiedProductTemplateRequest} unifiedProductTemplateRequest 
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productTemplatesCreate(companyId: number, unifiedProductTemplateRequest: UnifiedProductTemplateRequest, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnifiedProductTemplate>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productTemplatesCreate(companyId, unifiedProductTemplateRequest, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductTemplateApi.productTemplatesCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete an existing product template.
         * @summary Delete Product Template
         * @param {number} companyId 
         * @param {string} id 
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productTemplatesDestroy(companyId: number, id: string, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productTemplatesDestroy(companyId, id, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductTemplateApi.productTemplatesDestroy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List multiple product templates.
         * @summary List Product Templates
         * @param {number} companyId 
         * @param {string} [name] 
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productTemplatesList(companyId: number, name?: string, ordering?: string, page?: number, pageSize?: number, search?: string, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedUnifiedProductTemplateList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productTemplatesList(companyId, name, ordering, page, pageSize, search, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductTemplateApi.productTemplatesList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update an existing product template.
         * @summary Update Product Template
         * @param {number} companyId 
         * @param {string} id 
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {PatchedUnifiedProductTemplateRequest} [patchedUnifiedProductTemplateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productTemplatesPartialUpdate(companyId: number, id: string, leafLinkVersion?: string, patchedUnifiedProductTemplateRequest?: PatchedUnifiedProductTemplateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnifiedProductTemplate>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productTemplatesPartialUpdate(companyId, id, leafLinkVersion, patchedUnifiedProductTemplateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductTemplateApi.productTemplatesPartialUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve a single product template.
         * @summary Retrieve Product Template
         * @param {number} companyId 
         * @param {string} id 
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productTemplatesRetrieve(companyId: number, id: string, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnifiedProductTemplate>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productTemplatesRetrieve(companyId, id, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductTemplateApi.productTemplatesRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ProductTemplateApi - factory interface
 * @export
 */
export const ProductTemplateApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProductTemplateApiFp(configuration)
    return {
        /**
         * Create a new product template.
         * @summary Create Product Template
         * @param {ProductTemplateApiProductTemplatesCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productTemplatesCreate(requestParameters: ProductTemplateApiProductTemplatesCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<UnifiedProductTemplate> {
            return localVarFp.productTemplatesCreate(requestParameters.companyId, requestParameters.unifiedProductTemplateRequest, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete an existing product template.
         * @summary Delete Product Template
         * @param {ProductTemplateApiProductTemplatesDestroyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productTemplatesDestroy(requestParameters: ProductTemplateApiProductTemplatesDestroyRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.productTemplatesDestroy(requestParameters.companyId, requestParameters.id, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * List multiple product templates.
         * @summary List Product Templates
         * @param {ProductTemplateApiProductTemplatesListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productTemplatesList(requestParameters: ProductTemplateApiProductTemplatesListRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedUnifiedProductTemplateList> {
            return localVarFp.productTemplatesList(requestParameters.companyId, requestParameters.name, requestParameters.ordering, requestParameters.page, requestParameters.pageSize, requestParameters.search, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * Update an existing product template.
         * @summary Update Product Template
         * @param {ProductTemplateApiProductTemplatesPartialUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productTemplatesPartialUpdate(requestParameters: ProductTemplateApiProductTemplatesPartialUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<UnifiedProductTemplate> {
            return localVarFp.productTemplatesPartialUpdate(requestParameters.companyId, requestParameters.id, requestParameters.leafLinkVersion, requestParameters.patchedUnifiedProductTemplateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a single product template.
         * @summary Retrieve Product Template
         * @param {ProductTemplateApiProductTemplatesRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productTemplatesRetrieve(requestParameters: ProductTemplateApiProductTemplatesRetrieveRequest, options?: RawAxiosRequestConfig): AxiosPromise<UnifiedProductTemplate> {
            return localVarFp.productTemplatesRetrieve(requestParameters.companyId, requestParameters.id, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for productTemplatesCreate operation in ProductTemplateApi.
 * @export
 * @interface ProductTemplateApiProductTemplatesCreateRequest
 */
export interface ProductTemplateApiProductTemplatesCreateRequest {
    /**
     * 
     * @type {number}
     * @memberof ProductTemplateApiProductTemplatesCreate
     */
    readonly companyId: number

    /**
     * 
     * @type {UnifiedProductTemplateRequest}
     * @memberof ProductTemplateApiProductTemplatesCreate
     */
    readonly unifiedProductTemplateRequest: UnifiedProductTemplateRequest

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof ProductTemplateApiProductTemplatesCreate
     */
    readonly leafLinkVersion?: string
}

/**
 * Request parameters for productTemplatesDestroy operation in ProductTemplateApi.
 * @export
 * @interface ProductTemplateApiProductTemplatesDestroyRequest
 */
export interface ProductTemplateApiProductTemplatesDestroyRequest {
    /**
     * 
     * @type {number}
     * @memberof ProductTemplateApiProductTemplatesDestroy
     */
    readonly companyId: number

    /**
     * 
     * @type {string}
     * @memberof ProductTemplateApiProductTemplatesDestroy
     */
    readonly id: string

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof ProductTemplateApiProductTemplatesDestroy
     */
    readonly leafLinkVersion?: string
}

/**
 * Request parameters for productTemplatesList operation in ProductTemplateApi.
 * @export
 * @interface ProductTemplateApiProductTemplatesListRequest
 */
export interface ProductTemplateApiProductTemplatesListRequest {
    /**
     * 
     * @type {number}
     * @memberof ProductTemplateApiProductTemplatesList
     */
    readonly companyId: number

    /**
     * 
     * @type {string}
     * @memberof ProductTemplateApiProductTemplatesList
     */
    readonly name?: string

    /**
     * Which field to use when ordering the results.
     * @type {string}
     * @memberof ProductTemplateApiProductTemplatesList
     */
    readonly ordering?: string

    /**
     * A page number within the paginated result set.
     * @type {number}
     * @memberof ProductTemplateApiProductTemplatesList
     */
    readonly page?: number

    /**
     * Number of results to return per page.
     * @type {number}
     * @memberof ProductTemplateApiProductTemplatesList
     */
    readonly pageSize?: number

    /**
     * A search term.
     * @type {string}
     * @memberof ProductTemplateApiProductTemplatesList
     */
    readonly search?: string

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof ProductTemplateApiProductTemplatesList
     */
    readonly leafLinkVersion?: string
}

/**
 * Request parameters for productTemplatesPartialUpdate operation in ProductTemplateApi.
 * @export
 * @interface ProductTemplateApiProductTemplatesPartialUpdateRequest
 */
export interface ProductTemplateApiProductTemplatesPartialUpdateRequest {
    /**
     * 
     * @type {number}
     * @memberof ProductTemplateApiProductTemplatesPartialUpdate
     */
    readonly companyId: number

    /**
     * 
     * @type {string}
     * @memberof ProductTemplateApiProductTemplatesPartialUpdate
     */
    readonly id: string

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof ProductTemplateApiProductTemplatesPartialUpdate
     */
    readonly leafLinkVersion?: string

    /**
     * 
     * @type {PatchedUnifiedProductTemplateRequest}
     * @memberof ProductTemplateApiProductTemplatesPartialUpdate
     */
    readonly patchedUnifiedProductTemplateRequest?: PatchedUnifiedProductTemplateRequest
}

/**
 * Request parameters for productTemplatesRetrieve operation in ProductTemplateApi.
 * @export
 * @interface ProductTemplateApiProductTemplatesRetrieveRequest
 */
export interface ProductTemplateApiProductTemplatesRetrieveRequest {
    /**
     * 
     * @type {number}
     * @memberof ProductTemplateApiProductTemplatesRetrieve
     */
    readonly companyId: number

    /**
     * 
     * @type {string}
     * @memberof ProductTemplateApiProductTemplatesRetrieve
     */
    readonly id: string

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof ProductTemplateApiProductTemplatesRetrieve
     */
    readonly leafLinkVersion?: string
}

/**
 * ProductTemplateApi - object-oriented interface
 * @export
 * @class ProductTemplateApi
 * @extends {BaseAPI}
 */
export class ProductTemplateApi extends BaseAPI {
    /**
     * Create a new product template.
     * @summary Create Product Template
     * @param {ProductTemplateApiProductTemplatesCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductTemplateApi
     */
    public productTemplatesCreate(requestParameters: ProductTemplateApiProductTemplatesCreateRequest, options?: RawAxiosRequestConfig) {
        return ProductTemplateApiFp(this.configuration).productTemplatesCreate(requestParameters.companyId, requestParameters.unifiedProductTemplateRequest, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete an existing product template.
     * @summary Delete Product Template
     * @param {ProductTemplateApiProductTemplatesDestroyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductTemplateApi
     */
    public productTemplatesDestroy(requestParameters: ProductTemplateApiProductTemplatesDestroyRequest, options?: RawAxiosRequestConfig) {
        return ProductTemplateApiFp(this.configuration).productTemplatesDestroy(requestParameters.companyId, requestParameters.id, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List multiple product templates.
     * @summary List Product Templates
     * @param {ProductTemplateApiProductTemplatesListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductTemplateApi
     */
    public productTemplatesList(requestParameters: ProductTemplateApiProductTemplatesListRequest, options?: RawAxiosRequestConfig) {
        return ProductTemplateApiFp(this.configuration).productTemplatesList(requestParameters.companyId, requestParameters.name, requestParameters.ordering, requestParameters.page, requestParameters.pageSize, requestParameters.search, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update an existing product template.
     * @summary Update Product Template
     * @param {ProductTemplateApiProductTemplatesPartialUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductTemplateApi
     */
    public productTemplatesPartialUpdate(requestParameters: ProductTemplateApiProductTemplatesPartialUpdateRequest, options?: RawAxiosRequestConfig) {
        return ProductTemplateApiFp(this.configuration).productTemplatesPartialUpdate(requestParameters.companyId, requestParameters.id, requestParameters.leafLinkVersion, requestParameters.patchedUnifiedProductTemplateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve a single product template.
     * @summary Retrieve Product Template
     * @param {ProductTemplateApiProductTemplatesRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductTemplateApi
     */
    public productTemplatesRetrieve(requestParameters: ProductTemplateApiProductTemplatesRetrieveRequest, options?: RawAxiosRequestConfig) {
        return ProductTemplateApiFp(this.configuration).productTemplatesRetrieve(requestParameters.companyId, requestParameters.id, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ProductsApi - axios parameter creator
 * @export
 */
export const ProductsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * LeafLink API for Marketplace products.
         * @param {UnifiedProductRequest} unifiedProductRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsCreate: async (unifiedProductRequest: UnifiedProductRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'unifiedProductRequest' is not null or undefined
            assertParamExists('productsCreate', 'unifiedProductRequest', unifiedProductRequest)
            const localVarPath = `/products`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(unifiedProductRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Perform a \'DELETE\' on a product. It will mark the specified product as Archived.  Logic is put here as the ModelViewSet destroy function doesn\'t use the serializer.
         * @param {number} id A unique integer value identifying this product.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsDestroy: async (id: number, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('productsDestroy', 'id', id)
            const localVarPath = `/products/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * LeafLink API for Marketplace products.
         * @param {number} id A unique integer value identifying this product.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {PatchedUnifiedProductRequest} [patchedUnifiedProductRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsPartialUpdate: async (id: number, leafLinkVersion?: string, patchedUnifiedProductRequest?: PatchedUnifiedProductRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('productsPartialUpdate', 'id', id)
            const localVarPath = `/products/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchedUnifiedProductRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * LeafLink API for Marketplace products.
         * @param {number} id A unique integer value identifying this product.
         * @param {UnifiedProductRequest} unifiedProductRequest 
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsUpdate: async (id: number, unifiedProductRequest: UnifiedProductRequest, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('productsUpdate', 'id', id)
            // verify required parameter 'unifiedProductRequest' is not null or undefined
            assertParamExists('productsUpdate', 'unifiedProductRequest', unifiedProductRequest)
            const localVarPath = `/products/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(unifiedProductRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProductsApi - functional programming interface
 * @export
 */
export const ProductsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProductsApiAxiosParamCreator(configuration)
    return {
        /**
         * LeafLink API for Marketplace products.
         * @param {UnifiedProductRequest} unifiedProductRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productsCreate(unifiedProductRequest: UnifiedProductRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnifiedProduct>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productsCreate(unifiedProductRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductsApi.productsCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Perform a \'DELETE\' on a product. It will mark the specified product as Archived.  Logic is put here as the ModelViewSet destroy function doesn\'t use the serializer.
         * @param {number} id A unique integer value identifying this product.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productsDestroy(id: number, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productsDestroy(id, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductsApi.productsDestroy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * LeafLink API for Marketplace products.
         * @param {number} id A unique integer value identifying this product.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {PatchedUnifiedProductRequest} [patchedUnifiedProductRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productsPartialUpdate(id: number, leafLinkVersion?: string, patchedUnifiedProductRequest?: PatchedUnifiedProductRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnifiedProduct>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productsPartialUpdate(id, leafLinkVersion, patchedUnifiedProductRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductsApi.productsPartialUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * LeafLink API for Marketplace products.
         * @param {number} id A unique integer value identifying this product.
         * @param {UnifiedProductRequest} unifiedProductRequest 
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productsUpdate(id: number, unifiedProductRequest: UnifiedProductRequest, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnifiedProduct>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productsUpdate(id, unifiedProductRequest, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductsApi.productsUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ProductsApi - factory interface
 * @export
 */
export const ProductsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProductsApiFp(configuration)
    return {
        /**
         * LeafLink API for Marketplace products.
         * @param {ProductsApiProductsCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsCreate(requestParameters: ProductsApiProductsCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<UnifiedProduct> {
            return localVarFp.productsCreate(requestParameters.unifiedProductRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Perform a \'DELETE\' on a product. It will mark the specified product as Archived.  Logic is put here as the ModelViewSet destroy function doesn\'t use the serializer.
         * @param {ProductsApiProductsDestroyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsDestroy(requestParameters: ProductsApiProductsDestroyRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.productsDestroy(requestParameters.id, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * LeafLink API for Marketplace products.
         * @param {ProductsApiProductsPartialUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsPartialUpdate(requestParameters: ProductsApiProductsPartialUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<UnifiedProduct> {
            return localVarFp.productsPartialUpdate(requestParameters.id, requestParameters.leafLinkVersion, requestParameters.patchedUnifiedProductRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * LeafLink API for Marketplace products.
         * @param {ProductsApiProductsUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsUpdate(requestParameters: ProductsApiProductsUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<UnifiedProduct> {
            return localVarFp.productsUpdate(requestParameters.id, requestParameters.unifiedProductRequest, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for productsCreate operation in ProductsApi.
 * @export
 * @interface ProductsApiProductsCreateRequest
 */
export interface ProductsApiProductsCreateRequest {
    /**
     * 
     * @type {UnifiedProductRequest}
     * @memberof ProductsApiProductsCreate
     */
    readonly unifiedProductRequest: UnifiedProductRequest
}

/**
 * Request parameters for productsDestroy operation in ProductsApi.
 * @export
 * @interface ProductsApiProductsDestroyRequest
 */
export interface ProductsApiProductsDestroyRequest {
    /**
     * A unique integer value identifying this product.
     * @type {number}
     * @memberof ProductsApiProductsDestroy
     */
    readonly id: number

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof ProductsApiProductsDestroy
     */
    readonly leafLinkVersion?: string
}

/**
 * Request parameters for productsPartialUpdate operation in ProductsApi.
 * @export
 * @interface ProductsApiProductsPartialUpdateRequest
 */
export interface ProductsApiProductsPartialUpdateRequest {
    /**
     * A unique integer value identifying this product.
     * @type {number}
     * @memberof ProductsApiProductsPartialUpdate
     */
    readonly id: number

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof ProductsApiProductsPartialUpdate
     */
    readonly leafLinkVersion?: string

    /**
     * 
     * @type {PatchedUnifiedProductRequest}
     * @memberof ProductsApiProductsPartialUpdate
     */
    readonly patchedUnifiedProductRequest?: PatchedUnifiedProductRequest
}

/**
 * Request parameters for productsUpdate operation in ProductsApi.
 * @export
 * @interface ProductsApiProductsUpdateRequest
 */
export interface ProductsApiProductsUpdateRequest {
    /**
     * A unique integer value identifying this product.
     * @type {number}
     * @memberof ProductsApiProductsUpdate
     */
    readonly id: number

    /**
     * 
     * @type {UnifiedProductRequest}
     * @memberof ProductsApiProductsUpdate
     */
    readonly unifiedProductRequest: UnifiedProductRequest

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof ProductsApiProductsUpdate
     */
    readonly leafLinkVersion?: string
}

/**
 * ProductsApi - object-oriented interface
 * @export
 * @class ProductsApi
 * @extends {BaseAPI}
 */
export class ProductsApi extends BaseAPI {
    /**
     * LeafLink API for Marketplace products.
     * @param {ProductsApiProductsCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public productsCreate(requestParameters: ProductsApiProductsCreateRequest, options?: RawAxiosRequestConfig) {
        return ProductsApiFp(this.configuration).productsCreate(requestParameters.unifiedProductRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Perform a \'DELETE\' on a product. It will mark the specified product as Archived.  Logic is put here as the ModelViewSet destroy function doesn\'t use the serializer.
     * @param {ProductsApiProductsDestroyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public productsDestroy(requestParameters: ProductsApiProductsDestroyRequest, options?: RawAxiosRequestConfig) {
        return ProductsApiFp(this.configuration).productsDestroy(requestParameters.id, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * LeafLink API for Marketplace products.
     * @param {ProductsApiProductsPartialUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public productsPartialUpdate(requestParameters: ProductsApiProductsPartialUpdateRequest, options?: RawAxiosRequestConfig) {
        return ProductsApiFp(this.configuration).productsPartialUpdate(requestParameters.id, requestParameters.leafLinkVersion, requestParameters.patchedUnifiedProductRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * LeafLink API for Marketplace products.
     * @param {ProductsApiProductsUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public productsUpdate(requestParameters: ProductsApiProductsUpdateRequest, options?: RawAxiosRequestConfig) {
        return ProductsApiFp(this.configuration).productsUpdate(requestParameters.id, requestParameters.unifiedProductRequest, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SalesInvoicesApi - axios parameter creator
 * @export
 */
export const SalesInvoicesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [createdDateFrom] 
         * @param {string} [createdDateTo] 
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        salesInvoicesList: async (createdDateFrom?: string, createdDateTo?: string, ordering?: string, page?: number, pageSize?: number, search?: string, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/sales_invoices`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (createdDateFrom !== undefined) {
                localVarQueryParameter['created_date_from'] = (createdDateFrom as any instanceof Date) ?
                    (createdDateFrom as any).toISOString().substring(0,10) :
                    createdDateFrom;
            }

            if (createdDateTo !== undefined) {
                localVarQueryParameter['created_date_to'] = (createdDateTo as any instanceof Date) ?
                    (createdDateTo as any).toISOString().substring(0,10) :
                    createdDateTo;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id A unique integer value identifying this order.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        salesInvoicesRetrieve: async (id: number, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('salesInvoicesRetrieve', 'id', id)
            const localVarPath = `/sales_invoices/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SalesInvoicesApi - functional programming interface
 * @export
 */
export const SalesInvoicesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SalesInvoicesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [createdDateFrom] 
         * @param {string} [createdDateTo] 
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async salesInvoicesList(createdDateFrom?: string, createdDateTo?: string, ordering?: string, page?: number, pageSize?: number, search?: string, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedUnifiedOrderAsSalesInvoiceList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.salesInvoicesList(createdDateFrom, createdDateTo, ordering, page, pageSize, search, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalesInvoicesApi.salesInvoicesList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id A unique integer value identifying this order.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async salesInvoicesRetrieve(id: number, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnifiedOrderAsSalesInvoice>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.salesInvoicesRetrieve(id, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalesInvoicesApi.salesInvoicesRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SalesInvoicesApi - factory interface
 * @export
 */
export const SalesInvoicesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SalesInvoicesApiFp(configuration)
    return {
        /**
         * 
         * @param {SalesInvoicesApiSalesInvoicesListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        salesInvoicesList(requestParameters: SalesInvoicesApiSalesInvoicesListRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedUnifiedOrderAsSalesInvoiceList> {
            return localVarFp.salesInvoicesList(requestParameters.createdDateFrom, requestParameters.createdDateTo, requestParameters.ordering, requestParameters.page, requestParameters.pageSize, requestParameters.search, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SalesInvoicesApiSalesInvoicesRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        salesInvoicesRetrieve(requestParameters: SalesInvoicesApiSalesInvoicesRetrieveRequest, options?: RawAxiosRequestConfig): AxiosPromise<UnifiedOrderAsSalesInvoice> {
            return localVarFp.salesInvoicesRetrieve(requestParameters.id, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for salesInvoicesList operation in SalesInvoicesApi.
 * @export
 * @interface SalesInvoicesApiSalesInvoicesListRequest
 */
export interface SalesInvoicesApiSalesInvoicesListRequest {
    /**
     * 
     * @type {string}
     * @memberof SalesInvoicesApiSalesInvoicesList
     */
    readonly createdDateFrom?: string

    /**
     * 
     * @type {string}
     * @memberof SalesInvoicesApiSalesInvoicesList
     */
    readonly createdDateTo?: string

    /**
     * Which field to use when ordering the results.
     * @type {string}
     * @memberof SalesInvoicesApiSalesInvoicesList
     */
    readonly ordering?: string

    /**
     * A page number within the paginated result set.
     * @type {number}
     * @memberof SalesInvoicesApiSalesInvoicesList
     */
    readonly page?: number

    /**
     * Number of results to return per page.
     * @type {number}
     * @memberof SalesInvoicesApiSalesInvoicesList
     */
    readonly pageSize?: number

    /**
     * A search term.
     * @type {string}
     * @memberof SalesInvoicesApiSalesInvoicesList
     */
    readonly search?: string

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof SalesInvoicesApiSalesInvoicesList
     */
    readonly leafLinkVersion?: string
}

/**
 * Request parameters for salesInvoicesRetrieve operation in SalesInvoicesApi.
 * @export
 * @interface SalesInvoicesApiSalesInvoicesRetrieveRequest
 */
export interface SalesInvoicesApiSalesInvoicesRetrieveRequest {
    /**
     * A unique integer value identifying this order.
     * @type {number}
     * @memberof SalesInvoicesApiSalesInvoicesRetrieve
     */
    readonly id: number

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof SalesInvoicesApiSalesInvoicesRetrieve
     */
    readonly leafLinkVersion?: string
}

/**
 * SalesInvoicesApi - object-oriented interface
 * @export
 * @class SalesInvoicesApi
 * @extends {BaseAPI}
 */
export class SalesInvoicesApi extends BaseAPI {
    /**
     * 
     * @param {SalesInvoicesApiSalesInvoicesListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesInvoicesApi
     */
    public salesInvoicesList(requestParameters: SalesInvoicesApiSalesInvoicesListRequest = {}, options?: RawAxiosRequestConfig) {
        return SalesInvoicesApiFp(this.configuration).salesInvoicesList(requestParameters.createdDateFrom, requestParameters.createdDateTo, requestParameters.ordering, requestParameters.page, requestParameters.pageSize, requestParameters.search, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SalesInvoicesApiSalesInvoicesRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesInvoicesApi
     */
    public salesInvoicesRetrieve(requestParameters: SalesInvoicesApiSalesInvoicesRetrieveRequest, options?: RawAxiosRequestConfig) {
        return SalesInvoicesApiFp(this.configuration).salesInvoicesRetrieve(requestParameters.id, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SettingsApi - axios parameter creator
 * @export
 */
export const SettingsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Update buyer notification settings.
         * @param {BuyerNotificationSettingRequest} [buyerNotificationSettingRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        settingsCompaniesBuyerNotificationsCreate: async (buyerNotificationSettingRequest?: BuyerNotificationSettingRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/settings/companies/buyer_notifications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(buyerNotificationSettingRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get buyer notification settings.
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        settingsCompaniesBuyerNotificationsList: async (ordering?: string, page?: number, pageSize?: number, search?: string, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/settings/companies/buyer_notifications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Unified API Buyer Notification Settings.
         * @param {number} id A unique integer value identifying this company.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        settingsCompaniesBuyerNotificationsRetrieve: async (id: number, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('settingsCompaniesBuyerNotificationsRetrieve', 'id', id)
            const localVarPath = `/settings/companies/buyer_notifications/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SettingsApi - functional programming interface
 * @export
 */
export const SettingsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SettingsApiAxiosParamCreator(configuration)
    return {
        /**
         * Update buyer notification settings.
         * @param {BuyerNotificationSettingRequest} [buyerNotificationSettingRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async settingsCompaniesBuyerNotificationsCreate(buyerNotificationSettingRequest?: BuyerNotificationSettingRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BuyerNotificationSetting>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.settingsCompaniesBuyerNotificationsCreate(buyerNotificationSettingRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.settingsCompaniesBuyerNotificationsCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get buyer notification settings.
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async settingsCompaniesBuyerNotificationsList(ordering?: string, page?: number, pageSize?: number, search?: string, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedBuyerNotificationSettingList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.settingsCompaniesBuyerNotificationsList(ordering, page, pageSize, search, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.settingsCompaniesBuyerNotificationsList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Unified API Buyer Notification Settings.
         * @param {number} id A unique integer value identifying this company.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async settingsCompaniesBuyerNotificationsRetrieve(id: number, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BuyerNotificationSetting>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.settingsCompaniesBuyerNotificationsRetrieve(id, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.settingsCompaniesBuyerNotificationsRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SettingsApi - factory interface
 * @export
 */
export const SettingsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SettingsApiFp(configuration)
    return {
        /**
         * Update buyer notification settings.
         * @param {SettingsApiSettingsCompaniesBuyerNotificationsCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        settingsCompaniesBuyerNotificationsCreate(requestParameters: SettingsApiSettingsCompaniesBuyerNotificationsCreateRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<BuyerNotificationSetting> {
            return localVarFp.settingsCompaniesBuyerNotificationsCreate(requestParameters.buyerNotificationSettingRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Get buyer notification settings.
         * @param {SettingsApiSettingsCompaniesBuyerNotificationsListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        settingsCompaniesBuyerNotificationsList(requestParameters: SettingsApiSettingsCompaniesBuyerNotificationsListRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedBuyerNotificationSettingList> {
            return localVarFp.settingsCompaniesBuyerNotificationsList(requestParameters.ordering, requestParameters.page, requestParameters.pageSize, requestParameters.search, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * Unified API Buyer Notification Settings.
         * @param {SettingsApiSettingsCompaniesBuyerNotificationsRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        settingsCompaniesBuyerNotificationsRetrieve(requestParameters: SettingsApiSettingsCompaniesBuyerNotificationsRetrieveRequest, options?: RawAxiosRequestConfig): AxiosPromise<BuyerNotificationSetting> {
            return localVarFp.settingsCompaniesBuyerNotificationsRetrieve(requestParameters.id, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for settingsCompaniesBuyerNotificationsCreate operation in SettingsApi.
 * @export
 * @interface SettingsApiSettingsCompaniesBuyerNotificationsCreateRequest
 */
export interface SettingsApiSettingsCompaniesBuyerNotificationsCreateRequest {
    /**
     * 
     * @type {BuyerNotificationSettingRequest}
     * @memberof SettingsApiSettingsCompaniesBuyerNotificationsCreate
     */
    readonly buyerNotificationSettingRequest?: BuyerNotificationSettingRequest
}

/**
 * Request parameters for settingsCompaniesBuyerNotificationsList operation in SettingsApi.
 * @export
 * @interface SettingsApiSettingsCompaniesBuyerNotificationsListRequest
 */
export interface SettingsApiSettingsCompaniesBuyerNotificationsListRequest {
    /**
     * Which field to use when ordering the results.
     * @type {string}
     * @memberof SettingsApiSettingsCompaniesBuyerNotificationsList
     */
    readonly ordering?: string

    /**
     * A page number within the paginated result set.
     * @type {number}
     * @memberof SettingsApiSettingsCompaniesBuyerNotificationsList
     */
    readonly page?: number

    /**
     * Number of results to return per page.
     * @type {number}
     * @memberof SettingsApiSettingsCompaniesBuyerNotificationsList
     */
    readonly pageSize?: number

    /**
     * A search term.
     * @type {string}
     * @memberof SettingsApiSettingsCompaniesBuyerNotificationsList
     */
    readonly search?: string

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof SettingsApiSettingsCompaniesBuyerNotificationsList
     */
    readonly leafLinkVersion?: string
}

/**
 * Request parameters for settingsCompaniesBuyerNotificationsRetrieve operation in SettingsApi.
 * @export
 * @interface SettingsApiSettingsCompaniesBuyerNotificationsRetrieveRequest
 */
export interface SettingsApiSettingsCompaniesBuyerNotificationsRetrieveRequest {
    /**
     * A unique integer value identifying this company.
     * @type {number}
     * @memberof SettingsApiSettingsCompaniesBuyerNotificationsRetrieve
     */
    readonly id: number

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof SettingsApiSettingsCompaniesBuyerNotificationsRetrieve
     */
    readonly leafLinkVersion?: string
}

/**
 * SettingsApi - object-oriented interface
 * @export
 * @class SettingsApi
 * @extends {BaseAPI}
 */
export class SettingsApi extends BaseAPI {
    /**
     * Update buyer notification settings.
     * @param {SettingsApiSettingsCompaniesBuyerNotificationsCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public settingsCompaniesBuyerNotificationsCreate(requestParameters: SettingsApiSettingsCompaniesBuyerNotificationsCreateRequest = {}, options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).settingsCompaniesBuyerNotificationsCreate(requestParameters.buyerNotificationSettingRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get buyer notification settings.
     * @param {SettingsApiSettingsCompaniesBuyerNotificationsListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public settingsCompaniesBuyerNotificationsList(requestParameters: SettingsApiSettingsCompaniesBuyerNotificationsListRequest = {}, options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).settingsCompaniesBuyerNotificationsList(requestParameters.ordering, requestParameters.page, requestParameters.pageSize, requestParameters.search, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Unified API Buyer Notification Settings.
     * @param {SettingsApiSettingsCompaniesBuyerNotificationsRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public settingsCompaniesBuyerNotificationsRetrieve(requestParameters: SettingsApiSettingsCompaniesBuyerNotificationsRetrieveRequest, options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).settingsCompaniesBuyerNotificationsRetrieve(requestParameters.id, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SplitIOApi - axios parameter creator
 * @export
 */
export const SplitIOApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get split treatments for a company
         * @summary Get split treatments
         * @param {number} companyId The ID of the viewing company
         * @param {Array<SplitsRetrieveSplitNameEnum>} [splitName] The names of the splits
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        splitsRetrieve: async (companyId: number, splitName?: Array<SplitsRetrieveSplitNameEnum>, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('splitsRetrieve', 'companyId', companyId)
            const localVarPath = `/splits`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (companyId !== undefined) {
                localVarQueryParameter['company_id'] = companyId;
            }

            if (splitName) {
                localVarQueryParameter['split_name'] = splitName;
            }


    
            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SplitIOApi - functional programming interface
 * @export
 */
export const SplitIOApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SplitIOApiAxiosParamCreator(configuration)
    return {
        /**
         * Get split treatments for a company
         * @summary Get split treatments
         * @param {number} companyId The ID of the viewing company
         * @param {Array<SplitsRetrieveSplitNameEnum>} [splitName] The names of the splits
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async splitsRetrieve(companyId: number, splitName?: Array<SplitsRetrieveSplitNameEnum>, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SplitTreatment>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.splitsRetrieve(companyId, splitName, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SplitIOApi.splitsRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SplitIOApi - factory interface
 * @export
 */
export const SplitIOApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SplitIOApiFp(configuration)
    return {
        /**
         * Get split treatments for a company
         * @summary Get split treatments
         * @param {SplitIOApiSplitsRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        splitsRetrieve(requestParameters: SplitIOApiSplitsRetrieveRequest, options?: RawAxiosRequestConfig): AxiosPromise<SplitTreatment> {
            return localVarFp.splitsRetrieve(requestParameters.companyId, requestParameters.splitName, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for splitsRetrieve operation in SplitIOApi.
 * @export
 * @interface SplitIOApiSplitsRetrieveRequest
 */
export interface SplitIOApiSplitsRetrieveRequest {
    /**
     * The ID of the viewing company
     * @type {number}
     * @memberof SplitIOApiSplitsRetrieve
     */
    readonly companyId: number

    /**
     * The names of the splits
     * @type {Array<'acct_man_pod__enrollment_nue_integration' | 'acct_man_pod__plan_price' | 'acct_man_pod__plans_and_billing' | 'acct_pod__seller_order_summary' | 'active_experiments' | 'ads_dashboard_recently_purchased_carousel' | 'ads_enable_recently_purchased_brands_carousel' | 'ads_enable_share_menu' | 'ads_enable_top_purchased_products_carousel' | 'ads_enable_vueified_share_leaflink' | 'ads_in_platform_product_promotion' | 'ads_kevel_buyer_seller_dash' | 'ads_moloco_shop_brands_featured_brands' | 'ads_moloco_shop_brands_sidebar_banners' | 'ads_platform_promotion_automation' | 'ads_pod_enable_moloco_ad_reporting' | 'ads_product_recommendation' | 'ads_product_recommendation_organic_recommendations' | 'ads_product_spotlight' | 'ads_serve_algolia_recommendations' | 'ads_shoppable_skyscraper' | 'ads_sponsorships_in_product_search' | 'buyer_settings_store_requests_vue' | 'can_access_company_group_features' | 'ce_pod__buyer_metrc_onboarding' | 'collab_pod__payments_in_crm' | 'collab_pod__promo_code_display' | 'collab_pod__sales_rep_email_actions' | 'com_pod__cart_payment_cta' | 'com_pod__cart_payment_option' | 'com_pod__reverse_factor' | 'com_pod__vendor_menu' | 'commerce__accept_payments_payment_events' | 'cop_pod__bank_linking' | 'cop_pod__payments_exploration_dashboard_widget' | 'cop_pod__terms_and_conditions' | 'cret_pod__vueified_company_profile' | 'custom_menus__edit_product_redirect' | 'eapps_sage_enabled' | 'enable_logistics_permission_to_all_users' | 'enterprise_pod__mult_payment_methods' | 'enterprise_pod__order_fees' | 'fire_pod__cashback_rewards' | 'fire_pod__delinquent_lockdown' | 'fire_pod__direct_pay_auto_authorization' | 'fire_pod__direct_pay_enabled_states' | 'fire_pod__enable_post_cascade' | 'fire_pod__enable_post_weekly_sum_view' | 'fire_pod__mp_auto_pausing' | 'fire_pod__mp_auto_pausing_update' | 'fire_pod__mp_balance_checks' | 'fire_pod__order_adjustments_event_consumer' | 'fire_pod__post_package_services' | 'fire_pod__post_settings' | 'fire_pod__seller_global_post_settings' | 'force_segment_reporting' | 'gro_pod__order_summary_invitations' | 'gro_pod__printed_menu' | 'gro_pod__vendor_menu_ui_enhancement' | 'inbound_shipments_create' | 'int_pod__order_pdf_report' | 'inventory_negative_available_quantity_logging' | 'inventory_pod__inventory_batch_support' | 'inventory_pod__inventory_warehouse_support' | 'inventory_pod__listings_allocations' | 'inventory_pod__new_product_list_page' | 'knock_notifications_toaster' | 'live_inventory_indicator' | 'llm_buyers_club_rollout' | 'llm_gpo_seller_report_v2' | 'llm_leaflink_plus_enrollment_billing' | 'llm_leaflink_plus_enrollment_updates' | 'llm_sigma_gpo_report' | 'llm_vue_seller_reports' | 'logistics_pod__enable_auto_update_of_metrc_templates' | 'logistics_pod__enable_customers_to_select_transport_partner' | 'logistics_pod__submit_order_via_csv_upload' | 'manage_license__add_integration__buyer' | 'manage_licenses__new_metrc_flow' | 'messaging_notifications' | 'npr_pod__integrations_seller' | 'ogk_pod__knock_notifications' | 'oms_data_sync_events' | 'oms_historical_data_sync' | 'oms_product_sync_events' | 'order_latency' | 'order_summary_ancillary_enhancements' | 'order_summary_receipt_log' | 'orders_internal_approvals' | 'orders_received_dataview' | 'pause_inactive_license_companies' | 'payment_on_sell_through__enrollment' | 'plat_arch_pod__oso_cloud' | 'plat_arch_pod__unified_hijacking' | 'post__sign_terms_and_conditions_for_all_staff_users' | 'post_allow_remove_post_flag_from_order' | 'post_automated_payments__calculation' | 'post_order_preagreement_settings' | 'post_sts_unit_conversion' | 'psx_pod__buyer_dashboard' | 'replenishment_catalog_page' | 'ret_pod__order_minimum' | 'ret_pod__split_orders' | 'retail_category_management_self_service' | 'retail_product_leaderboard_negotiate' | 'retention_pod__brand_menu_social_links' | 'retention_pod__buyer_reports' | 'seed_to_sale__buyer_nav' | 'seed_to_sale__transfer_template' | 'seed_to_sale_coa_download' | 'seller_settings_vue' | 'settings__buyer_account_details' | 'settings__tax_schedules' | 'shipping_request_delivery_modal' | 'shop_brands_performance_improvement' | 'show_sell_through_for_non_post' | 'sips_pod__mp_license_service_api' | 'spliff_pod__collab_notification' | 'ssr_iframe' | 'supply_chain_delivered_status' | 'switch_customer_for_cloned_orders' | 'trace_pod__s2s_transfers' | 'trace_pod__search_by_assigned_packages' | 'traceability__biotrack_buyer_onboarding' | 'traceability__biotrack_seller_attach_manifest' | 'traceability__biotrack_seller_transfers_page' | 'traceability_pod__automated_metrc_license_validation' | 'traceability_pod__biotrack_new_york' | 'traceability_pod__credential_encryption' | 'traceability_pod__experiment__reconcile_inventory' | 'traceability_pod__integration_settings' | 'transport_pod__ma_next_day_delivery' | 'transport_pod__shipping_set_order_payments' | 'vue_buyer_notification_settings' | 'vue_inventory_bulk_price_update' | 'vue_inventory_product_add_edit_page' | 'vue_inventory_product_line_page' | 'vue_messages_page' | 'vue_settings_brands_page'>}
     * @memberof SplitIOApiSplitsRetrieve
     */
    readonly splitName?: Array<SplitsRetrieveSplitNameEnum>

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof SplitIOApiSplitsRetrieve
     */
    readonly leafLinkVersion?: string
}

/**
 * SplitIOApi - object-oriented interface
 * @export
 * @class SplitIOApi
 * @extends {BaseAPI}
 */
export class SplitIOApi extends BaseAPI {
    /**
     * Get split treatments for a company
     * @summary Get split treatments
     * @param {SplitIOApiSplitsRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SplitIOApi
     */
    public splitsRetrieve(requestParameters: SplitIOApiSplitsRetrieveRequest, options?: RawAxiosRequestConfig) {
        return SplitIOApiFp(this.configuration).splitsRetrieve(requestParameters.companyId, requestParameters.splitName, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const SplitsRetrieveSplitNameEnum = {
    AcctManPodEnrollmentNueIntegration: 'acct_man_pod__enrollment_nue_integration',
    AcctManPodPlanPrice: 'acct_man_pod__plan_price',
    AcctManPodPlansAndBilling: 'acct_man_pod__plans_and_billing',
    AcctPodSellerOrderSummary: 'acct_pod__seller_order_summary',
    ActiveExperiments: 'active_experiments',
    AdsDashboardRecentlyPurchasedCarousel: 'ads_dashboard_recently_purchased_carousel',
    AdsEnableRecentlyPurchasedBrandsCarousel: 'ads_enable_recently_purchased_brands_carousel',
    AdsEnableShareMenu: 'ads_enable_share_menu',
    AdsEnableTopPurchasedProductsCarousel: 'ads_enable_top_purchased_products_carousel',
    AdsEnableVueifiedShareLeaflink: 'ads_enable_vueified_share_leaflink',
    AdsInPlatformProductPromotion: 'ads_in_platform_product_promotion',
    AdsKevelBuyerSellerDash: 'ads_kevel_buyer_seller_dash',
    AdsMolocoShopBrandsFeaturedBrands: 'ads_moloco_shop_brands_featured_brands',
    AdsMolocoShopBrandsSidebarBanners: 'ads_moloco_shop_brands_sidebar_banners',
    AdsPlatformPromotionAutomation: 'ads_platform_promotion_automation',
    AdsPodEnableMolocoAdReporting: 'ads_pod_enable_moloco_ad_reporting',
    AdsProductRecommendation: 'ads_product_recommendation',
    AdsProductRecommendationOrganicRecommendations: 'ads_product_recommendation_organic_recommendations',
    AdsProductSpotlight: 'ads_product_spotlight',
    AdsServeAlgoliaRecommendations: 'ads_serve_algolia_recommendations',
    AdsShoppableSkyscraper: 'ads_shoppable_skyscraper',
    AdsSponsorshipsInProductSearch: 'ads_sponsorships_in_product_search',
    BuyerSettingsStoreRequestsVue: 'buyer_settings_store_requests_vue',
    CanAccessCompanyGroupFeatures: 'can_access_company_group_features',
    CePodBuyerMetrcOnboarding: 'ce_pod__buyer_metrc_onboarding',
    CollabPodPaymentsInCrm: 'collab_pod__payments_in_crm',
    CollabPodPromoCodeDisplay: 'collab_pod__promo_code_display',
    CollabPodSalesRepEmailActions: 'collab_pod__sales_rep_email_actions',
    ComPodCartPaymentCta: 'com_pod__cart_payment_cta',
    ComPodCartPaymentOption: 'com_pod__cart_payment_option',
    ComPodReverseFactor: 'com_pod__reverse_factor',
    ComPodVendorMenu: 'com_pod__vendor_menu',
    CommerceAcceptPaymentsPaymentEvents: 'commerce__accept_payments_payment_events',
    CopPodBankLinking: 'cop_pod__bank_linking',
    CopPodPaymentsExplorationDashboardWidget: 'cop_pod__payments_exploration_dashboard_widget',
    CopPodTermsAndConditions: 'cop_pod__terms_and_conditions',
    CretPodVueifiedCompanyProfile: 'cret_pod__vueified_company_profile',
    CustomMenusEditProductRedirect: 'custom_menus__edit_product_redirect',
    EappsSageEnabled: 'eapps_sage_enabled',
    EnableLogisticsPermissionToAllUsers: 'enable_logistics_permission_to_all_users',
    EnterprisePodMultPaymentMethods: 'enterprise_pod__mult_payment_methods',
    EnterprisePodOrderFees: 'enterprise_pod__order_fees',
    FirePodCashbackRewards: 'fire_pod__cashback_rewards',
    FirePodDelinquentLockdown: 'fire_pod__delinquent_lockdown',
    FirePodDirectPayAutoAuthorization: 'fire_pod__direct_pay_auto_authorization',
    FirePodDirectPayEnabledStates: 'fire_pod__direct_pay_enabled_states',
    FirePodEnablePostCascade: 'fire_pod__enable_post_cascade',
    FirePodEnablePostWeeklySumView: 'fire_pod__enable_post_weekly_sum_view',
    FirePodMpAutoPausing: 'fire_pod__mp_auto_pausing',
    FirePodMpAutoPausingUpdate: 'fire_pod__mp_auto_pausing_update',
    FirePodMpBalanceChecks: 'fire_pod__mp_balance_checks',
    FirePodOrderAdjustmentsEventConsumer: 'fire_pod__order_adjustments_event_consumer',
    FirePodPostPackageServices: 'fire_pod__post_package_services',
    FirePodPostSettings: 'fire_pod__post_settings',
    FirePodSellerGlobalPostSettings: 'fire_pod__seller_global_post_settings',
    ForceSegmentReporting: 'force_segment_reporting',
    GroPodOrderSummaryInvitations: 'gro_pod__order_summary_invitations',
    GroPodPrintedMenu: 'gro_pod__printed_menu',
    GroPodVendorMenuUiEnhancement: 'gro_pod__vendor_menu_ui_enhancement',
    InboundShipmentsCreate: 'inbound_shipments_create',
    IntPodOrderPdfReport: 'int_pod__order_pdf_report',
    InventoryNegativeAvailableQuantityLogging: 'inventory_negative_available_quantity_logging',
    InventoryPodInventoryBatchSupport: 'inventory_pod__inventory_batch_support',
    InventoryPodInventoryWarehouseSupport: 'inventory_pod__inventory_warehouse_support',
    InventoryPodListingsAllocations: 'inventory_pod__listings_allocations',
    InventoryPodNewProductListPage: 'inventory_pod__new_product_list_page',
    KnockNotificationsToaster: 'knock_notifications_toaster',
    LiveInventoryIndicator: 'live_inventory_indicator',
    LlmBuyersClubRollout: 'llm_buyers_club_rollout',
    LlmGpoSellerReportV2: 'llm_gpo_seller_report_v2',
    LlmLeaflinkPlusEnrollmentBilling: 'llm_leaflink_plus_enrollment_billing',
    LlmLeaflinkPlusEnrollmentUpdates: 'llm_leaflink_plus_enrollment_updates',
    LlmSigmaGpoReport: 'llm_sigma_gpo_report',
    LlmVueSellerReports: 'llm_vue_seller_reports',
    LogisticsPodEnableAutoUpdateOfMetrcTemplates: 'logistics_pod__enable_auto_update_of_metrc_templates',
    LogisticsPodEnableCustomersToSelectTransportPartner: 'logistics_pod__enable_customers_to_select_transport_partner',
    LogisticsPodSubmitOrderViaCsvUpload: 'logistics_pod__submit_order_via_csv_upload',
    ManageLicenseAddIntegrationBuyer: 'manage_license__add_integration__buyer',
    ManageLicensesNewMetrcFlow: 'manage_licenses__new_metrc_flow',
    MessagingNotifications: 'messaging_notifications',
    NprPodIntegrationsSeller: 'npr_pod__integrations_seller',
    OgkPodKnockNotifications: 'ogk_pod__knock_notifications',
    OmsDataSyncEvents: 'oms_data_sync_events',
    OmsHistoricalDataSync: 'oms_historical_data_sync',
    OmsProductSyncEvents: 'oms_product_sync_events',
    OrderLatency: 'order_latency',
    OrderSummaryAncillaryEnhancements: 'order_summary_ancillary_enhancements',
    OrderSummaryReceiptLog: 'order_summary_receipt_log',
    OrdersInternalApprovals: 'orders_internal_approvals',
    OrdersReceivedDataview: 'orders_received_dataview',
    PauseInactiveLicenseCompanies: 'pause_inactive_license_companies',
    PaymentOnSellThroughEnrollment: 'payment_on_sell_through__enrollment',
    PlatArchPodOsoCloud: 'plat_arch_pod__oso_cloud',
    PlatArchPodUnifiedHijacking: 'plat_arch_pod__unified_hijacking',
    PostSignTermsAndConditionsForAllStaffUsers: 'post__sign_terms_and_conditions_for_all_staff_users',
    PostAllowRemovePostFlagFromOrder: 'post_allow_remove_post_flag_from_order',
    PostAutomatedPaymentsCalculation: 'post_automated_payments__calculation',
    PostOrderPreagreementSettings: 'post_order_preagreement_settings',
    PostStsUnitConversion: 'post_sts_unit_conversion',
    PsxPodBuyerDashboard: 'psx_pod__buyer_dashboard',
    ReplenishmentCatalogPage: 'replenishment_catalog_page',
    RetPodOrderMinimum: 'ret_pod__order_minimum',
    RetPodSplitOrders: 'ret_pod__split_orders',
    RetailCategoryManagementSelfService: 'retail_category_management_self_service',
    RetailProductLeaderboardNegotiate: 'retail_product_leaderboard_negotiate',
    RetentionPodBrandMenuSocialLinks: 'retention_pod__brand_menu_social_links',
    RetentionPodBuyerReports: 'retention_pod__buyer_reports',
    SeedToSaleBuyerNav: 'seed_to_sale__buyer_nav',
    SeedToSaleTransferTemplate: 'seed_to_sale__transfer_template',
    SeedToSaleCoaDownload: 'seed_to_sale_coa_download',
    SellerSettingsVue: 'seller_settings_vue',
    SettingsBuyerAccountDetails: 'settings__buyer_account_details',
    SettingsTaxSchedules: 'settings__tax_schedules',
    ShippingRequestDeliveryModal: 'shipping_request_delivery_modal',
    ShopBrandsPerformanceImprovement: 'shop_brands_performance_improvement',
    ShowSellThroughForNonPost: 'show_sell_through_for_non_post',
    SipsPodMpLicenseServiceApi: 'sips_pod__mp_license_service_api',
    SpliffPodCollabNotification: 'spliff_pod__collab_notification',
    SsrIframe: 'ssr_iframe',
    SupplyChainDeliveredStatus: 'supply_chain_delivered_status',
    SwitchCustomerForClonedOrders: 'switch_customer_for_cloned_orders',
    TracePodS2sTransfers: 'trace_pod__s2s_transfers',
    TracePodSearchByAssignedPackages: 'trace_pod__search_by_assigned_packages',
    TraceabilityBiotrackBuyerOnboarding: 'traceability__biotrack_buyer_onboarding',
    TraceabilityBiotrackSellerAttachManifest: 'traceability__biotrack_seller_attach_manifest',
    TraceabilityBiotrackSellerTransfersPage: 'traceability__biotrack_seller_transfers_page',
    TraceabilityPodAutomatedMetrcLicenseValidation: 'traceability_pod__automated_metrc_license_validation',
    TraceabilityPodBiotrackNewYork: 'traceability_pod__biotrack_new_york',
    TraceabilityPodCredentialEncryption: 'traceability_pod__credential_encryption',
    TraceabilityPodExperimentReconcileInventory: 'traceability_pod__experiment__reconcile_inventory',
    TraceabilityPodIntegrationSettings: 'traceability_pod__integration_settings',
    TransportPodMaNextDayDelivery: 'transport_pod__ma_next_day_delivery',
    TransportPodShippingSetOrderPayments: 'transport_pod__shipping_set_order_payments',
    VueBuyerNotificationSettings: 'vue_buyer_notification_settings',
    VueInventoryBulkPriceUpdate: 'vue_inventory_bulk_price_update',
    VueInventoryProductAddEditPage: 'vue_inventory_product_add_edit_page',
    VueInventoryProductLinePage: 'vue_inventory_product_line_page',
    VueMessagesPage: 'vue_messages_page',
    VueSettingsBrandsPage: 'vue_settings_brands_page'
} as const;
export type SplitsRetrieveSplitNameEnum = typeof SplitsRetrieveSplitNameEnum[keyof typeof SplitsRetrieveSplitNameEnum];


/**
 * StatesApi - axios parameter creator
 * @export
 */
export const StatesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * List states.
         * @summary List States
         * @param {boolean} logisticsEnabled2 If set to \&#39;true\&#39; endpoint will return only States that have at least one seller with enabled logistics.
         * @param {number} [limit] Number of results to return per page.
         * @param {boolean} [logisticsEnabled] 
         * @param {number} [offset] The initial index from which to return the results.
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {string} [search] A search term.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        statesList: async (logisticsEnabled2: boolean, limit?: number, logisticsEnabled?: boolean, offset?: number, ordering?: string, search?: string, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'logisticsEnabled2' is not null or undefined
            assertParamExists('statesList', 'logisticsEnabled2', logisticsEnabled2)
            const localVarPath = `/states`
                .replace(`{${"logistics_enabled"}}`, encodeURIComponent(String(logisticsEnabled2)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication tokenAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (logisticsEnabled !== undefined) {
                localVarQueryParameter['logistics_enabled'] = logisticsEnabled;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * State view set.
         * @param {number} id A unique integer value identifying this state.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        statesRetrieve: async (id: number, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('statesRetrieve', 'id', id)
            const localVarPath = `/states/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication tokenAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StatesApi - functional programming interface
 * @export
 */
export const StatesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = StatesApiAxiosParamCreator(configuration)
    return {
        /**
         * List states.
         * @summary List States
         * @param {boolean} logisticsEnabled2 If set to \&#39;true\&#39; endpoint will return only States that have at least one seller with enabled logistics.
         * @param {number} [limit] Number of results to return per page.
         * @param {boolean} [logisticsEnabled] 
         * @param {number} [offset] The initial index from which to return the results.
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {string} [search] A search term.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async statesList(logisticsEnabled2: boolean, limit?: number, logisticsEnabled?: boolean, offset?: number, ordering?: string, search?: string, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedStateList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.statesList(logisticsEnabled2, limit, logisticsEnabled, offset, ordering, search, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StatesApi.statesList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * State view set.
         * @param {number} id A unique integer value identifying this state.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async statesRetrieve(id: number, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StateUnifiedUpstreamMarketplace>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.statesRetrieve(id, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StatesApi.statesRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * StatesApi - factory interface
 * @export
 */
export const StatesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = StatesApiFp(configuration)
    return {
        /**
         * List states.
         * @summary List States
         * @param {StatesApiStatesListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        statesList(requestParameters: StatesApiStatesListRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedStateList> {
            return localVarFp.statesList(requestParameters.logisticsEnabled2, requestParameters.limit, requestParameters.logisticsEnabled, requestParameters.offset, requestParameters.ordering, requestParameters.search, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * State view set.
         * @param {StatesApiStatesRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        statesRetrieve(requestParameters: StatesApiStatesRetrieveRequest, options?: RawAxiosRequestConfig): AxiosPromise<StateUnifiedUpstreamMarketplace> {
            return localVarFp.statesRetrieve(requestParameters.id, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for statesList operation in StatesApi.
 * @export
 * @interface StatesApiStatesListRequest
 */
export interface StatesApiStatesListRequest {
    /**
     * If set to \&#39;true\&#39; endpoint will return only States that have at least one seller with enabled logistics.
     * @type {boolean}
     * @memberof StatesApiStatesList
     */
    readonly logisticsEnabled2: boolean

    /**
     * Number of results to return per page.
     * @type {number}
     * @memberof StatesApiStatesList
     */
    readonly limit?: number

    /**
     * 
     * @type {boolean}
     * @memberof StatesApiStatesList
     */
    readonly logisticsEnabled?: boolean

    /**
     * The initial index from which to return the results.
     * @type {number}
     * @memberof StatesApiStatesList
     */
    readonly offset?: number

    /**
     * Which field to use when ordering the results.
     * @type {string}
     * @memberof StatesApiStatesList
     */
    readonly ordering?: string

    /**
     * A search term.
     * @type {string}
     * @memberof StatesApiStatesList
     */
    readonly search?: string

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof StatesApiStatesList
     */
    readonly leafLinkVersion?: string
}

/**
 * Request parameters for statesRetrieve operation in StatesApi.
 * @export
 * @interface StatesApiStatesRetrieveRequest
 */
export interface StatesApiStatesRetrieveRequest {
    /**
     * A unique integer value identifying this state.
     * @type {number}
     * @memberof StatesApiStatesRetrieve
     */
    readonly id: number

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof StatesApiStatesRetrieve
     */
    readonly leafLinkVersion?: string
}

/**
 * StatesApi - object-oriented interface
 * @export
 * @class StatesApi
 * @extends {BaseAPI}
 */
export class StatesApi extends BaseAPI {
    /**
     * List states.
     * @summary List States
     * @param {StatesApiStatesListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatesApi
     */
    public statesList(requestParameters: StatesApiStatesListRequest, options?: RawAxiosRequestConfig) {
        return StatesApiFp(this.configuration).statesList(requestParameters.logisticsEnabled2, requestParameters.limit, requestParameters.logisticsEnabled, requestParameters.offset, requestParameters.ordering, requestParameters.search, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * State view set.
     * @param {StatesApiStatesRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatesApi
     */
    public statesRetrieve(requestParameters: StatesApiStatesRetrieveRequest, options?: RawAxiosRequestConfig) {
        return StatesApiFp(this.configuration).statesRetrieve(requestParameters.id, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * StrainApi - axios parameter creator
 * @export
 */
export const StrainApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * List multiple Strain Classifications.
         * @summary List Strain Clasifications
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {string} [search] A search term.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        strainClassificationsList: async (ordering?: string, search?: string, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/strain_classifications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List multiple Strains.
         * @summary List Strains
         * @param {Array<number>} [company] Multiple values may be separated by commas.
         * @param {boolean} [companyIsnull] 
         * @param {string} [companySlug] 
         * @param {Array<number>} [id] Multiple values may be separated by commas.
         * @param {string} [name] 
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {Array<string>} [strainClassification] Multiple values may be separated by commas.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        strainsList: async (company?: Array<number>, companyIsnull?: boolean, companySlug?: string, id?: Array<number>, name?: string, ordering?: string, page?: number, pageSize?: number, search?: string, strainClassification?: Array<string>, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/strains`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication tokenAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (company) {
                localVarQueryParameter['company'] = company.join(COLLECTION_FORMATS.csv);
            }

            if (companyIsnull !== undefined) {
                localVarQueryParameter['company__isnull'] = companyIsnull;
            }

            if (companySlug !== undefined) {
                localVarQueryParameter['company_slug'] = companySlug;
            }

            if (id) {
                localVarQueryParameter['id'] = id.join(COLLECTION_FORMATS.csv);
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (strainClassification) {
                localVarQueryParameter['strain_classification'] = strainClassification.join(COLLECTION_FORMATS.csv);
            }


    
            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a single Strain.
         * @summary Get Strain
         * @param {number} id A unique integer value identifying this strain.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        strainsRetrieve: async (id: number, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('strainsRetrieve', 'id', id)
            const localVarPath = `/strains/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication tokenAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StrainApi - functional programming interface
 * @export
 */
export const StrainApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = StrainApiAxiosParamCreator(configuration)
    return {
        /**
         * List multiple Strain Classifications.
         * @summary List Strain Clasifications
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {string} [search] A search term.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async strainClassificationsList(ordering?: string, search?: string, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Choice>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.strainClassificationsList(ordering, search, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StrainApi.strainClassificationsList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List multiple Strains.
         * @summary List Strains
         * @param {Array<number>} [company] Multiple values may be separated by commas.
         * @param {boolean} [companyIsnull] 
         * @param {string} [companySlug] 
         * @param {Array<number>} [id] Multiple values may be separated by commas.
         * @param {string} [name] 
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {Array<string>} [strainClassification] Multiple values may be separated by commas.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async strainsList(company?: Array<number>, companyIsnull?: boolean, companySlug?: string, id?: Array<number>, name?: string, ordering?: string, page?: number, pageSize?: number, search?: string, strainClassification?: Array<string>, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedUnifiedStrainList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.strainsList(company, companyIsnull, companySlug, id, name, ordering, page, pageSize, search, strainClassification, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StrainApi.strainsList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a single Strain.
         * @summary Get Strain
         * @param {number} id A unique integer value identifying this strain.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async strainsRetrieve(id: number, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnifiedStrain>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.strainsRetrieve(id, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StrainApi.strainsRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * StrainApi - factory interface
 * @export
 */
export const StrainApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = StrainApiFp(configuration)
    return {
        /**
         * List multiple Strain Classifications.
         * @summary List Strain Clasifications
         * @param {StrainApiStrainClassificationsListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        strainClassificationsList(requestParameters: StrainApiStrainClassificationsListRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<Choice>> {
            return localVarFp.strainClassificationsList(requestParameters.ordering, requestParameters.search, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * List multiple Strains.
         * @summary List Strains
         * @param {StrainApiStrainsListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        strainsList(requestParameters: StrainApiStrainsListRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedUnifiedStrainList> {
            return localVarFp.strainsList(requestParameters.company, requestParameters.companyIsnull, requestParameters.companySlug, requestParameters.id, requestParameters.name, requestParameters.ordering, requestParameters.page, requestParameters.pageSize, requestParameters.search, requestParameters.strainClassification, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a single Strain.
         * @summary Get Strain
         * @param {StrainApiStrainsRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        strainsRetrieve(requestParameters: StrainApiStrainsRetrieveRequest, options?: RawAxiosRequestConfig): AxiosPromise<UnifiedStrain> {
            return localVarFp.strainsRetrieve(requestParameters.id, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for strainClassificationsList operation in StrainApi.
 * @export
 * @interface StrainApiStrainClassificationsListRequest
 */
export interface StrainApiStrainClassificationsListRequest {
    /**
     * Which field to use when ordering the results.
     * @type {string}
     * @memberof StrainApiStrainClassificationsList
     */
    readonly ordering?: string

    /**
     * A search term.
     * @type {string}
     * @memberof StrainApiStrainClassificationsList
     */
    readonly search?: string

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof StrainApiStrainClassificationsList
     */
    readonly leafLinkVersion?: string
}

/**
 * Request parameters for strainsList operation in StrainApi.
 * @export
 * @interface StrainApiStrainsListRequest
 */
export interface StrainApiStrainsListRequest {
    /**
     * Multiple values may be separated by commas.
     * @type {Array<number>}
     * @memberof StrainApiStrainsList
     */
    readonly company?: Array<number>

    /**
     * 
     * @type {boolean}
     * @memberof StrainApiStrainsList
     */
    readonly companyIsnull?: boolean

    /**
     * 
     * @type {string}
     * @memberof StrainApiStrainsList
     */
    readonly companySlug?: string

    /**
     * Multiple values may be separated by commas.
     * @type {Array<number>}
     * @memberof StrainApiStrainsList
     */
    readonly id?: Array<number>

    /**
     * 
     * @type {string}
     * @memberof StrainApiStrainsList
     */
    readonly name?: string

    /**
     * Which field to use when ordering the results.
     * @type {string}
     * @memberof StrainApiStrainsList
     */
    readonly ordering?: string

    /**
     * A page number within the paginated result set.
     * @type {number}
     * @memberof StrainApiStrainsList
     */
    readonly page?: number

    /**
     * Number of results to return per page.
     * @type {number}
     * @memberof StrainApiStrainsList
     */
    readonly pageSize?: number

    /**
     * A search term.
     * @type {string}
     * @memberof StrainApiStrainsList
     */
    readonly search?: string

    /**
     * Multiple values may be separated by commas.
     * @type {Array<string>}
     * @memberof StrainApiStrainsList
     */
    readonly strainClassification?: Array<string>

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof StrainApiStrainsList
     */
    readonly leafLinkVersion?: string
}

/**
 * Request parameters for strainsRetrieve operation in StrainApi.
 * @export
 * @interface StrainApiStrainsRetrieveRequest
 */
export interface StrainApiStrainsRetrieveRequest {
    /**
     * A unique integer value identifying this strain.
     * @type {number}
     * @memberof StrainApiStrainsRetrieve
     */
    readonly id: number

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof StrainApiStrainsRetrieve
     */
    readonly leafLinkVersion?: string
}

/**
 * StrainApi - object-oriented interface
 * @export
 * @class StrainApi
 * @extends {BaseAPI}
 */
export class StrainApi extends BaseAPI {
    /**
     * List multiple Strain Classifications.
     * @summary List Strain Clasifications
     * @param {StrainApiStrainClassificationsListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StrainApi
     */
    public strainClassificationsList(requestParameters: StrainApiStrainClassificationsListRequest = {}, options?: RawAxiosRequestConfig) {
        return StrainApiFp(this.configuration).strainClassificationsList(requestParameters.ordering, requestParameters.search, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List multiple Strains.
     * @summary List Strains
     * @param {StrainApiStrainsListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StrainApi
     */
    public strainsList(requestParameters: StrainApiStrainsListRequest = {}, options?: RawAxiosRequestConfig) {
        return StrainApiFp(this.configuration).strainsList(requestParameters.company, requestParameters.companyIsnull, requestParameters.companySlug, requestParameters.id, requestParameters.name, requestParameters.ordering, requestParameters.page, requestParameters.pageSize, requestParameters.search, requestParameters.strainClassification, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a single Strain.
     * @summary Get Strain
     * @param {StrainApiStrainsRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StrainApi
     */
    public strainsRetrieve(requestParameters: StrainApiStrainsRetrieveRequest, options?: RawAxiosRequestConfig) {
        return StrainApiFp(this.configuration).strainsRetrieve(requestParameters.id, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TaxesApi - axios parameter creator
 * @export
 */
export const TaxesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create a new TaxSchedule.
         * @param {number} companyId The ID of the viewing company
         * @param {CreateInputRequest} createInputRequest 
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        taxesTaxSchedulesCreate: async (companyId: number, createInputRequest: CreateInputRequest, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('taxesTaxSchedulesCreate', 'companyId', companyId)
            // verify required parameter 'createInputRequest' is not null or undefined
            assertParamExists('taxesTaxSchedulesCreate', 'createInputRequest', createInputRequest)
            const localVarPath = `/taxes/tax_schedules`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (companyId !== undefined) {
                localVarQueryParameter['company_id'] = companyId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createInputRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a TaxSchedule... well, mark it as archived.
         * @param {number} companyId The ID of the viewing company
         * @param {number} id A unique integer value identifying this tax schedule.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        taxesTaxSchedulesDestroy: async (companyId: number, id: number, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('taxesTaxSchedulesDestroy', 'companyId', companyId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('taxesTaxSchedulesDestroy', 'id', id)
            const localVarPath = `/taxes/tax_schedules/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (companyId !== undefined) {
                localVarQueryParameter['company_id'] = companyId;
            }


    
            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get tax schedules for company.
         * @param {number} companyId The ID of the viewing company
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        taxesTaxSchedulesList: async (companyId: number, ordering?: string, page?: number, pageSize?: number, search?: string, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('taxesTaxSchedulesList', 'companyId', companyId)
            const localVarPath = `/taxes/tax_schedules`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (companyId !== undefined) {
                localVarQueryParameter['company_id'] = companyId;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a TaxSchedule by marking it as archived and creating a new one.
         * @param {number} companyId The ID of the viewing company
         * @param {number} id A unique integer value identifying this tax schedule.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {PatchedUpdateInputRequest} [patchedUpdateInputRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        taxesTaxSchedulesPartialUpdate: async (companyId: number, id: number, leafLinkVersion?: string, patchedUpdateInputRequest?: PatchedUpdateInputRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('taxesTaxSchedulesPartialUpdate', 'companyId', companyId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('taxesTaxSchedulesPartialUpdate', 'id', id)
            const localVarPath = `/taxes/tax_schedules/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (companyId !== undefined) {
                localVarQueryParameter['company_id'] = companyId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchedUpdateInputRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get tax schedule by ID for company.
         * @param {number} companyId The ID of the viewing company
         * @param {number} id A unique integer value identifying this tax schedule.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        taxesTaxSchedulesRetrieve: async (companyId: number, id: number, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('taxesTaxSchedulesRetrieve', 'companyId', companyId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('taxesTaxSchedulesRetrieve', 'id', id)
            const localVarPath = `/taxes/tax_schedules/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (companyId !== undefined) {
                localVarQueryParameter['company_id'] = companyId;
            }


    
            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TaxesApi - functional programming interface
 * @export
 */
export const TaxesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TaxesApiAxiosParamCreator(configuration)
    return {
        /**
         * Create a new TaxSchedule.
         * @param {number} companyId The ID of the viewing company
         * @param {CreateInputRequest} createInputRequest 
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async taxesTaxSchedulesCreate(companyId: number, createInputRequest: CreateInputRequest, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateUpdateSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.taxesTaxSchedulesCreate(companyId, createInputRequest, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxesApi.taxesTaxSchedulesCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a TaxSchedule... well, mark it as archived.
         * @param {number} companyId The ID of the viewing company
         * @param {number} id A unique integer value identifying this tax schedule.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async taxesTaxSchedulesDestroy(companyId: number, id: number, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.taxesTaxSchedulesDestroy(companyId, id, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxesApi.taxesTaxSchedulesDestroy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get tax schedules for company.
         * @param {number} companyId The ID of the viewing company
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async taxesTaxSchedulesList(companyId: number, ordering?: string, page?: number, pageSize?: number, search?: string, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedUnifiedTaxScheduleList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.taxesTaxSchedulesList(companyId, ordering, page, pageSize, search, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxesApi.taxesTaxSchedulesList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update a TaxSchedule by marking it as archived and creating a new one.
         * @param {number} companyId The ID of the viewing company
         * @param {number} id A unique integer value identifying this tax schedule.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {PatchedUpdateInputRequest} [patchedUpdateInputRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async taxesTaxSchedulesPartialUpdate(companyId: number, id: number, leafLinkVersion?: string, patchedUpdateInputRequest?: PatchedUpdateInputRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateUpdateSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.taxesTaxSchedulesPartialUpdate(companyId, id, leafLinkVersion, patchedUpdateInputRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxesApi.taxesTaxSchedulesPartialUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get tax schedule by ID for company.
         * @param {number} companyId The ID of the viewing company
         * @param {number} id A unique integer value identifying this tax schedule.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async taxesTaxSchedulesRetrieve(companyId: number, id: number, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnifiedTaxSchedule>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.taxesTaxSchedulesRetrieve(companyId, id, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxesApi.taxesTaxSchedulesRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TaxesApi - factory interface
 * @export
 */
export const TaxesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TaxesApiFp(configuration)
    return {
        /**
         * Create a new TaxSchedule.
         * @param {TaxesApiTaxesTaxSchedulesCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        taxesTaxSchedulesCreate(requestParameters: TaxesApiTaxesTaxSchedulesCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateUpdateSuccessResponse> {
            return localVarFp.taxesTaxSchedulesCreate(requestParameters.companyId, requestParameters.createInputRequest, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a TaxSchedule... well, mark it as archived.
         * @param {TaxesApiTaxesTaxSchedulesDestroyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        taxesTaxSchedulesDestroy(requestParameters: TaxesApiTaxesTaxSchedulesDestroyRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.taxesTaxSchedulesDestroy(requestParameters.companyId, requestParameters.id, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * Get tax schedules for company.
         * @param {TaxesApiTaxesTaxSchedulesListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        taxesTaxSchedulesList(requestParameters: TaxesApiTaxesTaxSchedulesListRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedUnifiedTaxScheduleList> {
            return localVarFp.taxesTaxSchedulesList(requestParameters.companyId, requestParameters.ordering, requestParameters.page, requestParameters.pageSize, requestParameters.search, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a TaxSchedule by marking it as archived and creating a new one.
         * @param {TaxesApiTaxesTaxSchedulesPartialUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        taxesTaxSchedulesPartialUpdate(requestParameters: TaxesApiTaxesTaxSchedulesPartialUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateUpdateSuccessResponse> {
            return localVarFp.taxesTaxSchedulesPartialUpdate(requestParameters.companyId, requestParameters.id, requestParameters.leafLinkVersion, requestParameters.patchedUpdateInputRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Get tax schedule by ID for company.
         * @param {TaxesApiTaxesTaxSchedulesRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        taxesTaxSchedulesRetrieve(requestParameters: TaxesApiTaxesTaxSchedulesRetrieveRequest, options?: RawAxiosRequestConfig): AxiosPromise<UnifiedTaxSchedule> {
            return localVarFp.taxesTaxSchedulesRetrieve(requestParameters.companyId, requestParameters.id, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for taxesTaxSchedulesCreate operation in TaxesApi.
 * @export
 * @interface TaxesApiTaxesTaxSchedulesCreateRequest
 */
export interface TaxesApiTaxesTaxSchedulesCreateRequest {
    /**
     * The ID of the viewing company
     * @type {number}
     * @memberof TaxesApiTaxesTaxSchedulesCreate
     */
    readonly companyId: number

    /**
     * 
     * @type {CreateInputRequest}
     * @memberof TaxesApiTaxesTaxSchedulesCreate
     */
    readonly createInputRequest: CreateInputRequest

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof TaxesApiTaxesTaxSchedulesCreate
     */
    readonly leafLinkVersion?: string
}

/**
 * Request parameters for taxesTaxSchedulesDestroy operation in TaxesApi.
 * @export
 * @interface TaxesApiTaxesTaxSchedulesDestroyRequest
 */
export interface TaxesApiTaxesTaxSchedulesDestroyRequest {
    /**
     * The ID of the viewing company
     * @type {number}
     * @memberof TaxesApiTaxesTaxSchedulesDestroy
     */
    readonly companyId: number

    /**
     * A unique integer value identifying this tax schedule.
     * @type {number}
     * @memberof TaxesApiTaxesTaxSchedulesDestroy
     */
    readonly id: number

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof TaxesApiTaxesTaxSchedulesDestroy
     */
    readonly leafLinkVersion?: string
}

/**
 * Request parameters for taxesTaxSchedulesList operation in TaxesApi.
 * @export
 * @interface TaxesApiTaxesTaxSchedulesListRequest
 */
export interface TaxesApiTaxesTaxSchedulesListRequest {
    /**
     * The ID of the viewing company
     * @type {number}
     * @memberof TaxesApiTaxesTaxSchedulesList
     */
    readonly companyId: number

    /**
     * Which field to use when ordering the results.
     * @type {string}
     * @memberof TaxesApiTaxesTaxSchedulesList
     */
    readonly ordering?: string

    /**
     * A page number within the paginated result set.
     * @type {number}
     * @memberof TaxesApiTaxesTaxSchedulesList
     */
    readonly page?: number

    /**
     * Number of results to return per page.
     * @type {number}
     * @memberof TaxesApiTaxesTaxSchedulesList
     */
    readonly pageSize?: number

    /**
     * A search term.
     * @type {string}
     * @memberof TaxesApiTaxesTaxSchedulesList
     */
    readonly search?: string

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof TaxesApiTaxesTaxSchedulesList
     */
    readonly leafLinkVersion?: string
}

/**
 * Request parameters for taxesTaxSchedulesPartialUpdate operation in TaxesApi.
 * @export
 * @interface TaxesApiTaxesTaxSchedulesPartialUpdateRequest
 */
export interface TaxesApiTaxesTaxSchedulesPartialUpdateRequest {
    /**
     * The ID of the viewing company
     * @type {number}
     * @memberof TaxesApiTaxesTaxSchedulesPartialUpdate
     */
    readonly companyId: number

    /**
     * A unique integer value identifying this tax schedule.
     * @type {number}
     * @memberof TaxesApiTaxesTaxSchedulesPartialUpdate
     */
    readonly id: number

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof TaxesApiTaxesTaxSchedulesPartialUpdate
     */
    readonly leafLinkVersion?: string

    /**
     * 
     * @type {PatchedUpdateInputRequest}
     * @memberof TaxesApiTaxesTaxSchedulesPartialUpdate
     */
    readonly patchedUpdateInputRequest?: PatchedUpdateInputRequest
}

/**
 * Request parameters for taxesTaxSchedulesRetrieve operation in TaxesApi.
 * @export
 * @interface TaxesApiTaxesTaxSchedulesRetrieveRequest
 */
export interface TaxesApiTaxesTaxSchedulesRetrieveRequest {
    /**
     * The ID of the viewing company
     * @type {number}
     * @memberof TaxesApiTaxesTaxSchedulesRetrieve
     */
    readonly companyId: number

    /**
     * A unique integer value identifying this tax schedule.
     * @type {number}
     * @memberof TaxesApiTaxesTaxSchedulesRetrieve
     */
    readonly id: number

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof TaxesApiTaxesTaxSchedulesRetrieve
     */
    readonly leafLinkVersion?: string
}

/**
 * TaxesApi - object-oriented interface
 * @export
 * @class TaxesApi
 * @extends {BaseAPI}
 */
export class TaxesApi extends BaseAPI {
    /**
     * Create a new TaxSchedule.
     * @param {TaxesApiTaxesTaxSchedulesCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaxesApi
     */
    public taxesTaxSchedulesCreate(requestParameters: TaxesApiTaxesTaxSchedulesCreateRequest, options?: RawAxiosRequestConfig) {
        return TaxesApiFp(this.configuration).taxesTaxSchedulesCreate(requestParameters.companyId, requestParameters.createInputRequest, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a TaxSchedule... well, mark it as archived.
     * @param {TaxesApiTaxesTaxSchedulesDestroyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaxesApi
     */
    public taxesTaxSchedulesDestroy(requestParameters: TaxesApiTaxesTaxSchedulesDestroyRequest, options?: RawAxiosRequestConfig) {
        return TaxesApiFp(this.configuration).taxesTaxSchedulesDestroy(requestParameters.companyId, requestParameters.id, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get tax schedules for company.
     * @param {TaxesApiTaxesTaxSchedulesListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaxesApi
     */
    public taxesTaxSchedulesList(requestParameters: TaxesApiTaxesTaxSchedulesListRequest, options?: RawAxiosRequestConfig) {
        return TaxesApiFp(this.configuration).taxesTaxSchedulesList(requestParameters.companyId, requestParameters.ordering, requestParameters.page, requestParameters.pageSize, requestParameters.search, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a TaxSchedule by marking it as archived and creating a new one.
     * @param {TaxesApiTaxesTaxSchedulesPartialUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaxesApi
     */
    public taxesTaxSchedulesPartialUpdate(requestParameters: TaxesApiTaxesTaxSchedulesPartialUpdateRequest, options?: RawAxiosRequestConfig) {
        return TaxesApiFp(this.configuration).taxesTaxSchedulesPartialUpdate(requestParameters.companyId, requestParameters.id, requestParameters.leafLinkVersion, requestParameters.patchedUpdateInputRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get tax schedule by ID for company.
     * @param {TaxesApiTaxesTaxSchedulesRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaxesApi
     */
    public taxesTaxSchedulesRetrieve(requestParameters: TaxesApiTaxesTaxSchedulesRetrieveRequest, options?: RawAxiosRequestConfig) {
        return TaxesApiFp(this.configuration).taxesTaxSchedulesRetrieve(requestParameters.companyId, requestParameters.id, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TraceabilityApi - axios parameter creator
 * @export
 */
export const TraceabilityApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Reconcile inventory for products, utilizes marketplace celery tasks + traceability service data.
         * @param {number} companyId The ID of the viewing company
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {PatchedTraceabilityRefreshProductsPackagesRequest} [patchedTraceabilityRefreshProductsPackagesRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        traceabilityActionsRefreshProductsPackagesPartialUpdate: async (companyId: number, leafLinkVersion?: string, patchedTraceabilityRefreshProductsPackagesRequest?: PatchedTraceabilityRefreshProductsPackagesRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('traceabilityActionsRefreshProductsPackagesPartialUpdate', 'companyId', companyId)
            const localVarPath = `/traceability/actions/refresh_products_packages`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (companyId !== undefined) {
                localVarQueryParameter['company_id'] = companyId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchedTraceabilityRefreshProductsPackagesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Perform refresh for specified resource types and optional datetime.
         * @param {number} companyId The ID of the viewing company
         * @param {string} types Comma-separated list of resource types to refresh
         * @param {string} [endDate] Resource refresh end date
         * @param {string} [startDate] Resource refresh start date
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        traceabilityActionsRefreshResourcesRetrieve: async (companyId: number, types: string, endDate?: string, startDate?: string, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('traceabilityActionsRefreshResourcesRetrieve', 'companyId', companyId)
            // verify required parameter 'types' is not null or undefined
            assertParamExists('traceabilityActionsRefreshResourcesRetrieve', 'types', types)
            const localVarPath = `/traceability/actions/refresh_resources`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (companyId !== undefined) {
                localVarQueryParameter['company_id'] = companyId;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString().substring(0,10) :
                    endDate;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString().substring(0,10) :
                    startDate;
            }

            if (types !== undefined) {
                localVarQueryParameter['types'] = types;
            }


    
            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new company in the traceability service.
         * @param {number} companyId The ID of the viewing company
         * @param {CompanyCreateRequest} companyCreateRequest 
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        traceabilityCompaniesCreate: async (companyId: number, companyCreateRequest: CompanyCreateRequest, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('traceabilityCompaniesCreate', 'companyId', companyId)
            // verify required parameter 'companyCreateRequest' is not null or undefined
            assertParamExists('traceabilityCompaniesCreate', 'companyCreateRequest', companyCreateRequest)
            const localVarPath = `/traceability/companies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (companyId !== undefined) {
                localVarQueryParameter['company_id'] = companyId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(companyCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a company in the traceability service.
         * @param {number} companyId The ID of the viewing company
         * @param {number} id ID of requested company
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {PatchedCompanyUpdateRequest} [patchedCompanyUpdateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        traceabilityCompaniesPartialUpdate: async (companyId: number, id: number, leafLinkVersion?: string, patchedCompanyUpdateRequest?: PatchedCompanyUpdateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('traceabilityCompaniesPartialUpdate', 'companyId', companyId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('traceabilityCompaniesPartialUpdate', 'id', id)
            const localVarPath = `/traceability/companies/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (companyId !== undefined) {
                localVarQueryParameter['company_id'] = companyId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchedCompanyUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get company by ID.
         * @param {number} companyId The ID of the viewing company
         * @param {number} id ID of requested company
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        traceabilityCompaniesRetrieve: async (companyId: number, id: number, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('traceabilityCompaniesRetrieve', 'companyId', companyId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('traceabilityCompaniesRetrieve', 'id', id)
            const localVarPath = `/traceability/companies/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (companyId !== undefined) {
                localVarQueryParameter['company_id'] = companyId;
            }


    
            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get company customers.
         * @param {number} companyId The ID of the viewing company
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        traceabilityCompanyCustomersList: async (companyId: number, ordering?: string, page?: number, pageSize?: number, search?: string, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('traceabilityCompanyCustomersList', 'companyId', companyId)
            const localVarPath = `/traceability/company_customers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (companyId !== undefined) {
                localVarQueryParameter['company_id'] = companyId;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get company customer by ID.
         * @param {number} companyId The ID of the viewing company
         * @param {number} id A unique integer value identifying this company customer.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        traceabilityCompanyCustomersRetrieve: async (companyId: number, id: number, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('traceabilityCompanyCustomersRetrieve', 'companyId', companyId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('traceabilityCompanyCustomersRetrieve', 'id', id)
            const localVarPath = `/traceability/company_customers/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (companyId !== undefined) {
                localVarQueryParameter['company_id'] = companyId;
            }


    
            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get company licenses
         * @param {number} companyId The ID of the viewing company
         * @param {LicenseApiKeyRequest} licenseApiKeyRequest 
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        traceabilityCompanyLicensesCreate: async (companyId: number, licenseApiKeyRequest: LicenseApiKeyRequest, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('traceabilityCompanyLicensesCreate', 'companyId', companyId)
            // verify required parameter 'licenseApiKeyRequest' is not null or undefined
            assertParamExists('traceabilityCompanyLicensesCreate', 'licenseApiKeyRequest', licenseApiKeyRequest)
            const localVarPath = `/traceability/company_licenses/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (companyId !== undefined) {
                localVarQueryParameter['company_id'] = companyId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(licenseApiKeyRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a company\'s integration.
         * @param {number} companyId The ID of the viewing company
         * @param {number} id ID of integration to modify
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        traceabilityCompanySettingDestroy: async (companyId: number, id: number, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('traceabilityCompanySettingDestroy', 'companyId', companyId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('traceabilityCompanySettingDestroy', 'id', id)
            const localVarPath = `/traceability/company_setting/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (companyId !== undefined) {
                localVarQueryParameter['company_id'] = companyId;
            }


    
            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new driver in the traceability service.
         * @param {number} companyId The ID of the viewing company
         * @param {TraceabilityDriverCreateUpdateInputRequest} traceabilityDriverCreateUpdateInputRequest 
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        traceabilityDriversCreate: async (companyId: number, traceabilityDriverCreateUpdateInputRequest: TraceabilityDriverCreateUpdateInputRequest, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('traceabilityDriversCreate', 'companyId', companyId)
            // verify required parameter 'traceabilityDriverCreateUpdateInputRequest' is not null or undefined
            assertParamExists('traceabilityDriversCreate', 'traceabilityDriverCreateUpdateInputRequest', traceabilityDriverCreateUpdateInputRequest)
            const localVarPath = `/traceability/drivers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (companyId !== undefined) {
                localVarQueryParameter['company_id'] = companyId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(traceabilityDriverCreateUpdateInputRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all drivers for company
         * @param {number} companyId The ID of the viewing company
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] Search term to filter the list by
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        traceabilityDriversList: async (companyId: number, ordering?: string, page?: number, pageSize?: number, search?: string, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('traceabilityDriversList', 'companyId', companyId)
            const localVarPath = `/traceability/drivers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (companyId !== undefined) {
                localVarQueryParameter['company_id'] = companyId;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a driver in the traceability service.
         * @param {number} companyId The ID of the viewing company
         * @param {string} externalId Vendor external ID of object to be updated
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {PatchedTraceabilityDriverCreateUpdateInputRequest} [patchedTraceabilityDriverCreateUpdateInputRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        traceabilityDriversPartialUpdate: async (companyId: number, externalId: string, leafLinkVersion?: string, patchedTraceabilityDriverCreateUpdateInputRequest?: PatchedTraceabilityDriverCreateUpdateInputRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('traceabilityDriversPartialUpdate', 'companyId', companyId)
            // verify required parameter 'externalId' is not null or undefined
            assertParamExists('traceabilityDriversPartialUpdate', 'externalId', externalId)
            const localVarPath = `/traceability/drivers/{external_id}`
                .replace(`{${"external_id"}}`, encodeURIComponent(String(externalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (companyId !== undefined) {
                localVarQueryParameter['company_id'] = companyId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchedTraceabilityDriverCreateUpdateInputRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all items from the traceability service for a company.
         * @param {number} companyId The ID of the viewing company
         * @param {boolean} [includeStrainData] Boolean to indicate whether strain data should be included
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] Search term to filter the list by
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        traceabilityItemsList: async (companyId: number, includeStrainData?: boolean, ordering?: string, page?: number, pageSize?: number, search?: string, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('traceabilityItemsList', 'companyId', companyId)
            const localVarPath = `/traceability/items`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (companyId !== undefined) {
                localVarQueryParameter['company_id'] = companyId;
            }

            if (includeStrainData !== undefined) {
                localVarQueryParameter['include_strain_data'] = includeStrainData;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get onboarding status.
         * @param {number} id ID of requested company
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        traceabilityOnboardingStatusRetrieve: async (id: number, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('traceabilityOnboardingStatusRetrieve', 'id', id)
            const localVarPath = `/traceability/onboarding_status/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Unified API Orders by Package Labels.
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        traceabilityOrdersByPackageLabelsList: async (ordering?: string, page?: number, pageSize?: number, search?: string, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/traceability/orders_by_package_labels`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Unified API Orders by Package Labels.
         * @param {number} id A unique integer value identifying this attached package.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        traceabilityOrdersByPackageLabelsRetrieve: async (id: number, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('traceabilityOrdersByPackageLabelsRetrieve', 'id', id)
            const localVarPath = `/traceability/orders_by_package_labels/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get company packages
         * @param {number} companyId The ID of the viewing company
         * @param {boolean} [assigned] Filter by Traceability.common_packages that are assigned/unassigned products
         * @param {number} [cbdMax] Filter by Traceability.common_packages with a CBD value less than or equal to the given value
         * @param {number} [cbdMin] Filter by Traceability.common_packages with a CBD value greater than or equal to the given value
         * @param {boolean} [hideAttachedPackages] Filter out any Traceability.common_package that has already been assigned to an order line-item
         * @param {boolean} [includeSourcePackages] Indicate whether to include a list of source_package_labels in the response
         * @param {string} [item] Filter by Traceability.metrc_package.item_id (accepts comma-separated list)
         * @param {string} [labTestingStatus] Filter by Traceability.common_package.metrc_package.lab_testing_status (accepts comma-separated list)
         * @param {string} [label] Filter by Traceability.common_package.label (accepts comma-separated list)
         * @param {string} [licenseNumber] Filter by Traceability.common_package.license_number (accepts comma-separated list)
         * @param {number} [limit] Limit for results, hard-cap of 25 enforced, default 25
         * @param {string} [location] Filter by Traceability.common_package.location_id (accepts comma-separated list)
         * @param {string} [manifestNumber] Filter Traceability.common_package by packages associated with manifest
         * @param {number} [offset] Used for pagination
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {string} [packagedDate] Filter by Traceability.metrc_package.packaged_date (accepts comma-separated list)
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [productIds] Filter Traceability.common_package by product_ids assigned to packages (accepts comma-separated list)
         * @param {string} [search] Search term to filter the list by
         * @param {string} [sourcePackage] Filter Traceability.common_package by packages that are children of the given label
         * @param {string} [status] Filter by Traceability.common_package.status field
         * @param {string} [templateId] Filter Traceability.common_package by packages assigned to template
         * @param {number} [thcMax] Filter by Traceability.common_packages with a THC value less than or equal to the given value
         * @param {number} [thcMin] Filter by Traceability.common_packages with a THC value greater than or equal to the given value
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        traceabilityPackagesList: async (companyId: number, assigned?: boolean, cbdMax?: number, cbdMin?: number, hideAttachedPackages?: boolean, includeSourcePackages?: boolean, item?: string, labTestingStatus?: string, label?: string, licenseNumber?: string, limit?: number, location?: string, manifestNumber?: string, offset?: number, ordering?: string, packagedDate?: string, page?: number, pageSize?: number, productIds?: string, search?: string, sourcePackage?: string, status?: string, templateId?: string, thcMax?: number, thcMin?: number, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('traceabilityPackagesList', 'companyId', companyId)
            const localVarPath = `/traceability/packages`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (assigned !== undefined) {
                localVarQueryParameter['assigned'] = assigned;
            }

            if (cbdMax !== undefined) {
                localVarQueryParameter['cbd_max'] = cbdMax;
            }

            if (cbdMin !== undefined) {
                localVarQueryParameter['cbd_min'] = cbdMin;
            }

            if (companyId !== undefined) {
                localVarQueryParameter['company_id'] = companyId;
            }

            if (hideAttachedPackages !== undefined) {
                localVarQueryParameter['hide_attached_packages'] = hideAttachedPackages;
            }

            if (includeSourcePackages !== undefined) {
                localVarQueryParameter['include_source_packages'] = includeSourcePackages;
            }

            if (item !== undefined) {
                localVarQueryParameter['item'] = item;
            }

            if (labTestingStatus !== undefined) {
                localVarQueryParameter['lab_testing_status'] = labTestingStatus;
            }

            if (label !== undefined) {
                localVarQueryParameter['label'] = label;
            }

            if (licenseNumber !== undefined) {
                localVarQueryParameter['license_number'] = licenseNumber;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (location !== undefined) {
                localVarQueryParameter['location'] = location;
            }

            if (manifestNumber !== undefined) {
                localVarQueryParameter['manifest_number'] = manifestNumber;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }

            if (packagedDate !== undefined) {
                localVarQueryParameter['packaged_date'] = packagedDate;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (productIds !== undefined) {
                localVarQueryParameter['product_ids'] = productIds;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (sourcePackage !== undefined) {
                localVarQueryParameter['source_package'] = sourcePackage;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (templateId !== undefined) {
                localVarQueryParameter['template_id'] = templateId;
            }

            if (thcMax !== undefined) {
                localVarQueryParameter['thc_max'] = thcMax;
            }

            if (thcMin !== undefined) {
                localVarQueryParameter['thc_min'] = thcMin;
            }


    
            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all refresh_requests from the traceability service for a company.
         * @param {number} companyId The ID of the viewing company
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [refreshDate] Filter results by refresh_request.created_at
         * @param {string} [search] A search term.
         * @param {string} [status] Filter results by comma-separated list of refresh statuses
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        traceabilityRefreshRequestsList: async (companyId: number, ordering?: string, page?: number, pageSize?: number, refreshDate?: string, search?: string, status?: string, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('traceabilityRefreshRequestsList', 'companyId', companyId)
            const localVarPath = `/traceability/refresh_requests`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (companyId !== undefined) {
                localVarQueryParameter['company_id'] = companyId;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (refreshDate !== undefined) {
                localVarQueryParameter['refresh_date'] = (refreshDate as any instanceof Date) ?
                    (refreshDate as any).toISOString().substring(0,10) :
                    refreshDate;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new Template in the traceability service.
         * @param {number} companyId The ID of the viewing company
         * @param {TemplateCreateRequest} templateCreateRequest 
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        traceabilityTemplatesCreate: async (companyId: number, templateCreateRequest: TemplateCreateRequest, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('traceabilityTemplatesCreate', 'companyId', companyId)
            // verify required parameter 'templateCreateRequest' is not null or undefined
            assertParamExists('traceabilityTemplatesCreate', 'templateCreateRequest', templateCreateRequest)
            const localVarPath = `/traceability/templates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (companyId !== undefined) {
                localVarQueryParameter['company_id'] = companyId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(templateCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get templates from the traceability service for company.
         * @param {number} companyId The ID of the viewing company
         * @param {number} [limit] Limit for results, hard-cap of 25 enforced, default 25
         * @param {number} [llOrderId] Filter results by associated LL order ID
         * @param {number} [offset] Used for pagination
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] Search term to filter the list by
         * @param {string} [shipDate] Filter results by ship date
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        traceabilityTemplatesList: async (companyId: number, limit?: number, llOrderId?: number, offset?: number, ordering?: string, page?: number, pageSize?: number, search?: string, shipDate?: string, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('traceabilityTemplatesList', 'companyId', companyId)
            const localVarPath = `/traceability/templates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (companyId !== undefined) {
                localVarQueryParameter['company_id'] = companyId;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (llOrderId !== undefined) {
                localVarQueryParameter['ll_order_id'] = llOrderId;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (shipDate !== undefined) {
                localVarQueryParameter['ship_date'] = (shipDate as any instanceof Date) ?
                    (shipDate as any).toISOString() :
                    shipDate;
            }


    
            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a template in the traceability service.
         * @param {number} companyId The ID of the viewing company
         * @param {number} id ID of requested template
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {PatchedTemplateUpdateRequest} [patchedTemplateUpdateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        traceabilityTemplatesPartialUpdate: async (companyId: number, id: number, leafLinkVersion?: string, patchedTemplateUpdateRequest?: PatchedTemplateUpdateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('traceabilityTemplatesPartialUpdate', 'companyId', companyId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('traceabilityTemplatesPartialUpdate', 'id', id)
            const localVarPath = `/traceability/templates/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (companyId !== undefined) {
                localVarQueryParameter['company_id'] = companyId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchedTemplateUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get template by ID for company.
         * @param {number} companyId The ID of the viewing company
         * @param {number} id ID of requested template
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        traceabilityTemplatesRetrieve: async (companyId: number, id: number, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('traceabilityTemplatesRetrieve', 'companyId', companyId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('traceabilityTemplatesRetrieve', 'id', id)
            const localVarPath = `/traceability/templates/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (companyId !== undefined) {
                localVarQueryParameter['company_id'] = companyId;
            }


    
            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get origin/destination companies of a transfer + their associated license
         * @param {number} companyId The ID of the viewing company
         * @param {string} [fromShipper] Filter by Traceability.transfer.shipper_facility_name|shipper_facility_license_number fields contain value
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {string} [toRecipient] Filter by Traceability.transfer.recipient_facility_name|recipient_facility_license_number fields contain value
         * @param {string} [transferType] Filter by Traceability.transfer.type field
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        traceabilityTransferCompaniesList: async (companyId: number, fromShipper?: string, ordering?: string, page?: number, pageSize?: number, search?: string, toRecipient?: string, transferType?: string, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('traceabilityTransferCompaniesList', 'companyId', companyId)
            const localVarPath = `/traceability/transfer_companies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (companyId !== undefined) {
                localVarQueryParameter['company_id'] = companyId;
            }

            if (fromShipper !== undefined) {
                localVarQueryParameter['from_shipper'] = fromShipper;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (toRecipient !== undefined) {
                localVarQueryParameter['to_recipient'] = toRecipient;
            }

            if (transferType !== undefined) {
                localVarQueryParameter['transfer_type'] = transferType;
            }


    
            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get traceability transfer data. Note: resource_type fields will not be present in the payloads. They are just needed to help define polymorphic fields.
         * @param {number} companyId The ID of the viewing company
         * @param {string} [arrivalDate] Filter by Traceability.transfer.arrival_date field
         * @param {string} [companyIds] Filter by Traceability.transfer.company.external_id (marketplace.company.id) field
         * @param {boolean} [excludeReceived] Filter by Traceability.transfer.received_datetime field not None
         * @param {string} [externalIds] Filter by Traceability.&lt;model&gt;.external_id field
         * @param {string} [fromShipper] Filter by Traceability.transfer.shipper_facility_name|shipper_facility_license_number fields contain value
         * @param {boolean} [hasAttachedOrders] Filter by transfers that are associated with orders in LL
         * @param {string} [ids] Traceability.&lt;model&gt;.id field
         * @param {boolean} [includePackageData] Include delivery packages in response
         * @param {number} [limit] Limit for results, hard-cap of 25 enforced, default 25
         * @param {string} [metrcIds] Filter by Traceability.&lt;model&gt;.metrc_id field
         * @param {number} [offset] Used for pagination
         * @param {string} [orderIds] Filter transfers by Traceability.order_transfer.order_id list field
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] Search term to filter the list by
         * @param {string} [shipDate] Filter results by ship date
         * @param {string} [sortBy] Sort results by given field
         * @param {string} [toRecipient] Filter by Traceability.transfer.recipient_facility_name|recipient_facility_license_number fields contain value
         * @param {string} [traceabilityTransferExternalIds] Filter by Traceability.transfer.metrc_id field
         * @param {string} [transferStatus] Filter by Traceability.transfer.status field
         * @param {string} [transferType] Filter by Traceability.transfer.type field
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        traceabilityTransfersList: async (companyId: number, arrivalDate?: string, companyIds?: string, excludeReceived?: boolean, externalIds?: string, fromShipper?: string, hasAttachedOrders?: boolean, ids?: string, includePackageData?: boolean, limit?: number, metrcIds?: string, offset?: number, orderIds?: string, ordering?: string, page?: number, pageSize?: number, search?: string, shipDate?: string, sortBy?: string, toRecipient?: string, traceabilityTransferExternalIds?: string, transferStatus?: string, transferType?: string, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('traceabilityTransfersList', 'companyId', companyId)
            const localVarPath = `/traceability/transfers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (arrivalDate !== undefined) {
                localVarQueryParameter['arrival_date'] = (arrivalDate as any instanceof Date) ?
                    (arrivalDate as any).toISOString().substring(0,10) :
                    arrivalDate;
            }

            if (companyId !== undefined) {
                localVarQueryParameter['company_id'] = companyId;
            }

            if (companyIds !== undefined) {
                localVarQueryParameter['company_ids'] = companyIds;
            }

            if (excludeReceived !== undefined) {
                localVarQueryParameter['exclude_received'] = excludeReceived;
            }

            if (externalIds !== undefined) {
                localVarQueryParameter['external_ids'] = externalIds;
            }

            if (fromShipper !== undefined) {
                localVarQueryParameter['from_shipper'] = fromShipper;
            }

            if (hasAttachedOrders !== undefined) {
                localVarQueryParameter['has_attached_orders'] = hasAttachedOrders;
            }

            if (ids !== undefined) {
                localVarQueryParameter['ids'] = ids;
            }

            if (includePackageData !== undefined) {
                localVarQueryParameter['include_package_data'] = includePackageData;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (metrcIds !== undefined) {
                localVarQueryParameter['metrc_ids'] = metrcIds;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (orderIds !== undefined) {
                localVarQueryParameter['order_ids'] = orderIds;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (shipDate !== undefined) {
                localVarQueryParameter['ship_date'] = (shipDate as any instanceof Date) ?
                    (shipDate as any).toISOString() :
                    shipDate;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (toRecipient !== undefined) {
                localVarQueryParameter['to_recipient'] = toRecipient;
            }

            if (traceabilityTransferExternalIds !== undefined) {
                localVarQueryParameter['traceability_transfer_external_ids'] = traceabilityTransferExternalIds;
            }

            if (transferStatus !== undefined) {
                localVarQueryParameter['transfer_status'] = transferStatus;
            }

            if (transferType !== undefined) {
                localVarQueryParameter['transfer_type'] = transferType;
            }


    
            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new vehicle in the traceability service.
         * @param {number} companyId The ID of the viewing company
         * @param {TraceabilityVehicleCreateUpdateInputRequest} traceabilityVehicleCreateUpdateInputRequest 
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        traceabilityVehiclesCreate: async (companyId: number, traceabilityVehicleCreateUpdateInputRequest: TraceabilityVehicleCreateUpdateInputRequest, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('traceabilityVehiclesCreate', 'companyId', companyId)
            // verify required parameter 'traceabilityVehicleCreateUpdateInputRequest' is not null or undefined
            assertParamExists('traceabilityVehiclesCreate', 'traceabilityVehicleCreateUpdateInputRequest', traceabilityVehicleCreateUpdateInputRequest)
            const localVarPath = `/traceability/vehicles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (companyId !== undefined) {
                localVarQueryParameter['company_id'] = companyId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(traceabilityVehicleCreateUpdateInputRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all vehicles
         * @param {number} companyId The ID of the viewing company
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] Search term to filter the list by
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        traceabilityVehiclesList: async (companyId: number, ordering?: string, page?: number, pageSize?: number, search?: string, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('traceabilityVehiclesList', 'companyId', companyId)
            const localVarPath = `/traceability/vehicles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (companyId !== undefined) {
                localVarQueryParameter['company_id'] = companyId;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a vehicle in the traceability service.
         * @param {number} companyId The ID of the viewing company
         * @param {string} externalId Vendor external ID of object to be updated
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {PatchedTraceabilityVehicleCreateUpdateInputRequest} [patchedTraceabilityVehicleCreateUpdateInputRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        traceabilityVehiclesPartialUpdate: async (companyId: number, externalId: string, leafLinkVersion?: string, patchedTraceabilityVehicleCreateUpdateInputRequest?: PatchedTraceabilityVehicleCreateUpdateInputRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('traceabilityVehiclesPartialUpdate', 'companyId', companyId)
            // verify required parameter 'externalId' is not null or undefined
            assertParamExists('traceabilityVehiclesPartialUpdate', 'externalId', externalId)
            const localVarPath = `/traceability/vehicles/{external_id}`
                .replace(`{${"external_id"}}`, encodeURIComponent(String(externalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (companyId !== undefined) {
                localVarQueryParameter['company_id'] = companyId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchedTraceabilityVehicleCreateUpdateInputRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TraceabilityApi - functional programming interface
 * @export
 */
export const TraceabilityApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TraceabilityApiAxiosParamCreator(configuration)
    return {
        /**
         * Reconcile inventory for products, utilizes marketplace celery tasks + traceability service data.
         * @param {number} companyId The ID of the viewing company
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {PatchedTraceabilityRefreshProductsPackagesRequest} [patchedTraceabilityRefreshProductsPackagesRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async traceabilityActionsRefreshProductsPackagesPartialUpdate(companyId: number, leafLinkVersion?: string, patchedTraceabilityRefreshProductsPackagesRequest?: PatchedTraceabilityRefreshProductsPackagesRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.traceabilityActionsRefreshProductsPackagesPartialUpdate(companyId, leafLinkVersion, patchedTraceabilityRefreshProductsPackagesRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TraceabilityApi.traceabilityActionsRefreshProductsPackagesPartialUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Perform refresh for specified resource types and optional datetime.
         * @param {number} companyId The ID of the viewing company
         * @param {string} types Comma-separated list of resource types to refresh
         * @param {string} [endDate] Resource refresh end date
         * @param {string} [startDate] Resource refresh start date
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async traceabilityActionsRefreshResourcesRetrieve(companyId: number, types: string, endDate?: string, startDate?: string, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.traceabilityActionsRefreshResourcesRetrieve(companyId, types, endDate, startDate, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TraceabilityApi.traceabilityActionsRefreshResourcesRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new company in the traceability service.
         * @param {number} companyId The ID of the viewing company
         * @param {CompanyCreateRequest} companyCreateRequest 
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async traceabilityCompaniesCreate(companyId: number, companyCreateRequest: CompanyCreateRequest, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompanyWriteSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.traceabilityCompaniesCreate(companyId, companyCreateRequest, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TraceabilityApi.traceabilityCompaniesCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update a company in the traceability service.
         * @param {number} companyId The ID of the viewing company
         * @param {number} id ID of requested company
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {PatchedCompanyUpdateRequest} [patchedCompanyUpdateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async traceabilityCompaniesPartialUpdate(companyId: number, id: number, leafLinkVersion?: string, patchedCompanyUpdateRequest?: PatchedCompanyUpdateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompanyWriteSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.traceabilityCompaniesPartialUpdate(companyId, id, leafLinkVersion, patchedCompanyUpdateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TraceabilityApi.traceabilityCompaniesPartialUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get company by ID.
         * @param {number} companyId The ID of the viewing company
         * @param {number} id ID of requested company
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async traceabilityCompaniesRetrieve(companyId: number, id: number, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TraceabilityCompany>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.traceabilityCompaniesRetrieve(companyId, id, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TraceabilityApi.traceabilityCompaniesRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get company customers.
         * @param {number} companyId The ID of the viewing company
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async traceabilityCompanyCustomersList(companyId: number, ordering?: string, page?: number, pageSize?: number, search?: string, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedUnifiedTraceabilityCompanyCustomerList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.traceabilityCompanyCustomersList(companyId, ordering, page, pageSize, search, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TraceabilityApi.traceabilityCompanyCustomersList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get company customer by ID.
         * @param {number} companyId The ID of the viewing company
         * @param {number} id A unique integer value identifying this company customer.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async traceabilityCompanyCustomersRetrieve(companyId: number, id: number, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnifiedTraceabilityCompanyCustomer>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.traceabilityCompanyCustomersRetrieve(companyId, id, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TraceabilityApi.traceabilityCompanyCustomersRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get company licenses
         * @param {number} companyId The ID of the viewing company
         * @param {LicenseApiKeyRequest} licenseApiKeyRequest 
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async traceabilityCompanyLicensesCreate(companyId: number, licenseApiKeyRequest: LicenseApiKeyRequest, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TraceabilityLicenses>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.traceabilityCompanyLicensesCreate(companyId, licenseApiKeyRequest, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TraceabilityApi.traceabilityCompanyLicensesCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a company\'s integration.
         * @param {number} companyId The ID of the viewing company
         * @param {number} id ID of integration to modify
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async traceabilityCompanySettingDestroy(companyId: number, id: number, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.traceabilityCompanySettingDestroy(companyId, id, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TraceabilityApi.traceabilityCompanySettingDestroy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new driver in the traceability service.
         * @param {number} companyId The ID of the viewing company
         * @param {TraceabilityDriverCreateUpdateInputRequest} traceabilityDriverCreateUpdateInputRequest 
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async traceabilityDriversCreate(companyId: number, traceabilityDriverCreateUpdateInputRequest: TraceabilityDriverCreateUpdateInputRequest, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TraceabilityDriver>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.traceabilityDriversCreate(companyId, traceabilityDriverCreateUpdateInputRequest, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TraceabilityApi.traceabilityDriversCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all drivers for company
         * @param {number} companyId The ID of the viewing company
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] Search term to filter the list by
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async traceabilityDriversList(companyId: number, ordering?: string, page?: number, pageSize?: number, search?: string, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedTraceabilityDriverList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.traceabilityDriversList(companyId, ordering, page, pageSize, search, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TraceabilityApi.traceabilityDriversList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update a driver in the traceability service.
         * @param {number} companyId The ID of the viewing company
         * @param {string} externalId Vendor external ID of object to be updated
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {PatchedTraceabilityDriverCreateUpdateInputRequest} [patchedTraceabilityDriverCreateUpdateInputRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async traceabilityDriversPartialUpdate(companyId: number, externalId: string, leafLinkVersion?: string, patchedTraceabilityDriverCreateUpdateInputRequest?: PatchedTraceabilityDriverCreateUpdateInputRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TraceabilityDriver>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.traceabilityDriversPartialUpdate(companyId, externalId, leafLinkVersion, patchedTraceabilityDriverCreateUpdateInputRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TraceabilityApi.traceabilityDriversPartialUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all items from the traceability service for a company.
         * @param {number} companyId The ID of the viewing company
         * @param {boolean} [includeStrainData] Boolean to indicate whether strain data should be included
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] Search term to filter the list by
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async traceabilityItemsList(companyId: number, includeStrainData?: boolean, ordering?: string, page?: number, pageSize?: number, search?: string, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedTraceabilityItemList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.traceabilityItemsList(companyId, includeStrainData, ordering, page, pageSize, search, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TraceabilityApi.traceabilityItemsList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get onboarding status.
         * @param {number} id ID of requested company
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async traceabilityOnboardingStatusRetrieve(id: number, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TraceabilityCompanyOnboarding>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.traceabilityOnboardingStatusRetrieve(id, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TraceabilityApi.traceabilityOnboardingStatusRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Unified API Orders by Package Labels.
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async traceabilityOrdersByPackageLabelsList(ordering?: string, page?: number, pageSize?: number, search?: string, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedUnifiedTraceabilityPackageOrdersList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.traceabilityOrdersByPackageLabelsList(ordering, page, pageSize, search, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TraceabilityApi.traceabilityOrdersByPackageLabelsList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Unified API Orders by Package Labels.
         * @param {number} id A unique integer value identifying this attached package.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async traceabilityOrdersByPackageLabelsRetrieve(id: number, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnifiedTraceabilityPackageOrders>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.traceabilityOrdersByPackageLabelsRetrieve(id, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TraceabilityApi.traceabilityOrdersByPackageLabelsRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get company packages
         * @param {number} companyId The ID of the viewing company
         * @param {boolean} [assigned] Filter by Traceability.common_packages that are assigned/unassigned products
         * @param {number} [cbdMax] Filter by Traceability.common_packages with a CBD value less than or equal to the given value
         * @param {number} [cbdMin] Filter by Traceability.common_packages with a CBD value greater than or equal to the given value
         * @param {boolean} [hideAttachedPackages] Filter out any Traceability.common_package that has already been assigned to an order line-item
         * @param {boolean} [includeSourcePackages] Indicate whether to include a list of source_package_labels in the response
         * @param {string} [item] Filter by Traceability.metrc_package.item_id (accepts comma-separated list)
         * @param {string} [labTestingStatus] Filter by Traceability.common_package.metrc_package.lab_testing_status (accepts comma-separated list)
         * @param {string} [label] Filter by Traceability.common_package.label (accepts comma-separated list)
         * @param {string} [licenseNumber] Filter by Traceability.common_package.license_number (accepts comma-separated list)
         * @param {number} [limit] Limit for results, hard-cap of 25 enforced, default 25
         * @param {string} [location] Filter by Traceability.common_package.location_id (accepts comma-separated list)
         * @param {string} [manifestNumber] Filter Traceability.common_package by packages associated with manifest
         * @param {number} [offset] Used for pagination
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {string} [packagedDate] Filter by Traceability.metrc_package.packaged_date (accepts comma-separated list)
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [productIds] Filter Traceability.common_package by product_ids assigned to packages (accepts comma-separated list)
         * @param {string} [search] Search term to filter the list by
         * @param {string} [sourcePackage] Filter Traceability.common_package by packages that are children of the given label
         * @param {string} [status] Filter by Traceability.common_package.status field
         * @param {string} [templateId] Filter Traceability.common_package by packages assigned to template
         * @param {number} [thcMax] Filter by Traceability.common_packages with a THC value less than or equal to the given value
         * @param {number} [thcMin] Filter by Traceability.common_packages with a THC value greater than or equal to the given value
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async traceabilityPackagesList(companyId: number, assigned?: boolean, cbdMax?: number, cbdMin?: number, hideAttachedPackages?: boolean, includeSourcePackages?: boolean, item?: string, labTestingStatus?: string, label?: string, licenseNumber?: string, limit?: number, location?: string, manifestNumber?: string, offset?: number, ordering?: string, packagedDate?: string, page?: number, pageSize?: number, productIds?: string, search?: string, sourcePackage?: string, status?: string, templateId?: string, thcMax?: number, thcMin?: number, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedTraceabilityPackageList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.traceabilityPackagesList(companyId, assigned, cbdMax, cbdMin, hideAttachedPackages, includeSourcePackages, item, labTestingStatus, label, licenseNumber, limit, location, manifestNumber, offset, ordering, packagedDate, page, pageSize, productIds, search, sourcePackage, status, templateId, thcMax, thcMin, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TraceabilityApi.traceabilityPackagesList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all refresh_requests from the traceability service for a company.
         * @param {number} companyId The ID of the viewing company
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [refreshDate] Filter results by refresh_request.created_at
         * @param {string} [search] A search term.
         * @param {string} [status] Filter results by comma-separated list of refresh statuses
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async traceabilityRefreshRequestsList(companyId: number, ordering?: string, page?: number, pageSize?: number, refreshDate?: string, search?: string, status?: string, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedTraceabilityRefreshRequestList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.traceabilityRefreshRequestsList(companyId, ordering, page, pageSize, refreshDate, search, status, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TraceabilityApi.traceabilityRefreshRequestsList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new Template in the traceability service.
         * @param {number} companyId The ID of the viewing company
         * @param {TemplateCreateRequest} templateCreateRequest 
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async traceabilityTemplatesCreate(companyId: number, templateCreateRequest: TemplateCreateRequest, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TemplateWriteSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.traceabilityTemplatesCreate(companyId, templateCreateRequest, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TraceabilityApi.traceabilityTemplatesCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get templates from the traceability service for company.
         * @param {number} companyId The ID of the viewing company
         * @param {number} [limit] Limit for results, hard-cap of 25 enforced, default 25
         * @param {number} [llOrderId] Filter results by associated LL order ID
         * @param {number} [offset] Used for pagination
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] Search term to filter the list by
         * @param {string} [shipDate] Filter results by ship date
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async traceabilityTemplatesList(companyId: number, limit?: number, llOrderId?: number, offset?: number, ordering?: string, page?: number, pageSize?: number, search?: string, shipDate?: string, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedTraceabilityTemplateList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.traceabilityTemplatesList(companyId, limit, llOrderId, offset, ordering, page, pageSize, search, shipDate, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TraceabilityApi.traceabilityTemplatesList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update a template in the traceability service.
         * @param {number} companyId The ID of the viewing company
         * @param {number} id ID of requested template
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {PatchedTemplateUpdateRequest} [patchedTemplateUpdateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async traceabilityTemplatesPartialUpdate(companyId: number, id: number, leafLinkVersion?: string, patchedTemplateUpdateRequest?: PatchedTemplateUpdateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TemplateWriteSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.traceabilityTemplatesPartialUpdate(companyId, id, leafLinkVersion, patchedTemplateUpdateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TraceabilityApi.traceabilityTemplatesPartialUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get template by ID for company.
         * @param {number} companyId The ID of the viewing company
         * @param {number} id ID of requested template
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async traceabilityTemplatesRetrieve(companyId: number, id: number, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TraceabilityTemplateDetail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.traceabilityTemplatesRetrieve(companyId, id, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TraceabilityApi.traceabilityTemplatesRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get origin/destination companies of a transfer + their associated license
         * @param {number} companyId The ID of the viewing company
         * @param {string} [fromShipper] Filter by Traceability.transfer.shipper_facility_name|shipper_facility_license_number fields contain value
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {string} [toRecipient] Filter by Traceability.transfer.recipient_facility_name|recipient_facility_license_number fields contain value
         * @param {string} [transferType] Filter by Traceability.transfer.type field
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async traceabilityTransferCompaniesList(companyId: number, fromShipper?: string, ordering?: string, page?: number, pageSize?: number, search?: string, toRecipient?: string, transferType?: string, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedTransferCompanyList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.traceabilityTransferCompaniesList(companyId, fromShipper, ordering, page, pageSize, search, toRecipient, transferType, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TraceabilityApi.traceabilityTransferCompaniesList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get traceability transfer data. Note: resource_type fields will not be present in the payloads. They are just needed to help define polymorphic fields.
         * @param {number} companyId The ID of the viewing company
         * @param {string} [arrivalDate] Filter by Traceability.transfer.arrival_date field
         * @param {string} [companyIds] Filter by Traceability.transfer.company.external_id (marketplace.company.id) field
         * @param {boolean} [excludeReceived] Filter by Traceability.transfer.received_datetime field not None
         * @param {string} [externalIds] Filter by Traceability.&lt;model&gt;.external_id field
         * @param {string} [fromShipper] Filter by Traceability.transfer.shipper_facility_name|shipper_facility_license_number fields contain value
         * @param {boolean} [hasAttachedOrders] Filter by transfers that are associated with orders in LL
         * @param {string} [ids] Traceability.&lt;model&gt;.id field
         * @param {boolean} [includePackageData] Include delivery packages in response
         * @param {number} [limit] Limit for results, hard-cap of 25 enforced, default 25
         * @param {string} [metrcIds] Filter by Traceability.&lt;model&gt;.metrc_id field
         * @param {number} [offset] Used for pagination
         * @param {string} [orderIds] Filter transfers by Traceability.order_transfer.order_id list field
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] Search term to filter the list by
         * @param {string} [shipDate] Filter results by ship date
         * @param {string} [sortBy] Sort results by given field
         * @param {string} [toRecipient] Filter by Traceability.transfer.recipient_facility_name|recipient_facility_license_number fields contain value
         * @param {string} [traceabilityTransferExternalIds] Filter by Traceability.transfer.metrc_id field
         * @param {string} [transferStatus] Filter by Traceability.transfer.status field
         * @param {string} [transferType] Filter by Traceability.transfer.type field
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async traceabilityTransfersList(companyId: number, arrivalDate?: string, companyIds?: string, excludeReceived?: boolean, externalIds?: string, fromShipper?: string, hasAttachedOrders?: boolean, ids?: string, includePackageData?: boolean, limit?: number, metrcIds?: string, offset?: number, orderIds?: string, ordering?: string, page?: number, pageSize?: number, search?: string, shipDate?: string, sortBy?: string, toRecipient?: string, traceabilityTransferExternalIds?: string, transferStatus?: string, transferType?: string, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedPolymorphicTransferList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.traceabilityTransfersList(companyId, arrivalDate, companyIds, excludeReceived, externalIds, fromShipper, hasAttachedOrders, ids, includePackageData, limit, metrcIds, offset, orderIds, ordering, page, pageSize, search, shipDate, sortBy, toRecipient, traceabilityTransferExternalIds, transferStatus, transferType, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TraceabilityApi.traceabilityTransfersList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new vehicle in the traceability service.
         * @param {number} companyId The ID of the viewing company
         * @param {TraceabilityVehicleCreateUpdateInputRequest} traceabilityVehicleCreateUpdateInputRequest 
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async traceabilityVehiclesCreate(companyId: number, traceabilityVehicleCreateUpdateInputRequest: TraceabilityVehicleCreateUpdateInputRequest, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TraceabilityVehicle>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.traceabilityVehiclesCreate(companyId, traceabilityVehicleCreateUpdateInputRequest, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TraceabilityApi.traceabilityVehiclesCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all vehicles
         * @param {number} companyId The ID of the viewing company
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] Search term to filter the list by
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async traceabilityVehiclesList(companyId: number, ordering?: string, page?: number, pageSize?: number, search?: string, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedTraceabilityVehicleList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.traceabilityVehiclesList(companyId, ordering, page, pageSize, search, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TraceabilityApi.traceabilityVehiclesList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update a vehicle in the traceability service.
         * @param {number} companyId The ID of the viewing company
         * @param {string} externalId Vendor external ID of object to be updated
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {PatchedTraceabilityVehicleCreateUpdateInputRequest} [patchedTraceabilityVehicleCreateUpdateInputRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async traceabilityVehiclesPartialUpdate(companyId: number, externalId: string, leafLinkVersion?: string, patchedTraceabilityVehicleCreateUpdateInputRequest?: PatchedTraceabilityVehicleCreateUpdateInputRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TraceabilityVehicle>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.traceabilityVehiclesPartialUpdate(companyId, externalId, leafLinkVersion, patchedTraceabilityVehicleCreateUpdateInputRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TraceabilityApi.traceabilityVehiclesPartialUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TraceabilityApi - factory interface
 * @export
 */
export const TraceabilityApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TraceabilityApiFp(configuration)
    return {
        /**
         * Reconcile inventory for products, utilizes marketplace celery tasks + traceability service data.
         * @param {TraceabilityApiTraceabilityActionsRefreshProductsPackagesPartialUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        traceabilityActionsRefreshProductsPackagesPartialUpdate(requestParameters: TraceabilityApiTraceabilityActionsRefreshProductsPackagesPartialUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.traceabilityActionsRefreshProductsPackagesPartialUpdate(requestParameters.companyId, requestParameters.leafLinkVersion, requestParameters.patchedTraceabilityRefreshProductsPackagesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Perform refresh for specified resource types and optional datetime.
         * @param {TraceabilityApiTraceabilityActionsRefreshResourcesRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        traceabilityActionsRefreshResourcesRetrieve(requestParameters: TraceabilityApiTraceabilityActionsRefreshResourcesRetrieveRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.traceabilityActionsRefreshResourcesRetrieve(requestParameters.companyId, requestParameters.types, requestParameters.endDate, requestParameters.startDate, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new company in the traceability service.
         * @param {TraceabilityApiTraceabilityCompaniesCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        traceabilityCompaniesCreate(requestParameters: TraceabilityApiTraceabilityCompaniesCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<CompanyWriteSuccessResponse> {
            return localVarFp.traceabilityCompaniesCreate(requestParameters.companyId, requestParameters.companyCreateRequest, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a company in the traceability service.
         * @param {TraceabilityApiTraceabilityCompaniesPartialUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        traceabilityCompaniesPartialUpdate(requestParameters: TraceabilityApiTraceabilityCompaniesPartialUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<CompanyWriteSuccessResponse> {
            return localVarFp.traceabilityCompaniesPartialUpdate(requestParameters.companyId, requestParameters.id, requestParameters.leafLinkVersion, requestParameters.patchedCompanyUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Get company by ID.
         * @param {TraceabilityApiTraceabilityCompaniesRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        traceabilityCompaniesRetrieve(requestParameters: TraceabilityApiTraceabilityCompaniesRetrieveRequest, options?: RawAxiosRequestConfig): AxiosPromise<TraceabilityCompany> {
            return localVarFp.traceabilityCompaniesRetrieve(requestParameters.companyId, requestParameters.id, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * Get company customers.
         * @param {TraceabilityApiTraceabilityCompanyCustomersListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        traceabilityCompanyCustomersList(requestParameters: TraceabilityApiTraceabilityCompanyCustomersListRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedUnifiedTraceabilityCompanyCustomerList> {
            return localVarFp.traceabilityCompanyCustomersList(requestParameters.companyId, requestParameters.ordering, requestParameters.page, requestParameters.pageSize, requestParameters.search, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * Get company customer by ID.
         * @param {TraceabilityApiTraceabilityCompanyCustomersRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        traceabilityCompanyCustomersRetrieve(requestParameters: TraceabilityApiTraceabilityCompanyCustomersRetrieveRequest, options?: RawAxiosRequestConfig): AxiosPromise<UnifiedTraceabilityCompanyCustomer> {
            return localVarFp.traceabilityCompanyCustomersRetrieve(requestParameters.companyId, requestParameters.id, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * Get company licenses
         * @param {TraceabilityApiTraceabilityCompanyLicensesCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        traceabilityCompanyLicensesCreate(requestParameters: TraceabilityApiTraceabilityCompanyLicensesCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<TraceabilityLicenses> {
            return localVarFp.traceabilityCompanyLicensesCreate(requestParameters.companyId, requestParameters.licenseApiKeyRequest, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a company\'s integration.
         * @param {TraceabilityApiTraceabilityCompanySettingDestroyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        traceabilityCompanySettingDestroy(requestParameters: TraceabilityApiTraceabilityCompanySettingDestroyRequest, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.traceabilityCompanySettingDestroy(requestParameters.companyId, requestParameters.id, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new driver in the traceability service.
         * @param {TraceabilityApiTraceabilityDriversCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        traceabilityDriversCreate(requestParameters: TraceabilityApiTraceabilityDriversCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<TraceabilityDriver> {
            return localVarFp.traceabilityDriversCreate(requestParameters.companyId, requestParameters.traceabilityDriverCreateUpdateInputRequest, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all drivers for company
         * @param {TraceabilityApiTraceabilityDriversListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        traceabilityDriversList(requestParameters: TraceabilityApiTraceabilityDriversListRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedTraceabilityDriverList> {
            return localVarFp.traceabilityDriversList(requestParameters.companyId, requestParameters.ordering, requestParameters.page, requestParameters.pageSize, requestParameters.search, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a driver in the traceability service.
         * @param {TraceabilityApiTraceabilityDriversPartialUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        traceabilityDriversPartialUpdate(requestParameters: TraceabilityApiTraceabilityDriversPartialUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<TraceabilityDriver> {
            return localVarFp.traceabilityDriversPartialUpdate(requestParameters.companyId, requestParameters.externalId, requestParameters.leafLinkVersion, requestParameters.patchedTraceabilityDriverCreateUpdateInputRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all items from the traceability service for a company.
         * @param {TraceabilityApiTraceabilityItemsListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        traceabilityItemsList(requestParameters: TraceabilityApiTraceabilityItemsListRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedTraceabilityItemList> {
            return localVarFp.traceabilityItemsList(requestParameters.companyId, requestParameters.includeStrainData, requestParameters.ordering, requestParameters.page, requestParameters.pageSize, requestParameters.search, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * Get onboarding status.
         * @param {TraceabilityApiTraceabilityOnboardingStatusRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        traceabilityOnboardingStatusRetrieve(requestParameters: TraceabilityApiTraceabilityOnboardingStatusRetrieveRequest, options?: RawAxiosRequestConfig): AxiosPromise<TraceabilityCompanyOnboarding> {
            return localVarFp.traceabilityOnboardingStatusRetrieve(requestParameters.id, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * Unified API Orders by Package Labels.
         * @param {TraceabilityApiTraceabilityOrdersByPackageLabelsListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        traceabilityOrdersByPackageLabelsList(requestParameters: TraceabilityApiTraceabilityOrdersByPackageLabelsListRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedUnifiedTraceabilityPackageOrdersList> {
            return localVarFp.traceabilityOrdersByPackageLabelsList(requestParameters.ordering, requestParameters.page, requestParameters.pageSize, requestParameters.search, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * Unified API Orders by Package Labels.
         * @param {TraceabilityApiTraceabilityOrdersByPackageLabelsRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        traceabilityOrdersByPackageLabelsRetrieve(requestParameters: TraceabilityApiTraceabilityOrdersByPackageLabelsRetrieveRequest, options?: RawAxiosRequestConfig): AxiosPromise<UnifiedTraceabilityPackageOrders> {
            return localVarFp.traceabilityOrdersByPackageLabelsRetrieve(requestParameters.id, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * Get company packages
         * @param {TraceabilityApiTraceabilityPackagesListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        traceabilityPackagesList(requestParameters: TraceabilityApiTraceabilityPackagesListRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedTraceabilityPackageList> {
            return localVarFp.traceabilityPackagesList(requestParameters.companyId, requestParameters.assigned, requestParameters.cbdMax, requestParameters.cbdMin, requestParameters.hideAttachedPackages, requestParameters.includeSourcePackages, requestParameters.item, requestParameters.labTestingStatus, requestParameters.label, requestParameters.licenseNumber, requestParameters.limit, requestParameters.location, requestParameters.manifestNumber, requestParameters.offset, requestParameters.ordering, requestParameters.packagedDate, requestParameters.page, requestParameters.pageSize, requestParameters.productIds, requestParameters.search, requestParameters.sourcePackage, requestParameters.status, requestParameters.templateId, requestParameters.thcMax, requestParameters.thcMin, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all refresh_requests from the traceability service for a company.
         * @param {TraceabilityApiTraceabilityRefreshRequestsListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        traceabilityRefreshRequestsList(requestParameters: TraceabilityApiTraceabilityRefreshRequestsListRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedTraceabilityRefreshRequestList> {
            return localVarFp.traceabilityRefreshRequestsList(requestParameters.companyId, requestParameters.ordering, requestParameters.page, requestParameters.pageSize, requestParameters.refreshDate, requestParameters.search, requestParameters.status, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new Template in the traceability service.
         * @param {TraceabilityApiTraceabilityTemplatesCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        traceabilityTemplatesCreate(requestParameters: TraceabilityApiTraceabilityTemplatesCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<TemplateWriteSuccessResponse> {
            return localVarFp.traceabilityTemplatesCreate(requestParameters.companyId, requestParameters.templateCreateRequest, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * Get templates from the traceability service for company.
         * @param {TraceabilityApiTraceabilityTemplatesListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        traceabilityTemplatesList(requestParameters: TraceabilityApiTraceabilityTemplatesListRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedTraceabilityTemplateList> {
            return localVarFp.traceabilityTemplatesList(requestParameters.companyId, requestParameters.limit, requestParameters.llOrderId, requestParameters.offset, requestParameters.ordering, requestParameters.page, requestParameters.pageSize, requestParameters.search, requestParameters.shipDate, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a template in the traceability service.
         * @param {TraceabilityApiTraceabilityTemplatesPartialUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        traceabilityTemplatesPartialUpdate(requestParameters: TraceabilityApiTraceabilityTemplatesPartialUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<TemplateWriteSuccessResponse> {
            return localVarFp.traceabilityTemplatesPartialUpdate(requestParameters.companyId, requestParameters.id, requestParameters.leafLinkVersion, requestParameters.patchedTemplateUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Get template by ID for company.
         * @param {TraceabilityApiTraceabilityTemplatesRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        traceabilityTemplatesRetrieve(requestParameters: TraceabilityApiTraceabilityTemplatesRetrieveRequest, options?: RawAxiosRequestConfig): AxiosPromise<TraceabilityTemplateDetail> {
            return localVarFp.traceabilityTemplatesRetrieve(requestParameters.companyId, requestParameters.id, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * Get origin/destination companies of a transfer + their associated license
         * @param {TraceabilityApiTraceabilityTransferCompaniesListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        traceabilityTransferCompaniesList(requestParameters: TraceabilityApiTraceabilityTransferCompaniesListRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedTransferCompanyList> {
            return localVarFp.traceabilityTransferCompaniesList(requestParameters.companyId, requestParameters.fromShipper, requestParameters.ordering, requestParameters.page, requestParameters.pageSize, requestParameters.search, requestParameters.toRecipient, requestParameters.transferType, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * Get traceability transfer data. Note: resource_type fields will not be present in the payloads. They are just needed to help define polymorphic fields.
         * @param {TraceabilityApiTraceabilityTransfersListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        traceabilityTransfersList(requestParameters: TraceabilityApiTraceabilityTransfersListRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedPolymorphicTransferList> {
            return localVarFp.traceabilityTransfersList(requestParameters.companyId, requestParameters.arrivalDate, requestParameters.companyIds, requestParameters.excludeReceived, requestParameters.externalIds, requestParameters.fromShipper, requestParameters.hasAttachedOrders, requestParameters.ids, requestParameters.includePackageData, requestParameters.limit, requestParameters.metrcIds, requestParameters.offset, requestParameters.orderIds, requestParameters.ordering, requestParameters.page, requestParameters.pageSize, requestParameters.search, requestParameters.shipDate, requestParameters.sortBy, requestParameters.toRecipient, requestParameters.traceabilityTransferExternalIds, requestParameters.transferStatus, requestParameters.transferType, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new vehicle in the traceability service.
         * @param {TraceabilityApiTraceabilityVehiclesCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        traceabilityVehiclesCreate(requestParameters: TraceabilityApiTraceabilityVehiclesCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<TraceabilityVehicle> {
            return localVarFp.traceabilityVehiclesCreate(requestParameters.companyId, requestParameters.traceabilityVehicleCreateUpdateInputRequest, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all vehicles
         * @param {TraceabilityApiTraceabilityVehiclesListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        traceabilityVehiclesList(requestParameters: TraceabilityApiTraceabilityVehiclesListRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedTraceabilityVehicleList> {
            return localVarFp.traceabilityVehiclesList(requestParameters.companyId, requestParameters.ordering, requestParameters.page, requestParameters.pageSize, requestParameters.search, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a vehicle in the traceability service.
         * @param {TraceabilityApiTraceabilityVehiclesPartialUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        traceabilityVehiclesPartialUpdate(requestParameters: TraceabilityApiTraceabilityVehiclesPartialUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<TraceabilityVehicle> {
            return localVarFp.traceabilityVehiclesPartialUpdate(requestParameters.companyId, requestParameters.externalId, requestParameters.leafLinkVersion, requestParameters.patchedTraceabilityVehicleCreateUpdateInputRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for traceabilityActionsRefreshProductsPackagesPartialUpdate operation in TraceabilityApi.
 * @export
 * @interface TraceabilityApiTraceabilityActionsRefreshProductsPackagesPartialUpdateRequest
 */
export interface TraceabilityApiTraceabilityActionsRefreshProductsPackagesPartialUpdateRequest {
    /**
     * The ID of the viewing company
     * @type {number}
     * @memberof TraceabilityApiTraceabilityActionsRefreshProductsPackagesPartialUpdate
     */
    readonly companyId: number

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof TraceabilityApiTraceabilityActionsRefreshProductsPackagesPartialUpdate
     */
    readonly leafLinkVersion?: string

    /**
     * 
     * @type {PatchedTraceabilityRefreshProductsPackagesRequest}
     * @memberof TraceabilityApiTraceabilityActionsRefreshProductsPackagesPartialUpdate
     */
    readonly patchedTraceabilityRefreshProductsPackagesRequest?: PatchedTraceabilityRefreshProductsPackagesRequest
}

/**
 * Request parameters for traceabilityActionsRefreshResourcesRetrieve operation in TraceabilityApi.
 * @export
 * @interface TraceabilityApiTraceabilityActionsRefreshResourcesRetrieveRequest
 */
export interface TraceabilityApiTraceabilityActionsRefreshResourcesRetrieveRequest {
    /**
     * The ID of the viewing company
     * @type {number}
     * @memberof TraceabilityApiTraceabilityActionsRefreshResourcesRetrieve
     */
    readonly companyId: number

    /**
     * Comma-separated list of resource types to refresh
     * @type {string}
     * @memberof TraceabilityApiTraceabilityActionsRefreshResourcesRetrieve
     */
    readonly types: string

    /**
     * Resource refresh end date
     * @type {string}
     * @memberof TraceabilityApiTraceabilityActionsRefreshResourcesRetrieve
     */
    readonly endDate?: string

    /**
     * Resource refresh start date
     * @type {string}
     * @memberof TraceabilityApiTraceabilityActionsRefreshResourcesRetrieve
     */
    readonly startDate?: string

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof TraceabilityApiTraceabilityActionsRefreshResourcesRetrieve
     */
    readonly leafLinkVersion?: string
}

/**
 * Request parameters for traceabilityCompaniesCreate operation in TraceabilityApi.
 * @export
 * @interface TraceabilityApiTraceabilityCompaniesCreateRequest
 */
export interface TraceabilityApiTraceabilityCompaniesCreateRequest {
    /**
     * The ID of the viewing company
     * @type {number}
     * @memberof TraceabilityApiTraceabilityCompaniesCreate
     */
    readonly companyId: number

    /**
     * 
     * @type {CompanyCreateRequest}
     * @memberof TraceabilityApiTraceabilityCompaniesCreate
     */
    readonly companyCreateRequest: CompanyCreateRequest

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof TraceabilityApiTraceabilityCompaniesCreate
     */
    readonly leafLinkVersion?: string
}

/**
 * Request parameters for traceabilityCompaniesPartialUpdate operation in TraceabilityApi.
 * @export
 * @interface TraceabilityApiTraceabilityCompaniesPartialUpdateRequest
 */
export interface TraceabilityApiTraceabilityCompaniesPartialUpdateRequest {
    /**
     * The ID of the viewing company
     * @type {number}
     * @memberof TraceabilityApiTraceabilityCompaniesPartialUpdate
     */
    readonly companyId: number

    /**
     * ID of requested company
     * @type {number}
     * @memberof TraceabilityApiTraceabilityCompaniesPartialUpdate
     */
    readonly id: number

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof TraceabilityApiTraceabilityCompaniesPartialUpdate
     */
    readonly leafLinkVersion?: string

    /**
     * 
     * @type {PatchedCompanyUpdateRequest}
     * @memberof TraceabilityApiTraceabilityCompaniesPartialUpdate
     */
    readonly patchedCompanyUpdateRequest?: PatchedCompanyUpdateRequest
}

/**
 * Request parameters for traceabilityCompaniesRetrieve operation in TraceabilityApi.
 * @export
 * @interface TraceabilityApiTraceabilityCompaniesRetrieveRequest
 */
export interface TraceabilityApiTraceabilityCompaniesRetrieveRequest {
    /**
     * The ID of the viewing company
     * @type {number}
     * @memberof TraceabilityApiTraceabilityCompaniesRetrieve
     */
    readonly companyId: number

    /**
     * ID of requested company
     * @type {number}
     * @memberof TraceabilityApiTraceabilityCompaniesRetrieve
     */
    readonly id: number

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof TraceabilityApiTraceabilityCompaniesRetrieve
     */
    readonly leafLinkVersion?: string
}

/**
 * Request parameters for traceabilityCompanyCustomersList operation in TraceabilityApi.
 * @export
 * @interface TraceabilityApiTraceabilityCompanyCustomersListRequest
 */
export interface TraceabilityApiTraceabilityCompanyCustomersListRequest {
    /**
     * The ID of the viewing company
     * @type {number}
     * @memberof TraceabilityApiTraceabilityCompanyCustomersList
     */
    readonly companyId: number

    /**
     * Which field to use when ordering the results.
     * @type {string}
     * @memberof TraceabilityApiTraceabilityCompanyCustomersList
     */
    readonly ordering?: string

    /**
     * A page number within the paginated result set.
     * @type {number}
     * @memberof TraceabilityApiTraceabilityCompanyCustomersList
     */
    readonly page?: number

    /**
     * Number of results to return per page.
     * @type {number}
     * @memberof TraceabilityApiTraceabilityCompanyCustomersList
     */
    readonly pageSize?: number

    /**
     * A search term.
     * @type {string}
     * @memberof TraceabilityApiTraceabilityCompanyCustomersList
     */
    readonly search?: string

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof TraceabilityApiTraceabilityCompanyCustomersList
     */
    readonly leafLinkVersion?: string
}

/**
 * Request parameters for traceabilityCompanyCustomersRetrieve operation in TraceabilityApi.
 * @export
 * @interface TraceabilityApiTraceabilityCompanyCustomersRetrieveRequest
 */
export interface TraceabilityApiTraceabilityCompanyCustomersRetrieveRequest {
    /**
     * The ID of the viewing company
     * @type {number}
     * @memberof TraceabilityApiTraceabilityCompanyCustomersRetrieve
     */
    readonly companyId: number

    /**
     * A unique integer value identifying this company customer.
     * @type {number}
     * @memberof TraceabilityApiTraceabilityCompanyCustomersRetrieve
     */
    readonly id: number

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof TraceabilityApiTraceabilityCompanyCustomersRetrieve
     */
    readonly leafLinkVersion?: string
}

/**
 * Request parameters for traceabilityCompanyLicensesCreate operation in TraceabilityApi.
 * @export
 * @interface TraceabilityApiTraceabilityCompanyLicensesCreateRequest
 */
export interface TraceabilityApiTraceabilityCompanyLicensesCreateRequest {
    /**
     * The ID of the viewing company
     * @type {number}
     * @memberof TraceabilityApiTraceabilityCompanyLicensesCreate
     */
    readonly companyId: number

    /**
     * 
     * @type {LicenseApiKeyRequest}
     * @memberof TraceabilityApiTraceabilityCompanyLicensesCreate
     */
    readonly licenseApiKeyRequest: LicenseApiKeyRequest

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof TraceabilityApiTraceabilityCompanyLicensesCreate
     */
    readonly leafLinkVersion?: string
}

/**
 * Request parameters for traceabilityCompanySettingDestroy operation in TraceabilityApi.
 * @export
 * @interface TraceabilityApiTraceabilityCompanySettingDestroyRequest
 */
export interface TraceabilityApiTraceabilityCompanySettingDestroyRequest {
    /**
     * The ID of the viewing company
     * @type {number}
     * @memberof TraceabilityApiTraceabilityCompanySettingDestroy
     */
    readonly companyId: number

    /**
     * ID of integration to modify
     * @type {number}
     * @memberof TraceabilityApiTraceabilityCompanySettingDestroy
     */
    readonly id: number

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof TraceabilityApiTraceabilityCompanySettingDestroy
     */
    readonly leafLinkVersion?: string
}

/**
 * Request parameters for traceabilityDriversCreate operation in TraceabilityApi.
 * @export
 * @interface TraceabilityApiTraceabilityDriversCreateRequest
 */
export interface TraceabilityApiTraceabilityDriversCreateRequest {
    /**
     * The ID of the viewing company
     * @type {number}
     * @memberof TraceabilityApiTraceabilityDriversCreate
     */
    readonly companyId: number

    /**
     * 
     * @type {TraceabilityDriverCreateUpdateInputRequest}
     * @memberof TraceabilityApiTraceabilityDriversCreate
     */
    readonly traceabilityDriverCreateUpdateInputRequest: TraceabilityDriverCreateUpdateInputRequest

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof TraceabilityApiTraceabilityDriversCreate
     */
    readonly leafLinkVersion?: string
}

/**
 * Request parameters for traceabilityDriversList operation in TraceabilityApi.
 * @export
 * @interface TraceabilityApiTraceabilityDriversListRequest
 */
export interface TraceabilityApiTraceabilityDriversListRequest {
    /**
     * The ID of the viewing company
     * @type {number}
     * @memberof TraceabilityApiTraceabilityDriversList
     */
    readonly companyId: number

    /**
     * Which field to use when ordering the results.
     * @type {string}
     * @memberof TraceabilityApiTraceabilityDriversList
     */
    readonly ordering?: string

    /**
     * A page number within the paginated result set.
     * @type {number}
     * @memberof TraceabilityApiTraceabilityDriversList
     */
    readonly page?: number

    /**
     * Number of results to return per page.
     * @type {number}
     * @memberof TraceabilityApiTraceabilityDriversList
     */
    readonly pageSize?: number

    /**
     * Search term to filter the list by
     * @type {string}
     * @memberof TraceabilityApiTraceabilityDriversList
     */
    readonly search?: string

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof TraceabilityApiTraceabilityDriversList
     */
    readonly leafLinkVersion?: string
}

/**
 * Request parameters for traceabilityDriversPartialUpdate operation in TraceabilityApi.
 * @export
 * @interface TraceabilityApiTraceabilityDriversPartialUpdateRequest
 */
export interface TraceabilityApiTraceabilityDriversPartialUpdateRequest {
    /**
     * The ID of the viewing company
     * @type {number}
     * @memberof TraceabilityApiTraceabilityDriversPartialUpdate
     */
    readonly companyId: number

    /**
     * Vendor external ID of object to be updated
     * @type {string}
     * @memberof TraceabilityApiTraceabilityDriversPartialUpdate
     */
    readonly externalId: string

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof TraceabilityApiTraceabilityDriversPartialUpdate
     */
    readonly leafLinkVersion?: string

    /**
     * 
     * @type {PatchedTraceabilityDriverCreateUpdateInputRequest}
     * @memberof TraceabilityApiTraceabilityDriversPartialUpdate
     */
    readonly patchedTraceabilityDriverCreateUpdateInputRequest?: PatchedTraceabilityDriverCreateUpdateInputRequest
}

/**
 * Request parameters for traceabilityItemsList operation in TraceabilityApi.
 * @export
 * @interface TraceabilityApiTraceabilityItemsListRequest
 */
export interface TraceabilityApiTraceabilityItemsListRequest {
    /**
     * The ID of the viewing company
     * @type {number}
     * @memberof TraceabilityApiTraceabilityItemsList
     */
    readonly companyId: number

    /**
     * Boolean to indicate whether strain data should be included
     * @type {boolean}
     * @memberof TraceabilityApiTraceabilityItemsList
     */
    readonly includeStrainData?: boolean

    /**
     * Which field to use when ordering the results.
     * @type {string}
     * @memberof TraceabilityApiTraceabilityItemsList
     */
    readonly ordering?: string

    /**
     * A page number within the paginated result set.
     * @type {number}
     * @memberof TraceabilityApiTraceabilityItemsList
     */
    readonly page?: number

    /**
     * Number of results to return per page.
     * @type {number}
     * @memberof TraceabilityApiTraceabilityItemsList
     */
    readonly pageSize?: number

    /**
     * Search term to filter the list by
     * @type {string}
     * @memberof TraceabilityApiTraceabilityItemsList
     */
    readonly search?: string

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof TraceabilityApiTraceabilityItemsList
     */
    readonly leafLinkVersion?: string
}

/**
 * Request parameters for traceabilityOnboardingStatusRetrieve operation in TraceabilityApi.
 * @export
 * @interface TraceabilityApiTraceabilityOnboardingStatusRetrieveRequest
 */
export interface TraceabilityApiTraceabilityOnboardingStatusRetrieveRequest {
    /**
     * ID of requested company
     * @type {number}
     * @memberof TraceabilityApiTraceabilityOnboardingStatusRetrieve
     */
    readonly id: number

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof TraceabilityApiTraceabilityOnboardingStatusRetrieve
     */
    readonly leafLinkVersion?: string
}

/**
 * Request parameters for traceabilityOrdersByPackageLabelsList operation in TraceabilityApi.
 * @export
 * @interface TraceabilityApiTraceabilityOrdersByPackageLabelsListRequest
 */
export interface TraceabilityApiTraceabilityOrdersByPackageLabelsListRequest {
    /**
     * Which field to use when ordering the results.
     * @type {string}
     * @memberof TraceabilityApiTraceabilityOrdersByPackageLabelsList
     */
    readonly ordering?: string

    /**
     * A page number within the paginated result set.
     * @type {number}
     * @memberof TraceabilityApiTraceabilityOrdersByPackageLabelsList
     */
    readonly page?: number

    /**
     * Number of results to return per page.
     * @type {number}
     * @memberof TraceabilityApiTraceabilityOrdersByPackageLabelsList
     */
    readonly pageSize?: number

    /**
     * A search term.
     * @type {string}
     * @memberof TraceabilityApiTraceabilityOrdersByPackageLabelsList
     */
    readonly search?: string

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof TraceabilityApiTraceabilityOrdersByPackageLabelsList
     */
    readonly leafLinkVersion?: string
}

/**
 * Request parameters for traceabilityOrdersByPackageLabelsRetrieve operation in TraceabilityApi.
 * @export
 * @interface TraceabilityApiTraceabilityOrdersByPackageLabelsRetrieveRequest
 */
export interface TraceabilityApiTraceabilityOrdersByPackageLabelsRetrieveRequest {
    /**
     * A unique integer value identifying this attached package.
     * @type {number}
     * @memberof TraceabilityApiTraceabilityOrdersByPackageLabelsRetrieve
     */
    readonly id: number

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof TraceabilityApiTraceabilityOrdersByPackageLabelsRetrieve
     */
    readonly leafLinkVersion?: string
}

/**
 * Request parameters for traceabilityPackagesList operation in TraceabilityApi.
 * @export
 * @interface TraceabilityApiTraceabilityPackagesListRequest
 */
export interface TraceabilityApiTraceabilityPackagesListRequest {
    /**
     * The ID of the viewing company
     * @type {number}
     * @memberof TraceabilityApiTraceabilityPackagesList
     */
    readonly companyId: number

    /**
     * Filter by Traceability.common_packages that are assigned/unassigned products
     * @type {boolean}
     * @memberof TraceabilityApiTraceabilityPackagesList
     */
    readonly assigned?: boolean

    /**
     * Filter by Traceability.common_packages with a CBD value less than or equal to the given value
     * @type {number}
     * @memberof TraceabilityApiTraceabilityPackagesList
     */
    readonly cbdMax?: number

    /**
     * Filter by Traceability.common_packages with a CBD value greater than or equal to the given value
     * @type {number}
     * @memberof TraceabilityApiTraceabilityPackagesList
     */
    readonly cbdMin?: number

    /**
     * Filter out any Traceability.common_package that has already been assigned to an order line-item
     * @type {boolean}
     * @memberof TraceabilityApiTraceabilityPackagesList
     */
    readonly hideAttachedPackages?: boolean

    /**
     * Indicate whether to include a list of source_package_labels in the response
     * @type {boolean}
     * @memberof TraceabilityApiTraceabilityPackagesList
     */
    readonly includeSourcePackages?: boolean

    /**
     * Filter by Traceability.metrc_package.item_id (accepts comma-separated list)
     * @type {string}
     * @memberof TraceabilityApiTraceabilityPackagesList
     */
    readonly item?: string

    /**
     * Filter by Traceability.common_package.metrc_package.lab_testing_status (accepts comma-separated list)
     * @type {string}
     * @memberof TraceabilityApiTraceabilityPackagesList
     */
    readonly labTestingStatus?: string

    /**
     * Filter by Traceability.common_package.label (accepts comma-separated list)
     * @type {string}
     * @memberof TraceabilityApiTraceabilityPackagesList
     */
    readonly label?: string

    /**
     * Filter by Traceability.common_package.license_number (accepts comma-separated list)
     * @type {string}
     * @memberof TraceabilityApiTraceabilityPackagesList
     */
    readonly licenseNumber?: string

    /**
     * Limit for results, hard-cap of 25 enforced, default 25
     * @type {number}
     * @memberof TraceabilityApiTraceabilityPackagesList
     */
    readonly limit?: number

    /**
     * Filter by Traceability.common_package.location_id (accepts comma-separated list)
     * @type {string}
     * @memberof TraceabilityApiTraceabilityPackagesList
     */
    readonly location?: string

    /**
     * Filter Traceability.common_package by packages associated with manifest
     * @type {string}
     * @memberof TraceabilityApiTraceabilityPackagesList
     */
    readonly manifestNumber?: string

    /**
     * Used for pagination
     * @type {number}
     * @memberof TraceabilityApiTraceabilityPackagesList
     */
    readonly offset?: number

    /**
     * Which field to use when ordering the results.
     * @type {string}
     * @memberof TraceabilityApiTraceabilityPackagesList
     */
    readonly ordering?: string

    /**
     * Filter by Traceability.metrc_package.packaged_date (accepts comma-separated list)
     * @type {string}
     * @memberof TraceabilityApiTraceabilityPackagesList
     */
    readonly packagedDate?: string

    /**
     * A page number within the paginated result set.
     * @type {number}
     * @memberof TraceabilityApiTraceabilityPackagesList
     */
    readonly page?: number

    /**
     * Number of results to return per page.
     * @type {number}
     * @memberof TraceabilityApiTraceabilityPackagesList
     */
    readonly pageSize?: number

    /**
     * Filter Traceability.common_package by product_ids assigned to packages (accepts comma-separated list)
     * @type {string}
     * @memberof TraceabilityApiTraceabilityPackagesList
     */
    readonly productIds?: string

    /**
     * Search term to filter the list by
     * @type {string}
     * @memberof TraceabilityApiTraceabilityPackagesList
     */
    readonly search?: string

    /**
     * Filter Traceability.common_package by packages that are children of the given label
     * @type {string}
     * @memberof TraceabilityApiTraceabilityPackagesList
     */
    readonly sourcePackage?: string

    /**
     * Filter by Traceability.common_package.status field
     * @type {string}
     * @memberof TraceabilityApiTraceabilityPackagesList
     */
    readonly status?: string

    /**
     * Filter Traceability.common_package by packages assigned to template
     * @type {string}
     * @memberof TraceabilityApiTraceabilityPackagesList
     */
    readonly templateId?: string

    /**
     * Filter by Traceability.common_packages with a THC value less than or equal to the given value
     * @type {number}
     * @memberof TraceabilityApiTraceabilityPackagesList
     */
    readonly thcMax?: number

    /**
     * Filter by Traceability.common_packages with a THC value greater than or equal to the given value
     * @type {number}
     * @memberof TraceabilityApiTraceabilityPackagesList
     */
    readonly thcMin?: number

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof TraceabilityApiTraceabilityPackagesList
     */
    readonly leafLinkVersion?: string
}

/**
 * Request parameters for traceabilityRefreshRequestsList operation in TraceabilityApi.
 * @export
 * @interface TraceabilityApiTraceabilityRefreshRequestsListRequest
 */
export interface TraceabilityApiTraceabilityRefreshRequestsListRequest {
    /**
     * The ID of the viewing company
     * @type {number}
     * @memberof TraceabilityApiTraceabilityRefreshRequestsList
     */
    readonly companyId: number

    /**
     * Which field to use when ordering the results.
     * @type {string}
     * @memberof TraceabilityApiTraceabilityRefreshRequestsList
     */
    readonly ordering?: string

    /**
     * A page number within the paginated result set.
     * @type {number}
     * @memberof TraceabilityApiTraceabilityRefreshRequestsList
     */
    readonly page?: number

    /**
     * Number of results to return per page.
     * @type {number}
     * @memberof TraceabilityApiTraceabilityRefreshRequestsList
     */
    readonly pageSize?: number

    /**
     * Filter results by refresh_request.created_at
     * @type {string}
     * @memberof TraceabilityApiTraceabilityRefreshRequestsList
     */
    readonly refreshDate?: string

    /**
     * A search term.
     * @type {string}
     * @memberof TraceabilityApiTraceabilityRefreshRequestsList
     */
    readonly search?: string

    /**
     * Filter results by comma-separated list of refresh statuses
     * @type {string}
     * @memberof TraceabilityApiTraceabilityRefreshRequestsList
     */
    readonly status?: string

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof TraceabilityApiTraceabilityRefreshRequestsList
     */
    readonly leafLinkVersion?: string
}

/**
 * Request parameters for traceabilityTemplatesCreate operation in TraceabilityApi.
 * @export
 * @interface TraceabilityApiTraceabilityTemplatesCreateRequest
 */
export interface TraceabilityApiTraceabilityTemplatesCreateRequest {
    /**
     * The ID of the viewing company
     * @type {number}
     * @memberof TraceabilityApiTraceabilityTemplatesCreate
     */
    readonly companyId: number

    /**
     * 
     * @type {TemplateCreateRequest}
     * @memberof TraceabilityApiTraceabilityTemplatesCreate
     */
    readonly templateCreateRequest: TemplateCreateRequest

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof TraceabilityApiTraceabilityTemplatesCreate
     */
    readonly leafLinkVersion?: string
}

/**
 * Request parameters for traceabilityTemplatesList operation in TraceabilityApi.
 * @export
 * @interface TraceabilityApiTraceabilityTemplatesListRequest
 */
export interface TraceabilityApiTraceabilityTemplatesListRequest {
    /**
     * The ID of the viewing company
     * @type {number}
     * @memberof TraceabilityApiTraceabilityTemplatesList
     */
    readonly companyId: number

    /**
     * Limit for results, hard-cap of 25 enforced, default 25
     * @type {number}
     * @memberof TraceabilityApiTraceabilityTemplatesList
     */
    readonly limit?: number

    /**
     * Filter results by associated LL order ID
     * @type {number}
     * @memberof TraceabilityApiTraceabilityTemplatesList
     */
    readonly llOrderId?: number

    /**
     * Used for pagination
     * @type {number}
     * @memberof TraceabilityApiTraceabilityTemplatesList
     */
    readonly offset?: number

    /**
     * Which field to use when ordering the results.
     * @type {string}
     * @memberof TraceabilityApiTraceabilityTemplatesList
     */
    readonly ordering?: string

    /**
     * A page number within the paginated result set.
     * @type {number}
     * @memberof TraceabilityApiTraceabilityTemplatesList
     */
    readonly page?: number

    /**
     * Number of results to return per page.
     * @type {number}
     * @memberof TraceabilityApiTraceabilityTemplatesList
     */
    readonly pageSize?: number

    /**
     * Search term to filter the list by
     * @type {string}
     * @memberof TraceabilityApiTraceabilityTemplatesList
     */
    readonly search?: string

    /**
     * Filter results by ship date
     * @type {string}
     * @memberof TraceabilityApiTraceabilityTemplatesList
     */
    readonly shipDate?: string

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof TraceabilityApiTraceabilityTemplatesList
     */
    readonly leafLinkVersion?: string
}

/**
 * Request parameters for traceabilityTemplatesPartialUpdate operation in TraceabilityApi.
 * @export
 * @interface TraceabilityApiTraceabilityTemplatesPartialUpdateRequest
 */
export interface TraceabilityApiTraceabilityTemplatesPartialUpdateRequest {
    /**
     * The ID of the viewing company
     * @type {number}
     * @memberof TraceabilityApiTraceabilityTemplatesPartialUpdate
     */
    readonly companyId: number

    /**
     * ID of requested template
     * @type {number}
     * @memberof TraceabilityApiTraceabilityTemplatesPartialUpdate
     */
    readonly id: number

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof TraceabilityApiTraceabilityTemplatesPartialUpdate
     */
    readonly leafLinkVersion?: string

    /**
     * 
     * @type {PatchedTemplateUpdateRequest}
     * @memberof TraceabilityApiTraceabilityTemplatesPartialUpdate
     */
    readonly patchedTemplateUpdateRequest?: PatchedTemplateUpdateRequest
}

/**
 * Request parameters for traceabilityTemplatesRetrieve operation in TraceabilityApi.
 * @export
 * @interface TraceabilityApiTraceabilityTemplatesRetrieveRequest
 */
export interface TraceabilityApiTraceabilityTemplatesRetrieveRequest {
    /**
     * The ID of the viewing company
     * @type {number}
     * @memberof TraceabilityApiTraceabilityTemplatesRetrieve
     */
    readonly companyId: number

    /**
     * ID of requested template
     * @type {number}
     * @memberof TraceabilityApiTraceabilityTemplatesRetrieve
     */
    readonly id: number

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof TraceabilityApiTraceabilityTemplatesRetrieve
     */
    readonly leafLinkVersion?: string
}

/**
 * Request parameters for traceabilityTransferCompaniesList operation in TraceabilityApi.
 * @export
 * @interface TraceabilityApiTraceabilityTransferCompaniesListRequest
 */
export interface TraceabilityApiTraceabilityTransferCompaniesListRequest {
    /**
     * The ID of the viewing company
     * @type {number}
     * @memberof TraceabilityApiTraceabilityTransferCompaniesList
     */
    readonly companyId: number

    /**
     * Filter by Traceability.transfer.shipper_facility_name|shipper_facility_license_number fields contain value
     * @type {string}
     * @memberof TraceabilityApiTraceabilityTransferCompaniesList
     */
    readonly fromShipper?: string

    /**
     * Which field to use when ordering the results.
     * @type {string}
     * @memberof TraceabilityApiTraceabilityTransferCompaniesList
     */
    readonly ordering?: string

    /**
     * A page number within the paginated result set.
     * @type {number}
     * @memberof TraceabilityApiTraceabilityTransferCompaniesList
     */
    readonly page?: number

    /**
     * Number of results to return per page.
     * @type {number}
     * @memberof TraceabilityApiTraceabilityTransferCompaniesList
     */
    readonly pageSize?: number

    /**
     * A search term.
     * @type {string}
     * @memberof TraceabilityApiTraceabilityTransferCompaniesList
     */
    readonly search?: string

    /**
     * Filter by Traceability.transfer.recipient_facility_name|recipient_facility_license_number fields contain value
     * @type {string}
     * @memberof TraceabilityApiTraceabilityTransferCompaniesList
     */
    readonly toRecipient?: string

    /**
     * Filter by Traceability.transfer.type field
     * @type {string}
     * @memberof TraceabilityApiTraceabilityTransferCompaniesList
     */
    readonly transferType?: string

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof TraceabilityApiTraceabilityTransferCompaniesList
     */
    readonly leafLinkVersion?: string
}

/**
 * Request parameters for traceabilityTransfersList operation in TraceabilityApi.
 * @export
 * @interface TraceabilityApiTraceabilityTransfersListRequest
 */
export interface TraceabilityApiTraceabilityTransfersListRequest {
    /**
     * The ID of the viewing company
     * @type {number}
     * @memberof TraceabilityApiTraceabilityTransfersList
     */
    readonly companyId: number

    /**
     * Filter by Traceability.transfer.arrival_date field
     * @type {string}
     * @memberof TraceabilityApiTraceabilityTransfersList
     */
    readonly arrivalDate?: string

    /**
     * Filter by Traceability.transfer.company.external_id (marketplace.company.id) field
     * @type {string}
     * @memberof TraceabilityApiTraceabilityTransfersList
     */
    readonly companyIds?: string

    /**
     * Filter by Traceability.transfer.received_datetime field not None
     * @type {boolean}
     * @memberof TraceabilityApiTraceabilityTransfersList
     */
    readonly excludeReceived?: boolean

    /**
     * Filter by Traceability.&lt;model&gt;.external_id field
     * @type {string}
     * @memberof TraceabilityApiTraceabilityTransfersList
     */
    readonly externalIds?: string

    /**
     * Filter by Traceability.transfer.shipper_facility_name|shipper_facility_license_number fields contain value
     * @type {string}
     * @memberof TraceabilityApiTraceabilityTransfersList
     */
    readonly fromShipper?: string

    /**
     * Filter by transfers that are associated with orders in LL
     * @type {boolean}
     * @memberof TraceabilityApiTraceabilityTransfersList
     */
    readonly hasAttachedOrders?: boolean

    /**
     * Traceability.&lt;model&gt;.id field
     * @type {string}
     * @memberof TraceabilityApiTraceabilityTransfersList
     */
    readonly ids?: string

    /**
     * Include delivery packages in response
     * @type {boolean}
     * @memberof TraceabilityApiTraceabilityTransfersList
     */
    readonly includePackageData?: boolean

    /**
     * Limit for results, hard-cap of 25 enforced, default 25
     * @type {number}
     * @memberof TraceabilityApiTraceabilityTransfersList
     */
    readonly limit?: number

    /**
     * Filter by Traceability.&lt;model&gt;.metrc_id field
     * @type {string}
     * @memberof TraceabilityApiTraceabilityTransfersList
     */
    readonly metrcIds?: string

    /**
     * Used for pagination
     * @type {number}
     * @memberof TraceabilityApiTraceabilityTransfersList
     */
    readonly offset?: number

    /**
     * Filter transfers by Traceability.order_transfer.order_id list field
     * @type {string}
     * @memberof TraceabilityApiTraceabilityTransfersList
     */
    readonly orderIds?: string

    /**
     * Which field to use when ordering the results.
     * @type {string}
     * @memberof TraceabilityApiTraceabilityTransfersList
     */
    readonly ordering?: string

    /**
     * A page number within the paginated result set.
     * @type {number}
     * @memberof TraceabilityApiTraceabilityTransfersList
     */
    readonly page?: number

    /**
     * Number of results to return per page.
     * @type {number}
     * @memberof TraceabilityApiTraceabilityTransfersList
     */
    readonly pageSize?: number

    /**
     * Search term to filter the list by
     * @type {string}
     * @memberof TraceabilityApiTraceabilityTransfersList
     */
    readonly search?: string

    /**
     * Filter results by ship date
     * @type {string}
     * @memberof TraceabilityApiTraceabilityTransfersList
     */
    readonly shipDate?: string

    /**
     * Sort results by given field
     * @type {string}
     * @memberof TraceabilityApiTraceabilityTransfersList
     */
    readonly sortBy?: string

    /**
     * Filter by Traceability.transfer.recipient_facility_name|recipient_facility_license_number fields contain value
     * @type {string}
     * @memberof TraceabilityApiTraceabilityTransfersList
     */
    readonly toRecipient?: string

    /**
     * Filter by Traceability.transfer.metrc_id field
     * @type {string}
     * @memberof TraceabilityApiTraceabilityTransfersList
     */
    readonly traceabilityTransferExternalIds?: string

    /**
     * Filter by Traceability.transfer.status field
     * @type {string}
     * @memberof TraceabilityApiTraceabilityTransfersList
     */
    readonly transferStatus?: string

    /**
     * Filter by Traceability.transfer.type field
     * @type {string}
     * @memberof TraceabilityApiTraceabilityTransfersList
     */
    readonly transferType?: string

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof TraceabilityApiTraceabilityTransfersList
     */
    readonly leafLinkVersion?: string
}

/**
 * Request parameters for traceabilityVehiclesCreate operation in TraceabilityApi.
 * @export
 * @interface TraceabilityApiTraceabilityVehiclesCreateRequest
 */
export interface TraceabilityApiTraceabilityVehiclesCreateRequest {
    /**
     * The ID of the viewing company
     * @type {number}
     * @memberof TraceabilityApiTraceabilityVehiclesCreate
     */
    readonly companyId: number

    /**
     * 
     * @type {TraceabilityVehicleCreateUpdateInputRequest}
     * @memberof TraceabilityApiTraceabilityVehiclesCreate
     */
    readonly traceabilityVehicleCreateUpdateInputRequest: TraceabilityVehicleCreateUpdateInputRequest

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof TraceabilityApiTraceabilityVehiclesCreate
     */
    readonly leafLinkVersion?: string
}

/**
 * Request parameters for traceabilityVehiclesList operation in TraceabilityApi.
 * @export
 * @interface TraceabilityApiTraceabilityVehiclesListRequest
 */
export interface TraceabilityApiTraceabilityVehiclesListRequest {
    /**
     * The ID of the viewing company
     * @type {number}
     * @memberof TraceabilityApiTraceabilityVehiclesList
     */
    readonly companyId: number

    /**
     * Which field to use when ordering the results.
     * @type {string}
     * @memberof TraceabilityApiTraceabilityVehiclesList
     */
    readonly ordering?: string

    /**
     * A page number within the paginated result set.
     * @type {number}
     * @memberof TraceabilityApiTraceabilityVehiclesList
     */
    readonly page?: number

    /**
     * Number of results to return per page.
     * @type {number}
     * @memberof TraceabilityApiTraceabilityVehiclesList
     */
    readonly pageSize?: number

    /**
     * Search term to filter the list by
     * @type {string}
     * @memberof TraceabilityApiTraceabilityVehiclesList
     */
    readonly search?: string

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof TraceabilityApiTraceabilityVehiclesList
     */
    readonly leafLinkVersion?: string
}

/**
 * Request parameters for traceabilityVehiclesPartialUpdate operation in TraceabilityApi.
 * @export
 * @interface TraceabilityApiTraceabilityVehiclesPartialUpdateRequest
 */
export interface TraceabilityApiTraceabilityVehiclesPartialUpdateRequest {
    /**
     * The ID of the viewing company
     * @type {number}
     * @memberof TraceabilityApiTraceabilityVehiclesPartialUpdate
     */
    readonly companyId: number

    /**
     * Vendor external ID of object to be updated
     * @type {string}
     * @memberof TraceabilityApiTraceabilityVehiclesPartialUpdate
     */
    readonly externalId: string

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof TraceabilityApiTraceabilityVehiclesPartialUpdate
     */
    readonly leafLinkVersion?: string

    /**
     * 
     * @type {PatchedTraceabilityVehicleCreateUpdateInputRequest}
     * @memberof TraceabilityApiTraceabilityVehiclesPartialUpdate
     */
    readonly patchedTraceabilityVehicleCreateUpdateInputRequest?: PatchedTraceabilityVehicleCreateUpdateInputRequest
}

/**
 * TraceabilityApi - object-oriented interface
 * @export
 * @class TraceabilityApi
 * @extends {BaseAPI}
 */
export class TraceabilityApi extends BaseAPI {
    /**
     * Reconcile inventory for products, utilizes marketplace celery tasks + traceability service data.
     * @param {TraceabilityApiTraceabilityActionsRefreshProductsPackagesPartialUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TraceabilityApi
     */
    public traceabilityActionsRefreshProductsPackagesPartialUpdate(requestParameters: TraceabilityApiTraceabilityActionsRefreshProductsPackagesPartialUpdateRequest, options?: RawAxiosRequestConfig) {
        return TraceabilityApiFp(this.configuration).traceabilityActionsRefreshProductsPackagesPartialUpdate(requestParameters.companyId, requestParameters.leafLinkVersion, requestParameters.patchedTraceabilityRefreshProductsPackagesRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Perform refresh for specified resource types and optional datetime.
     * @param {TraceabilityApiTraceabilityActionsRefreshResourcesRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TraceabilityApi
     */
    public traceabilityActionsRefreshResourcesRetrieve(requestParameters: TraceabilityApiTraceabilityActionsRefreshResourcesRetrieveRequest, options?: RawAxiosRequestConfig) {
        return TraceabilityApiFp(this.configuration).traceabilityActionsRefreshResourcesRetrieve(requestParameters.companyId, requestParameters.types, requestParameters.endDate, requestParameters.startDate, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new company in the traceability service.
     * @param {TraceabilityApiTraceabilityCompaniesCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TraceabilityApi
     */
    public traceabilityCompaniesCreate(requestParameters: TraceabilityApiTraceabilityCompaniesCreateRequest, options?: RawAxiosRequestConfig) {
        return TraceabilityApiFp(this.configuration).traceabilityCompaniesCreate(requestParameters.companyId, requestParameters.companyCreateRequest, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a company in the traceability service.
     * @param {TraceabilityApiTraceabilityCompaniesPartialUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TraceabilityApi
     */
    public traceabilityCompaniesPartialUpdate(requestParameters: TraceabilityApiTraceabilityCompaniesPartialUpdateRequest, options?: RawAxiosRequestConfig) {
        return TraceabilityApiFp(this.configuration).traceabilityCompaniesPartialUpdate(requestParameters.companyId, requestParameters.id, requestParameters.leafLinkVersion, requestParameters.patchedCompanyUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get company by ID.
     * @param {TraceabilityApiTraceabilityCompaniesRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TraceabilityApi
     */
    public traceabilityCompaniesRetrieve(requestParameters: TraceabilityApiTraceabilityCompaniesRetrieveRequest, options?: RawAxiosRequestConfig) {
        return TraceabilityApiFp(this.configuration).traceabilityCompaniesRetrieve(requestParameters.companyId, requestParameters.id, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get company customers.
     * @param {TraceabilityApiTraceabilityCompanyCustomersListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TraceabilityApi
     */
    public traceabilityCompanyCustomersList(requestParameters: TraceabilityApiTraceabilityCompanyCustomersListRequest, options?: RawAxiosRequestConfig) {
        return TraceabilityApiFp(this.configuration).traceabilityCompanyCustomersList(requestParameters.companyId, requestParameters.ordering, requestParameters.page, requestParameters.pageSize, requestParameters.search, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get company customer by ID.
     * @param {TraceabilityApiTraceabilityCompanyCustomersRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TraceabilityApi
     */
    public traceabilityCompanyCustomersRetrieve(requestParameters: TraceabilityApiTraceabilityCompanyCustomersRetrieveRequest, options?: RawAxiosRequestConfig) {
        return TraceabilityApiFp(this.configuration).traceabilityCompanyCustomersRetrieve(requestParameters.companyId, requestParameters.id, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get company licenses
     * @param {TraceabilityApiTraceabilityCompanyLicensesCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TraceabilityApi
     */
    public traceabilityCompanyLicensesCreate(requestParameters: TraceabilityApiTraceabilityCompanyLicensesCreateRequest, options?: RawAxiosRequestConfig) {
        return TraceabilityApiFp(this.configuration).traceabilityCompanyLicensesCreate(requestParameters.companyId, requestParameters.licenseApiKeyRequest, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a company\'s integration.
     * @param {TraceabilityApiTraceabilityCompanySettingDestroyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TraceabilityApi
     */
    public traceabilityCompanySettingDestroy(requestParameters: TraceabilityApiTraceabilityCompanySettingDestroyRequest, options?: RawAxiosRequestConfig) {
        return TraceabilityApiFp(this.configuration).traceabilityCompanySettingDestroy(requestParameters.companyId, requestParameters.id, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new driver in the traceability service.
     * @param {TraceabilityApiTraceabilityDriversCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TraceabilityApi
     */
    public traceabilityDriversCreate(requestParameters: TraceabilityApiTraceabilityDriversCreateRequest, options?: RawAxiosRequestConfig) {
        return TraceabilityApiFp(this.configuration).traceabilityDriversCreate(requestParameters.companyId, requestParameters.traceabilityDriverCreateUpdateInputRequest, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all drivers for company
     * @param {TraceabilityApiTraceabilityDriversListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TraceabilityApi
     */
    public traceabilityDriversList(requestParameters: TraceabilityApiTraceabilityDriversListRequest, options?: RawAxiosRequestConfig) {
        return TraceabilityApiFp(this.configuration).traceabilityDriversList(requestParameters.companyId, requestParameters.ordering, requestParameters.page, requestParameters.pageSize, requestParameters.search, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a driver in the traceability service.
     * @param {TraceabilityApiTraceabilityDriversPartialUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TraceabilityApi
     */
    public traceabilityDriversPartialUpdate(requestParameters: TraceabilityApiTraceabilityDriversPartialUpdateRequest, options?: RawAxiosRequestConfig) {
        return TraceabilityApiFp(this.configuration).traceabilityDriversPartialUpdate(requestParameters.companyId, requestParameters.externalId, requestParameters.leafLinkVersion, requestParameters.patchedTraceabilityDriverCreateUpdateInputRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all items from the traceability service for a company.
     * @param {TraceabilityApiTraceabilityItemsListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TraceabilityApi
     */
    public traceabilityItemsList(requestParameters: TraceabilityApiTraceabilityItemsListRequest, options?: RawAxiosRequestConfig) {
        return TraceabilityApiFp(this.configuration).traceabilityItemsList(requestParameters.companyId, requestParameters.includeStrainData, requestParameters.ordering, requestParameters.page, requestParameters.pageSize, requestParameters.search, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get onboarding status.
     * @param {TraceabilityApiTraceabilityOnboardingStatusRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TraceabilityApi
     */
    public traceabilityOnboardingStatusRetrieve(requestParameters: TraceabilityApiTraceabilityOnboardingStatusRetrieveRequest, options?: RawAxiosRequestConfig) {
        return TraceabilityApiFp(this.configuration).traceabilityOnboardingStatusRetrieve(requestParameters.id, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Unified API Orders by Package Labels.
     * @param {TraceabilityApiTraceabilityOrdersByPackageLabelsListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TraceabilityApi
     */
    public traceabilityOrdersByPackageLabelsList(requestParameters: TraceabilityApiTraceabilityOrdersByPackageLabelsListRequest = {}, options?: RawAxiosRequestConfig) {
        return TraceabilityApiFp(this.configuration).traceabilityOrdersByPackageLabelsList(requestParameters.ordering, requestParameters.page, requestParameters.pageSize, requestParameters.search, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Unified API Orders by Package Labels.
     * @param {TraceabilityApiTraceabilityOrdersByPackageLabelsRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TraceabilityApi
     */
    public traceabilityOrdersByPackageLabelsRetrieve(requestParameters: TraceabilityApiTraceabilityOrdersByPackageLabelsRetrieveRequest, options?: RawAxiosRequestConfig) {
        return TraceabilityApiFp(this.configuration).traceabilityOrdersByPackageLabelsRetrieve(requestParameters.id, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get company packages
     * @param {TraceabilityApiTraceabilityPackagesListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TraceabilityApi
     */
    public traceabilityPackagesList(requestParameters: TraceabilityApiTraceabilityPackagesListRequest, options?: RawAxiosRequestConfig) {
        return TraceabilityApiFp(this.configuration).traceabilityPackagesList(requestParameters.companyId, requestParameters.assigned, requestParameters.cbdMax, requestParameters.cbdMin, requestParameters.hideAttachedPackages, requestParameters.includeSourcePackages, requestParameters.item, requestParameters.labTestingStatus, requestParameters.label, requestParameters.licenseNumber, requestParameters.limit, requestParameters.location, requestParameters.manifestNumber, requestParameters.offset, requestParameters.ordering, requestParameters.packagedDate, requestParameters.page, requestParameters.pageSize, requestParameters.productIds, requestParameters.search, requestParameters.sourcePackage, requestParameters.status, requestParameters.templateId, requestParameters.thcMax, requestParameters.thcMin, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all refresh_requests from the traceability service for a company.
     * @param {TraceabilityApiTraceabilityRefreshRequestsListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TraceabilityApi
     */
    public traceabilityRefreshRequestsList(requestParameters: TraceabilityApiTraceabilityRefreshRequestsListRequest, options?: RawAxiosRequestConfig) {
        return TraceabilityApiFp(this.configuration).traceabilityRefreshRequestsList(requestParameters.companyId, requestParameters.ordering, requestParameters.page, requestParameters.pageSize, requestParameters.refreshDate, requestParameters.search, requestParameters.status, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new Template in the traceability service.
     * @param {TraceabilityApiTraceabilityTemplatesCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TraceabilityApi
     */
    public traceabilityTemplatesCreate(requestParameters: TraceabilityApiTraceabilityTemplatesCreateRequest, options?: RawAxiosRequestConfig) {
        return TraceabilityApiFp(this.configuration).traceabilityTemplatesCreate(requestParameters.companyId, requestParameters.templateCreateRequest, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get templates from the traceability service for company.
     * @param {TraceabilityApiTraceabilityTemplatesListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TraceabilityApi
     */
    public traceabilityTemplatesList(requestParameters: TraceabilityApiTraceabilityTemplatesListRequest, options?: RawAxiosRequestConfig) {
        return TraceabilityApiFp(this.configuration).traceabilityTemplatesList(requestParameters.companyId, requestParameters.limit, requestParameters.llOrderId, requestParameters.offset, requestParameters.ordering, requestParameters.page, requestParameters.pageSize, requestParameters.search, requestParameters.shipDate, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a template in the traceability service.
     * @param {TraceabilityApiTraceabilityTemplatesPartialUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TraceabilityApi
     */
    public traceabilityTemplatesPartialUpdate(requestParameters: TraceabilityApiTraceabilityTemplatesPartialUpdateRequest, options?: RawAxiosRequestConfig) {
        return TraceabilityApiFp(this.configuration).traceabilityTemplatesPartialUpdate(requestParameters.companyId, requestParameters.id, requestParameters.leafLinkVersion, requestParameters.patchedTemplateUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get template by ID for company.
     * @param {TraceabilityApiTraceabilityTemplatesRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TraceabilityApi
     */
    public traceabilityTemplatesRetrieve(requestParameters: TraceabilityApiTraceabilityTemplatesRetrieveRequest, options?: RawAxiosRequestConfig) {
        return TraceabilityApiFp(this.configuration).traceabilityTemplatesRetrieve(requestParameters.companyId, requestParameters.id, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get origin/destination companies of a transfer + their associated license
     * @param {TraceabilityApiTraceabilityTransferCompaniesListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TraceabilityApi
     */
    public traceabilityTransferCompaniesList(requestParameters: TraceabilityApiTraceabilityTransferCompaniesListRequest, options?: RawAxiosRequestConfig) {
        return TraceabilityApiFp(this.configuration).traceabilityTransferCompaniesList(requestParameters.companyId, requestParameters.fromShipper, requestParameters.ordering, requestParameters.page, requestParameters.pageSize, requestParameters.search, requestParameters.toRecipient, requestParameters.transferType, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get traceability transfer data. Note: resource_type fields will not be present in the payloads. They are just needed to help define polymorphic fields.
     * @param {TraceabilityApiTraceabilityTransfersListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TraceabilityApi
     */
    public traceabilityTransfersList(requestParameters: TraceabilityApiTraceabilityTransfersListRequest, options?: RawAxiosRequestConfig) {
        return TraceabilityApiFp(this.configuration).traceabilityTransfersList(requestParameters.companyId, requestParameters.arrivalDate, requestParameters.companyIds, requestParameters.excludeReceived, requestParameters.externalIds, requestParameters.fromShipper, requestParameters.hasAttachedOrders, requestParameters.ids, requestParameters.includePackageData, requestParameters.limit, requestParameters.metrcIds, requestParameters.offset, requestParameters.orderIds, requestParameters.ordering, requestParameters.page, requestParameters.pageSize, requestParameters.search, requestParameters.shipDate, requestParameters.sortBy, requestParameters.toRecipient, requestParameters.traceabilityTransferExternalIds, requestParameters.transferStatus, requestParameters.transferType, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new vehicle in the traceability service.
     * @param {TraceabilityApiTraceabilityVehiclesCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TraceabilityApi
     */
    public traceabilityVehiclesCreate(requestParameters: TraceabilityApiTraceabilityVehiclesCreateRequest, options?: RawAxiosRequestConfig) {
        return TraceabilityApiFp(this.configuration).traceabilityVehiclesCreate(requestParameters.companyId, requestParameters.traceabilityVehicleCreateUpdateInputRequest, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all vehicles
     * @param {TraceabilityApiTraceabilityVehiclesListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TraceabilityApi
     */
    public traceabilityVehiclesList(requestParameters: TraceabilityApiTraceabilityVehiclesListRequest, options?: RawAxiosRequestConfig) {
        return TraceabilityApiFp(this.configuration).traceabilityVehiclesList(requestParameters.companyId, requestParameters.ordering, requestParameters.page, requestParameters.pageSize, requestParameters.search, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a vehicle in the traceability service.
     * @param {TraceabilityApiTraceabilityVehiclesPartialUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TraceabilityApi
     */
    public traceabilityVehiclesPartialUpdate(requestParameters: TraceabilityApiTraceabilityVehiclesPartialUpdateRequest, options?: RawAxiosRequestConfig) {
        return TraceabilityApiFp(this.configuration).traceabilityVehiclesPartialUpdate(requestParameters.companyId, requestParameters.externalId, requestParameters.leafLinkVersion, requestParameters.patchedTraceabilityVehicleCreateUpdateInputRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TransportationApi - axios parameter creator
 * @export
 */
export const TransportationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Transport Company view set.
         * @param {number} id A unique integer value identifying this transport company.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transportationCompaniesRetrieve: async (id: number, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('transportationCompaniesRetrieve', 'id', id)
            const localVarPath = `/transportation/companies/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Transport partner drivers view set.
         * @param {number} id A unique integer value identifying this driver.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {PatchedInternalDriverRequest} [patchedInternalDriverRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transportationDriversPartialUpdate: async (id: number, leafLinkVersion?: string, patchedInternalDriverRequest?: PatchedInternalDriverRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('transportationDriversPartialUpdate', 'id', id)
            const localVarPath = `/transportation/drivers/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication tokenAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchedInternalDriverRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Transport partner drivers view set.
         * @param {number} id A unique integer value identifying this driver.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transportationDriversRetrieve: async (id: number, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('transportationDriversRetrieve', 'id', id)
            const localVarPath = `/transportation/drivers/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication tokenAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Unified API product categories.
         * @param {UnifiedL3OrderRequest} unifiedL3OrderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transportationOrdersCreate: async (unifiedL3OrderRequest: UnifiedL3OrderRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'unifiedL3OrderRequest' is not null or undefined
            assertParamExists('transportationOrdersCreate', 'unifiedL3OrderRequest', unifiedL3OrderRequest)
            const localVarPath = `/transportation/orders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication tokenAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(unifiedL3OrderRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Company transport partner view set.
         * @param {number} id A unique integer value identifying this company transport partner.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transportationPartnersRetrieve: async (id: number, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('transportationPartnersRetrieve', 'id', id)
            const localVarPath = `/transportation/partners/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Transport partner vehicle view set.
         * @param {number} id A unique integer value identifying this vehicle.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transportationVehiclesDestroy: async (id: number, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('transportationVehiclesDestroy', 'id', id)
            const localVarPath = `/transportation/vehicles/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication tokenAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Transport partner vehicle view set.
         * @param {number} id A unique integer value identifying this vehicle.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {PatchedVehicleRequest} [patchedVehicleRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transportationVehiclesPartialUpdate: async (id: number, leafLinkVersion?: string, patchedVehicleRequest?: PatchedVehicleRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('transportationVehiclesPartialUpdate', 'id', id)
            const localVarPath = `/transportation/vehicles/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication tokenAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchedVehicleRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Transport partner vehicle view set.
         * @param {number} id A unique integer value identifying this vehicle.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transportationVehiclesRetrieve: async (id: number, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('transportationVehiclesRetrieve', 'id', id)
            const localVarPath = `/transportation/vehicles/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication tokenAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TransportationApi - functional programming interface
 * @export
 */
export const TransportationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TransportationApiAxiosParamCreator(configuration)
    return {
        /**
         * Transport Company view set.
         * @param {number} id A unique integer value identifying this transport company.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async transportationCompaniesRetrieve(id: number, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TransportCompany>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.transportationCompaniesRetrieve(id, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TransportationApi.transportationCompaniesRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Transport partner drivers view set.
         * @param {number} id A unique integer value identifying this driver.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {PatchedInternalDriverRequest} [patchedInternalDriverRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async transportationDriversPartialUpdate(id: number, leafLinkVersion?: string, patchedInternalDriverRequest?: PatchedInternalDriverRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InternalDriver>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.transportationDriversPartialUpdate(id, leafLinkVersion, patchedInternalDriverRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TransportationApi.transportationDriversPartialUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Transport partner drivers view set.
         * @param {number} id A unique integer value identifying this driver.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async transportationDriversRetrieve(id: number, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InternalDriver>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.transportationDriversRetrieve(id, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TransportationApi.transportationDriversRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Unified API product categories.
         * @param {UnifiedL3OrderRequest} unifiedL3OrderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async transportationOrdersCreate(unifiedL3OrderRequest: UnifiedL3OrderRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnifiedL3Order>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.transportationOrdersCreate(unifiedL3OrderRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TransportationApi.transportationOrdersCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Company transport partner view set.
         * @param {number} id A unique integer value identifying this company transport partner.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async transportationPartnersRetrieve(id: number, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompanyTransportPartner>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.transportationPartnersRetrieve(id, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TransportationApi.transportationPartnersRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Transport partner vehicle view set.
         * @param {number} id A unique integer value identifying this vehicle.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async transportationVehiclesDestroy(id: number, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.transportationVehiclesDestroy(id, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TransportationApi.transportationVehiclesDestroy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Transport partner vehicle view set.
         * @param {number} id A unique integer value identifying this vehicle.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {PatchedVehicleRequest} [patchedVehicleRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async transportationVehiclesPartialUpdate(id: number, leafLinkVersion?: string, patchedVehicleRequest?: PatchedVehicleRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Vehicle>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.transportationVehiclesPartialUpdate(id, leafLinkVersion, patchedVehicleRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TransportationApi.transportationVehiclesPartialUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Transport partner vehicle view set.
         * @param {number} id A unique integer value identifying this vehicle.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async transportationVehiclesRetrieve(id: number, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Vehicle>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.transportationVehiclesRetrieve(id, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TransportationApi.transportationVehiclesRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TransportationApi - factory interface
 * @export
 */
export const TransportationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TransportationApiFp(configuration)
    return {
        /**
         * Transport Company view set.
         * @param {TransportationApiTransportationCompaniesRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transportationCompaniesRetrieve(requestParameters: TransportationApiTransportationCompaniesRetrieveRequest, options?: RawAxiosRequestConfig): AxiosPromise<TransportCompany> {
            return localVarFp.transportationCompaniesRetrieve(requestParameters.id, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * Transport partner drivers view set.
         * @param {TransportationApiTransportationDriversPartialUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transportationDriversPartialUpdate(requestParameters: TransportationApiTransportationDriversPartialUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<InternalDriver> {
            return localVarFp.transportationDriversPartialUpdate(requestParameters.id, requestParameters.leafLinkVersion, requestParameters.patchedInternalDriverRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Transport partner drivers view set.
         * @param {TransportationApiTransportationDriversRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transportationDriversRetrieve(requestParameters: TransportationApiTransportationDriversRetrieveRequest, options?: RawAxiosRequestConfig): AxiosPromise<InternalDriver> {
            return localVarFp.transportationDriversRetrieve(requestParameters.id, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * Unified API product categories.
         * @param {TransportationApiTransportationOrdersCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transportationOrdersCreate(requestParameters: TransportationApiTransportationOrdersCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<UnifiedL3Order> {
            return localVarFp.transportationOrdersCreate(requestParameters.unifiedL3OrderRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Company transport partner view set.
         * @param {TransportationApiTransportationPartnersRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transportationPartnersRetrieve(requestParameters: TransportationApiTransportationPartnersRetrieveRequest, options?: RawAxiosRequestConfig): AxiosPromise<CompanyTransportPartner> {
            return localVarFp.transportationPartnersRetrieve(requestParameters.id, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * Transport partner vehicle view set.
         * @param {TransportationApiTransportationVehiclesDestroyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transportationVehiclesDestroy(requestParameters: TransportationApiTransportationVehiclesDestroyRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.transportationVehiclesDestroy(requestParameters.id, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * Transport partner vehicle view set.
         * @param {TransportationApiTransportationVehiclesPartialUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transportationVehiclesPartialUpdate(requestParameters: TransportationApiTransportationVehiclesPartialUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<Vehicle> {
            return localVarFp.transportationVehiclesPartialUpdate(requestParameters.id, requestParameters.leafLinkVersion, requestParameters.patchedVehicleRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Transport partner vehicle view set.
         * @param {TransportationApiTransportationVehiclesRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transportationVehiclesRetrieve(requestParameters: TransportationApiTransportationVehiclesRetrieveRequest, options?: RawAxiosRequestConfig): AxiosPromise<Vehicle> {
            return localVarFp.transportationVehiclesRetrieve(requestParameters.id, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for transportationCompaniesRetrieve operation in TransportationApi.
 * @export
 * @interface TransportationApiTransportationCompaniesRetrieveRequest
 */
export interface TransportationApiTransportationCompaniesRetrieveRequest {
    /**
     * A unique integer value identifying this transport company.
     * @type {number}
     * @memberof TransportationApiTransportationCompaniesRetrieve
     */
    readonly id: number

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof TransportationApiTransportationCompaniesRetrieve
     */
    readonly leafLinkVersion?: string
}

/**
 * Request parameters for transportationDriversPartialUpdate operation in TransportationApi.
 * @export
 * @interface TransportationApiTransportationDriversPartialUpdateRequest
 */
export interface TransportationApiTransportationDriversPartialUpdateRequest {
    /**
     * A unique integer value identifying this driver.
     * @type {number}
     * @memberof TransportationApiTransportationDriversPartialUpdate
     */
    readonly id: number

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof TransportationApiTransportationDriversPartialUpdate
     */
    readonly leafLinkVersion?: string

    /**
     * 
     * @type {PatchedInternalDriverRequest}
     * @memberof TransportationApiTransportationDriversPartialUpdate
     */
    readonly patchedInternalDriverRequest?: PatchedInternalDriverRequest
}

/**
 * Request parameters for transportationDriversRetrieve operation in TransportationApi.
 * @export
 * @interface TransportationApiTransportationDriversRetrieveRequest
 */
export interface TransportationApiTransportationDriversRetrieveRequest {
    /**
     * A unique integer value identifying this driver.
     * @type {number}
     * @memberof TransportationApiTransportationDriversRetrieve
     */
    readonly id: number

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof TransportationApiTransportationDriversRetrieve
     */
    readonly leafLinkVersion?: string
}

/**
 * Request parameters for transportationOrdersCreate operation in TransportationApi.
 * @export
 * @interface TransportationApiTransportationOrdersCreateRequest
 */
export interface TransportationApiTransportationOrdersCreateRequest {
    /**
     * 
     * @type {UnifiedL3OrderRequest}
     * @memberof TransportationApiTransportationOrdersCreate
     */
    readonly unifiedL3OrderRequest: UnifiedL3OrderRequest
}

/**
 * Request parameters for transportationPartnersRetrieve operation in TransportationApi.
 * @export
 * @interface TransportationApiTransportationPartnersRetrieveRequest
 */
export interface TransportationApiTransportationPartnersRetrieveRequest {
    /**
     * A unique integer value identifying this company transport partner.
     * @type {number}
     * @memberof TransportationApiTransportationPartnersRetrieve
     */
    readonly id: number

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof TransportationApiTransportationPartnersRetrieve
     */
    readonly leafLinkVersion?: string
}

/**
 * Request parameters for transportationVehiclesDestroy operation in TransportationApi.
 * @export
 * @interface TransportationApiTransportationVehiclesDestroyRequest
 */
export interface TransportationApiTransportationVehiclesDestroyRequest {
    /**
     * A unique integer value identifying this vehicle.
     * @type {number}
     * @memberof TransportationApiTransportationVehiclesDestroy
     */
    readonly id: number

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof TransportationApiTransportationVehiclesDestroy
     */
    readonly leafLinkVersion?: string
}

/**
 * Request parameters for transportationVehiclesPartialUpdate operation in TransportationApi.
 * @export
 * @interface TransportationApiTransportationVehiclesPartialUpdateRequest
 */
export interface TransportationApiTransportationVehiclesPartialUpdateRequest {
    /**
     * A unique integer value identifying this vehicle.
     * @type {number}
     * @memberof TransportationApiTransportationVehiclesPartialUpdate
     */
    readonly id: number

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof TransportationApiTransportationVehiclesPartialUpdate
     */
    readonly leafLinkVersion?: string

    /**
     * 
     * @type {PatchedVehicleRequest}
     * @memberof TransportationApiTransportationVehiclesPartialUpdate
     */
    readonly patchedVehicleRequest?: PatchedVehicleRequest
}

/**
 * Request parameters for transportationVehiclesRetrieve operation in TransportationApi.
 * @export
 * @interface TransportationApiTransportationVehiclesRetrieveRequest
 */
export interface TransportationApiTransportationVehiclesRetrieveRequest {
    /**
     * A unique integer value identifying this vehicle.
     * @type {number}
     * @memberof TransportationApiTransportationVehiclesRetrieve
     */
    readonly id: number

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof TransportationApiTransportationVehiclesRetrieve
     */
    readonly leafLinkVersion?: string
}

/**
 * TransportationApi - object-oriented interface
 * @export
 * @class TransportationApi
 * @extends {BaseAPI}
 */
export class TransportationApi extends BaseAPI {
    /**
     * Transport Company view set.
     * @param {TransportationApiTransportationCompaniesRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransportationApi
     */
    public transportationCompaniesRetrieve(requestParameters: TransportationApiTransportationCompaniesRetrieveRequest, options?: RawAxiosRequestConfig) {
        return TransportationApiFp(this.configuration).transportationCompaniesRetrieve(requestParameters.id, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Transport partner drivers view set.
     * @param {TransportationApiTransportationDriversPartialUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransportationApi
     */
    public transportationDriversPartialUpdate(requestParameters: TransportationApiTransportationDriversPartialUpdateRequest, options?: RawAxiosRequestConfig) {
        return TransportationApiFp(this.configuration).transportationDriversPartialUpdate(requestParameters.id, requestParameters.leafLinkVersion, requestParameters.patchedInternalDriverRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Transport partner drivers view set.
     * @param {TransportationApiTransportationDriversRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransportationApi
     */
    public transportationDriversRetrieve(requestParameters: TransportationApiTransportationDriversRetrieveRequest, options?: RawAxiosRequestConfig) {
        return TransportationApiFp(this.configuration).transportationDriversRetrieve(requestParameters.id, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Unified API product categories.
     * @param {TransportationApiTransportationOrdersCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransportationApi
     */
    public transportationOrdersCreate(requestParameters: TransportationApiTransportationOrdersCreateRequest, options?: RawAxiosRequestConfig) {
        return TransportationApiFp(this.configuration).transportationOrdersCreate(requestParameters.unifiedL3OrderRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Company transport partner view set.
     * @param {TransportationApiTransportationPartnersRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransportationApi
     */
    public transportationPartnersRetrieve(requestParameters: TransportationApiTransportationPartnersRetrieveRequest, options?: RawAxiosRequestConfig) {
        return TransportationApiFp(this.configuration).transportationPartnersRetrieve(requestParameters.id, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Transport partner vehicle view set.
     * @param {TransportationApiTransportationVehiclesDestroyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransportationApi
     */
    public transportationVehiclesDestroy(requestParameters: TransportationApiTransportationVehiclesDestroyRequest, options?: RawAxiosRequestConfig) {
        return TransportationApiFp(this.configuration).transportationVehiclesDestroy(requestParameters.id, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Transport partner vehicle view set.
     * @param {TransportationApiTransportationVehiclesPartialUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransportationApi
     */
    public transportationVehiclesPartialUpdate(requestParameters: TransportationApiTransportationVehiclesPartialUpdateRequest, options?: RawAxiosRequestConfig) {
        return TransportationApiFp(this.configuration).transportationVehiclesPartialUpdate(requestParameters.id, requestParameters.leafLinkVersion, requestParameters.patchedVehicleRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Transport partner vehicle view set.
     * @param {TransportationApiTransportationVehiclesRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransportationApi
     */
    public transportationVehiclesRetrieve(requestParameters: TransportationApiTransportationVehiclesRetrieveRequest, options?: RawAxiosRequestConfig) {
        return TransportationApiFp(this.configuration).transportationVehiclesRetrieve(requestParameters.id, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UnitDenominationApi - axios parameter creator
 * @export
 */
export const UnitDenominationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * List all Unit Denominations
         * @summary List Unit Denominations
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unitDenominationsList: async (ordering?: string, page?: number, pageSize?: number, search?: string, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/unit_denominations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication tokenAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a Unit Denomination by ID
         * @summary Get a Unit Denomination
         * @param {number} id A unique integer value identifying this unit denomination.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unitDenominationsRetrieve: async (id: number, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('unitDenominationsRetrieve', 'id', id)
            const localVarPath = `/unit_denominations/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication tokenAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UnitDenominationApi - functional programming interface
 * @export
 */
export const UnitDenominationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UnitDenominationApiAxiosParamCreator(configuration)
    return {
        /**
         * List all Unit Denominations
         * @summary List Unit Denominations
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unitDenominationsList(ordering?: string, page?: number, pageSize?: number, search?: string, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedUnifiedUnitDenominationList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unitDenominationsList(ordering, page, pageSize, search, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UnitDenominationApi.unitDenominationsList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a Unit Denomination by ID
         * @summary Get a Unit Denomination
         * @param {number} id A unique integer value identifying this unit denomination.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unitDenominationsRetrieve(id: number, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnifiedUnitDenomination>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unitDenominationsRetrieve(id, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UnitDenominationApi.unitDenominationsRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UnitDenominationApi - factory interface
 * @export
 */
export const UnitDenominationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UnitDenominationApiFp(configuration)
    return {
        /**
         * List all Unit Denominations
         * @summary List Unit Denominations
         * @param {UnitDenominationApiUnitDenominationsListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unitDenominationsList(requestParameters: UnitDenominationApiUnitDenominationsListRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedUnifiedUnitDenominationList> {
            return localVarFp.unitDenominationsList(requestParameters.ordering, requestParameters.page, requestParameters.pageSize, requestParameters.search, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a Unit Denomination by ID
         * @summary Get a Unit Denomination
         * @param {UnitDenominationApiUnitDenominationsRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unitDenominationsRetrieve(requestParameters: UnitDenominationApiUnitDenominationsRetrieveRequest, options?: RawAxiosRequestConfig): AxiosPromise<UnifiedUnitDenomination> {
            return localVarFp.unitDenominationsRetrieve(requestParameters.id, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for unitDenominationsList operation in UnitDenominationApi.
 * @export
 * @interface UnitDenominationApiUnitDenominationsListRequest
 */
export interface UnitDenominationApiUnitDenominationsListRequest {
    /**
     * Which field to use when ordering the results.
     * @type {string}
     * @memberof UnitDenominationApiUnitDenominationsList
     */
    readonly ordering?: string

    /**
     * A page number within the paginated result set.
     * @type {number}
     * @memberof UnitDenominationApiUnitDenominationsList
     */
    readonly page?: number

    /**
     * Number of results to return per page.
     * @type {number}
     * @memberof UnitDenominationApiUnitDenominationsList
     */
    readonly pageSize?: number

    /**
     * A search term.
     * @type {string}
     * @memberof UnitDenominationApiUnitDenominationsList
     */
    readonly search?: string

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof UnitDenominationApiUnitDenominationsList
     */
    readonly leafLinkVersion?: string
}

/**
 * Request parameters for unitDenominationsRetrieve operation in UnitDenominationApi.
 * @export
 * @interface UnitDenominationApiUnitDenominationsRetrieveRequest
 */
export interface UnitDenominationApiUnitDenominationsRetrieveRequest {
    /**
     * A unique integer value identifying this unit denomination.
     * @type {number}
     * @memberof UnitDenominationApiUnitDenominationsRetrieve
     */
    readonly id: number

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof UnitDenominationApiUnitDenominationsRetrieve
     */
    readonly leafLinkVersion?: string
}

/**
 * UnitDenominationApi - object-oriented interface
 * @export
 * @class UnitDenominationApi
 * @extends {BaseAPI}
 */
export class UnitDenominationApi extends BaseAPI {
    /**
     * List all Unit Denominations
     * @summary List Unit Denominations
     * @param {UnitDenominationApiUnitDenominationsListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UnitDenominationApi
     */
    public unitDenominationsList(requestParameters: UnitDenominationApiUnitDenominationsListRequest = {}, options?: RawAxiosRequestConfig) {
        return UnitDenominationApiFp(this.configuration).unitDenominationsList(requestParameters.ordering, requestParameters.page, requestParameters.pageSize, requestParameters.search, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a Unit Denomination by ID
     * @summary Get a Unit Denomination
     * @param {UnitDenominationApiUnitDenominationsRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UnitDenominationApi
     */
    public unitDenominationsRetrieve(requestParameters: UnitDenominationApiUnitDenominationsRetrieveRequest, options?: RawAxiosRequestConfig) {
        return UnitDenominationApiFp(this.configuration).unitDenominationsRetrieve(requestParameters.id, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UnitOfMeasureApi - axios parameter creator
 * @export
 */
export const UnitOfMeasureApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * List all Unit of Measures
         * @summary List Unit of Measures
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unitsOfMeasureList: async (ordering?: string, page?: number, pageSize?: number, search?: string, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/units_of_measure`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication tokenAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a Unit of Measure by ID
         * @summary Get a Unit of Measure
         * @param {number} id A unique integer value identifying this unit of measure.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unitsOfMeasureRetrieve: async (id: number, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('unitsOfMeasureRetrieve', 'id', id)
            const localVarPath = `/units_of_measure/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication tokenAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UnitOfMeasureApi - functional programming interface
 * @export
 */
export const UnitOfMeasureApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UnitOfMeasureApiAxiosParamCreator(configuration)
    return {
        /**
         * List all Unit of Measures
         * @summary List Unit of Measures
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unitsOfMeasureList(ordering?: string, page?: number, pageSize?: number, search?: string, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedUnifiedUnitOfMeasureList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unitsOfMeasureList(ordering, page, pageSize, search, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UnitOfMeasureApi.unitsOfMeasureList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a Unit of Measure by ID
         * @summary Get a Unit of Measure
         * @param {number} id A unique integer value identifying this unit of measure.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unitsOfMeasureRetrieve(id: number, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnifiedUnitOfMeasure>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unitsOfMeasureRetrieve(id, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UnitOfMeasureApi.unitsOfMeasureRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UnitOfMeasureApi - factory interface
 * @export
 */
export const UnitOfMeasureApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UnitOfMeasureApiFp(configuration)
    return {
        /**
         * List all Unit of Measures
         * @summary List Unit of Measures
         * @param {UnitOfMeasureApiUnitsOfMeasureListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unitsOfMeasureList(requestParameters: UnitOfMeasureApiUnitsOfMeasureListRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedUnifiedUnitOfMeasureList> {
            return localVarFp.unitsOfMeasureList(requestParameters.ordering, requestParameters.page, requestParameters.pageSize, requestParameters.search, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a Unit of Measure by ID
         * @summary Get a Unit of Measure
         * @param {UnitOfMeasureApiUnitsOfMeasureRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unitsOfMeasureRetrieve(requestParameters: UnitOfMeasureApiUnitsOfMeasureRetrieveRequest, options?: RawAxiosRequestConfig): AxiosPromise<UnifiedUnitOfMeasure> {
            return localVarFp.unitsOfMeasureRetrieve(requestParameters.id, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for unitsOfMeasureList operation in UnitOfMeasureApi.
 * @export
 * @interface UnitOfMeasureApiUnitsOfMeasureListRequest
 */
export interface UnitOfMeasureApiUnitsOfMeasureListRequest {
    /**
     * Which field to use when ordering the results.
     * @type {string}
     * @memberof UnitOfMeasureApiUnitsOfMeasureList
     */
    readonly ordering?: string

    /**
     * A page number within the paginated result set.
     * @type {number}
     * @memberof UnitOfMeasureApiUnitsOfMeasureList
     */
    readonly page?: number

    /**
     * Number of results to return per page.
     * @type {number}
     * @memberof UnitOfMeasureApiUnitsOfMeasureList
     */
    readonly pageSize?: number

    /**
     * A search term.
     * @type {string}
     * @memberof UnitOfMeasureApiUnitsOfMeasureList
     */
    readonly search?: string

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof UnitOfMeasureApiUnitsOfMeasureList
     */
    readonly leafLinkVersion?: string
}

/**
 * Request parameters for unitsOfMeasureRetrieve operation in UnitOfMeasureApi.
 * @export
 * @interface UnitOfMeasureApiUnitsOfMeasureRetrieveRequest
 */
export interface UnitOfMeasureApiUnitsOfMeasureRetrieveRequest {
    /**
     * A unique integer value identifying this unit of measure.
     * @type {number}
     * @memberof UnitOfMeasureApiUnitsOfMeasureRetrieve
     */
    readonly id: number

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof UnitOfMeasureApiUnitsOfMeasureRetrieve
     */
    readonly leafLinkVersion?: string
}

/**
 * UnitOfMeasureApi - object-oriented interface
 * @export
 * @class UnitOfMeasureApi
 * @extends {BaseAPI}
 */
export class UnitOfMeasureApi extends BaseAPI {
    /**
     * List all Unit of Measures
     * @summary List Unit of Measures
     * @param {UnitOfMeasureApiUnitsOfMeasureListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UnitOfMeasureApi
     */
    public unitsOfMeasureList(requestParameters: UnitOfMeasureApiUnitsOfMeasureListRequest = {}, options?: RawAxiosRequestConfig) {
        return UnitOfMeasureApiFp(this.configuration).unitsOfMeasureList(requestParameters.ordering, requestParameters.page, requestParameters.pageSize, requestParameters.search, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a Unit of Measure by ID
     * @summary Get a Unit of Measure
     * @param {UnitOfMeasureApiUnitsOfMeasureRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UnitOfMeasureApi
     */
    public unitsOfMeasureRetrieve(requestParameters: UnitOfMeasureApiUnitsOfMeasureRetrieveRequest, options?: RawAxiosRequestConfig) {
        return UnitOfMeasureApiFp(this.configuration).unitsOfMeasureRetrieve(requestParameters.id, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * VendorsApi - axios parameter creator
 * @export
 */
export const VendorsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get a single vendor company profile.
         * @summary Get Vendor Company Profile
         * @param {number} companyId 
         * @param {number} id A unique integer value identifying this company.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vendorRetrieve: async (companyId: number, id: number, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('vendorRetrieve', 'companyId', companyId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('vendorRetrieve', 'id', id)
            const localVarPath = `/vendor/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (companyId !== undefined) {
                localVarQueryParameter['company_id'] = companyId;
            }


    
            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vendorsRecommendedList: async (ordering?: string, page?: number, pageSize?: number, search?: string, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/vendors/recommended`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vendorsRecommendedRetrieve: async (id: string, leafLinkVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('vendorsRecommendedRetrieve', 'id', id)
            const localVarPath = `/vendors/recommended/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (leafLinkVersion != null) {
                localVarHeaderParameter['LeafLink-Version'] = typeof leafLinkVersion === 'string'
                    ? leafLinkVersion
                    : JSON.stringify(leafLinkVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * VendorsApi - functional programming interface
 * @export
 */
export const VendorsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = VendorsApiAxiosParamCreator(configuration)
    return {
        /**
         * Get a single vendor company profile.
         * @summary Get Vendor Company Profile
         * @param {number} companyId 
         * @param {number} id A unique integer value identifying this company.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async vendorRetrieve(companyId: number, id: number, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnifiedVendorCompany>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.vendorRetrieve(companyId, id, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VendorsApi.vendorRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async vendorsRecommendedList(ordering?: string, page?: number, pageSize?: number, search?: string, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedUnifiedRecommendedCompanyList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.vendorsRecommendedList(ordering, page, pageSize, search, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VendorsApi.vendorsRecommendedList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {string} [leafLinkVersion] [API version docs](/api/getting-started/#versioning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async vendorsRecommendedRetrieve(id: string, leafLinkVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnifiedRecommendedCompany>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.vendorsRecommendedRetrieve(id, leafLinkVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VendorsApi.vendorsRecommendedRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * VendorsApi - factory interface
 * @export
 */
export const VendorsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = VendorsApiFp(configuration)
    return {
        /**
         * Get a single vendor company profile.
         * @summary Get Vendor Company Profile
         * @param {VendorsApiVendorRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vendorRetrieve(requestParameters: VendorsApiVendorRetrieveRequest, options?: RawAxiosRequestConfig): AxiosPromise<UnifiedVendorCompany> {
            return localVarFp.vendorRetrieve(requestParameters.companyId, requestParameters.id, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {VendorsApiVendorsRecommendedListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vendorsRecommendedList(requestParameters: VendorsApiVendorsRecommendedListRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedUnifiedRecommendedCompanyList> {
            return localVarFp.vendorsRecommendedList(requestParameters.ordering, requestParameters.page, requestParameters.pageSize, requestParameters.search, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {VendorsApiVendorsRecommendedRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vendorsRecommendedRetrieve(requestParameters: VendorsApiVendorsRecommendedRetrieveRequest, options?: RawAxiosRequestConfig): AxiosPromise<UnifiedRecommendedCompany> {
            return localVarFp.vendorsRecommendedRetrieve(requestParameters.id, requestParameters.leafLinkVersion, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for vendorRetrieve operation in VendorsApi.
 * @export
 * @interface VendorsApiVendorRetrieveRequest
 */
export interface VendorsApiVendorRetrieveRequest {
    /**
     * 
     * @type {number}
     * @memberof VendorsApiVendorRetrieve
     */
    readonly companyId: number

    /**
     * A unique integer value identifying this company.
     * @type {number}
     * @memberof VendorsApiVendorRetrieve
     */
    readonly id: number

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof VendorsApiVendorRetrieve
     */
    readonly leafLinkVersion?: string
}

/**
 * Request parameters for vendorsRecommendedList operation in VendorsApi.
 * @export
 * @interface VendorsApiVendorsRecommendedListRequest
 */
export interface VendorsApiVendorsRecommendedListRequest {
    /**
     * Which field to use when ordering the results.
     * @type {string}
     * @memberof VendorsApiVendorsRecommendedList
     */
    readonly ordering?: string

    /**
     * A page number within the paginated result set.
     * @type {number}
     * @memberof VendorsApiVendorsRecommendedList
     */
    readonly page?: number

    /**
     * Number of results to return per page.
     * @type {number}
     * @memberof VendorsApiVendorsRecommendedList
     */
    readonly pageSize?: number

    /**
     * A search term.
     * @type {string}
     * @memberof VendorsApiVendorsRecommendedList
     */
    readonly search?: string

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof VendorsApiVendorsRecommendedList
     */
    readonly leafLinkVersion?: string
}

/**
 * Request parameters for vendorsRecommendedRetrieve operation in VendorsApi.
 * @export
 * @interface VendorsApiVendorsRecommendedRetrieveRequest
 */
export interface VendorsApiVendorsRecommendedRetrieveRequest {
    /**
     * 
     * @type {string}
     * @memberof VendorsApiVendorsRecommendedRetrieve
     */
    readonly id: string

    /**
     * [API version docs](/api/getting-started/#versioning)
     * @type {string}
     * @memberof VendorsApiVendorsRecommendedRetrieve
     */
    readonly leafLinkVersion?: string
}

/**
 * VendorsApi - object-oriented interface
 * @export
 * @class VendorsApi
 * @extends {BaseAPI}
 */
export class VendorsApi extends BaseAPI {
    /**
     * Get a single vendor company profile.
     * @summary Get Vendor Company Profile
     * @param {VendorsApiVendorRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VendorsApi
     */
    public vendorRetrieve(requestParameters: VendorsApiVendorRetrieveRequest, options?: RawAxiosRequestConfig) {
        return VendorsApiFp(this.configuration).vendorRetrieve(requestParameters.companyId, requestParameters.id, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {VendorsApiVendorsRecommendedListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VendorsApi
     */
    public vendorsRecommendedList(requestParameters: VendorsApiVendorsRecommendedListRequest = {}, options?: RawAxiosRequestConfig) {
        return VendorsApiFp(this.configuration).vendorsRecommendedList(requestParameters.ordering, requestParameters.page, requestParameters.pageSize, requestParameters.search, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {VendorsApiVendorsRecommendedRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VendorsApi
     */
    public vendorsRecommendedRetrieve(requestParameters: VendorsApiVendorsRecommendedRetrieveRequest, options?: RawAxiosRequestConfig) {
        return VendorsApiFp(this.configuration).vendorsRecommendedRetrieve(requestParameters.id, requestParameters.leafLinkVersion, options).then((request) => request(this.axios, this.basePath));
    }
}



